(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4c53"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4c53"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

parcelRegister("22OJp", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("jkN7i")).then(()=>parcelRequire("S0nQY"));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case "preload":
            return $1c132cac09cd18d9$var$cachedPreloads;
        case "prefetch":
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("gnS5A", function(module, exports) {

$parcel$export(module.exports, "rotation", function () { return ye; });

var $6qd2L = parcelRequire("6qd2L");

var $3aNd6 = parcelRequire("3aNd6");
var $49decdd7c8e65498$require$Buffer = $3aNd6.Buffer;
function e(e, t, s) {
    return t in e ? Object.defineProperty(e, t, {
        value: s,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = s, e;
}
var t = "undefined" != typeof self ? self : $parcel$global;
const s = "undefined" != typeof navigator, i = s && "undefined" == typeof HTMLImageElement, n = !("undefined" == typeof $parcel$global || "undefined" == typeof $6qd2L || !$6qd2L.versions || !$6qd2L.versions.node), r = t.Buffer, a = !!r, h = (e)=>void 0 !== e;
function f(e) {
    return void 0 === e || (e instanceof Map ? 0 === e.size : 0 === Object.values(e).filter(h).length);
}
function l(e) {
    let t = new Error(e);
    throw delete t.stack, t;
}
function o(e) {
    let t = function(e) {
        let t = 0;
        return e.ifd0.enabled && (t += 1024), e.exif.enabled && (t += 2048), e.makerNote && (t += 2048), e.userComment && (t += 1024), e.gps.enabled && (t += 512), e.interop.enabled && (t += 100), e.ifd1.enabled && (t += 1024), t + 2048;
    }(e);
    return e.jfif.enabled && (t += 50), e.xmp.enabled && (t += 2e4), e.iptc.enabled && (t += 14e3), e.icc.enabled && (t += 6e3), t;
}
const u = (e)=>String.fromCharCode.apply(null, e), d = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : void 0;
class c {
    static from(e, t) {
        return e instanceof this && e.le === t ? e : new c(e, void 0, void 0, t);
    }
    constructor(e, t = 0, s, i){
        if ("boolean" == typeof i && (this.le = i), Array.isArray(e) && (e = new Uint8Array(e)), 0 === e) this.byteOffset = 0, this.byteLength = 0;
        else if (e instanceof ArrayBuffer) {
            void 0 === s && (s = e.byteLength - t);
            let i = new DataView(e, t, s);
            this._swapDataView(i);
        } else if (e instanceof Uint8Array || e instanceof DataView || e instanceof c) {
            void 0 === s && (s = e.byteLength - t), (t += e.byteOffset) + s > e.byteOffset + e.byteLength && l("Creating view outside of available memory in ArrayBuffer");
            let i = new DataView(e.buffer, t, s);
            this._swapDataView(i);
        } else if ("number" == typeof e) {
            let t = new DataView(new ArrayBuffer(e));
            this._swapDataView(t);
        } else l("Invalid input argument for BufferView: " + e);
    }
    _swapArrayBuffer(e) {
        this._swapDataView(new DataView(e));
    }
    _swapBuffer(e) {
        this._swapDataView(new DataView(e.buffer, e.byteOffset, e.byteLength));
    }
    _swapDataView(e) {
        this.dataView = e, this.buffer = e.buffer, this.byteOffset = e.byteOffset, this.byteLength = e.byteLength;
    }
    _lengthToEnd(e) {
        return this.byteLength - e;
    }
    set(e, t, s = c) {
        return e instanceof DataView || e instanceof c ? e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : e instanceof ArrayBuffer && (e = new Uint8Array(e)), e instanceof Uint8Array || l("BufferView.set(): Invalid data argument."), this.toUint8().set(e, t), new s(this, t, e.byteLength);
    }
    subarray(e, t) {
        return t = t || this._lengthToEnd(e), new c(this, e, t);
    }
    toUint8() {
        return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
    }
    getUint8Array(e, t) {
        return new Uint8Array(this.buffer, this.byteOffset + e, t);
    }
    getString(e = 0, t = this.byteLength) {
        let s = this.getUint8Array(e, t);
        var i;
        return i = s, d ? d.decode(i) : a ? $49decdd7c8e65498$require$Buffer.from(i).toString("utf8") : decodeURIComponent(escape(u(i)));
    }
    getLatin1String(e = 0, t = this.byteLength) {
        let s = this.getUint8Array(e, t);
        return u(s);
    }
    getUnicodeString(e = 0, t = this.byteLength) {
        const s = [];
        for(let i = 0; i < t && e + i < this.byteLength; i += 2)s.push(this.getUint16(e + i));
        return u(s);
    }
    getInt8(e) {
        return this.dataView.getInt8(e);
    }
    getUint8(e) {
        return this.dataView.getUint8(e);
    }
    getInt16(e, t = this.le) {
        return this.dataView.getInt16(e, t);
    }
    getInt32(e, t = this.le) {
        return this.dataView.getInt32(e, t);
    }
    getUint16(e, t = this.le) {
        return this.dataView.getUint16(e, t);
    }
    getUint32(e, t = this.le) {
        return this.dataView.getUint32(e, t);
    }
    getFloat32(e, t = this.le) {
        return this.dataView.getFloat32(e, t);
    }
    getFloat64(e, t = this.le) {
        return this.dataView.getFloat64(e, t);
    }
    getFloat(e, t = this.le) {
        return this.dataView.getFloat32(e, t);
    }
    getDouble(e, t = this.le) {
        return this.dataView.getFloat64(e, t);
    }
    getUintBytes(e, t, s) {
        switch(t){
            case 1:
                return this.getUint8(e, s);
            case 2:
                return this.getUint16(e, s);
            case 4:
                return this.getUint32(e, s);
            case 8:
                return this.getUint64 && this.getUint64(e, s);
        }
    }
    getUint(e, t, s) {
        switch(t){
            case 8:
                return this.getUint8(e, s);
            case 16:
                return this.getUint16(e, s);
            case 32:
                return this.getUint32(e, s);
            case 64:
                return this.getUint64 && this.getUint64(e, s);
        }
    }
    toString(e) {
        return this.dataView.toString(e, this.constructor.name);
    }
    ensureChunk() {}
}
function p(e, t) {
    l(`${e} '${t}' was not loaded, try using full build of exifr.`);
}
class g extends Map {
    constructor(e){
        super(), this.kind = e;
    }
    get(e, t) {
        return this.has(e) || p(this.kind, e), t && (e in t || function(e, t) {
            l(`Unknown ${e} '${t}'.`);
        }(this.kind, e), t[e].enabled || p(this.kind, e)), super.get(e);
    }
    keyList() {
        return Array.from(this.keys());
    }
}
var m = new g("file parser"), y = new g("segment parser"), b = new g("file reader");
let w = t.fetch;
function k(e, t) {
    var i;
    return (i = e).startsWith("data:") || i.length > 1e4 ? v(e, t, "base64") : n && e.includes("://") ? O(e, t, "url", S) : n ? v(e, t, "fs") : s ? O(e, t, "url", S) : void l("Invalid input argument");
}
async function O(e, t, s, i) {
    return b.has(s) ? v(e, t, s) : i ? async function(e, t) {
        let s = await t(e);
        return new c(s);
    }(e, i) : void l(`Parser ${s} is not loaded`);
}
async function v(e, t, s) {
    let i = new (b.get(s))(e, t);
    return await i.read(), i;
}
const S = (e)=>w(e).then((e)=>e.arrayBuffer()), A = (e)=>new Promise((t, s)=>{
        let i = new FileReader;
        i.onloadend = ()=>t(i.result || new ArrayBuffer), i.onerror = s, i.readAsArrayBuffer(e);
    });
class U extends Map {
    get tagKeys() {
        return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
    }
    get tagValues() {
        return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
    }
}
function x(e, t, s) {
    let i = new U;
    for (let [e, t] of s)i.set(e, t);
    if (Array.isArray(t)) for (let s of t)e.set(s, i);
    else e.set(t, i);
    return i;
}
function C(e, t, s) {
    let i, n = e.get(t);
    for (i of s)n.set(i[0], i[1]);
}
const B = new Map, V = new Map, I = new Map, L = [
    "chunked",
    "firstChunkSize",
    "firstChunkSizeNode",
    "firstChunkSizeBrowser",
    "chunkSize",
    "chunkLimit"
], T = [
    "jfif",
    "xmp",
    "icc",
    "iptc",
    "ihdr"
], z = [
    "tiff",
    ...T
], P = [
    "ifd0",
    "ifd1",
    "exif",
    "gps",
    "interop"
], F = [
    ...z,
    ...P
], j = [
    "makerNote",
    "userComment"
], E = [
    "translateKeys",
    "translateValues",
    "reviveValues",
    "multiSegment"
], M = [
    ...E,
    "sanitize",
    "mergeOutput",
    "silentErrors"
];
class _ {
    get translate() {
        return this.translateKeys || this.translateValues || this.reviveValues;
    }
}
class D extends _ {
    get needed() {
        return this.enabled || this.deps.size > 0;
    }
    constructor(t, s, i, n){
        if (super(), e(this, "enabled", !1), e(this, "skip", new Set), e(this, "pick", new Set), e(this, "deps", new Set), e(this, "translateKeys", !1), e(this, "translateValues", !1), e(this, "reviveValues", !1), this.key = t, this.enabled = s, this.parse = this.enabled, this.applyInheritables(n), this.canBeFiltered = P.includes(t), this.canBeFiltered && (this.dict = B.get(t)), void 0 !== i) {
            if (Array.isArray(i)) this.parse = this.enabled = !0, this.canBeFiltered && i.length > 0 && this.translateTagSet(i, this.pick);
            else if ("object" == typeof i) {
                if (this.enabled = !0, this.parse = !1 !== i.parse, this.canBeFiltered) {
                    let { pick: e, skip: t } = i;
                    e && e.length > 0 && this.translateTagSet(e, this.pick), t && t.length > 0 && this.translateTagSet(t, this.skip);
                }
                this.applyInheritables(i);
            } else !0 === i || !1 === i ? this.parse = this.enabled = i : l(`Invalid options argument: ${i}`);
        }
    }
    applyInheritables(e) {
        let t, s;
        for (t of E)s = e[t], void 0 !== s && (this[t] = s);
    }
    translateTagSet(e, t) {
        if (this.dict) {
            let s, i, { tagKeys: n, tagValues: r } = this.dict;
            for (s of e)"string" == typeof s ? (i = r.indexOf(s), -1 === i && (i = n.indexOf(Number(s))), -1 !== i && t.add(Number(n[i]))) : t.add(s);
        } else for (let s of e)t.add(s);
    }
    finalizeFilters() {
        !this.enabled && this.deps.size > 0 ? (this.enabled = !0, X(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && X(this.pick, this.deps);
    }
}
var N = {
    jfif: !1,
    tiff: !0,
    xmp: !1,
    icc: !1,
    iptc: !1,
    ifd0: !0,
    ifd1: !1,
    exif: !0,
    gps: !0,
    interop: !1,
    ihdr: void 0,
    makerNote: !1,
    userComment: !1,
    multiSegment: !1,
    skip: [],
    pick: [],
    translateKeys: !0,
    translateValues: !0,
    reviveValues: !0,
    sanitize: !0,
    mergeOutput: !0,
    silentErrors: !0,
    chunked: !0,
    firstChunkSize: void 0,
    firstChunkSizeNode: 512,
    firstChunkSizeBrowser: 65536,
    chunkSize: 65536,
    chunkLimit: 5
}, $ = new Map;
class R extends _ {
    static useCached(e) {
        let t = $.get(e);
        return void 0 !== t || (t = new this(e), $.set(e, t)), t;
    }
    constructor(e){
        super(), !0 === e ? this.setupFromTrue() : void 0 === e ? this.setupFromUndefined() : Array.isArray(e) ? this.setupFromArray(e) : "object" == typeof e ? this.setupFromObject(e) : l(`Invalid options argument ${e}`), void 0 === this.firstChunkSize && (this.firstChunkSize = s ? this.firstChunkSizeBrowser : this.firstChunkSizeNode), this.mergeOutput && (this.ifd1.enabled = !1), this.filterNestedSegmentTags(), this.traverseTiffDependencyTree(), this.checkLoadedPlugins();
    }
    setupFromUndefined() {
        let e;
        for (e of L)this[e] = N[e];
        for (e of M)this[e] = N[e];
        for (e of j)this[e] = N[e];
        for (e of F)this[e] = new D(e, N[e], void 0, this);
    }
    setupFromTrue() {
        let e;
        for (e of L)this[e] = N[e];
        for (e of M)this[e] = N[e];
        for (e of j)this[e] = !0;
        for (e of F)this[e] = new D(e, !0, void 0, this);
    }
    setupFromArray(e) {
        let t;
        for (t of L)this[t] = N[t];
        for (t of M)this[t] = N[t];
        for (t of j)this[t] = N[t];
        for (t of F)this[t] = new D(t, !1, void 0, this);
        this.setupGlobalFilters(e, void 0, P);
    }
    setupFromObject(e) {
        let t;
        for (t of (P.ifd0 = P.ifd0 || P.image, P.ifd1 = P.ifd1 || P.thumbnail, Object.assign(this, e), L))this[t] = W(e[t], N[t]);
        for (t of M)this[t] = W(e[t], N[t]);
        for (t of j)this[t] = W(e[t], N[t]);
        for (t of z)this[t] = new D(t, N[t], e[t], this);
        for (t of P)this[t] = new D(t, N[t], e[t], this.tiff);
        this.setupGlobalFilters(e.pick, e.skip, P, F), !0 === e.tiff ? this.batchEnableWithBool(P, !0) : !1 === e.tiff ? this.batchEnableWithUserValue(P, e) : Array.isArray(e.tiff) ? this.setupGlobalFilters(e.tiff, void 0, P) : "object" == typeof e.tiff && this.setupGlobalFilters(e.tiff.pick, e.tiff.skip, P);
    }
    batchEnableWithBool(e, t) {
        for (let s of e)this[s].enabled = t;
    }
    batchEnableWithUserValue(e, t) {
        for (let s of e){
            let e = t[s];
            this[s].enabled = !1 !== e && void 0 !== e;
        }
    }
    setupGlobalFilters(e, t, s, i = s) {
        if (e && e.length) {
            for (let e of i)this[e].enabled = !1;
            let t = K(e, s);
            for (let [e, s] of t)X(this[e].pick, s), this[e].enabled = !0;
        } else if (t && t.length) {
            let e = K(t, s);
            for (let [t, s] of e)X(this[t].skip, s);
        }
    }
    filterNestedSegmentTags() {
        let { ifd0: e, exif: t, xmp: s, iptc: i, icc: n } = this;
        this.makerNote ? t.deps.add(37500) : t.skip.add(37500), this.userComment ? t.deps.add(37510) : t.skip.add(37510), s.enabled || e.skip.add(700), i.enabled || e.skip.add(33723), n.enabled || e.skip.add(34675);
    }
    traverseTiffDependencyTree() {
        let { ifd0: e, exif: t, gps: s, interop: i } = this;
        i.needed && (t.deps.add(40965), e.deps.add(40965)), t.needed && e.deps.add(34665), s.needed && e.deps.add(34853), this.tiff.enabled = P.some((e)=>!0 === this[e].enabled) || this.makerNote || this.userComment;
        for (let e of P)this[e].finalizeFilters();
    }
    get onlyTiff() {
        return !T.map((e)=>this[e].enabled).some((e)=>!0 === e) && this.tiff.enabled;
    }
    checkLoadedPlugins() {
        for (let e of z)this[e].enabled && !y.has(e) && p("segment parser", e);
    }
}
function K(e, t) {
    let s, i, n, r, a = [];
    for (n of t){
        for (r of (s = B.get(n), i = [], s))(e.includes(r[0]) || e.includes(r[1])) && i.push(r[0]);
        i.length && a.push([
            n,
            i
        ]);
    }
    return a;
}
function W(e, t) {
    return void 0 !== e ? e : void 0 !== t ? t : void 0;
}
function X(e, t) {
    for (let s of t)e.add(s);
}
e(R, "default", N);
class H {
    constructor(t){
        e(this, "parsers", {}), e(this, "output", {}), e(this, "errors", []), e(this, "pushToErrors", (e)=>this.errors.push(e)), this.options = R.useCached(t);
    }
    async read(e) {
        this.file = await function(e, t) {
            return "string" == typeof e ? k(e, t) : s && !i && e instanceof HTMLImageElement ? k(e.src, t) : e instanceof Uint8Array || e instanceof ArrayBuffer || e instanceof DataView ? new c(e) : s && e instanceof Blob ? O(e, t, "blob", A) : void l("Invalid input argument");
        }(e, this.options);
    }
    setup() {
        if (this.fileParser) return;
        let { file: e } = this, t = e.getUint16(0);
        for (let [s, i] of m)if (i.canHandle(e, t)) return this.fileParser = new i(this.options, this.file, this.parsers), e[s] = !0;
        this.file.close && this.file.close(), l("Unknown file format");
    }
    async parse() {
        let { output: e, errors: t } = this;
        var s;
        return this.setup(), this.options.silentErrors ? (await this.executeParsers().catch(this.pushToErrors), t.push(...this.fileParser.errors)) : await this.executeParsers(), this.file.close && this.file.close(), this.options.silentErrors && t.length > 0 && (e.errors = t), f(s = e) ? void 0 : s;
    }
    async executeParsers() {
        let { output: e } = this;
        await this.fileParser.parse();
        let t = Object.values(this.parsers).map(async (t)=>{
            let s = await t.parse();
            t.assignToOutput(e, s);
        });
        this.options.silentErrors && (t = t.map((e)=>e.catch(this.pushToErrors))), await Promise.all(t);
    }
    async extractThumbnail() {
        this.setup();
        let { options: e, file: t } = this, s = y.get("tiff", e);
        var i;
        if (t.tiff ? i = {
            start: 0,
            type: "tiff"
        } : t.jpeg && (i = await this.fileParser.getOrFindSegment("tiff")), void 0 === i) return;
        let n = await this.fileParser.ensureSegmentChunk(i), r = this.parsers.tiff = new s(n, e, t), a = await r.extractThumbnail();
        return t.close && t.close(), a;
    }
}
async function Y(e, t) {
    let s = new H(t);
    return await s.read(e), s.parse();
}
var G = Object.freeze({
    __proto__: null,
    parse: Y,
    Exifr: H,
    fileParsers: m,
    segmentParsers: y,
    fileReaders: b,
    tagKeys: B,
    tagValues: V,
    tagRevivers: I,
    createDictionary: x,
    extendDictionary: C,
    fetchUrlAsArrayBuffer: S,
    readBlobAsArrayBuffer: A,
    chunkedProps: L,
    otherSegments: T,
    segments: z,
    tiffBlocks: P,
    segmentsAndBlocks: F,
    tiffExtractables: j,
    inheritables: E,
    allFormatters: M,
    Options: R
});
class J {
    static findPosition(e, t) {
        let s = e.getUint16(t + 2) + 2, i = "function" == typeof this.headerLength ? this.headerLength(e, t, s) : this.headerLength, n = t + i, r = s - i;
        return {
            offset: t,
            length: s,
            headerLength: i,
            start: n,
            size: r,
            end: n + r
        };
    }
    static parse(e, t = {}) {
        return new this(e, new R({
            [this.type]: t
        }), e).parse();
    }
    normalizeInput(e) {
        return e instanceof c ? e : new c(e);
    }
    constructor(t, s = {}, i){
        e(this, "errors", []), e(this, "raw", new Map), e(this, "handleError", (e)=>{
            if (!this.options.silentErrors) throw e;
            this.errors.push(e.message);
        }), this.chunk = this.normalizeInput(t), this.file = i, this.type = this.constructor.type, this.globalOptions = this.options = s, this.localOptions = s[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
    }
    translate() {
        this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
    }
    get output() {
        return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
    }
    translateBlock(e, t) {
        let s = I.get(t), i = V.get(t), n = B.get(t), r = this.options[t], a = r.reviveValues && !!s, h = r.translateValues && !!i, f = r.translateKeys && !!n, l = {};
        for (let [t, r] of e)a && s.has(t) ? r = s.get(t)(r) : h && i.has(t) && (r = this.translateValue(r, i.get(t))), f && n.has(t) && (t = n.get(t) || t), l[t] = r;
        return l;
    }
    translateValue(e, t) {
        return t[e] || t.DEFAULT || e;
    }
    assignToOutput(e, t) {
        this.assignObjectToOutput(e, this.constructor.type, t);
    }
    assignObjectToOutput(e, t, s) {
        if (this.globalOptions.mergeOutput) return Object.assign(e, s);
        e[t] ? Object.assign(e[t], s) : e[t] = s;
    }
}
e(J, "headerLength", 4), e(J, "type", void 0), e(J, "multiSegment", !1), e(J, "canHandle", ()=>!1);
function q(e) {
    return 192 === e || 194 === e || 196 === e || 219 === e || 221 === e || 218 === e || 254 === e;
}
function Q(e) {
    return e >= 224 && e <= 239;
}
function Z(e, t, s) {
    for (let [i, n] of y)if (n.canHandle(e, t, s)) return i;
}
class ee extends class {
    constructor(t, s, i){
        e(this, "errors", []), e(this, "ensureSegmentChunk", async (e)=>{
            let t = e.start, s = e.size || 65536;
            if (this.file.chunked) {
                if (this.file.available(t, s)) e.chunk = this.file.subarray(t, s);
                else try {
                    e.chunk = await this.file.readChunk(t, s);
                } catch (t) {
                    l(`Couldn't read segment: ${JSON.stringify(e)}. ${t.message}`);
                }
            } else this.file.byteLength > t + s ? e.chunk = this.file.subarray(t, s) : void 0 === e.size ? e.chunk = this.file.subarray(t) : l("Segment unreachable: " + JSON.stringify(e));
            return e.chunk;
        }), this.extendOptions && this.extendOptions(t), this.options = t, this.file = s, this.parsers = i;
    }
    injectSegment(e, t) {
        this.options[e].enabled && this.createParser(e, t);
    }
    createParser(e, t) {
        let s = new (y.get(e))(t, this.options, this.file);
        return this.parsers[e] = s;
    }
    createParsers(e) {
        for (let t of e){
            let { type: e, chunk: s } = t, i = this.options[e];
            if (i && i.enabled) {
                let t = this.parsers[e];
                t && t.append || t || this.createParser(e, s);
            }
        }
    }
    async readSegments(e) {
        let t = e.map(this.ensureSegmentChunk);
        await Promise.all(t);
    }
} {
    constructor(...t){
        super(...t), e(this, "appSegments", []), e(this, "jpegSegments", []), e(this, "unknownSegments", []);
    }
    static canHandle(e, t) {
        return 65496 === t;
    }
    async parse() {
        await this.findAppSegments(), await this.readSegments(this.appSegments), this.mergeMultiSegments(), this.createParsers(this.mergedAppSegments || this.appSegments);
    }
    setupSegmentFinderArgs(e) {
        !0 === e ? (this.findAll = !0, this.wanted = new Set(y.keyList())) : (e = void 0 === e ? y.keyList().filter((e)=>this.options[e].enabled) : e.filter((e)=>this.options[e].enabled && y.has(e)), this.findAll = !1, this.remaining = new Set(e), this.wanted = new Set(e)), this.unfinishedMultiSegment = !1;
    }
    async findAppSegments(e = 0, t) {
        this.setupSegmentFinderArgs(t);
        let { file: s, findAll: i, wanted: n, remaining: r } = this;
        if (!i && this.file.chunked && (i = Array.from(n).some((e)=>{
            let t = y.get(e), s = this.options[e];
            return t.multiSegment && s.multiSegment;
        }), i && await this.file.readWhole()), e = this.findAppSegmentsInRange(e, s.byteLength), !this.options.onlyTiff && s.chunked) {
            let t = !1;
            for(; r.size > 0 && !t && (s.canReadNextChunk || this.unfinishedMultiSegment);){
                let { nextChunkOffset: i } = s, n = this.appSegments.some((e)=>!this.file.available(e.offset || e.start, e.length || e.size));
                if (t = e > i && !n ? !await s.readNextChunk(e) : !await s.readNextChunk(i), void 0 === (e = this.findAppSegmentsInRange(e, s.byteLength))) return;
            }
        }
    }
    findAppSegmentsInRange(e, t) {
        t -= 2;
        let s, i, n, r, a, h, { file: f, findAll: l, wanted: o, remaining: u, options: d } = this;
        for(; e < t; e++)if (255 === f.getUint8(e)) {
            if (s = f.getUint8(e + 1), Q(s)) {
                if (i = f.getUint16(e + 2), n = Z(f, e, i), n && o.has(n) && (r = y.get(n), a = r.findPosition(f, e), h = d[n], a.type = n, this.appSegments.push(a), !l && (r.multiSegment && h.multiSegment ? (this.unfinishedMultiSegment = a.chunkNumber < a.chunkCount, this.unfinishedMultiSegment || u.delete(n)) : u.delete(n), 0 === u.size))) break;
                d.recordUnknownSegments && (a = J.findPosition(f, e), a.marker = s, this.unknownSegments.push(a)), e += i + 1;
            } else if (q(s)) {
                if (i = f.getUint16(e + 2), 218 === s && !1 !== d.stopAfterSos) return;
                d.recordJpegSegments && this.jpegSegments.push({
                    offset: e,
                    length: i,
                    marker: s
                }), e += i + 1;
            }
        }
        return e;
    }
    mergeMultiSegments() {
        if (!this.appSegments.some((e)=>e.multiSegment)) return;
        let e = function(e, t) {
            let s, i, n, r = new Map;
            for(let a = 0; a < e.length; a++)s = e[a], i = s[t], r.has(i) ? n = r.get(i) : r.set(i, n = []), n.push(s);
            return Array.from(r);
        }(this.appSegments, "type");
        this.mergedAppSegments = e.map(([e, t])=>{
            let s = y.get(e, this.options);
            if (s.handleMultiSegments) return {
                type: e,
                chunk: s.handleMultiSegments(t)
            };
            return t[0];
        });
    }
    getSegment(e) {
        return this.appSegments.find((t)=>t.type === e);
    }
    async getOrFindSegment(e) {
        let t = this.getSegment(e);
        return void 0 === t && (await this.findAppSegments(0, [
            e
        ]), t = this.getSegment(e)), t;
    }
}
e(ee, "type", "jpeg"), m.set("jpeg", ee);
const te = [
    void 0,
    1,
    1,
    2,
    4,
    8,
    1,
    1,
    2,
    4,
    8,
    4,
    8,
    4
];
class se extends J {
    parseHeader() {
        var e = this.chunk.getUint16();
        18761 === e ? this.le = !0 : 19789 === e && (this.le = !1), this.chunk.le = this.le, this.headerParsed = !0;
    }
    parseTags(e, t, s = new Map) {
        let { pick: i, skip: n } = this.options[t];
        i = new Set(i);
        let r = i.size > 0, a = 0 === n.size, h = this.chunk.getUint16(e);
        e += 2;
        for(let f = 0; f < h; f++){
            let h = this.chunk.getUint16(e);
            if (r) {
                if (i.has(h) && (s.set(h, this.parseTag(e, h, t)), i.delete(h), 0 === i.size)) break;
            } else !a && n.has(h) || s.set(h, this.parseTag(e, h, t));
            e += 12;
        }
        return s;
    }
    parseTag(e, t, s) {
        let { chunk: i } = this, n = i.getUint16(e + 2), r = i.getUint32(e + 4), a = te[n];
        if (a * r <= 4 ? e += 8 : e = i.getUint32(e + 8), (n < 1 || n > 13) && l(`Invalid TIFF value type. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e}`), e > i.byteLength && l(`Invalid TIFF value offset. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e} is outside of chunk size ${i.byteLength}`), 1 === n) return i.getUint8Array(e, r);
        if (2 === n) return "" === (h = (function(e) {
            for(; e.endsWith("\0");)e = e.slice(0, -1);
            return e;
        })(h = i.getString(e, r)).trim()) ? void 0 : h;
        var h;
        if (7 === n) return i.getUint8Array(e, r);
        if (1 === r) return this.parseTagValue(n, e);
        {
            let t = new (function(e) {
                switch(e){
                    case 1:
                        return Uint8Array;
                    case 3:
                        return Uint16Array;
                    case 4:
                        return Uint32Array;
                    case 5:
                        return Array;
                    case 6:
                        return Int8Array;
                    case 8:
                        return Int16Array;
                    case 9:
                        return Int32Array;
                    case 10:
                        return Array;
                    case 11:
                        return Float32Array;
                    case 12:
                        return Float64Array;
                    default:
                        return Array;
                }
            }(n))(r), s = a;
            for(let i = 0; i < r; i++)t[i] = this.parseTagValue(n, e), e += s;
            return t;
        }
    }
    parseTagValue(e, t) {
        let { chunk: s } = this;
        switch(e){
            case 1:
                return s.getUint8(t);
            case 3:
                return s.getUint16(t);
            case 4:
                return s.getUint32(t);
            case 5:
                return s.getUint32(t) / s.getUint32(t + 4);
            case 6:
                return s.getInt8(t);
            case 8:
                return s.getInt16(t);
            case 9:
                return s.getInt32(t);
            case 10:
                return s.getInt32(t) / s.getInt32(t + 4);
            case 11:
                return s.getFloat(t);
            case 12:
                return s.getDouble(t);
            case 13:
                return s.getUint32(t);
            default:
                l(`Invalid tiff type ${e}`);
        }
    }
}
class ie extends se {
    static canHandle(e, t) {
        return 225 === e.getUint8(t + 1) && 1165519206 === e.getUint32(t + 4) && 0 === e.getUint16(t + 8);
    }
    async parse() {
        this.parseHeader();
        let { options: e } = this;
        return e.ifd0.enabled && await this.parseIfd0Block(), e.exif.enabled && await this.safeParse("parseExifBlock"), e.gps.enabled && await this.safeParse("parseGpsBlock"), e.interop.enabled && await this.safeParse("parseInteropBlock"), e.ifd1.enabled && await this.safeParse("parseThumbnailBlock"), this.createOutput();
    }
    safeParse(e) {
        let t = this[e]();
        return void 0 !== t.catch && (t = t.catch(this.handleError)), t;
    }
    findIfd0Offset() {
        void 0 === this.ifd0Offset && (this.ifd0Offset = this.chunk.getUint32(4));
    }
    findIfd1Offset() {
        if (void 0 === this.ifd1Offset) {
            this.findIfd0Offset();
            let e = this.chunk.getUint16(this.ifd0Offset), t = this.ifd0Offset + 2 + 12 * e;
            this.ifd1Offset = this.chunk.getUint32(t);
        }
    }
    parseBlock(e, t) {
        let s = new Map;
        return this[t] = s, this.parseTags(e, t, s), s;
    }
    async parseIfd0Block() {
        if (this.ifd0) return;
        let { file: e } = this;
        this.findIfd0Offset(), this.ifd0Offset < 8 && l("Malformed EXIF data"), !e.chunked && this.ifd0Offset > e.byteLength && l(`IFD0 offset points to outside of file.\nthis.ifd0Offset: ${this.ifd0Offset}, file.byteLength: ${e.byteLength}`), e.tiff && await e.ensureChunk(this.ifd0Offset, o(this.options));
        let t = this.parseBlock(this.ifd0Offset, "ifd0");
        return 0 !== t.size ? (this.exifOffset = t.get(34665), this.interopOffset = t.get(40965), this.gpsOffset = t.get(34853), this.xmp = t.get(700), this.iptc = t.get(33723), this.icc = t.get(34675), this.options.sanitize && (t.delete(34665), t.delete(40965), t.delete(34853), t.delete(700), t.delete(33723), t.delete(34675)), t) : void 0;
    }
    async parseExifBlock() {
        if (this.exif) return;
        if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.exifOffset) return;
        this.file.tiff && await this.file.ensureChunk(this.exifOffset, o(this.options));
        let e = this.parseBlock(this.exifOffset, "exif");
        return this.interopOffset || (this.interopOffset = e.get(40965)), this.makerNote = e.get(37500), this.userComment = e.get(37510), this.options.sanitize && (e.delete(40965), e.delete(37500), e.delete(37510)), this.unpack(e, 41728), this.unpack(e, 41729), e;
    }
    unpack(e, t) {
        let s = e.get(t);
        s && 1 === s.length && e.set(t, s[0]);
    }
    async parseGpsBlock() {
        if (this.gps) return;
        if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.gpsOffset) return;
        let e = this.parseBlock(this.gpsOffset, "gps");
        return e && e.has(2) && e.has(4) && (e.set("latitude", ne(...e.get(2), e.get(1))), e.set("longitude", ne(...e.get(4), e.get(3)))), e;
    }
    async parseInteropBlock() {
        if (!this.interop && (this.ifd0 || await this.parseIfd0Block(), void 0 !== this.interopOffset || this.exif || await this.parseExifBlock(), void 0 !== this.interopOffset)) return this.parseBlock(this.interopOffset, "interop");
    }
    async parseThumbnailBlock(e = !1) {
        if (!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || e)) return this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = !0), this.ifd1;
    }
    async extractThumbnail() {
        if (this.headerParsed || this.parseHeader(), this.ifd1Parsed || await this.parseThumbnailBlock(!0), void 0 === this.ifd1) return;
        let e = this.ifd1.get(513), t = this.ifd1.get(514);
        return this.chunk.getUint8Array(e, t);
    }
    get image() {
        return this.ifd0;
    }
    get thumbnail() {
        return this.ifd1;
    }
    createOutput() {
        let e, t, s, i = {};
        for (t of P)if (e = this[t], !f(e)) {
            if (s = this.canTranslate ? this.translateBlock(e, t) : Object.fromEntries(e), this.options.mergeOutput) {
                if ("ifd1" === t) continue;
                Object.assign(i, s);
            } else i[t] = s;
        }
        return this.makerNote && (i.makerNote = this.makerNote), this.userComment && (i.userComment = this.userComment), i;
    }
    assignToOutput(e, t) {
        if (this.globalOptions.mergeOutput) Object.assign(e, t);
        else for (let [s, i] of Object.entries(t))this.assignObjectToOutput(e, s, i);
    }
}
function ne(e, t, s, i) {
    var n = e + t / 60 + s / 3600;
    return "S" !== i && "W" !== i || (n *= -1), n;
}
e(ie, "type", "tiff"), e(ie, "headerLength", 10), y.set("tiff", ie);
var re = Object.freeze({
    __proto__: null,
    default: G,
    Exifr: H,
    fileParsers: m,
    segmentParsers: y,
    fileReaders: b,
    tagKeys: B,
    tagValues: V,
    tagRevivers: I,
    createDictionary: x,
    extendDictionary: C,
    fetchUrlAsArrayBuffer: S,
    readBlobAsArrayBuffer: A,
    chunkedProps: L,
    otherSegments: T,
    segments: z,
    tiffBlocks: P,
    segmentsAndBlocks: F,
    tiffExtractables: j,
    inheritables: E,
    allFormatters: M,
    Options: R,
    parse: Y
});
const ae = {
    ifd0: !1,
    ifd1: !1,
    exif: !1,
    gps: !1,
    interop: !1,
    sanitize: !1,
    reviveValues: !0,
    translateKeys: !1,
    translateValues: !1,
    mergeOutput: !1
}, he = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    gps: [
        1,
        2,
        3,
        4
    ]
});
async function fe(e) {
    let t = new H(he);
    await t.read(e);
    let s = await t.parse();
    if (s && s.gps) {
        let { latitude: e, longitude: t } = s.gps;
        return {
            latitude: e,
            longitude: t
        };
    }
}
const le = Object.assign({}, ae, {
    tiff: !1,
    ifd1: !0,
    mergeOutput: !1
});
async function oe(e) {
    let t = new H(le);
    await t.read(e);
    let s = await t.extractThumbnail();
    return s && a ? r.from(s) : s;
}
async function ue(e) {
    let t = await this.thumbnail(e);
    if (void 0 !== t) {
        let e = new Blob([
            t
        ]);
        return URL.createObjectURL(e);
    }
}
const de = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    ifd0: [
        274
    ]
});
async function ce(e) {
    let t = new H(de);
    await t.read(e);
    let s = await t.parse();
    if (s && s.ifd0) return s.ifd0[274];
}
const pe = Object.freeze({
    1: {
        dimensionSwapped: !1,
        scaleX: 1,
        scaleY: 1,
        deg: 0,
        rad: 0
    },
    2: {
        dimensionSwapped: !1,
        scaleX: -1,
        scaleY: 1,
        deg: 0,
        rad: 0
    },
    3: {
        dimensionSwapped: !1,
        scaleX: 1,
        scaleY: 1,
        deg: 180,
        rad: 180 * Math.PI / 180
    },
    4: {
        dimensionSwapped: !1,
        scaleX: -1,
        scaleY: 1,
        deg: 180,
        rad: 180 * Math.PI / 180
    },
    5: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: -1,
        deg: 90,
        rad: 90 * Math.PI / 180
    },
    6: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: 1,
        deg: 90,
        rad: 90 * Math.PI / 180
    },
    7: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: -1,
        deg: 270,
        rad: 270 * Math.PI / 180
    },
    8: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: 1,
        deg: 270,
        rad: 270 * Math.PI / 180
    }
});
let ge = !0, me = !0;
if ("object" == typeof navigator) {
    let e = navigator.userAgent;
    if (e.includes("iPad") || e.includes("iPhone")) {
        let t = e.match(/OS (\d+)_(\d+)/);
        if (t) {
            let [, e, s] = t, i = Number(e) + .1 * Number(s);
            ge = i < 13.4, me = !1;
        }
    } else if (e.includes("OS X 10")) {
        let [, t] = e.match(/OS X 10[_.](\d+)/);
        ge = me = Number(t) < 15;
    }
    if (e.includes("Chrome/")) {
        let [, t] = e.match(/Chrome\/(\d+)/);
        ge = me = Number(t) < 81;
    } else if (e.includes("Firefox/")) {
        let [, t] = e.match(/Firefox\/(\d+)/);
        ge = me = Number(t) < 77;
    }
}
async function ye(e) {
    let t = await ce(e);
    return Object.assign({
        canvas: ge,
        css: me
    }, pe[t]);
}
class be extends c {
    constructor(...t){
        super(...t), e(this, "ranges", new we), 0 !== this.byteLength && this.ranges.add(0, this.byteLength);
    }
    _tryExtend(e, t, s) {
        if (0 === e && 0 === this.byteLength && s) {
            let e = new DataView(s.buffer || s, s.byteOffset, s.byteLength);
            this._swapDataView(e);
        } else {
            let s = e + t;
            if (s > this.byteLength) {
                let { dataView: e } = this._extend(s);
                this._swapDataView(e);
            }
        }
    }
    _extend(e) {
        let t;
        t = a ? r.allocUnsafe(e) : new Uint8Array(e);
        let s = new DataView(t.buffer, t.byteOffset, t.byteLength);
        return t.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), {
            uintView: t,
            dataView: s
        };
    }
    subarray(e, t, s = !1) {
        return t = t || this._lengthToEnd(e), s && this._tryExtend(e, t), this.ranges.add(e, t), super.subarray(e, t);
    }
    set(e, t, s = !1) {
        s && this._tryExtend(t, e.byteLength, e);
        let i = super.set(e, t);
        return this.ranges.add(t, i.byteLength), i;
    }
    async ensureChunk(e, t) {
        this.chunked && (this.ranges.available(e, t) || await this.readChunk(e, t));
    }
    available(e, t) {
        return this.ranges.available(e, t);
    }
}
class we {
    constructor(){
        e(this, "list", []);
    }
    get length() {
        return this.list.length;
    }
    add(e, t, s = 0) {
        let i = e + t, n = this.list.filter((t)=>ke(e, t.offset, i) || ke(e, t.end, i));
        if (n.length > 0) {
            e = Math.min(e, ...n.map((e)=>e.offset)), i = Math.max(i, ...n.map((e)=>e.end)), t = i - e;
            let s = n.shift();
            s.offset = e, s.length = t, s.end = i, this.list = this.list.filter((e)=>!n.includes(e));
        } else this.list.push({
            offset: e,
            length: t,
            end: i
        });
    }
    available(e, t) {
        let s = e + t;
        return this.list.some((t)=>t.offset <= e && s <= t.end);
    }
}
function ke(e, t, s) {
    return e <= t && t <= s;
}
class Oe extends be {
    constructor(t, s){
        super(0), e(this, "chunksRead", 0), this.input = t, this.options = s;
    }
    async readWhole() {
        this.chunked = !1, await this.readChunk(this.nextChunkOffset);
    }
    async readChunked() {
        this.chunked = !0, await this.readChunk(0, this.options.firstChunkSize);
    }
    async readNextChunk(e = this.nextChunkOffset) {
        if (this.fullyRead) return this.chunksRead++, !1;
        let t = this.options.chunkSize, s = await this.readChunk(e, t);
        return !!s && s.byteLength === t;
    }
    async readChunk(e, t) {
        if (this.chunksRead++, 0 !== (t = this.safeWrapAddress(e, t))) return this._readChunk(e, t);
    }
    safeWrapAddress(e, t) {
        return void 0 !== this.size && e + t > this.size ? Math.max(0, this.size - e) : t;
    }
    get nextChunkOffset() {
        if (0 !== this.ranges.list.length) return this.ranges.list[0].length;
    }
    get canReadNextChunk() {
        return this.chunksRead < this.options.chunkLimit;
    }
    get fullyRead() {
        return void 0 !== this.size && this.nextChunkOffset === this.size;
    }
    read() {
        return this.options.chunked ? this.readChunked() : this.readWhole();
    }
    close() {}
}
b.set("blob", class extends Oe {
    async readWhole() {
        this.chunked = !1;
        let e = await A(this.input);
        this._swapArrayBuffer(e);
    }
    readChunked() {
        return this.chunked = !0, this.size = this.input.size, super.readChunked();
    }
    async _readChunk(e, t) {
        let s = t ? e + t : void 0, i = this.input.slice(e, s), n = await A(i);
        return this.set(n, e, !0);
    }
});
var $49decdd7c8e65498$export$2e2bcd8739ae039 = re;

});
parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});

parcelRegister("3aNd6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $24f87a6f86a8996f$export$a143d493d941bafc; }, function (v) { return $24f87a6f86a8996f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $24f87a6f86a8996f$export$f99ded8fe4b79145; }, function (v) { return $24f87a6f86a8996f$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$24f87a6f86a8996f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $5d11t.toByteArray($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("5d11t", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3caef5c332c7293f$export$d622b2ad8d90c771; }, function (v) { return $3caef5c332c7293f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3caef5c332c7293f$export$6100ba28696e12de; }, function (v) { return $3caef5c332c7293f$export$6100ba28696e12de = v; });
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("7rddL", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $56a54f6ebabce67d$export$aafa59e2e03f2942; }, function (v) { return $56a54f6ebabce67d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $56a54f6ebabce67d$export$68d8715fc104d294; }, function (v) { return $56a54f6ebabce67d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



var $953d2c28560a14fe$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("fdQ30"), JSON.parse('["fdQ30","contact.js","jkN7i","../account/tinymce.min.58a25f5e.js","agqxp","../article/tinymce.min.05edad61.js","hAiFf","../checkoutfailed/tinymce.min.f15fad1d.js","8XP1L","tinymce.min.c1c66141.js","6KVic","../general/tinymce.min.0b731625.js","hcLsR","../internal/tinymce.min.798ab06b.js","25mWf","../feedback/tinymce.min.9b5a8c12.js","dQ5OD","../returns/tinymce.min.2f072c7c.js","jMuyX","../staticcontent/tinymce.min.f29932a4.js","jOKl9","contact.css"]'));

class $e31d2de11bbf216d$export$2e2bcd8739ae039 {
    constructor(list){
        this.customElementList = list;
        this.init();
    }
    init() {
        this.customElementList.forEach((item)=>{
            !customElements.get(item.name) && customElements.define(item.name, item.constructor);
        });
    }
}


class $8f658dda969a7982$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.listeners = [];
    }
    // eslint-disable-next-line class-methods-use-this
    connectedCallback() {}
    /**
     * If the custom element is getting removed of the dom, all listeners
     * are getting removed of the element.
     */ disconnectedCallback() {
        this.listeners.forEach((item)=>{
            item.element.removeEventListener(item.event, item.action);
        });
    }
    /**
     * Here you can push a listener object directly to the listener array
     *
     * @param {Listener} {}
     */ pushListener({ event: event, element: element, action: action }) {
        this.listeners.push({
            event: event,
            element: element,
            action: action
        });
        element.addEventListener(event, action);
    }
    /**
     * Removes the given element from the listener array and removes the
     * EventListener from the element and returns the listener object.
     * If the element was not found, undefined is returned.
     *
     * @param {Element} element
     * @returns {Listener | undefined}
     */ removeListener(element) {
        const foundElement = this.listeners.find((item)=>item.element === element);
        if (!foundElement) return;
        foundElement?.element.removeEventListener(foundElement.event, foundElement.action);
        const newList = this.listeners.filter((item)=>item.element !== element);
        this.listeners = newList;
        return foundElement;
    }
}


/* eslint-disable max-len */ const $86b3c5b6d66bd808$var$globalFormErrorMessages = {
    badInput: "Please enter a number.",
    patternMismatch: "Please match the requested format.",
    rangeOverflow: "Please select a value that is no more than {max}.",
    rangeUnderflow: "Please select a value that is no less than {min}.",
    stepMismatch: "Please select a value that is a multiple from {step}.",
    tooLong: "Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.",
    tooShort: "Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.",
    typeMismatch: "The value you have entered for this field is invalid.",
    valueMissing: "Please fill out this field.",
    // These properties must be empty.
    valid: "",
    customError: ""
};
const $86b3c5b6d66bd808$var$globalFormPasswordValidityMessages = {
    passwordNotMatching: "The password does not match the one above."
};
const $86b3c5b6d66bd808$var$globalFormExpandErrorMessages = {
    stepAdjust: "The value you entered for this field is invalid. The value has been changed from {currentValue} to {newValue}",
    existigName: "This name {currentValue} already exists."
};
const $86b3c5b6d66bd808$var$globalBasketMessages = {
    messageEmptyBasket: {
        code: "1-6-6220",
        text: "Shopping cart is empty"
    },
    messageAddedToBasket: {
        code: "1-6-6221",
        text: "added to the shopping cart"
    },
    quickOrderMessageTooShort: {
        code: "1-6-6222",
        text: "At least %1 characters are required for a search."
    }
};
const $86b3c5b6d66bd808$var$globalDeliveryMessages = {
    messageDeliveryTypeGeneral: {
        code: "1-6-6226",
        text: "Delivery method changed"
    }
};
const $86b3c5b6d66bd808$var$globalPaymentMessages = {
    messagePaymentTypeCreditCard: {
        code: "1-6-6227",
        text: "Payment type credit card"
    },
    messagePaymentTypeInvoice: {
        code: "1-6-6227",
        text: "Payment type invoice"
    },
    messagePaymentTypeInAdvance: {
        code: "1-6-6227",
        text: "Payment type advance payment"
    },
    messagePaymentTypeOnDelivery: {
        code: "1-6-6227",
        text: "Payment type cash on delivery"
    },
    messagePaymentTypeGeneral: {
        code: "1-6-6227",
        text: "Payment type changed"
    }
};
const $86b3c5b6d66bd808$var$globalCompareMessages = {
    messageHint: {
        code: "1-6-6240",
        text: ""
    },
    allRemoved: {
        code: "1-6-6240",
        text: "All items removed"
    },
    empty: {
        code: "1-6-6240",
        text: "Your article comparison is empty."
    }
};
const $86b3c5b6d66bd808$var$globalFavoriteMessages = {
    messageInvalidName: {
        code: "2-6-6270",
        text: "Unable to create the wish list; the name is invalid."
    },
    messageMaxLists: {
        code: "2-6-6277",
        text: "Max. number of wish lists reached!"
    },
    messageMaxPositions: {
        code: "2-6-6278",
        text: "Max. number of positions reached!"
    },
    messageDeleteConfirmation: {
        code: "2-6-6273",
        text: "Do you really want to delete the wish list?"
    }
};
const $86b3c5b6d66bd808$var$globalAutocompleteMessages = {
    messageNoValueFound: {
        code: "1-6-6290",
        text: "No match found!"
    }
};
const $86b3c5b6d66bd808$var$globalAccountMessages = {
    messageDelete: {
        code: "1-6-6200",
        text: "Do you really want to delete this address?"
    },
    messageChangeSuccess: {
        code: "1-6-6200",
        text: "Address successfully modified."
    }
};
const $86b3c5b6d66bd808$var$globalGeneralMessages = {
    messageEmptyText: {
        code: "1-6-6290",
        text: "The output was suppressed due to an empty text."
    },
    messageOk: {
        code: "1-6-6290",
        text: "Yes"
    },
    messageCancel: {
        code: "1-6-6290",
        text: "No"
    },
    messageChange: {
        code: "1-6-6290",
        text: "The selection was changed"
    },
    messageDefault: {
        code: "1-6-0000",
        text: ""
    },
    messageDefaultInfo: {
        code: "1-6-0000",
        text: ""
    },
    messageDefaultWarning: {
        code: "2-6-0000",
        text: ""
    },
    messageDefaultError: {
        code: "3-6-0000",
        text: ""
    },
    messageDefaultDebug: {
        code: "4-6-0000",
        text: ""
    }
};
const $86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages = {
    messageTooShort: {
        code: "1-6-6260",
        text: "At least 3 characters!"
    },
    messageResultEmpty: {
        code: "1-6-6260",
        text: "No items found!"
    },
    messageDangerousString: {
        code: "1-6-6260",
        text: "invalid character <."
    },
    messageDisallowedCharacter: {
        code: "1-6-6260",
        text: "Invalid character: %1"
    }
};
const $86b3c5b6d66bd808$var$globalFileuploadAreaMessages = {
    defaultMessage: {
        code: "1-6-2002",
        text: "Store the files here to upload them"
    },
    fallbackMessage: {
        code: "2-6-2002",
        text: "Your browser does not support drag&drop file uploads"
    },
    fallbackText: {
        code: "2-6-2002",
        text: "Use the form to upload your files"
    },
    fileTooBig: {
        code: "2-6-2002",
        text: "The file is too large. The maximum file size is {{maxFileSize}} MB"
    },
    invalidFileType: {
        code: "2-6-2002",
        text: "Unable to upload files of this type"
    },
    responseError: {
        code: "3-6-2002",
        text: "The server rejected your request with status {{statusCode}}"
    },
    cancelUpload: {
        code: "1-6-2002",
        text: "Cancel upload"
    },
    cancelUploadConfirmation: {
        code: "1-6-2002",
        text: "Cancel upload?"
    },
    removeFile: {
        code: "1-6-2002",
        text: "Remove file"
    },
    maxFilesExceeded: {
        code: "2-6-2002",
        text: "You are not allowed to upload any more files"
    },
    buttonBrowse: {
        code: "1-6-2002",
        text: "Select files to upload"
    },
    uploadHint: {
        code: "1-6-2002",
        text: "Drag files and folders here"
    }
};
const $86b3c5b6d66bd808$var$globalFilterMessages = {
    emptyResult: {
        code: "1-1-6280",
        text: "Keine Ergebnisse gefunden."
    }
};
const $86b3c5b6d66bd808$var$globalCheckoutMessages = {
    missingTerms: {
        code: "3-6-6230",
        text: "Please accept the General terms and conditions."
    },
    loadingCheckoutTitle: {
        code: "1-6-6260",
        text: "Almost done!"
    },
    loadingCheckoutText: {
        code: "1-6-6261",
        text: "The order is carried out. This can take a moment!"
    }
};
const $86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages = {
    htmlErrorGeneral: {
        code: "3-6-6000",
        text: "Something has gone wrong!"
    },
    htmlError401: {
        code: "3-6-6000",
        text: "A valid authentication is required to process the request."
    },
    htmlError403: {
        code: "3-6-6000",
        text: "The request could not be processed due to missing authorization of the client."
    },
    htmlError404: {
        code: "3-6-6000",
        text: "The requested site does not exist."
    },
    htmlError413: {
        code: "3-6-6000",
        text: "The file is too large."
    },
    htmlError415: {
        code: "3-6-6000",
        text: "This media type is not supported."
    },
    htmlError422: {
        code: "3-6-6000",
        text: "Unable to display the requested site correctly."
    },
    htmlError500: {
        code: "3-6-6000",
        text: "Internal server error"
    },
    htmlError503: {
        code: "3-6-6000",
        text: "The server is temporarily unavailable."
    }
};
if (!window.opacc) window.opacc = {};
const $86b3c5b6d66bd808$export$7ea287b8bcd34b91 = {
    ...$86b3c5b6d66bd808$var$globalFormErrorMessages,
    ...$86b3c5b6d66bd808$var$globalFormPasswordValidityMessages,
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormValidityMessages,
    ...window.opacc.tkFormPasswordValidityMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormValidityMessages,
    ...window.opacc.projectFormPasswordValidityMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$35e6ad2b040b8403 = {
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$287bafa924522a4d = {
    ...$86b3c5b6d66bd808$var$globalBasketMessages,
    ...window.opacc.tkBasketMessages,
    ...window.opacc.projectBasketMessages
};
const $86b3c5b6d66bd808$export$ad480231e1cfb49 = {
    ...$86b3c5b6d66bd808$var$globalCompareMessages,
    ...window.opacc.tkCompareMessages,
    ...window.opacc.projectCompareMessages
};
const $86b3c5b6d66bd808$export$329e838a9ba51357 = {
    ...$86b3c5b6d66bd808$var$globalFavoriteMessages,
    ...window.opacc.tkFavoriteMessages,
    ...window.opacc.projectFavoriteMessages
};
const $86b3c5b6d66bd808$export$39227038979f1988 = {
    ...$86b3c5b6d66bd808$var$globalGeneralMessages,
    ...window.opacc.tkGeneralMessages,
    ...window.opacc.projectGeneralMessages
};
const $86b3c5b6d66bd808$export$f625b980042672da = {
    ...$86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages,
    ...window.opacc.tkDirectSearchSuggestMessages,
    ...window.opacc.projectDirectSearchSuggestMessages
};
const $86b3c5b6d66bd808$export$fe24ead06f0313ff = {
    ...$86b3c5b6d66bd808$var$globalFileuploadAreaMessages,
    ...window.opacc.tkFileUploadAreaMessages,
    ...window.opacc.projectFileUploadAreaMessages
};
const $86b3c5b6d66bd808$export$1c7f7f3bbe522ebc = {
    ...$86b3c5b6d66bd808$var$globalFilterMessages,
    ...window.opacc.tkFilterMessages,
    ...window.opacc.projectFilterMessages
};
const $86b3c5b6d66bd808$export$fbedd73e1269236f = {
    ...$86b3c5b6d66bd808$var$globalAutocompleteMessages,
    ...window.opacc.tkAutocompleteMessages,
    ...window.opacc.projectAutocompleteMessages
};
const $86b3c5b6d66bd808$export$389a1ce21906c656 = {
    ...$86b3c5b6d66bd808$var$globalPaymentMessages,
    ...window.opacc.tkPaymentMessages,
    ...window.opacc.projectPaymentMessages
};
const $86b3c5b6d66bd808$export$36d5448025feaaa9 = {
    ...$86b3c5b6d66bd808$var$globalDeliveryMessages,
    ...window.opacc.tkDeliveryMessages,
    ...window.opacc.projectDeliveryMessages
};
const $86b3c5b6d66bd808$export$efd88ea7bc399322 = {
    ...$86b3c5b6d66bd808$var$globalAccountMessages,
    ...window.opacc.tkAccountMessages,
    ...window.opacc.projectAccountMessages
};
const $86b3c5b6d66bd808$export$4705307fe5270e12 = {
    ...$86b3c5b6d66bd808$var$globalCheckoutMessages,
    ...window.opacc.tkCheckoutMessages,
    ...window.opacc.projectCheckoutMessages
};
const $86b3c5b6d66bd808$export$6e7e78d2cde281b0 = {
    ...$86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages,
    ...window.opacc.tkHtmlErrorCodeMessages,
    ...window.opacc.projectHtmlErrorCodeMessages
};
const $86b3c5b6d66bd808$export$97a703132b664051 = {
    ...window.opacc.tkZipCityMessages
};


/**
 * @param {string} html representing any number of sibling elements
 * @return {NodeListOf<ChildNode>}
 */ const $2d540709c75492d4$var$render = (html, isBody = false)=>{
    if (!html) $2d540709c75492d4$var$render("<div></div>");
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return isBody ? doc.body : doc.body.children.item(0);
};
var $2d540709c75492d4$export$2e2bcd8739ae039 = $2d540709c75492d4$var$render;


var $1221feb2184dfefe$export$9130146a86a85749;
(function(NotificationType) {
    NotificationType["SUCCESS"] = "Success";
    NotificationType["WARNING"] = "Warning";
    NotificationType["ERROR"] = "Error";
    NotificationType["INFO"] = "Info";
})($1221feb2184dfefe$export$9130146a86a85749 || ($1221feb2184dfefe$export$9130146a86a85749 = {}));
const $1221feb2184dfefe$var$mapMessageCodeToText = (response, messages)=>{
    let textMessage;
    if (!response.pluginId) return "";
    if (response.pluginId === "paymentType") {
        const paymentMessages = {
            0: messages.messagePaymentTypeGeneral.text,
            1: messages.messagePaymentTypeCreditCard.text,
            2: messages.messagePaymentTypeInvoice.text,
            5: messages.messagePaymentTypeInAdvance.text,
            6: messages.messagePaymentTypeOnDelivery.text
        };
        textMessage = paymentMessages[Number(response.paymentType) || 0];
    } else if (response.pluginId === "deliveryType") textMessage = messages.messageDeliveryTypeGeneral.text;
    else if (response.pluginId === "checkoutAdressChange") textMessage = messages.messageChangeSuccess.text;
    return textMessage;
};
const $1221feb2184dfefe$var$getConsoleStyle = (backgroundColor, textColor = "white")=>[
        `background: ${backgroundColor}`,
        `color: ${textColor}`,
        "display: block"
    ].join(";");
const $1221feb2184dfefe$var$logToConsole = (message, type)=>{
    const consoleHandler = {
        ["Success"] () {
            // eslint-disable-next-line no-console
            console.info(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle("green"));
        },
        ["Warning"] () {
            // eslint-disable-next-line no-console
            console.warn(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle("yellow", "black"));
        },
        ["Error"] () {
            // eslint-disable-next-line no-console
            console.log(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle("red"));
        },
        ["Info"] () {
            // eslint-disable-next-line no-console
            console.debug(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle("blue"));
        }
    };
    consoleHandler[type]();
};
const $1221feb2184dfefe$var$renderMessageContainer = (parentElement)=>{
    let messageContainer = parentElement.querySelector("[data-tk-message-container]");
    if (!messageContainer) {
        messageContainer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-message__container" data-tk-message-container></div>');
        parentElement.insertAdjacentElement("beforeend", messageContainer);
    }
    return messageContainer;
};
const $1221feb2184dfefe$export$3a57e165650c636f = (type, message, wait = 2.5, options = {})=>{
    if (!message) return;
    const dialogs = document.querySelectorAll("dialog[open]");
    let messageContainer;
    if (dialogs.length === 0) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
    else {
        const lastDialog = Array.from(dialogs).at(-1);
        if (!lastDialog) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
        else messageContainer = $1221feb2184dfefe$var$renderMessageContainer(lastDialog);
    }
    const toast = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
        <div class="tk-message tk-message--toast tk-message--${type.toLowerCase()}">
            <span class="tk-message__icon"><i class="tk-icon-${type.toLowerCase()}"></i></span>
            <span class="tk-message__label">${message}</span>
        </div>
    `);
    toast.style.animation = `fadein .5s, fadeout .5s ${wait}s`;
    toast.classList.add("tk-message--show");
    messageContainer.appendChild(toast);
    toast.addEventListener("animationend", (event)=>{
        if (event.animationName !== "fadeout") return;
        messageContainer.removeChild(toast);
    });
    options.consoleMessage ? $1221feb2184dfefe$var$logToConsole(options.consoleMessage, type) : $1221feb2184dfefe$var$logToConsole(message, type);
};
const $1221feb2184dfefe$export$146c7c7e50ed1bd2 = (item, messageOverride)=>{
    const type = item.code.substring(0, 1);
    const message = messageOverride || item.text;
    const typeHandler = {
        1: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Success", message, item.wait),
        2: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Warning", message, item.wait),
        3: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Error", message, item.wait),
        4: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Info", message, item.wait)
    };
    typeHandler[type]();
};
const $1221feb2184dfefe$export$5b256beea4c7e9b5 = (items, response)=>{
    const messages = {
        ...(0, $86b3c5b6d66bd808$export$39227038979f1988),
        ...(0, $86b3c5b6d66bd808$export$efd88ea7bc399322),
        ...(0, $86b3c5b6d66bd808$export$389a1ce21906c656),
        ...(0, $86b3c5b6d66bd808$export$36d5448025feaaa9)
    };
    items.forEach((item)=>{
        $1221feb2184dfefe$export$146c7c7e50ed1bd2(item, $1221feb2184dfefe$var$mapMessageCodeToText(response, messages));
    });
};


class $4576c900b5c49dcd$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.eventName = this.getAttribute("data-tk-event-name") || "event-purchase";
        this.basketId = this.querySelector("[data-tk-otm-basket-id]") || undefined;
        this.messageContainerSelector = this.getAttribute("data-tk-message-container-selector") || '[id^="wp_messages_container_"]';
        this.sessionTimeoutWrapper = this.querySelector("[data-tk-session-timeout-wrapper]") || undefined;
        this.sessionTime = Number(this.sessionTimeoutWrapper?.getAttribute("data-tk-session-time") || 0);
        this.firstItemToScrollInto = this.querySelector("[data-tk-scroll-into]") || undefined;
    }
    connectedCallback() {
        this.processNotification();
        this.sessionTimeoutWrapper && this.showSessionTimeout();
        this.firstItemToScrollInto && this.scrollToElement();
        if (!this.basketId || !window.dataLayer) return;
        const data = this.getPurchaseData();
        data && window.dataLayer.push(data);
    }
    processNotification() {
        const messageContainer = document.querySelector(this.messageContainerSelector);
        if (!messageContainer || !messageContainer.hasChildNodes()) return;
        const infoMessage = messageContainer.querySelectorAll(".Info");
        const errorMessage = messageContainer.querySelectorAll(".Error");
        const warningMessage = messageContainer.querySelectorAll(".Warning");
        const debugMessage = messageContainer.querySelectorAll(".Debug");
        const messageList = Array.from([
            ...infoMessage,
            ...errorMessage,
            ...warningMessage,
            ...debugMessage
        ]);
        const types = {
            Info: (0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS,
            Error: (0, $1221feb2184dfefe$export$9130146a86a85749).ERROR,
            Warning: (0, $1221feb2184dfefe$export$9130146a86a85749).WARNING,
            Debug: (0, $1221feb2184dfefe$export$9130146a86a85749).INFO
        };
        messageList.forEach((item)=>{
            const type = types[item.className];
            const childList = Array.from(item.firstChild?.childNodes || []);
            const message = childList.find((item)=>item instanceof Text)?.textContent || "";
            const code = item.querySelector(".was-message-code")?.textContent || "";
            const addition = item.querySelector(".was-message-addition")?.textContent || "";
            const wait = Number(item.querySelector(".was-message-wait")?.textContent) || undefined;
            const consoleMessage = `${code}: ${message}} (wait: ${wait} sec.${addition})`;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)(type, message, wait, {
                consoleMessage: consoleMessage
            });
        });
        messageContainer.remove();
    }
    showSessionTimeout() {
        setTimeout(()=>{
            this.sessionTimeoutWrapper.hidden = false;
        }, this.sessionTime);
    }
    getPurchaseData() {
        return {
            event: "event-purchase",
            ecommerce: {
                purchase: {
                    actionField: this.getActionData(),
                    products: this.getProductData()
                }
            }
        };
    }
    getActionData() {
        const affiliation = this.querySelector("[data-tk-otm-affiliation]");
        const revenue = this.querySelector("[data-tk-otm-revenue]");
        const tax = this.querySelector("[data-tk-otm-tax]");
        const shipping = this.querySelector("[data-tk-otm-shipping]");
        return {
            id: this.basketId.innerText,
            affiliation: affiliation ? affiliation.innerText : "",
            revenue: revenue ? revenue.innerText : "",
            tax: tax ? tax.innerText : "",
            shipping: shipping ? shipping.innerText : ""
        };
    }
    getProductData() {
        const data = [];
        const items = this.querySelectorAll("[data-tk-otm-item]");
        Array.from(items).forEach((item)=>{
            const id = item.querySelector(".otm-id");
            const name = item.querySelector(".otm-name");
            const brand = item.querySelector(".otm-brand");
            const category = item.querySelector(".otm-category");
            const price = item.querySelector(".otm-price");
            const quantity = item.querySelector(".otm-quantity");
            const position = item.querySelector(".otm-position");
            data.push({
                id: id ? id.innerText : "",
                name: name ? name.innerText : "",
                brand: brand ? brand.innerText : "",
                category: category ? category.innerText : "",
                price: price ? price.innerText : "",
                quantity: quantity ? quantity.innerText : "",
                position: position ? position.innerText : ""
            });
        });
        return data;
    }
    scrollToElement() {
        const { top: top } = this.firstItemToScrollInto.getBoundingClientRect();
        const offset = Number(this.firstItemToScrollInto?.getAttribute("data-tk-scroll-into-offset")) || 16;
        const mainContainer = this.querySelector("main");
        const mainRect = mainContainer?.getBoundingClientRect();
        const mainRectTop = mainRect?.top || 0;
        const scrollY = top - mainRectTop - offset;
        setTimeout(()=>{
            window.scrollTo({
                top: scrollY,
                behavior: "smooth"
            });
        }, 0);
    }
}



class $2e3d1137f4724c0f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.resizeEventName = this.getAttribute("data-tk-resize-event-name") || "tk-viewport-resize";
        this.resizeObserver = new ResizeObserver(this.checkSize.bind(this));
        // * These breakpoints must match the CSS breakpoints, otherwise conflicts may occur.
        this.breakpoints = new Map([
            [
                "xs",
                576
            ],
            [
                "s",
                768
            ],
            [
                "m",
                992
            ],
            [
                "l",
                1200
            ],
            [
                "xl",
                1440
            ]
        ]);
        this.currentBreakpoint = this.getCurrentBreakpoint(this.clientWidth);
    }
    connectedCallback() {
        this.resizeObserver.observe(this);
        window.viewport = this;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
    }
    checkSize(entries) {
        entries.forEach(()=>{
            const currentWidth = window.innerWidth;
            const currentBreakpoint = this.getCurrentBreakpoint(currentWidth);
            if (this.currentBreakpoint !== currentBreakpoint) {
                const event = new CustomEvent(this.resizeEventName, {
                    bubbles: true,
                    detail: {
                        width: currentWidth,
                        breakpoint: currentBreakpoint
                    }
                });
                this.currentBreakpoint = currentBreakpoint;
                this.dispatchEvent(event);
            }
        });
    }
    getCurrentBreakpoint(width) {
        let currentBreakpoint = "xs";
        this.breakpoints.forEach((value, key)=>{
            if (width >= value) currentBreakpoint = key;
        });
        return currentBreakpoint;
    }
}



const $1653b55d89a7adce$var$getDefaultErrorFnc = (error)=>{
    throw new Error(`Request failed: ${error}`);
};
const $1653b55d89a7adce$export$a4101276b4831ec4 = (checkForReadOnlyContext = false)=>{
    const asyncUrl = "/WebPortal/async.aspx";
    if (!window.opacc || !window.opacc.systemUrls || !checkForReadOnlyContext || !window.opacc.systemUrls.asyncReadOnly) return asyncUrl;
    return window.opacc.systemUrls.asyncReadOnly;
};
const $1653b55d89a7adce$var$prepareJsonResponse = (response, showMessages)=>{
    const data = window.atob(response.data);
    const html = document.createElement("div");
    html.innerHTML = data;
    const json = response.contentType === "application/json" && html.innerText !== "" ? JSON.parse(html.innerText) : {};
    showMessages && (0, $1221feb2184dfefe$export$5b256beea4c7e9b5)(response.messages, json);
    return {
        status: response.status,
        messages: response.messages,
        dataAsBase64: response.data,
        contentType: response,
        success: response.status === "ok",
        dataAsHtml: response.contentType === "text/html" ? html.innerText : "",
        dataAsJson: json,
        data: data
    };
};
const $1653b55d89a7adce$var$recordToURLSearchParams = (data)=>{
    const searchParams = new URLSearchParams();
    Object.entries(data).forEach(([key, value])=>{
        searchParams.append(key, value || "");
    });
    return searchParams;
};
const $1653b55d89a7adce$var$formDataToURLSearchParams = (formData)=>{
    const searchParams = new URLSearchParams();
    formData.forEach((value, key)=>{
        searchParams.append(key, value);
    });
    return searchParams;
};
const $1653b55d89a7adce$export$d5a8517da06db2d = async ({ requestURL: requestURL, resolveHandler: resolveHandler, rejectHandler: rejectHandler = $1653b55d89a7adce$var$getDefaultErrorFnc, payload: payload, decodeJSONResponse: decodeJSONResponse = true, cache: cache = "default", showMessages: showMessages = true })=>{
    const headers = new Headers({
        "x-requested-with": "XMLHttpRequest",
        "response-type": "json"
    });
    let body;
    if (payload) {
        headers.set("content-type", "application/x-www-form-urlencoded; charset=UTF-8");
        if (payload instanceof URLSearchParams) body = payload;
        else if (payload instanceof FormData) body = $1653b55d89a7adce$var$formDataToURLSearchParams(payload);
        else if (payload instanceof Object) body = $1653b55d89a7adce$var$recordToURLSearchParams(payload);
    }
    const init = {
        method: payload ? "POST" : "GET",
        headers: headers,
        cache: cache,
        credentials: "include",
        body: body
    };
    try {
        const response = await fetch(requestURL, init);
        const contentType = response.headers.get("content-type");
        const data = contentType?.includes("application/json") ? await response.json() : await response.text();
        const preparedData = decodeJSONResponse ? $1653b55d89a7adce$var$prepareJsonResponse(data, showMessages) : data;
        resolveHandler(preparedData);
    } catch (error) {
        rejectHandler(error);
    }
};
const $1653b55d89a7adce$export$24835cb787452b46 = async (params)=>{
    const requestManager = document.querySelector("[data-tk-request-manager]");
    if (requestManager) return requestManager.addRequest(params);
    return $1653b55d89a7adce$export$d5a8517da06db2d(params);
};




var $2215c02a950e9fbf$var$DialogActions;
/**
 * data-tk-dialog-jump-forward
 * data-tk-dialog-jump-backward
 * data-tk-dialog-jump-to
 * data-tk-dialog-close
 * data-tk-dialog-close-and-reset
 * data-tk-close-on-backdrop-click
 */ (function(DialogActions) {
    DialogActions["JUMP_FORWARD"] = "jump_forward";
    DialogActions["JUMP_BACKWARD"] = "jump_backward";
    DialogActions["JUMP_TO"] = "jump_to";
    DialogActions["RESET_FORM"] = "reset_form";
})($2215c02a950e9fbf$var$DialogActions || ($2215c02a950e9fbf$var$DialogActions = {}));
class $2215c02a950e9fbf$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.dialogs = [];
        this.currentDialog = 0;
        this.shouldOpen = false;
        this.closeOnBackdropClick = true;
        this.url = this.getAttribute("data-tk-url") || undefined;
        this.button = this.querySelector("button") || undefined;
        this.shouldOpen = this.hasAttribute("data-tk-open");
        this.closeOnBackdropClick = this.hasAttribute("data-tk-close-on-backdrop-click") ? JSON.parse(this.getAttribute("data-tk-close-on-backdrop-click")) : true;
        this.shouldMaxWidth = this.hasAttribute("data-tk-should-max-width");
        this.dialogClassName = this.getAttribute("data-tk-dialog-class-name") || "tk-dialog";
        this.dialogInnerClassName = this.getAttribute("data-tk-dialog-inner-class-name") || "tk-dialog__inner";
        this.dialogCloseClassName = this.getAttribute("data-tk-dialog-close-class-name") || "tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close";
        this.maxWidthClassName = this.getAttribute("data-tk-max-width-class-name") || "tk-dialog--max-width";
        this.formDataString = this.getAttribute("data-tk-form-data") || undefined;
        this.isPopup = this.hasAttribute("data-tk-is-popup");
        this.isConfirm = this.hasAttribute("data-tk-is-confirm");
        this.confirmTitle = this.getAttribute("data-tk-confirm-title") || undefined;
        this.confirmDescription = this.getAttribute("data-tk-confirm-description") || undefined;
        this.confirmCancelIcon = this.getAttribute("data-tk-confirm-cancel-icon") || "cross";
        this.confirmCancelLabel = this.getAttribute("data-tk-confirm-cancel-label") || undefined;
        this.confirmSubmitIcon = this.getAttribute("data-tk-confirm-submit-icon") || "check";
        this.confirmSubmitLabel = this.getAttribute("data-tk-confirm-submit-label") || undefined;
        this.forceReloadContent = this.hasAttribute("data-tk-force-reload-content");
    }
    connectedCallback() {
        if (!this.url) throw new Error("Dialog: URL is missing!");
        this.registerClickListener();
        this.checkAutoOpen();
    }
    registerClickListener() {
        if (!this.button) return;
        const onClick = this.openDialog.bind(this, this.url);
        this.pushListener({
            event: "click",
            element: this.button,
            action: onClick
        });
    }
    registerFormListener(form) {
        const onSubmit = this.handleForm.bind(this, form);
        this.pushListener({
            event: "submit",
            element: form,
            action: onSubmit
        });
    }
    registerCloseListener() {
        const onClick = this.closeDialog.bind(this);
        this.pushListener({
            event: "click",
            element: window,
            action: onClick
        });
    }
    createDialog(url) {
        const dialog = $2215c02a950e9fbf$export$2e2bcd8739ae039.renderDialog({
            className: `${this.dialogClassName} ${this.shouldMaxWidth ? this.maxWidthClassName : ""}`,
            closeClassName: this.dialogCloseClassName,
            innerClassName: this.dialogInnerClassName,
            tag: "dialog",
            isConfirm: this.isConfirm,
            confirmURL: url,
            confirmTitle: this.confirmTitle,
            confirmDescription: this.confirmDescription,
            confirmCancelIcon: this.confirmCancelIcon,
            confirmCancelLabel: this.confirmCancelLabel,
            confirmSubmitIcon: this.confirmSubmitIcon,
            confirmSubmitLabel: this.confirmSubmitLabel
        });
        const onClosed = this.closedDialog.bind(this);
        this.pushListener({
            event: "close",
            element: dialog,
            action: onClosed
        });
        this.currentDialog = this.dialogs.push({
            url: url,
            dialog: dialog
        }) - 1;
        return dialog;
    }
    getContent(url) {
        if (this.isConfirm) {
            this.closeCurrentDialog();
            const dialog = this.createDialog(url);
            this.isPopup ? dialog.show() : dialog.showModal();
            this.hookAfterShowModal(dialog);
        } else (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url)
        });
    }
    getContentWithData(url, payload) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: payload
        });
    }
    handleResponseSuccess(url, response) {
        if (!response || !response.success) return;
        this.closeCurrentDialog();
        const dialog = this.createDialog(url);
        const content = dialog.querySelector("[data-tk-dialog-content]");
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
        this.isPopup ? dialog.show() : dialog.showModal();
        this.hookAfterShowModal(dialog);
        const form = content.querySelector("form");
        form && this.registerFormListener(form);
    }
    openDialog(url) {
        this.handleUrlAndDialogs(url);
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    closeDialog(event) {
        const dialogItem = this.dialogs.at(this.currentDialog);
        // Used to check if the event isn't triggered by the enter key
        const isRealClickEvent = event.pointerId !== -1;
        if (!dialogItem || !isRealClickEvent) return;
        const { dialog: dialog } = dialogItem;
        if (this.closeOnBackdropClick) $2215c02a950e9fbf$export$2e2bcd8739ae039.closeDialogIfOutside(dialog, event);
    }
    hookAfterShowModal(dialog) {
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-close]", ()=>dialog.close());
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-close-and-reset]", (button)=>this.handleActions("reset_form", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-jump-forward]", (button)=>this.handleActions("jump_forward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-jump-backward]", (button)=>this.handleActions("jump_backward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-jump-to]", (button)=>this.handleActions("jump_to", button));
    }
    static attachButtonClickHandler(dialog, selector, callback) {
        const buttons = dialog.querySelectorAll(selector);
        buttons.forEach((button)=>{
            button.addEventListener("click", ()=>callback(button));
        });
    }
    handleActions(action, button) {
        const handler = {
            jump_forward: ()=>this.forward(button),
            jump_backward: ()=>this.backward(),
            jump_to: ()=>this.jumpTo(button),
            reset_form: ()=>this.resetForm(button)
        };
        handler[action]();
    }
    closeCurrentDialog() {
        const dialogItem = this.dialogs.at(this.currentDialog);
        if (!dialogItem) return;
        dialogItem.dialog.close();
    }
    handleUrlAndDialogs(url) {
        const existsURL = this.dialogs.some((dialogItem)=>dialogItem.url === url);
        if (existsURL) {
            const nextDialog = this.getDialogByURL(url);
            if (!nextDialog) return;
            const waitForContent = this.forceReloadContent;
            if (this.forceReloadContent) this.renewDialogContent(nextDialog, url);
            if (waitForContent) return;
            nextDialog.showModal();
        } else try {
            const payload = JSON.parse(this.formDataString || "{}");
            Object.keys(payload).length > 0 ? this.getContentWithData(url, payload) : this.getContent(url);
        } catch (error) {
            throw new Error(`Dialog: ${error}`);
        }
    }
    forward(button) {
        // Check if already exists
        const url = button.getAttribute("data-tk-url");
        if (!url) throw new Error("Dialog: URL is missing!");
        this.closeCurrentDialog();
        this.handleUrlAndDialogs(url);
        this.currentDialog += 1;
    }
    backward() {
        const nextDialogItem = this.dialogs.at(this.currentDialog - 1);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        nextDialogItem.dialog.showModal();
        this.currentDialog -= 1;
    }
    jumpTo(button) {
        const index = Number(button.getAttribute("data-tk-dialog-jump-to"));
        const nextDialogItem = this.dialogs.at(index);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        nextDialogItem.dialog.showModal();
        this.currentDialog = index;
    }
    resetForm(button) {
        button.form?.reset();
        this.closeCurrentDialog();
    }
    handleForm(form, event) {
        const shouldSwitchToNext = form.hasAttribute("data-tk-switch-to-next");
        if (!shouldSwitchToNext) return;
        event.preventDefault();
        const formData = new FormData(form);
        const url = form.action;
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: formData
        });
    }
    getDialogByURL(url) {
        const dialogItem = this.dialogs.find((item)=>item.url === url);
        return dialogItem?.dialog;
    }
    closedDialog() {
        const allDialogClosed = this.dialogs.every((item)=>!item.dialog.open);
        if (!allDialogClosed) return;
        this.currentDialog = 0;
        this.removeListener(window);
    }
    static renderDialog(options) {
        const { tag: tag, className: className = "tk-dialog", closeClassName: closeClassName = "tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close", innerClassName: innerClassName = "tk-dialog__inner", content: content, isConfirm: isConfirm = false, confirmURL: confirmURL, confirmTitle: confirmTitle, confirmDescription: confirmDescription, confirmCancelIcon: confirmCancelIcon, confirmCancelLabel: confirmCancelLabel, confirmSubmitIcon: confirmSubmitIcon, confirmSubmitLabel: confirmSubmitLabel } = options;
        const dialog = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            ${isConfirm ? `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            <form action="${confirmURL}" method="post">
                                <h3>${confirmTitle}</h3>
                                <p>${confirmDescription}</p>
                                <div class="flex flex--gap-x-2 flex--justify-end spacer-mt-9">
                                    <button type="button" class="tk-button tk-button--secondary" data-tk-dialog-close>
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmCancelIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmCancelLabel}</span>
                                    </button>
                                    <button type="submit" class="tk-button tk-button--primary">
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmSubmitIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmSubmitLabel}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </${tag}>
                ` : `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            ${content}
                        </div>
                    </${tag}>
                `}
        `);
        document.body.insertAdjacentElement("beforeend", dialog);
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-close]", ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog));
        return dialog;
    }
    static open(element, isPopup = false) {
        if (element instanceof HTMLDialogElement) isPopup ? element.show() : element.showModal();
        else element.classList.add("tk-dialog--open");
    }
    static close(element) {
        if (element instanceof HTMLDialogElement) element.close();
        else {
            element.classList.remove("tk-dialog--open");
            element.dispatchEvent(new Event("close"));
        }
    }
    static closeDialogIfOutside(element, event) {
        /**
         * Checking the coordinates of the client for the value 0 and the
         * HTMLSelectElement or HTMLOptionElement element ensures that the
         * dialogue does not close in Mozilla. This is a bug in Firefox
         * that has not yet been fixed.
         */ if (event.clientX === 0 && event.clientY === 0 && (event.target instanceof HTMLSelectElement || event.target instanceof HTMLOptionElement)) return;
        const dialogDimensions = element.getBoundingClientRect();
        if (event.clientX < dialogDimensions.left || event.clientX > dialogDimensions.right || event.clientY < dialogDimensions.top || event.clientY > dialogDimensions.bottom) element.close();
    }
    checkAutoOpen() {
        if (this.shouldOpen) this.openDialog(this.url);
    }
    renewDialogContent(dialog, url) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.getRenewDialogContent.bind(this, dialog)
        });
    }
    getRenewDialogContent(openDialog, response) {
        const dialogInner = openDialog.querySelector("[data-tk-dialog-content]");
        dialogInner.innerHTML = response.dataAsHtml;
        openDialog.showModal();
        this.hookAfterShowModal(openDialog);
    }
}






class $edcef81612fbf4b7$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector("[data-tk-static-content-edit]") || undefined;
        this.target = this.getAttribute("data-tk-target") || "#tk-static-content-editor";
        this.boId = this.getAttribute("data-tk-bo-id") || undefined;
        this.boNumber = this.getAttribute("data-tk-bo-number") || undefined;
        this.artTextNumber = this.getAttribute("data-tk-art-text-number") || undefined;
        this.bo = this.getAttribute("data-tk-bo") || undefined;
        this.attr = this.getAttribute("data-tk-attr") || undefined;
        this.itemId = this.getAttribute("data-tk-id") || undefined;
        this.langNumber = this.getAttribute("data-tk-lang-number") || undefined;
        this.dataPer = this.getAttribute("data-tk-data-per") || undefined;
        this.asyncTemplate = this.getAttribute("data-tk-async-template") || undefined;
        this.urlTemplate = [];
        this.templateContentPromiseArray = [];
        this.templatesLoaded = false;
        this.fileUploadIFrameURL = this.getAttribute("data-tk-file-upload-iframe-url") || "";
    }
    async connectedCallback() {
        if (!this.button || !this.boId || !this.dataPer || !this.asyncTemplate) return;
        // @ts-ignore Import module
        // eslint-disable-next-line import/extensions, import/no-absolute-path
        await (parcelRequire("22OJp"));
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.sendAjaxRequest.bind(this);
        this.pushListener({
            event: "click",
            element: this.button,
            action: onClick
        });
    }
    registerModalListener(modal) {
        const saveButton = modal.querySelector("[data-tk-static-content-save]") || undefined;
        const onSave = this.save.bind(this, saveButton);
        saveButton && this.pushListener({
            event: "click",
            element: saveButton,
            action: onSave
        });
        const cancelButton = modal.querySelector("[data-tk-static-content-cancel]");
        const onCancel = this.cancel.bind(this);
        cancelButton && this.pushListener({
            event: "click",
            element: cancelButton,
            action: onCancel
        });
    }
    sendAjaxRequest() {
        this.requestData = {
            type: "staticcontent",
            boid: this.boId,
            bonumber: this.boNumber,
            arttextno: this.artTextNumber,
            per: this.dataPer,
            template: this.asyncTemplate,
            modalid: this.target,
            bo: this.bo,
            id: this.itemId,
            attr: this.attr
        };
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.showContentInEditMode.bind(this),
            payload: this.requestData
        });
    }
    save(button) {
        if (!button) return;
        const htmlEncoded = $edcef81612fbf4b7$export$2e2bcd8739ae039.htmlEncode($edcef81612fbf4b7$export$2e2bcd8739ae039.getContentFromEditMode());
        this.requestData = {
            type: "staticcontent",
            boid: this.boId,
            bonumber: this.boNumber,
            arttextno: this.artTextNumber,
            bo: this.bo,
            id: this.itemId,
            attr: this.attr,
            html: htmlEncoded
        };
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshContent.bind(this),
            payload: this.requestData
        });
        this.cancel();
    }
    cancel() {
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).close(this.dialog);
    }
    showContentInEditMode(response) {
        if (!response.success || !this.requestData) return;
        this.dialog = (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).renderDialog({
            content: response.dataAsHtml,
            className: "tk-dialog tk-dialog--fullscreen",
            tag: "div"
        });
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).open(this.dialog);
        this.pushListener({
            event: "close",
            element: this.dialog,
            action: ()=>this.dialog?.remove()
        });
        this.initEditor();
        const modal = document.querySelector(this.target);
        if (!modal) return;
        this.registerModalListener(modal);
    }
    static getContentFromEditMode() {
        return window.tinymce.activeEditor?.getContent({
            format: "raw"
        }) || "";
    }
    refreshContent(response) {
        if (!response.success || !this.requestData) return;
        let contentContainer = document.getElementById(`staticcontent-${this.requestData.boid}-${this.requestData.arttextno}`);
        if (!contentContainer) this.requestData.id !== undefined && (contentContainer = document.getElementById(this.requestData.id));
        else contentContainer.innerHTML = response.dataAsHtml;
    }
    initEditor() {
        if (!this.requestData) return;
        const selector = `${this.requestData.modalid} [data-tk-static-content-textarea]`;
        // Editor must be removed before initialisation
        window.tinymce.remove(selector);
        const options = {
            selector: selector,
            language: $edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage(),
            plugins: [
                "advlist",
                "autolink",
                "lists",
                "link",
                "image",
                "charmap",
                "preview",
                "anchor",
                "pagebreak",
                "searchreplace",
                "wordcount",
                "visualblocks",
                "visualchars",
                "code",
                "fullscreen",
                "insertdatetime",
                "media",
                "nonbreaking",
                "save",
                "table",
                "directionality",
                "emoticons",
                "template",
                "quickbars"
            ],
            insertdatetime_formats: [
                "%d.%m.%Y",
                "%H:%M"
            ],
            contextmenu: "link image table",
            tools: "inserttable",
            toolbar: "undo redo | styleselect | bold italic | forecolor backcolor | alignleft aligncenteralignright alignjustify | bullist numlist outdent indent | image media link | preview print | filemanager",
            width: "100%",
            base_url: "/webportal/config/layout/themes/tk/vendor/tinymce/",
            language_url: `/webportal/config/layout/themes/tk/translations/tinymce/${$edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage()}.js`,
            promotion: false,
            content_css: [
                "default",
                `/webportal/config/layout/themes/project/generated/staticcontent/staticcontent.css?${new Date().getTime()}`
            ],
            templates: this.urlTemplate,
            extended_valid_elements: "tk-tabs-accordion,tk-tabs-accordion[class],i[data-tk-accordion-icon]",
            custom_elements: "tk-tabs-accordion,tk-tabs-accordion",
            setup: (editor)=>{
                editor.on("SaveContent", (event)=>{
                    event.content = $edcef81612fbf4b7$export$2e2bcd8739ae039.htmlEncode($edcef81612fbf4b7$export$2e2bcd8739ae039.htmlDecode(event.content));
                });
                const openmanager = ()=>{
                    editor.windowManager.openUrl({
                        title: "File Manager",
                        url: $edcef81612fbf4b7$export$2e2bcd8739ae039.getFileManagerURL(editor),
                        width: 900,
                        height: 440
                    });
                };
                editor.ui.registry.addButton("filemanager", {
                    icon: "browse",
                    tooltip: "Insert file",
                    onAction: openmanager
                });
                editor.ui.registry.addMenuItem("filemanager", {
                    icon: "browse",
                    text: "Insert file",
                    onAction: openmanager
                });
                const templateURLElement = document.querySelector("[data-tk-staticcontent-templates-url]");
                const templateURL = templateURLElement && templateURLElement.getAttribute("data-op-url");
                if (templateURL) this.getTemplates(templateURL);
            }
        };
        if (this.fileUploadIFrameURL) options.file_picker_callback = this.handleFilePicker.bind(this);
        window.tinymce.init(options);
    }
    handleFilePicker(callback) {
        window.tinymce.activeEditor?.windowManager.openUrl({
            title: "Fileupload Area",
            url: this.fileUploadIFrameURL,
            width: 800,
            height: 600
        });
        window.addEventListener("message", (event)=>{
            const { data: data } = event;
            if (window.location.origin !== event.origin) return;
            callback(data.content);
        });
    }
    static getFileManagerURL(editor) {
        return `/webportal/tinymcefilemanager.aspx?editor=${editor.id}&lang=${$edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage()}`;
    }
    static htmlEncode(content) {
        return content.toString().replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    static htmlDecode(content) {
        return content.toString().replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&quot;/g, '"').replace(/&amp;/g, "&");
    }
    static getLanguage() {
        if (window.location.href.indexOf("/en/") !== -1) return "en_GB";
        if (window.location.href.indexOf("/fr/") !== -1) return "fr_FR";
        if (window.location.href.indexOf("/it/") !== -1) return "it";
        return "de";
    }
    async getTemplates(templateURL) {
        if (this.templatesLoaded) return;
        // get url content
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: templateURL,
                resolveHandler: (response)=>{
                    this.getTemplateContent(response, resolve);
                }
            });
        });
    }
    getTemplateContent(response, resolveFunction) {
        response.dataAsJson.forEach((element)=>{
            this.templateContentPromiseArray = [];
            this.templateContentPromiseArray.push(new Promise((resolve)=>{
                (0, $1653b55d89a7adce$export$24835cb787452b46)({
                    requestURL: element.url,
                    resolveHandler: (response)=>{
                        this.saveTemplateContent(response, element, resolveFunction, resolve);
                    }
                });
            }));
        });
    }
    saveTemplateContent(response, element, resolvedAllFunction, resolveArrayElementFunction) {
        const templateContent = response.dataAsHtml;
        const newTemplateEntry = {
            title: element.title,
            description: element.description,
            content: templateContent
        };
        this.urlTemplate.push(newTemplateEntry);
        resolveArrayElementFunction();
        Promise.allSettled(this.templateContentPromiseArray).then(()=>{
            resolvedAllFunction();
            this.templatesLoaded = true;
        });
    }
}



var $9a3403e3213d867d$var$HoverState;
(function(HoverState) {
    HoverState["ACTIVE"] = "active";
    HoverState["INACTIVE"] = "inactive";
})($9a3403e3213d867d$var$HoverState || ($9a3403e3213d867d$var$HoverState = {}));
class $9a3403e3213d867d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.fieldElement = this.querySelector("input, select, textarea");
        this.labelElement = this.querySelector("label") || undefined;
        this.isMaterial = this.hasAttribute("data-tk-is-material");
        this.materialClass = this.getAttribute("data-tk-material-class") || "tk-form-material";
        this.materialNumberInputClass = this.getAttribute("data-tk-material-number-input-class") || "tk-form-material--number";
        this.materialLabelInsideClass = this.getAttribute("data-tk-material-label-inside-class") || "tk-form-material--label-inside";
        this.materialSelectFocussedClass = this.getAttribute("data-tk-material-select-focussed-class") || "tk-form-select--focussed";
        this.materialLoadedClass = this.getAttribute("data-tk-material-loaded-class") || "tk-form-material--loaded";
        this.isPasswordInput = this.hasAttribute("data-tk-toggle-password");
        this.disableOnAddonClick = this.hasAttribute("data-tk-disable-on-addon-click");
        this.addonElement = this.querySelector("[data-tk-addon]") || undefined;
        this.waitForSurroundingContent = this.closest("[data-wait-for-surrounding-content]") || undefined;
        this.addonSuffixDistance = 0;
        this.addonPrefixDistance = 0;
        this.addonDefaultPadding = parseInt(this.getAttribute("data-tk-addon-default-padding") || "0", 10) || 4;
        this.onTransitionEnd = ()=>{};
    }
    connectedCallback() {
        if (this.isNumberInput() || this.waitForSurroundingContent) {
            this.onDomContentLoaded();
            return;
        }
        this.checkRequiredAttribute();
        this.registerAddonClickedListener();
        this.registerAddonHoverListener();
        this.registerShowPasswordClickedListener();
        this.initMaterialInput();
        this.observeDisabledAttribute();
    }
    /**
     * For the Material Number Input or forms inside of tables, it is necessary that all surrounding elements have been
     * fullyloaded before the Material Number Element itself is displayed.
     * This is because the position of the label in the collapsed state
     * needs to be calculated for the Material Number Input. This calculation depends on the surrounding elements
     */ onDomContentLoaded() {
        document.addEventListener("DOMContentLoaded", ()=>{
            this.checkRequiredAttribute();
            this.registerAddonClickedListener();
            this.registerAddonHoverListener();
            this.registerShowPasswordClickedListener();
            this.initMaterialInput();
            this.observeDisabledAttribute();
        });
    }
    // #region Required
    checkRequiredAttribute() {
        if (!this.labelElement || !this.fieldElement || !this.fieldElement.hasAttribute("required")) return;
        this.labelElement.textContent = `${this.labelElement.textContent} *`;
    }
    // #endregion
    // #region disabled
    observeDisabledAttribute() {
        if (!this.fieldElement || !this.labelElement) return;
        // inital check
        this.checkDisabledAttribute();
        const observerConfig = {
            attributes: true,
            attributeFilter: [
                "disabled"
            ]
        };
        const onCheckDiabledAttribute = this.checkDisabledAttribute.bind(this);
        const observer = new MutationObserver(onCheckDiabledAttribute);
        observer.observe(this.fieldElement, observerConfig);
    }
    checkDisabledAttribute() {
        const addDisabledClass = this.fieldElement.hasAttribute("disabled");
        this.classList.toggle("tk-form-input--disabled", addDisabledClass);
    }
    // #endregion
    // #region Addon
    registerAddonClickedListener() {
        if (!this.addonElement || this.disableOnAddonClick) return;
        const addonClickHandler = this.onAddonClicked.bind(this);
        this.pushListener({
            event: "click",
            element: this.addonElement,
            action: addonClickHandler
        });
    }
    registerAddonHoverListener() {
        if (!this.addonElement) return;
        const onHoverStartHandler = this.onAddonHover.bind(this, "active");
        this.pushListener({
            event: "mouseenter",
            element: this.addonElement,
            action: onHoverStartHandler
        });
        const onHoverEndHandler = this.onAddonHover.bind(this, "inactive");
        this.pushListener({
            event: "mouseleave",
            element: this.addonElement,
            action: onHoverEndHandler
        });
    }
    onAddonHover(hoverState) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error("No Input element found");
        this.classList.toggle("tk-form--addon-hover", hoverState === "active" && !this.fieldElement.disabled);
    }
    onAddonClicked() {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error("No Input element found");
        if (this.isPasswordInput) return;
        this.fieldElement.focus();
        const lastCharPosition = this.fieldElement.value.length;
        const isNumberInput = this.fieldElement.type === "number";
        if (isNumberInput) this.fieldElement.setAttribute("type", "text");
        this.fieldElement.setSelectionRange(lastCharPosition, lastCharPosition);
        if (isNumberInput) this.fieldElement.setAttribute("type", "number");
    }
    registerShowPasswordClickedListener() {
        if (!this.isPasswordInput || !this.addonElement) return;
        const passwordShowClickHandler = this.onPasswordShowClicked.bind(this);
        this.pushListener({
            event: "mousedown",
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: "mouseup",
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: "touchstart",
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: "touchend",
            element: this.addonElement,
            action: passwordShowClickHandler
        });
    }
    onPasswordShowClicked(event) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement)) throw new Error("Missing input element");
        if (event.type === "mousedown" || event.type === "touchstart") this.fieldElement.type = "text";
        else this.fieldElement.type = "password";
    }
    // #endregion
    // #region Material
    initMaterialInput() {
        if (!this.isMaterial) return;
        if (!this.fieldElement) throw new Error("No element found");
        this.classList.add(this.materialClass);
        if (this.isNumberInput()) this.classList.add(this.materialNumberInputClass);
        this.registerLabelTransitionEndListener();
        this.calculateAddonWidth();
        this.setMaterialLabelState();
        this.registerMaterialValueChangeListener();
        this.registerMaterialSelectFocusChangeListener();
    }
    /**
     * This function is mainly used to check whether a valid value has been
     * set for the data-tk-addon attribute
     * @returns addonType: string representing the addon type
     */ getAddonType() {
        if (!this.addonElement) throw new Error("Missing addon");
        const addonType = this.addonElement.getAttribute("data-tk-addon");
        if (addonType !== "prefix" && addonType !== "suffix") throw new Error("Wrong addon type");
        return addonType;
    }
    /**
     * Checks whether the element contains a value or not. This information is required
     * to determine whether the label should be displayed inside or outside the element.
     * @returns isEmptyElement: boolean
     */ checkForValue() {
        let isEmptyElement;
        if (this.fieldElement instanceof HTMLSelectElement) {
            const selectedOption = this.querySelector("option:checked");
            const isPlaceholderOption = selectedOption?.hasAttribute("data-tk-empty-option");
            isEmptyElement = isPlaceholderOption;
        } else isEmptyElement = this.fieldElement?.value === "";
        return isEmptyElement;
    }
    /**
     * This function implements the material functionality by displaying the label either
     * inside or outside the control, depending on the content
     */ setMaterialLabelState() {
        // check input value
        const isEmptyMaterialInput = this.checkForValue();
        if (isEmptyMaterialInput) {
            this.classList.add(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error("Missing label element");
            if (this.isNumberInput()) this.setupMaterialNumberLabelStyle();
            if (!this.isNumberInput()) this.setupMaterialDefaultLabelStyle();
        } else {
            this.classList.remove(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error("Missing label element");
            this.labelElement.removeAttribute("style");
        }
    }
    /**
     * This function calculates the label position for a material input that is not of type
     * number and where the label is located within the input
     */ setupMaterialDefaultLabelStyle() {
        if (this.addonPrefixDistance === 0 && this.addonSuffixDistance === 0) return;
        this.labelElement.style.marginLeft = this.addonPrefixDistance > 0 ? `${this.addonPrefixDistance + this.addonDefaultPadding}px` : "0px";
        this.labelElement.style.marginRight = this.addonSuffixDistance > 0 ? `${this.addonSuffixDistance + this.addonDefaultPadding}px` : "0px";
        this.labelElement.style.paddingInline = "0";
    }
    /**
     * This function calculates the label position for a material input of type Number where
     *  the label is located within the input
     */ setupMaterialNumberLabelStyle() {
        this.labelElement.style.paddingInline = "0";
        const labelWidthWithPadding = this.labelElement.getBoundingClientRect().width;
        const computedLabelStyle = window.getComputedStyle(this.labelElement);
        const labelPaddingLeft = parseFloat(computedLabelStyle.paddingLeft);
        const labelPaddingRight = parseFloat(computedLabelStyle.paddingRight);
        const labelWidth = labelWidthWithPadding - labelPaddingLeft - labelPaddingRight;
        const formControlWidth = this.getBoundingClientRect().width;
        const computetInputStyle = window.getComputedStyle(this.fieldElement);
        const inputPaddingRight = parseFloat(computetInputStyle.paddingRight);
        const addonWidth = this.addonElement && this.getAddonType() === "suffix" ? this.addonElement.getBoundingClientRect().width : 0;
        const xOffset = Math.round(formControlWidth - labelWidth - addonWidth - inputPaddingRight);
        this.labelElement.style.paddingLeft = `${xOffset}px`;
    }
    /**
     * This function checks whether the current control has an addon. If so, depending
     * on the type of control, it checks whether the material label requires additional
     * spacing in the folded state
     */ calculateAddonWidth() {
        if (!this.addonElement) return;
        if (this.fieldElement instanceof HTMLSelectElement) return;
        /* The text is displayed right-aligned for the number inputs.
        They must therefore be treated separately */ const isNumberInput = this.isNumberInput();
        const addonType = this.getAddonType();
        if (!isNumberInput && addonType === "prefix") this.addonPrefixDistance = this.addonElement.offsetWidth;
        else if (isNumberInput && addonType === "suffix") this.addonSuffixDistance = this.addonElement.offsetWidth;
    }
    /**
     * Checks whether the input is of type Number. This information is required because
     * the text does not start on the left when the number input is collapsed
     * @returns boolean: representing is input of type number
     */ isNumberInput() {
        if (!(this.fieldElement instanceof HTMLInputElement)) return false;
        return this.fieldElement && this.fieldElement.type === "number";
    }
    /**
     * Listener for material control value changes
     */ registerMaterialValueChangeListener() {
        const onValueChanged = this.setMaterialLabelState.bind(this);
        this.pushListener({
            event: "input",
            element: this.fieldElement,
            action: onValueChanged
        });
    }
    /**
     * Is required so that a class can be added to the focused material select
     * element that colors the text of the select white
     */ registerMaterialSelectFocusChangeListener() {
        if (!(this.fieldElement instanceof HTMLSelectElement)) return;
        const onFocusChanged = this.onMaterialSelectFocusChanged.bind(this);
        this.pushListener({
            event: "focusin",
            element: this.fieldElement,
            action: onFocusChanged
        });
        this.pushListener({
            event: "focusout",
            element: this.fieldElement,
            action: onFocusChanged
        });
    }
    /**
     * This function is used to add a class to the focused material select, which sets
     * the font to white if no option has been selected
     * @param event: Used to determin if focus has been set or removed
     */ onMaterialSelectFocusChanged(event) {
        const { type: type } = event;
        if (type === "focusin") this.classList.add(this.materialSelectFocussedClass);
        else this.classList.remove(this.materialSelectFocussedClass);
    }
    /**
     * This function fades in the material element as soon as the label is in
     * the correct position
     */ registerLabelTransitionEndListener() {
        if (!this.labelElement) throw new Error("Missing label element");
        this.onTransitionEnd = this.addMaterialLoadedModifier.bind(this);
        this.pushListener({
            event: "transitionend",
            element: this.labelElement,
            action: this.onTransitionEnd
        });
    }
    addMaterialLoadedModifier() {
        this.classList.add(this.materialLoadedClass);
        this.labelElement.removeEventListener("transitionend", this.onTransitionEnd);
    }
}





var $21a7ddce6a8de4e2$var$matchType;
(function(matchType) {
    matchType["Some"] = "SOME";
    matchType["Full"] = "FULLMATCH";
})($21a7ddce6a8de4e2$var$matchType || ($21a7ddce6a8de4e2$var$matchType = {}));
class $21a7ddce6a8de4e2$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.validationList = [];
        this.form = this.querySelector("form") || undefined;
        this.fieldWrapperSelector = this.getAttribute("data-tk-field-wrapper-selector") || "[data-tk-field-wrapper]";
        this.formErrorClassName = this.getAttribute("data-tk-form-error-class-name") || "tk-form--error";
        this.fieldHintClassName = this.getAttribute("data-tk-field-hint-class-name") || "tk-form__hint";
        this.shouldValidateInline = this.hasAttribute("data-tk-should-validate-inline");
        this.passwordStrengthMeter = this.querySelector("[data-tk-password-strength-meter]") || undefined;
        this.passwordNewElement = this.querySelector("[data-tk-password-new]") || undefined;
        this.passwordRepeatElement = this.querySelector("[data-tk-password-repeat]") || undefined;
        this.passwordValidClassName = this.getAttribute("data-tk-password-valid-class-name") || "tk-form--valid";
        this.passwordInvalidClassName = this.getAttribute("data-tk-password-valid-class-name") || "tk-form--invalid";
        this.googleRecaptcha = this.querySelector("[data-tk-google-recaptcha]") || undefined;
        // Selects an element that is clicked when the enter key is pressed
        this.preventEnterDefaultAction = this.getAttribute("data-tk-enter-data-attribute-selector") || undefined;
    }
    connectedCallback() {
        if (!this.form) return;
        this.validationList = [];
        this.setNoValidateForm();
        this.searchFieldElements();
        this.registerSubmitListener();
        this.registerPasswordListener();
        this.shouldValidateInline && this.registerFieldValidationListener();
    }
    setNoValidateForm() {
        if (!this.form) return;
        this.form.noValidate = true;
    }
    searchFieldElements() {
        const formElements = this.querySelectorAll("input, select, textarea");
        const formElementList = Array.from(formElements);
        const filteredFormElements = formElementList.filter((element)=>!element.disabled);
        filteredFormElements.forEach((element)=>{
            const wrapper = element.closest(this.fieldWrapperSelector);
            wrapper && this.validationList.push({
                element: element,
                wrapper: wrapper,
                messages: $21a7ddce6a8de4e2$export$2e2bcd8739ae039.generateValidityMessages(element)
            });
        });
    }
    registerSubmitListener() {
        if (!this.form) return;
        const onSubmitHandler = this.validateForm.bind(this);
        this.pushListener({
            event: "submit",
            element: this.form,
            action: onSubmitHandler
        });
    }
    registerPasswordListener() {
        if (!(this.passwordStrengthMeter && this.passwordNewElement && this.passwordRepeatElement)) return;
        const onValidatePassword = this.validatePassword.bind(this);
        this.pushListener({
            event: "input",
            element: this.passwordNewElement,
            action: onValidatePassword
        });
        this.pushListener({
            event: "input",
            element: this.passwordRepeatElement,
            action: onValidatePassword
        });
    }
    registerFieldValidationListener() {
        this.validationList.forEach((item)=>{
            const onValidation = this.validateField.bind(this, item);
            this.pushListener({
                event: "blur",
                element: item.element,
                action: onValidation
            });
            this.pushListener({
                event: "input",
                element: item.element,
                action: onValidation
            });
        });
    }
    async validateRecaptcha() {
        if (!this.googleRecaptcha) return true;
        return new Promise((resolve)=>{
            grecaptcha.ready(async ()=>{
                const siteKey = this.googleRecaptcha.getAttribute("data-tk-site-key");
                if (!siteKey) return resolve(false);
                const token = await grecaptcha.execute(siteKey, {
                    action: "submit"
                });
                if (!token) return resolve(false);
                this.googleRecaptcha.value = token;
                resolve(true);
            });
        });
    }
    async validateByAPI() {
        const validationList = [];
        const fieldElements = this.querySelectorAll("[data-tk-field-check-api]");
        if (fieldElements.length === 0) return true;
        const apiPromises = Array.from(fieldElements).map(async (element)=>{
            const apiURL = element.getAttribute("data-tk-field-check-api");
            const input = element.querySelector("input");
            if (!input || !apiURL || input.value === "") return true;
            const response = await $21a7ddce6a8de4e2$export$2e2bcd8739ae039.fetchExistAPI(apiURL, input.value);
            const validationItem = this.validationList.find((item)=>item.wrapper === element);
            const { isValid: isValid } = response.dataAsJson;
            if (!isValid && validationItem) {
                this.removeMessage(validationItem);
                this.createElementMessage(validationItem, (0, $86b3c5b6d66bd808$export$35e6ad2b040b8403).existigName);
            }
            return isValid;
        });
        const results = await Promise.all(apiPromises);
        validationList.push(...results);
        return validationList.every((item)=>item);
    }
    static async fetchExistAPI(url, value) {
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                payload: {
                    value: value
                },
                resolveHandler: (response)=>{
                    resolve(response);
                }
            });
        });
    }
    async validateForm(event) {
        event.preventDefault();
        const isFormValid = await this.isFormValid();
        if (!isFormValid) return;
        if (this.preventEnterDefaultAction) {
            const elemntToClick = document.querySelector(`[${this.preventEnterDefaultAction}]`);
            elemntToClick?.querySelector("button")?.click();
            return;
        }
        this.form?.submit();
    }
    async isFormValid() {
        await this.validateFields();
        const areFieldsValid = this.validationList.every((item)=>item.element.validity.valid);
        if (!areFieldsValid) return false;
        const isValid = await this.validateByAPI();
        const isRecaptchaValid = await this.validateRecaptcha();
        return (!this.passwordStrengthMeter || this.checkPasswordStengthMeter()) && this.checkPasswordMatching() && isValid && isRecaptchaValid;
    }
    async validateFields() {
        this.validationList.forEach((item)=>{
            this.validateField(item);
        });
        this.firstElementToScrollTo = undefined;
    }
    validateField(item) {
        this.removeMessage(item);
        if (!item.element.validity.valid) this.showMessage(item);
    }
    showMessage(item) {
        const validityList = $21a7ddce6a8de4e2$export$2e2bcd8739ae039.createValidityDictionary(item.element);
        const invalidMessage = validityList.find((validity)=>validity.value);
        const message = invalidMessage ? item.messages.find((message)=>message.key === invalidMessage.key)?.value || "" : item.element.validationMessage;
        this.createElementMessage(item, message);
    }
    createElementMessage(item, message) {
        const spanElement = document.createElement("span");
        spanElement.classList.add(this.fieldHintClassName);
        spanElement.textContent = $21a7ddce6a8de4e2$export$2e2bcd8739ae039.replacePlaceholders(message, item.element);
        item.messageElement = spanElement;
        item.wrapper.classList.add(this.formErrorClassName);
        item.wrapper.insertAdjacentElement("beforeend", spanElement);
        if (this.firstElementToScrollTo) return;
        this.firstElementToScrollTo = item.messageElement;
        this.firstElementToScrollTo.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }
    removeMessage(item) {
        const spanElement = item.messageElement;
        if (!spanElement) return;
        spanElement.remove();
        item.wrapper.classList.remove(this.formErrorClassName);
    }
    static createValidityDictionary(element) {
        const { validity: validity } = element;
        const validityList = [];
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for(const key in validity){
            const validityItem = {
                key: key,
                value: Boolean(validity[key])
            };
            validityList.push(validityItem);
        }
        return validityList;
    }
    static generateValidityMessages(element) {
        const list = [];
        const customErrorPrefix = "data-tk-error-msg-";
        const attributeList = element.getAttributeNames().filter((name)=>name.startsWith(customErrorPrefix));
        attributeList.forEach((key)=>{
            const keyFormatted = key.replace(customErrorPrefix, "").replace(/-./g, (x)=>x[1].toUpperCase());
            const value = element.getAttribute(key);
            value && list.push({
                key: keyFormatted,
                value: value
            });
        });
        if (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91) {
            const messages = (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91);
            Object.entries(messages).forEach((entry)=>{
                const [key, value] = entry;
                const foundMessage = list.filter((item)=>item.key === key);
                !foundMessage.length && list.push({
                    key: key,
                    value: value
                });
            });
        }
        return list;
    }
    static replacePlaceholders(value, element) {
        const dictionary = {
            "{minLength}": element.getAttribute("minlength") || "",
            "{maxLength}": element.getAttribute("maxlength") || "",
            "{length}": element.value.length.toString() || "",
            "{step}": element.getAttribute("step") || "",
            "{min}": element.getAttribute("min") || "",
            "{max}": element.getAttribute("max") || "",
            "{currentValue}": element.value
        };
        const re = new RegExp(Object.keys(dictionary).join("|"), "gi");
        return value.replace(re, (matched)=>dictionary[matched]);
    }
    checkPasswordStengthMeter() {
        const patterns = this.getPasswordPatterns();
        return patterns.every((item)=>item.element?.classList.contains(this.passwordValidClassName));
    }
    checkPasswordMatching() {
        let isValid;
        const newPasswordItem = this.validationList.find((item)=>item.element === this.passwordNewElement);
        const repeatPasswordItem = this.validationList.find((item)=>item.element === this.passwordRepeatElement);
        if (!newPasswordItem || !repeatPasswordItem) return true;
        if (newPasswordItem.element.value !== repeatPasswordItem.element.value) {
            this.removeMessage(repeatPasswordItem);
            this.createElementMessage(repeatPasswordItem, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).passwordNotMatching);
            isValid = false;
        } else isValid = true;
        return isValid;
    }
    validatePassword(event) {
        const target = event.currentTarget;
        const patterns = this.getPasswordPatterns();
        patterns.forEach((item)=>{
            const regex = new RegExp(item.pattern || "", item.matchtype === "FULLMATCH" ? "g" : "");
            const regexpMatch = target.value.match(regex);
            if (item.matchtype === "SOME") {
                if (regexpMatch) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
            if (item.matchtype === "FULLMATCH") {
                if (regexpMatch?.length === target.value.length) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
        });
    }
    getPasswordPatterns() {
        const characterPatternElement = this.passwordStrengthMeter?.querySelector("[data-tk-pwd-character-pattern]");
        const upperPatternElement = this.passwordStrengthMeter?.querySelector("[data-tk-pwd-upper-pattern]");
        const numberPatternElement = this.passwordStrengthMeter?.querySelector("[data-tk-pwd-number-pattern]");
        const allowedSymbolPatternElement = this.passwordStrengthMeter?.querySelector("[data-tk-pwd-allowed-symbols-pattern]");
        const characterPattern = characterPatternElement?.getAttribute("data-tk-pwd-character-pattern");
        const upperPattern = upperPatternElement?.getAttribute("data-tk-pwd-upper-pattern");
        const numberPattern = numberPatternElement?.getAttribute("data-tk-pwd-number-pattern");
        const allowedSymbolPattern = allowedSymbolPatternElement?.getAttribute("data-tk-pwd-allowed-symbols-pattern");
        return [
            {
                pattern: characterPattern,
                element: characterPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: upperPattern,
                element: upperPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: numberPattern,
                element: numberPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: allowedSymbolPattern,
                element: allowedSymbolPatternElement,
                matchtype: "FULLMATCH"
            }
        ];
    }
}



class $5163560edb86f711$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.counter = 0;
        this.link = this.querySelector("a") || undefined;
        this.emptyClass = this.getAttribute("data-tk-compare-list-link-empty-class") || "tk-button__header--empty";
    }
    connectedCallback() {
        if (!this.hasAttribute("data-tk-compare-list-link-count") || !this.link) return;
        this.initCounter();
    }
    initCounter() {
        const countString = this.getAttribute("data-tk-compare-list-link-count");
        this.counter = Number(countString);
        this.setCounter();
    }
    updateCounter(compareState) {
        if (compareState === "a") this.counter += 1;
        if (compareState === "p") this.counter -= 1;
        this.setCounter();
    }
    setCounter() {
        this.link.setAttribute("data-count", `${this.counter}`);
        this.updateCounterVisibility();
    }
    updateCounterVisibility() {
        this.link.classList.toggle(this.emptyClass, this.counter === 0);
    }
}


function $7e8cc8975b3fe464$export$60d21ef256fe91e0(point, rectangle, offset) {
    return point.x < rectangle.left + (offset?.left || 0) || point.x > rectangle.right + (offset?.right || 0) || point.y < rectangle.top + (offset?.top || 0) || point.y > rectangle.bottom + (offset?.bottom || 0);
}
function $7e8cc8975b3fe464$export$dcbd32acb1a13bc6(event, rectangles) {
    const point = {
        x: event.clientX,
        y: event.clientY
    };
    return rectangles.every((item)=>$7e8cc8975b3fe464$export$60d21ef256fe91e0(point, item.rectangle, item.offset));
}


class $9d20cb2aef3a6ec2$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.dialog = this.querySelector("dialog") || undefined;
        this.button = this.querySelector("button") || undefined;
        this.selectedClassName = this.getAttribute("data-selected-class-name") || "tk-button__account--selected";
        this.alignedRightClassName = this.getAttribute("data-aligned-right-class-name") || "tk-button__account--right";
        this.onShowEvent = ()=>{};
        this.onCloseEvent = ()=>{};
    }
    disconnectedCallback() {
        this.removeEventListener("mouseenter", this.onShowEvent);
        this.dialog?.removeEventListener("mouseleave", this.onCloseEvent);
    }
    connectedCallback() {
        this.registerOpenListener();
    }
    registerOpenListener() {
        this.onShowEvent = this.show.bind(this);
        this.addEventListener("mouseenter", this.onShowEvent);
    }
    registerCloseListener() {
        this.onCloseEvent = this.close.bind(this);
        this.addEventListener("mouseleave", this.onCloseEvent);
        this.dialog?.addEventListener("mouseleave", this.onCloseEvent);
    }
    show() {
        if (!this.dialog || !this.button) return;
        this.dialog.show();
        this.button.classList.add(this.selectedClassName);
        const { left: left } = this.button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        if (window.outerWidth <= this.dialog.clientWidth + leftPosition) this.dialog.classList.add(this.alignedRightClassName);
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    close(event) {
        if (!this.dialog || !this.button) return;
        const dialogDimensions = this.dialog.getBoundingClientRect();
        const buttonDimensions = this.button.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: dialogDimensions
            },
            {
                rectangle: buttonDimensions,
                offset: {
                    bottom: dialogDimensions.top - buttonDimensions.bottom
                }
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.button.classList.remove(this.selectedClassName);
            this.dialog.close();
        }
    }
}






class $8b05e2474621c644$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static #_ = this.observedAttributes = [
        "data-count"
    ];
    constructor(){
        super();
        this.isDataFetched = false;
        this.headerButton = this.querySelector("[data-tk-header-button]") || undefined;
        this.overlay = this.querySelector("[data-tk-minibasket-overlay]") || undefined;
        this.contentWrapper = this.querySelector("[data-tk-minibasket-content]") || undefined;
        this.countItemsRequestURL = this.getAttribute("data-tk-count-items-request-url") || undefined;
        this.getContentRequestURL = this.getAttribute("data-tk-get-content-request-url") || undefined;
        this.headerButtonEmptyClassName = this.getAttribute("data-tk-header-button-empty-class-name") || "tk-button__header--empty";
        this.offset = Number(this.getAttribute("data-tk-minibasket-offset")) || 4;
        this.openClassName = this.getAttribute("data-tk-open-class-name") || "tk-minibasket--open";
        this.minDistanceToBorder = Number(this.getAttribute("data-tk-min-distance-to-border")) || 5;
        // Custom Events
        this.openedEventName = this.getAttribute("data-tk-event-opened-name") || "tk-minibasket-opened";
        this.openedEvent = new CustomEvent(this.openedEventName);
        this.closedEventName = this.getAttribute("data-tk-event-closed-name") || "tk-minibasket-closed";
        this.closedEvent = new CustomEvent(this.closedEventName);
        this.updateEventName = this.getAttribute("data-tk-event-update-name") || "tk-minibasket-update";
        this.updateEvent = new CustomEvent(this.updateEventName);
    }
    connectedCallback() {
        if (!this.headerButton) throw new Error("Minibasket: Header Button is missing!");
        if (!this.countItemsRequestURL || !this.getContentRequestURL) throw new Error("Minibasket: Request URLs are missing!");
        this.registerInitializeListener();
        this.fetchQuantity();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "data-count") this.setCounter(Number(newValue));
    }
    registerInitializeListener() {
        const handleOpen = this.open.bind(this);
        this.pushListener({
            event: "click",
            element: this.headerButton,
            action: handleOpen
        });
        const handleOpened = this.opened.bind(this);
        this.pushListener({
            event: this.openedEventName,
            element: this,
            action: handleOpened
        });
        const handleUpdate = this.update.bind(this);
        this.pushListener({
            event: this.updateEventName,
            element: this,
            action: handleUpdate
        });
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: "click",
            element: window,
            action: handleClose
        });
    }
    registerScrollListener() {
        const handleScroll = this.alignOverlayToButton.bind(this);
        this.pushListener({
            event: "scroll",
            element: window,
            action: handleScroll
        });
    }
    open() {
        document.body.insertAdjacentElement("beforeend", this.overlay);
        this.overlay.classList.add(this.openClassName);
        this.alignOverlayToButton();
        !this.isDataFetched && this.fetchAll();
        this.dispatchEvent(this.openedEvent);
    }
    opened() {
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
            this.registerScrollListener();
        }, 0);
    }
    update() {
        this.fetchQuantity();
        this.fetchAll();
    }
    close(event) {
        if (!this.overlay) return;
        const headerButtonRect = this.headerButton.getBoundingClientRect();
        const overlayRect = this.overlay.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: headerButtonRect
            },
            {
                rectangle: overlayRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.overlay.classList.remove(this.openClassName);
            this.dispatchEvent(this.closedEvent);
            this.removeListener(window);
        }
    }
    fetchAll() {
        Promise.all([
            $8b05e2474621c644$export$2e2bcd8739ae039.fetchData(this.getContentRequestURL)
        ]).then((responses)=>{
            this.isDataFetched = true;
            this.placeContent(responses[0]);
        }).catch(()=>{
            this.isDataFetched = false;
        });
    }
    fetchQuantity() {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.countItemsRequestURL,
            resolveHandler: this.getQuantity.bind(this)
        });
    }
    static fetchData(url) {
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: (response)=>{
                    resolve(response);
                }
            });
        });
    }
    getQuantity(response) {
        if (!response || !response.success) return;
        const { quantity: quantity } = response.dataAsJson;
        this.setCounter(quantity);
    }
    setCounter(quantity) {
        if (quantity === 0) this.headerButton?.classList.add(this.headerButtonEmptyClassName);
        else {
            this.headerButton?.setAttribute("data-count", `${quantity || 0}`);
            this.headerButton?.classList.remove(this.headerButtonEmptyClassName);
        }
    }
    placeContent(response) {
        if (!response || !response.success) return;
        if (!this.contentWrapper) return;
        const items = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.contentWrapper.innerHTML = "";
        this.contentWrapper.insertAdjacentHTML("beforeend", items.innerHTML);
    }
    alignOverlayToButton() {
        const { bottom: bottom, right: right } = this.headerButton.getBoundingClientRect();
        const { width: width } = this.overlay.getBoundingClientRect();
        const distanceToBorder = right - width;
        this.overlay.style.top = `${bottom + this.offset}px`;
        if (distanceToBorder >= this.minDistanceToBorder) this.overlay.style.left = `${right - width}px`;
        else {
            this.overlay.style.left = "50%";
            this.overlay.style.transform = "translateX(-50%)";
        }
    }
}





class $cb17fd7e698c018c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.listWrapperClassName = this.getAttribute("data-tk-zip-list-class") || "tk-form-zipcity__list";
        this.fieldCountry = this.querySelector("[data-tk-zip-country]") || undefined;
        this.fieldZip = this.querySelector("[data-tk-zip-zip]") || undefined;
        this.fieldCity = this.querySelector("[data-tk-zip-city]") || undefined;
        this.lastSearchTerm = "";
        this.selectedField = undefined;
        this.listWrapper = document.createElement("div");
        this.listWrapper.classList.add(this.listWrapperClassName);
        this.listWrapper.hidden = true;
        this.loadingSpinnerTimeout = null;
        this.clearDataTimeout = null;
        this.inputObject = {
            inputField: undefined,
            dropdown: this.listWrapper,
            listItemSelected: undefined,
            data: []
        };
    }
    connectedCallback() {
        this.registerListener();
    }
    registerListener() {
        if (!this.fieldZip && !this.fieldCity) return;
        const onInputHandler = this.searchZipCity.bind(this);
        const onClickHandler = this.toggleDropdown.bind(this);
        const onSelectHandler = this.selectItem.bind(this);
        const onChangeHandler = this.clearFormFields.bind(this);
        const onInputKeyNavigationHandler = this.inputKeyNavigation.bind(this);
        const onDropdownKeyNavigationHandler = this.dropdownKeyNavigation.bind(this);
        this.pushListener({
            event: "click",
            element: this.fieldZip,
            action: onClickHandler
        });
        this.pushListener({
            event: "click",
            element: this.fieldCity,
            action: onClickHandler
        });
        this.pushListener({
            event: "click",
            element: this.inputObject.dropdown,
            action: onSelectHandler
        });
        this.pushListener({
            event: "input",
            element: this.fieldZip,
            action: onInputHandler
        });
        this.pushListener({
            event: "input",
            element: this.fieldCity,
            action: onInputHandler
        });
        this.pushListener({
            event: "keydown",
            element: this.fieldZip,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: "keydown",
            element: this.fieldCity,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: "keydown",
            element: this.inputObject.dropdown,
            action: onDropdownKeyNavigationHandler
        });
        if (this.fieldCountry) this.pushListener({
            event: "change",
            element: this.fieldCountry,
            action: onChangeHandler
        });
    }
    inputKeyNavigation(event) {
        if (!(event.code === "Tab" || event.code === "Enter" || event.code === "ArrowDown")) return;
        this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.dropdown?.classList.remove("hide");
        this.inputObject.listItemSelected.focus();
        event.preventDefault();
    }
    dropdownKeyNavigation(event) {
        const keyActions = {
            ArrowDown: ()=>this.handleArrowKey(true),
            ArrowUp: ()=>this.handleArrowKey(false),
            Enter: ()=>this.selectItem(event),
            Space: ()=>this.selectItem(event),
            Tab: ()=>this.hideDropdown(true),
            Escape: ()=>this.hideDropdown(true)
        };
        const action = keyActions[event.code];
        if (!action) return;
        action();
        event.preventDefault();
    }
    handleArrowKey(isDown) {
        if (this.inputObject.listItemSelected) {
            const nextElement = isDown ? this.inputObject.listItemSelected.nextElementSibling : this.inputObject.listItemSelected.previousElementSibling;
            if (nextElement instanceof HTMLElement) this.inputObject.listItemSelected = nextElement;
        } else this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.listItemSelected.focus();
        this.setScroller();
    }
    hideDropdown(isHidden = false) {
        if (this.inputObject.dropdown) {
            if (!isHidden) {
                this.showLoadingAnimation();
                this.listWrapper.style.border = "unset";
            }
            this.inputObject.dropdown.hidden = isHidden;
        }
    }
    toggleDropdown() {
        if (this.inputObject.dropdown && this.inputObject.dropdown.hasChildNodes()) this.inputObject.dropdown.hidden = !this.inputObject.dropdown.hidden;
    }
    setScroller() {
        const { dropdown: dropdown, listItemSelected: listItemSelected } = this.inputObject;
        if (!dropdown || !listItemSelected) return;
        const index = Array.from(dropdown.children).indexOf(listItemSelected);
        const elHeight = listItemSelected.offsetHeight;
        const { scrollTop: scrollTop } = dropdown;
        const viewport = scrollTop + dropdown.offsetHeight;
        const elOffset = elHeight * index;
        if (elOffset >= scrollTop && elOffset + elHeight <= viewport) return;
        dropdown.scrollTop = elOffset;
    }
    setInputObject() {
        if (!this.selectedField?.parentElement?.querySelector(`.${this.listWrapperClassName}`)) this.selectedField?.insertAdjacentElement("afterend", this.listWrapper);
        this.inputObject.inputField = this.selectedField;
    }
    searchZipCity(event) {
        this.selectedField = event.target;
        const value = this.selectedField.value.trim();
        if (value.length < 2) {
            this.clearDataTimeout && clearTimeout(this.clearDataTimeout);
            this.clearDataTimeout = setTimeout(()=>{
                this.clearData();
            }, 300);
            return;
        }
        this.lastSearchTerm = value;
        this.setInputObject();
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.callApi(value);
        }, 300);
    }
    callApi(value) {
        if (!this.inputObject.dropdown) return;
        this.hideDropdown(false);
        if (this.lastSearchTerm !== value) return;
        const zipCity = this.parseZipCity(value);
        const apiUrl = `${window.location.origin}/api/portal/v1/zipsearch`;
        const urlObject = new URL(apiUrl);
        const { searchParams: searchParams } = urlObject;
        Object.entries(zipCity).forEach(([key, value])=>{
            searchParams.set(key, value);
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: urlObject.toString(),
            resolveHandler: this.refreshResultList.bind(this),
            decodeJSONResponse: false
        });
    }
    parseZipCity(value) {
        let zip;
        let city;
        const country = this.fieldCountry?.value?.toLowerCase() || "ch";
        const arr = value.split(" ");
        const numberRegex = /^[0-9]+$/;
        const regexTest = arr.find((elem)=>numberRegex.test(elem));
        if (regexTest === undefined) zip = "";
        else zip = regexTest;
        if (!zip) {
            if (arr.length > 1) zip = +arr[1] || "";
        }
        zip = zip.toString();
        city = value.replace(zip, "").trim();
        if (city === "undefined") city = "";
        return {
            zip: zip,
            city: city,
            country: country
        };
    }
    refreshResultList(response) {
        if (!response) return;
        this.clearData();
        if (Array.isArray(response)) response.forEach((element)=>{
            const listItemTpl = `
                <button type="button" class="tk-form-list-item"
                    data-tk-country="${element.country}"
                    data-tk-zip="${element.zip}"
                    data-tk-city="${element.city}"
                    tabindex="-1"
                >
                    <span class="tk-form__label">
                        ${element.zip} ${element.city}
                    </span>
                </button>`;
            this.inputObject.dropdown.insertAdjacentHTML("beforeend", listItemTpl);
            this.inputObject.data?.push({
                zip: element.zip,
                city: element.city,
                country: element.country
            });
        });
        if (this.inputObject.data.length === 0) {
            const listItemTpl = `
                <div class="spacer-p-2">
                    <div class="tk-message tk-message--info tk-message--fullwidth">
                        <span class="tk-message__icon">
                            <i class="tk-icon-warning"></i>
                        </span>
                        <span class="tk-message__label">${(0, $86b3c5b6d66bd808$export$97a703132b664051).noMatchFound}</span>
                    </div>
                </div>`;
            this.inputObject.dropdown.insertAdjacentHTML("beforeend", listItemTpl);
        }
        this.listWrapper.style.border = "";
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.inputObject.dropdown.hidden = false;
    }
    selectItem(event) {
        let selectedItem = event.target;
        selectedItem = selectedItem.closest("[data-tk-zip]");
        if (!selectedItem) return;
        const zip = selectedItem.getAttribute("data-tk-zip");
        const city = selectedItem.getAttribute("data-tk-city");
        const country = selectedItem.getAttribute("data-tk-country");
        if (this.fieldZip) this.fieldZip.value = zip;
        if (this.fieldCity) this.fieldCity.value = city;
        if (this.fieldCountry) this.fieldCountry.value = country;
        this.inputObject.inputField.focus();
        this.clearData();
    }
    clearFormFields() {
        this.clearData();
        this.fieldCity.value = "";
        this.fieldZip.value = "";
    }
    clearData() {
        if (this.inputObject.dropdown) {
            this.hideDropdown(true);
            this.inputObject.dropdown.replaceChildren();
        }
        this.inputObject.data = [];
    }
    showLoadingAnimation() {
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.loadingSpinnerTimeout = setTimeout(()=>{
            this.listWrapper.innerHTML = `
                <div class="tk-progress tk-progress--infinite tk-progress--breakout">
                    <div class="tk-progress__bar"></div>
                </div>`;
        }, 300);
    }
}




var $fe64c06a372e274b$export$bcd15065bd7fecf6;
(function(SortDirectionEnum) {
    SortDirectionEnum["ASC"] = "ASC";
    SortDirectionEnum["DESC"] = "DESC";
})($fe64c06a372e274b$export$bcd15065bd7fecf6 || ($fe64c06a372e274b$export$bcd15065bd7fecf6 = {}));
const $fe64c06a372e274b$export$633da1651c3bd3f9 = (a, b, direction)=>direction.toUpperCase() === "DESC" ? b.localeCompare(a) : a.localeCompare(b);
const $fe64c06a372e274b$export$dcb32d3e7e407924 = (a, b, direction)=>{
    const numberA = Number(a);
    const numberB = Number(b);
    return direction.toUpperCase() === "DESC" ? numberB - numberA : numberA - numberB;
};
const $fe64c06a372e274b$export$c4c806e061935577 = (a, b, direction)=>{
    const dateFormattedA = a.split(".").reverse().join("-");
    const dateFormattedB = b.split(".").reverse().join("-");
    const dateA = Date.parse(dateFormattedA);
    const dateB = Date.parse(dateFormattedB);
    return direction.toUpperCase() === "DESC" ? dateB - dateA : dateA - dateB;
};
const $fe64c06a372e274b$export$15d252ed5f5f8636 = (a, b, direction)=>{
    const dateA = new Date();
    const dateB = new Date();
    const splittedA = a.split(":").map((item)=>Number(item));
    const splittedB = b.split(":").map((item)=>Number(item));
    dateA.setHours(splittedA.at(0) || 0, splittedA.at(1), splittedA.at(2));
    dateB.setHours(splittedB.at(0) || 0, splittedB.at(1), splittedB.at(2));
    const timeA = dateA.getTime();
    const timeB = dateB.getTime();
    return direction.toUpperCase() === "DESC" ? timeB - timeA : timeA - timeB;
};
const $fe64c06a372e274b$export$ed1371d464d87bcf = (a, b, direction)=>{
    const timeStampListA = a.split(" ");
    const timeStampListB = b.split(" ");
    const dateA = timeStampListA.at(0)?.split(".").reverse().join("-");
    const dateB = timeStampListB.at(0)?.split(".").reverse().join("-");
    const timeA = timeStampListA.at(1);
    const timeB = timeStampListB.at(1);
    const timestampA = Date.parse(`${dateA}T${timeA}`);
    const timestampB = Date.parse(`${dateB}T${timeB}`);
    return direction.toUpperCase() === "DESC" ? timestampB - timestampA : timestampA - timestampB;
};
const $fe64c06a372e274b$export$92f3520fe1ac7383 = (a, b, direction)=>{
    const booleanA = Boolean(a);
    const booleanB = Boolean(b);
    const numberA = Number(booleanA);
    const numberB = Number(booleanB);
    return direction === "DESC" ? numberB - numberA : numberA - numberB;
};



var $2595e2ca594d6789$var$DataMaster;
(function(DataMaster) {
    DataMaster["CLIENT"] = "client";
})($2595e2ca594d6789$var$DataMaster || ($2595e2ca594d6789$var$DataMaster = {}));
class $2595e2ca594d6789$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.gridTemplateColList = [];
        this.isHorizontalScrollable = false;
        this.headElement = this.querySelector("[data-tk-table-head]") || undefined;
        if (!this.headElement) throw new Error("Table: Head is missing!");
        this.rowHeadElement = this.headElement.querySelector("[data-tk-table-row]") || undefined;
        this.headShadowClassName = this.getAttribute("data-tk-head-shadow-class-name") || "tk-table__head-shadow";
        this.isStickyLeft = this.hasAttribute("data-tk-is-sticky-left");
        this.isStickyHead = this.hasAttribute("data-tk-is-sticky-head");
        this.gridTemplateMobile = this.getAttribute("data-tk-grid-template-mobile") || "1fr";
        this.loadedClassName = this.getAttribute("data-tk-loaded-class-name") || "tk-table--loaded";
        this.stickyLeftClassname = this.getAttribute("data-tk-sticky-left-class-name") || "tk-table--sticky-left";
        this.rightShadowClassName = this.getAttribute("data-tk-right-shadow-class-name") || "tk-table__right-shadow";
        this.stickyHeadClassName = this.getAttribute("data-tk-sticky-head-class-name") || "tk-table--sticky-head";
        this.customCols = this.getAttribute("data-tk-col-width") || "auto";
        this.observer = new ResizeObserver(this.handleResize.bind(this));
        this.desktopMinWidth = Number(this.getAttribute("data-tk-desktop-min-width")) || 992;
        this.rowLinkSelector = "data-tk-table-row-link";
        this.table = this.querySelector("table") || undefined;
        this.ascSortClassName = this.getAttribute("data-tk-asc-sort-class-name") || "tk-table--sort-asc";
        this.descSortClassName = this.getAttribute("data-tk-desc-sort-class-name") || "tk-table--sort-desc";
        this.isSortTable = Boolean(this.table?.hasAttribute("data-tk-table-sort"));
        this.colAlignStart = this.hasAttribute("data-tk-col-align-start");
        this.colAlignStartClassName = this.getAttribute("data-tk-col-align-start-class-name") || "tk-table__col--align-left";
        this.colItemAlignCenter = this.hasAttribute("data-tk-col-item-align-center");
        this.colItemAlignCenterClassName = this.getAttribute("data-tk-col-item-align-center-class-name") || "tk-table__col--item-align-center";
        this.colItemAlignStart = this.hasAttribute("data-tk-col-item-align-start");
        this.colItemAlignStartClassName = this.getAttribute("data-tk-col-item-align-start-class-name") || "tk-table__col--item-align-start";
        this.colItemAlignEnd = this.hasAttribute("data-tk-col-item-align-end");
        this.colItemAlignEndClassName = this.getAttribute("data-tk-col-item-align-end-class-name") || "tk-table__col--item-align-end";
        this.tableSelector = "[data-tk-table-sort]";
        this.sortDirectionSelector = "[data-tk-sort-direction]";
        this.tkSortDirectionSelector = "tkSortDirection";
        this.tkSortAttrSelector = "tkSortAttr";
        this.tkSortDatatypeSelector = "tkSortDatatype";
        this.dataMasterSelector = "data-tk-datamaster";
        this.dataSortAttrSelector = "data-tk-sort-attr";
    }
    connectedCallback() {
        this.classList.add(this.loadedClassName);
        window.viewport.clientWidth < this.desktopMinWidth ? this.setGridMobile() : this.setGrid();
        this.registerViewportListener();
        this.registerScrollListener();
        this.registerRowLinkListener();
        this.observer.observe(this);
        this.isStickyHead && this.setStickyHead();
        this.isSortTable && this.registerTableHeadListener();
        this.colAlignStart && this.setColAlignStart();
        this.colItemAlignCenter && this.setColItemAlign(this.colItemAlignCenterClassName);
        this.colItemAlignStart && this.setColItemAlign(this.colItemAlignStartClassName);
        this.colItemAlignEnd && this.setColItemAlign(this.colItemAlignEndClassName);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.observer.unobserve(this);
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: "tk-viewport-resize",
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        if (customEvent.detail.width < this.desktopMinWidth) this.setGridMobile();
        else this.setGrid();
    }
    registerScrollListener() {
        const handleHorizontalScrollListener = this.toggleScrollHorizontalBehavior.bind(this);
        this.pushListener({
            event: "scroll",
            element: this,
            action: handleHorizontalScrollListener
        });
        if (this.isStickyLeft) {
            const handleStickyLeftListener = this.toggleScrollLeftBehavior.bind(this);
            this.pushListener({
                event: "scroll",
                element: this,
                action: handleStickyLeftListener
            });
        }
        if (this.isStickyHead) {
            const handleStickyHeadListener = this.toggleScrollTopBehavior.bind(this);
            this.pushListener({
                event: "scroll",
                element: this,
                action: handleStickyHeadListener
            });
        }
    }
    registerTableHeadListener() {
        const handleSortTable = this.handleSortTable.bind(this);
        this.pushListener({
            event: "click",
            element: this,
            action: handleSortTable
        });
    }
    registerRowLinkListener() {
        const handleRowLink = this.handleRowLink.bind(this);
        this.pushListener({
            event: "click",
            element: this,
            action: handleRowLink
        });
    }
    handleRowLink(event) {
        const target = event.target;
        if (target.closest("a")) return;
        const row = target.closest(`[${this.rowLinkSelector}]`);
        if (!row) return;
        const link = row.getAttribute(this.rowLinkSelector);
        if (!link) return;
        window.location.href = link;
    }
    handleSortTable(event) {
        if (!event) return;
        const target = event.target;
        const column = target.closest("th");
        column && column.hasAttribute("data-tk-sort-direction") && this.sortTable(column);
    }
    handleResize(entries) {
        entries.forEach(()=>{
            this.isHorizontalScrollable = this.scrollWidth > this.clientWidth;
            if (this.isHorizontalScrollable && !this.horizontalScrollShadowElement) this.setHorizontalScrollShadow();
            if (!this.horizontalScrollShadowElement) return;
            this.horizontalScrollShadowElement.hidden = !this.isHorizontalScrollable;
            this.boxShadowElement && (this.boxShadowElement.style.width = `${this.scrollWidth}px`);
        });
    }
    setGrid() {
        if (!this.rowHeadElement) return;
        const cols = this.rowHeadElement.childElementCount;
        this.gridTemplateColList = this.customCols?.split(/(?!, ),/g);
        this.style.gridTemplateColumns = this.customCols?.includes(",") ? this.gridTemplateColList?.join(" ") : `repeat(${cols}, ${this.customCols})`;
        if (this.headElement) this.headElement.classList.remove("tk-table__head--force-mobile");
        const titleElements = this.table?.querySelectorAll("[data-tk-table-body] .tk-table__title");
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.remove("tk-table__title--force-mobile");
        });
    }
    setGridMobile() {
        this.style.gridTemplateColumns = this.gridTemplateMobile;
        if (this.headElement) this.headElement.classList.add("tk-table__head--force-mobile");
        const titleElements = this.table?.querySelectorAll("[data-tk-table-body] .tk-table__title");
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.add("tk-table__title--force-mobile");
        });
    }
    toggleScrollLeftBehavior(event) {
        const element = event.target;
        this.classList.toggle(this.stickyLeftClassname, element.scrollLeft > 0);
    }
    toggleScrollHorizontalBehavior(event) {
        if (!this.horizontalScrollShadowElement) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = event.target;
        this.horizontalScrollShadowElement.hidden = scrollLeft >= scrollWidth - clientWidth;
        this.horizontalScrollShadowElement.style.right = `-${scrollLeft}px`;
    }
    toggleScrollTopBehavior(event) {
        if (!this.boxShadowElement) return;
        const element = event.target;
        this.boxShadowElement.hidden = element.scrollTop === 0;
        this.classList.toggle(this.stickyHeadClassName, element.scrollTop > 0);
        this.boxShadowElement.style.top = element.scrollTop.toFixed();
    }
    setStickyHead() {
        if (!this.headElement) return;
        this.boxShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.headShadowClassName}' hidden></div>`);
        if (!this.boxShadowElement) return;
        const column = this.rowHeadElement?.firstElementChild;
        const height = column?.getBoundingClientRect().height || 0;
        this.boxShadowElement.style.width = `${this.scrollWidth}px`;
        this.boxShadowElement.style.height = `${height}px`;
        this.headElement.insertAdjacentElement("afterbegin", this.boxShadowElement);
    }
    setHorizontalScrollShadow() {
        this.horizontalScrollShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.rightShadowClassName}'></div>`);
        if (!this.horizontalScrollShadowElement) return;
        this.insertAdjacentElement("beforeend", this.horizontalScrollShadowElement);
    }
    sortTable(column) {
        const dataMaster = this.table?.getAttribute(this.dataMasterSelector);
        if (dataMaster === "client") {
            this.setOrToggleSortDirection(column);
            this.clearHeadElementClassList(column);
            this.clientSortTable({
                element: column,
                type: column.dataset[this.tkSortDatatypeSelector],
                sortDirection: column.dataset[this.tkSortDirectionSelector],
                column: column.cellIndex
            });
            this.postAsynClientSortState(column);
        } else this.serverAsynTableSortRequest(column);
    }
    clientSortTable(headItem) {
        const tableBody = this.table?.querySelector("[data-tk-table-body]");
        if (!tableBody) return;
        const rows = tableBody.querySelectorAll("[data-tk-table-row]");
        if (!rows) return;
        const rowList = Array.from(rows).map((element)=>{
            const value = Array.from(element.querySelectorAll("[data-tk-table-value]")).at(headItem.column)?.textContent || "";
            return {
                element: element,
                value: value
            };
        });
        const sortTypes = {
            A: (a, b)=>(0, $fe64c06a372e274b$export$633da1651c3bd3f9)(a, b, headItem.sortDirection),
            N: (a, b)=>(0, $fe64c06a372e274b$export$dcb32d3e7e407924)(a, b, headItem.sortDirection),
            D: (a, b)=>(0, $fe64c06a372e274b$export$c4c806e061935577)(a, b, headItem.sortDirection),
            H: (a, b)=>(0, $fe64c06a372e274b$export$15d252ed5f5f8636)(a, b, headItem.sortDirection),
            S: (a, b)=>(0, $fe64c06a372e274b$export$ed1371d464d87bcf)(a, b, headItem.sortDirection),
            B: (a, b)=>(0, $fe64c06a372e274b$export$92f3520fe1ac7383)(a, b, headItem.sortDirection)
        };
        const sortedList = rowList.sort((a, b)=>sortTypes[headItem.type](a.value, b.value));
        tableBody.innerHTML = "";
        sortedList.forEach((item)=>{
            tableBody.appendChild(item.element);
        });
        if (headItem.element.classList.contains(this.ascSortClassName) || headItem.element.classList.contains(this.descSortClassName)) headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.replace(this.ascSortClassName, this.descSortClassName) : headItem.element.classList.replace(this.descSortClassName, this.ascSortClassName);
        else headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.add(this.descSortClassName) : headItem.element.classList.add(this.ascSortClassName);
    }
    clearHeadElementClassList(column) {
        if (!this.rowHeadElement) return;
        const head = Array.from(this.rowHeadElement.children);
        const filteredHead = head.filter((item)=>item !== column);
        filteredHead.forEach((child)=>{
            const element = child;
            element.classList.remove(this.ascSortClassName);
            element.classList.remove(this.descSortClassName);
        });
    }
    setOrToggleSortDirection(thElement) {
        this.removeUnseletectedSortDir(thElement);
        // toggelt direction auf geklickten header spalte
        thElement.dataset[this.tkSortDirectionSelector] = thElement.dataset[this.tkSortDirectionSelector] === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC ? (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC : (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC;
    }
    serverAsynTableSortRequest(thElement) {
        this.setOrToggleSortDirection(thElement);
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.asyncTableSortHandler.bind(this),
            payload: options
        });
    }
    postAsynClientSortState(thElement) {
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: ()=>{},
            payload: options
        });
    }
    asyncTableSortHandler(response) {
        if (!response.success || !response.dataAsHtml) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.replaceAllResponseTable(html);
    }
    replaceAllResponseTable(element) {
        const oldTables = document.querySelectorAll(this.tableSelector);
        const newTables = element.querySelectorAll(this.tableSelector);
        oldTables.forEach((oldTable)=>{
            const correspondingNewTable = Array.from(newTables).find((newTable)=>oldTable.id === newTable.id);
            if (correspondingNewTable) oldTable?.parentNode?.replaceChild(correspondingNewTable, oldTable);
        });
    }
    getAsynPostOptions(thElement) {
        const table = thElement.closest(this.tableSelector);
        if (!table) return {};
        const client = table.getAttribute(this.dataMasterSelector);
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const sortDirection = thElement.dataset[this.tkSortDirectionSelector];
        const options = {
            type: "tablesort",
            clientSort: String(!!client),
            tableid: table.id,
            sorting: `{"${sortAttribut}":"${sortDirection}"}`
        };
        return options;
    }
    removeUnseletectedSortDir(thElement) {
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const table = thElement.closest(this.tableSelector);
        if (!table) return;
        const headers = table.querySelectorAll(this.sortDirectionSelector);
        headers.forEach((header)=>{
            const headerSortAttr = header.dataset[this.tkSortAttrSelector];
            if (headerSortAttr !== sortAttribut) return;
            header.dataset[this.tkSortDirectionSelector] = "";
        });
    }
    setColAlignStart() {
        const tableBody = this.table?.querySelector("[data-tk-table-body]");
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll("[data-tk-table-row] td");
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(this.colAlignStartClassName);
        });
    }
    setColItemAlign(className) {
        const tableBody = this.table?.querySelector("[data-tk-table-body]");
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll("[data-tk-table-row] td");
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(className);
        });
    }
}





class $40898dd22403025f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.pages = [];
        this.navigationWrapper = document.querySelector("[data-tk-nav-wrapper]") || undefined;
        this.wrapper = this.querySelector("[data-tk-wrapper]") || undefined;
        this.openButton = document.querySelector(`[data-tk-nav-open="${this.id}"]`) || undefined;
        this.closeButton = document.querySelector(`[data-tk-nav-close="${this.id}"]`) || undefined;
        this.openClassName = this.getAttribute("data-tk-open-class-name") || "viewport__navigation--open";
        this.currentMenuId = this.getAttribute("data-tk-current-menu-id") || undefined;
        this.hasChildrenClassName = this.getAttribute("data-tk-has-children-class-name") || "tk-nav-burger-item--has-children";
        this.asyncTemplateName = this.getAttribute("data-tk-nav-async-template-name") || "tk-navigation-burgerlist";
        this.desktopMinWidth = Number(this.getAttribute("data-tk-desktop-min-width")) || 1200;
        this.overlayClassName = this.getAttribute("data-tk-overlay-class-name") || "viewport__overlay";
        this.isMobile = window.viewport.clientWidth < this.desktopMinWidth;
        this.isMobileActive = false;
        this.overlay = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class="${this.overlayClassName}"></div>`);
    }
    connectedCallback() {
        if (!this.currentMenuId) throw new Error("Current menu id is missing!");
        this.registerViewportListener();
        this.registerButtonListener();
        this.registerClickListener();
        this.isMobile && this.switchToMobile();
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: "tk-viewport-resize",
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        this.isMobile = customEvent.detail.width < this.desktopMinWidth;
        this.isMobile ? this.switchToMobile() : this.switchToDesktop();
    }
    registerButtonListener() {
        this.openButton?.addEventListener("click", this.openNavigation.bind(this));
        this.closeButton?.addEventListener("click", this.closeNavigation.bind(this));
    }
    registerClickListener() {
        this.addEventListener("click", this.handleClickLink.bind(this));
    }
    openNavigation() {
        this.navigationWrapper ? this.navigationWrapper.classList.add(this.openClassName) : this.classList.add(this.openClassName);
        document.body.insertAdjacentElement("beforeend", this.overlay);
    }
    closeNavigation() {
        this.navigationWrapper ? this.navigationWrapper.classList.remove(this.openClassName) : this.classList.remove(this.openClassName);
        const overlay = document.querySelector(`.${this.overlayClassName}`);
        overlay?.remove();
    }
    async handleClickLink(event) {
        if (!this.isMobile) return;
        event.preventDefault();
        const target = event.target;
        let element;
        if (target.hasAttribute("data-tk-nav-id")) element = target;
        else element = target.closest("[data-tk-nav-id]");
        if (!element) return;
        if (!element.parentElement?.classList.contains(this.hasChildrenClassName) && !element.parentElement?.hasAttribute("data-tk-nav-page")) {
            window.location.href = element.href;
            this.closeNavigation();
            return;
        }
        const id = element.getAttribute("data-tk-nav-id");
        if (!id) return;
        if (this.existPage(id)) {
            const page = this.getPage(id);
            if (!page) return;
            this.insertPage(page.element);
            $40898dd22403025f$export$2e2bcd8739ae039.jumpToPage(page.element);
            this.removeLastPageFromDOM();
        } else {
            const response = await this.getTemplate(id);
            this.responseNextLevel(response);
        }
    }
    getTemplate(id) {
        const url = window.opacc.systemUrls?.async || "/WebPortal/async.aspx";
        const data = {
            type: "navigation",
            navigationid: id,
            template: this.asyncTemplateName
        };
        return new Promise((resolve, reject)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: (response)=>resolve(response),
                rejectHandler: (error)=>reject(error),
                payload: data
            });
        });
    }
    responseNextLevel(response) {
        if (!response.success) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsJson.showItems);
        if (!html) return;
        const navigation = html.querySelector("[data-tk-nav-page]");
        if (!navigation) return;
        this.addPage(navigation);
        this.insertPage(navigation);
        $40898dd22403025f$export$2e2bcd8739ae039.jumpToPage(navigation);
        this.removeLastPageFromDOM();
    }
    insertPage(element) {
        const pages = this.querySelector("[data-tk-nav-pages]");
        if (!pages) return;
        pages.insertAdjacentElement("afterbegin", element);
    }
    addPage(element) {
        const id = element.getAttribute("data-tk-nav-page") || "";
        !this.existPage(id) && this.pages.push({
            id: id,
            element: element
        });
    }
    getPage(id) {
        return this.pages.find((page)=>page.id === id);
    }
    existPage(id) {
        if (id === "") return false;
        const foundPage = this.pages.filter((page)=>page.id === id);
        return foundPage.length > 0;
    }
    removeLastPageFromDOM() {
        const pages = this.querySelector("[data-tk-nav-pages]");
        if (!pages) return;
        const pageList = Array.from(pages.children);
        const oldPages = pageList.filter((element)=>element !== pages.firstElementChild);
        oldPages.forEach((element)=>element.remove());
    }
    async switchToMobile() {
        if (this.isMobileActive) return;
        this.isMobileActive = true;
        this.closeButton && (this.closeButton.hidden = false);
        if (!this.wrapper) return;
        this.desktopView = this.wrapper.innerHTML;
        if (!this.mobileView) {
            const response = await this.getTemplate(this.currentMenuId);
            const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsJson.showItems);
            if (!html) throw new Error("Burgerlist: Root Element is missing!");
            this.wrapper.replaceChildren(html);
            const navigation = html.querySelector("[data-tk-nav-page]");
            navigation && this.addPage(navigation);
        } else {
            this.wrapper.innerHTML = "";
            this.wrapper.insertAdjacentHTML("afterbegin", this.mobileView);
        }
    }
    async switchToDesktop() {
        if (!this.isMobileActive) return;
        this.isMobileActive = false;
        this.closeButton && (this.closeButton.hidden = true);
        if (!this.wrapper) return;
        this.mobileView = this.wrapper.innerHTML;
        if (!this.desktopView) return;
        this.wrapper.innerHTML = "";
        this.wrapper.insertAdjacentHTML("afterbegin", this.desktopView);
    }
    static jumpToPage(element) {
        element.scrollIntoView(false);
    }
}






var $011e7dbf949e9361$var$MessageType;
(function(MessageType) {
    MessageType[MessageType["tooShort"] = 1] = "tooShort";
    MessageType[MessageType["dangerousString"] = 2] = "dangerousString";
    MessageType[MessageType["disallowedCharacters"] = 3] = "disallowedCharacters";
})($011e7dbf949e9361$var$MessageType || ($011e7dbf949e9361$var$MessageType = {}));
const $011e7dbf949e9361$var$ALLOWED_CHARACTERS = /[^a-zA-Z0-9 äÄãÃåÅáÁàÀâÂéÉèÈêÊëËöÖóÓòÒôÔõÕüÜúÚùÙûÛìÌíÍîÎïÏñÑøØçÇß',-_.]+/;
class $011e7dbf949e9361$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.selectorSearch = "[data-tk-search]";
        this.selectorSearchBackButton = "[data-tk-search-back]";
        this.selectorSearchResetButton = "[data-tk-search-reset]";
        this.selectorSearchSubmitButton = "[data-tk-search-submit]";
        this.selectorSearchFilterElement = "[data-tk-search-filter]";
        this.selectorSearchResult = "[data-tk-search-result]";
        this.attributeSearchMinLength = "[data-tk-search-min-input-length]";
        this.directSearchInputObj = {};
        this.timerID = 0;
        this.searchTermAsUrlParam = true;
        this.disallowedCharacters = "";
        this.directSearchForm = this.querySelector(this.selectorSearch) || undefined;
        this.directSearchBackButton = this.querySelector(this.selectorSearchBackButton) || undefined;
        this.directSearchResetButton = this.querySelector(this.selectorSearchResetButton) || undefined;
        this.directSearchSubmitButton = this.querySelector(this.selectorSearchSubmitButton) || undefined;
        this.directSearchFilterElement = this.querySelector(this.selectorSearchFilterElement) || undefined;
        this.directSearchResult = this.querySelector(this.selectorSearchResult) || undefined;
        this.directSearchMinLength = Number(this.getAttribute(this.attributeSearchMinLength)) || 3;
        this.activeClassName = this.getAttribute("data-tk-active-class-name") || "tk-search--active";
        this.activeResultClassName = this.getAttribute("data-tk-active-result-class-name") || "tk-search--has-data";
        this.tooShortClassName = this.getAttribute("data-tk-too-short-class-name") || "tk-search__result--too-short";
        this.loadingClassName = this.getAttribute("data-tk-loading-class-name") || "tk-search__result--loading";
        this.allowedCharactersRegex = RegExp(this.getAttribute("data-tk-allowed-characters") || $011e7dbf949e9361$var$ALLOWED_CHARACTERS);
        if (!this.directSearchForm) throw new Error("TK: Missing Direct-Search");
        this.directSearchInputElement = this.directSearchForm.querySelector("input") || undefined;
        if (!this.directSearchInputElement) throw new Error("TK: Missing Direct-Search-Input");
        if (!this.directSearchResult) throw new Error("TK: Missing Direct-Search Result Wrapper");
        $011e7dbf949e9361$export$2e2bcd8739ae039.replaceToActionUrl();
    }
    connectedCallback() {
        this.registerListener();
    }
    registerListener() {
        if (this.directSearchInputElement) {
            const keyUpEventHandler = this.getSuggest.bind(this);
            const setClassEventHandler = this.setActiveClass.bind(this);
            const submitEventHandler = this.submitSearch.bind(this);
            const focusOutEventHandler = this.focusOut.bind(this);
            this.pushListener({
                event: "submit",
                element: this.directSearchForm,
                action: submitEventHandler
            });
            this.pushListener({
                event: "input",
                element: this.directSearchInputElement,
                action: keyUpEventHandler
            });
            this.pushListener({
                event: "focusin",
                element: this.directSearchInputElement,
                action: setClassEventHandler
            });
            this.pushListener({
                event: "click",
                element: window,
                action: focusOutEventHandler
            });
        }
        if (this.directSearchBackButton) {
            const navigateBackEventHandler = this.navigateBack.bind(this);
            this.pushListener({
                event: "click",
                element: this.directSearchBackButton,
                action: navigateBackEventHandler
            });
        }
        if (this.directSearchResetButton) {
            const resetEventHandler = this.resetSearch.bind(this);
            this.pushListener({
                event: "click",
                element: this.directSearchResetButton,
                action: resetEventHandler
            });
        }
        if (this.directSearchFilterElement) {
            const selectboxEventHandler = this.getSuggest.bind(this);
            this.pushListener({
                event: "change",
                element: this.directSearchFilterElement,
                action: selectboxEventHandler
            });
        }
    }
    setActiveClass() {
        this.classList.add(this.activeClassName);
    }
    submitSearch(event) {
        if (!this.directSearchForm) return;
        event.preventDefault();
        this.directSearchInputObj = this.validateSearchInput();
        this.modifyDOM();
        if (!this.directSearchInputObj.valid) {
            this.classList.add(this.activeResultClassName);
            if (this.directSearchInputObj.hasDangerousString) this.setErrorMessage(2);
            else if (this.directSearchInputObj.hasDisallowedChars) this.setErrorMessage(3);
            else this.setErrorMessage(1);
            return;
        }
        this.directSearchForm.submit();
    }
    focusOut(event) {
        if (event.pointerId === -1) return;
        const fieldElement = this.directSearchInputElement;
        const resultElement = this.directSearchResult;
        if (!fieldElement || !resultElement) return;
        const fieldElementRect = fieldElement.getBoundingClientRect();
        const resultRect = resultElement.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: fieldElementRect
            },
            {
                rectangle: resultRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.classList.remove(this.activeClassName);
            this.resetSearch();
        }
    }
    setProgressBar() {
        const progressBarTpl = `
        <div class="tk-progress tk-progress--infinite tk-progress--breakout">
            <div class="tk-progress__bar"></div>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML("beforeend", progressBarTpl);
    }
    setErrorMessage(msgType) {
        let message = "";
        switch(msgType){
            case 1:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageTooShort.text.replace("%1", String(this.directSearchMinLength));
                break;
            case 2:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageDangerousString.text;
                break;
            case 3:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageDisallowedCharacter.text.replace("%1", String(this.disallowedCharacters));
                break;
            default:
                break;
        }
        const msgTpl = `
        <div class="tk-message tk-message--info tk-message--breakout">
            <span class="tk-message__icon">
                <i class="tk-icon-info"></i>
            </span>
            <span class="tk-message__label">
                ${message}
            </span>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML("beforeend", msgTpl);
    }
    setMessageTooShort() {
        const msgTpl = `
        <div class="tk-message tk-message--info tk-message--breakout">
            <span class="tk-message__icon">
                <i class="tk-icon-info"></i>
            </span>
            <span class="tk-message__label">
                ${(0, $86b3c5b6d66bd808$export$f625b980042672da).messageTooShort.text.replace("%1", String(this.directSearchMinLength))}
            </span>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML("beforeend", msgTpl);
    }
    getSuggest() {
        if (!this.directSearchResult) return;
        this.directSearchInputObj = this.validateSearchInput();
        this.modifyDOM();
        if (!this.directSearchInputObj.valid) {
            this.classList.add(this.activeResultClassName);
            if (this.directSearchInputObj.hasDangerousString) this.setErrorMessage(2);
            else if (this.directSearchInputObj.hasDisallowedChars) this.setErrorMessage(3);
            else this.setErrorMessage(1);
            return;
        }
        this.resetResultList();
        this.timerID && clearTimeout(this.timerID);
        this.timerID = window.setTimeout(()=>{
            // append Progress-Bar
            this.setProgressBar();
            const searchData = this.setDataForRequest();
            const data = Object.fromEntries(Object.entries(searchData));
            const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: this.getDirectSearchSuggestDataFromResult.bind(this),
                payload: data
            });
        }, 500);
    }
    setDataForRequest() {
        const retVal = {
            type: "directsearchsuggest",
            inputValue: encodeURIComponent(this.directSearchInputObj.value),
            filterAttribute: this.directSearchFilterElement?.dataset.tkSearchFilterAttribute,
            filterValue: this.directSearchFilterElement?.value
        };
        if (!this.directSearchFilterElement) {
            delete retVal.filterAttribute;
            delete retVal.filterValue;
        }
        return retVal;
    }
    getDirectSearchSuggestDataFromResult(response) {
        if (!this.directSearchResult) return;
        this.classList.add(this.activeResultClassName);
        this.directSearchResult.innerHTML = response.dataAsJson.html;
    }
    modifyDOM() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        }, {
            element: this,
            className: this.activeResultClassName
        });
        if (this.directSearchInputObj.valid) $011e7dbf949e9361$export$2e2bcd8739ae039.addClassList(classListObj);
        else this.resetResultList();
    }
    static clearClassListObj() {
        const classListObj = [];
        return classListObj;
    }
    static addClassList(items) {
        items.forEach((item)=>{
            item.element?.classList.add(item.className);
        });
    }
    static removeClassList(items) {
        items.forEach((item)=>{
            item.element?.classList.remove(item.className);
        });
    }
    resetResultList() {
        this.directSearchResult?.replaceChildren();
    }
    navigateBack() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        });
        $011e7dbf949e9361$export$2e2bcd8739ae039.removeClassList(classListObj);
    }
    resetSearch() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        }, {
            element: this,
            className: this.activeResultClassName
        });
        this.resetResultList();
        $011e7dbf949e9361$export$2e2bcd8739ae039.removeClassList(classListObj);
        this.directSearchForm?.reset();
    }
    static replaceToActionUrl() {
        const actionUrl = localStorage.getItem("searchActionUrl") ? new URL(localStorage.getItem("searchActionUrl")) : undefined;
        if (actionUrl && actionUrl.pathname === window.location.pathname) window.history.replaceState(null, "searchActionUrl", actionUrl);
        if (actionUrl) localStorage.removeItem("searchActionUrl");
    }
    validateSearchInput() {
        const value = this.directSearchInputElement?.value.trim() || "";
        const minLength = Number(this.getAttribute("data-tk-search-min-input-length") || 3);
        const hasDangerousString = value?.includes("<");
        const hasDisallowedChars = this.hasDisallowedCharacters(value);
        return {
            minimum: minLength,
            value: value,
            valid: value.length >= minLength && !hasDangerousString && !hasDisallowedChars,
            hasDangerousString: hasDangerousString,
            hasDisallowedChars: hasDisallowedChars
        };
    }
    hasDisallowedCharacters(value) {
        if (!value) {
            this.disallowedCharacters = "";
            return false;
        }
        const character = value.match(this.allowedCharactersRegex)?.at(0) ?? "";
        this.disallowedCharacters = character;
        return Boolean(character);
    }
}



class $66984fa0a405fb2a$export$2e2bcd8739ae039 extends (0, $011e7dbf949e9361$export$2e2bcd8739ae039) {
    setMessageTooShort() {
        const msgTpl = `
        <div class="tk-message tk-message--info tk-message--breakout">
            <span class="tk-message__icon">
                <i class="tk-icon-info"></i>
            </span>
            <span class="tk-message__label">
                ${(0, $86b3c5b6d66bd808$export$f625b980042672da).messageTooShort.text.replace("%1", String(this.directSearchMinLength))}
            </span>
        </div>`;
        this.directSearchResult.insertAdjacentHTML("beforeend", msgTpl);
        this.directSearchResult.style.gap = "0";
    }
}



function $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $a85fd1efd23057e0$var$id = 0;
function $a85fd1efd23057e0$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $a85fd1efd23057e0$var$id++ + "_" + name;
}
// We're using a generic because languages have different plural rules.
// eslint-disable-next-line no-use-before-define
function $a85fd1efd23057e0$var$insertReplacement(source, rx, replacement) {
    const newParts = [];
    source.forEach((chunk)=>{
        // When the source contains multiple placeholders for interpolation,
        // we should ignore chunks that are not strings, because those
        // can be JSX objects and will be otherwise incorrectly turned into strings.
        // Without this condition we’d get this: [object Object] hello [object Object] my <button>
        if (typeof chunk !== "string") return newParts.push(chunk);
        return rx[Symbol.split](chunk).forEach((raw, i, list)=>{
            if (raw !== "") newParts.push(raw);
            // Interlace with the `replacement` value
            if (i < list.length - 1) newParts.push(replacement);
        });
    });
    return newParts;
}
/**
 * Takes a string with placeholder variables like `%{smart_count} file selected`
 * and replaces it with values from options `{smart_count: 5}`
 *
 * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
 * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
 *
 * @param phrase that needs interpolation, with placeholders
 * @param options with values that will be used to replace placeholders
 */ function $a85fd1efd23057e0$var$interpolate(phrase, options) {
    const dollarRegex = /\$/g;
    const dollarBillsYall = "$$$$";
    let interpolated = [
        phrase
    ];
    if (options == null) return interpolated;
    for (const arg of Object.keys(options))if (arg !== "_") {
        // Ensure replacement value is escaped to prevent special $-prefixed
        // regex replace tokens. the "$$$$" is needed because each "$" needs to
        // be escaped with "$" itself, and we need two in the resulting output.
        let replacement = options[arg];
        if (typeof replacement === "string") replacement = dollarRegex[Symbol.replace](replacement, dollarBillsYall);
        // We create a new `RegExp` each time instead of using a more-efficient
        // string replace so that the same argument can be replaced multiple times
        // in the same phrase.
        interpolated = $a85fd1efd23057e0$var$insertReplacement(interpolated, new RegExp(`%\\{${arg}\\}`, "g"), replacement);
    }
    return interpolated;
}
const $a85fd1efd23057e0$var$defaultOnMissingKey = (key)=>{
    throw new Error(`missing string: ${key}`);
};
/**
 * Translates strings with interpolation & pluralization support.
 * Extensible with custom dictionaries and pluralization functions.
 *
 * Borrows heavily from and inspired by Polyglot https://github.com/airbnb/polyglot.js,
 * basically a stripped-down version of it. Differences: pluralization functions are not hardcoded
 * and can be easily added among with dictionaries, nested objects are used for pluralization
 * as opposed to `||||` delimeter
 *
 * Usage example: `translator.translate('files_chosen', {smart_count: 3})`
 */ var $a85fd1efd23057e0$var$_onMissingKey = /*#__PURE__*/ $a85fd1efd23057e0$var$_classPrivateFieldLooseKey("onMissingKey");
var $a85fd1efd23057e0$var$_apply = /*#__PURE__*/ $a85fd1efd23057e0$var$_classPrivateFieldLooseKey("apply");
class $a85fd1efd23057e0$export$2e2bcd8739ae039 {
    constructor(locales, _temp){
        let { onMissingKey: onMissingKey = $a85fd1efd23057e0$var$defaultOnMissingKey } = _temp === void 0 ? {} : _temp;
        Object.defineProperty(this, $a85fd1efd23057e0$var$_apply, {
            value: $a85fd1efd23057e0$var$_apply2
        });
        Object.defineProperty(this, $a85fd1efd23057e0$var$_onMissingKey, {
            writable: true,
            value: void 0
        });
        this.locale = {
            strings: {},
            pluralize (n) {
                if (n === 1) return 0;
                return 1;
            }
        };
        if (Array.isArray(locales)) locales.forEach($a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_apply)[$a85fd1efd23057e0$var$_apply], this);
        else $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_apply)[$a85fd1efd23057e0$var$_apply](locales);
        $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_onMissingKey)[$a85fd1efd23057e0$var$_onMissingKey] = onMissingKey;
    }
    /**
   * Public translate method
   *
   * @param key
   * @param options with values that will be used later to replace placeholders in string
   * @returns string translated (and interpolated)
   */ translate(key, options) {
        return this.translateArray(key, options).join("");
    }
    /**
   * Get a translation and return the translated and interpolated parts as an array.
   *
   * @returns The translated and interpolated parts, in order.
   */ translateArray(key, options) {
        let string = this.locale.strings[key];
        if (string == null) {
            $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_onMissingKey)[$a85fd1efd23057e0$var$_onMissingKey](key);
            string = key;
        }
        const hasPluralForms = typeof string === "object";
        if (hasPluralForms) {
            if (options && typeof options.smart_count !== "undefined") {
                const plural = this.locale.pluralize(options.smart_count);
                return $a85fd1efd23057e0$var$interpolate(string[plural], options);
            }
            throw new Error("Attempted to use a string with plural forms, but no value was given for %{smart_count}");
        }
        if (typeof string !== "string") throw new Error(`string was not a string`);
        return $a85fd1efd23057e0$var$interpolate(string, options);
    }
}
function $a85fd1efd23057e0$var$_apply2(locale) {
    if (!(locale != null && locale.strings)) return;
    const prevLocale = this.locale;
    Object.assign(this.locale, {
        strings: {
            ...prevLocale.strings,
            ...locale.strings
        },
        pluralize: locale.pluralize || prevLocale.pluralize
    });
}


var $1713863f3a962559$exports = {};
/**
* Create an event emitter with namespaces
* @name createNamespaceEmitter
* @example
* var emitter = require('./index')()
*
* emitter.on('*', function () {
*   console.log('all events emitted', this.event)
* })
*
* emitter.on('example', function () {
*   console.log('example event emitted')
* })
*/ $1713863f3a962559$exports = function createNamespaceEmitter() {
    var emitter = {};
    var _fns = emitter._fns = {};
    /**
  * Emit an event. Optionally namespace the event. Handlers are fired in the order in which they were added with exact matches taking precedence. Separate the namespace and event with a `:`
  * @name emit
  * @param {String} event – the name of the event, with optional namespace
  * @param {...*} data – up to 6 arguments that are passed to the event listener
  * @example
  * emitter.emit('example')
  * emitter.emit('demo:test')
  * emitter.emit('data', { example: true}, 'a string', 1)
  */ emitter.emit = function emit(event, arg1, arg2, arg3, arg4, arg5, arg6) {
        var toEmit = getListeners(event);
        if (toEmit.length) emitAll(event, toEmit, [
            arg1,
            arg2,
            arg3,
            arg4,
            arg5,
            arg6
        ]);
    };
    /**
  * Create en event listener.
  * @name on
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.on('example', function () {})
  * emitter.on('demo', function () {})
  */ emitter.on = function on(event, fn) {
        if (!_fns[event]) _fns[event] = [];
        _fns[event].push(fn);
    };
    /**
  * Create en event listener that fires once.
  * @name once
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.once('example', function () {})
  * emitter.once('demo', function () {})
  */ emitter.once = function once(event, fn) {
        function one() {
            fn.apply(this, arguments);
            emitter.off(event, one);
        }
        this.on(event, one);
    };
    /**
  * Stop listening to an event. Stop all listeners on an event by only passing the event name. Stop a single listener by passing that event handler as a callback.
  * You must be explicit about what will be unsubscribed: `emitter.off('demo')` will unsubscribe an `emitter.on('demo')` listener,
  * `emitter.off('demo:example')` will unsubscribe an `emitter.on('demo:example')` listener
  * @name off
  * @param {String} event
  * @param {Function} [fn] – the specific handler
  * @example
  * emitter.off('example')
  * emitter.off('demo', function () {})
  */ emitter.off = function off(event, fn) {
        var keep = [];
        if (event && fn) {
            var fns = this._fns[event];
            var i = 0;
            var l = fns ? fns.length : 0;
            for(i; i < l; i++)if (fns[i] !== fn) keep.push(fns[i]);
        }
        keep.length ? this._fns[event] = keep : delete this._fns[event];
    };
    function getListeners(e) {
        var out = _fns[e] ? _fns[e] : [];
        var idx = e.indexOf(":");
        var args = idx === -1 ? [
            e
        ] : [
            e.substring(0, idx),
            e.substring(idx + 1)
        ];
        var keys = Object.keys(_fns);
        var i = 0;
        var l = keys.length;
        for(i; i < l; i++){
            var key = keys[i];
            if (key === "*") out = out.concat(_fns[key]);
            if (args.length === 2 && args[0] === key) {
                out = out.concat(_fns[key]);
                break;
            }
        }
        return out;
    }
    function emitAll(e, fns, args) {
        var i = 0;
        var l = fns.length;
        for(i; i < l; i++){
            if (!fns[i]) break;
            fns[i].event = e;
            fns[i].apply(fns[i], args);
        }
    }
    return emitter;
};


let $3c82c89e950acc97$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $3c82c89e950acc97$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $3c82c89e950acc97$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $3c82c89e950acc97$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $a50c1ad1c2867517$exports = {};
var $8284bc2b60dc4bc4$exports = {};
var $db5dfd0661742a1a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $db5dfd0661742a1a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$db5dfd0661742a1a$exports = $db5dfd0661742a1a$var$isObject;


var $1c50bd4ee78fb504$exports = {};
var $67910ad3df1b1086$exports = {};
var $fb170ba8a9c2191f$exports = {};
/** Detect free variable `global` from Node.js. */ var $fb170ba8a9c2191f$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$fb170ba8a9c2191f$exports = $fb170ba8a9c2191f$var$freeGlobal;


/** Detect free variable `self`. */ var $67910ad3df1b1086$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $67910ad3df1b1086$var$root = $fb170ba8a9c2191f$exports || $67910ad3df1b1086$var$freeSelf || Function("return this")();
$67910ad3df1b1086$exports = $67910ad3df1b1086$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1c50bd4ee78fb504$var$now = function() {
    return $67910ad3df1b1086$exports.Date.now();
};
$1c50bd4ee78fb504$exports = $1c50bd4ee78fb504$var$now;


var $e588870a06e690e1$exports = {};
var $3b7784db2f170e31$exports = {};
var $85eafef3a7f213a3$exports = {};
/** Used to match a single whitespace character. */ var $85eafef3a7f213a3$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $85eafef3a7f213a3$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $85eafef3a7f213a3$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$85eafef3a7f213a3$exports = $85eafef3a7f213a3$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $3b7784db2f170e31$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $3b7784db2f170e31$var$baseTrim(string) {
    return string ? string.slice(0, $85eafef3a7f213a3$exports(string) + 1).replace($3b7784db2f170e31$var$reTrimStart, "") : string;
}
$3b7784db2f170e31$exports = $3b7784db2f170e31$var$baseTrim;



var $b7350b23d035986b$exports = {};
var $852d1f971b259156$exports = {};
var $a090581360ce8173$exports = {};

/** Built-in value references. */ var $a090581360ce8173$var$Symbol = $67910ad3df1b1086$exports.Symbol;
$a090581360ce8173$exports = $a090581360ce8173$var$Symbol;


var $f2cc4cee927d37c7$exports = {};

/** Used for built-in method references. */ var $f2cc4cee927d37c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f2cc4cee927d37c7$var$hasOwnProperty = $f2cc4cee927d37c7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f2cc4cee927d37c7$var$nativeObjectToString = $f2cc4cee927d37c7$var$objectProto.toString;
/** Built-in value references. */ var $f2cc4cee927d37c7$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f2cc4cee927d37c7$var$getRawTag(value) {
    var isOwn = $f2cc4cee927d37c7$var$hasOwnProperty.call(value, $f2cc4cee927d37c7$var$symToStringTag), tag = value[$f2cc4cee927d37c7$var$symToStringTag];
    try {
        value[$f2cc4cee927d37c7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f2cc4cee927d37c7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f2cc4cee927d37c7$var$symToStringTag] = tag;
        else delete value[$f2cc4cee927d37c7$var$symToStringTag];
    }
    return result;
}
$f2cc4cee927d37c7$exports = $f2cc4cee927d37c7$var$getRawTag;


var $934b51efa189f09c$exports = {};
/** Used for built-in method references. */ var $934b51efa189f09c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $934b51efa189f09c$var$nativeObjectToString = $934b51efa189f09c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $934b51efa189f09c$var$objectToString(value) {
    return $934b51efa189f09c$var$nativeObjectToString.call(value);
}
$934b51efa189f09c$exports = $934b51efa189f09c$var$objectToString;


/** `Object#toString` result references. */ var $852d1f971b259156$var$nullTag = "[object Null]", $852d1f971b259156$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $852d1f971b259156$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $852d1f971b259156$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $852d1f971b259156$var$undefinedTag : $852d1f971b259156$var$nullTag;
    return $852d1f971b259156$var$symToStringTag && $852d1f971b259156$var$symToStringTag in Object(value) ? $f2cc4cee927d37c7$exports(value) : $934b51efa189f09c$exports(value);
}
$852d1f971b259156$exports = $852d1f971b259156$var$baseGetTag;


var $5475ba594a8bdf91$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5475ba594a8bdf91$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$5475ba594a8bdf91$exports = $5475ba594a8bdf91$var$isObjectLike;


/** `Object#toString` result references. */ var $b7350b23d035986b$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b7350b23d035986b$var$isSymbol(value) {
    return typeof value == "symbol" || $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $b7350b23d035986b$var$symbolTag;
}
$b7350b23d035986b$exports = $b7350b23d035986b$var$isSymbol;


/** Used as references for various `Number` constants. */ var $e588870a06e690e1$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $e588870a06e690e1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e588870a06e690e1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e588870a06e690e1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e588870a06e690e1$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e588870a06e690e1$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($b7350b23d035986b$exports(value)) return $e588870a06e690e1$var$NAN;
    if ($db5dfd0661742a1a$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $db5dfd0661742a1a$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $3b7784db2f170e31$exports(value);
    var isBinary = $e588870a06e690e1$var$reIsBinary.test(value);
    return isBinary || $e588870a06e690e1$var$reIsOctal.test(value) ? $e588870a06e690e1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e588870a06e690e1$var$reIsBadHex.test(value) ? $e588870a06e690e1$var$NAN : +value;
}
$e588870a06e690e1$exports = $e588870a06e690e1$var$toNumber;


/** Error message constants. */ var $8284bc2b60dc4bc4$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8284bc2b60dc4bc4$var$nativeMax = Math.max, $8284bc2b60dc4bc4$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $8284bc2b60dc4bc4$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($8284bc2b60dc4bc4$var$FUNC_ERROR_TEXT);
    wait = $e588870a06e690e1$exports(wait) || 0;
    if ($db5dfd0661742a1a$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $8284bc2b60dc4bc4$var$nativeMax($e588870a06e690e1$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $8284bc2b60dc4bc4$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1c50bd4ee78fb504$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1c50bd4ee78fb504$exports());
    }
    function debounced() {
        var time = $1c50bd4ee78fb504$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$8284bc2b60dc4bc4$exports = $8284bc2b60dc4bc4$var$debounce;



/** Error message constants. */ var $a50c1ad1c2867517$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $a50c1ad1c2867517$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($a50c1ad1c2867517$var$FUNC_ERROR_TEXT);
    if ($db5dfd0661742a1a$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $8284bc2b60dc4bc4$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$a50c1ad1c2867517$exports = $a50c1ad1c2867517$var$throttle;


function $f790bad313c52a0f$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $f790bad313c52a0f$var$id = 0;
function $f790bad313c52a0f$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $f790bad313c52a0f$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f790bad313c52a0f$var$packageJson = {
    "version": "3.2.2"
};
var $f790bad313c52a0f$var$_callbacks = /*#__PURE__*/ $f790bad313c52a0f$var$_classPrivateFieldLooseKey("callbacks");
var $f790bad313c52a0f$var$_publish = /*#__PURE__*/ $f790bad313c52a0f$var$_classPrivateFieldLooseKey("publish");
/**
 * Default store that keeps state in a simple object.
 */ class $f790bad313c52a0f$var$DefaultStore {
    constructor(){
        Object.defineProperty(this, $f790bad313c52a0f$var$_publish, {
            value: $f790bad313c52a0f$var$_publish2
        });
        this.state = {};
        Object.defineProperty(this, $f790bad313c52a0f$var$_callbacks, {
            writable: true,
            value: new Set()
        });
    }
    getState() {
        return this.state;
    }
    setState(patch) {
        const prevState = {
            ...this.state
        };
        const nextState = {
            ...this.state,
            ...patch
        };
        this.state = nextState;
        $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_publish)[$f790bad313c52a0f$var$_publish](prevState, nextState, patch);
    }
    subscribe(listener) {
        $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].add(listener);
        return ()=>{
            $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].delete(listener);
        };
    }
}
function $f790bad313c52a0f$var$_publish2() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].forEach((listener)=>{
        listener(...args);
    });
}
$f790bad313c52a0f$var$DefaultStore.VERSION = $f790bad313c52a0f$var$packageJson.version;
var $f790bad313c52a0f$export$2e2bcd8739ae039 = $f790bad313c52a0f$var$DefaultStore;


/**
 * Takes a full filename string and returns an object {name, extension}
 */ function $09afbe8d004816d5$export$2e2bcd8739ae039(fullFileName) {
    const lastDot = fullFileName.lastIndexOf(".");
    // these count as no extension: "no-dot", "trailing-dot."
    if (lastDot === -1 || lastDot === fullFileName.length - 1) return {
        name: fullFileName,
        extension: undefined
    };
    return {
        name: fullFileName.slice(0, lastDot),
        extension: fullFileName.slice(lastDot + 1)
    };
}


// ___Why not add the mime-types package?
//    It's 19.7kB gzipped, and we only need mime types for well-known extensions (for file previews).
// ___Where to take new extensions from?
//    https://github.com/jshttp/mime-db/blob/master/db.json
var $92507ee89880573c$export$2e2bcd8739ae039 = {
    __proto__: null,
    md: "text/markdown",
    markdown: "text/markdown",
    mp4: "video/mp4",
    mp3: "audio/mp3",
    svg: "image/svg+xml",
    jpg: "image/jpeg",
    png: "image/png",
    webp: "image/webp",
    gif: "image/gif",
    heic: "image/heic",
    heif: "image/heif",
    yaml: "text/yaml",
    yml: "text/yaml",
    csv: "text/csv",
    tsv: "text/tab-separated-values",
    tab: "text/tab-separated-values",
    avi: "video/x-msvideo",
    mks: "video/x-matroska",
    mkv: "video/x-matroska",
    mov: "video/quicktime",
    dicom: "application/dicom",
    doc: "application/msword",
    docm: "application/vnd.ms-word.document.macroenabled.12",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    dot: "application/msword",
    dotm: "application/vnd.ms-word.template.macroenabled.12",
    dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
    xla: "application/vnd.ms-excel",
    xlam: "application/vnd.ms-excel.addin.macroenabled.12",
    xlc: "application/vnd.ms-excel",
    xlf: "application/x-xliff+xml",
    xlm: "application/vnd.ms-excel",
    xls: "application/vnd.ms-excel",
    xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
    xlsm: "application/vnd.ms-excel.sheet.macroenabled.12",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xlt: "application/vnd.ms-excel",
    xltm: "application/vnd.ms-excel.template.macroenabled.12",
    xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    xlw: "application/vnd.ms-excel",
    txt: "text/plain",
    text: "text/plain",
    conf: "text/plain",
    log: "text/plain",
    pdf: "application/pdf",
    zip: "application/zip",
    "7z": "application/x-7z-compressed",
    rar: "application/x-rar-compressed",
    tar: "application/x-tar",
    gz: "application/gzip",
    dmg: "application/x-apple-diskimage"
};


function $d70a5ddc0e61f36b$export$2e2bcd8739ae039(file) {
    var _getFileNameAndExtens;
    if (file.type) return file.type;
    const fileExtension = file.name ? (_getFileNameAndExtens = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.name).extension) == null ? void 0 : _getFileNameAndExtens.toLowerCase() : null;
    if (fileExtension && fileExtension in (0, $92507ee89880573c$export$2e2bcd8739ae039)) // else, see if we can map extension to a mime type
    return (0, $92507ee89880573c$export$2e2bcd8739ae039)[fileExtension];
    // if all fails, fall back to a generic byte stream type
    return "application/octet-stream";
}




function $d67267bb9859462b$var$encodeCharacter(character) {
    return character.charCodeAt(0).toString(32);
}
function $d67267bb9859462b$var$encodeFilename(name) {
    let suffix = "";
    return name.replace(/[^A-Z0-9]/gi, (character)=>{
        suffix += `-${$d67267bb9859462b$var$encodeCharacter(character)}`;
        return "/";
    }) + suffix;
}
function $d67267bb9859462b$export$2e2bcd8739ae039(file) {
    // It's tempting to do `[items].filter(Boolean).join('-')` here, but that
    // is slower! simple string concatenation is fast
    let id = "uppy";
    if (typeof file.name === "string") id += `-${$d67267bb9859462b$var$encodeFilename(file.name.toLowerCase())}`;
    if (file.type !== undefined) id += `-${file.type}`;
    if (file.meta && typeof file.meta.relativePath === "string") id += `-${$d67267bb9859462b$var$encodeFilename(file.meta.relativePath.toLowerCase())}`;
    if (file.data.size !== undefined) id += `-${file.data.size}`;
    if (file.data.lastModified !== undefined) id += `-${file.data.lastModified}`;
    return id;
}
// If the provider has a stable, unique ID, then we can use that to identify the file.
// Then we don't have to generate our own ID, and we can add the same file many times if needed (different path)
function $d67267bb9859462b$var$hasFileStableId(file) {
    if (!file.isRemote || !file.remote) return false;
    // These are the providers that it seems like have stable IDs for their files. The other's I haven't checked yet.
    const stableIdProviders = new Set([
        "box",
        "dropbox",
        "drive",
        "facebook",
        "unsplash"
    ]);
    return stableIdProviders.has(file.remote.provider);
}
function $d67267bb9859462b$export$2ff5b23440673856(file) {
    if ($d67267bb9859462b$var$hasFileStableId(file)) return file.id;
    const fileType = (0, $d70a5ddc0e61f36b$export$2e2bcd8739ae039)(file);
    return $d67267bb9859462b$export$2e2bcd8739ae039({
        ...file,
        type: fileType
    });
}


// Edge 15.x does not fire 'progress' events on uploads.
// See https://github.com/transloadit/uppy/issues/945
// And https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12224510/
function $d0281443a9bf1cf1$export$2e2bcd8739ae039(userAgent) {
    // Allow passing in userAgent for tests
    if (userAgent == null && typeof navigator !== "undefined") // eslint-disable-next-line no-param-reassign
    userAgent = navigator.userAgent;
    // Assume it works because basically everything supports progress events.
    if (!userAgent) return true;
    const m = /Edge\/(\d+\.\d+)/.exec(userAgent);
    if (!m) return true;
    const edgeVersion = m[1];
    const version = edgeVersion.split(".", 2);
    const major = parseInt(version[0], 10);
    const minor = parseInt(version[1], 10);
    // Worked before:
    // Edge 40.15063.0.0
    // Microsoft EdgeHTML 15.15063
    if (major < 15 || major === 15 && minor < 15063) return true;
    // Fixed in:
    // Microsoft EdgeHTML 18.18218
    if (major > 18 || major === 18 && minor >= 18218) return true;
    // other versions don't work.
    return false;
}


function $77bbd1edc6b4e0f3$export$2e2bcd8739ae039(fileType, fileDescriptor) {
    if (fileDescriptor.name) return fileDescriptor.name;
    if (fileType.split("/")[0] === "image") return `${fileType.split("/")[0]}.${fileType.split("/")[1]}`;
    return "noname";
}


/* eslint-disable no-console */ /**
 * Adds zero to strings shorter than two characters.
 */ function $cd89119ba1e2ad9d$var$pad(number) {
    return number < 10 ? `0${number}` : number.toString();
}
function $cd89119ba1e2ad9d$export$2e2bcd8739ae039() {
    const date = new Date();
    const hours = $cd89119ba1e2ad9d$var$pad(date.getHours());
    const minutes = $cd89119ba1e2ad9d$var$pad(date.getMinutes());
    const seconds = $cd89119ba1e2ad9d$var$pad(date.getSeconds());
    return `${hours}:${minutes}:${seconds}`;
}


// Swallow all logs, except errors.
// default if logger is not set or debug: false
const $b03b26a8a191c595$export$51086a57eba987c9 = {
    debug: ()=>{},
    warn: ()=>{},
    error: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return console.error(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    }
};
// Print logs to console with namespace + timestamp,
// set by logger: Uppy.debugLogger or debug: true
const $b03b26a8a191c595$export$e6a390ea6399b7d8 = {
    debug: function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return console.debug(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    },
    warn: function() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return console.warn(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    },
    error: function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return console.error(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    }
};


/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable max-classes-per-file, class-methods-use-this */ var $06e80194017bcce5$exports = {};
"use strict";
$06e80194017bcce5$exports = function prettierBytes(num) {
    if (typeof num !== "number" || Number.isNaN(num)) throw new TypeError(`Expected a number, got ${typeof num}`);
    const neg = num < 0;
    const units = [
        "B",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    if (neg) num = -num;
    if (num < 1) return `${(neg ? "-" : "") + num} B`;
    const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
    num = Number(num / 1024 ** exponent);
    const unit = units[exponent];
    if (num >= 10 || num % 1 === 0) return `${(neg ? "-" : "") + num.toFixed(0)} ${unit}`;
    return `${(neg ? "-" : "") + num.toFixed(1)} ${unit}`;
};


var $34b5d77a3aae6147$exports = {};
var $bf27c8b296b096af$exports = {};
/* jshint node: true */ "use strict";
/**
  # wildcard

  Very simple wildcard matching, which is designed to provide the same
  functionality that is found in the
  [eve](https://github.com/adobe-webplatform/eve) eventing library.

  ## Usage

  It works with strings:

  <<< examples/strings.js

  Arrays:

  <<< examples/arrays.js

  Objects (matching against keys):

  <<< examples/objects.js

  While the library works in Node, if you are are looking for file-based
  wildcard matching then you should have a look at:

  <https://github.com/isaacs/node-glob>
**/ function $bf27c8b296b096af$var$WildcardMatcher(text, separator) {
    this.text = text = text || "";
    this.hasWild = ~text.indexOf("*");
    this.separator = separator;
    this.parts = text.split(separator);
}
$bf27c8b296b096af$var$WildcardMatcher.prototype.match = function(input) {
    var matches = true;
    var parts = this.parts;
    var ii;
    var partsCount = parts.length;
    var testParts;
    if (typeof input == "string" || input instanceof String) {
        if (!this.hasWild && this.text != input) matches = false;
        else {
            testParts = (input || "").split(this.separator);
            for(ii = 0; matches && ii < partsCount; ii++){
                if (parts[ii] === "*") continue;
                else if (ii < testParts.length) matches = parts[ii] === testParts[ii];
                else matches = false;
            }
            // If matches, then return the component parts
            matches = matches && testParts;
        }
    } else if (typeof input.splice == "function") {
        matches = [];
        for(ii = input.length; ii--;)if (this.match(input[ii])) matches[matches.length] = input[ii];
    } else if (typeof input == "object") {
        matches = {};
        for(var key in input)if (this.match(key)) matches[key] = input[key];
    }
    return matches;
};
$bf27c8b296b096af$exports = function(text, test, separator) {
    var matcher = new $bf27c8b296b096af$var$WildcardMatcher(text, separator || /[\/\.]/);
    if (typeof test != "undefined") return matcher.match(test);
    return matcher;
};


var $34b5d77a3aae6147$var$reMimePartSplit = /[\/\+\.]/;
/**
  # mime-match

  A simple function to checker whether a target mime type matches a mime-type
  pattern (e.g. image/jpeg matches image/jpeg OR image/*).

  ## Example Usage

  <<< example.js

**/ $34b5d77a3aae6147$exports = function(target, pattern) {
    function test(pattern) {
        var result = $bf27c8b296b096af$exports(pattern, target, $34b5d77a3aae6147$var$reMimePartSplit);
        // ensure that we have a valid mime type (should have two parts)
        return result && result.length >= 2;
    }
    return pattern ? test(pattern.split(";")[0]) : test;
};


/**
 * The minimal required properties to be present from UppyFile in order to validate it.
 */ const $3044940369c0f03d$export$ba43bf67f3d48107 = {
    maxFileSize: null,
    minFileSize: null,
    maxTotalFileSize: null,
    maxNumberOfFiles: null,
    minNumberOfFiles: null,
    allowedFileTypes: null,
    requiredMetaFields: []
};
class $3044940369c0f03d$export$e4d147272ce048a7 extends Error {
    constructor(message, opts){
        var _opts$isUserFacing;
        super(message);
        this.isRestriction = true;
        this.isUserFacing = (_opts$isUserFacing = opts == null ? void 0 : opts.isUserFacing) != null ? _opts$isUserFacing : true;
        if (opts != null && opts.file) this.file = opts.file; // only some restriction errors are related to a particular file
    }
}
class $3044940369c0f03d$export$c464a380a24dd3b8 {
    constructor(getOpts, i18n){
        this.i18n = i18n;
        this.getOpts = ()=>{
            var _opts$restrictions;
            const opts = getOpts();
            if (((_opts$restrictions = opts.restrictions) == null ? void 0 : _opts$restrictions.allowedFileTypes) != null && !Array.isArray(opts.restrictions.allowedFileTypes)) throw new TypeError("`restrictions.allowedFileTypes` must be an array");
            return opts;
        };
    }
    // Because these operations are slow, we cannot run them for every file (if we are adding multiple files)
    validateAggregateRestrictions(existingFiles, addingFiles) {
        const { maxTotalFileSize: maxTotalFileSize, maxNumberOfFiles: maxNumberOfFiles } = this.getOpts().restrictions;
        if (maxNumberOfFiles) {
            const nonGhostFiles = existingFiles.filter((f)=>!f.isGhost);
            if (nonGhostFiles.length + addingFiles.length > maxNumberOfFiles) throw new $3044940369c0f03d$export$e4d147272ce048a7(`${this.i18n("youCanOnlyUploadX", {
                smart_count: maxNumberOfFiles
            })}`);
        }
        if (maxTotalFileSize) {
            let totalFilesSize = existingFiles.reduce((total, f)=>{
                var _f$size;
                return total + ((_f$size = f.size) != null ? _f$size : 0);
            }, 0);
            for (const addingFile of addingFiles)if (addingFile.size != null) {
                // We can't check maxTotalFileSize if the size is unknown.
                totalFilesSize += addingFile.size;
                if (totalFilesSize > maxTotalFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.i18n("exceedsSize", {
                    size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(maxTotalFileSize),
                    file: addingFile.name
                }));
            }
        }
    }
    validateSingleFile(file) {
        const { maxFileSize: maxFileSize, minFileSize: minFileSize, allowedFileTypes: allowedFileTypes } = this.getOpts().restrictions;
        if (allowedFileTypes) {
            const isCorrectFileType = allowedFileTypes.some((type)=>{
                // check if this is a mime-type
                if (type.includes("/")) {
                    if (!file.type) return false;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($34b5d77a3aae6147$exports)))(file.type.replace(/;.*?$/, ""), type);
                }
                // otherwise this is likely an extension
                if (type[0] === "." && file.extension) return file.extension.toLowerCase() === type.slice(1).toLowerCase();
                return false;
            });
            if (!isCorrectFileType) {
                const allowedFileTypesString = allowedFileTypes.join(", ");
                throw new $3044940369c0f03d$export$e4d147272ce048a7(this.i18n("youCanOnlyUploadFileTypes", {
                    types: allowedFileTypesString
                }), {
                    file: file
                });
            }
        }
        // We can't check maxFileSize if the size is unknown.
        if (maxFileSize && file.size != null && file.size > maxFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.i18n("exceedsSize", {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(maxFileSize),
            file: file.name
        }), {
            file: file
        });
        // We can't check minFileSize if the size is unknown.
        if (minFileSize && file.size != null && file.size < minFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.i18n("inferiorSize", {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(minFileSize)
        }), {
            file: file
        });
    }
    validate(existingFiles, addingFiles) {
        addingFiles.forEach((addingFile)=>{
            this.validateSingleFile(addingFile);
        });
        this.validateAggregateRestrictions(existingFiles, addingFiles);
    }
    validateMinNumberOfFiles(files) {
        const { minNumberOfFiles: minNumberOfFiles } = this.getOpts().restrictions;
        if (minNumberOfFiles && Object.keys(files).length < minNumberOfFiles) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.i18n("youHaveToAtLeastSelectX", {
            smart_count: minNumberOfFiles
        }));
    }
    getMissingRequiredMetaFields(file) {
        const error = new $3044940369c0f03d$export$e4d147272ce048a7(this.i18n("missingRequiredMetaFieldOnFile", {
            fileName: file.name
        }));
        const { requiredMetaFields: requiredMetaFields } = this.getOpts().restrictions;
        const missingFields = [];
        for (const field of requiredMetaFields)if (!Object.hasOwn(file.meta, field) || file.meta[field] === "") missingFields.push(field);
        return {
            missingFields: missingFields,
            error: error
        };
    }
}


var $721644b39e57ffe9$export$2e2bcd8739ae039 = {
    strings: {
        addBulkFilesFailed: {
            0: "Failed to add %{smart_count} file due to an internal error",
            1: "Failed to add %{smart_count} files due to internal errors"
        },
        youCanOnlyUploadX: {
            0: "You can only upload %{smart_count} file",
            1: "You can only upload %{smart_count} files"
        },
        youHaveToAtLeastSelectX: {
            0: "You have to select at least %{smart_count} file",
            1: "You have to select at least %{smart_count} files"
        },
        exceedsSize: "%{file} exceeds maximum allowed size of %{size}",
        missingRequiredMetaField: "Missing required meta fields",
        missingRequiredMetaFieldOnFile: "Missing required meta fields in %{fileName}",
        inferiorSize: "This file is smaller than the allowed size of %{size}",
        youCanOnlyUploadFileTypes: "You can only upload: %{types}",
        noMoreFilesAllowed: "Cannot add more files",
        noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
        companionError: "Connection with Companion failed",
        authAborted: "Authentication aborted",
        companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}",
        failedToUpload: "Failed to upload %{file}",
        noInternetConnection: "No Internet connection",
        connectedToInternet: "Connected to the Internet",
        // Strings for remote providers
        noFilesFound: "You have no files or folders here",
        noSearchResults: "Unfortunately, there are no results for this search",
        selectX: {
            0: "Select %{smart_count}",
            1: "Select %{smart_count}"
        },
        allFilesFromFolderNamed: "All files from folder %{name}",
        openFolderNamed: "Open folder %{name}",
        cancel: "Cancel",
        logOut: "Log out",
        filter: "Filter",
        resetFilter: "Reset filter",
        loading: "Loading...",
        loadedXFiles: "Loaded %{numFiles} files",
        authenticateWithTitle: "Please authenticate with %{pluginName} to select files",
        authenticateWith: "Connect to %{pluginName}",
        signInWithGoogle: "Sign in with Google",
        searchImages: "Search for images",
        enterTextToSearch: "Enter text to search for images",
        search: "Search",
        resetSearch: "Reset search",
        emptyFolderAdded: "No files were added from empty folder",
        addedNumFiles: "Added %{numFiles} file(s)",
        folderAlreadyAdded: 'The folder "%{folder}" was already added',
        folderAdded: {
            0: "Added %{smart_count} file from %{folder}",
            1: "Added %{smart_count} files from %{folder}"
        },
        additionalRestrictionsFailed: "%{count} additional restrictions were not fulfilled"
    }
};


let $b16b91c7840d3bff$var$_Symbol$for, $b16b91c7840d3bff$var$_Symbol$for2;
function $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $b16b91c7840d3bff$var$id = 0;
function $b16b91c7840d3bff$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $b16b91c7840d3bff$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $b16b91c7840d3bff$var$packageJson = {
    "version": "3.10.1"
};
/*
 * UnknownProviderPlugin can be any Companion plugin (such as Google Drive).
 * As the plugins are passed around throughout Uppy we need a generic type for this.
 * It may seems like duplication, but this type safe. Changing the type of `storage`
 * will error in the `Provider` class of @uppy/companion-client and vice versa.
 *
 * Note that this is the *plugin* class, not a version of the `Provider` class.
 * `Provider` does operate on Companion plugins with `uppy.getPlugin()`.
 */ /*
 * UnknownSearchProviderPlugin can be any search Companion plugin (such as Unsplash).
 * As the plugins are passed around throughout Uppy we need a generic type for this.
 * It may seems like duplication, but this type safe. Changing the type of `title`
 * will error in the `SearchProvider` class of @uppy/companion-client and vice versa.
 *
 * Note that this is the *plugin* class, not a version of the `SearchProvider` class.
 * `SearchProvider` does operate on Companion plugins with `uppy.getPlugin()`.
 */ // TODO: can we use namespaces in other plugins to populate this?
// eslint-disable-next-line @typescript-eslint/no-empty-interface
// The user facing type for UppyOptions used in uppy.setOptions()
/** @deprecated */ const $b16b91c7840d3bff$var$defaultUploadState = {
    totalProgress: 0,
    allowNewUpload: true,
    error: null,
    recoveredState: null
};
/**
 * Uppy Core module.
 * Manages plugins, state updates, acts as an event bus,
 * adds/removes files and metadata.
 */ var $b16b91c7840d3bff$var$_plugins = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("plugins");
var $b16b91c7840d3bff$var$_restricter = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("restricter");
var $b16b91c7840d3bff$var$_storeUnsubscribe = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("storeUnsubscribe");
var $b16b91c7840d3bff$var$_emitter = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("emitter");
var $b16b91c7840d3bff$var$_preProcessors = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("preProcessors");
var $b16b91c7840d3bff$var$_uploaders = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("uploaders");
var $b16b91c7840d3bff$var$_postProcessors = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("postProcessors");
var $b16b91c7840d3bff$var$_informAndEmit = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("informAndEmit");
var $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkRequiredMetaFieldsOnFile");
var $b16b91c7840d3bff$var$_checkRequiredMetaFields = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkRequiredMetaFields");
var $b16b91c7840d3bff$var$_assertNewUploadAllowed = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("assertNewUploadAllowed");
var $b16b91c7840d3bff$var$_transformFile = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("transformFile");
var $b16b91c7840d3bff$var$_startIfAutoProceed = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("startIfAutoProceed");
var $b16b91c7840d3bff$var$_checkAndUpdateFileState = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkAndUpdateFileState");
var $b16b91c7840d3bff$var$_addListeners = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("addListeners");
var $b16b91c7840d3bff$var$_updateOnlineStatus = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("updateOnlineStatus");
var $b16b91c7840d3bff$var$_requestClientById = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("requestClientById");
var $b16b91c7840d3bff$var$_createUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("createUpload");
var $b16b91c7840d3bff$var$_getUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("getUpload");
var $b16b91c7840d3bff$var$_removeUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("removeUpload");
var $b16b91c7840d3bff$var$_runUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("runUpload");
$b16b91c7840d3bff$var$_Symbol$for = Symbol.for("uppy test: getPlugins");
$b16b91c7840d3bff$var$_Symbol$for2 = Symbol.for("uppy test: createUpload");
class $b16b91c7840d3bff$export$1c95bea2669f592b {
    /**
   * Instantiate Uppy
   */ constructor(_opts){
        /**
     * Run an upload. This picks up where it left off in case the upload is being restored.
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_runUpload, {
            value: $b16b91c7840d3bff$var$_runUpload2
        });
        /**
     * Remove an upload, eg. if it has been canceled or completed.
     *
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_removeUpload, {
            value: $b16b91c7840d3bff$var$_removeUpload2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_getUpload, {
            value: $b16b91c7840d3bff$var$_getUpload2
        });
        /**
     * Create an upload for a bunch of files.
     *
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_createUpload, {
            value: $b16b91c7840d3bff$var$_createUpload2
        });
        /**
     * Registers listeners for all global actions, like:
     * `error`, `file-removed`, `upload-progress`
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_addListeners, {
            value: $b16b91c7840d3bff$var$_addListeners2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState, {
            value: $b16b91c7840d3bff$var$_checkAndUpdateFileState2
        });
        // Schedule an upload if `autoProceed` is enabled.
        Object.defineProperty(this, $b16b91c7840d3bff$var$_startIfAutoProceed, {
            value: $b16b91c7840d3bff$var$_startIfAutoProceed2
        });
        /**
     * Create a file state object based on user-provided `addFile()` options.
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_transformFile, {
            value: $b16b91c7840d3bff$var$_transformFile2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed, {
            value: $b16b91c7840d3bff$var$_assertNewUploadAllowed2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkRequiredMetaFields, {
            value: $b16b91c7840d3bff$var$_checkRequiredMetaFields2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile, {
            value: $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_informAndEmit, {
            value: $b16b91c7840d3bff$var$_informAndEmit2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_plugins, {
            writable: true,
            value: Object.create(null)
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_restricter, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_storeUnsubscribe, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_emitter, {
            writable: true,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($1713863f3a962559$exports)))()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_preProcessors, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_uploaders, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_postProcessors, {
            writable: true,
            value: new Set()
        });
        this.scheduledAutoProceed = null;
        this.wasOffline = false;
        // ___Why throttle at 500ms?
        //    - We must throttle at >250ms for superfocus in Dashboard to work well
        //    (because animation takes 0.25s, and we want to wait for all animations to be over before refocusing).
        //    [Practical Check]: if thottle is at 100ms, then if you are uploading a file,
        //    and click 'ADD MORE FILES', - focus won't activate in Firefox.
        //    - We must throttle at around >500ms to avoid performance lags.
        //    [Practical Check] Firefox, try to upload a big file for a prolonged period of time. Laptop will start to heat up.
        // todo when uploading multiple files, this will cause problems because they share the same throttle,
        // meaning some files might never get their progress reported (eaten up by progress events from other files)
        this.calculateProgress = (0, (/*@__PURE__*/$parcel$interopDefault($a50c1ad1c2867517$exports)))((file, data)=>{
            const fileInState = this.getFile(file == null ? void 0 : file.id);
            if (file == null || !fileInState) {
                this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
                return;
            }
            if (fileInState.progress.percentage === 100) {
                this.log(`Not setting progress for a file that has been already uploaded: ${file.id}`);
                return;
            }
            // bytesTotal may be null or zero; in that case we can't divide by it
            const canHavePercentage = Number.isFinite(data.bytesTotal) && data.bytesTotal > 0;
            this.setFileState(file.id, {
                progress: {
                    ...fileInState.progress,
                    bytesUploaded: data.bytesUploaded,
                    bytesTotal: data.bytesTotal,
                    percentage: canHavePercentage ? Math.round(data.bytesUploaded / data.bytesTotal * 100) : 0
                }
            });
            this.calculateTotalProgress();
        }, 500, {
            leading: true,
            trailing: true
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_updateOnlineStatus, {
            writable: true,
            value: this.updateOnlineStatus.bind(this)
        });
        // We need to store request clients by a unique ID, so we can share RequestClient instances across files
        // this allows us to do rate limiting and synchronous operations like refreshing provider tokens
        // example: refreshing tokens: if each file has their own requestclient,
        // we don't have any way to synchronize all requests in order to
        // - block all requests
        // - refresh the token
        // - unblock all requests and allow them to run with a the new access token
        // back when we had a requestclient per file, once an access token expired,
        // all 6 files would go ahead and refresh the token at the same time
        // (calling /refresh-token up to 6 times), which will probably fail for some providers
        Object.defineProperty(this, $b16b91c7840d3bff$var$_requestClientById, {
            writable: true,
            value: new Map()
        });
        this.defaultLocale = (0, $721644b39e57ffe9$export$2e2bcd8739ae039);
        const defaultOptions = {
            id: "uppy",
            autoProceed: false,
            allowMultipleUploadBatches: true,
            debug: false,
            restrictions: (0, $3044940369c0f03d$export$ba43bf67f3d48107),
            meta: {},
            onBeforeFileAdded: (file, files)=>!Object.hasOwn(files, file.id),
            onBeforeUpload: (files)=>files,
            store: new (0, $f790bad313c52a0f$export$2e2bcd8739ae039)(),
            logger: (0, $b03b26a8a191c595$export$51086a57eba987c9),
            infoTimeout: 5000
        };
        const merged = {
            ...defaultOptions,
            ..._opts
        };
        // Merge default options with the ones set by user,
        // making sure to merge restrictions too
        this.opts = {
            ...merged,
            restrictions: {
                ...defaultOptions.restrictions,
                ..._opts && _opts.restrictions
            }
        };
        // Support debug: true for backwards-compatability, unless logger is set in opts
        // opts instead of this.opts to avoid comparing objects — we set logger: justErrorsLogger in defaultOptions
        if (_opts && _opts.logger && _opts.debug) this.log("You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.", "warning");
        else if (_opts && _opts.debug) this.opts.logger = (0, $b03b26a8a191c595$export$e6a390ea6399b7d8);
        this.log(`Using Core v${$b16b91c7840d3bff$export$1c95bea2669f592b.VERSION}`);
        this.i18nInit();
        this.store = this.opts.store;
        this.setState({
            ...$b16b91c7840d3bff$var$defaultUploadState,
            plugins: {},
            files: {},
            currentUploads: {},
            capabilities: {
                uploadProgress: (0, $d0281443a9bf1cf1$export$2e2bcd8739ae039)(),
                individualCancellation: true,
                resumableUploads: false
            },
            meta: {
                ...this.opts.meta
            },
            info: []
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter] = new (0, $3044940369c0f03d$export$c464a380a24dd3b8)(()=>this.opts, this.i18n);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_storeUnsubscribe)[$b16b91c7840d3bff$var$_storeUnsubscribe] = this.store.subscribe(// eslint-disable-next-line
        // @ts-ignore Store is incorrectly typed
        (prevState, nextState, patch)=>{
            // eslint-disable-next-line
            // @ts-ignore Store is incorrectly typed
            this.emit("state-update", prevState, nextState, patch);
            this.updateAll(nextState);
        });
        // Exposing uppy object on window for debugging and testing
        if (this.opts.debug && typeof window !== "undefined") // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore Mutating the global object for debug purposes
        window[this.opts.id] = this;
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_addListeners)[$b16b91c7840d3bff$var$_addListeners]();
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].emit(event, ...args);
    }
    on(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].on(event, callback);
        return this;
    }
    once(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].once(event, callback);
        return this;
    }
    off(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].off(event, callback);
        return this;
    }
    /**
   * Iterate on all plugins and run `update` on them.
   * Called each time state changes.
   *
   */ updateAll(state) {
        this.iteratePlugins((plugin)=>{
            plugin.update(state);
        });
    }
    /**
   * Updates state with a patch
   */ setState(patch) {
        // eslint-disable-next-line
        // @ts-ignore Store is incorrectly typed
        this.store.setState(patch);
    }
    /**
   * Returns current state.
   */ getState() {
        // eslint-disable-next-line
        // @ts-ignore Store is incorrectly typed
        return this.store.getState();
    }
    patchFilesState(filesWithNewState) {
        const existingFilesState = this.getState().files;
        this.setState({
            files: {
                ...existingFilesState,
                ...Object.fromEntries(Object.entries(filesWithNewState).map((_ref)=>{
                    let [fileID, newFileState] = _ref;
                    return [
                        fileID,
                        {
                            ...existingFilesState[fileID],
                            ...newFileState
                        }
                    ];
                }))
            }
        });
    }
    /**
   * Shorthand to set state for a specific file.
   */ setFileState(fileID, state) {
        if (!this.getState().files[fileID]) throw new Error(`Can\u{2019}t set state for ${fileID} (the file could have been removed)`);
        this.patchFilesState({
            [fileID]: state
        });
    }
    i18nInit() {
        const onMissingKey = (key)=>this.log(`Missing i18n string: ${key}`, "error");
        const translator = new (0, $a85fd1efd23057e0$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.opts.locale
        ], {
            onMissingKey: onMissingKey
        });
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.locale = translator.locale;
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts,
            restrictions: {
                ...this.opts.restrictions,
                ...newOpts == null ? void 0 : newOpts.restrictions
            }
        };
        if (newOpts.meta) this.setMeta(newOpts.meta);
        this.i18nInit();
        if (newOpts.locale) this.iteratePlugins((plugin)=>{
            plugin.setOptions(newOpts);
        });
        // Note: this is not the preact `setState`, it's an internal function that has the same name.
        this.setState(undefined); // so that UI re-renders with new options
    }
    // todo next major: remove
    resetProgress() {
        const defaultProgress = {
            percentage: 0,
            bytesUploaded: 0,
            uploadComplete: false,
            uploadStarted: null
        };
        const files = {
            ...this.getState().files
        };
        const updatedFiles = {};
        Object.keys(files).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...files[fileID],
                progress: {
                    ...files[fileID].progress,
                    ...defaultProgress
                }
            };
        });
        this.setState({
            files: updatedFiles,
            ...$b16b91c7840d3bff$var$defaultUploadState
        });
        this.emit("reset-progress");
    }
    // @todo next major: rename to `clear()`, make it also cancel ongoing uploads
    // or throw and say you need to cancel manually
    clearUploadedFiles() {
        this.setState({
            ...$b16b91c7840d3bff$var$defaultUploadState,
            files: {}
        });
    }
    addPreProcessor(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors].add(fn);
    }
    removePreProcessor(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors].delete(fn);
    }
    addPostProcessor(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].add(fn);
    }
    removePostProcessor(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].delete(fn);
    }
    addUploader(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders].add(fn);
    }
    removeUploader(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders].delete(fn);
    }
    setMeta(data) {
        const updatedMeta = {
            ...this.getState().meta,
            ...data
        };
        const updatedFiles = {
            ...this.getState().files
        };
        Object.keys(updatedFiles).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...updatedFiles[fileID],
                meta: {
                    ...updatedFiles[fileID].meta,
                    ...data
                }
            };
        });
        this.log("Adding metadata:");
        this.log(data);
        this.setState({
            meta: updatedMeta,
            files: updatedFiles
        });
    }
    setFileMeta(fileID, data) {
        const updatedFiles = {
            ...this.getState().files
        };
        if (!updatedFiles[fileID]) {
            this.log("Was trying to set metadata for a file that has been removed: ", fileID);
            return;
        }
        const newMeta = {
            ...updatedFiles[fileID].meta,
            ...data
        };
        updatedFiles[fileID] = {
            ...updatedFiles[fileID],
            meta: newMeta
        };
        this.setState({
            files: updatedFiles
        });
    }
    /**
   * Get a file object.
   */ getFile(fileID) {
        return this.getState().files[fileID];
    }
    /**
   * Get all files in an array.
   */ getFiles() {
        const { files: files } = this.getState();
        return Object.values(files);
    }
    getFilesByIds(ids) {
        return ids.map((id)=>this.getFile(id));
    }
    // TODO: remove or refactor this method. It's very inefficient
    getObjectOfFilesPerState() {
        const { files: filesObject, totalProgress: totalProgress, error: error } = this.getState();
        const files = Object.values(filesObject);
        const inProgressFiles = files.filter((_ref2)=>{
            let { progress: progress } = _ref2;
            return !progress.uploadComplete && progress.uploadStarted;
        });
        const newFiles = files.filter((file)=>!file.progress.uploadStarted);
        const startedFiles = files.filter((file)=>file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess);
        const uploadStartedFiles = files.filter((file)=>file.progress.uploadStarted);
        const pausedFiles = files.filter((file)=>file.isPaused);
        const completeFiles = files.filter((file)=>file.progress.uploadComplete);
        const erroredFiles = files.filter((file)=>file.error);
        const inProgressNotPausedFiles = inProgressFiles.filter((file)=>!file.isPaused);
        const processingFiles = files.filter((file)=>file.progress.preprocess || file.progress.postprocess);
        return {
            newFiles: newFiles,
            startedFiles: startedFiles,
            uploadStartedFiles: uploadStartedFiles,
            pausedFiles: pausedFiles,
            completeFiles: completeFiles,
            erroredFiles: erroredFiles,
            inProgressFiles: inProgressFiles,
            inProgressNotPausedFiles: inProgressNotPausedFiles,
            processingFiles: processingFiles,
            isUploadStarted: uploadStartedFiles.length > 0,
            isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
            isAllErrored: !!error && erroredFiles.length === files.length,
            isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
            isUploadInProgress: inProgressFiles.length > 0,
            isSomeGhost: files.some((file)=>file.isGhost)
        };
    }
    validateRestrictions(file, files) {
        if (files === void 0) files = this.getFiles();
        try {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validate(files, [
                file
            ]);
        } catch (err) {
            return err;
        }
        return null;
    }
    checkIfFileAlreadyExists(fileID) {
        const { files: files } = this.getState();
        if (files[fileID] && !files[fileID].isGhost) return true;
        return false;
    }
    /**
   * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
   * try to guess file type in a clever way, check file against restrictions,
   * and start an upload if `autoProceed === true`.
   */ addFile(file) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed)[$b16b91c7840d3bff$var$_assertNewUploadAllowed](file);
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState)[$b16b91c7840d3bff$var$_checkAndUpdateFileState]([
            file
        ]);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit](restrictionErrors);
        if (errors.length > 0) throw errors[0];
        this.setState({
            files: nextFilesState
        });
        const [firstValidFileToAdd] = validFilesToAdd;
        this.emit("file-added", firstValidFileToAdd);
        this.emit("files-added", validFilesToAdd);
        this.log(`Added file: ${firstValidFileToAdd.name}, ${firstValidFileToAdd.id}, mime type: ${firstValidFileToAdd.type}`);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_startIfAutoProceed)[$b16b91c7840d3bff$var$_startIfAutoProceed]();
        return firstValidFileToAdd.id;
    }
    /**
   * Add multiple files to `state.files`. See the `addFile()` documentation.
   *
   * If an error occurs while adding a file, it is logged and the user is notified.
   * This is good for UI plugins, but not for programmatic use.
   * Programmatic users should usually still use `addFile()` on individual files.
   */ addFiles(fileDescriptors) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed)[$b16b91c7840d3bff$var$_assertNewUploadAllowed]();
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState)[$b16b91c7840d3bff$var$_checkAndUpdateFileState](fileDescriptors);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit](restrictionErrors);
        const nonRestrictionErrors = errors.filter((error)=>!error.isRestriction);
        if (nonRestrictionErrors.length > 0) {
            let message = "Multiple errors occurred while adding files:\n";
            nonRestrictionErrors.forEach((subError)=>{
                message += `\n * ${subError.message}`;
            });
            this.info({
                message: this.i18n("addBulkFilesFailed", {
                    smart_count: nonRestrictionErrors.length
                }),
                details: message
            }, "error", this.opts.infoTimeout);
            if (typeof AggregateError === "function") throw new AggregateError(nonRestrictionErrors, message);
            else {
                const err = new Error(message);
                // @ts-expect-error fallback when AggregateError is not available
                err.errors = nonRestrictionErrors;
                throw err;
            }
        }
        // OK, we haven't thrown an error, we can start updating state and emitting events now:
        this.setState({
            files: nextFilesState
        });
        validFilesToAdd.forEach((file)=>{
            this.emit("file-added", file);
        });
        this.emit("files-added", validFilesToAdd);
        if (validFilesToAdd.length > 5) this.log(`Added batch of ${validFilesToAdd.length} files`);
        else Object.values(validFilesToAdd).forEach((file)=>{
            this.log(`Added file: ${file.name}\n id: ${file.id}\n type: ${file.type}`);
        });
        if (validFilesToAdd.length > 0) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_startIfAutoProceed)[$b16b91c7840d3bff$var$_startIfAutoProceed]();
    }
    removeFiles(fileIDs, reason) {
        const { files: files, currentUploads: currentUploads } = this.getState();
        const updatedFiles = {
            ...files
        };
        const updatedUploads = {
            ...currentUploads
        };
        const removedFiles = Object.create(null);
        fileIDs.forEach((fileID)=>{
            if (files[fileID]) {
                removedFiles[fileID] = files[fileID];
                delete updatedFiles[fileID];
            }
        });
        // Remove files from the `fileIDs` list in each upload.
        function fileIsNotRemoved(uploadFileID) {
            return removedFiles[uploadFileID] === undefined;
        }
        Object.keys(updatedUploads).forEach((uploadID)=>{
            const newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved);
            // Remove the upload if no files are associated with it anymore.
            if (newFileIDs.length === 0) {
                delete updatedUploads[uploadID];
                return;
            }
            const { capabilities: capabilities } = this.getState();
            if (newFileIDs.length !== currentUploads[uploadID].fileIDs.length && !capabilities.individualCancellation) throw new Error("individualCancellation is disabled");
            updatedUploads[uploadID] = {
                ...currentUploads[uploadID],
                fileIDs: newFileIDs
            };
        });
        const stateUpdate = {
            currentUploads: updatedUploads,
            files: updatedFiles
        };
        // If all files were removed - allow new uploads,
        // and clear recoveredState
        if (Object.keys(updatedFiles).length === 0) {
            stateUpdate.allowNewUpload = true;
            stateUpdate.error = null;
            stateUpdate.recoveredState = null;
        }
        this.setState(stateUpdate);
        this.calculateTotalProgress();
        const removedFileIDs = Object.keys(removedFiles);
        removedFileIDs.forEach((fileID)=>{
            this.emit("file-removed", removedFiles[fileID], reason);
        });
        if (removedFileIDs.length > 5) this.log(`Removed ${removedFileIDs.length} files`);
        else this.log(`Removed files: ${removedFileIDs.join(", ")}`);
    }
    removeFile(fileID, reason) {
        this.removeFiles([
            fileID
        ], reason);
    }
    pauseResume(fileID) {
        if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).progress.uploadComplete) return undefined;
        const wasPaused = this.getFile(fileID).isPaused || false;
        const isPaused = !wasPaused;
        this.setFileState(fileID, {
            isPaused: isPaused
        });
        this.emit("upload-pause", fileID, isPaused);
        return isPaused;
    }
    pauseAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: true
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit("pause-all");
    }
    resumeAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: false,
                error: null
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit("resume-all");
    }
    retryAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const filesToRetry = Object.keys(updatedFiles).filter((file)=>{
            return updatedFiles[file].error;
        });
        filesToRetry.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: false,
                error: null
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles,
            error: null
        });
        this.emit("retry-all", filesToRetry);
        if (filesToRetry.length === 0) return Promise.resolve({
            successful: [],
            failed: []
        });
        const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](filesToRetry, {
            forceAllowNewUpload: true // create new upload even if allowNewUpload: false
        });
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
    }
    cancelAll(_temp) {
        let { reason: reason = "user" } = _temp === void 0 ? {} : _temp;
        this.emit("cancel-all", {
            reason: reason
        });
        // Only remove existing uploads if user is canceling
        if (reason === "user") {
            const { files: files } = this.getState();
            const fileIDs = Object.keys(files);
            if (fileIDs.length) this.removeFiles(fileIDs, "cancel-all");
            this.setState($b16b91c7840d3bff$var$defaultUploadState);
        // todo should we call this.emit('reset-progress') like we do for resetProgress?
        }
    }
    retryUpload(fileID) {
        this.setFileState(fileID, {
            error: null,
            isPaused: false
        });
        this.emit("upload-retry", fileID);
        const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload]([
            fileID
        ], {
            forceAllowNewUpload: true // create new upload even if allowNewUpload: false
        });
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
    }
    logout() {
        this.iteratePlugins((plugin)=>{
            var _provider;
            (_provider = plugin.provider) == null || _provider.logout == null || _provider.logout();
        });
    }
    calculateTotalProgress() {
        // calculate total progress, using the number of files currently uploading,
        // multiplied by 100 and the summ of individual progress of each file
        const files = this.getFiles();
        const inProgress = files.filter((file)=>{
            return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
        });
        if (inProgress.length === 0) {
            this.emit("progress", 0);
            this.setState({
                totalProgress: 0
            });
            return;
        }
        const sizedFiles = inProgress.filter((file)=>file.progress.bytesTotal != null);
        const unsizedFiles = inProgress.filter((file)=>file.progress.bytesTotal == null);
        if (sizedFiles.length === 0) {
            const progressMax = inProgress.length * 100;
            const currentProgress = unsizedFiles.reduce((acc, file)=>{
                return acc + file.progress.percentage;
            }, 0);
            const totalProgress = Math.round(currentProgress / progressMax * 100);
            this.setState({
                totalProgress: totalProgress
            });
            return;
        }
        let totalSize = sizedFiles.reduce((acc, file)=>{
            var _file$progress$bytesT;
            return acc + ((_file$progress$bytesT = file.progress.bytesTotal) != null ? _file$progress$bytesT : 0);
        }, 0);
        const averageSize = totalSize / sizedFiles.length;
        totalSize += averageSize * unsizedFiles.length;
        let uploadedSize = 0;
        sizedFiles.forEach((file)=>{
            uploadedSize += file.progress.bytesUploaded;
        });
        unsizedFiles.forEach((file)=>{
            uploadedSize += averageSize * (file.progress.percentage || 0) / 100;
        });
        let totalProgress = totalSize === 0 ? 0 : Math.round(uploadedSize / totalSize * 100);
        // hot fix, because:
        // uploadedSize ended up larger than totalSize, resulting in 1325% total
        if (totalProgress > 100) totalProgress = 100;
        this.setState({
            totalProgress: totalProgress
        });
        this.emit("progress", totalProgress);
    }
    updateOnlineStatus() {
        var _window$navigator$onL;
        const online = (_window$navigator$onL = window.navigator.onLine) != null ? _window$navigator$onL : true;
        if (!online) {
            this.emit("is-offline");
            this.info(this.i18n("noInternetConnection"), "error", 0);
            this.wasOffline = true;
        } else {
            this.emit("is-online");
            if (this.wasOffline) {
                this.emit("back-online");
                this.info(this.i18n("connectedToInternet"), "success", 3000);
                this.wasOffline = false;
            }
        }
    }
    getID() {
        return this.opts.id;
    }
    /**
   * Registers a plugin with Core.
   */ use(Plugin, opts) {
        if (typeof Plugin !== "function") {
            const msg = `Expected a plugin class, but got ${Plugin === null ? "null" : typeof Plugin}.` + " Please verify that the plugin was imported and spelled correctly.";
            throw new TypeError(msg);
        }
        // Instantiate
        const plugin = new Plugin(this, opts);
        const pluginId = plugin.id;
        if (!pluginId) throw new Error("Your plugin must have an id");
        if (!plugin.type) throw new Error("Your plugin must have a type");
        const existsPluginAlready = this.getPlugin(pluginId);
        if (existsPluginAlready) {
            const msg = `Already found a plugin named '${existsPluginAlready.id}'. ` + `Tried to use: '${pluginId}'.\n` + "Uppy plugins must have unique `id` options. See https://uppy.io/docs/plugins/#id.";
            throw new Error(msg);
        }
        // @ts-expect-error does exist
        if (Plugin.VERSION) // @ts-expect-error does exist
        this.log(`Using ${pluginId} v${Plugin.VERSION}`);
        if (plugin.type in $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][plugin.type].push(plugin);
        else $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][plugin.type] = [
            plugin
        ];
        plugin.install();
        this.emit("plugin-added", plugin);
        return this;
    }
    /**
   * Find one Plugin by name.
   */ getPlugin(id) {
        for (const plugins of Object.values($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins])){
            const foundPlugin = plugins.find((plugin)=>plugin.id === id);
            if (foundPlugin != null) return foundPlugin;
        }
        return undefined;
    }
    [$b16b91c7840d3bff$var$_Symbol$for](type) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][type];
    }
    /**
   * Iterate through all `use`d plugins.
   *
   */ iteratePlugins(method) {
        Object.values($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]).flat(1).forEach(method);
    }
    /**
   * Uninstall and remove a plugin.
   *
   * @param {object} instance The plugin instance to remove.
   */ removePlugin(instance) {
        this.log(`Removing plugin ${instance.id}`);
        this.emit("plugin-remove", instance);
        if (instance.uninstall) instance.uninstall();
        const list = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][instance.type];
        // list.indexOf failed here, because Vue3 converted the plugin instance
        // to a Proxy object, which failed the strict comparison test:
        // obj !== objProxy
        const index = list.findIndex((item)=>item.id === instance.id);
        if (index !== -1) list.splice(index, 1);
        const state = this.getState();
        const updatedState = {
            plugins: {
                ...state.plugins,
                [instance.id]: undefined
            }
        };
        this.setState(updatedState);
    }
    /**
   * Uninstall all plugins and close down this Uppy instance.
   */ // @todo next major: rename to `destroy`.
    // Cancel local uploads, cancel remote uploads, DON'T cancel assemblies
    // document that if you do want to cancel assemblies, you need to call smth manually.
    // Potentially remove reason, as it’s confusing, just come up with a default behaviour.
    close(_temp2) {
        let { reason: reason } = _temp2 === void 0 ? {} : _temp2;
        this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`);
        this.cancelAll({
            reason: reason
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_storeUnsubscribe)[$b16b91c7840d3bff$var$_storeUnsubscribe]();
        this.iteratePlugins((plugin)=>{
            this.removePlugin(plugin);
        });
        if (typeof window !== "undefined" && window.removeEventListener) {
            window.removeEventListener("online", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
            window.removeEventListener("offline", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        }
    }
    hideInfo() {
        const { info: info } = this.getState();
        this.setState({
            info: info.slice(1)
        });
        this.emit("info-hidden");
    }
    /**
   * Set info message in `state.info`, so that UI plugins like `Informer`
   * can display the message.
   */ info(message, type, duration) {
        if (type === void 0) type = "info";
        if (duration === void 0) duration = 3000;
        const isComplexMessage = typeof message === "object";
        this.setState({
            info: [
                ...this.getState().info,
                {
                    type: type,
                    message: isComplexMessage ? message.message : message,
                    details: isComplexMessage ? message.details : null
                }
            ]
        });
        setTimeout(()=>this.hideInfo(), duration);
        this.emit("info-visible");
    }
    /**
   * Passes messages to a function, provided in `opts.logger`.
   * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
   */ log(message, type) {
        const { logger: logger } = this.opts;
        switch(type){
            case "error":
                logger.error(message);
                break;
            case "warning":
                logger.warn(message);
                break;
            default:
                logger.debug(message);
                break;
        }
    }
    registerRequestClient(id, client) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_requestClientById)[$b16b91c7840d3bff$var$_requestClientById].set(id, client);
    }
    /** @protected */ getRequestClientForFile(file) {
        if (!file.remote) throw new Error(`Tried to get RequestClient for a non-remote file ${file.id}`);
        const requestClient = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_requestClientById)[$b16b91c7840d3bff$var$_requestClientById].get(file.remote.requestClientId);
        if (requestClient == null) throw new Error(`requestClientId "${file.remote.requestClientId}" not registered for file "${file.id}"`);
        return requestClient;
    }
    /**
   * Restore an upload by its ID.
   */ restore(uploadID) {
        this.log(`Core: attempting to restore upload "${uploadID}"`);
        if (!this.getState().currentUploads[uploadID]) {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
            return Promise.reject(new Error("Nonexistent upload"));
        }
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
    }
    [$b16b91c7840d3bff$var$_Symbol$for2]() {
        // @ts-expect-error https://github.com/microsoft/TypeScript/issues/47595
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](...arguments);
    }
    /**
   * Add data to an upload's result object.
   */ addResultData(uploadID, data) {
        if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_getUpload)[$b16b91c7840d3bff$var$_getUpload](uploadID)) {
            this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
            return;
        }
        const { currentUploads: currentUploads } = this.getState();
        const currentUpload = {
            ...currentUploads[uploadID],
            result: {
                ...currentUploads[uploadID].result,
                ...data
            }
        };
        this.setState({
            currentUploads: {
                ...currentUploads,
                [uploadID]: currentUpload
            }
        });
    }
    /**
   * Start an upload for all the files that are not currently being uploaded.
   */ upload() {
        var _classPrivateFieldLoo;
        if (!((_classPrivateFieldLoo = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]["uploader"]) != null && _classPrivateFieldLoo.length)) this.log("No uploader type plugins are used", "warning");
        let { files: files } = this.getState();
        const onBeforeUploadResult = this.opts.onBeforeUpload(files);
        if (onBeforeUploadResult === false) return Promise.reject(new Error("Not starting the upload because onBeforeUpload returned false"));
        if (onBeforeUploadResult && typeof onBeforeUploadResult === "object") {
            files = onBeforeUploadResult;
            // Updating files in state, because uploader plugins receive file IDs,
            // and then fetch the actual file object from state
            this.setState({
                files: files
            });
        }
        return Promise.resolve().then(()=>$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateMinNumberOfFiles(files)).catch((err)=>{
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
                err
            ]);
            throw err;
        }).then(()=>{
            if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFields)[$b16b91c7840d3bff$var$_checkRequiredMetaFields](files)) throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n("missingRequiredMetaField"));
        }).catch((err)=>{
            // Doing this in a separate catch because we already emited and logged
            // all the errors in `checkRequiredMetaFields` so we only throw a generic
            // missing fields error here.
            throw err;
        }).then(()=>{
            const { currentUploads: currentUploads } = this.getState();
            // get a list of files that are currently assigned to uploads
            const currentlyUploadingFiles = Object.values(currentUploads).flatMap((curr)=>curr.fileIDs);
            const waitingFileIDs = [];
            Object.keys(files).forEach((fileID)=>{
                const file = this.getFile(fileID);
                // if the file hasn't started uploading and hasn't already been assigned to an upload..
                if (!file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1) waitingFileIDs.push(file.id);
            });
            const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](waitingFileIDs);
            return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
        }).catch((err)=>{
            this.emit("error", err);
            this.log(err, "error");
            throw err;
        });
    }
}
function $b16b91c7840d3bff$var$_informAndEmit2(errors) {
    for (const error of errors){
        if (error.isRestriction) this.emit("restriction-failed", error.file, error);
        else this.emit("error", error, error.file);
        this.log(error, "warning");
    }
    const userFacingErrors = errors.filter((error)=>error.isUserFacing);
    // don't flood the user: only show the first 4 toasts
    const maxNumToShow = 4;
    const firstErrors = userFacingErrors.slice(0, maxNumToShow);
    const additionalErrors = userFacingErrors.slice(maxNumToShow);
    firstErrors.forEach((_ref3)=>{
        let { message: message, details: details = "" } = _ref3;
        this.info({
            message: message,
            details: details
        }, "error", this.opts.infoTimeout);
    });
    if (additionalErrors.length > 0) this.info({
        message: this.i18n("additionalRestrictionsFailed", {
            count: additionalErrors.length
        })
    });
}
function $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile2(file) {
    const { missingFields: missingFields, error: error } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].getMissingRequiredMetaFields(file);
    if (missingFields.length > 0) {
        this.setFileState(file.id, {
            missingRequiredMetaFields: missingFields
        });
        this.log(error.message);
        this.emit("restriction-failed", file, error);
        return false;
    }
    return true;
}
function $b16b91c7840d3bff$var$_checkRequiredMetaFields2(files) {
    let success = true;
    for (const file of Object.values(files))if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile)[$b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile](file)) success = false;
    return success;
}
function $b16b91c7840d3bff$var$_assertNewUploadAllowed2(file) {
    const { allowNewUpload: allowNewUpload } = this.getState();
    if (allowNewUpload === false) {
        const error = new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n("noMoreFilesAllowed"), {
            file: file
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
            error
        ]);
        throw error;
    }
}
function $b16b91c7840d3bff$var$_transformFile2(fileDescriptorOrFile) {
    // Uppy expects files in { name, type, size, data } format.
    // If the actual File object is passed from input[type=file] or drag-drop,
    // we normalize it to match Uppy file object
    const file = fileDescriptorOrFile instanceof File ? {
        name: fileDescriptorOrFile.name,
        type: fileDescriptorOrFile.type,
        size: fileDescriptorOrFile.size,
        data: fileDescriptorOrFile
    } : fileDescriptorOrFile;
    const fileType = (0, $d70a5ddc0e61f36b$export$2e2bcd8739ae039)(file);
    const fileName = (0, $77bbd1edc6b4e0f3$export$2e2bcd8739ae039)(fileType, file);
    const fileExtension = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(fileName).extension;
    const id = (0, $d67267bb9859462b$export$2ff5b23440673856)(file);
    const meta = file.meta || {};
    meta.name = fileName;
    meta.type = fileType;
    // `null` means the size is unknown.
    const size = Number.isFinite(file.data.size) ? file.data.size : null;
    return {
        source: file.source || "",
        id: id,
        name: fileName,
        extension: fileExtension || "",
        meta: {
            ...this.getState().meta,
            ...meta
        },
        type: fileType,
        data: file.data,
        progress: {
            percentage: 0,
            bytesUploaded: 0,
            bytesTotal: size,
            uploadComplete: false,
            uploadStarted: null
        },
        size: size,
        isGhost: false,
        isRemote: file.isRemote || false,
        // TODO: this should not be a string
        // @ts-expect-error wrong
        remote: file.remote || "",
        preview: file.preview
    };
}
function $b16b91c7840d3bff$var$_startIfAutoProceed2() {
    if (this.opts.autoProceed && !this.scheduledAutoProceed) this.scheduledAutoProceed = setTimeout(()=>{
        this.scheduledAutoProceed = null;
        this.upload().catch((err)=>{
            if (!err.isRestriction) this.log(err.stack || err.message || err);
        });
    }, 4);
}
function $b16b91c7840d3bff$var$_checkAndUpdateFileState2(filesToAdd) {
    const { files: existingFiles } = this.getState();
    // create a copy of the files object only once
    const nextFilesState = {
        ...existingFiles
    };
    const validFilesToAdd = [];
    const errors = [];
    for (const fileToAdd of filesToAdd)try {
        var _existingFiles$newFil;
        let newFile = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_transformFile)[$b16b91c7840d3bff$var$_transformFile](fileToAdd);
        // If a file has been recovered (Golden Retriever), but we were unable to recover its data (probably too large),
        // users are asked to re-select these half-recovered files and then this method will be called again.
        // In order to keep the progress, meta and everything else, we keep the existing file,
        // but we replace `data`, and we remove `isGhost`, because the file is no longer a ghost now
        const isGhost = (_existingFiles$newFil = existingFiles[newFile.id]) == null ? void 0 : _existingFiles$newFil.isGhost;
        if (isGhost) {
            const existingFileState = existingFiles[newFile.id];
            newFile = {
                ...existingFileState,
                isGhost: false,
                data: fileToAdd.data
            };
            this.log(`Replaced the blob in the restored ghost file: ${newFile.name}, ${newFile.id}`);
        }
        const onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, nextFilesState);
        if (!onBeforeFileAddedResult && this.checkIfFileAlreadyExists(newFile.id)) throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n("noDuplicates", {
            fileName: newFile.name
        }), {
            file: fileToAdd
        });
        // Pass through reselected files from Golden Retriever
        if (onBeforeFileAddedResult === false && !isGhost) // Don’t show UI info for this error, as it should be done by the developer
        throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)("Cannot add the file because onBeforeFileAdded returned false.", {
            isUserFacing: false,
            file: fileToAdd
        });
        else if (typeof onBeforeFileAddedResult === "object" && onBeforeFileAddedResult !== null) newFile = onBeforeFileAddedResult;
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateSingleFile(newFile);
        // need to add it to the new local state immediately, so we can use the state to validate the next files too
        nextFilesState[newFile.id] = newFile;
        validFilesToAdd.push(newFile);
    } catch (err) {
        errors.push(err);
    }
    try {
        // need to run this separately because it's much more slow, so if we run it inside the for-loop it will be very slow
        // when many files are added
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateAggregateRestrictions(Object.values(existingFiles), validFilesToAdd);
    } catch (err) {
        errors.push(err);
        // If we have any aggregate error, don't allow adding this batch
        return {
            nextFilesState: existingFiles,
            validFilesToAdd: [],
            errors: errors
        };
    }
    return {
        nextFilesState: nextFilesState,
        validFilesToAdd: validFilesToAdd,
        errors: errors
    };
}
function $b16b91c7840d3bff$var$_addListeners2() {
    // Type inference only works for inline functions so we have to type it again
    const errorHandler = (error, file, response)=>{
        let errorMsg = error.message || "Unknown error";
        if (error.details) errorMsg += ` ${error.details}`;
        this.setState({
            error: errorMsg
        });
        if (file != null && file.id in this.getState().files) this.setFileState(file.id, {
            error: errorMsg,
            response: response
        });
    };
    this.on("error", errorHandler);
    this.on("upload-error", (file, error, response)=>{
        errorHandler(error, file, response);
        if (typeof error === "object" && error.message) {
            var _file$name;
            this.log(error.message, "error");
            const newError = new Error(this.i18n("failedToUpload", {
                file: (_file$name = file == null ? void 0 : file.name) != null ? _file$name : ""
            })); // we may want a new custom error here
            newError.isUserFacing = true; // todo maybe don't do this with all errors?
            newError.details = error.message;
            if (error.details) newError.details += ` ${error.details}`;
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
                newError
            ]);
        } else $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
            error
        ]);
    });
    let uploadStalledWarningRecentlyEmitted = null;
    this.on("upload-stalled", (error, files)=>{
        const { message: message } = error;
        const details = files.map((file)=>file.meta.name).join(", ");
        if (!uploadStalledWarningRecentlyEmitted) {
            this.info({
                message: message,
                details: details
            }, "warning", this.opts.infoTimeout);
            uploadStalledWarningRecentlyEmitted = setTimeout(()=>{
                uploadStalledWarningRecentlyEmitted = null;
            }, this.opts.infoTimeout);
        }
        this.log(`${message} ${details}`.trim(), "warning");
    });
    this.on("upload", ()=>{
        this.setState({
            error: null
        });
    });
    const onUploadStarted = (files)=>{
        const filesFiltered = files.filter((file)=>{
            const exists = file != null && this.getFile(file.id);
            if (!exists) this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return exists;
        });
        const filesState = Object.fromEntries(filesFiltered.map((file)=>[
                file.id,
                {
                    progress: {
                        uploadStarted: Date.now(),
                        uploadComplete: false,
                        percentage: 0,
                        bytesUploaded: 0,
                        bytesTotal: file.size
                    }
                }
            ]));
        this.patchFilesState(filesState);
    };
    this.on("upload-start", (files)=>{
        files.forEach((file)=>{
            // todo backward compat, remove this event in a next major
            this.emit("upload-started", file);
        });
        onUploadStarted(files);
    });
    this.on("upload-progress", this.calculateProgress);
    this.on("upload-success", (file, uploadResp)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const currentProgress = this.getFile(file.id).progress;
        this.setFileState(file.id, {
            progress: {
                ...currentProgress,
                postprocess: $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].size > 0 ? {
                    mode: "indeterminate"
                } : undefined,
                uploadComplete: true,
                percentage: 100,
                bytesUploaded: currentProgress.bytesTotal
            },
            response: uploadResp,
            uploadURL: uploadResp.uploadURL,
            isPaused: false
        });
        // Remote providers sometimes don't tell us the file size,
        // but we can know how many bytes we uploaded once the upload is complete.
        if (file.size == null) this.setFileState(file.id, {
            size: uploadResp.bytesUploaded || currentProgress.bytesTotal
        });
        this.calculateTotalProgress();
    });
    this.on("preprocess-progress", (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getFile(file.id).progress,
                preprocess: progress
            }
        });
    });
    this.on("preprocess-complete", (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.preprocess;
        this.setState({
            files: files
        });
    });
    this.on("postprocess-progress", (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getState().files[file.id].progress,
                postprocess: progress
            }
        });
    });
    this.on("postprocess-complete", (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.postprocess;
        this.setState({
            files: files
        });
    });
    this.on("restored", ()=>{
        // Files may have changed--ensure progress is still accurate.
        this.calculateTotalProgress();
    });
    // @ts-expect-error should fix itself when dashboard it typed (also this doesn't belong here)
    this.on("dashboard:file-edit-complete", (file)=>{
        if (file) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile)[$b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile](file);
    });
    // show informer if offline
    if (typeof window !== "undefined" && window.addEventListener) {
        window.addEventListener("online", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        window.addEventListener("offline", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        setTimeout($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus], 3000);
    }
}
function $b16b91c7840d3bff$var$_createUpload2(fileIDs, opts) {
    if (opts === void 0) opts = {};
    // uppy.retryAll sets this to true — when retrying we want to ignore `allowNewUpload: false`
    const { forceAllowNewUpload: forceAllowNewUpload = false } = opts;
    const { allowNewUpload: allowNewUpload, currentUploads: currentUploads } = this.getState();
    if (!allowNewUpload && !forceAllowNewUpload) throw new Error("Cannot create a new upload: already uploading.");
    const uploadID = (0, $3c82c89e950acc97$export$ac4959f4f1338dfc)();
    this.emit("upload", {
        id: uploadID,
        fileIDs: fileIDs
    });
    this.setState({
        allowNewUpload: this.opts.allowMultipleUploadBatches !== false && this.opts.allowMultipleUploads !== false,
        currentUploads: {
            ...currentUploads,
            [uploadID]: {
                fileIDs: fileIDs,
                step: 0,
                result: {}
            }
        }
    });
    return uploadID;
}
function $b16b91c7840d3bff$var$_getUpload2(uploadID) {
    const { currentUploads: currentUploads } = this.getState();
    return currentUploads[uploadID];
}
function $b16b91c7840d3bff$var$_removeUpload2(uploadID) {
    const currentUploads = {
        ...this.getState().currentUploads
    };
    delete currentUploads[uploadID];
    this.setState({
        currentUploads: currentUploads
    });
}
async function $b16b91c7840d3bff$var$_runUpload2(uploadID) {
    const getCurrentUpload = ()=>{
        const { currentUploads: currentUploads } = this.getState();
        return currentUploads[uploadID];
    };
    let currentUpload = getCurrentUpload();
    const steps = [
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors],
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders],
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors]
    ];
    try {
        for(let step = currentUpload.step || 0; step < steps.length; step++){
            if (!currentUpload) break;
            const fn = steps[step];
            this.setState({
                currentUploads: {
                    ...this.getState().currentUploads,
                    [uploadID]: {
                        ...currentUpload,
                        step: step
                    }
                }
            });
            const { fileIDs: fileIDs } = currentUpload;
            // TODO give this the `updatedUpload` object as its only parameter maybe?
            // Otherwise when more metadata may be added to the upload this would keep getting more parameters
            await fn(fileIDs, uploadID);
            // Update currentUpload value in case it was modified asynchronously.
            currentUpload = getCurrentUpload();
        }
    } catch (err) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
        throw err;
    }
    // Set result data.
    if (currentUpload) {
        // Mark postprocessing step as complete if necessary; this addresses a case where we might get
        // stuck in the postprocessing UI while the upload is fully complete.
        // If the postprocessing steps do not do any work, they may not emit postprocessing events at
        // all, and never mark the postprocessing as complete. This is fine on its own but we
        // introduced code in the @uppy/core upload-success handler to prepare postprocessing progress
        // state if any postprocessors are registered. That is to avoid a "flash of completed state"
        // before the postprocessing plugins can emit events.
        //
        // So, just in case an upload with postprocessing plugins *has* completed *without* emitting
        // postprocessing completion, we do it instead.
        currentUpload.fileIDs.forEach((fileID)=>{
            const file = this.getFile(fileID);
            if (file && file.progress.postprocess) this.emit("postprocess-complete", file);
        });
        const files = currentUpload.fileIDs.map((fileID)=>this.getFile(fileID));
        const successful = files.filter((file)=>!file.error);
        const failed = files.filter((file)=>file.error);
        this.addResultData(uploadID, {
            successful: successful,
            failed: failed,
            uploadID: uploadID
        });
        // Update currentUpload value in case it was modified asynchronously.
        currentUpload = getCurrentUpload();
    }
    // Emit completion events.
    // This is in a separate function so that the `currentUploads` variable
    // always refers to the latest state. In the handler right above it refers
    // to an outdated object without the `.result` property.
    let result;
    if (currentUpload) {
        result = currentUpload.result;
        this.emit("complete", result);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
    }
    if (result == null) this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
    return result;
}
$b16b91c7840d3bff$export$1c95bea2669f592b.VERSION = $b16b91c7840d3bff$var$packageJson.version;
var $b16b91c7840d3bff$export$2e2bcd8739ae039 = $b16b91c7840d3bff$export$1c95bea2669f592b;


var $4d2e93495e50cc85$var$n, $4d2e93495e50cc85$export$41c562ebe57d11e2, $4d2e93495e50cc85$var$u, $4d2e93495e50cc85$export$a8257692ac88316c, $4d2e93495e50cc85$var$i, $4d2e93495e50cc85$var$o, $4d2e93495e50cc85$var$r, $4d2e93495e50cc85$var$f, $4d2e93495e50cc85$var$e, $4d2e93495e50cc85$var$c = {}, $4d2e93495e50cc85$var$s = [], $4d2e93495e50cc85$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $4d2e93495e50cc85$var$h = Array.isArray;
function $4d2e93495e50cc85$var$v(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $4d2e93495e50cc85$var$p(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $4d2e93495e50cc85$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $4d2e93495e50cc85$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $4d2e93495e50cc85$var$d(l, f, i, o, null);
}
function $4d2e93495e50cc85$var$d(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$4d2e93495e50cc85$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode && $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode(f), f;
}
function $4d2e93495e50cc85$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $4d2e93495e50cc85$export$ffb0004e005737fa(n) {
    return n.children;
}
function $4d2e93495e50cc85$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $4d2e93495e50cc85$var$m(n, l) {
    if (null == l) return n.__ ? $4d2e93495e50cc85$var$m(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $4d2e93495e50cc85$var$m(n) : null;
}
function $4d2e93495e50cc85$var$w(n, u, t) {
    var i, o = n.__v, r = o.__e, f = n.__P;
    if (f) return (i = $4d2e93495e50cc85$var$v({}, o)).__v = o.__v + 1, $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode && $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode(i), $4d2e93495e50cc85$var$M(f, i, o, n.__n, void 0 !== f.ownerSVGElement, 32 & o.__u ? [
        r
    ] : null, u, null == r ? $4d2e93495e50cc85$var$m(o) : r, !!(32 & o.__u), t), i.__v = o.__v, i.__.__k[i.__i] = i, i.__d = void 0, i.__e != r && $4d2e93495e50cc85$var$k(i), i;
}
function $4d2e93495e50cc85$var$k(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $4d2e93495e50cc85$var$k(n);
    }
}
function $4d2e93495e50cc85$var$x(n) {
    (!n.__d && (n.__d = !0) && $4d2e93495e50cc85$var$i.push(n) && !$4d2e93495e50cc85$var$C.__r++ || $4d2e93495e50cc85$var$o !== $4d2e93495e50cc85$export$41c562ebe57d11e2.debounceRendering) && (($4d2e93495e50cc85$var$o = $4d2e93495e50cc85$export$41c562ebe57d11e2.debounceRendering) || $4d2e93495e50cc85$var$r)($4d2e93495e50cc85$var$C);
}
function $4d2e93495e50cc85$var$C() {
    var n, u, t, o = [], r = [];
    for($4d2e93495e50cc85$var$i.sort($4d2e93495e50cc85$var$f); n = $4d2e93495e50cc85$var$i.shift();)n.__d && (t = $4d2e93495e50cc85$var$i.length, u = $4d2e93495e50cc85$var$w(n, o, r) || u, 0 === t || $4d2e93495e50cc85$var$i.length > t ? ($4d2e93495e50cc85$var$j(o, u, r), r.length = o.length = 0, u = void 0, $4d2e93495e50cc85$var$i.sort($4d2e93495e50cc85$var$f)) : u && $4d2e93495e50cc85$export$41c562ebe57d11e2.__c && $4d2e93495e50cc85$export$41c562ebe57d11e2.__c(u, $4d2e93495e50cc85$var$s));
    u && $4d2e93495e50cc85$var$j(o, u, r), $4d2e93495e50cc85$var$C.__r = 0;
}
function $4d2e93495e50cc85$var$P(n, l, u, t, i, o, r, f, e, a, h) {
    var v, p, y, d, _, g = t && t.__k || $4d2e93495e50cc85$var$s, b = l.length;
    for(u.__d = e, $4d2e93495e50cc85$var$S(u, l, g), e = u.__d, v = 0; v < b; v++)null != (y = u.__k[v]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $4d2e93495e50cc85$var$c : g[y.__i] || $4d2e93495e50cc85$var$c, y.__i = v, $4d2e93495e50cc85$var$M(n, y, p, i, o, r, f, e, a, h), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $4d2e93495e50cc85$var$N(p.ref, null, y), h.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? e = $4d2e93495e50cc85$var$$(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $4d2e93495e50cc85$var$S(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $4d2e93495e50cc85$var$d(null, i, null, null, i) : $4d2e93495e50cc85$var$h(i) ? $4d2e93495e50cc85$var$d($4d2e93495e50cc85$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $4d2e93495e50cc85$var$d(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $4d2e93495e50cc85$var$I(i, u, r = t + a, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : a = f < r && f == r - 1 ? f - r : 0, f !== t + a && (i.__u |= 65536))) : (o = u[t]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $4d2e93495e50cc85$var$m(o)), $4d2e93495e50cc85$var$O(o, o, !1), u[t] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $4d2e93495e50cc85$var$m(o)), $4d2e93495e50cc85$var$O(o, o));
}
function $4d2e93495e50cc85$var$$(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $4d2e93495e50cc85$var$$(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $4d2e93495e50cc85$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($4d2e93495e50cc85$var$h(n) ? n.some(function(n) {
        $4d2e93495e50cc85$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $4d2e93495e50cc85$var$I(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $4d2e93495e50cc85$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $4d2e93495e50cc85$var$a.test(l) ? u : u + "px";
}
function $4d2e93495e50cc85$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $4d2e93495e50cc85$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $4d2e93495e50cc85$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? $4d2e93495e50cc85$var$L : $4d2e93495e50cc85$var$D, o)) : n.removeEventListener(l, o ? $4d2e93495e50cc85$var$L : $4d2e93495e50cc85$var$D, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $4d2e93495e50cc85$var$D(n) {
    if (this.l) {
        var u = this.l[n.type + !1];
        if (n.t) {
            if (n.t <= u.u) return;
        } else n.t = Date.now();
        return u($4d2e93495e50cc85$export$41c562ebe57d11e2.event ? $4d2e93495e50cc85$export$41c562ebe57d11e2.event(n) : n);
    }
}
function $4d2e93495e50cc85$var$L(n) {
    if (this.l) return this.l[n.type + !0]($4d2e93495e50cc85$export$41c562ebe57d11e2.event ? $4d2e93495e50cc85$export$41c562ebe57d11e2.event(n) : n);
}
function $4d2e93495e50cc85$var$M(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, m, w, k, x, C, S, $, H, I, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $4d2e93495e50cc85$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (k = u.props, x = (a = A.contextType) && i[a.__c], C = a ? x ? x.props.value : a.__ : i, t.__c ? w = (p = u.__c = t.__c).__ = p.__E : ("prototype" in A && A.prototype.render ? u.__c = p = new A(k, C) : (u.__c = p = new $4d2e93495e50cc85$export$16fa2f45be04daa8(k, C), p.constructor = A, p.render = $4d2e93495e50cc85$var$q), x && x.sub(p), p.props = k, p.state || (p.state = {}), p.context = C, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != A.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $4d2e93495e50cc85$var$v({}, p.__s)), $4d2e93495e50cc85$var$v(p.__s, A.getDerivedStateFromProps(k, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == A.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && k !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(k, C), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(k, p.__s, C) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = k, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), S = 0; S < p._sb.length; S++)p.__h.push(p._sb[S]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(k, p.__s, C), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, m);
            });
        }
        if (p.context = C, p.props = k, p.__P = n, p.__e = !1, $ = $4d2e93495e50cc85$export$41c562ebe57d11e2.__r, H = 0, "prototype" in A && A.prototype.render) {
            for(p.state = p.__s, p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), I = 0; I < p._sb.length; I++)p.__h.push(p._sb[I]);
            p._sb = [];
        } else do p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++H < 25);
        p.state = p.__s, null != p.getChildContext && (i = $4d2e93495e50cc85$var$v($4d2e93495e50cc85$var$v({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (m = p.getSnapshotBeforeUpdate(d, _)), $4d2e93495e50cc85$var$P(n, $4d2e93495e50cc85$var$h(T = null != a && a.type === $4d2e93495e50cc85$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__u &= -161, p.__h.length && f.push(p), w && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $4d2e93495e50cc85$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $4d2e93495e50cc85$export$41c562ebe57d11e2.diffed) && a(u);
}
function $4d2e93495e50cc85$var$j(n, u, t) {
    for(var i = 0; i < t.length; i++)$4d2e93495e50cc85$var$N(t[i], t[++i], t[++i]);
    $4d2e93495e50cc85$export$41c562ebe57d11e2.__c && $4d2e93495e50cc85$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $4d2e93495e50cc85$var$z(l, u, t, i, o, r, f, e, s) {
    var a, v, y, d, _, g, b, w = t.props, k = u.props, x = u.type;
    if ("svg" === x && (o = !0), null != r) {
        for(a = 0; a < r.length; a++)if ((_ = r[a]) && "setAttribute" in _ == !!x && (x ? _.localName === x : 3 === _.nodeType)) {
            l = _, r[a] = null;
            break;
        }
    }
    if (null == l) {
        if (null === x) return document.createTextNode(k);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, k.is && k), r = null, e = !1;
    }
    if (null === x) w === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && $4d2e93495e50cc85$var$n.call(l.childNodes), w = t.props || $4d2e93495e50cc85$var$c, !e && null != r) for(w = {}, a = 0; a < l.attributes.length; a++)w[(_ = l.attributes[a]).name] = _.value;
        for(a in w)_ = w[a], "children" == a || ("dangerouslySetInnerHTML" == a ? y = _ : "key" === a || a in k || $4d2e93495e50cc85$var$A(l, a, null, _, o));
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? b = _ : "key" === a || e && "function" != typeof _ || w[a] === _ || $4d2e93495e50cc85$var$A(l, a, _, w[a], o);
        if (v) e || y && (v.__html === y.__html || v.__html === l.innerHTML) || (l.innerHTML = v.__html), u.__k = [];
        else if (y && (l.innerHTML = ""), $4d2e93495e50cc85$var$P(l, $4d2e93495e50cc85$var$h(d) ? d : [
            d
        ], u, t, i, o && "foreignObject" !== x, r, f, r ? r[0] : t.__k && $4d2e93495e50cc85$var$m(t, 0), e, s), null != r) for(a = r.length; a--;)null != r[a] && $4d2e93495e50cc85$var$p(r[a]);
        e || (a = "value", void 0 !== g && (g !== l[a] || "progress" === x && !g || "option" === x && g !== w[a]) && $4d2e93495e50cc85$var$A(l, a, g, w[a], !1), a = "checked", void 0 !== b && b !== l[a] && $4d2e93495e50cc85$var$A(l, a, b, w[a], !1));
    }
    return l;
}
function $4d2e93495e50cc85$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $4d2e93495e50cc85$var$O(n, u, t) {
    var i, o;
    if ($4d2e93495e50cc85$export$41c562ebe57d11e2.unmount && $4d2e93495e50cc85$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $4d2e93495e50cc85$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $4d2e93495e50cc85$var$O(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $4d2e93495e50cc85$var$p(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $4d2e93495e50cc85$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $4d2e93495e50cc85$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $4d2e93495e50cc85$export$41c562ebe57d11e2.__ && $4d2e93495e50cc85$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $4d2e93495e50cc85$var$M(t, u = (!o && i || t).__k = $4d2e93495e50cc85$export$c8a8987d4410bf2d($4d2e93495e50cc85$export$ffb0004e005737fa, null, [
        u
    ]), r || $4d2e93495e50cc85$var$c, $4d2e93495e50cc85$var$c, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $4d2e93495e50cc85$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), u.__d = void 0, $4d2e93495e50cc85$var$j(f, u, e);
}
function $4d2e93495e50cc85$export$fa8d919ba61d84db(n, l) {
    $4d2e93495e50cc85$export$b3890eb0ae9dca99(n, l, $4d2e93495e50cc85$export$fa8d919ba61d84db);
}
function $4d2e93495e50cc85$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $4d2e93495e50cc85$var$v({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $4d2e93495e50cc85$var$n.call(arguments, 2) : t), $4d2e93495e50cc85$var$d(l.type, e, i || l.key, o || l.ref, null);
}
function $4d2e93495e50cc85$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $4d2e93495e50cc85$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $4d2e93495e50cc85$var$x(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$4d2e93495e50cc85$var$n = $4d2e93495e50cc85$var$s.slice, $4d2e93495e50cc85$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $4d2e93495e50cc85$var$u = 0, $4d2e93495e50cc85$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $4d2e93495e50cc85$var$v({}, this.state), "function" == typeof n && (n = n($4d2e93495e50cc85$var$v({}, u), this.props)), n && $4d2e93495e50cc85$var$v(u, n), null != n && this.__v && (l && this._sb.push(l), $4d2e93495e50cc85$var$x(this));
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $4d2e93495e50cc85$var$x(this));
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.render = $4d2e93495e50cc85$export$ffb0004e005737fa, $4d2e93495e50cc85$var$i = [], $4d2e93495e50cc85$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $4d2e93495e50cc85$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $4d2e93495e50cc85$var$C.__r = 0, $4d2e93495e50cc85$var$e = 0;


/**
 * Check if an object is a DOM element. Duck-typing based on `nodeType`.
 */ function $dcdea5a9bf8353ff$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    if (!("nodeType" in obj)) return false;
    return obj.nodeType === Node.ELEMENT_NODE;
}


function $1866f8238923bb5d$var$findDOMElement(element, context) {
    if (context === void 0) context = document;
    if (typeof element === "string") return context.querySelector(element);
    if ((0, $dcdea5a9bf8353ff$export$2e2bcd8739ae039)(element)) return element;
    return null;
}
var $1866f8238923bb5d$export$2e2bcd8739ae039 = $1866f8238923bb5d$var$findDOMElement;


/**
 * Get the declared text direction for an element.
 */ function $82cce0c04a5d7a26$var$getTextDirection(element) {
    var _element;
    // There is another way to determine text direction using getComputedStyle(), as done here:
    // https://github.com/pencil-js/text-direction/blob/2a235ce95089b3185acec3b51313cbba921b3811/text-direction.js
    //
    // We do not use that approach because we are interested specifically in the _declared_ text direction.
    // If no text direction is declared, we have to provide our own explicit text direction so our
    // bidirectional CSS style sheets work.
    while(element && !element.dir)// eslint-disable-next-line no-param-reassign
    element = element.parentNode;
    return (_element = element) == null ? void 0 : _element.dir;
}
var $82cce0c04a5d7a26$export$2e2bcd8739ae039 = $82cce0c04a5d7a26$var$getTextDirection;


/* eslint-disable class-methods-use-this */ /**
 * Core plugin logic that all plugins share.
 *
 * BasePlugin does not contain DOM rendering so it can be used for plugins
 * without a user interface.
 *
 * See `Plugin` for the extended version with Preact rendering for interfaces.
 */ 
class $336df15d01030489$export$2e2bcd8739ae039 {
    constructor(uppy, opts){
        this.uppy = uppy;
        this.opts = opts != null ? opts : {};
    }
    getPluginState() {
        const { plugins: plugins } = this.uppy.getState();
        return (plugins == null ? void 0 : plugins[this.id]) || {};
    }
    setPluginState(update) {
        const { plugins: plugins } = this.uppy.getState();
        this.uppy.setState({
            plugins: {
                ...plugins,
                [this.id]: {
                    ...plugins[this.id],
                    ...update
                }
            }
        });
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts
        };
        this.setPluginState(undefined); // so that UI re-renders with new options
        this.i18nInit();
    }
    i18nInit() {
        const translator = new (0, $a85fd1efd23057e0$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.uppy.locale,
            this.opts.locale
        ]);
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.setPluginState(undefined); // so that UI re-renders and we see the updated locale
    }
    /**
   * Extendable methods
   * ==================
   * These methods are here to serve as an overview of the extendable methods as well as
   * making them not conditional in use, such as `if (this.afterUpdate)`.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addTarget(plugin) {
        throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
    }
    install() {}
    uninstall() {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    update(state) {}
    // Called after every state update, after everything's mounted. Debounced.
    afterUpdate() {}
}


function $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $5d08dd66a9cc6899$var$id = 0;
function $5d08dd66a9cc6899$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $5d08dd66a9cc6899$var$id++ + "_" + name;
}
/**
 * Defer a frequent call to the microtask queue.
 */ function $5d08dd66a9cc6899$var$debounce(fn) {
    let calling = null;
    let latestArgs;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        latestArgs = args;
        if (!calling) calling = Promise.resolve().then(()=>{
            calling = null;
            // At this point `args` may be different from the most
            // recent state, if multiple calls happened since this task
            // was queued. So we use the `latestArgs`, which definitely
            // is the most recent call.
            return fn(...latestArgs);
        });
        return calling;
    };
}
/**
 * UIPlugin is the extended version of BasePlugin to incorporate rendering with Preact.
 * Use this for plugins that need a user interface.
 *
 * For plugins without an user interface, see BasePlugin.
 */ var $5d08dd66a9cc6899$var$_updateUI = /*#__PURE__*/ $5d08dd66a9cc6899$var$_classPrivateFieldLooseKey("updateUI");
class $5d08dd66a9cc6899$var$UIPlugin extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, $5d08dd66a9cc6899$var$_updateUI, {
            writable: true,
            value: void 0
        });
    }
    getTargetPlugin(target // eslint-disable-line no-use-before-define
    ) {
        let targetPlugin;
        if (typeof (target == null ? void 0 : target.addTarget) === "function") {
            // Targeting a plugin *instance*
            targetPlugin = target;
            if (!(targetPlugin instanceof $5d08dd66a9cc6899$var$UIPlugin)) // eslint-disable-next-line no-console
            console.warn(new Error("The provided plugin is not an instance of UIPlugin. This is an indication of a bug with the way Uppy is bundled.", {
                cause: {
                    targetPlugin: targetPlugin,
                    UIPlugin: $5d08dd66a9cc6899$var$UIPlugin
                }
            }));
        } else if (typeof target === "function") {
            // Targeting a plugin type
            const Target = target;
            // Find the target plugin instance.
            this.uppy.iteratePlugins((p)=>{
                if (p instanceof Target) targetPlugin = p;
            });
        }
        return targetPlugin;
    }
    /**
   * Check if supplied `target` is a DOM element or an `object`.
   * If it’s an object — target is a plugin, and we search `plugins`
   * for a plugin with same name and return its target.
   */ mount(target, // eslint-disable-line no-use-before-define
    plugin) {
        const callerPluginName = plugin.id;
        const targetElement = (0, $1866f8238923bb5d$export$2e2bcd8739ae039)(target);
        if (targetElement) {
            this.isTargetDOMEl = true;
            // When target is <body> with a single <div> element,
            // Preact thinks it’s the Uppy root element in there when doing a diff,
            // and destroys it. So we are creating a fragment (could be empty div)
            const uppyRootElement = document.createElement("div");
            uppyRootElement.classList.add("uppy-Root");
            // API for plugins that require a synchronous rerender.
            $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(this, $5d08dd66a9cc6899$var$_updateUI)[$5d08dd66a9cc6899$var$_updateUI] = $5d08dd66a9cc6899$var$debounce((state)=>{
                // plugin could be removed, but this.rerender is debounced below,
                // so it could still be called even after uppy.removePlugin or uppy.close
                // hence the check
                if (!this.uppy.getPlugin(this.id)) return;
                (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(this.render(state), uppyRootElement);
                this.afterUpdate();
            });
            this.uppy.log(`Installing ${callerPluginName} to a DOM element '${target}'`);
            if (this.opts.replaceTargetContent) // Doing render(h(null), targetElement), which should have been
            // a better way, since because the component might need to do additional cleanup when it is removed,
            // stopped working — Preact just adds null into target, not replacing
            targetElement.innerHTML = "";
            (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(this.render(this.uppy.getState()), uppyRootElement);
            this.el = uppyRootElement;
            targetElement.appendChild(uppyRootElement);
            // Set the text direction if the page has not defined one.
            uppyRootElement.dir = this.opts.direction || (0, $82cce0c04a5d7a26$export$2e2bcd8739ae039)(uppyRootElement) || "ltr";
            this.onMount();
            return this.el;
        }
        const targetPlugin = this.getTargetPlugin(target);
        if (targetPlugin) {
            this.uppy.log(`Installing ${callerPluginName} to ${targetPlugin.id}`);
            this.parent = targetPlugin;
            this.el = targetPlugin.addTarget(plugin);
            this.onMount();
            return this.el;
        }
        this.uppy.log(`Not installing ${callerPluginName}`);
        let message = `Invalid target option given to ${callerPluginName}.`;
        if (typeof target === "function") message += " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly.";
        else message += "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.";
        throw new Error(message);
    }
    /**
   * Called when plugin is mounted, whether in DOM or into another plugin.
   * Needed because sometimes plugins are mounted separately/after `install`,
   * so this.el and this.parent might not be available in `install`.
   * This is the case with @uppy/react plugins, for example.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    render(state) {
        throw new Error("Extend the render method to add your plugin to a DOM element");
    }
    update(state) {
        if (this.el != null) {
            var _classPrivateFieldLoo, _classPrivateFieldLoo2;
            (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(this, $5d08dd66a9cc6899$var$_updateUI))[$5d08dd66a9cc6899$var$_updateUI]) == null || _classPrivateFieldLoo.call(_classPrivateFieldLoo2, state);
        }
    }
    unmount() {
        if (this.isTargetDOMEl) {
            var _this$el;
            (_this$el = this.el) == null || _this$el.remove();
        }
        this.onUnmount();
    }
    onMount() {}
    onUnmount() {}
}
var $5d08dd66a9cc6899$export$2e2bcd8739ae039 = $5d08dd66a9cc6899$var$UIPlugin;



/**
 * Low-pass filter using Exponential Moving Averages (aka exponential smoothing)
 * Filters a sequence of values by updating the mixing the previous output value
 * with the new input using the exponential window function
 *
 * @param newValue the n-th value of the sequence
 * @param previousSmoothedValue the exponential average of the first n-1 values
 * @param halfLife value of `dt` to move the smoothed value halfway between `previousFilteredValue` and `newValue`
 * @param dt time elapsed between adding the (n-1)th and the n-th values
 * @returns the exponential average of the first n values
 */ function $4e5b770b58150a1e$export$2e2bcd8739ae039(newValue, previousSmoothedValue, halfLife, dt) {
    if (halfLife === 0 || newValue === previousSmoothedValue) return newValue;
    if (dt === 0) return previousSmoothedValue;
    return newValue + (previousSmoothedValue - newValue) * 2 ** (-dt / halfLife);
}



var $5278b2bb79ab63f5$export$2e2bcd8739ae039 = {
    STATE_ERROR: "error",
    STATE_WAITING: "waiting",
    STATE_PREPROCESSING: "preprocessing",
    STATE_UPLOADING: "uploading",
    STATE_POSTPROCESSING: "postprocessing",
    STATE_COMPLETE: "complete"
};



var $02c2aab7657be691$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $02c2aab7657be691$exports) {
        classNames.default = classNames;
        $02c2aab7657be691$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



function $3d16a6a6f033a885$export$2e2bcd8739ae039(files) {
    const values = [];
    let mode = "indeterminate";
    let message;
    for (const { progress: progress } of Object.values(files)){
        const { preprocess: preprocess, postprocess: postprocess } = progress;
        // In the future we should probably do this differently. For now we'll take the
        // mode and message from the first file…
        if (message == null && (preprocess || postprocess)) ({ mode: mode, message: message } = preprocess || postprocess);
        if ((preprocess == null ? void 0 : preprocess.mode) === "determinate") values.push(preprocess.value);
        if ((postprocess == null ? void 0 : postprocess.mode) === "determinate") values.push(postprocess.value);
    }
    const value = values.reduce((total, progressValue)=>{
        return total + progressValue / values.length;
    }, 0);
    return {
        mode: mode,
        message: message,
        value: value
    };
}





function $1bd6564471caa0d9$export$2e2bcd8739ae039(rawSeconds) {
    const hours = Math.floor(rawSeconds / 3600) % 24;
    const minutes = Math.floor(rawSeconds / 60) % 60;
    const seconds = Math.floor(rawSeconds % 60);
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}


function $cf4f21df8a3b103f$export$2e2bcd8739ae039(seconds) {
    const time = (0, $1bd6564471caa0d9$export$2e2bcd8739ae039)(seconds);
    // Only display hours and minutes if they are greater than 0 but always
    // display minutes if hours is being displayed
    // Display a leading zero if the there is a preceding unit: 1m 05s, but 5s
    const hoursStr = time.hours === 0 ? "" : `${time.hours}h`;
    const minutesStr = time.minutes === 0 ? "" : `${time.hours === 0 ? time.minutes : ` ${time.minutes.toString(10).padStart(2, "0")}`}m`;
    const secondsStr = time.hours !== 0 ? "" : `${time.minutes === 0 ? time.seconds : ` ${time.seconds.toString(10).padStart(2, "0")}`}s`;
    return `${hoursStr}${minutesStr}${secondsStr}`;
}



const $c0c4f933fc4ac9a2$var$DOT = `\u00B7`;
const $c0c4f933fc4ac9a2$var$renderDot = ()=>` ${$c0c4f933fc4ac9a2$var$DOT} `;
function $c0c4f933fc4ac9a2$export$8fd979504d9f59d1(props) {
    const { newFiles: newFiles, isUploadStarted: isUploadStarted, recoveredState: recoveredState, i18n: i18n, uploadState: uploadState, isSomeGhost: isSomeGhost, startUpload: startUpload } = props;
    const uploadBtnClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--upload", {
        "uppy-c-btn-primary": uploadState === (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING
    }, {
        "uppy-StatusBar-actionBtn--disabled": isSomeGhost
    });
    const uploadBtnText = newFiles && isUploadStarted && !recoveredState ? i18n("uploadXNewFiles", {
        smart_count: newFiles
    }) : i18n("uploadXFiles", {
        smart_count: newFiles
    });
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: uploadBtnClassNames,
        "aria-label": i18n("uploadXFiles", {
            smart_count: newFiles
        }),
        onClick: startUpload,
        disabled: isSomeGhost,
        "data-uppy-super-focusable": true
    }, uploadBtnText);
}
function $c0c4f933fc4ac9a2$export$d0263dca13d9e524(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry",
        "aria-label": i18n("retryUpload"),
        onClick: ()=>uppy.retryAll().catch(()=>{
            /* Error reported and handled via an event */ }),
        "data-uppy-super-focusable": true,
        "data-cy": "retry"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "8",
        height: "10",
        viewBox: "0 0 8 10"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z"
    })), i18n("retry"));
}
function $c0c4f933fc4ac9a2$export$bda6e5e4654fa168(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        title: i18n("cancel"),
        "aria-label": i18n("cancel"),
        onClick: ()=>uppy.cancelAll(),
        "data-cy": "cancel",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#888",
        cx: "8",
        cy: "8",
        r: "8"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"
    }))));
}
function $c0c4f933fc4ac9a2$export$f8fda1be68e432db(props) {
    const { isAllPaused: isAllPaused, i18n: i18n, isAllComplete: isAllComplete, resumableUploads: resumableUploads, uppy: uppy } = props;
    const title = isAllPaused ? i18n("resume") : i18n("pause");
    function togglePauseResume() {
        if (isAllComplete) return;
        if (!resumableUploads) {
            uppy.cancelAll();
            return;
        }
        if (isAllPaused) {
            uppy.resumeAll();
            return;
        }
        uppy.pauseAll();
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        title: title,
        "aria-label": title,
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        type: "button",
        onClick: togglePauseResume,
        "data-cy": "togglePauseResume",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#888",
        cx: "8",
        cy: "8",
        r: "8"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: isAllPaused ? "M6 4.25L11.5 8 6 11.75z" : "M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z"
    }))));
}
function $c0c4f933fc4ac9a2$export$c5b3ad0eb3665a4a(props) {
    const { i18n: i18n, doneButtonHandler: doneButtonHandler } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done",
        onClick: doneButtonHandler,
        "data-uppy-super-focusable": true
    }, i18n("done"));
}
function $c0c4f933fc4ac9a2$export$b08b517936747730() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        className: "uppy-StatusBar-spinner",
        "aria-hidden": "true",
        focusable: "false",
        width: "14",
        height: "14"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0",
        fillRule: "evenodd"
    }));
}
function $c0c4f933fc4ac9a2$export$f10e066f2fffa2e8(props) {
    const { progress: progress } = props;
    const { value: value, mode: mode, message: message } = progress;
    const dot = `\u00B7`;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$b08b517936747730, null), mode === "determinate" ? `${Math.round(value * 100)}% ${dot} ` : "", message);
}
function $c0c4f933fc4ac9a2$export$511da99642518663(props) {
    const { numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, i18n: i18n } = props;
    const ifShowFilesUploadedOfTotal = numUploads > 1;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, ifShowFilesUploadedOfTotal && i18n("filesUploadedOfTotal", {
        complete: complete,
        smart_count: numUploads
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-StatusBar-additionalInfo"
    }, ifShowFilesUploadedOfTotal && $c0c4f933fc4ac9a2$var$renderDot(), i18n("dataUploadedOfTotal", {
        complete: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalUploadedSize),
        total: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalSize)
    }), $c0c4f933fc4ac9a2$var$renderDot(), i18n("xTimeLeft", {
        time: (0, $cf4f21df8a3b103f$export$2e2bcd8739ae039)(totalETA)
    })));
}
function $c0c4f933fc4ac9a2$var$FileUploadCount(props) {
    const { i18n: i18n, complete: complete, numUploads: numUploads } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, i18n("filesUploadedOfTotal", {
        complete: complete,
        smart_count: numUploads
    }));
}
function $c0c4f933fc4ac9a2$var$UploadNewlyAddedFiles(props) {
    const { i18n: i18n, newFiles: newFiles, startUpload: startUpload } = props;
    const uploadBtnClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--uploadNewlyAdded");
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondaryHint"
    }, i18n("xMoreFilesAdded", {
        smart_count: newFiles
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: uploadBtnClassNames,
        "aria-label": i18n("uploadXFiles", {
            smart_count: newFiles
        }),
        onClick: startUpload
    }, i18n("upload")));
}
function $c0c4f933fc4ac9a2$export$2d75d7371a967988(props) {
    const { i18n: i18n, supportsUploadProgress: supportsUploadProgress, totalProgress: totalProgress, showProgressDetails: showProgressDetails, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused, newFiles: newFiles, numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, startUpload: startUpload } = props;
    const showUploadNewlyAddedFiles = newFiles && isUploadStarted;
    if (!isUploadStarted || isAllComplete) return null;
    const title = isAllPaused ? i18n("paused") : i18n("uploading");
    function renderProgressDetails() {
        if (!isAllPaused && !showUploadNewlyAddedFiles && showProgressDetails) {
            if (supportsUploadProgress) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$511da99642518663, {
                numUploads: numUploads,
                complete: complete,
                totalUploadedSize: totalUploadedSize,
                totalSize: totalSize,
                totalETA: totalETA,
                i18n: i18n
            });
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$FileUploadCount, {
                i18n: i18n,
                complete: complete,
                numUploads: numUploads
            });
        }
        return null;
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        "aria-label": title,
        title: title
    }, !isAllPaused ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$b08b517936747730, null) : null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, supportsUploadProgress ? `${title}: ${totalProgress}%` : title), renderProgressDetails(), showUploadNewlyAddedFiles ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$UploadNewlyAddedFiles, {
        i18n: i18n,
        newFiles: newFiles,
        startUpload: startUpload
    }) : null));
}
function $c0c4f933fc4ac9a2$export$8dc84f0e764ad25e(props) {
    const { i18n: i18n } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        role: "status",
        title: i18n("complete")
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-StatusBar-statusIndicator uppy-c-icon",
        width: "15",
        height: "11",
        viewBox: "0 0 15 11"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z"
    })), i18n("complete"))));
}
function $c0c4f933fc4ac9a2$export$7331502eb9534bdb(props) {
    const { error: error, i18n: i18n, complete: complete, numUploads: numUploads } = props;
    function displayErrorAlert() {
        const errorMessage = `${i18n("uploadFailed")} \n\n ${error}`;
        // eslint-disable-next-line no-alert
        alert(errorMessage); // TODO: move to custom alert implementation
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        title: i18n("uploadFailed")
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-StatusBar-statusIndicator uppy-c-icon",
        width: "11",
        height: "11",
        viewBox: "0 0 11 11"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z"
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, i18n("uploadFailed"), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-StatusBar-details",
        "aria-label": i18n("showErrorDetails"),
        "data-microtip-position": "top-right",
        "data-microtip-size": "medium",
        onClick: displayErrorAlert,
        type: "button"
    }, "?")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$FileUploadCount, {
        i18n: i18n,
        complete: complete,
        numUploads: numUploads
    })));
}


const { STATE_ERROR: $4af84b49d740c94f$var$STATE_ERROR, STATE_WAITING: $4af84b49d740c94f$var$STATE_WAITING, STATE_PREPROCESSING: $4af84b49d740c94f$var$STATE_PREPROCESSING, STATE_UPLOADING: $4af84b49d740c94f$var$STATE_UPLOADING, STATE_POSTPROCESSING: $4af84b49d740c94f$var$STATE_POSTPROCESSING, STATE_COMPLETE: $4af84b49d740c94f$var$STATE_COMPLETE } = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039);
function $4af84b49d740c94f$export$2e2bcd8739ae039(props) {
    const { newFiles: newFiles, allowNewUpload: allowNewUpload, isUploadInProgress: isUploadInProgress, isAllPaused: isAllPaused, resumableUploads: resumableUploads, error: error, hideUploadButton: hideUploadButton, hidePauseResumeButton: hidePauseResumeButton, hideCancelButton: hideCancelButton, hideRetryButton: hideRetryButton, recoveredState: recoveredState, uploadState: uploadState, totalProgress: totalProgress, files: files, supportsUploadProgress: supportsUploadProgress, hideAfterFinish: hideAfterFinish, isSomeGhost: isSomeGhost, doneButtonHandler: doneButtonHandler, isUploadStarted: isUploadStarted, i18n: i18n, startUpload: startUpload, uppy: uppy, isAllComplete: isAllComplete, showProgressDetails: showProgressDetails, numUploads: numUploads, complete: complete, totalSize: totalSize, totalETA: totalETA, totalUploadedSize: totalUploadedSize } = props;
    function getProgressValue() {
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
                {
                    const progress = (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files);
                    if (progress.mode === "determinate") return progress.value * 100;
                    return totalProgress;
                }
            case $4af84b49d740c94f$var$STATE_ERROR:
                return null;
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return null;
                return totalProgress;
            default:
                return totalProgress;
        }
    }
    function getIsIndeterminate() {
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
                {
                    const { mode: mode } = (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files);
                    return mode === "indeterminate";
                }
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return true;
                return false;
            default:
                return false;
        }
    }
    function getIsHidden() {
        if (recoveredState) return false;
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_WAITING:
                return hideUploadButton || newFiles === 0;
            case $4af84b49d740c94f$var$STATE_COMPLETE:
                return hideAfterFinish;
            default:
                return false;
        }
    }
    const progressValue = getProgressValue();
    const isHidden = getIsHidden();
    const width = progressValue != null ? progressValue : 100;
    const showUploadBtn = !error && newFiles && !isUploadInProgress && !isAllPaused && allowNewUpload && !hideUploadButton;
    const showCancelBtn = !hideCancelButton && uploadState !== $4af84b49d740c94f$var$STATE_WAITING && uploadState !== $4af84b49d740c94f$var$STATE_COMPLETE;
    const showPauseResumeBtn = resumableUploads && !hidePauseResumeButton && uploadState === $4af84b49d740c94f$var$STATE_UPLOADING;
    const showRetryBtn = error && !isAllComplete && !hideRetryButton;
    const showDoneBtn = doneButtonHandler && uploadState === $4af84b49d740c94f$var$STATE_COMPLETE;
    const progressClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-StatusBar-progress", {
        "is-indeterminate": getIsIndeterminate()
    });
    const statusBarClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-StatusBar", `is-${uploadState}`, {
        "has-ghosts": isSomeGhost
    });
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: statusBarClassNames,
        "aria-hidden": isHidden
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: progressClassNames,
        style: {
            width: `${width}%`
        },
        role: "progressbar",
        "aria-label": `${width}%`,
        "aria-valuetext": `${width}%`,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": progressValue
    }), (()=>{
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$f10e066f2fffa2e8), {
                    progress: (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files)
                });
            case $4af84b49d740c94f$var$STATE_COMPLETE:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$8dc84f0e764ad25e), {
                    i18n: i18n
                });
            case $4af84b49d740c94f$var$STATE_ERROR:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$7331502eb9534bdb), {
                    error: error,
                    i18n: i18n,
                    numUploads: numUploads,
                    complete: complete
                });
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$2d75d7371a967988), {
                    i18n: i18n,
                    supportsUploadProgress: supportsUploadProgress,
                    totalProgress: totalProgress,
                    showProgressDetails: showProgressDetails,
                    isUploadStarted: isUploadStarted,
                    isAllComplete: isAllComplete,
                    isAllPaused: isAllPaused,
                    newFiles: newFiles,
                    numUploads: numUploads,
                    complete: complete,
                    totalUploadedSize: totalUploadedSize,
                    totalSize: totalSize,
                    totalETA: totalETA,
                    startUpload: startUpload
                });
            default:
                return null;
        }
    })(), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-actions"
    }, recoveredState || showUploadBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$8fd979504d9f59d1), {
        newFiles: newFiles,
        isUploadStarted: isUploadStarted,
        recoveredState: recoveredState,
        i18n: i18n,
        isSomeGhost: isSomeGhost,
        startUpload: startUpload,
        uploadState: uploadState
    }) : null, showRetryBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$d0263dca13d9e524), {
        i18n: i18n,
        uppy: uppy
    }) : null, showPauseResumeBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$f8fda1be68e432db), {
        isAllPaused: isAllPaused,
        i18n: i18n,
        isAllComplete: isAllComplete,
        resumableUploads: resumableUploads,
        uppy: uppy
    }) : null, showCancelBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$bda6e5e4654fa168), {
        i18n: i18n,
        uppy: uppy
    }) : null, showDoneBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$c5b3ad0eb3665a4a), {
        i18n: i18n,
        doneButtonHandler: doneButtonHandler
    }) : null));
}
$4af84b49d740c94f$export$2e2bcd8739ae039.defaultProps = {
    doneButtonHandler: undefined,
    hideAfterFinish: false,
    hideCancelButton: false,
    hidePauseResumeButton: false,
    hideRetryButton: false,
    hideUploadButton: undefined,
    showProgressDetails: undefined
};


var $f9ab456b3e2aaacb$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the status bar while files are being uploaded.
        uploading: "Uploading",
        // Shown in the status bar once all files have been uploaded.
        complete: "Complete",
        // Shown in the status bar if an upload failed.
        uploadFailed: "Upload failed",
        // Shown in the status bar while the upload is paused.
        paused: "Paused",
        // Used as the label for the button that retries an upload.
        retry: "Retry",
        // Used as the label for the button that cancels an upload.
        cancel: "Cancel",
        // Used as the label for the button that pauses an upload.
        pause: "Pause",
        // Used as the label for the button that resumes an upload.
        resume: "Resume",
        // Used as the label for the button that resets the upload state after an upload
        done: "Done",
        // When `showProgressDetails` is set, shows the number of files that have been fully uploaded so far.
        filesUploadedOfTotal: {
            0: "%{complete} of %{smart_count} file uploaded",
            1: "%{complete} of %{smart_count} files uploaded"
        },
        // When `showProgressDetails` is set, shows the amount of bytes that have been uploaded so far.
        dataUploadedOfTotal: "%{complete} of %{total}",
        // When `showProgressDetails` is set, shows an estimation of how long the upload will take to complete.
        xTimeLeft: "%{time} left",
        // Used as the label for the button that starts an upload.
        uploadXFiles: {
            0: "Upload %{smart_count} file",
            1: "Upload %{smart_count} files"
        },
        // Used as the label for the button that starts an upload, if another upload has been started in the past
        // and new files were added later.
        uploadXNewFiles: {
            0: "Upload +%{smart_count} file",
            1: "Upload +%{smart_count} files"
        },
        upload: "Upload",
        retryUpload: "Retry upload",
        xMoreFilesAdded: {
            0: "%{smart_count} more file added",
            1: "%{smart_count} more files added"
        },
        showErrorDetails: "Show error details"
    }
};


function $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $f22a72e7b80fdb1a$var$id = 0;
function $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $f22a72e7b80fdb1a$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f22a72e7b80fdb1a$var$packageJson = {
    "version": "3.3.1"
};
const $f22a72e7b80fdb1a$var$speedFilterHalfLife = 2000;
const $f22a72e7b80fdb1a$var$ETAFilterHalfLife = 2000;
function $f22a72e7b80fdb1a$var$getUploadingState(error, isAllComplete, recoveredState, files) {
    if (error) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_ERROR;
    if (isAllComplete) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_COMPLETE;
    if (recoveredState) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING;
    let state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]];
        // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_UPLOADING;
        // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess) state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_PREPROCESSING;
        // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_PREPROCESSING) state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_POSTPROCESSING;
    }
    return state;
}
// set default options, must be kept in sync with @uppy/react/src/StatusBar.js
const $f22a72e7b80fdb1a$var$defaultOptions = {
    target: "body",
    hideUploadButton: false,
    hideRetryButton: false,
    hidePauseResumeButton: false,
    hideCancelButton: false,
    showProgressDetails: false,
    hideAfterFinish: true,
    doneButtonHandler: null
};
/**
 * StatusBar: renders a status bar with upload/pause/resume/cancel/retry buttons,
 * progress percentage and time remaining.
 */ var $f22a72e7b80fdb1a$var$_lastUpdateTime = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("lastUpdateTime");
var $f22a72e7b80fdb1a$var$_previousUploadedBytes = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousUploadedBytes");
var $f22a72e7b80fdb1a$var$_previousSpeed = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousSpeed");
var $f22a72e7b80fdb1a$var$_previousETA = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousETA");
var $f22a72e7b80fdb1a$var$_computeSmoothETA = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("computeSmoothETA");
var $f22a72e7b80fdb1a$var$_onUploadStart = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("onUploadStart");
class $f22a72e7b80fdb1a$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$f22a72e7b80fdb1a$var$defaultOptions,
            ...opts
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_computeSmoothETA, {
            value: $f22a72e7b80fdb1a$var$_computeSmoothETA2
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_lastUpdateTime, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousSpeed, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousETA, {
            writable: true,
            value: void 0
        });
        this.startUpload = ()=>{
            return this.uppy.upload().catch(()=>{
            // Error logged in Core
            });
        };
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_onUploadStart, {
            writable: true,
            value: ()=>{
                const { recoveredState: recoveredState } = this.uppy.getState();
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] = null;
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] = null;
                if (recoveredState) {
                    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = Object.values(recoveredState.files).reduce((pv, _ref)=>{
                        let { progress: progress } = _ref;
                        return pv + progress.bytesUploaded;
                    }, 0);
                    // We don't set `#lastUpdateTime` at this point because the upload won't
                    // actually resume until the user asks for it.
                    this.uppy.emit("restore-confirmed");
                    return;
                }
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = 0;
            }
        });
        this.id = this.opts.id || "StatusBar";
        this.title = "StatusBar";
        this.type = "progressindicator";
        this.defaultLocale = (0, $f9ab456b3e2aaacb$export$2e2bcd8739ae039);
        this.i18nInit();
        this.render = this.render.bind(this);
        this.install = this.install.bind(this);
    }
    render(state) {
        const { capabilities: capabilities, files: files, allowNewUpload: allowNewUpload, totalProgress: totalProgress, error: error, recoveredState: recoveredState } = state;
        const { newFiles: newFiles, startedFiles: startedFiles, completeFiles: completeFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused, isUploadInProgress: isUploadInProgress, isSomeGhost: isSomeGhost } = this.uppy.getObjectOfFilesPerState();
        // If some state was recovered, we want to show Upload button/counter
        // for all the files, because in this case it’s not an Upload button,
        // but “Confirm Restore Button”
        const newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
        const resumableUploads = !!capabilities.resumableUploads;
        const supportsUploadProgress = capabilities.uploadProgress !== false;
        let totalSize = 0;
        let totalUploadedSize = 0;
        startedFiles.forEach((file)=>{
            totalSize += file.progress.bytesTotal || 0;
            totalUploadedSize += file.progress.bytesUploaded || 0;
        });
        const totalETA = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_computeSmoothETA)[$f22a72e7b80fdb1a$var$_computeSmoothETA]({
            uploaded: totalUploadedSize,
            total: totalSize,
            remaining: totalSize - totalUploadedSize
        });
        return (0, $4af84b49d740c94f$export$2e2bcd8739ae039)({
            error: error,
            uploadState: $f22a72e7b80fdb1a$var$getUploadingState(error, isAllComplete, recoveredState, state.files || {}),
            allowNewUpload: allowNewUpload,
            totalProgress: totalProgress,
            totalSize: totalSize,
            totalUploadedSize: totalUploadedSize,
            isAllComplete: false,
            isAllPaused: isAllPaused,
            isAllErrored: // @ts-expect-error TODO: remove this in 4.x branch
            isAllErrored,
            isUploadStarted: isUploadStarted,
            isUploadInProgress: isUploadInProgress,
            isSomeGhost: isSomeGhost,
            recoveredState: recoveredState,
            complete: completeFiles.length,
            newFiles: newFilesOrRecovered.length,
            numUploads: startedFiles.length,
            totalETA: totalETA,
            files: files,
            i18n: this.i18n,
            uppy: this.uppy,
            startUpload: this.startUpload,
            doneButtonHandler: this.opts.doneButtonHandler,
            resumableUploads: resumableUploads,
            supportsUploadProgress: supportsUploadProgress,
            showProgressDetails: this.opts.showProgressDetails,
            hideUploadButton: this.opts.hideUploadButton,
            hideRetryButton: this.opts.hideRetryButton,
            hidePauseResumeButton: this.opts.hidePauseResumeButton,
            hideCancelButton: this.opts.hideCancelButton,
            hideAfterFinish: this.opts.hideAfterFinish,
            // ts-expect-error TODO: remove this in 4.x branch
            isTargetDOMEl: this.isTargetDOMEl
        });
    }
    onMount() {
        // Set the text direction if the page has not defined one.
        const element = this.el;
        const direction = (0, $82cce0c04a5d7a26$export$2e2bcd8739ae039)(element);
        if (!direction) element.dir = "ltr";
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
        this.uppy.on("upload", $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_onUploadStart)[$f22a72e7b80fdb1a$var$_onUploadStart]);
        // To cover the use case where the status bar is installed while the upload
        // has started, we set `lastUpdateTime` right away.
        $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
        $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = this.uppy.getFiles().reduce((pv, file)=>pv + file.progress.bytesUploaded, 0);
    }
    uninstall() {
        this.unmount();
        this.uppy.off("upload", $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_onUploadStart)[$f22a72e7b80fdb1a$var$_onUploadStart]);
    }
}
function $f22a72e7b80fdb1a$var$_computeSmoothETA2(totalBytes) {
    var _classPrivateFieldLoo, _classPrivateFieldLoo2;
    if (totalBytes.total === 0 || totalBytes.remaining === 0) return 0;
    // When state is restored, lastUpdateTime is still nullish at this point.
    (_classPrivateFieldLoo2 = (_classPrivateFieldLoo = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime))[$f22a72e7b80fdb1a$var$_lastUpdateTime]) != null ? _classPrivateFieldLoo2 : _classPrivateFieldLoo[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
    const dt = performance.now() - $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime];
    if (dt === 0) {
        var _classPrivateFieldLoo3;
        return Math.round(((_classPrivateFieldLoo3 = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA]) != null ? _classPrivateFieldLoo3 : 0) / 100) / 10;
    }
    const uploadedBytesSinceLastTick = totalBytes.uploaded - $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes];
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = totalBytes.uploaded;
    // uploadedBytesSinceLastTick can be negative in some cases (packet loss?)
    // in which case, we wait for next tick to update ETA.
    if (uploadedBytesSinceLastTick <= 0) {
        var _classPrivateFieldLoo4;
        return Math.round(((_classPrivateFieldLoo4 = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA]) != null ? _classPrivateFieldLoo4 : 0) / 100) / 10;
    }
    const currentSpeed = uploadedBytesSinceLastTick / dt;
    const filteredSpeed = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] == null ? currentSpeed : (0, $4e5b770b58150a1e$export$2e2bcd8739ae039)(currentSpeed, $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed], $f22a72e7b80fdb1a$var$speedFilterHalfLife, dt);
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] = filteredSpeed;
    const instantETA = totalBytes.remaining / filteredSpeed;
    const updatedPreviousETA = Math.max($f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] - dt, 0);
    const filteredETA = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] == null ? instantETA : (0, $4e5b770b58150a1e$export$2e2bcd8739ae039)(instantETA, updatedPreviousETA, $f22a72e7b80fdb1a$var$ETAFilterHalfLife, dt);
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] = filteredETA;
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
    return Math.round(filteredETA / 100) / 10;
}
$f22a72e7b80fdb1a$export$2e2bcd8739ae039.VERSION = $f22a72e7b80fdb1a$var$packageJson.version;




/* eslint-disable jsx-a11y/no-noninteractive-element-interactions  */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 


const $aaa56faedf37f661$var$TRANSITION_MS = 300;
class $aaa56faedf37f661$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.ref = (0, $4d2e93495e50cc85$export$7d1e3a5e95ceca43)();
    }
    componentWillEnter(callback) {
        this.ref.current.style.opacity = "1";
        this.ref.current.style.transform = "none";
        setTimeout(callback, $aaa56faedf37f661$var$TRANSITION_MS);
    }
    componentWillLeave(callback) {
        this.ref.current.style.opacity = "0";
        this.ref.current.style.transform = "translateY(350%)";
        setTimeout(callback, $aaa56faedf37f661$var$TRANSITION_MS);
    }
    render() {
        const { children: children } = this.props;
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Informer-animated",
            ref: this.ref
        }, children);
    }
}


// INFO: not typing copy pasted libarary code
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable */ /**
 * @source https://github.com/developit/preact-transition-group
 */ 
function $39136bc8da03ed4c$var$assign(obj, props) {
    return Object.assign(obj, props);
}
function $39136bc8da03ed4c$var$getKey(vnode, fallback) {
    var _vnode$key;
    return (_vnode$key = vnode == null ? void 0 : vnode.key) != null ? _vnode$key : fallback;
}
function $39136bc8da03ed4c$var$linkRef(component, name) {
    const cache = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
    return cache[name] || (cache[name] = (c)=>{
        component.refs[name] = c;
    });
}
function $39136bc8da03ed4c$var$getChildMapping(children) {
    const out = {};
    for(let i = 0; i < children.length; i++)if (children[i] != null) {
        const key = $39136bc8da03ed4c$var$getKey(children[i], i.toString(36));
        out[key] = children[i];
    }
    return out;
}
function $39136bc8da03ed4c$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    const getValueForKey = (key)=>next.hasOwnProperty(key) ? next[key] : prev[key];
    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    const nextKeysPending = {};
    let pendingKeys = [];
    for(const prevKey in prev){
        if (next.hasOwnProperty(prevKey)) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    const childMapping = {};
    for(const nextKey in next){
        if (nextKeysPending.hasOwnProperty(nextKey)) for(let i = 0; i < nextKeysPending[nextKey].length; i++){
            const pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    }
    // Finally, add the keys which didn't appear before any key in `next`
    for(let i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
const $39136bc8da03ed4c$var$identity = (i)=>i;
class $39136bc8da03ed4c$var$TransitionGroup extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(props, context){
        super(props, context);
        this.refs = {};
        this.state = {
            children: $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children)) || [])
        };
        this.performAppear = this.performAppear.bind(this);
        this.performEnter = this.performEnter.bind(this);
        this.performLeave = this.performLeave.bind(this);
    }
    componentWillMount() {
        this.currentlyTransitioningKeys = {};
        this.keysToAbortLeave = [];
        this.keysToEnter = [];
        this.keysToLeave = [];
    }
    componentDidMount() {
        const initialChildMapping = this.state.children;
        for(const key in initialChildMapping)if (initialChildMapping[key]) // this.performAppear(getKey(initialChildMapping[key], key));
        this.performAppear(key);
    }
    componentWillReceiveProps(nextProps) {
        const nextChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(nextProps.children) || []);
        const prevChildMapping = this.state.children;
        this.setState((prevState)=>({
                children: $39136bc8da03ed4c$var$mergeChildMappings(prevState.children, nextChildMapping)
            }));
        let key;
        for(key in nextChildMapping)if (nextChildMapping.hasOwnProperty(key)) {
            const hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
            // We should re-enter the component and abort its leave function
            if (nextChildMapping[key] && hasPrev && this.currentlyTransitioningKeys[key]) {
                this.keysToEnter.push(key);
                this.keysToAbortLeave.push(key);
            } else if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) this.keysToEnter.push(key);
        }
        for(key in prevChildMapping)if (prevChildMapping.hasOwnProperty(key)) {
            const hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
            if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) this.keysToLeave.push(key);
        }
    }
    componentDidUpdate() {
        const { keysToEnter: keysToEnter } = this;
        this.keysToEnter = [];
        keysToEnter.forEach(this.performEnter);
        const { keysToLeave: keysToLeave } = this;
        this.keysToLeave = [];
        keysToLeave.forEach(this.performLeave);
    }
    _finishAbort(key) {
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) this.keysToAbortLeave.splice(idx, 1);
    }
    performAppear(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillAppear) component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
        else this._handleDoneAppearing(key);
    }
    _handleDoneAppearing(key) {
        const component = this.refs[key];
        if (component != null && component.componentDidAppear) component.componentDidAppear();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully appeared. Remove it.
        this.performLeave(key);
    }
    performEnter(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillEnter) component.componentWillEnter(this._handleDoneEntering.bind(this, key));
        else this._handleDoneEntering(key);
    }
    _handleDoneEntering(key) {
        const component = this.refs[key];
        if (component != null && component.componentDidEnter) component.componentDidEnter();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully entered. Remove it.
        this.performLeave(key);
    }
    performLeave(key) {
        // If we should immediately abort this leave function,
        // don't run the leave transition at all.
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillLeave) component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
        else // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        this._handleDoneLeaving(key);
    }
    _handleDoneLeaving(key) {
        // If we should immediately abort the leave,
        // then skip this altogether
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        const component = this.refs[key];
        if (component != null && component.componentDidLeave) component.componentDidLeave();
        delete this.currentlyTransitioningKeys[key];
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) // This entered again before it fully left. Add it again.
        this.performEnter(key);
        else {
            const children = $39136bc8da03ed4c$var$assign({}, this.state.children);
            delete children[key];
            this.setState({
                children: children
            });
        }
    }
    render(_ref, _ref2) {
        let { childFactory: childFactory, transitionLeave: transitionLeave, transitionName: transitionName, transitionAppear: transitionAppear, transitionEnter: transitionEnter, transitionLeaveTimeout: transitionLeaveTimeout, transitionEnterTimeout: transitionEnterTimeout, transitionAppearTimeout: transitionAppearTimeout, component: component, ...props } = _ref;
        let { children: children } = _ref2;
        // TODO: we could get rid of the need for the wrapper node
        // by cloning a single child
        const childrenToRender = Object.entries(children).map((_ref3)=>{
            let [key, child] = _ref3;
            if (!child) return undefined;
            const ref = $39136bc8da03ed4c$var$linkRef(this, key);
            return (0, $4d2e93495e50cc85$export$e530037191fcd5d7)(childFactory(child), {
                ref: ref,
                key: key
            });
        }).filter(Boolean);
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)(component, props, childrenToRender);
    }
}
$39136bc8da03ed4c$var$TransitionGroup.defaultProps = {
    component: "span",
    childFactory: $39136bc8da03ed4c$var$identity
};
var $39136bc8da03ed4c$export$2e2bcd8739ae039 = $39136bc8da03ed4c$var$TransitionGroup;


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $2d1e3e0d76faae78$var$packageJson = {
    "version": "3.1.0"
};
class $2d1e3e0d76faae78$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, opts);
        this.render = (state)=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy uppy-Informer"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $39136bc8da03ed4c$export$2e2bcd8739ae039), null, state.info.map((info)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aaa56faedf37f661$export$2e2bcd8739ae039), {
                    key: info.message
                }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("p", {
                    role: "alert"
                }, info.message, " ", info.details && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                    "aria-label": info.details,
                    "data-microtip-position": "top-left",
                    "data-microtip-size": "medium",
                    role: "tooltip",
                    onClick: ()=>// eslint-disable-next-line no-alert
                        alert(`${info.message} \n\n ${info.details}`)
                }, "?"))))));
        };
        this.type = "progressindicator";
        this.id = this.opts.id || "Informer";
        this.title = "Informer";
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
    }
}
$2d1e3e0d76faae78$export$2e2bcd8739ae039.VERSION = $2d1e3e0d76faae78$var$packageJson.version;





const $8f6efe9c4afa65c2$var$DATA_URL_PATTERN = /^data:([^/]+\/[^,;]+(?:[^,]*?))(;base64)?,([\s\S]*)$/;
function $8f6efe9c4afa65c2$export$2e2bcd8739ae039(dataURI, opts, toFile) {
    var _ref, _opts$mimeType;
    // get the base64 data
    const dataURIData = $8f6efe9c4afa65c2$var$DATA_URL_PATTERN.exec(dataURI);
    // user may provide mime type, if not get it from data URI
    const mimeType = (_ref = (_opts$mimeType = opts.mimeType) != null ? _opts$mimeType : dataURIData == null ? void 0 : dataURIData[1]) != null ? _ref : "plain/text";
    let data; // We add `!` to tell TS we're OK with `data` being not defined when the dataURI is invalid.
    if ((dataURIData == null ? void 0 : dataURIData[2]) != null) {
        const binary = atob(decodeURIComponent(dataURIData[3]));
        const bytes = new Uint8Array(binary.length);
        for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
        data = [
            bytes
        ];
    } else if ((dataURIData == null ? void 0 : dataURIData[3]) != null) data = [
        decodeURIComponent(dataURIData[3])
    ];
    // Convert to a File?
    if (toFile) return new File(data, opts.name || "", {
        type: mimeType
    });
    return new Blob(data, {
        type: mimeType
    });
}


/**
 * Check if a URL string is an object URL from `URL.createObjectURL`.
 */ function $3b72dc28c9f79a38$export$2e2bcd8739ae039(url) {
    return url.startsWith("blob:");
}


function $2e3a76623b3bbcc9$export$2e2bcd8739ae039(fileType) {
    if (!fileType) return false;
    // list of images that browsers can preview
    return /^[^/]+\/(jpe?g|gif|png|svg|svg\+xml|bmp|webp|avif)$/.test(fileType);
}



var $gnS5A = parcelRequire("gnS5A");
var $7785655e028eb2bd$export$2e2bcd8739ae039 = {
    strings: {
        generatingThumbnails: "Generating thumbnails..."
    }
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f92c4ad36d89e394$var$packageJson = {
    "version": "3.1.0"
};
/**
 * Save a <canvas> element's content to a Blob object.
 *
 */ function $f92c4ad36d89e394$var$canvasToBlob(canvas, type, quality) {
    try {
        canvas.getContext("2d").getImageData(0, 0, 1, 1);
    } catch (err) {
        if (err.code === 18) return Promise.reject(new Error("cannot read image, probably an svg with external resources"));
    }
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, type, quality);
    }).then((blob)=>{
        if (blob === null) throw new Error("cannot read image, probably an svg with external resources");
        return blob;
    });
    return Promise.resolve().then(()=>{
        return (0, $8f6efe9c4afa65c2$export$2e2bcd8739ae039)(canvas.toDataURL(type, quality), {});
    }).then((blob)=>{
        if (blob === null) throw new Error("could not extract blob, probably an old browser");
        return blob;
    });
}
function $f92c4ad36d89e394$var$rotateImage(image, translate) {
    let w = image.width;
    let h = image.height;
    if (translate.deg === 90 || translate.deg === 270) {
        w = image.height;
        h = image.width;
    }
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const context = canvas.getContext("2d");
    context.translate(w / 2, h / 2);
    if (translate.canvas) {
        context.rotate(translate.rad);
        context.scale(translate.scaleX, translate.scaleY);
    }
    context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);
    return canvas;
}
/**
 * Make sure the image doesn’t exceed browser/device canvas limits.
 * For ios with 256 RAM and ie
 */ function $f92c4ad36d89e394$var$protect(image) {
    // https://stackoverflow.com/questions/6081483/maximum-size-of-a-canvas-element
    const ratio = image.width / image.height;
    const maxSquare = 5000000; // ios max canvas square
    const maxSize = 4096; // ie max canvas dimensions
    let maxW = Math.floor(Math.sqrt(maxSquare * ratio));
    let maxH = Math.floor(maxSquare / Math.sqrt(maxSquare * ratio));
    if (maxW > maxSize) {
        maxW = maxSize;
        maxH = Math.round(maxW / ratio);
    }
    if (maxH > maxSize) {
        maxH = maxSize;
        maxW = Math.round(ratio * maxH);
    }
    if (image.width > maxW) {
        const canvas = document.createElement("canvas");
        canvas.width = maxW;
        canvas.height = maxH;
        canvas.getContext("2d").drawImage(image, 0, 0, maxW, maxH);
        return canvas;
    }
    return image;
}
const $f92c4ad36d89e394$var$defaultOptions = {
    thumbnailWidth: null,
    thumbnailHeight: null,
    thumbnailType: "image/jpeg",
    waitForThumbnailsBeforeUpload: false,
    lazy: false
};
class $f92c4ad36d89e394$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$f92c4ad36d89e394$var$defaultOptions,
            ...opts
        });
        this.onFileAdded = (file)=>{
            if (!file.preview && file.data && (0, $2e3a76623b3bbcc9$export$2e2bcd8739ae039)(file.type) && !file.isRemote) this.addToQueue(file.id);
        };
        /**
     * Cancel a lazy request for a thumbnail if the thumbnail has not yet been generated.
     */ this.onCancelRequest = (file)=>{
            const index = this.queue.indexOf(file.id);
            if (index !== -1) this.queue.splice(index, 1);
        };
        /**
     * Clean up the thumbnail for a file. Cancel lazy requests and free the thumbnail URL.
     */ this.onFileRemoved = (file)=>{
            const index = this.queue.indexOf(file.id);
            if (index !== -1) this.queue.splice(index, 1);
            // Clean up object URLs.
            if (file.preview && (0, $3b72dc28c9f79a38$export$2e2bcd8739ae039)(file.preview)) URL.revokeObjectURL(file.preview);
        };
        this.onRestored = ()=>{
            const restoredFiles = this.uppy.getFiles().filter((file)=>file.isRestored);
            restoredFiles.forEach((file)=>{
                // Only add blob URLs; they are likely invalid after being restored.
                if (!file.preview || (0, $3b72dc28c9f79a38$export$2e2bcd8739ae039)(file.preview)) this.addToQueue(file.id);
            });
        };
        this.onAllFilesRemoved = ()=>{
            this.queue = [];
        };
        this.waitUntilAllProcessed = (fileIDs)=>{
            fileIDs.forEach((fileID)=>{
                const file = this.uppy.getFile(fileID);
                this.uppy.emit("preprocess-progress", file, {
                    mode: "indeterminate",
                    message: this.i18n("generatingThumbnails")
                });
            });
            const emitPreprocessCompleteForAll = ()=>{
                fileIDs.forEach((fileID)=>{
                    const file = this.uppy.getFile(fileID);
                    this.uppy.emit("preprocess-complete", file);
                });
            };
            return new Promise((resolve)=>{
                if (this.queueProcessing) this.uppy.once("thumbnail:all-generated", ()=>{
                    emitPreprocessCompleteForAll();
                    resolve();
                });
                else {
                    emitPreprocessCompleteForAll();
                    resolve();
                }
            });
        };
        this.type = "modifier";
        this.id = this.opts.id || "ThumbnailGenerator";
        this.title = "Thumbnail Generator";
        this.queue = [];
        this.queueProcessing = false;
        this.defaultThumbnailDimension = 200;
        this.thumbnailType = this.opts.thumbnailType;
        this.defaultLocale = (0, $7785655e028eb2bd$export$2e2bcd8739ae039);
        this.i18nInit();
        if (this.opts.lazy && this.opts.waitForThumbnailsBeforeUpload) throw new Error("ThumbnailGenerator: The `lazy` and `waitForThumbnailsBeforeUpload` options are mutually exclusive. Please ensure at most one of them is set to `true`.");
    }
    createThumbnail(file, targetWidth, targetHeight) {
        const originalUrl = URL.createObjectURL(file.data);
        const onload = new Promise((resolve, reject)=>{
            const image = new Image();
            image.src = originalUrl;
            image.addEventListener("load", ()=>{
                URL.revokeObjectURL(originalUrl);
                resolve(image);
            });
            image.addEventListener("error", (event)=>{
                URL.revokeObjectURL(originalUrl);
                reject(event.error || new Error("Could not create thumbnail"));
            });
        });
        const orientationPromise = (0, $gnS5A.rotation)(file.data).catch(()=>1);
        return Promise.all([
            onload,
            orientationPromise
        ]).then((_ref)=>{
            let [image, orientation] = _ref;
            const dimensions = this.getProportionalDimensions(image, targetWidth, targetHeight, orientation.deg);
            const rotatedImage = $f92c4ad36d89e394$var$rotateImage(image, orientation);
            const resizedImage = this.resizeImage(rotatedImage, dimensions.width, dimensions.height);
            return $f92c4ad36d89e394$var$canvasToBlob(resizedImage, this.thumbnailType, 80);
        }).then((blob)=>{
            return URL.createObjectURL(blob);
        });
    }
    /**
   * Get the new calculated dimensions for the given image and a target width
   * or height. If both width and height are given, only width is taken into
   * account. If neither width nor height are given, the default dimension
   * is used.
   */ getProportionalDimensions(img, width, height, deg) {
        // eslint-disable-line no-shadow
        let aspect = img.width / img.height;
        if (deg === 90 || deg === 270) aspect = img.height / img.width;
        if (width != null) return {
            width: width,
            height: Math.round(width / aspect)
        };
        if (height != null) return {
            width: Math.round(height * aspect),
            height: height
        };
        return {
            width: this.defaultThumbnailDimension,
            height: Math.round(this.defaultThumbnailDimension / aspect)
        };
    }
    /**
   * Resize an image to the target `width` and `height`.
   *
   * Returns a Canvas with the resized image on it.
   */ // eslint-disable-next-line class-methods-use-this
    resizeImage(image, targetWidth, targetHeight) {
        // Resizing in steps refactored to use a solution from
        // https://blog.uploadcare.com/image-resize-in-browsers-is-broken-e38eed08df01
        let img = $f92c4ad36d89e394$var$protect(image);
        let steps = Math.ceil(Math.log2(img.width / targetWidth));
        if (steps < 1) steps = 1;
        let sW = targetWidth * 2 ** (steps - 1);
        let sH = targetHeight * 2 ** (steps - 1);
        const x = 2;
        while(steps--){
            const canvas = document.createElement("canvas");
            canvas.width = sW;
            canvas.height = sH;
            canvas.getContext("2d").drawImage(img, 0, 0, sW, sH);
            img = canvas;
            sW = Math.round(sW / x);
            sH = Math.round(sH / x);
        }
        return img;
    }
    /**
   * Set the preview URL for a file.
   */ setPreviewURL(fileID, preview) {
        this.uppy.setFileState(fileID, {
            preview: preview
        });
    }
    addToQueue(fileID) {
        this.queue.push(fileID);
        if (this.queueProcessing === false) this.processQueue();
    }
    processQueue() {
        this.queueProcessing = true;
        if (this.queue.length > 0) {
            const current = this.uppy.getFile(this.queue.shift());
            if (!current) {
                this.uppy.log("[ThumbnailGenerator] file was removed before a thumbnail could be generated, but not removed from the queue. This is probably a bug", "error");
                return Promise.resolve();
            }
            return this.requestThumbnail(current).catch(()=>{}) // eslint-disable-line node/handle-callback-err
            .then(()=>this.processQueue());
        }
        this.queueProcessing = false;
        this.uppy.log("[ThumbnailGenerator] Emptied thumbnail queue");
        this.uppy.emit("thumbnail:all-generated");
        return Promise.resolve();
    }
    requestThumbnail(file) {
        if ((0, $2e3a76623b3bbcc9$export$2e2bcd8739ae039)(file.type) && !file.isRemote) return this.createThumbnail(file, this.opts.thumbnailWidth, this.opts.thumbnailHeight).then((preview)=>{
            this.setPreviewURL(file.id, preview);
            this.uppy.log(`[ThumbnailGenerator] Generated thumbnail for ${file.id}`);
            this.uppy.emit("thumbnail:generated", this.uppy.getFile(file.id), preview);
        }).catch((err)=>{
            this.uppy.log(`[ThumbnailGenerator] Failed thumbnail for ${file.id}:`, "warning");
            this.uppy.log(err, "warning");
            this.uppy.emit("thumbnail:error", this.uppy.getFile(file.id), err);
        });
        return Promise.resolve();
    }
    install() {
        this.uppy.on("file-removed", this.onFileRemoved);
        this.uppy.on("cancel-all", this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.on("thumbnail:request", this.onFileAdded);
            this.uppy.on("thumbnail:cancel", this.onCancelRequest);
        } else {
            this.uppy.on("thumbnail:request", this.onFileAdded);
            this.uppy.on("file-added", this.onFileAdded);
            this.uppy.on("restored", this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.addPreProcessor(this.waitUntilAllProcessed);
    }
    uninstall() {
        this.uppy.off("file-removed", this.onFileRemoved);
        this.uppy.off("cancel-all", this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.off("thumbnail:request", this.onFileAdded);
            this.uppy.off("thumbnail:cancel", this.onCancelRequest);
        } else {
            this.uppy.off("thumbnail:request", this.onFileAdded);
            this.uppy.off("file-added", this.onFileAdded);
            this.uppy.off("restored", this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.removePreProcessor(this.waitUntilAllProcessed);
    }
}
$f92c4ad36d89e394$export$2e2bcd8739ae039.VERSION = $f92c4ad36d89e394$var$packageJson.version;



/**
 * Find one or more DOM elements.
 */ function $3da4efa7f88c23a6$var$findAllDOMElements(element) {
    if (typeof element === "string") {
        const elements = document.querySelectorAll(element);
        return elements.length === 0 ? null : Array.from(elements);
    }
    if (typeof element === "object" && (0, $dcdea5a9bf8353ff$export$2e2bcd8739ae039)(element)) return [
        element
    ];
    return null;
}
var $3da4efa7f88c23a6$export$2e2bcd8739ae039 = $3da4efa7f88c23a6$var$findAllDOMElements;


/**
 * Converts list into array
 */ var $d737086ca91a9c7d$export$2e2bcd8739ae039 = Array.from;


/**
 * Recursive function, calls the original callback() when the directory is entirely parsed.
 */ function $b08bd893356e01b1$export$2e2bcd8739ae039(directoryReader, oldEntries, logDropError, _ref) {
    let { onSuccess: onSuccess } = _ref;
    directoryReader.readEntries((entries)=>{
        const newEntries = [
            ...oldEntries,
            ...entries
        ];
        // According to the FileSystem API spec, getFilesAndDirectoriesFromDirectory()
        // must be called until it calls the onSuccess with an empty array.
        if (entries.length) queueMicrotask(()=>{
            $b08bd893356e01b1$export$2e2bcd8739ae039(directoryReader, newEntries, logDropError, {
                onSuccess: onSuccess
            });
        });
        else onSuccess(newEntries);
    }, // Make sure we resolve on error anyway, it's fine if only one directory couldn't be parsed!
    (error)=>{
        logDropError(error);
        onSuccess(oldEntries);
    });
}


/**
 * Polyfill for the new (experimental) getAsFileSystemHandle API (using the popular webkitGetAsEntry behind the scenes)
 * so that we can switch to the getAsFileSystemHandle API once it (hopefully) becomes standard
 */ function $e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(entry, logDropError) {
    if (entry == null) return entry;
    return {
        kind: // eslint-disable-next-line no-nested-ternary
        entry.isFile ? "file" : entry.isDirectory ? "directory" : undefined,
        name: entry.name,
        getFile () {
            return new Promise((resolve, reject)=>entry.file(resolve, reject));
        },
        async *values () {
            // If the file is a directory.
            const directoryReader = entry.createReader();
            const entries = await new Promise((resolve)=>{
                (0, $b08bd893356e01b1$export$2e2bcd8739ae039)(directoryReader, [], logDropError, {
                    onSuccess: (dirEntries)=>resolve(dirEntries.map((file)=>$e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(file, logDropError)))
                });
            });
            yield* entries;
        },
        isSameEntry: undefined
    };
}
function $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(entry, relativePath, lastResortFile) {
    try {
        if (lastResortFile === void 0) lastResortFile = undefined;
        return async function*() {
            const getNextRelativePath = ()=>`${relativePath}/${entry.name}`;
            // For each dropped item, - make sure it's a file/directory, and start deepening in!
            if (entry.kind === "file") {
                const file = await entry.getFile();
                if (file != null) {
                    file.relativePath = relativePath ? getNextRelativePath() : null;
                    yield file;
                } else if (lastResortFile != null) yield lastResortFile;
            } else if (entry.kind === "directory") for await (const handle of entry.values())// Recurse on the directory, appending the dir name to the relative path
            yield* $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(handle, relativePath ? getNextRelativePath() : entry.name);
            else if (lastResortFile != null) yield lastResortFile;
        }();
    } catch (e) {
        return Promise.reject(e);
    }
}
async function* $e30d9f0f4292db6d$export$2e2bcd8739ae039(dataTransfer, logDropError) {
    // Retrieving the dropped items must happen synchronously
    // otherwise only the first item gets treated and the other ones are garbage collected.
    // https://github.com/transloadit/uppy/pull/3998
    const fileSystemHandles = await Promise.all(Array.from(dataTransfer.items, async (item)=>{
        var _fileSystemHandle;
        let fileSystemHandle;
        // TODO enable getAsFileSystemHandle API once we can get it working with subdirectories
        // IMPORTANT: Need to check isSecureContext *before* calling getAsFileSystemHandle
        // or else Chrome will crash when running in HTTP: https://github.com/transloadit/uppy/issues/4133
        // if (window.isSecureContext && item.getAsFileSystemHandle != null)
        // fileSystemHandle = await item.getAsFileSystemHandle()
        // `webkitGetAsEntry` exists in all popular browsers (including non-WebKit browsers),
        // however it may be renamed to getAsEntry() in the future, so you should code defensively, looking for both.
        // from https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
        const getAsEntry = ()=>typeof item.getAsEntry === "function" ? item.getAsEntry() : item.webkitGetAsEntry();
        // eslint-disable-next-line prefer-const
        (_fileSystemHandle = fileSystemHandle) != null ? _fileSystemHandle : fileSystemHandle = $e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
        return {
            fileSystemHandle: fileSystemHandle,
            lastResortFile: item.getAsFile() // can be used as a fallback in case other methods fail
        };
    }));
    for (const { lastResortFile: lastResortFile, fileSystemHandle: fileSystemHandle } of fileSystemHandles){
        // fileSystemHandle and lastResortFile can be null when we drop an url.
        if (fileSystemHandle != null) try {
            yield* $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(fileSystemHandle, "", lastResortFile);
        } catch (err) {
            // Example: If dropping a symbolic link, Chromium will throw:
            // "DOMException: A requested file or directory could not be found at the time an operation was processed.",
            // So we will use lastResortFile instead. See https://github.com/transloadit/uppy/issues/3505.
            if (lastResortFile != null) yield lastResortFile;
            else logDropError(err);
        }
        else if (lastResortFile != null) yield lastResortFile;
    }
}



function $d5d92a586549e3b5$export$2e2bcd8739ae039(dataTransfer) {
    const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(dataTransfer.files);
    return Promise.resolve(files);
}


async function $954bacbcaff60289$export$2e2bcd8739ae039(dataTransfer, options) {
    var _options$logDropError;
    // Get all files from all subdirs. Works (at least) in Chrome, Mozilla, and Safari
    const logDropError = (_options$logDropError = options == null ? void 0 : options.logDropError) != null ? _options$logDropError : Function.prototype;
    try {
        const accumulator = [];
        for await (const file of (0, $e30d9f0f4292db6d$export$2e2bcd8739ae039)(dataTransfer, logDropError))accumulator.push(file);
        return accumulator;
    // Otherwise just return all first-order files
    } catch  {
        return (0, $d5d92a586549e3b5$export$2e2bcd8739ae039)(dataTransfer);
    }
}



var $11d558640132ea3e$exports = {};
"use strict";



/* eslint-disable react/require-default-props */ 

var $e28f05d17e052ff9$var$t, $e28f05d17e052ff9$var$r, $e28f05d17e052ff9$var$u, $e28f05d17e052ff9$var$i, $e28f05d17e052ff9$var$o = 0, $e28f05d17e052ff9$var$f = [], $e28f05d17e052ff9$var$c = [], $e28f05d17e052ff9$var$e = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2), $e28f05d17e052ff9$var$a = $e28f05d17e052ff9$var$e.__b, $e28f05d17e052ff9$var$v = $e28f05d17e052ff9$var$e.__r, $e28f05d17e052ff9$var$l = $e28f05d17e052ff9$var$e.diffed, $e28f05d17e052ff9$var$m = $e28f05d17e052ff9$var$e.__c, $e28f05d17e052ff9$var$s = $e28f05d17e052ff9$var$e.unmount, $e28f05d17e052ff9$var$d = $e28f05d17e052ff9$var$e.__;
function $e28f05d17e052ff9$var$h(n, t) {
    $e28f05d17e052ff9$var$e.__h && $e28f05d17e052ff9$var$e.__h($e28f05d17e052ff9$var$r, n, $e28f05d17e052ff9$var$o || t), $e28f05d17e052ff9$var$o = 0;
    var u = $e28f05d17e052ff9$var$r.__H || ($e28f05d17e052ff9$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({
        __V: $e28f05d17e052ff9$var$c
    }), u.__[n];
}
function $e28f05d17e052ff9$export$60241385465d0a34(n) {
    return $e28f05d17e052ff9$var$o = 1, $e28f05d17e052ff9$export$13e3392192263954($e28f05d17e052ff9$var$D, n);
}
function $e28f05d17e052ff9$export$13e3392192263954(n, u, i) {
    var o = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $e28f05d17e052ff9$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $e28f05d17e052ff9$var$r, !$e28f05d17e052ff9$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $e28f05d17e052ff9$var$r.u = !0;
        var c = $e28f05d17e052ff9$var$r.shouldComponentUpdate, e = $e28f05d17e052ff9$var$r.componentWillUpdate;
        $e28f05d17e052ff9$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $e28f05d17e052ff9$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $e28f05d17e052ff9$export$6d9c69b0de29b591(n, u) {
    var i = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 3);
    !$e28f05d17e052ff9$var$e.__s && $e28f05d17e052ff9$var$C(i.__H, u) && (i.__ = n, i.i = u, $e28f05d17e052ff9$var$r.__H.__h.push(i));
}
function $e28f05d17e052ff9$export$e5c5a5f917a5871c(n, u) {
    var i = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 4);
    !$e28f05d17e052ff9$var$e.__s && $e28f05d17e052ff9$var$C(i.__H, u) && (i.__ = n, i.i = u, $e28f05d17e052ff9$var$r.__h.push(i));
}
function $e28f05d17e052ff9$export$b8f5890fc79d6aca(n) {
    return $e28f05d17e052ff9$var$o = 5, $e28f05d17e052ff9$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $e28f05d17e052ff9$export$d5a552a76deda3c2(n, t, r) {
    $e28f05d17e052ff9$var$o = 6, $e28f05d17e052ff9$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $e28f05d17e052ff9$export$1538c33de8887b59(n, r) {
    var u = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 7);
    return $e28f05d17e052ff9$var$C(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $e28f05d17e052ff9$export$35808ee640e87ca7(n, t) {
    return $e28f05d17e052ff9$var$o = 8, $e28f05d17e052ff9$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $e28f05d17e052ff9$export$fae74005e78b1a27(n) {
    var u = $e28f05d17e052ff9$var$r.context[n.__c], i = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($e28f05d17e052ff9$var$r)), u.props.value) : n.__;
}
function $e28f05d17e052ff9$export$dc8fbce3eb94dc1e(n, t) {
    $e28f05d17e052ff9$var$e.useDebugValue && $e28f05d17e052ff9$var$e.useDebugValue(t ? t(n) : n);
}
function $e28f05d17e052ff9$export$c052f6604b7d51fe(n) {
    var u = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 10), i = $e28f05d17e052ff9$export$60241385465d0a34();
    return u.__ = n, $e28f05d17e052ff9$var$r.componentDidCatch || ($e28f05d17e052ff9$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $e28f05d17e052ff9$export$f680877a34711e37() {
    var n = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 11);
    if (!n.__) {
        for(var u = $e28f05d17e052ff9$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $e28f05d17e052ff9$var$j() {
    for(var n; n = $e28f05d17e052ff9$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($e28f05d17e052ff9$var$z), n.__H.__h.forEach($e28f05d17e052ff9$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $e28f05d17e052ff9$var$e.__e(t, n.__v);
    }
}
$e28f05d17e052ff9$var$e.__b = function(n) {
    $e28f05d17e052ff9$var$r = null, $e28f05d17e052ff9$var$a && $e28f05d17e052ff9$var$a(n);
}, $e28f05d17e052ff9$var$e.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $e28f05d17e052ff9$var$d && $e28f05d17e052ff9$var$d(n, t);
}, $e28f05d17e052ff9$var$e.__r = function(n) {
    $e28f05d17e052ff9$var$v && $e28f05d17e052ff9$var$v(n), $e28f05d17e052ff9$var$t = 0;
    var i = ($e28f05d17e052ff9$var$r = n.__c).__H;
    i && ($e28f05d17e052ff9$var$u === $e28f05d17e052ff9$var$r ? (i.__h = [], $e28f05d17e052ff9$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $e28f05d17e052ff9$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($e28f05d17e052ff9$var$z), i.__h.forEach($e28f05d17e052ff9$var$B), i.__h = [], $e28f05d17e052ff9$var$t = 0)), $e28f05d17e052ff9$var$u = $e28f05d17e052ff9$var$r;
}, $e28f05d17e052ff9$var$e.diffed = function(n) {
    $e28f05d17e052ff9$var$l && $e28f05d17e052ff9$var$l(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $e28f05d17e052ff9$var$f.push(t) && $e28f05d17e052ff9$var$i === $e28f05d17e052ff9$var$e.requestAnimationFrame || (($e28f05d17e052ff9$var$i = $e28f05d17e052ff9$var$e.requestAnimationFrame) || $e28f05d17e052ff9$var$w)($e28f05d17e052ff9$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $e28f05d17e052ff9$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $e28f05d17e052ff9$var$c;
    })), $e28f05d17e052ff9$var$u = $e28f05d17e052ff9$var$r = null;
}, $e28f05d17e052ff9$var$e.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($e28f05d17e052ff9$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $e28f05d17e052ff9$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $e28f05d17e052ff9$var$e.__e(r, n.__v);
        }
    }), $e28f05d17e052ff9$var$m && $e28f05d17e052ff9$var$m(n, t);
}, $e28f05d17e052ff9$var$e.unmount = function(n) {
    $e28f05d17e052ff9$var$s && $e28f05d17e052ff9$var$s(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $e28f05d17e052ff9$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $e28f05d17e052ff9$var$e.__e(t, r.__v));
};
var $e28f05d17e052ff9$var$k = "function" == typeof requestAnimationFrame;
function $e28f05d17e052ff9$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $e28f05d17e052ff9$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $e28f05d17e052ff9$var$k && (t = requestAnimationFrame(r));
}
function $e28f05d17e052ff9$var$z(n) {
    var t = $e28f05d17e052ff9$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $e28f05d17e052ff9$var$r = t;
}
function $e28f05d17e052ff9$var$B(n) {
    var t = $e28f05d17e052ff9$var$r;
    n.__c = n.__(), $e28f05d17e052ff9$var$r = t;
}
function $e28f05d17e052ff9$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $e28f05d17e052ff9$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $616f0acd28bd0dc4$var$GoogleIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        "fill-rule": "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#FFF",
        cx: "13",
        cy: "13",
        r: "13"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M21.64 13.205c0-.639-.057-1.252-.164-1.841H13v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z",
        fill: "#4285F4",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13 22c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H4.957v2.332A8.997 8.997 0 0013 22z",
        fill: "#34A853",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.964 14.71A5.41 5.41 0 017.682 13c0-.593.102-1.17.282-1.71V8.958H4.957A8.996 8.996 0 004 13c0 1.452.348 2.827.957 4.042l3.007-2.332z",
        fill: "#FBBC05",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13 7.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C17.463 4.891 15.426 4 13 4a8.997 8.997 0 00-8.043 4.958l3.007 2.332C8.672 9.163 10.656 7.58 13 7.58z",
        fill: "#EA4335",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4 4h18v18H4z"
    })));
}
function $616f0acd28bd0dc4$var$DefaultForm(_ref) {
    let { pluginName: pluginName, i18n: i18n, onAuth: onAuth } = _ref;
    // In order to comply with Google's brand we need to create a different button
    // for the Google Drive plugin
    const isGoogleDrive = pluginName === "Google Drive";
    const onSubmit = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((e)=>{
        e.preventDefault();
        onAuth();
    }, [
        onAuth
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("form", {
        onSubmit: onSubmit
    }, isGoogleDrive ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn uppy-Provider-btn-google",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($616f0acd28bd0dc4$var$GoogleIcon, null), i18n("signInWithGoogle")) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn",
        "data-uppy-super-focusable": true
    }, i18n("authenticateWith", {
        pluginName: pluginName
    })));
}
const $616f0acd28bd0dc4$var$defaultRenderForm = (_ref2)=>{
    let { pluginName: pluginName, i18n: i18n, onAuth: onAuth } = _ref2;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($616f0acd28bd0dc4$var$DefaultForm, {
        pluginName: pluginName,
        i18n: i18n,
        onAuth: onAuth
    });
};
function $616f0acd28bd0dc4$export$2e2bcd8739ae039(props) {
    const { loading: loading, pluginName: pluginName, pluginIcon: pluginIcon, i18n: i18n, handleAuth: handleAuth, renderForm: renderForm = $616f0acd28bd0dc4$var$defaultRenderForm } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-auth"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-authIcon"
    }, pluginIcon()), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-authTitle"
    }, i18n("authenticateWithTitle", {
        pluginName: pluginName
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-authForm"
    }, renderForm({
        pluginName: pluginName,
        i18n: i18n,
        loading: loading,
        onAuth: handleAuth
    })));
}


/* eslint-disable react/destructuring-assignment */ 

function $4ee9dcacd7f26785$export$2e2bcd8739ae039(_ref) {
    let { i18n: i18n, logout: logout, username: username } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-ProviderBrowser-user",
        key: "username"
    }, username), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        onClick: logout,
        className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowser-userLogout",
        key: "logout"
    }, i18n("logOut")));
}



const $48839592a474f204$var$Breadcrumb = (props)=>{
    const { getFolder: getFolder, title: title, isLast: isLast } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        onClick: getFolder
    }, title), !isLast ? " / " : "");
};
function $48839592a474f204$export$2e2bcd8739ae039(props) {
    const { getFolder: getFolder, title: title, breadcrumbsIcon: breadcrumbsIcon, breadcrumbs: breadcrumbs } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-breadcrumbs"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-breadcrumbsIcon"
    }, breadcrumbsIcon), breadcrumbs.map((directory, i)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($48839592a474f204$var$Breadcrumb, {
            key: directory.id,
            getFolder: ()=>getFolder(directory.requestPath, directory.name),
            title: i === 0 ? title : directory.name,
            isLast: i + 1 === breadcrumbs.length
        })));
}


function $6b1b801e011f359f$export$2e2bcd8739ae039(props) {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, props.showBreadcrumbs && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $48839592a474f204$export$2e2bcd8739ae039), {
        getFolder: props.getFolder,
        breadcrumbs: props.breadcrumbs,
        breadcrumbsIcon: props.pluginIcon && props.pluginIcon(),
        title: props.title
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4ee9dcacd7f26785$export$2e2bcd8739ae039), {
        logout: props.logout,
        username: props.username,
        i18n: props.i18n
    }));
}


/* eslint-disable react/require-default-props */ 


function $d0cca3c9705b0857$export$2e2bcd8739ae039(file) {
    return {
        ...file,
        type: file.mimeType,
        extension: file.name ? (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.name).extension : null
    };
}




function $aba06cd85441b3f8$var$_extends() {
    $aba06cd85441b3f8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aba06cd85441b3f8$var$_extends.apply(this, arguments);
}
const $aba06cd85441b3f8$var$STYLE_INNER = {
    position: "relative",
    // Disabled for our use case: the wrapper elements around FileList already deal with overflow,
    // and this additional property would hide things that we want to show.
    //
    // overflow: 'hidden',
    width: "100%",
    minHeight: "100%"
};
const $aba06cd85441b3f8$var$STYLE_CONTENT = {
    position: "absolute",
    top: 0,
    left: 0,
    // Because the `top` value gets set to some offset, this `height` being 100% would make the scrollbar
    // stretch far beyond the content. For our use case, the content div actually can get its height from
    // the elements inside it, so we don't need to specify a `height` property at all.
    //
    // height: '100%',
    width: "100%",
    overflow: "visible"
};
class $aba06cd85441b3f8$var$VirtualList extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        // The currently focused node, used to retain focus when the visible rows change.
        // To avoid update loops, this should not cause state updates, so it's kept as a plain property.
        this.handleScroll = ()=>{
            this.setState({
                offset: this.base.scrollTop
            });
        };
        this.handleResize = ()=>{
            this.resize();
        };
        this.focusElement = null;
        this.state = {
            offset: 0,
            height: 0
        };
    }
    componentDidMount() {
        this.resize();
        window.addEventListener("resize", this.handleResize);
    }
    // TODO: refactor to stable lifecycle method
    // eslint-disable-next-line
    componentWillUpdate() {
        if (this.base.contains(document.activeElement)) this.focusElement = document.activeElement;
    }
    componentDidUpdate() {
        // Maintain focus when rows are added and removed.
        if (this.focusElement && this.focusElement.parentNode && document.activeElement !== this.focusElement) this.focusElement.focus();
        this.focusElement = null;
        this.resize();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }
    resize() {
        const { height: height } = this.state;
        if (height !== this.base.offsetHeight) this.setState({
            height: this.base.offsetHeight
        });
    }
    render(_ref) {
        let { data: data, rowHeight: rowHeight, renderRow: renderRow, overscanCount: overscanCount = 10, ...props } = _ref;
        const { offset: offset, height: height } = this.state;
        // first visible row index
        let start = Math.floor(offset / rowHeight);
        // actual number of visible rows (without overscan)
        let visibleRowCount = Math.floor(height / rowHeight);
        // Overscan: render blocks of rows modulo an overscan row count
        // This dramatically reduces DOM writes during scrolling
        if (overscanCount) {
            start = Math.max(0, start - start % overscanCount);
            visibleRowCount += overscanCount;
        }
        // last visible + overscan row index + padding to allow keyboard focus to travel past the visible area
        const end = start + visibleRowCount + 4;
        // data slice currently in viewport plus overscan items
        const selection = data.slice(start, end);
        const styleInner = {
            ...$aba06cd85441b3f8$var$STYLE_INNER,
            height: data.length * rowHeight
        };
        const styleContent = {
            ...$aba06cd85441b3f8$var$STYLE_CONTENT,
            top: start * rowHeight
        };
        // The `role="presentation"` attributes ensure that these wrapper elements are not treated as list
        // items by accessibility and outline tools.
        return(// eslint-disable-next-line react/jsx-props-no-spreading
        (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", $aba06cd85441b3f8$var$_extends({
            onScroll: this.handleScroll
        }, props), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            role: "presentation",
            style: styleInner
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            role: "presentation",
            style: styleContent
        }, selection.map(renderRow)))));
    }
}
var $aba06cd85441b3f8$export$2e2bcd8739ae039 = $aba06cd85441b3f8$var$VirtualList;


/* eslint-disable react/require-default-props */ 

let $a0ee3b646e338d67$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $a0ee3b646e338d67$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $a0ee3b646e338d67$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $a0ee3b646e338d67$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


function $a64872f8825ef0cd$export$2e2bcd8739ae039(props) {
    const { search: search, searchOnInput: searchOnInput, searchTerm: searchTerm, showButton: showButton, inputLabel: inputLabel, clearSearchLabel: clearSearchLabel, buttonLabel: buttonLabel, clearSearch: clearSearch, inputClassName: inputClassName, buttonCSSClassName: buttonCSSClassName } = props;
    const [searchText, setSearchText] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(searchTerm != null ? searchTerm : "");
    // const debouncedSearch = debounce((q) => search(q), 1000)
    const validateAndSearch = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        ev.preventDefault();
        search(searchText);
    }, [
        search,
        searchText
    ]);
    const handleInput = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        const inputValue = ev.target.value;
        setSearchText(inputValue);
        if (searchOnInput) search(inputValue);
    }, [
        setSearchText,
        searchOnInput,
        search
    ]);
    const handleReset = ()=>{
        setSearchText("");
        if (clearSearch) clearSearch();
    };
    const [form] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(()=>{
        const formEl = document.createElement("form");
        formEl.setAttribute("tabindex", "-1");
        formEl.id = (0, $a0ee3b646e338d67$export$ac4959f4f1338dfc)();
        return formEl;
    });
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        document.body.appendChild(form);
        form.addEventListener("submit", validateAndSearch);
        return ()=>{
            form.removeEventListener("submit", validateAndSearch);
            document.body.removeChild(form);
        };
    }, [
        form,
        validateAndSearch
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        className: `uppy-u-reset ${inputClassName}`,
        type: "search",
        "aria-label": inputLabel,
        placeholder: inputLabel,
        value: searchText,
        onInput: handleInput,
        form: form.id,
        "data-uppy-super-focusable": true
    }), !showButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-ProviderBrowser-searchFilterIcon",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8.638 7.99l3.172 3.172a.492.492 0 1 1-.697.697L7.91 8.656a4.977 4.977 0 0 1-2.983.983C2.206 9.639 0 7.481 0 4.819 0 2.158 2.206 0 4.927 0c2.721 0 4.927 2.158 4.927 4.82a4.74 4.74 0 0 1-1.216 3.17zm-3.71.685c2.176 0 3.94-1.726 3.94-3.856 0-2.129-1.764-3.855-3.94-3.855C2.75.964.984 2.69.984 4.819c0 2.13 1.765 3.856 3.942 3.856z"
    })), !showButton && searchText && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-ProviderBrowser-searchFilterReset",
        type: "button",
        "aria-label": clearSearchLabel,
        title: clearSearchLabel,
        onClick: handleReset
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        viewBox: "0 0 19 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M17.318 17.232L9.94 9.854 9.586 9.5l-.354.354-7.378 7.378h.707l-.62-.62v.706L9.318 9.94l.354-.354-.354-.354L1.94 1.854v.707l.62-.62h-.706l7.378 7.378.354.354.354-.354 7.378-7.378h-.707l.622.62v-.706L9.854 9.232l-.354.354.354.354 7.378 7.378.708-.707-7.38-7.378v.708l7.38-7.38.353-.353-.353-.353-.622-.622-.353-.353-.354.352-7.378 7.38h.708L2.56 1.23 2.208.88l-.353.353-.622.62-.353.355.352.353 7.38 7.38v-.708l-7.38 7.38-.353.353.352.353.622.622.353.353.354-.353 7.38-7.38h-.708l7.38 7.38z"
    }))), showButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: `uppy-u-reset uppy-c-btn uppy-c-btn-primary ${buttonCSSClassName}`,
        type: "submit",
        form: form.id
    }, buttonLabel));
}



function $4ab2a94a3ee5ad67$export$2e2bcd8739ae039(_ref) {
    let { cancel: cancel, done: done, i18n: i18n, selected: selected } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-footer"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary",
        onClick: done,
        type: "button"
    }, i18n("selectX", {
        smart_count: selected
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-link",
        onClick: cancel,
        type: "button"
    }, i18n("cancel")));
}




/* eslint-disable react/require-default-props */ 
function $eeb730e0d52603b2$var$FileIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: 11,
        height: 14.5,
        viewBox: "0 0 44 58"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M27.437.517a1 1 0 0 0-.094.03H4.25C2.037.548.217 2.368.217 4.58v48.405c0 2.212 1.82 4.03 4.03 4.03H39.03c2.21 0 4.03-1.818 4.03-4.03V15.61a1 1 0 0 0-.03-.28 1 1 0 0 0 0-.093 1 1 0 0 0-.03-.032 1 1 0 0 0 0-.03 1 1 0 0 0-.032-.063 1 1 0 0 0-.03-.063 1 1 0 0 0-.032 0 1 1 0 0 0-.03-.063 1 1 0 0 0-.032-.03 1 1 0 0 0-.03-.063 1 1 0 0 0-.063-.062l-14.593-14a1 1 0 0 0-.062-.062A1 1 0 0 0 28 .708a1 1 0 0 0-.374-.157 1 1 0 0 0-.156 0 1 1 0 0 0-.03-.03l-.003-.003zM4.25 2.547h22.218v9.97c0 2.21 1.82 4.03 4.03 4.03h10.564v36.438a2.02 2.02 0 0 1-2.032 2.032H4.25c-1.13 0-2.032-.9-2.032-2.032V4.58c0-1.13.902-2.032 2.03-2.032zm24.218 1.345l10.375 9.937.75.718H30.5c-1.13 0-2.032-.9-2.032-2.03V3.89z"
    }));
}
function $eeb730e0d52603b2$var$FolderIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        style: {
            minWidth: 16,
            marginRight: 3
        },
        viewBox: "0 0 276.157 276.157"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M273.08 101.378c-3.3-4.65-8.86-7.32-15.254-7.32h-24.34V67.59c0-10.2-8.3-18.5-18.5-18.5h-85.322c-3.63 0-9.295-2.875-11.436-5.805l-6.386-8.735c-4.982-6.814-15.104-11.954-23.546-11.954H58.73c-9.292 0-18.638 6.608-21.737 15.372l-2.033 5.752c-.958 2.71-4.72 5.37-7.596 5.37H18.5C8.3 49.09 0 57.39 0 67.59v167.07c0 .886.16 1.73.443 2.52.152 3.306 1.18 6.424 3.053 9.064 3.3 4.652 8.86 7.32 15.255 7.32h188.487c11.395 0 23.27-8.425 27.035-19.18l40.677-116.188c2.11-6.035 1.43-12.164-1.87-16.816zM18.5 64.088h8.864c9.295 0 18.64-6.607 21.738-15.37l2.032-5.75c.96-2.712 4.722-5.373 7.597-5.373h29.565c3.63 0 9.295 2.876 11.437 5.806l6.386 8.735c4.982 6.815 15.104 11.954 23.546 11.954h85.322c1.898 0 3.5 1.602 3.5 3.5v26.47H69.34c-11.395 0-23.27 8.423-27.035 19.178L15 191.23V67.59c0-1.898 1.603-3.5 3.5-3.5zm242.29 49.15l-40.676 116.188c-1.674 4.78-7.812 9.135-12.877 9.135H18.75c-1.447 0-2.576-.372-3.02-.997-.442-.625-.422-1.814.057-3.18l40.677-116.19c1.674-4.78 7.812-9.134 12.877-9.134h188.487c1.448 0 2.577.372 3.02.997.443.625.423 1.814-.056 3.18z"
    }));
}
function $eeb730e0d52603b2$var$VideoIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        style: {
            width: 16,
            marginRight: 4
        },
        viewBox: "0 0 58 58"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M36.537 28.156l-11-7a1.005 1.005 0 0 0-1.02-.033C24.2 21.3 24 21.635 24 22v14a1 1 0 0 0 1.537.844l11-7a1.002 1.002 0 0 0 0-1.688zM26 34.18V23.82L34.137 29 26 34.18z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M57 6H1a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM10 28H2v-9h8v9zm-8 2h8v9H2v-9zm10 10V8h34v42H12V40zm44-12h-8v-9h8v9zm-8 2h8v9h-8v-9zm8-22v9h-8V8h8zM2 8h8v9H2V8zm0 42v-9h8v9H2zm54 0h-8v-9h8v9z"
    }));
}
function $eeb730e0d52603b2$export$2e2bcd8739ae039(props) {
    const { itemIconString: itemIconString } = props;
    if (itemIconString === null) return null;
    switch(itemIconString){
        case "file":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$FileIcon, null);
        case "folder":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$FolderIcon, null);
        case "video":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$VideoIcon, null);
        default:
            {
                const { alt: alt } = props;
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("img", {
                    src: itemIconString,
                    alt: alt,
                    referrerPolicy: "no-referrer",
                    loading: "lazy",
                    width: 16,
                    height: 16
                });
            }
    }
}


/* eslint-disable react/require-default-props */ 

function $34c44cdae6ac04e3$var$GridListItem(props) {
    const { className: className, isDisabled: isDisabled, restrictionError: restrictionError, isChecked: isChecked, title: title, itemIconEl: itemIconEl, showTitles: showTitles, toggleCheckbox: toggleCheckbox, recordShiftKeyPress: recordShiftKeyPress, id: id, children: children } = props;
    const checkBoxClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-u-reset", "uppy-ProviderBrowserItem-checkbox", "uppy-ProviderBrowserItem-checkbox--grid", {
        "uppy-ProviderBrowserItem-checkbox--is-checked": isChecked
    });
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("li", {
        className: className,
        title: isDisabled ? restrictionError == null ? void 0 : restrictionError.message : undefined
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        type: "checkbox",
        className: checkBoxClassName,
        onChange: toggleCheckbox,
        onKeyDown: recordShiftKeyPress,
        onMouseDown: recordShiftKeyPress,
        name: "listitem",
        id: id,
        checked: isChecked,
        disabled: isDisabled,
        "data-uppy-super-focusable": true
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
        htmlFor: id,
        "aria-label": title,
        className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
    }, itemIconEl, showTitles && title, children));
}
var $34c44cdae6ac04e3$export$2e2bcd8739ae039 = $34c44cdae6ac04e3$var$GridListItem;


/* eslint-disable react/require-default-props */ 
function $1a9b1423cd47af37$export$2e2bcd8739ae039(props) {
    const { className: className, isDisabled: isDisabled, restrictionError: restrictionError, isCheckboxDisabled: isCheckboxDisabled, isChecked: isChecked, toggleCheckbox: toggleCheckbox, recordShiftKeyPress: recordShiftKeyPress, type: type, id: id, itemIconEl: itemIconEl, title: title, handleFolderClick: handleFolderClick, showTitles: showTitles, i18n: i18n } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("li", {
        className: className,
        title: isDisabled ? restrictionError == null ? void 0 : restrictionError.message : undefined
    }, !isCheckboxDisabled ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        type: "checkbox",
        className: `uppy-u-reset uppy-ProviderBrowserItem-checkbox ${isChecked ? "uppy-ProviderBrowserItem-checkbox--is-checked" : ""}`,
        onChange: toggleCheckbox,
        onKeyDown: recordShiftKeyPress,
        onMouseDown: recordShiftKeyPress,
        name: "listitem",
        id: id,
        checked: isChecked,
        "aria-label": type === "file" ? null : i18n("allFilesFromFolderNamed", {
            name: title
        }),
        disabled: isDisabled,
        "data-uppy-super-focusable": true
    }) : null, type === "file" ? // label for a checkbox
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
        htmlFor: id,
        className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowserItem-iconWrap"
    }, itemIconEl), showTitles && title) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowserItem-inner",
        onClick: handleFolderClick,
        "aria-label": i18n("openFolderNamed", {
            name: title
        })
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowserItem-iconWrap"
    }, itemIconEl), showTitles && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, title)));
}


function $7f388d6d579fe299$var$_extends() {
    $7f388d6d579fe299$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7f388d6d579fe299$var$_extends.apply(this, arguments);
}
function $7f388d6d579fe299$export$2e2bcd8739ae039(props) {
    const { author: author, getItemIcon: getItemIcon, isChecked: isChecked, isDisabled: isDisabled, viewType: viewType } = props;
    const itemIconString = getItemIcon();
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-ProviderBrowserItem", {
        "uppy-ProviderBrowserItem--selected": isChecked
    }, {
        "uppy-ProviderBrowserItem--disabled": isDisabled
    }, {
        "uppy-ProviderBrowserItem--noPreview": itemIconString === "video"
    });
    const itemIconEl = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $eeb730e0d52603b2$export$2e2bcd8739ae039), {
        itemIconString: itemIconString
    });
    switch(viewType){
        case "grid":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $34c44cdae6ac04e3$export$2e2bcd8739ae039), $7f388d6d579fe299$var$_extends({}, props, {
                className: className,
                itemIconEl: itemIconEl
            }));
        case "list":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $1a9b1423cd47af37$export$2e2bcd8739ae039), $7f388d6d579fe299$var$_extends({}, props, {
                className: className,
                itemIconEl: itemIconEl
            }));
        case "unsplash":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $34c44cdae6ac04e3$export$2e2bcd8739ae039), $7f388d6d579fe299$var$_extends({}, props, {
                className: className,
                itemIconEl: itemIconEl
            }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
                href: `${author.url}?utm_source=Companion&utm_medium=referral`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "uppy-ProviderBrowserItem-author",
                tabIndex: -1
            }, author.name));
        default:
            throw new Error(`There is no such type ${viewType}`);
    }
}


const $ffc120143b595bcb$var$VIRTUAL_SHARED_DIR = "shared-with-me";
function $ffc120143b595bcb$var$ListItem(props) {
    const { currentSelection: currentSelection, uppyFiles: uppyFiles, viewType: viewType, isChecked: isChecked, toggleCheckbox: toggleCheckbox, recordShiftKeyPress: recordShiftKeyPress, showTitles: showTitles, i18n: i18n, validateRestrictions: validateRestrictions, getNextFolder: getNextFolder, f: f } = props;
    if (f.isFolder) return (0, $7f388d6d579fe299$export$2e2bcd8739ae039)({
        showTitles: showTitles,
        viewType: viewType,
        i18n: i18n,
        id: f.id,
        title: f.name,
        getItemIcon: ()=>f.icon,
        isChecked: isChecked(f),
        toggleCheckbox: (event)=>toggleCheckbox(event, f),
        recordShiftKeyPress: recordShiftKeyPress,
        type: "folder",
        // TODO: when was this supposed to be true?
        isDisabled: false,
        isCheckboxDisabled: f.id === $ffc120143b595bcb$var$VIRTUAL_SHARED_DIR,
        // getNextFolder always exists when f.isFolder is true
        handleFolderClick: ()=>getNextFolder(f)
    });
    const restrictionError = validateRestrictions((0, $d0cca3c9705b0857$export$2e2bcd8739ae039)(f), [
        ...uppyFiles,
        ...currentSelection
    ]);
    return (0, $7f388d6d579fe299$export$2e2bcd8739ae039)({
        id: f.id,
        title: f.name,
        author: f.author,
        getItemIcon: ()=>f.icon,
        isChecked: isChecked(f),
        toggleCheckbox: (event)=>toggleCheckbox(event, f),
        isCheckboxDisabled: false,
        recordShiftKeyPress: recordShiftKeyPress,
        showTitles: showTitles,
        viewType: viewType,
        i18n: i18n,
        type: "file",
        isDisabled: Boolean(restrictionError) && !isChecked(f),
        restrictionError: restrictionError
    });
}
function $ffc120143b595bcb$var$Browser(props) {
    const { currentSelection: currentSelection, folders: folders, files: files, uppyFiles: uppyFiles, viewType: viewType, headerComponent: headerComponent, showBreadcrumbs: showBreadcrumbs, isChecked: isChecked, toggleCheckbox: toggleCheckbox, recordShiftKeyPress: recordShiftKeyPress, handleScroll: handleScroll, showTitles: showTitles, i18n: i18n, validateRestrictions: validateRestrictions, isLoading: isLoading, showSearchFilter: showSearchFilter, search: search, searchTerm: searchTerm, clearSearch: clearSearch, searchOnInput: searchOnInput, searchInputLabel: searchInputLabel, clearSearchLabel: clearSearchLabel, getNextFolder: getNextFolder, cancel: cancel, done: done, noResultsLabel: noResultsLabel, loadAllFiles: loadAllFiles } = props;
    const selected = currentSelection.length;
    const rows = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>[
            ...folders,
            ...files
        ], [
        folders,
        files
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-ProviderBrowser", `uppy-ProviderBrowser-viewType--${viewType}`)
    }, headerComponent && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-header"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-ProviderBrowser-headerBar", !showBreadcrumbs && "uppy-ProviderBrowser-headerBar--simple")
    }, headerComponent)), showSearchFilter && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        class: "uppy-ProviderBrowser-searchFilter"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $a64872f8825ef0cd$export$2e2bcd8739ae039), {
        search: search,
        searchTerm: searchTerm,
        clearSearch: clearSearch,
        inputLabel: searchInputLabel,
        clearSearchLabel: clearSearchLabel,
        inputClassName: "uppy-ProviderBrowser-searchFilterInput",
        searchOnInput: searchOnInput
    })), (()=>{
        if (isLoading) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Provider-loading"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, i18n("loading")));
        if (!folders.length && !files.length) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Provider-empty"
        }, noResultsLabel);
        if (loadAllFiles) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-ProviderBrowser-body"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("ul", {
            className: "uppy-ProviderBrowser-list"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aba06cd85441b3f8$export$2e2bcd8739ae039), {
            data: rows,
            renderRow: (f)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($ffc120143b595bcb$var$ListItem, {
                    currentSelection: currentSelection,
                    uppyFiles: uppyFiles,
                    viewType: viewType,
                    isChecked: isChecked,
                    toggleCheckbox: toggleCheckbox,
                    recordShiftKeyPress: recordShiftKeyPress,
                    showTitles: showTitles,
                    i18n: i18n,
                    validateRestrictions: validateRestrictions,
                    getNextFolder: getNextFolder,
                    f: f
                }),
            rowHeight: 31
        })));
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-ProviderBrowser-body"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("ul", {
            className: "uppy-ProviderBrowser-list",
            onScroll: handleScroll,
            role: "listbox",
            tabIndex: -1
        }, rows.map((f)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($ffc120143b595bcb$var$ListItem, {
                currentSelection: currentSelection,
                uppyFiles: uppyFiles,
                viewType: viewType,
                isChecked: isChecked,
                toggleCheckbox: toggleCheckbox,
                recordShiftKeyPress: recordShiftKeyPress,
                showTitles: showTitles,
                i18n: i18n,
                validateRestrictions: validateRestrictions,
                getNextFolder: getNextFolder,
                f: f
            }))));
    })(), selected > 0 && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4ab2a94a3ee5ad67$export$2e2bcd8739ae039), {
        selected: selected,
        done: done,
        cancel: cancel,
        i18n: i18n
    }));
}
var $ffc120143b595bcb$export$2e2bcd8739ae039 = $ffc120143b595bcb$var$Browser;



class $284651d7489bd34f$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    componentWillUnmount() {
        const { onUnmount: onUnmount } = this.props;
        onUnmount();
    }
    render() {
        const { children: children } = this.props;
        return (0, $4d2e93495e50cc85$export$47e4c5b300681277)(children)[0];
    }
}





class $2b848f45ec727ac0$export$2e2bcd8739ae039 {
    constructor(plugin, opts){
        this.filterItems = (items)=>{
            const state = this.plugin.getPluginState();
            if (!state.filterInput || state.filterInput === "") return items;
            return items.filter((folder)=>{
                return folder.name.toLowerCase().indexOf(state.filterInput.toLowerCase()) !== -1;
            });
        };
        this.recordShiftKeyPress = (e)=>{
            this.isShiftKeyPressed = e.shiftKey;
        };
        this.isChecked = (file)=>{
            const { currentSelection: currentSelection } = this.plugin.getPluginState();
            // comparing id instead of the file object, because the reference to the object
            // changes when we switch folders, and the file list is updated
            return currentSelection.some((item)=>item.id === file.id);
        };
        this.plugin = plugin;
        this.provider = opts.provider;
        this.opts = opts;
        this.isHandlingScroll = false;
        this.preFirstRender = this.preFirstRender.bind(this);
        this.handleError = this.handleError.bind(this);
        this.clearSelection = this.clearSelection.bind(this);
        this.cancelPicking = this.cancelPicking.bind(this);
    }
    preFirstRender() {
        this.plugin.setPluginState({
            didFirstRender: true
        });
        this.plugin.onFirstRender();
    }
    shouldHandleScroll(event) {
        const { scrollHeight: scrollHeight, scrollTop: scrollTop, offsetHeight: offsetHeight } = event.target;
        const scrollPosition = scrollHeight - (scrollTop + offsetHeight);
        return scrollPosition < 50 && !this.isHandlingScroll;
    }
    clearSelection() {
        this.plugin.setPluginState({
            currentSelection: [],
            filterInput: ""
        });
    }
    cancelPicking() {
        this.clearSelection();
        const dashboard = this.plugin.uppy.getPlugin("Dashboard");
        if (dashboard) // @ts-expect-error impossible to type this correctly without adding dashboard
        // as a dependency to this package.
        dashboard.hideAllPanels();
    }
    handleError(error) {
        var _error$cause;
        const { uppy: uppy } = this.plugin;
        const message = uppy.i18n("companionError");
        uppy.log(error.toString());
        if (error.isAuthError || ((_error$cause = error.cause) == null ? void 0 : _error$cause.name) === "AbortError") // authError just means we're not authenticated, don't show to user
        // AbortError means the user has clicked "cancel" on an operation
        return;
        uppy.info({
            message: message,
            details: error.toString()
        }, "error", 5000);
    }
    registerRequestClient() {
        this.requestClientId = this.provider.provider;
        this.plugin.uppy.registerRequestClient(this.requestClientId, this.provider);
    }
    // TODO: document what is a "tagFile" or get rid of this concept
    getTagFile(file) {
        const tagFile = {
            id: file.id,
            source: this.plugin.id,
            name: file.name || file.id,
            type: file.mimeType,
            isRemote: true,
            data: file,
            // @ts-expect-error meta is filled conditionally below
            meta: {},
            body: {
                fileId: file.id
            },
            remote: {
                companionUrl: this.plugin.opts.companionUrl,
                // @ts-expect-error untyped for now
                url: `${this.provider.fileUrl(file.requestPath)}`,
                body: {
                    fileId: file.id
                },
                providerName: this.provider.name,
                provider: this.provider.provider,
                requestClientId: this.requestClientId
            }
        };
        const fileType = (0, $d70a5ddc0e61f36b$export$2e2bcd8739ae039)(tagFile);
        // TODO Should we just always use the thumbnail URL if it exists?
        if (fileType && (0, $2e3a76623b3bbcc9$export$2e2bcd8739ae039)(fileType)) tagFile.preview = file.thumbnail;
        if (file.author) {
            if (file.author.name != null) tagFile.meta.authorName = String(file.author.name);
            if (file.author.url) tagFile.meta.authorUrl = file.author.url;
        }
        // add relativePath similar to non-remote files: https://github.com/transloadit/uppy/pull/4486#issuecomment-1579203717
        if (file.relDirPath != null) tagFile.meta.relativePath = file.relDirPath ? `${file.relDirPath}/${tagFile.name}` : null;
        // and absolutePath (with leading slash) https://github.com/transloadit/uppy/pull/4537#issuecomment-1614236655
        if (file.absDirPath != null) tagFile.meta.absolutePath = file.absDirPath ? `/${file.absDirPath}/${tagFile.name}` : `/${tagFile.name}`;
        return tagFile;
    }
    /**
   * Toggles file/folder checkbox to on/off state while updating files list.
   *
   * Note that some extra complexity comes from supporting shift+click to
   * toggle multiple checkboxes at once, which is done by getting all files
   * in between last checked file and current one.
   */ toggleCheckbox(e, file) {
        e.stopPropagation();
        e.preventDefault();
        e.currentTarget.focus();
        const { folders: folders, files: files } = this.plugin.getPluginState();
        const items = this.filterItems(folders.concat(files));
        // Shift-clicking selects a single consecutive list of items
        // starting at the previous click.
        if (this.lastCheckbox && this.isShiftKeyPressed) {
            const { currentSelection: currentSelection } = this.plugin.getPluginState();
            const prevIndex = items.indexOf(this.lastCheckbox);
            const currentIndex = items.indexOf(file);
            const newSelection = prevIndex < currentIndex ? items.slice(prevIndex, currentIndex + 1) : items.slice(currentIndex, prevIndex + 1);
            const reducedNewSelection = [];
            // Check restrictions on each file in currentSelection,
            // reduce it to only contain files that pass restrictions
            for (const item of newSelection){
                const { uppy: uppy } = this.plugin;
                const restrictionError = uppy.validateRestrictions((0, $d0cca3c9705b0857$export$2e2bcd8739ae039)(item), [
                    ...uppy.getFiles(),
                    ...reducedNewSelection
                ]);
                if (!restrictionError) reducedNewSelection.push(item);
                else uppy.info({
                    message: restrictionError.message
                }, "error", uppy.opts.infoTimeout);
            }
            this.plugin.setPluginState({
                currentSelection: [
                    ...new Set([
                        ...currentSelection,
                        ...reducedNewSelection
                    ])
                ]
            });
            return;
        }
        this.lastCheckbox = file;
        const { currentSelection: currentSelection } = this.plugin.getPluginState();
        if (this.isChecked(file)) this.plugin.setPluginState({
            currentSelection: currentSelection.filter((item)=>item.id !== file.id)
        });
        else this.plugin.setPluginState({
            currentSelection: currentSelection.concat([
                file
            ])
        });
    }
    setLoading(loading) {
        this.plugin.setPluginState({
            loading: loading
        });
    }
}


function $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $671181bcc8a0cf10$var$id = 0;
function $671181bcc8a0cf10$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $671181bcc8a0cf10$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $671181bcc8a0cf10$var$packageJson = {
    "version": "3.11.0"
};
function $671181bcc8a0cf10$var$formatBreadcrumbs(breadcrumbs) {
    return breadcrumbs.slice(1).map((directory)=>directory.name).join("/");
}
function $671181bcc8a0cf10$var$prependPath(path, component) {
    if (!path) return component;
    return `${path}/${component}`;
}
function $671181bcc8a0cf10$export$b9ab270927e310e4() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "30",
        height: "30",
        viewBox: "0 0 30 30"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
    }));
}
const $671181bcc8a0cf10$var$defaultOptions = {
    viewType: "list",
    showTitles: true,
    showFilter: true,
    showBreadcrumbs: true,
    loadAllFiles: false
};
var $671181bcc8a0cf10$var$_abortController = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("abortController");
var $671181bcc8a0cf10$var$_withAbort = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("withAbort");
var $671181bcc8a0cf10$var$_list = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("list");
var $671181bcc8a0cf10$var$_listFilesAndFolders = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("listFilesAndFolders");
var $671181bcc8a0cf10$var$_recursivelyListAllFiles = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("recursivelyListAllFiles");
class $671181bcc8a0cf10$export$2e2bcd8739ae039 extends (0, $2b848f45ec727ac0$export$2e2bcd8739ae039) {
    constructor(plugin, opts){
        super(plugin, {
            ...$671181bcc8a0cf10$var$defaultOptions,
            ...opts
        });
        // Logic
        Object.defineProperty(this, $671181bcc8a0cf10$var$_recursivelyListAllFiles, {
            value: $671181bcc8a0cf10$var$_recursivelyListAllFiles2
        });
        Object.defineProperty(this, $671181bcc8a0cf10$var$_listFilesAndFolders, {
            value: $671181bcc8a0cf10$var$_listFilesAndFolders2
        });
        Object.defineProperty(this, $671181bcc8a0cf10$var$_list, {
            value: $671181bcc8a0cf10$var$_list2
        });
        Object.defineProperty(this, $671181bcc8a0cf10$var$_withAbort, {
            value: $671181bcc8a0cf10$var$_withAbort2
        });
        Object.defineProperty(this, $671181bcc8a0cf10$var$_abortController, {
            writable: true,
            value: void 0
        });
        this.filterQuery = this.filterQuery.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.getFolder = this.getFolder.bind(this);
        this.getNextFolder = this.getNextFolder.bind(this);
        this.logout = this.logout.bind(this);
        this.handleAuth = this.handleAuth.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.donePicking = this.donePicking.bind(this);
        // Visual
        this.render = this.render.bind(this);
        // Set default state for the plugin
        this.plugin.setPluginState({
            authenticated: undefined,
            // we don't know yet
            files: [],
            folders: [],
            breadcrumbs: [],
            filterInput: "",
            isSearchVisible: false,
            currentSelection: []
        });
        this.registerRequestClient();
    }
    // eslint-disable-next-line class-methods-use-this
    tearDown() {
    // Nothing.
    }
    /**
   * Select a folder based on its id: fetches the folder and then updates state with its contents
   * TODO rename to something better like selectFolder or navigateToFolder (breaking change?)
   *
   */ async getFolder(requestPath, name) {
        this.setLoading(true);
        try {
            await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                this.lastCheckbox = undefined;
                let { breadcrumbs: breadcrumbs } = this.plugin.getPluginState();
                const index = breadcrumbs.findIndex((dir)=>requestPath === dir.requestPath);
                if (index !== -1) // means we navigated back to a known directory (already in the stack), so cut the stack off there
                breadcrumbs = breadcrumbs.slice(0, index + 1);
                else // we have navigated into a new (unknown) folder, add it to the stack
                breadcrumbs = [
                    ...breadcrumbs,
                    {
                        requestPath: requestPath,
                        name: name
                    }
                ];
                this.nextPagePath = requestPath;
                let files = [];
                let folders = [];
                do {
                    const { files: newFiles, folders: newFolders } = await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_listFilesAndFolders)[$671181bcc8a0cf10$var$_listFilesAndFolders]({
                        breadcrumbs: breadcrumbs,
                        signal: signal
                    });
                    files = files.concat(newFiles);
                    folders = folders.concat(newFolders);
                    this.setLoading(this.plugin.uppy.i18n("loadedXFiles", {
                        numFiles: files.length + folders.length
                    }));
                }while (this.opts.loadAllFiles && this.nextPagePath);
                this.plugin.setPluginState({
                    folders: folders,
                    files: files,
                    breadcrumbs: breadcrumbs,
                    filterInput: ""
                });
            });
        } catch (err) {
            // This is the first call that happens when the provider view loads, after auth, so it's probably nice to show any
            // error occurring here to the user.
            if ((err == null ? void 0 : err.name) === "UserFacingApiError") {
                this.plugin.uppy.info({
                    message: this.plugin.uppy.i18n(err.message)
                }, "warning", 5000);
                return;
            }
            this.handleError(err);
        } finally{
            this.setLoading(false);
        }
    }
    /**
   * Fetches new folder
   */ getNextFolder(folder) {
        this.getFolder(folder.requestPath, folder.name);
        this.lastCheckbox = undefined;
    }
    /**
   * Removes session token on client side.
   */ async logout() {
        try {
            await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                const res = await this.provider.logout({
                    signal: signal
                });
                // res.ok is from the JSON body, not to be confused with Response.ok
                if (res.ok) {
                    if (!res.revoked) {
                        const message = this.plugin.uppy.i18n("companionUnauthorizeHint", {
                            provider: this.plugin.title,
                            url: res.manual_revoke_url
                        });
                        this.plugin.uppy.info(message, "info", 7000);
                    }
                    const newState = {
                        authenticated: false,
                        files: [],
                        folders: [],
                        breadcrumbs: [],
                        filterInput: ""
                    };
                    this.plugin.setPluginState(newState);
                }
            });
        } catch (err) {
            this.handleError(err);
        }
    }
    filterQuery(input) {
        this.plugin.setPluginState({
            filterInput: input
        });
    }
    clearFilter() {
        this.plugin.setPluginState({
            filterInput: ""
        });
    }
    async handleAuth(authFormData) {
        try {
            await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                this.setLoading(true);
                await this.provider.login({
                    authFormData: authFormData,
                    signal: signal
                });
                this.plugin.setPluginState({
                    authenticated: true
                });
                this.preFirstRender();
            });
        } catch (err) {
            if (err.name === "UserFacingApiError") {
                this.plugin.uppy.info({
                    message: this.plugin.uppy.i18n(err.message)
                }, "warning", 5000);
                return;
            }
            this.plugin.uppy.log(`login failed: ${err.message}`);
        } finally{
            this.setLoading(false);
        }
    }
    async handleScroll(event) {
        if (this.shouldHandleScroll(event) && this.nextPagePath) {
            this.isHandlingScroll = true;
            try {
                await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                    const { files: files, folders: folders, breadcrumbs: breadcrumbs } = this.plugin.getPluginState();
                    const { files: newFiles, folders: newFolders } = await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_listFilesAndFolders)[$671181bcc8a0cf10$var$_listFilesAndFolders]({
                        breadcrumbs: breadcrumbs,
                        signal: signal
                    });
                    const combinedFiles = files.concat(newFiles);
                    const combinedFolders = folders.concat(newFolders);
                    this.plugin.setPluginState({
                        folders: combinedFolders,
                        files: combinedFiles
                    });
                });
            } catch (error) {
                this.handleError(error);
            } finally{
                this.isHandlingScroll = false;
            }
        }
    }
    async donePicking() {
        this.setLoading(true);
        try {
            await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                const { currentSelection: currentSelection } = this.plugin.getPluginState();
                const messages = [];
                const newFiles = [];
                for (const selectedItem of currentSelection){
                    const { requestPath: requestPath } = selectedItem;
                    const withRelDirPath = (newItem)=>({
                            ...newItem,
                            // calculate the file's path relative to the user's selected item's path
                            // see https://github.com/transloadit/uppy/pull/4537#issuecomment-1614236655
                            relDirPath: newItem.absDirPath.replace(selectedItem.absDirPath, "").replace(/^\//, "")
                        });
                    if (selectedItem.isFolder) {
                        let isEmpty = true;
                        let numNewFiles = 0;
                        const queue = new (0, (/*@__PURE__*/$parcel$interopDefault($11d558640132ea3e$exports)))({
                            concurrency: 6
                        });
                        const onFiles = (files)=>{
                            for (const newFile of files){
                                const tagFile = this.getTagFile(newFile);
                                const id = (0, $d67267bb9859462b$export$2ff5b23440673856)(tagFile);
                                // If the same folder is added again, we don't want to send
                                // X amount of duplicate file notifications, we want to say
                                // the folder was already added. This checks if all files are duplicate,
                                // if that's the case, we don't add the files.
                                if (!this.plugin.uppy.checkIfFileAlreadyExists(id)) {
                                    newFiles.push(withRelDirPath(newFile));
                                    numNewFiles++;
                                    this.setLoading(this.plugin.uppy.i18n("addedNumFiles", {
                                        numFiles: numNewFiles
                                    }));
                                }
                                isEmpty = false;
                            }
                        };
                        await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_recursivelyListAllFiles)[$671181bcc8a0cf10$var$_recursivelyListAllFiles]({
                            requestPath: requestPath,
                            absDirPath: $671181bcc8a0cf10$var$prependPath(selectedItem.absDirPath, selectedItem.name),
                            relDirPath: selectedItem.name,
                            queue: queue,
                            onFiles: onFiles,
                            signal: signal
                        });
                        await queue.onIdle();
                        let message;
                        if (isEmpty) message = this.plugin.uppy.i18n("emptyFolderAdded");
                        else if (numNewFiles === 0) message = this.plugin.uppy.i18n("folderAlreadyAdded", {
                            folder: selectedItem.name
                        });
                        else // TODO we don't really know at this point whether any files were actually added
                        // (only later after addFiles has been called) so we should probably rewrite this.
                        // Example: If all files fail to add due to restriction error, it will still say "Added 100 files from folder"
                        message = this.plugin.uppy.i18n("folderAdded", {
                            smart_count: numNewFiles,
                            folder: selectedItem.name
                        });
                        messages.push(message);
                    } else newFiles.push(withRelDirPath(selectedItem));
                }
                // Note: this.plugin.uppy.addFiles must be only run once we are done fetching all files,
                // because it will cause the loading screen to disappear,
                // and that will allow the user to start the upload, so we need to make sure we have
                // finished all async operations before we add any file
                // see https://github.com/transloadit/uppy/pull/4384
                this.plugin.uppy.log("Adding files from a remote provider");
                this.plugin.uppy.addFiles(// @ts-expect-error `addFiles` expects `body` to be `File` or `Blob`,
                // but as the todo comment in `View.ts` indicates, we strangly pass `CompanionFile` as `body`.
                // For now it's better to ignore than to have a potential breaking change.
                newFiles.map((file)=>this.getTagFile(file, this.requestClientId)));
                this.plugin.setPluginState({
                    filterInput: ""
                });
                messages.forEach((message)=>this.plugin.uppy.info(message));
                this.clearSelection();
            });
        } catch (err) {
            this.handleError(err);
        } finally{
            this.setLoading(false);
        }
    }
    render(state, viewOptions) {
        var _this = this;
        if (viewOptions === void 0) viewOptions = {};
        const { authenticated: authenticated, didFirstRender: didFirstRender } = this.plugin.getPluginState();
        const { i18n: i18n } = this.plugin.uppy;
        if (!didFirstRender) this.preFirstRender();
        const targetViewOptions = {
            ...this.opts,
            ...viewOptions
        };
        const { files: files, folders: folders, filterInput: filterInput, loading: loading, currentSelection: currentSelection } = this.plugin.getPluginState();
        const { isChecked: isChecked, recordShiftKeyPress: recordShiftKeyPress, filterItems: filterItems } = this;
        const hasInput = filterInput !== "";
        const pluginIcon = this.plugin.icon || $671181bcc8a0cf10$export$b9ab270927e310e4;
        const headerProps = {
            showBreadcrumbs: targetViewOptions.showBreadcrumbs,
            getFolder: this.getFolder,
            breadcrumbs: this.plugin.getPluginState().breadcrumbs,
            pluginIcon: pluginIcon,
            title: this.plugin.title,
            logout: this.logout,
            username: this.username,
            i18n: i18n
        };
        const browserProps = {
            isChecked: isChecked,
            toggleCheckbox: this.toggleCheckbox.bind(this),
            recordShiftKeyPress: recordShiftKeyPress,
            currentSelection: currentSelection,
            files: hasInput ? filterItems(files) : files,
            folders: hasInput ? filterItems(folders) : folders,
            getNextFolder: this.getNextFolder,
            getFolder: this.getFolder,
            loadAllFiles: this.opts.loadAllFiles,
            // For SearchFilterInput component
            showSearchFilter: targetViewOptions.showFilter,
            search: this.filterQuery,
            clearSearch: this.clearFilter,
            searchTerm: filterInput,
            searchOnInput: true,
            searchInputLabel: i18n("filter"),
            clearSearchLabel: i18n("resetFilter"),
            noResultsLabel: i18n("noFilesFound"),
            logout: this.logout,
            handleScroll: this.handleScroll,
            done: this.donePicking,
            cancel: this.cancelPicking,
            // eslint-disable-next-line react/jsx-props-no-spreading
            headerComponent: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $6b1b801e011f359f$export$2e2bcd8739ae039), headerProps),
            title: this.plugin.title,
            viewType: targetViewOptions.viewType,
            showTitles: targetViewOptions.showTitles,
            showBreadcrumbs: targetViewOptions.showBreadcrumbs,
            pluginIcon: pluginIcon,
            i18n: this.plugin.uppy.i18n,
            uppyFiles: this.plugin.uppy.getFiles(),
            validateRestrictions: function() {
                return _this.plugin.uppy.validateRestrictions(...arguments);
            },
            isLoading: loading
        };
        if (authenticated === false) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $284651d7489bd34f$export$2e2bcd8739ae039), {
            onUnmount: this.clearSelection
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $616f0acd28bd0dc4$export$2e2bcd8739ae039), {
            pluginName: this.plugin.title,
            pluginIcon: pluginIcon,
            handleAuth: this.handleAuth,
            i18n: this.plugin.uppy.i18nArray,
            renderForm: this.opts.renderAuthForm,
            loading: loading
        }));
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $284651d7489bd34f$export$2e2bcd8739ae039), {
            onUnmount: this.clearSelection
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ffc120143b595bcb$export$2e2bcd8739ae039), browserProps));
    }
}
async function $671181bcc8a0cf10$var$_withAbort2(op) {
    var _classPrivateFieldLoo;
    // prevent multiple requests in parallel from causing race conditions
    (_classPrivateFieldLoo = $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController]) == null || _classPrivateFieldLoo.abort();
    const abortController = new AbortController();
    $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController] = abortController;
    const cancelRequest = ()=>{
        abortController.abort();
        this.clearSelection();
    };
    try {
        // @ts-expect-error this should be typed in @uppy/dashboard.
        // Even then I don't think we can make this work without adding dashboard
        // as a dependency to provider-views.
        this.plugin.uppy.on("dashboard:close-panel", cancelRequest);
        this.plugin.uppy.on("cancel-all", cancelRequest);
        await op(abortController.signal);
    } finally{
        // @ts-expect-error this should be typed in @uppy/dashboard.
        // Even then I don't think we can make this work without adding dashboard
        // as a dependency to provider-views.
        this.plugin.uppy.off("dashboard:close-panel", cancelRequest);
        this.plugin.uppy.off("cancel-all", cancelRequest);
        $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController] = undefined;
    }
}
async function $671181bcc8a0cf10$var$_list2(_ref) {
    let { requestPath: requestPath, absDirPath: absDirPath, signal: signal } = _ref;
    const { username: username, nextPagePath: nextPagePath, items: items } = await this.provider.list(requestPath, {
        signal: signal
    });
    this.username = username || this.username;
    return {
        items: items.map((item)=>({
                ...item,
                absDirPath: absDirPath
            })),
        nextPagePath: nextPagePath
    };
}
async function $671181bcc8a0cf10$var$_listFilesAndFolders2(_ref2) {
    let { breadcrumbs: breadcrumbs, signal: signal } = _ref2;
    const absDirPath = $671181bcc8a0cf10$var$formatBreadcrumbs(breadcrumbs);
    const { items: items, nextPagePath: nextPagePath } = await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_list)[$671181bcc8a0cf10$var$_list]({
        requestPath: this.nextPagePath,
        absDirPath: absDirPath,
        signal: signal
    });
    this.nextPagePath = nextPagePath;
    const files = [];
    const folders = [];
    items.forEach((item)=>{
        if (item.isFolder) folders.push(item);
        else files.push(item);
    });
    return {
        files: files,
        folders: folders
    };
}
async function $671181bcc8a0cf10$var$_recursivelyListAllFiles2(_ref3) {
    let { requestPath: requestPath, absDirPath: absDirPath, relDirPath: relDirPath, queue: queue, onFiles: onFiles, signal: signal } = _ref3;
    let curPath = requestPath;
    while(curPath){
        const res = await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_list)[$671181bcc8a0cf10$var$_list]({
            requestPath: curPath,
            absDirPath: absDirPath,
            signal: signal
        });
        curPath = res.nextPagePath;
        const files = res.items.filter((item)=>!item.isFolder);
        const folders = res.items.filter((item)=>item.isFolder);
        onFiles(files);
        // recursively queue call to self for each folder
        const promises = folders.map(async (folder)=>queue.add(async ()=>$671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_recursivelyListAllFiles)[$671181bcc8a0cf10$var$_recursivelyListAllFiles]({
                    requestPath: folder.requestPath,
                    absDirPath: $671181bcc8a0cf10$var$prependPath(absDirPath, folder.name),
                    relDirPath: $671181bcc8a0cf10$var$prependPath(relDirPath, folder.name),
                    queue: queue,
                    onFiles: onFiles,
                    signal: signal
                })));
        await Promise.all(promises); // in case we get an error
    }
}
$671181bcc8a0cf10$export$2e2bcd8739ae039.VERSION = $671181bcc8a0cf10$var$packageJson.version;









function $3174b53b600a62c5$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $3174b53b600a62c5$var$id = 0;
function $3174b53b600a62c5$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $3174b53b600a62c5$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $3174b53b600a62c5$var$packageJson = {
    "version": "3.11.0"
};
const $3174b53b600a62c5$var$defaultState = {
    isInputMode: true,
    files: [],
    folders: [],
    breadcrumbs: [],
    filterInput: "",
    currentSelection: [],
    searchTerm: null
};
const $3174b53b600a62c5$var$defaultOptions = {
    viewType: "grid",
    showTitles: true,
    showFilter: true,
    showBreadcrumbs: true
};
var $3174b53b600a62c5$var$_updateFilesAndInputMode = /*#__PURE__*/ $3174b53b600a62c5$var$_classPrivateFieldLooseKey("updateFilesAndInputMode");
class $3174b53b600a62c5$export$2e2bcd8739ae039 extends (0, $2b848f45ec727ac0$export$2e2bcd8739ae039) {
    constructor(plugin, opts){
        super(plugin, {
            ...$3174b53b600a62c5$var$defaultOptions,
            ...opts
        });
        Object.defineProperty(this, $3174b53b600a62c5$var$_updateFilesAndInputMode, {
            value: $3174b53b600a62c5$var$_updateFilesAndInputMode2
        });
        this.nextPageQuery = null;
        this.search = this.search.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.resetPluginState = this.resetPluginState.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.donePicking = this.donePicking.bind(this);
        this.render = this.render.bind(this);
        this.plugin.setPluginState($3174b53b600a62c5$var$defaultState);
        this.registerRequestClient();
    }
    // eslint-disable-next-line class-methods-use-this
    tearDown() {
    // Nothing.
    }
    resetPluginState() {
        this.plugin.setPluginState($3174b53b600a62c5$var$defaultState);
    }
    async search(query) {
        const { searchTerm: searchTerm } = this.plugin.getPluginState();
        if (query && query === searchTerm) // no need to search again as this is the same as the previous search
        return;
        this.setLoading(true);
        try {
            const res = await this.provider.search(query);
            $3174b53b600a62c5$var$_classPrivateFieldLooseBase(this, $3174b53b600a62c5$var$_updateFilesAndInputMode)[$3174b53b600a62c5$var$_updateFilesAndInputMode](res, []);
        } catch (err) {
            this.handleError(err);
        } finally{
            this.setLoading(false);
        }
    }
    clearSearch() {
        this.plugin.setPluginState({
            currentSelection: [],
            files: [],
            searchTerm: null
        });
    }
    async handleScroll(event) {
        const query = this.nextPageQuery || null;
        if (this.shouldHandleScroll(event) && query) {
            this.isHandlingScroll = true;
            try {
                const { files: files, searchTerm: searchTerm } = this.plugin.getPluginState();
                const response = await this.provider.search(searchTerm, query);
                $3174b53b600a62c5$var$_classPrivateFieldLooseBase(this, $3174b53b600a62c5$var$_updateFilesAndInputMode)[$3174b53b600a62c5$var$_updateFilesAndInputMode](response, files);
            } catch (error) {
                this.handleError(error);
            } finally{
                this.isHandlingScroll = false;
            }
        }
    }
    donePicking() {
        const { currentSelection: currentSelection } = this.plugin.getPluginState();
        this.plugin.uppy.log("Adding remote search provider files");
        this.plugin.uppy.addFiles(currentSelection.map((file)=>this.getTagFile(file)));
        this.resetPluginState();
    }
    render(state, viewOptions) {
        var _this = this;
        if (viewOptions === void 0) viewOptions = {};
        const { didFirstRender: didFirstRender, isInputMode: isInputMode, searchTerm: searchTerm } = this.plugin.getPluginState();
        const { i18n: i18n } = this.plugin.uppy;
        if (!didFirstRender) this.preFirstRender();
        const targetViewOptions = {
            ...this.opts,
            ...viewOptions
        };
        const { files: files, folders: folders, filterInput: filterInput, loading: loading, currentSelection: currentSelection } = this.plugin.getPluginState();
        const { isChecked: isChecked, filterItems: filterItems, recordShiftKeyPress: recordShiftKeyPress } = this;
        const hasInput = filterInput !== "";
        const browserProps = {
            isChecked: isChecked,
            toggleCheckbox: this.toggleCheckbox.bind(this),
            recordShiftKeyPress: recordShiftKeyPress,
            currentSelection: currentSelection,
            files: hasInput ? filterItems(files) : files,
            folders: hasInput ? filterItems(folders) : folders,
            handleScroll: this.handleScroll,
            done: this.donePicking,
            cancel: this.cancelPicking,
            // For SearchFilterInput component
            showSearchFilter: targetViewOptions.showFilter,
            search: this.search,
            clearSearch: this.clearSearch,
            searchTerm: searchTerm,
            searchOnInput: false,
            searchInputLabel: i18n("search"),
            clearSearchLabel: i18n("resetSearch"),
            noResultsLabel: i18n("noSearchResults"),
            title: this.plugin.title,
            viewType: targetViewOptions.viewType,
            showTitles: targetViewOptions.showTitles,
            showFilter: targetViewOptions.showFilter,
            isLoading: loading,
            showBreadcrumbs: targetViewOptions.showBreadcrumbs,
            pluginIcon: this.plugin.icon,
            i18n: i18n,
            uppyFiles: this.plugin.uppy.getFiles(),
            validateRestrictions: function() {
                return _this.plugin.uppy.validateRestrictions(...arguments);
            }
        };
        if (isInputMode) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $284651d7489bd34f$export$2e2bcd8739ae039), {
            onUnmount: this.resetPluginState
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-SearchProvider"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $a64872f8825ef0cd$export$2e2bcd8739ae039), {
            search: this.search,
            inputLabel: i18n("enterTextToSearch"),
            buttonLabel: i18n("searchImages"),
            inputClassName: "uppy-c-textInput uppy-SearchProvider-input",
            buttonCSSClassName: "uppy-SearchProvider-searchButton",
            showButton: true
        })));
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $284651d7489bd34f$export$2e2bcd8739ae039), {
            onUnmount: this.resetPluginState
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ffc120143b595bcb$export$2e2bcd8739ae039), browserProps));
    }
}
function $3174b53b600a62c5$var$_updateFilesAndInputMode2(res, files) {
    this.nextPageQuery = res.nextPageQuery;
    res.items.forEach((item)=>{
        files.push(item);
    });
    this.plugin.setPluginState({
        currentSelection: [],
        isInputMode: false,
        files: files,
        searchTerm: res.searchedFor
    });
}
$3174b53b600a62c5$export$2e2bcd8739ae039.VERSION = $3174b53b600a62c5$var$packageJson.version;






let $ee6f2436cceea22a$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $ee6f2436cceea22a$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $ee6f2436cceea22a$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $ee6f2436cceea22a$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $e66b69e563b626e6$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e66b69e563b626e6$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e66b69e563b626e6$var$safeIsNaN(first) && $e66b69e563b626e6$var$safeIsNaN(second)) return true;
    return false;
}
function $e66b69e563b626e6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e66b69e563b626e6$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e66b69e563b626e6$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e66b69e563b626e6$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



var $a6c8757fba02bc34$export$2e2bcd8739ae039 = [
    'a[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'area[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    "input:not([disabled]):not([inert]):not([aria-hidden])",
    "select:not([disabled]):not([inert]):not([aria-hidden])",
    "textarea:not([disabled]):not([inert]):not([aria-hidden])",
    "button:not([disabled]):not([inert]):not([aria-hidden])",
    'iframe:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'object:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'embed:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[contenteditable]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[tabindex]:not([tabindex^="-"]):not([inert]):not([aria-hidden])'
];


/**
 * @returns {HTMLElement} - either dashboard element, or the overlay that's most on top
 */ function $0a4934e80baa1792$export$2e2bcd8739ae039(dashboardEl, activeOverlayType) {
    if (activeOverlayType) {
        const overlayEl = dashboardEl.querySelector(`[data-uppy-paneltype="${activeOverlayType}"]`);
        // if an overlay is already mounted
        if (overlayEl) return overlayEl;
    }
    return dashboardEl;
}


function $f5d602e6112dba3d$var$focusOnFirstNode(event, nodes) {
    const node = nodes[0];
    if (node) {
        node.focus();
        event.preventDefault();
    }
}
function $f5d602e6112dba3d$var$focusOnLastNode(event, nodes) {
    const node = nodes[nodes.length - 1];
    if (node) {
        node.focus();
        event.preventDefault();
    }
}
// ___Why not just use (focusedItemIndex === -1)?
//    Firefox thinks <ul> is focusable, but we don't have <ul>s in our FOCUSABLE_ELEMENTS. Which means that if we tab into
//    the <ul>, code will think that we are not in the active overlay, and we should focusOnFirstNode() of the currently
//    active overlay!
//    [Practical check] if we use (focusedItemIndex === -1), instagram provider in firefox will never get focus on its pics
//    in the <ul>.
function $f5d602e6112dba3d$var$isFocusInOverlay(activeOverlayEl) {
    return activeOverlayEl.contains(document.activeElement);
}
function $f5d602e6112dba3d$export$f41e0874aee57111(event, activeOverlayType, dashboardEl) {
    const activeOverlayEl = (0, $0a4934e80baa1792$export$2e2bcd8739ae039)(dashboardEl, activeOverlayType);
    const focusableNodes = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(activeOverlayEl.querySelectorAll((0, $a6c8757fba02bc34$export$2e2bcd8739ae039)));
    const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
    // If we pressed tab, and focus is not yet within the current overlay - focus on
    // the first element within the current overlay.
    // This is a safety measure (for when user returns from another tab e.g.), most
    // plugins will try to focus on some important element as it loads.
    if (!$f5d602e6112dba3d$var$isFocusInOverlay(activeOverlayEl)) $f5d602e6112dba3d$var$focusOnFirstNode(event, focusableNodes);
    else if (event.shiftKey && focusedItemIndex === 0) $f5d602e6112dba3d$var$focusOnLastNode(event, focusableNodes);
    else if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) $f5d602e6112dba3d$var$focusOnFirstNode(event, focusableNodes);
}
function $f5d602e6112dba3d$export$66fd63158b65050a(event, activeOverlayType, dashboardEl) {
    // ___When we're in the bare 'Drop files here, paste, browse or import from' screen
    if (activeOverlayType === null) ;
    else // Trap the focus inside this overlay!
    // User can close the overlay (click 'Done') if they want to travel away from Uppy.
    $f5d602e6112dba3d$export$f41e0874aee57111(event, activeOverlayType, dashboardEl);
}





function $33dc1dd867a7b8b6$export$2e2bcd8739ae039() {
    let lastFocusWasOnSuperFocusableEl = false;
    const superFocus = (dashboardEl, activeOverlayType)=>{
        const overlayEl = (0, $0a4934e80baa1792$export$2e2bcd8739ae039)(dashboardEl, activeOverlayType);
        const isFocusInOverlay = overlayEl.contains(document.activeElement);
        // If focus is already in the topmost overlay, AND on last update we focused on the superfocusable
        // element - then leave focus up to the user.
        // [Practical check] without this line, typing in the search input in googledrive overlay won't work.
        if (isFocusInOverlay && lastFocusWasOnSuperFocusableEl) return;
        const superFocusableEl = overlayEl.querySelector("[data-uppy-super-focusable]");
        // If we are already in the topmost overlay, AND there are no super focusable elements yet, - leave focus up to the user.
        // [Practical check] without this line, if you are in an empty folder in google drive, and something's uploading in the
        // bg, - focus will be jumping to Done all the time.
        if (isFocusInOverlay && !superFocusableEl) return;
        if (superFocusableEl) {
            superFocusableEl.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = true;
        } else {
            const firstEl = overlayEl.querySelector((0, $a6c8757fba02bc34$export$2e2bcd8739ae039));
            firstEl == null || firstEl.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = false;
        }
    };
    // ___Why do we need to debounce?
    //    1. To deal with animations: overlay changes via animations, which results in the DOM updating AFTER plugin.update()
    //       already executed.
    //    [Practical check] without debounce, if we open the Url overlay, and click 'Done', Dashboard won't get focused again.
    //    [Practical check] if we delay 250ms instead of 260ms - IE11 won't get focused in same situation.
    //    2. Performance: there can be many state update()s in a second, and this function is called every time.
    return (0, (/*@__PURE__*/$parcel$interopDefault($8284bc2b60dc4bc4$exports)))(superFocus, 260);
}




/**
 * Checks if the browser supports Drag & Drop (not supported on mobile devices, for example).
 */ function $5e3c26e19f70d299$export$2e2bcd8739ae039() {
    const div = document.body;
    if (!("draggable" in div) || !("ondragstart" in div && "ondrop" in div)) return false;
    if (!("FormData" in window)) return false;
    if (!("FileReader" in window)) return false;
    return true;
}





// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck Typing this file requires more work, skipping it to unblock the rest of the transition.
/* eslint-disable react/destructuring-assignment */ 

var $1181142648d48c51$exports = {};
$1181142648d48c51$exports = function isShallowEqual(a, b) {
    if (a === b) return true;
    for(var i in a)if (!(i in b)) return false;
    for(var i in b)if (a[i] !== b[i]) return false;
    return true;
};





function $7fe1d951359cc6e1$var$iconImage() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "#686DE0",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M5 7v10h15V7H5zm0-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M6.35 17.172l4.994-5.026a.5.5 0 0 1 .707 0l2.16 2.16 3.505-3.505a.5.5 0 0 1 .707 0l2.336 2.31-.707.72-1.983-1.97-3.505 3.505a.5.5 0 0 1-.707 0l-2.16-2.159-3.938 3.939-1.409.026z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        cx: "7.5",
        cy: "9.5",
        r: "1.5"
    })));
}
function $7fe1d951359cc6e1$var$iconAudio() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z",
        fill: "#049BCF",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconVideo() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z",
        fill: "#19AF67",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconPDF() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z",
        fill: "#E2514A",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconArchive() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M10.45 2.05h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V2.55a.5.5 0 0 1 .5-.5zm2.05 1.024h1.05a.5.5 0 0 1 .5.5V3.6a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5v-.001zM10.45 0h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 3.074h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 1.024h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm-2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-1.656 3.074l-.82 5.946c.52.302 1.174.458 1.976.458.803 0 1.455-.156 1.975-.458l-.82-5.946h-2.311zm0-1.025h2.312c.512 0 .946.378 1.015.885l.82 5.946c.056.412-.142.817-.501 1.026-.686.398-1.515.597-2.49.597-.974 0-1.804-.199-2.49-.597a1.025 1.025 0 0 1-.5-1.026l.819-5.946c.07-.507.503-.885 1.015-.885zm.545 6.6a.5.5 0 0 1-.397-.561l.143-.999a.5.5 0 0 1 .495-.429h.74a.5.5 0 0 1 .495.43l.143.998a.5.5 0 0 1-.397.561c-.404.08-.819.08-1.222 0z",
        fill: "#00C469",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconFile() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "#A7AFB7",
        fillRule: "nonzero"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M5.5 22a.5.5 0 0 1-.5-.5v-18a.5.5 0 0 1 .5-.5h10.719a.5.5 0 0 1 .367.16l3.281 3.556a.5.5 0 0 1 .133.339V21.5a.5.5 0 0 1-.5.5h-14zm.5-1h13V7.25L16 4H6v17z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M15 4v3a1 1 0 0 0 1 1h3V7h-3V4h-1z"
    })));
}
function $7fe1d951359cc6e1$var$iconText() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4.5 7h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h10a.5.5 0 1 1 0 1h-10a.5.5 0 1 1 0-1z",
        fill: "#5A5E69",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$export$2e2bcd8739ae039(fileType) {
    const defaultChoice = {
        color: "#838999",
        icon: $7fe1d951359cc6e1$var$iconFile()
    };
    if (!fileType) return defaultChoice;
    const fileTypeGeneral = fileType.split("/")[0];
    const fileTypeSpecific = fileType.split("/")[1];
    // Text
    if (fileTypeGeneral === "text") return {
        color: "#5a5e69",
        icon: $7fe1d951359cc6e1$var$iconText()
    };
    // Image
    if (fileTypeGeneral === "image") return {
        color: "#686de0",
        icon: $7fe1d951359cc6e1$var$iconImage()
    };
    // Audio
    if (fileTypeGeneral === "audio") return {
        color: "#068dbb",
        icon: $7fe1d951359cc6e1$var$iconAudio()
    };
    // Video
    if (fileTypeGeneral === "video") return {
        color: "#19af67",
        icon: $7fe1d951359cc6e1$var$iconVideo()
    };
    // PDF
    if (fileTypeGeneral === "application" && fileTypeSpecific === "pdf") return {
        color: "#e25149",
        icon: $7fe1d951359cc6e1$var$iconPDF()
    };
    // Archive
    const archiveTypes = [
        "zip",
        "x-7z-compressed",
        "x-zip-compressed",
        "x-rar-compressed",
        "x-tar",
        "x-gzip",
        "x-apple-diskimage"
    ];
    if (fileTypeGeneral === "application" && archiveTypes.indexOf(fileTypeSpecific) !== -1) return {
        color: "#00C469",
        icon: $7fe1d951359cc6e1$var$iconArchive()
    };
    return defaultChoice;
}


function $9e2af7705a2c15c5$export$2e2bcd8739ae039(props) {
    const { file: file } = props;
    if (file.preview) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("img", {
        className: "uppy-Dashboard-Item-previewImg",
        alt: file.name,
        src: file.preview
    });
    const { color: color, icon: icon } = (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-previewIconWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-Dashboard-Item-previewIcon",
        style: {
            color: color
        }
    }, icon), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-Dashboard-Item-previewIconBg",
        width: "58",
        height: "76",
        viewBox: "0 0 58 76"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        fill: "#FFF",
        width: "58",
        height: "76",
        rx: "3",
        fillRule: "evenodd"
    })));
}



const $e8c1f4ca43ed49b9$var$metaFieldIdToName = (metaFieldId, metaFields)=>{
    const fields = typeof metaFields === "function" ? metaFields() : metaFields;
    const field = fields.filter((f)=>f.id === metaFieldId);
    return field[0].name;
};
function $e8c1f4ca43ed49b9$export$2e2bcd8739ae039(props) {
    const { file: file, toggleFileCard: toggleFileCard, i18n: i18n, metaFields: metaFields } = props;
    const { missingRequiredMetaFields: missingRequiredMetaFields } = file;
    if (!(missingRequiredMetaFields != null && missingRequiredMetaFields.length)) return null;
    const metaFieldsString = missingRequiredMetaFields.map((missingMetaField)=>$e8c1f4ca43ed49b9$var$metaFieldIdToName(missingMetaField, metaFields)).join(", ");
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-errorMessage"
    }, i18n("missingRequiredMetaFields", {
        smart_count: missingRequiredMetaFields.length,
        fields: metaFieldsString
    }), " ", (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        class: "uppy-u-reset uppy-Dashboard-Item-errorMessageBtn",
        onClick: ()=>toggleFileCard(true, file.id)
    }, i18n("editFile")));
}



function $bfd13c8521ef3809$export$2e2bcd8739ae039(props) {
    const { file: file, i18n: i18n, toggleFileCard: toggleFileCard, metaFields: metaFields, showLinkToFileUploadResult: showLinkToFileUploadResult } = props;
    const white = "rgba(255, 255, 255, 0.5)";
    const previewBackgroundColor = file.preview ? white : (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type).color;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-previewInnerWrap",
        style: {
            backgroundColor: previewBackgroundColor
        }
    }, showLinkToFileUploadResult && file.uploadURL && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
        className: "uppy-Dashboard-Item-previewLink",
        href: file.uploadURL,
        rel: "noreferrer noopener",
        target: "_blank",
        "aria-label": file.meta.name
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        hidden: true
    }, file.meta.name)), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $9e2af7705a2c15c5$export$2e2bcd8739ae039), {
        file: file
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e8c1f4ca43ed49b9$export$2e2bcd8739ae039), {
        file: file,
        i18n: i18n,
        toggleFileCard: toggleFileCard,
        metaFields: metaFields
    }));
}


/* eslint-disable react/destructuring-assignment */ 
function $130a6df4f019eb5d$var$onPauseResumeCancelRetry(props) {
    if (props.isUploaded) return;
    if (props.error && !props.hideRetryButton) {
        props.uppy.retryUpload(props.file.id);
        return;
    }
    if (props.resumableUploads && !props.hidePauseResumeButton) props.uppy.pauseResume(props.file.id);
    else if (props.individualCancellation && !props.hideCancelButton) props.uppy.removeFile(props.file.id);
}
function $130a6df4f019eb5d$var$progressIndicatorTitle(props) {
    if (props.isUploaded) return props.i18n("uploadComplete");
    if (props.error) return props.i18n("retryUpload");
    if (props.resumableUploads) {
        if (props.file.isPaused) return props.i18n("resumeUpload");
        return props.i18n("pauseUpload");
    }
    if (props.individualCancellation) return props.i18n("cancelUpload");
    return "";
}
function $130a6df4f019eb5d$var$ProgressIndicatorButton(props) {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-progressIndicator",
        type: "button",
        "aria-label": $130a6df4f019eb5d$var$progressIndicatorTitle(props),
        title: $130a6df4f019eb5d$var$progressIndicatorTitle(props),
        onClick: ()=>$130a6df4f019eb5d$var$onPauseResumeCancelRetry(props)
    }, props.children));
}
function $130a6df4f019eb5d$var$ProgressCircleContainer(_ref) {
    let { children: children } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "70",
        height: "70",
        viewBox: "0 0 36 36",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--circle"
    }, children);
}
function $130a6df4f019eb5d$var$ProgressCircle(_ref2) {
    let { progress: progress } = _ref2;
    // circle length equals 2 * PI * R
    const circleLength = 2 * Math.PI * 15;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        className: "uppy-Dashboard-Item-progressIcon--bg",
        r: "15",
        cx: "18",
        cy: "18",
        "stroke-width": "2",
        fill: "none"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        className: "uppy-Dashboard-Item-progressIcon--progress",
        r: "15",
        cx: "18",
        cy: "18",
        transform: "rotate(-90, 18, 18)",
        fill: "none",
        "stroke-width": "2",
        "stroke-dasharray": circleLength,
        "stroke-dashoffset": circleLength - circleLength / 100 * progress
    }));
}
function $130a6df4f019eb5d$export$2e2bcd8739ae039(props) {
    // Nothing if upload has not started
    if (!props.file.progress.uploadStarted) return null;
    // Green checkmark when complete
    if (props.isUploaded) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progressIndicator"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        r: "15",
        cx: "18",
        cy: "18",
        fill: "#1bb240"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--check",
        transform: "translate(2, 3)",
        points: "14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"
    }))));
    if (props.recoveredState) return undefined;
    // Retry button for error
    if (props.error && !props.hideRetryButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--retry",
        width: "28",
        height: "31",
        viewBox: "0 0 16 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M16 11a8 8 0 1 1-8-8v2a6 6 0 1 0 6 6h2z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.9 3H10v2H7.9z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8.536.5l3.535 3.536-1.414 1.414L7.12 1.914z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M10.657 2.621l1.414 1.415L8.536 7.57 7.12 6.157z"
    }))));
    // Pause/resume button for resumable uploads
    if (props.resumableUploads && !props.hidePauseResumeButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }), props.file.isPaused ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--play",
        transform: "translate(3, 3)",
        points: "12 20 12 10 20 15"
    }) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        className: "uppy-Dashboard-Item-progressIcon--pause",
        transform: "translate(14.5, 13)"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "0",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "5",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
    })))));
    // Cancel button for non-resumable uploads if individualCancellation is supported (not bundled)
    if (!props.resumableUploads && props.individualCancellation && !props.hideCancelButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "cancel",
        transform: "translate(2, 2)",
        points: "19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"
    }))));
    // Just progress when buttons are disabled
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progressIndicator"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }))));
}


/* eslint-disable react/destructuring-assignment */ 

/**
 * Truncates a string to the given number of chars (maxLength) by inserting '...' in the middle of that string.
 * Partially taken from https://stackoverflow.com/a/5723274/3192470.
 */ const $1e7f833197af6f70$var$separator = "...";
function $1e7f833197af6f70$export$2e2bcd8739ae039(string, maxLength) {
    // Return the empty string if maxLength is zero
    if (maxLength === 0) return "";
    // Return original string if it's already shorter than maxLength
    if (string.length <= maxLength) return string;
    // Return truncated substring appended of the ellipsis char if string can't be meaningfully truncated
    if (maxLength <= $1e7f833197af6f70$var$separator.length + 1) return `${string.slice(0, maxLength - 1)}\u{2026}`;
    const charsToShow = maxLength - $1e7f833197af6f70$var$separator.length;
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);
    return string.slice(0, frontChars) + $1e7f833197af6f70$var$separator + string.slice(-backChars);
}



const $35b148ba1db29747$var$renderFileName = (props)=>{
    const { author: author, name: name } = props.file.meta;
    function getMaxNameLength() {
        if (props.isSingleFile && props.containerHeight >= 350) return 90;
        if (props.containerWidth <= 352) return 35;
        if (props.containerWidth <= 576) return 60;
        // When `author` is present, we want to make sure
        // the file name fits on one line so we can place
        // the author on the second line.
        return author ? 20 : 30;
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-name",
        title: name
    }, (0, $1e7f833197af6f70$export$2e2bcd8739ae039)(name, getMaxNameLength()));
};
const $35b148ba1db29747$var$renderAuthor = (props)=>{
    var _props$file$remote;
    const { author: author } = props.file.meta;
    const providerName = (_props$file$remote = props.file.remote) == null ? void 0 : _props$file$remote.providerName;
    const dot = `\u00B7`;
    if (!author) return null;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-author"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
        href: `${author.url}?utm_source=Companion&utm_medium=referral`,
        target: "_blank",
        rel: "noopener noreferrer"
    }, (0, $1e7f833197af6f70$export$2e2bcd8739ae039)(author.name, 13)), providerName ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, ` ${dot} `, providerName, ` ${dot} `) : null);
};
const $35b148ba1db29747$var$renderFileSize = (props)=>props.file.size && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-statusSize"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(props.file.size));
const $35b148ba1db29747$var$ReSelectButton = (props)=>props.file.isGhost && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, " \u2022 ", (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-reSelect",
        type: "button",
        onClick: props.toggleAddFilesPanel
    }, props.i18n("reSelect")));
const $35b148ba1db29747$var$ErrorButton = (_ref)=>{
    let { file: file, onClick: onClick } = _ref;
    if (file.error) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-errorDetails",
        "aria-label": file.error,
        "data-microtip-position": "bottom",
        "data-microtip-size": "medium",
        onClick: onClick,
        type: "button"
    }, "?");
    return null;
};
function $35b148ba1db29747$export$2e2bcd8739ae039(props) {
    const { file: file } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-fileInfo",
        "data-uppy-file-source": file.source
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-fileName"
    }, $35b148ba1db29747$var$renderFileName(props), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($35b148ba1db29747$var$ErrorButton, {
        file: props.file,
        onClick: ()=>alert(props.file.error) // TODO: move to a custom alert implementation
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-status"
    }, $35b148ba1db29747$var$renderAuthor(props), $35b148ba1db29747$var$renderFileSize(props), $35b148ba1db29747$var$ReSelectButton(props)), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e8c1f4ca43ed49b9$export$2e2bcd8739ae039), {
        file: props.file,
        i18n: props.i18n,
        toggleFileCard: props.toggleFileCard,
        metaFields: props.metaFields
    }));
}



/**
 * Copies text to clipboard by creating an almost invisible textarea,
 * adding text there, then running execCommand('copy').
 * Falls back to prompt() when the easy way fails (hello, Safari!)
 * From http://stackoverflow.com/a/30810322
 *
 * @param {string} textToCopy
 * @param {string} fallbackString
 * @returns {Promise}
 */ function $1402db5492a36d8b$export$2e2bcd8739ae039(textToCopy, fallbackString) {
    if (fallbackString === void 0) fallbackString = "Copy the URL below";
    return new Promise((resolve)=>{
        const textArea = document.createElement("textarea");
        textArea.setAttribute("style", {
            position: "fixed",
            top: 0,
            left: 0,
            width: "2em",
            height: "2em",
            padding: 0,
            border: "none",
            outline: "none",
            boxShadow: "none",
            background: "transparent"
        });
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        const magicCopyFailed = (cause)=>{
            document.body.removeChild(textArea);
            // eslint-disable-next-line no-alert
            window.prompt(fallbackString, textToCopy);
            resolve();
        };
        try {
            const successful = document.execCommand("copy");
            if (!successful) return magicCopyFailed("copy command unavailable");
            document.body.removeChild(textArea);
            return resolve();
        } catch (err) {
            document.body.removeChild(textArea);
            return magicCopyFailed(err);
        }
    });
}


function $d15239db21f41277$var$EditButton(_ref) {
    let { file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, metaFields: metaFields, canEditFile: canEditFile, i18n: i18n, onClick: onClick } = _ref;
    if (!uploadInProgressOrComplete && metaFields && metaFields.length > 0 || !uploadInProgressOrComplete && canEditFile(file)) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-action uppy-Dashboard-Item-action--edit",
        type: "button",
        "aria-label": i18n("editFileWithFilename", {
            file: file.meta.name
        }),
        title: i18n("editFileWithFilename", {
            file: file.meta.name
        }),
        onClick: ()=>onClick()
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M1.5 10.793h2.793A1 1 0 0 0 5 10.5L11.5 4a1 1 0 0 0 0-1.414L9.707.793a1 1 0 0 0-1.414 0l-6.5 6.5A1 1 0 0 0 1.5 8v2.793zm1-1V8L9 1.5l1.793 1.793-6.5 6.5H2.5z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "1",
        y: "12.293",
        width: "11",
        height: "1",
        rx: ".5"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fillRule: "nonzero",
        d: "M6.793 2.5L9.5 5.207l.707-.707L7.5 1.793z"
    }))));
    return null;
}
function $d15239db21f41277$var$RemoveButton(_ref2) {
    let { i18n: i18n, onClick: onClick, file: file } = _ref2;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--remove",
        type: "button",
        "aria-label": i18n("removeFile", {
            file: file.meta.name
        }),
        title: i18n("removeFile", {
            file: file.meta.name
        }),
        onClick: ()=>onClick()
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9 0C4.034 0 0 4.034 0 9s4.034 9 9 9 9-4.034 9-9-4.034-9-9-9z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: "M13 12.222l-.778.778L9 9.778 5.778 13 5 12.222 8.222 9 5 5.778 5.778 5 9 8.222 12.222 5l.778.778L9.778 9z"
    })));
}
const $d15239db21f41277$var$copyLinkToClipboard = (event, props)=>{
    (0, $1402db5492a36d8b$export$2e2bcd8739ae039)(props.file.uploadURL, props.i18n("copyLinkToClipboardFallback")).then(()=>{
        props.uppy.log("Link copied to clipboard.");
        props.uppy.info(props.i18n("copyLinkToClipboardSuccess"), "info", 3000);
    }).catch(props.uppy.log)// avoid losing focus
    .then(()=>event.target.focus({
            preventScroll: true
        }));
};
function $d15239db21f41277$var$CopyLinkButton(props) {
    const { i18n: i18n } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--copyLink",
        type: "button",
        "aria-label": i18n("copyLink"),
        title: i18n("copyLink"),
        onClick: (event)=>$d15239db21f41277$var$copyLinkToClipboard(event, props)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 14 12"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.94 7.703a2.613 2.613 0 0 1-.626 2.681l-.852.851a2.597 2.597 0 0 1-1.849.766A2.616 2.616 0 0 1 2.764 7.54l.852-.852a2.596 2.596 0 0 1 2.69-.625L5.267 7.099a1.44 1.44 0 0 0-.833.407l-.852.851a1.458 1.458 0 0 0 1.03 2.486c.39 0 .755-.152 1.03-.426l.852-.852c.231-.231.363-.522.406-.824l1.04-1.038zm4.295-5.937A2.596 2.596 0 0 0 10.387 1c-.698 0-1.355.272-1.849.766l-.852.851a2.614 2.614 0 0 0-.624 2.688l1.036-1.036c.041-.304.173-.6.407-.833l.852-.852c.275-.275.64-.426 1.03-.426a1.458 1.458 0 0 1 1.03 2.486l-.852.851a1.442 1.442 0 0 1-.824.406l-1.04 1.04a2.596 2.596 0 0 0 2.683-.628l.851-.85a2.616 2.616 0 0 0 0-3.697zm-6.88 6.883a.577.577 0 0 0 .82 0l3.474-3.474a.579.579 0 1 0-.819-.82L5.355 7.83a.579.579 0 0 0 0 .819z"
    })));
}
function $d15239db21f41277$export$2e2bcd8739ae039(props) {
    const { uppy: uppy, file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, canEditFile: canEditFile, metaFields: metaFields, showLinkToFileUploadResult: showLinkToFileUploadResult, showRemoveButton: showRemoveButton, i18n: i18n, toggleFileCard: toggleFileCard, openFileEditor: openFileEditor } = props;
    const editAction = ()=>{
        if (metaFields && metaFields.length > 0) toggleFileCard(true, file.id);
        else openFileEditor(file);
    };
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-actionWrapper"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$EditButton, {
        i18n: i18n,
        file: file,
        uploadInProgressOrComplete: uploadInProgressOrComplete,
        canEditFile: canEditFile,
        metaFields: metaFields,
        onClick: editAction
    }), showLinkToFileUploadResult && file.uploadURL ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$CopyLinkButton, {
        file: file,
        uppy: uppy,
        i18n: i18n
    }) : null, showRemoveButton ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$RemoveButton, {
        i18n: i18n,
        file: file,
        uppy: uppy,
        onClick: ()=>uppy.removeFile(file.id, "removed-by-user")
    }) : null);
}


class $ed540296fca56761$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    componentDidMount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($1181142648d48c51$exports)))(this.props, nextProps);
    }
    // VirtualList mounts FileItems again and they emit `thumbnail:request`
    // Otherwise thumbnails are broken or missing after Golden Retriever restores files
    componentDidUpdate() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    componentWillUnmount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleCancelThumbnail(file);
    }
    render() {
        const { file: file } = this.props;
        const isProcessing = file.progress.preprocess || file.progress.postprocess;
        const isUploaded = file.progress.uploadComplete && !isProcessing && !file.error;
        const uploadInProgressOrComplete = file.progress.uploadStarted || isProcessing;
        const uploadInProgress = file.progress.uploadStarted && !file.progress.uploadComplete || isProcessing;
        const error = file.error || false;
        // File that Golden Retriever was able to partly restore (only meta, not blob),
        // users still need to re-add it, so it’s a ghost
        const { isGhost: isGhost } = file;
        let showRemoveButton = this.props.individualCancellation ? !isUploaded : !uploadInProgress && !isUploaded;
        if (isUploaded && this.props.showRemoveButtonAfterComplete) showRemoveButton = true;
        const dashboardItemClass = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))({
            "uppy-Dashboard-Item": true,
            "is-inprogress": uploadInProgress && !this.props.recoveredState,
            "is-processing": isProcessing,
            "is-complete": isUploaded,
            "is-error": !!error,
            "is-resumable": this.props.resumableUploads,
            "is-noIndividualCancellation": !this.props.individualCancellation,
            "is-ghost": isGhost
        });
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: dashboardItemClass,
            id: `uppy_${file.id}`,
            role: this.props.role
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-Item-preview"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $bfd13c8521ef3809$export$2e2bcd8739ae039), {
            file: file,
            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
            i18n: this.props.i18n,
            toggleFileCard: this.props.toggleFileCard,
            metaFields: this.props.metaFields
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $130a6df4f019eb5d$export$2e2bcd8739ae039), {
            uppy: this.props.uppy,
            file: file,
            error: error,
            isUploaded: isUploaded,
            hideRetryButton: this.props.hideRetryButton,
            hideCancelButton: this.props.hideCancelButton,
            hidePauseResumeButton: this.props.hidePauseResumeButton,
            recoveredState: this.props.recoveredState,
            showRemoveButtonAfterComplete: this.props.showRemoveButtonAfterComplete,
            resumableUploads: this.props.resumableUploads,
            individualCancellation: this.props.individualCancellation,
            i18n: this.props.i18n
        })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-Item-fileInfoAndButtons"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35b148ba1db29747$export$2e2bcd8739ae039), {
            file: file,
            id: this.props.id,
            acquirers: this.props.acquirers,
            containerWidth: this.props.containerWidth,
            containerHeight: this.props.containerHeight,
            i18n: this.props.i18n,
            toggleAddFilesPanel: this.props.toggleAddFilesPanel,
            toggleFileCard: this.props.toggleFileCard,
            metaFields: this.props.metaFields,
            isSingleFile: this.props.isSingleFile
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $d15239db21f41277$export$2e2bcd8739ae039), {
            file: file,
            metaFields: this.props.metaFields,
            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
            showRemoveButton: showRemoveButton,
            canEditFile: this.props.canEditFile,
            uploadInProgressOrComplete: uploadInProgressOrComplete,
            toggleFileCard: this.props.toggleFileCard,
            openFileEditor: this.props.openFileEditor,
            uppy: this.props.uppy,
            i18n: this.props.i18n
        })));
    }
}


function $7a578b6cd2206257$var$chunks(list, size) {
    const chunked = [];
    let currentChunk = [];
    list.forEach((item)=>{
        if (currentChunk.length < size) currentChunk.push(item);
        else {
            chunked.push(currentChunk);
            currentChunk = [
                item
            ];
        }
    });
    if (currentChunk.length) chunked.push(currentChunk);
    return chunked;
}
function $7a578b6cd2206257$export$2e2bcd8739ae039(_ref) {
    let { id: id, error: error, i18n: i18n, uppy: uppy, files: files, acquirers: acquirers, resumableUploads: resumableUploads, hideRetryButton: hideRetryButton, hidePauseResumeButton: hidePauseResumeButton, hideCancelButton: hideCancelButton, showLinkToFileUploadResult: showLinkToFileUploadResult, showRemoveButtonAfterComplete: showRemoveButtonAfterComplete, isWide: isWide, metaFields: metaFields, isSingleFile: isSingleFile, toggleFileCard: toggleFileCard, handleRequestThumbnail: handleRequestThumbnail, handleCancelThumbnail: handleCancelThumbnail, recoveredState: recoveredState, individualCancellation: individualCancellation, itemsPerRow: itemsPerRow, openFileEditor: openFileEditor, canEditFile: canEditFile, toggleAddFilesPanel: toggleAddFilesPanel, containerWidth: containerWidth, containerHeight: containerHeight } = _ref;
    // It's not great that this is hardcoded!
    // It's ESPECIALLY not great that this is checking against `itemsPerRow`!
    const rowHeight = itemsPerRow === 1 ? // Mobile
    71 : 200;
    // Sort files by file.isGhost, ghost files first, only if recoveredState is present
    const rows = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>{
        const sortByGhostComesFirst = (file1, file2)=>files[file2].isGhost - files[file1].isGhost;
        const fileIds = Object.keys(files);
        if (recoveredState) fileIds.sort(sortByGhostComesFirst);
        return $7a578b6cd2206257$var$chunks(fileIds, itemsPerRow);
    }, [
        files,
        itemsPerRow,
        recoveredState
    ]);
    const renderRow = (row // The `role="presentation` attribute ensures that the list items are properly
    )=>// associated with the `VirtualList` element.
        // We use the first file ID as the key—this should not change across scroll rerenders
        (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            class: "uppy-Dashboard-filesInner",
            role: "presentation",
            key: row[0]
        }, row.map((fileID)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ed540296fca56761$export$2e2bcd8739ae039), {
                key: fileID,
                uppy: uppy,
                id: id,
                error: error,
                i18n: i18n,
                acquirers: acquirers,
                resumableUploads: resumableUploads,
                individualCancellation: individualCancellation,
                hideRetryButton: hideRetryButton,
                hidePauseResumeButton: hidePauseResumeButton,
                hideCancelButton: hideCancelButton,
                showLinkToFileUploadResult: showLinkToFileUploadResult,
                showRemoveButtonAfterComplete: showRemoveButtonAfterComplete,
                isWide: isWide,
                metaFields: metaFields,
                recoveredState: recoveredState,
                isSingleFile: isSingleFile,
                containerWidth: containerWidth,
                containerHeight: containerHeight,
                toggleFileCard: toggleFileCard,
                handleRequestThumbnail: handleRequestThumbnail,
                handleCancelThumbnail: handleCancelThumbnail,
                role: "listitem",
                openFileEditor: openFileEditor,
                canEditFile: canEditFile,
                toggleAddFilesPanel: toggleAddFilesPanel,
                file: files[fileID]
            })));
    if (isSingleFile) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        class: "uppy-Dashboard-files"
    }, renderRow(rows[0]));
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aba06cd85441b3f8$export$2e2bcd8739ae039), {
        class: "uppy-Dashboard-files",
        role: "list",
        data: rows,
        renderRow: renderRow,
        rowHeight: rowHeight
    });
}



let $3f3c0a16d9cbe8a2$var$_Symbol$for;
$3f3c0a16d9cbe8a2$var$_Symbol$for = Symbol.for("uppy test: disable unused locale key warning");
class $3f3c0a16d9cbe8a2$var$AddFiles extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.triggerFileInputClick = ()=>{
            this.fileInput.click();
        };
        this.triggerFolderInputClick = ()=>{
            this.folderInput.click();
        };
        this.triggerVideoCameraInputClick = ()=>{
            this.mobileVideoFileInput.click();
        };
        this.triggerPhotoCameraInputClick = ()=>{
            this.mobilePhotoFileInput.click();
        };
        this.onFileInputChange = (event)=>{
            this.props.handleInputChange(event);
            // We clear the input after a file is selected, because otherwise
            // change event is not fired in Chrome and Safari when a file
            // with the same name is selected.
            // ___Why not use value="" on <input/> instead?
            //    Because if we use that method of clearing the input,
            //    Chrome will not trigger change if we drop the same file twice (Issue #768).
            event.target.value = null; // eslint-disable-line no-param-reassign
        };
        this.renderHiddenInput = (isFolder, refCallback)=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
                className: "uppy-Dashboard-input",
                hidden: true,
                "aria-hidden": "true",
                tabIndex: -1,
                webkitdirectory: isFolder,
                type: "file",
                name: "files[]",
                multiple: this.props.maxNumberOfFiles !== 1,
                onChange: this.onFileInputChange,
                accept: this.props.allowedFileTypes,
                ref: refCallback
            });
        };
        this.renderHiddenCameraInput = (type, nativeCameraFacingMode, refCallback)=>{
            const typeToAccept = {
                photo: "image/*",
                video: "video/*"
            };
            const accept = typeToAccept[type];
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
                className: "uppy-Dashboard-input",
                hidden: true,
                "aria-hidden": "true",
                tabIndex: -1,
                type: "file",
                name: `camera-${type}`,
                onChange: this.onFileInputChange,
                capture: nativeCameraFacingMode,
                accept: accept,
                ref: refCallback
            });
        };
        this.renderMyDeviceAcquirer = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MyDevice"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerFileInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                className: "uppy-DashboardTab-iconMyDevice",
                "aria-hidden": "true",
                focusable: "false",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                d: "M8.45 22.087l-1.305-6.674h17.678l-1.572 6.674H8.45zm4.975-12.412l1.083 1.765a.823.823 0 00.715.386h7.951V13.5H8.587V9.675h4.838zM26.043 13.5h-1.195v-2.598c0-.463-.336-.75-.798-.75h-8.356l-1.082-1.766A.823.823 0 0013.897 8H7.728c-.462 0-.815.256-.815.718V13.5h-.956a.97.97 0 00-.746.37.972.972 0 00-.19.81l1.724 8.565c.095.44.484.755.933.755H24c.44 0 .824-.3.929-.727l2.043-8.568a.972.972 0 00-.176-.825.967.967 0 00-.753-.38z",
                fill: "currentcolor",
                "fill-rule": "evenodd"
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n("myDevice"))));
        };
        this.renderPhotoCamera = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MobilePhotoCamera"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerPhotoCameraInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                "aria-hidden": "true",
                focusable: "false",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                d: "M23.5 9.5c1.417 0 2.5 1.083 2.5 2.5v9.167c0 1.416-1.083 2.5-2.5 2.5h-15c-1.417 0-2.5-1.084-2.5-2.5V12c0-1.417 1.083-2.5 2.5-2.5h2.917l1.416-2.167C13 7.167 13.25 7 13.5 7h5c.25 0 .5.167.667.333L20.583 9.5H23.5zM16 11.417a4.706 4.706 0 00-4.75 4.75 4.704 4.704 0 004.75 4.75 4.703 4.703 0 004.75-4.75c0-2.663-2.09-4.75-4.75-4.75zm0 7.825c-1.744 0-3.076-1.332-3.076-3.074 0-1.745 1.333-3.077 3.076-3.077 1.744 0 3.074 1.333 3.074 3.076s-1.33 3.075-3.074 3.075z",
                fill: "#02B383",
                "fill-rule": "nonzero"
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n("takePictureBtn"))));
        };
        this.renderVideoCamera = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MobileVideoCamera"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerVideoCameraInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                "aria-hidden": "true",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                fill: "#FF675E",
                fillRule: "nonzero",
                d: "m21.254 14.277 2.941-2.588c.797-.313 1.243.818 1.09 1.554-.01 2.094.02 4.189-.017 6.282-.126.915-1.145 1.08-1.58.34l-2.434-2.142c-.192.287-.504 1.305-.738.468-.104-1.293-.028-2.596-.05-3.894.047-.312.381.823.426 1.069.063-.384.206-.744.362-1.09zm-12.939-3.73c3.858.013 7.717-.025 11.574.02.912.129 1.492 1.237 1.351 2.217-.019 2.412.04 4.83-.03 7.239-.17 1.025-1.166 1.59-2.029 1.429-3.705-.012-7.41.025-11.114-.019-.913-.129-1.492-1.237-1.352-2.217.018-2.404-.036-4.813.029-7.214.136-.82.83-1.473 1.571-1.454z "
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n("recordVideoBtn"))));
        };
        this.renderBrowseButton = (text, onClickFn)=>{
            const numberOfAcquirers = this.props.acquirers.length;
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-Dashboard-browse",
                onClick: onClickFn,
                "data-uppy-super-focusable": numberOfAcquirers === 0
            }, text);
        };
        this.renderDropPasteBrowseTagline = (numberOfAcquirers)=>{
            const browseFiles = this.renderBrowseButton(this.props.i18n("browseFiles"), this.triggerFileInputClick);
            const browseFolders = this.renderBrowseButton(this.props.i18n("browseFolders"), this.triggerFolderInputClick);
            // in order to keep the i18n CamelCase and options lower (as are defaults) we will want to transform a lower
            // to Camel
            const lowerFMSelectionType = this.props.fileManagerSelectionType;
            const camelFMSelectionType = lowerFMSelectionType.charAt(0).toUpperCase() + lowerFMSelectionType.slice(1);
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                class: "uppy-Dashboard-AddFiles-title"
            }, // eslint-disable-next-line no-nested-ternary
            this.props.disableLocalFiles ? this.props.i18n("importFiles") : numberOfAcquirers > 0 ? this.props.i18nArray(`dropPasteImport${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            }) : this.props.i18nArray(`dropPaste${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            }));
        };
        this.renderAcquirer = (acquirer)=>{
            var _this$props$activePic;
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": acquirer.id
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-cy": acquirer.id,
                "aria-controls": `uppy-DashboardContent-panel--${acquirer.id}`,
                "aria-selected": ((_this$props$activePic = this.props.activePickerPanel) == null ? void 0 : _this$props$activePic.id) === acquirer.id,
                "data-uppy-super-focusable": true,
                onClick: ()=>this.props.showPanel(acquirer.id)
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, acquirer.icon()), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, acquirer.name)));
        };
        this.renderAcquirers = (acquirers)=>{
            // Group last two buttons, so we don’t end up with
            // just one button on a new line
            const acquirersWithoutLastTwo = [
                ...acquirers
            ];
            const lastTwoAcquirers = acquirersWithoutLastTwo.splice(acquirers.length - 2, acquirers.length);
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, acquirersWithoutLastTwo.map((acquirer)=>this.renderAcquirer(acquirer)), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                role: "presentation",
                style: {
                    "white-space": "nowrap"
                }
            }, lastTwoAcquirers.map((acquirer)=>this.renderAcquirer(acquirer))));
        };
        this.renderSourcesList = (acquirers, disableLocalFiles)=>{
            const { showNativePhotoCameraButton: showNativePhotoCameraButton, showNativeVideoCameraButton: showNativeVideoCameraButton } = this.props;
            let list = [];
            const myDeviceKey = "myDevice";
            if (!disableLocalFiles) list.push({
                key: myDeviceKey,
                elements: this.renderMyDeviceAcquirer()
            });
            if (showNativePhotoCameraButton) list.push({
                key: "nativePhotoCameraButton",
                elements: this.renderPhotoCamera()
            });
            if (showNativeVideoCameraButton) list.push({
                key: "nativePhotoCameraButton",
                elements: this.renderVideoCamera()
            });
            list.push(...acquirers.map((acquirer)=>({
                    key: acquirer.id,
                    elements: this.renderAcquirer(acquirer)
                })));
            // doesn't make sense to show only a lonely "My Device"
            const hasOnlyMyDevice = list.length === 1 && list[0].key === myDeviceKey;
            if (hasOnlyMyDevice) list = [];
            // Group last two buttons, so we don’t end up with
            // just one button on a new line
            const listWithoutLastTwo = [
                ...list
            ];
            const lastTwo = listWithoutLastTwo.splice(list.length - 2, list.length);
            const renderList = (l)=>l.map((_ref)=>{
                    let { key: key, elements: elements } = _ref;
                    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
                        key: key
                    }, elements);
                });
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, this.renderDropPasteBrowseTagline(list.length), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-Dashboard-AddFiles-list",
                role: "tablist"
            }, renderList(listWithoutLastTwo), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                role: "presentation",
                style: {
                    "white-space": "nowrap"
                }
            }, renderList(lastTwo))));
        };
    }
    [$3f3c0a16d9cbe8a2$var$_Symbol$for]() {
        // Those are actually used in `renderDropPasteBrowseTagline` method.
        this.props.i18nArray("dropPasteBoth");
        this.props.i18nArray("dropPasteFiles");
        this.props.i18nArray("dropPasteFolders");
        this.props.i18nArray("dropPasteImportBoth");
        this.props.i18nArray("dropPasteImportFiles");
        this.props.i18nArray("dropPasteImportFolders");
    }
    renderPoweredByUppy() {
        const { i18nArray: i18nArray } = this.props;
        const uppyBranding = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon uppy-Dashboard-poweredByIcon",
            width: "11",
            height: "11",
            viewBox: "0 0 11 11"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
            d: "M7.365 10.5l-.01-4.045h2.612L5.5.806l-4.467 5.65h2.604l.01 4.044h3.718z",
            fillRule: "evenodd"
        })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-Dashboard-poweredByUppy"
        }, "Uppy"));
        const linkText = i18nArray("poweredBy", {
            uppy: uppyBranding
        });
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
            tabIndex: -1,
            href: "https://uppy.io",
            rel: "noreferrer noopener",
            target: "_blank",
            className: "uppy-Dashboard-poweredBy"
        }, linkText);
    }
    render() {
        const { showNativePhotoCameraButton: showNativePhotoCameraButton, showNativeVideoCameraButton: showNativeVideoCameraButton, nativeCameraFacingMode: nativeCameraFacingMode } = this.props;
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-AddFiles"
        }, this.renderHiddenInput(false, (ref)=>{
            this.fileInput = ref;
        }), this.renderHiddenInput(true, (ref)=>{
            this.folderInput = ref;
        }), showNativePhotoCameraButton && this.renderHiddenCameraInput("photo", nativeCameraFacingMode, (ref)=>{
            this.mobilePhotoFileInput = ref;
        }), showNativeVideoCameraButton && this.renderHiddenCameraInput("video", nativeCameraFacingMode, (ref)=>{
            this.mobileVideoFileInput = ref;
        }), this.renderSourcesList(this.props.acquirers, this.props.disableLocalFiles), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-AddFiles-info"
        }, this.props.note && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-note"
        }, this.props.note), this.props.proudlyDisplayPoweredByUppy && this.renderPoweredByUppy(this.props)));
    }
}
var $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039 = $3f3c0a16d9cbe8a2$var$AddFiles;


/* eslint-disable react/destructuring-assignment */ 


const $175934b4bbc4fb46$var$AddFilesPanel = (props)=>{
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-Dashboard-AddFilesPanel", props.className),
        "data-uppy-panelType": "AddFiles",
        "aria-hidden": !props.showAddFilesPanel
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, props.i18n("addingMoreFiles")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: ()=>props.toggleAddFilesPanel(false)
    }, props.i18n("back"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039), props));
};
var $175934b4bbc4fb46$export$2e2bcd8739ae039 = $175934b4bbc4fb46$var$AddFilesPanel;




// ignore drop/paste events if they are not in input or textarea —
// otherwise when Url plugin adds drop/paste listeners to this.el,
// draging UI elements or pasting anything into any field triggers those events —
// Url treats them as URLs that need to be imported
function $cb1052d4a6aa569a$var$ignoreEvent(ev) {
    const { tagName: tagName } = ev.target;
    if (tagName === "INPUT" || tagName === "TEXTAREA") {
        ev.stopPropagation();
        return;
    }
    ev.preventDefault();
    ev.stopPropagation();
}
var $cb1052d4a6aa569a$export$2e2bcd8739ae039 = $cb1052d4a6aa569a$var$ignoreEvent;


function $e3578ca53f5728a8$var$PickerPanelContent(_ref) {
    let { activePickerPanel: activePickerPanel, className: className, hideAllPanels: hideAllPanels, i18n: i18n, state: state, uppy: uppy } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-DashboardContent-panel", className),
        role: "tabpanel",
        "data-uppy-panelType": "PickerPanel",
        id: `uppy-DashboardContent-panel--${activePickerPanel.id}`,
        onDragOver: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDragLeave: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDrop: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onPaste: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, i18n("importFrom", {
        name: activePickerPanel.name
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: hideAllPanels
    }, i18n("cancel"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-panelBody"
    }, uppy.getPlugin(activePickerPanel.id).render(state)));
}
var $e3578ca53f5728a8$export$2e2bcd8739ae039 = $e3578ca53f5728a8$var$PickerPanelContent;


/* eslint-disable react/destructuring-assignment */ 

function $d8360bbc75e6a373$var$EditorPanel(props) {
    const file = props.files[props.fileCardFor];
    const handleCancel = ()=>{
        props.uppy.emit("file-editor:cancel", file);
        props.closeFileEditor();
    };
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-DashboardContent-panel", props.className),
        role: "tabpanel",
        "data-uppy-panelType": "FileEditor",
        id: "uppy-DashboardContent-panel--editor"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, props.i18nArray("editing", {
        file: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-DashboardContent-titleFile"
        }, file.meta ? file.meta.name : file.name)
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: handleCancel
    }, props.i18n("cancel")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-save",
        type: "button",
        onClick: props.saveFileEditor
    }, props.i18n("save"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-panelBody"
    }, props.editors.map((target)=>{
        return props.uppy.getPlugin(target.id).render(props.state);
    })));
}
var $d8360bbc75e6a373$export$2e2bcd8739ae039 = $d8360bbc75e6a373$var$EditorPanel;



const $915070fc553cba86$var$uploadStates = {
    STATE_ERROR: "error",
    STATE_WAITING: "waiting",
    STATE_PREPROCESSING: "preprocessing",
    STATE_UPLOADING: "uploading",
    STATE_POSTPROCESSING: "postprocessing",
    STATE_COMPLETE: "complete",
    STATE_PAUSED: "paused"
};
function $915070fc553cba86$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files) {
    if (files === void 0) files = {};
    if (isAllErrored) return $915070fc553cba86$var$uploadStates.STATE_ERROR;
    if (isAllComplete) return $915070fc553cba86$var$uploadStates.STATE_COMPLETE;
    if (isAllPaused) return $915070fc553cba86$var$uploadStates.STATE_PAUSED;
    let state = $915070fc553cba86$var$uploadStates.STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]];
        // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return $915070fc553cba86$var$uploadStates.STATE_UPLOADING;
        // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess && state !== $915070fc553cba86$var$uploadStates.STATE_UPLOADING) state = $915070fc553cba86$var$uploadStates.STATE_PREPROCESSING;
        // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== $915070fc553cba86$var$uploadStates.STATE_UPLOADING && state !== $915070fc553cba86$var$uploadStates.STATE_PREPROCESSING) state = $915070fc553cba86$var$uploadStates.STATE_POSTPROCESSING;
    }
    return state;
}
function $915070fc553cba86$var$UploadStatus(_ref) {
    let { files: files, i18n: i18n, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused, inProgressNotPausedFiles: inProgressNotPausedFiles, newFiles: newFiles, processingFiles: processingFiles } = _ref;
    const uploadingState = $915070fc553cba86$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files);
    switch(uploadingState){
        case "uploading":
            return i18n("uploadingXFiles", {
                smart_count: inProgressNotPausedFiles.length
            });
        case "preprocessing":
        case "postprocessing":
            return i18n("processingXFiles", {
                smart_count: processingFiles.length
            });
        case "paused":
            return i18n("uploadPaused");
        case "waiting":
            return i18n("xFilesSelected", {
                smart_count: newFiles.length
            });
        case "complete":
            return i18n("uploadComplete");
        case "error":
            return i18n("error");
        default:
    }
}
function $915070fc553cba86$var$PanelTopBar(props) {
    const { i18n: i18n, isAllComplete: isAllComplete, hideCancelButton: hideCancelButton, maxNumberOfFiles: maxNumberOfFiles, toggleAddFilesPanel: toggleAddFilesPanel, uppy: uppy } = props;
    let { allowNewUpload: allowNewUpload } = props;
    // TODO maybe this should be done in ../Dashboard.jsx, then just pass that down as `allowNewUpload`
    if (allowNewUpload && maxNumberOfFiles) // eslint-disable-next-line react/destructuring-assignment
    allowNewUpload = props.totalFileCount < props.maxNumberOfFiles;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, !isAllComplete && !hideCancelButton ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: ()=>uppy.cancelAll()
    }, i18n("cancel")) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($915070fc553cba86$var$UploadStatus, props)), allowNewUpload ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-addMore",
        type: "button",
        "aria-label": i18n("addMoreFiles"),
        title: i18n("addMoreFiles"),
        onClick: ()=>toggleAddFilesPanel(true)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8 6.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8v6a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8h-6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h6v-6A.5.5 0 0 1 7 0h.5a.5.5 0 0 1 .5.5v6z"
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-DashboardContent-addMoreCaption"
    }, i18n("addMore"))) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", null));
}
var $915070fc553cba86$export$2e2bcd8739ae039 = $915070fc553cba86$var$PanelTopBar;










function $fca34f2366194ceb$export$2e2bcd8739ae039(props) {
    const { computedMetaFields: computedMetaFields, requiredMetaFields: requiredMetaFields, updateMeta: updateMeta, form: form, formState: formState } = props;
    const fieldCSSClasses = {
        text: "uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input"
    };
    return computedMetaFields.map((field)=>{
        const id = `uppy-Dashboard-FileCard-input-${field.id}`;
        const required = requiredMetaFields.includes(field.id);
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("fieldset", {
            key: field.id,
            className: "uppy-Dashboard-FileCard-fieldset"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
            className: "uppy-Dashboard-FileCard-label",
            htmlFor: id
        }, field.name), field.render !== undefined ? field.render({
            value: formState[field.id],
            onChange: (newVal)=>updateMeta(newVal, field.id),
            fieldCSSClasses: fieldCSSClasses,
            required: required,
            form: form.id
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
            className: fieldCSSClasses.text,
            id: id,
            form: form.id,
            type: field.type || "text",
            required: required,
            value: formState[field.id],
            placeholder: field.placeholder,
            onInput: (ev)=>updateMeta(ev.target.value, field.id),
            "data-uppy-super-focusable": true
        }));
    });
}


function $af43f3a66035ecee$export$2e2bcd8739ae039(props) {
    var _getMetaFields;
    const { files: files, fileCardFor: fileCardFor, toggleFileCard: toggleFileCard, saveFileCard: saveFileCard, metaFields: metaFields, requiredMetaFields: requiredMetaFields, openFileEditor: openFileEditor, i18n: i18n, i18nArray: i18nArray, className: className, canEditFile: canEditFile } = props;
    const getMetaFields = ()=>{
        return typeof metaFields === "function" ? metaFields(files[fileCardFor]) : metaFields;
    };
    const file = files[fileCardFor];
    const computedMetaFields = (_getMetaFields = getMetaFields()) != null ? _getMetaFields : [];
    const showEditButton = canEditFile(file);
    const storedMetaData = {};
    computedMetaFields.forEach((field)=>{
        var _file$meta$field$id;
        storedMetaData[field.id] = (_file$meta$field$id = file.meta[field.id]) != null ? _file$meta$field$id : "";
    });
    const [formState, setFormState] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(storedMetaData);
    const handleSave = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        ev.preventDefault();
        saveFileCard(formState, fileCardFor);
    }, [
        saveFileCard,
        formState,
        fileCardFor
    ]);
    const updateMeta = (newVal, name)=>{
        setFormState({
            ...formState,
            [name]: newVal
        });
    };
    const handleCancel = ()=>{
        toggleFileCard(false);
    };
    const [form] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(()=>{
        const formEl = document.createElement("form");
        formEl.setAttribute("tabindex", "-1");
        formEl.id = (0, $ee6f2436cceea22a$export$ac4959f4f1338dfc)();
        return formEl;
    });
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        document.body.appendChild(form);
        form.addEventListener("submit", handleSave);
        return ()=>{
            form.removeEventListener("submit", handleSave);
            document.body.removeChild(form);
        };
    }, [
        form,
        handleSave
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-Dashboard-FileCard", className),
        "data-uppy-panelType": "FileCard",
        onDragOver: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDragLeave: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDrop: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onPaste: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, i18nArray("editing", {
        file: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-DashboardContent-titleFile"
        }, file.meta ? file.meta.name : file.name)
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        form: form.id,
        title: i18n("finishEditingFile"),
        onClick: handleCancel
    }, i18n("cancel"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-inner"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-preview",
        style: {
            backgroundColor: (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type).color
        }
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $9e2af7705a2c15c5$export$2e2bcd8739ae039), {
        file: file
    }), showEditButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
        onClick: (event)=>{
            // When opening the image editor we want to save any meta fields changes.
            // Otherwise it's confusing for the user to click save in the editor,
            // but the changes here are discarded. This bypasses validation,
            // but we are okay with that.
            handleSave(event);
            openFileEditor(file);
        }
    }, i18n("editImage"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-info"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $fca34f2366194ceb$export$2e2bcd8739ae039), {
        computedMetaFields: computedMetaFields,
        requiredMetaFields: requiredMetaFields,
        updateMeta: updateMeta,
        form: form,
        formState: formState
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-actions"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn",
        type: "submit",
        form: form.id
    }, i18n("saveChanges")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
        type: "button",
        onClick: handleCancel,
        form: form.id
    }, i18n("cancel")))));
}





const $35cf1967ab48fc35$var$transitionName = "uppy-transition-slideDownUp";
const $35cf1967ab48fc35$var$duration = 250;
/**
 * Vertical slide transition.
 *
 * This can take a _single_ child component, which _must_ accept a `className` prop.
 *
 * Currently this is specific to the `uppy-transition-slideDownUp` transition,
 * but it should be simple to extend this for any type of single-element
 * transition by setting the CSS name and duration as props.
 */ function $35cf1967ab48fc35$var$Slide(_ref) {
    let { children: children } = _ref;
    const [cachedChildren, setCachedChildren] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(null);
    const [className, setClassName] = (0, $e28f05d17e052ff9$export$60241385465d0a34)("");
    const enterTimeoutRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const leaveTimeoutRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const animationFrameRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const handleEnterTransition = ()=>{
        setClassName(`${$35cf1967ab48fc35$var$transitionName}-enter`);
        cancelAnimationFrame(animationFrameRef.current);
        clearTimeout(leaveTimeoutRef.current);
        leaveTimeoutRef.current = undefined;
        animationFrameRef.current = requestAnimationFrame(()=>{
            setClassName(`${$35cf1967ab48fc35$var$transitionName}-enter ${$35cf1967ab48fc35$var$transitionName}-enter-active`);
            enterTimeoutRef.current = setTimeout(()=>{
                setClassName("");
            }, $35cf1967ab48fc35$var$duration);
        });
    };
    const handleLeaveTransition = ()=>{
        setClassName(`${$35cf1967ab48fc35$var$transitionName}-leave`);
        cancelAnimationFrame(animationFrameRef.current);
        clearTimeout(enterTimeoutRef.current);
        enterTimeoutRef.current = undefined;
        animationFrameRef.current = requestAnimationFrame(()=>{
            setClassName(`${$35cf1967ab48fc35$var$transitionName}-leave ${$35cf1967ab48fc35$var$transitionName}-leave-active`);
            leaveTimeoutRef.current = setTimeout(()=>{
                setCachedChildren(null);
                setClassName("");
            }, $35cf1967ab48fc35$var$duration);
        });
    };
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        const child = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(children)[0];
        if (cachedChildren === child) return;
        if (child && !cachedChildren) handleEnterTransition();
        else if (cachedChildren && !child && !leaveTimeoutRef.current) handleLeaveTransition();
        setCachedChildren(child);
    }, [
        children,
        cachedChildren
    ]); // Dependency array to trigger effect on children change
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        return ()=>{
            clearTimeout(enterTimeoutRef.current);
            clearTimeout(leaveTimeoutRef.current);
            cancelAnimationFrame(animationFrameRef.current);
        };
    }, []); // Cleanup useEffect
    if (!cachedChildren) return null;
    return (0, $4d2e93495e50cc85$export$e530037191fcd5d7)(cachedChildren, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))(className, cachedChildren.props.className)
    });
}
var $35cf1967ab48fc35$export$2e2bcd8739ae039 = $35cf1967ab48fc35$var$Slide;


function $8dc96b7f61bbef1d$var$_extends() {
    $8dc96b7f61bbef1d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8dc96b7f61bbef1d$var$_extends.apply(this, arguments);
}
// http://dev.edenspiekermann.com/2016/02/11/introducing-accessible-modal-dialog
// https://github.com/ghosh/micromodal
const $8dc96b7f61bbef1d$var$WIDTH_XL = 900;
const $8dc96b7f61bbef1d$var$WIDTH_LG = 700;
const $8dc96b7f61bbef1d$var$WIDTH_MD = 576;
const $8dc96b7f61bbef1d$var$HEIGHT_MD = 330;
function $8dc96b7f61bbef1d$export$2e2bcd8739ae039(props) {
    const isNoFiles = props.totalFileCount === 0;
    const isSingleFile = props.totalFileCount === 1;
    const isSizeMD = props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD;
    const isSizeHeightMD = props.containerHeight > $8dc96b7f61bbef1d$var$HEIGHT_MD;
    const dashboardClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))({
        "uppy-Dashboard": true,
        "uppy-Dashboard--isDisabled": props.disabled,
        "uppy-Dashboard--animateOpenClose": props.animateOpenClose,
        "uppy-Dashboard--isClosing": props.isClosing,
        "uppy-Dashboard--isDraggingOver": props.isDraggingOver,
        "uppy-Dashboard--modal": !props.inline,
        "uppy-size--md": props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD,
        "uppy-size--lg": props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_LG,
        "uppy-size--xl": props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_XL,
        "uppy-size--height-md": props.containerHeight > $8dc96b7f61bbef1d$var$HEIGHT_MD,
        // We might want to enable this in the future
        // 'uppy-size--height-lg': props.containerHeight > HEIGHT_LG,
        // 'uppy-size--height-xl': props.containerHeight > HEIGHT_XL,
        "uppy-Dashboard--isAddFilesPanelVisible": props.showAddFilesPanel,
        "uppy-Dashboard--isInnerWrapVisible": props.areInsidesReadyToBeVisible,
        // Only enable “centered single file” mode when Dashboard is tall enough
        "uppy-Dashboard--singleFile": props.singleFileFullScreen && isSingleFile && isSizeHeightMD
    });
    // Important: keep these in sync with the percent width values in `src/components/FileItem/index.scss`.
    let itemsPerRow = 1; // mobile
    if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_XL) itemsPerRow = 5;
    else if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_LG) itemsPerRow = 4;
    else if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD) itemsPerRow = 3;
    const showFileList = props.showSelectedFiles && !isNoFiles;
    const numberOfFilesForRecovery = props.recoveredState ? Object.keys(props.recoveredState.files).length : null;
    const numberOfGhosts = props.files ? Object.keys(props.files).filter((fileID)=>props.files[fileID].isGhost).length : null;
    const renderRestoredText = ()=>{
        if (numberOfGhosts > 0) return props.i18n("recoveredXFiles", {
            smart_count: numberOfGhosts
        });
        return props.i18n("recoveredAllFiles");
    };
    const dashboard = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: dashboardClassName,
        "data-uppy-theme": props.theme,
        "data-uppy-num-acquirers": props.acquirers.length,
        "data-uppy-drag-drop-supported": !props.disableLocalFiles && (0, $5e3c26e19f70d299$export$2e2bcd8739ae039)(),
        "aria-hidden": props.inline ? "false" : props.isHidden,
        "aria-disabled": props.disabled,
        "aria-label": !props.inline ? props.i18n("dashboardWindowTitle") : props.i18n("dashboardTitle"),
        onPaste: props.handlePaste,
        onDragOver: props.handleDragOver,
        onDragLeave: props.handleDragLeave,
        onDrop: props.handleDrop
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        "aria-hidden": "true",
        className: "uppy-Dashboard-overlay",
        tabIndex: -1,
        onClick: props.handleClickOutside
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-inner",
        "aria-modal": !props.inline && "true",
        role: props.inline ? undefined : "dialog",
        style: {
            width: props.inline && props.width ? props.width : "",
            height: props.inline && props.height ? props.height : ""
        }
    }, !props.inline ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-close",
        type: "button",
        "aria-label": props.i18n("closeModal"),
        title: props.i18n("closeModal"),
        onClick: props.closeModal
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        "aria-hidden": "true"
    }, "\xd7")) : null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-innerWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-dropFilesHereHint"
    }, props.i18n("dropHint")), showFileList && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $915070fc553cba86$export$2e2bcd8739ae039), props), numberOfFilesForRecovery && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-serviceMsg"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        className: "uppy-Dashboard-serviceMsg-icon",
        "aria-hidden": "true",
        focusable: "false",
        width: "21",
        height: "16",
        viewBox: "0 0 24 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        transform: "translate(0 -1)",
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M12.857 1.43l10.234 17.056A1 1 0 0122.234 20H1.766a1 1 0 01-.857-1.514L11.143 1.429a1 1 0 011.714 0z",
        fill: "#FFD300"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#000",
        d: "M11 6h2l-.3 8h-1.4z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#000",
        cx: "12",
        cy: "17",
        r: "1"
    }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("strong", {
        className: "uppy-Dashboard-serviceMsg-title"
    }, props.i18n("sessionRestored")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-serviceMsg-text"
    }, renderRestoredText())), showFileList ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $7a578b6cd2206257$export$2e2bcd8739ae039), {
        id: props.id,
        error: props.error,
        i18n: props.i18n,
        uppy: props.uppy,
        files: props.files,
        acquirers: props.acquirers,
        resumableUploads: props.resumableUploads,
        hideRetryButton: props.hideRetryButton,
        hidePauseResumeButton: props.hidePauseResumeButton,
        hideCancelButton: props.hideCancelButton,
        showLinkToFileUploadResult: props.showLinkToFileUploadResult,
        showRemoveButtonAfterComplete: props.showRemoveButtonAfterComplete,
        isWide: props.isWide,
        metaFields: props.metaFields,
        toggleFileCard: props.toggleFileCard,
        handleRequestThumbnail: props.handleRequestThumbnail,
        handleCancelThumbnail: props.handleCancelThumbnail,
        recoveredState: props.recoveredState,
        individualCancellation: props.individualCancellation,
        openFileEditor: props.openFileEditor,
        canEditFile: props.canEditFile,
        toggleAddFilesPanel: props.toggleAddFilesPanel,
        isSingleFile: isSingleFile,
        itemsPerRow: itemsPerRow
    }) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({}, props, {
        isSizeMD: isSizeMD
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.showAddFilesPanel ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $175934b4bbc4fb46$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "AddFiles"
    }, props, {
        isSizeMD: isSizeMD
    })) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.fileCardFor ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $af43f3a66035ecee$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "FileCard"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.activePickerPanel ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e3578ca53f5728a8$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "Picker"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.showFileEditor ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $d8360bbc75e6a373$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "Editor"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-progressindicators"
    }, props.progressindicators.map((target)=>{
        return props.uppy.getPlugin(target.id).render(props.state);
    })))));
    return dashboard;
}


var $c4158ae05dd76b13$export$2e2bcd8739ae039 = {
    strings: {
        // When `inline: false`, used as the screen reader label for the button that closes the modal.
        closeModal: "Close Modal",
        // Used as the screen reader label for the plus (+) button that shows the “Add more files” screen
        addMoreFiles: "Add more files",
        addingMoreFiles: "Adding more files",
        // Used as the header for import panels, e.g., “Import from Google Drive”.
        importFrom: "Import from %{name}",
        // When `inline: false`, used as the screen reader label for the dashboard modal.
        dashboardWindowTitle: "Uppy Dashboard Window (Press escape to close)",
        // When `inline: true`, used as the screen reader label for the dashboard area.
        dashboardTitle: "Uppy Dashboard",
        // Shown in the Informer when a link to a file was copied to the clipboard.
        copyLinkToClipboardSuccess: "Link copied to clipboard.",
        // Used when a link cannot be copied automatically — the user has to select the text from the
        // input element below this string.
        copyLinkToClipboardFallback: "Copy the URL below",
        // Used as the hover title and screen reader label for buttons that copy a file link.
        copyLink: "Copy link",
        back: "Back",
        // Used as the screen reader label for buttons that remove a file.
        removeFile: "Remove file",
        // Used as the screen reader label for buttons that open the metadata editor panel for a file.
        editFile: "Edit file",
        editImage: "Edit image",
        // Shown in the panel header for the metadata editor. Rendered as “Editing image.png”.
        editing: "Editing %{file}",
        // Shown on the main upload screen when an upload error occurs
        error: "Error",
        // Used as the screen reader label for the button that saves metadata edits and returns to the
        // file list view.
        finishEditingFile: "Finish editing file",
        saveChanges: "Save changes",
        // Used as the label for the tab button that opens the system file selection dialog.
        myDevice: "My Device",
        dropHint: "Drop your files here",
        // Used as the hover text and screen reader label for file progress indicators when
        // they have been fully uploaded.
        uploadComplete: "Upload complete",
        uploadPaused: "Upload paused",
        // Used as the hover text and screen reader label for the buttons to resume paused uploads.
        resumeUpload: "Resume upload",
        // Used as the hover text and screen reader label for the buttons to pause uploads.
        pauseUpload: "Pause upload",
        // Used as the hover text and screen reader label for the buttons to retry failed uploads.
        retryUpload: "Retry upload",
        // Used as the hover text and screen reader label for the buttons to cancel uploads.
        cancelUpload: "Cancel upload",
        // Used in a title, how many files are currently selected
        xFilesSelected: {
            0: "%{smart_count} file selected",
            1: "%{smart_count} files selected"
        },
        uploadingXFiles: {
            0: "Uploading %{smart_count} file",
            1: "Uploading %{smart_count} files"
        },
        processingXFiles: {
            0: "Processing %{smart_count} file",
            1: "Processing %{smart_count} files"
        },
        // The "powered by Uppy" link at the bottom of the Dashboard.
        poweredBy: "Powered by %{uppy}",
        addMore: "Add more",
        editFileWithFilename: "Edit file %{file}",
        save: "Save",
        cancel: "Cancel",
        dropPasteFiles: "Drop files here or %{browseFiles}",
        dropPasteFolders: "Drop files here or %{browseFolders}",
        dropPasteBoth: "Drop files here, %{browseFiles} or %{browseFolders}",
        dropPasteImportFiles: "Drop files here, %{browseFiles} or import from:",
        dropPasteImportFolders: "Drop files here, %{browseFolders} or import from:",
        dropPasteImportBoth: "Drop files here, %{browseFiles}, %{browseFolders} or import from:",
        importFiles: "Import files from:",
        browseFiles: "browse files",
        browseFolders: "browse folders",
        recoveredXFiles: {
            0: "We could not fully recover 1 file. Please re-select it and resume the upload.",
            1: "We could not fully recover %{smart_count} files. Please re-select them and resume the upload."
        },
        recoveredAllFiles: "We restored all files. You can now resume the upload.",
        sessionRestored: "Session restored",
        reSelect: "Re-select",
        missingRequiredMetaFields: {
            0: "Missing required meta field: %{fields}.",
            1: "Missing required meta fields: %{fields}."
        },
        // Used for native device camera buttons on mobile
        takePictureBtn: "Take Picture",
        recordVideoBtn: "Record Video"
    }
};


function $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $b868dcf7a47332e3$var$id = 0;
function $b868dcf7a47332e3$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $b868dcf7a47332e3$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $b868dcf7a47332e3$var$packageJson = {
    "version": "3.8.1"
};
const $b868dcf7a47332e3$var$memoize = (0, $e66b69e563b626e6$export$2e2bcd8739ae039).default || (0, $e66b69e563b626e6$export$2e2bcd8739ae039);
const $b868dcf7a47332e3$var$TAB_KEY = 9;
const $b868dcf7a47332e3$var$ESC_KEY = 27;
function $b868dcf7a47332e3$var$createPromise() {
    const o = {};
    o.promise = new Promise((resolve, reject)=>{
        o.resolve = resolve;
        o.reject = reject;
    });
    return o;
}
// set default options, must be kept in sync with packages/@uppy/react/src/DashboardModal.js
const $b868dcf7a47332e3$var$defaultOptions = {
    target: "body",
    metaFields: [],
    inline: false,
    width: 750,
    height: 550,
    thumbnailWidth: 280,
    thumbnailType: "image/jpeg",
    waitForThumbnailsBeforeUpload: false,
    defaultPickerIcon: $671181bcc8a0cf10$export$b9ab270927e310e4,
    showLinkToFileUploadResult: false,
    showProgressDetails: false,
    hideUploadButton: false,
    hideCancelButton: false,
    hideRetryButton: false,
    hidePauseResumeButton: false,
    hideProgressAfterFinish: false,
    note: null,
    closeModalOnClickOutside: false,
    closeAfterFinish: false,
    singleFileFullScreen: true,
    disableStatusBar: false,
    disableInformer: false,
    disableThumbnailGenerator: false,
    disablePageScrollWhenModalOpen: true,
    animateOpenClose: true,
    fileManagerSelectionType: "files",
    proudlyDisplayPoweredByUppy: true,
    showSelectedFiles: true,
    showRemoveButtonAfterComplete: false,
    browserBackButtonClose: false,
    showNativePhotoCameraButton: false,
    showNativeVideoCameraButton: false,
    theme: "light",
    autoOpen: null,
    autoOpenFileEditor: false,
    disabled: false,
    disableLocalFiles: false,
    // Dynamic default options, they have to be defined in the constructor (because
    // they require access to the `this` keyword), but we still want them to
    // appear in the default options so TS knows they'll be defined.
    doneButtonHandler: null,
    onRequestCloseModal: null
};
/**
 * Dashboard UI with previews, metadata editing, tabs for various services and more
 */ var $b868dcf7a47332e3$var$_disabledNodes = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("disabledNodes");
var $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("generateLargeThumbnailIfSingleFile");
var $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("openFileEditorWhenFilesAdded");
var $b868dcf7a47332e3$var$_attachRenderFunctionToTarget = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("attachRenderFunctionToTarget");
var $b868dcf7a47332e3$var$_isTargetSupported = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("isTargetSupported");
var $b868dcf7a47332e3$var$_getAcquirers = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getAcquirers");
var $b868dcf7a47332e3$var$_getProgressIndicators = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getProgressIndicators");
var $b868dcf7a47332e3$var$_getEditors = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getEditors");
var $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("addSpecifiedPluginsFromOptions");
var $b868dcf7a47332e3$var$_autoDiscoverPlugins = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("autoDiscoverPlugins");
var $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("addSupportedPluginIfNoTarget");
class $b868dcf7a47332e3$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    // Timeouts
    constructor(uppy, _opts){
        var _this$opts4, _this$opts4$doneButto, _this$opts5, _this$opts5$onRequest;
        // support for the legacy `autoOpenFileEditor` option,
        // TODO: we can remove this code when we update the Uppy major version
        let autoOpen;
        if (!_opts) autoOpen = null;
        else if (_opts.autoOpen === undefined) autoOpen = _opts.autoOpenFileEditor ? "imageEditor" : null;
        else autoOpen = _opts.autoOpen;
        super(uppy, {
            ...$b868dcf7a47332e3$var$defaultOptions,
            ..._opts,
            autoOpen: autoOpen
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_disabledNodes, {
            writable: true,
            value: void 0
        });
        this.modalName = `uppy-Dashboard-${(0, $ee6f2436cceea22a$export$ac4959f4f1338dfc)()}`;
        this.superFocus = (0, $33dc1dd867a7b8b6$export$2e2bcd8739ae039)();
        this.ifFocusedOnUppyRecently = false;
        this.removeTarget = (plugin)=>{
            const pluginState = this.getPluginState();
            // filter out the one we want to remove
            const newTargets = pluginState.targets.filter((target)=>target.id !== plugin.id);
            this.setPluginState({
                targets: newTargets
            });
        };
        this.addTarget = (plugin)=>{
            const callerPluginId = plugin.id || plugin.constructor.name;
            const callerPluginName = plugin.title || callerPluginId;
            const callerPluginType = plugin.type;
            if (callerPluginType !== "acquirer" && callerPluginType !== "progressindicator" && callerPluginType !== "editor") {
                const msg = "Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor";
                this.uppy.log(msg, "error");
                return null;
            }
            const target = {
                id: callerPluginId,
                name: callerPluginName,
                type: callerPluginType
            };
            const state = this.getPluginState();
            const newTargets = state.targets.slice();
            newTargets.push(target);
            this.setPluginState({
                targets: newTargets
            });
            return this.el;
        };
        this.hideAllPanels = ()=>{
            var _state$activePickerPa;
            const state = this.getPluginState();
            const update = {
                activePickerPanel: undefined,
                showAddFilesPanel: false,
                activeOverlayType: null,
                fileCardFor: null,
                showFileEditor: false
            };
            if (state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType) // avoid doing a state update if nothing changed
            return;
            this.setPluginState(update);
            this.uppy.emit("dashboard:close-panel", (_state$activePickerPa = state.activePickerPanel) == null ? void 0 : _state$activePickerPa.id);
        };
        this.showPanel = (id)=>{
            const { targets: targets } = this.getPluginState();
            const activePickerPanel = targets.find((target)=>{
                return target.type === "acquirer" && target.id === id;
            });
            this.setPluginState({
                activePickerPanel: activePickerPanel,
                activeOverlayType: "PickerPanel"
            });
            this.uppy.emit("dashboard:show-panel", id);
        };
        this.canEditFile = (file)=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            return editors.some((target)=>this.uppy.getPlugin(target.id).canEditFile(file));
        };
        this.openFileEditor = (file)=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            this.setPluginState({
                showFileEditor: true,
                fileCardFor: file.id || null,
                activeOverlayType: "FileEditor"
            });
            editors.forEach((editor)=>{
                this.uppy.getPlugin(editor.id).selectFile(file);
            });
        };
        this.closeFileEditor = ()=>{
            const { metaFields: metaFields } = this.getPluginState();
            const isMetaEditorEnabled = metaFields && metaFields.length > 0;
            if (isMetaEditorEnabled) this.setPluginState({
                showFileEditor: false,
                activeOverlayType: "FileCard"
            });
            else this.setPluginState({
                showFileEditor: false,
                fileCardFor: null,
                activeOverlayType: "AddFiles"
            });
        };
        this.saveFileEditor = ()=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            editors.forEach((editor)=>{
                this.uppy.getPlugin(editor.id).save();
            });
            this.closeFileEditor();
        };
        this.openModal = ()=>{
            const { promise: promise, resolve: resolve } = $b868dcf7a47332e3$var$createPromise();
            // save scroll position
            this.savedScrollPosition = window.pageYOffset;
            // save active element, so we can restore focus when modal is closed
            this.savedActiveElement = document.activeElement;
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.add("uppy-Dashboard-isFixed");
            if (this.opts.animateOpenClose && this.getPluginState().isClosing) {
                const handler = ()=>{
                    this.setPluginState({
                        isHidden: false
                    });
                    this.el.removeEventListener("animationend", handler, false);
                    resolve();
                };
                this.el.addEventListener("animationend", handler, false);
            } else {
                this.setPluginState({
                    isHidden: false
                });
                resolve();
            }
            if (this.opts.browserBackButtonClose) this.updateBrowserHistory();
            // handle ESC and TAB keys in modal dialog
            document.addEventListener("keydown", this.handleKeyDownInModal);
            this.uppy.emit("dashboard:modal-open");
            return promise;
        };
        this.closeModal = (opts)=>{
            var _opts$manualClose;
            // Whether the modal is being closed by the user (`true`) or by other means (e.g. browser back button)
            const manualClose = (_opts$manualClose = opts == null ? void 0 : opts.manualClose) != null ? _opts$manualClose : true;
            const { isHidden: isHidden, isClosing: isClosing } = this.getPluginState();
            if (isHidden || isClosing) // short-circuit if animation is ongoing
            return undefined;
            const { promise: promise, resolve: resolve } = $b868dcf7a47332e3$var$createPromise();
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.remove("uppy-Dashboard-isFixed");
            if (this.opts.animateOpenClose) {
                this.setPluginState({
                    isClosing: true
                });
                const handler = ()=>{
                    this.setPluginState({
                        isHidden: true,
                        isClosing: false
                    });
                    this.superFocus.cancel();
                    this.savedActiveElement.focus();
                    this.el.removeEventListener("animationend", handler, false);
                    resolve();
                };
                this.el.addEventListener("animationend", handler, false);
            } else {
                this.setPluginState({
                    isHidden: true
                });
                this.superFocus.cancel();
                this.savedActiveElement.focus();
                resolve();
            }
            // handle ESC and TAB keys in modal dialog
            document.removeEventListener("keydown", this.handleKeyDownInModal);
            if (manualClose) {
                if (this.opts.browserBackButtonClose) {
                    var _history$state;
                    // Make sure that the latest entry in the history state is our modal name
                    // eslint-disable-next-line no-restricted-globals
                    if ((_history$state = history.state) != null && _history$state[this.modalName]) // Go back in history to clear out the entry we created (ultimately closing the modal)
                    // eslint-disable-next-line no-restricted-globals
                    history.back();
                }
            }
            this.uppy.emit("dashboard:modal-closed");
            return promise;
        };
        this.isModalOpen = ()=>{
            return !this.getPluginState().isHidden || false;
        };
        this.requestCloseModal = ()=>{
            if (this.opts.onRequestCloseModal) return this.opts.onRequestCloseModal();
            return this.closeModal();
        };
        this.setDarkModeCapability = (isDarkModeOn)=>{
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    darkMode: isDarkModeOn
                }
            });
        };
        this.handleSystemDarkModeChange = (event)=>{
            const isDarkModeOnNow = event.matches;
            this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnNow ? "on" : "off"}`);
            this.setDarkModeCapability(isDarkModeOnNow);
        };
        this.toggleFileCard = (show, fileID)=>{
            const file = this.uppy.getFile(fileID);
            if (show) this.uppy.emit("dashboard:file-edit-start", file);
            else this.uppy.emit("dashboard:file-edit-complete", file);
            this.setPluginState({
                fileCardFor: show ? fileID : null,
                activeOverlayType: show ? "FileCard" : null
            });
        };
        this.toggleAddFilesPanel = (show)=>{
            this.setPluginState({
                showAddFilesPanel: show,
                activeOverlayType: show ? "AddFiles" : null
            });
        };
        this.addFiles = (files)=>{
            const descriptors = files.map((file)=>({
                    source: this.id,
                    name: file.name,
                    type: file.type,
                    data: file,
                    meta: {
                        // path of the file relative to the ancestor directory the user selected.
                        // e.g. 'docs/Old Prague/airbnb.pdf'
                        relativePath: file.relativePath || file.webkitRelativePath || null
                    }
                }));
            try {
                this.uppy.addFiles(descriptors);
            } catch (err) {
                this.uppy.log(err);
            }
        };
        // ___Why make insides of Dashboard invisible until first ResizeObserver event is emitted?
        //    ResizeOberserver doesn't emit the first resize event fast enough, users can see the jump from one .uppy-size-- to
        //    another (e.g. in Safari)
        // ___Why not apply visibility property to .uppy-Dashboard-inner?
        //    Because ideally, acc to specs, ResizeObserver should see invisible elements as of width 0. So even though applying
        //    invisibility to .uppy-Dashboard-inner works now, it may not work in the future.
        this.startListeningToResize = ()=>{
            // Watch for Dashboard container (`.uppy-Dashboard-inner`) resize
            // and update containerWidth/containerHeight in plugin state accordingly.
            // Emits first event on initialization.
            this.resizeObserver = new ResizeObserver((entries)=>{
                const uppyDashboardInnerEl = entries[0];
                const { width: width, height: height } = uppyDashboardInnerEl.contentRect;
                this.setPluginState({
                    containerWidth: width,
                    containerHeight: height,
                    areInsidesReadyToBeVisible: true
                });
            });
            this.resizeObserver.observe(this.el.querySelector(".uppy-Dashboard-inner"));
            // If ResizeObserver fails to emit an event telling us what size to use - default to the mobile view
            this.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(()=>{
                const pluginState = this.getPluginState();
                const isModalAndClosed = !this.opts.inline && pluginState.isHidden;
                if (// We might want to enable this in the future
                // if ResizeObserver hasn't yet fired,
                !pluginState.areInsidesReadyToBeVisible && // and it's not due to the modal being closed
                !isModalAndClosed) {
                    this.uppy.log("[Dashboard] resize event didn\u2019t fire on time: defaulted to mobile layout", "warning");
                    this.setPluginState({
                        areInsidesReadyToBeVisible: true
                    });
                }
            }, 1000);
        };
        this.stopListeningToResize = ()=>{
            this.resizeObserver.disconnect();
            clearTimeout(this.makeDashboardInsidesVisibleAnywayTimeout);
        };
        // Records whether we have been interacting with uppy right now,
        // which is then used to determine whether state updates should trigger a refocusing.
        this.recordIfFocusedOnUppyRecently = (event)=>{
            if (this.el.contains(event.target)) this.ifFocusedOnUppyRecently = true;
            else {
                this.ifFocusedOnUppyRecently = false;
                // ___Why run this.superFocus.cancel here when it already runs in superFocusOnEachUpdate?
                //    Because superFocus is debounced, when we move from Uppy to some other element on the page,
                //    previously run superFocus sometimes hits and moves focus back to Uppy.
                this.superFocus.cancel();
            }
        };
        this.disableInteractiveElements = (disable)=>{
            var _classPrivateFieldLoo;
            const NODES_TO_DISABLE = [
                "a[href]",
                "input:not([disabled])",
                "select:not([disabled])",
                "textarea:not([disabled])",
                "button:not([disabled])",
                '[role="button"]:not([disabled])'
            ];
            const nodesToDisable = (_classPrivateFieldLoo = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes]) != null ? _classPrivateFieldLoo : (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(this.el.querySelectorAll(NODES_TO_DISABLE)).filter((node)=>!node.classList.contains("uppy-Dashboard-close"));
            for (const node of nodesToDisable)// Links can’t have `disabled` attr, so we use `aria-disabled` for a11y
            if (node.tagName === "A") node.setAttribute("aria-disabled", disable);
            else node.disabled = disable;
            if (disable) $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes] = nodesToDisable;
            else $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes] = null;
            this.dashboardIsDisabled = disable;
        };
        this.updateBrowserHistory = ()=>{
            var _history$state2;
            // Ensure history state does not already contain our modal name to avoid double-pushing
            // eslint-disable-next-line no-restricted-globals
            if (!((_history$state2 = history.state) != null && _history$state2[this.modalName])) // Push to history so that the page is not lost on browser back button press
            // eslint-disable-next-line no-restricted-globals
            history.pushState({
                // eslint-disable-next-line no-restricted-globals
                ...history.state,
                [this.modalName]: true
            }, "");
            // Listen for back button presses
            window.addEventListener("popstate", this.handlePopState, false);
        };
        this.handlePopState = (event)=>{
            var _event$state;
            // Close the modal if the history state no longer contains our modal name
            if (this.isModalOpen() && (!event.state || !event.state[this.modalName])) this.closeModal({
                manualClose: false
            });
            // When the browser back button is pressed and uppy is now the latest entry
            // in the history but the modal is closed, fix the history by removing the
            // uppy history entry.
            // This occurs when another entry is added into the history state while the
            // modal is open, and then the modal gets manually closed.
            // Solves PR #575 (https://github.com/transloadit/uppy/pull/575)
            if (!this.isModalOpen() && (_event$state = event.state) != null && _event$state[this.modalName]) // eslint-disable-next-line no-restricted-globals
            history.back();
        };
        this.handleKeyDownInModal = (event)=>{
            // close modal on esc key press
            if (event.keyCode === $b868dcf7a47332e3$var$ESC_KEY) this.requestCloseModal();
            // trap focus on tab key press
            if (event.keyCode === $b868dcf7a47332e3$var$TAB_KEY) $f5d602e6112dba3d$export$f41e0874aee57111(event, this.getPluginState().activeOverlayType, this.el);
        };
        this.handleClickOutside = ()=>{
            if (this.opts.closeModalOnClickOutside) this.requestCloseModal();
        };
        this.handlePaste = (event)=>{
            // Let any acquirer plugin (Url/Webcam/etc.) handle pastes to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === "acquirer") plugin.handleRootPaste == null || plugin.handleRootPaste(event);
            });
            // Add all dropped files
            const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(event.clipboardData.files);
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files pasted");
                this.addFiles(files);
            }
        };
        this.handleInputChange = (event)=>{
            event.preventDefault();
            const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(event.target.files);
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files selected through input");
                this.addFiles(files);
            }
        };
        this.handleDragOver = (event)=>{
            var _this$opts$onDragOver, _this$opts;
            event.preventDefault();
            event.stopPropagation();
            // Check if some plugin can handle the datatransfer without files —
            // for instance, the Url plugin can import a url
            const canSomePluginHandleRootDrop = ()=>{
                let somePluginCanHandleRootDrop = true;
                this.uppy.iteratePlugins((plugin)=>{
                    if (plugin.canHandleRootDrop != null && plugin.canHandleRootDrop(event)) somePluginCanHandleRootDrop = true;
                });
                return somePluginCanHandleRootDrop;
            };
            // Check if the "type" of the datatransfer object includes files
            const doesEventHaveFiles = ()=>{
                const { types: types } = event.dataTransfer;
                return types.some((type)=>type === "Files");
            };
            // Deny drop, if no plugins can handle datatransfer, there are no files,
            // or when opts.disabled is set, or new uploads are not allowed
            const somePluginCanHandleRootDrop = canSomePluginHandleRootDrop();
            const hasFiles = doesEventHaveFiles();
            if (!somePluginCanHandleRootDrop && !hasFiles || this.opts.disabled || // opts.disableLocalFiles should only be taken into account if no plugins
            // can handle the datatransfer
            this.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !this.uppy.getState().allowNewUpload) {
                event.dataTransfer.dropEffect = "none"; // eslint-disable-line no-param-reassign
                clearTimeout(this.removeDragOverClassTimeout);
                return;
            }
            // Add a small (+) icon on drop
            // (and prevent browsers from interpreting this as files being _moved_ into the
            // browser, https://github.com/transloadit/uppy/issues/1978).
            event.dataTransfer.dropEffect = "copy"; // eslint-disable-line no-param-reassign
            clearTimeout(this.removeDragOverClassTimeout);
            this.setPluginState({
                isDraggingOver: true
            });
            (_this$opts$onDragOver = (_this$opts = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts, event);
        };
        this.handleDragLeave = (event)=>{
            var _this$opts$onDragLeav, _this$opts2;
            event.preventDefault();
            event.stopPropagation();
            clearTimeout(this.removeDragOverClassTimeout);
            // Timeout against flickering, this solution is taken from drag-drop library.
            // Solution with 'pointer-events: none' didn't work across browsers.
            this.removeDragOverClassTimeout = setTimeout(()=>{
                this.setPluginState({
                    isDraggingOver: false
                });
            }, 50);
            (_this$opts$onDragLeav = (_this$opts2 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts2, event);
        };
        this.handleDrop = async (event)=>{
            var _this$opts$onDrop, _this$opts3;
            event.preventDefault();
            event.stopPropagation();
            clearTimeout(this.removeDragOverClassTimeout);
            this.setPluginState({
                isDraggingOver: false
            });
            // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === "acquirer") plugin.handleRootDrop == null || plugin.handleRootDrop(event);
            });
            // Add all dropped files
            let executedDropErrorOnce = false;
            const logDropError = (error)=>{
                this.uppy.log(error, "error");
                // In practice all drop errors are most likely the same,
                // so let's just show one to avoid overwhelming the user
                if (!executedDropErrorOnce) {
                    this.uppy.info(error.message, "error");
                    executedDropErrorOnce = true;
                }
            };
            this.uppy.log("[Dashboard] Processing dropped files");
            // Add all dropped files
            const files = await (0, $954bacbcaff60289$export$2e2bcd8739ae039)(event.dataTransfer, {
                logDropError: logDropError
            });
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files dropped");
                this.addFiles(files);
            }
            (_this$opts$onDrop = (_this$opts3 = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts3, event);
        };
        this.handleRequestThumbnail = (file)=>{
            if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit("thumbnail:request", file);
        };
        /**
     * We cancel thumbnail requests when a file item component unmounts to avoid
     * clogging up the queue when the user scrolls past many elements.
     */ this.handleCancelThumbnail = (file)=>{
            if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit("thumbnail:cancel", file);
        };
        this.handleKeyDownInInline = (event)=>{
            // Trap focus on tab key press.
            if (event.keyCode === $b868dcf7a47332e3$var$TAB_KEY) $f5d602e6112dba3d$export$66fd63158b65050a(event, this.getPluginState().activeOverlayType, this.el);
        };
        // ___Why do we listen to the 'paste' event on a document instead of onPaste={props.handlePaste} prop,
        //    or this.el.addEventListener('paste')?
        //    Because (at least) Chrome doesn't handle paste if focus is on some button, e.g. 'My Device'.
        //    => Therefore, the best option is to listen to all 'paste' events, and only react to them when we are focused on our
        //       particular Uppy instance.
        // ___Why do we still need onPaste={props.handlePaste} for the DashboardUi?
        //    Because if we click on the 'Drop files here' caption e.g., `document.activeElement` will be 'body'. Which means our
        //    standard determination of whether we're pasting into our Uppy instance won't work.
        //    => Therefore, we need a traditional onPaste={props.handlePaste} handler too.
        this.handlePasteOnBody = (event)=>{
            const isFocusInOverlay = this.el.contains(document.activeElement);
            if (isFocusInOverlay) this.handlePaste(event);
        };
        this.handleComplete = (_ref)=>{
            let { failed: failed } = _ref;
            if (this.opts.closeAfterFinish && !(failed != null && failed.length)) // All uploads are done
            this.requestCloseModal();
        };
        this.handleCancelRestore = ()=>{
            this.uppy.emit("restore-canceled");
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile, {
            writable: true,
            value: ()=>{
                if (this.opts.disableThumbnailGenerator) return;
                const LARGE_THUMBNAIL = 600;
                const files = this.uppy.getFiles();
                if (files.length === 1) {
                    const thumbnailGenerator = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
                    thumbnailGenerator == null || thumbnailGenerator.setOptions({
                        thumbnailWidth: LARGE_THUMBNAIL
                    });
                    const fileForThumbnail = {
                        ...files[0],
                        preview: undefined
                    };
                    thumbnailGenerator == null || thumbnailGenerator.requestThumbnail(fileForThumbnail).then(()=>{
                        thumbnailGenerator == null || thumbnailGenerator.setOptions({
                            thumbnailWidth: this.opts.thumbnailWidth
                        });
                    });
                }
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded, {
            writable: true,
            value: (files)=>{
                const firstFile = files[0];
                const { metaFields: metaFields } = this.getPluginState();
                const isMetaEditorEnabled = metaFields && metaFields.length > 0;
                const isImageEditorEnabled = this.canEditFile(firstFile);
                if (isMetaEditorEnabled && this.opts.autoOpen === "metaEditor") this.toggleFileCard(true, firstFile.id);
                else if (isImageEditorEnabled && this.opts.autoOpen === "imageEditor") this.openFileEditor(firstFile);
            }
        });
        this.initEvents = ()=>{
            // Modal open button
            if (this.opts.trigger && !this.opts.inline) {
                const showModalTrigger = (0, $3da4efa7f88c23a6$export$2e2bcd8739ae039)(this.opts.trigger);
                if (showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.addEventListener("click", this.openModal));
                else this.uppy.log("Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself", "warning");
            }
            this.startListeningToResize();
            document.addEventListener("paste", this.handlePasteOnBody);
            this.uppy.on("plugin-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            this.uppy.on("plugin-remove", this.removeTarget);
            this.uppy.on("file-added", this.hideAllPanels);
            this.uppy.on("dashboard:modal-closed", this.hideAllPanels);
            this.uppy.on("complete", this.handleComplete);
            this.uppy.on("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            this.uppy.on("file-removed", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            // ___Why fire on capture?
            //    Because this.ifFocusedOnUppyRecently needs to change before onUpdate() fires.
            document.addEventListener("focus", this.recordIfFocusedOnUppyRecently, true);
            document.addEventListener("click", this.recordIfFocusedOnUppyRecently, true);
            if (this.opts.inline) this.el.addEventListener("keydown", this.handleKeyDownInInline);
            if (this.opts.autoOpen) this.uppy.on("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded)[$b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded]);
        };
        this.removeEvents = ()=>{
            const showModalTrigger = (0, $3da4efa7f88c23a6$export$2e2bcd8739ae039)(this.opts.trigger);
            if (!this.opts.inline && showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.removeEventListener("click", this.openModal));
            this.stopListeningToResize();
            document.removeEventListener("paste", this.handlePasteOnBody);
            window.removeEventListener("popstate", this.handlePopState, false);
            this.uppy.off("plugin-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            this.uppy.off("plugin-remove", this.removeTarget);
            this.uppy.off("file-added", this.hideAllPanels);
            this.uppy.off("dashboard:modal-closed", this.hideAllPanels);
            this.uppy.off("complete", this.handleComplete);
            this.uppy.off("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            this.uppy.off("file-removed", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            document.removeEventListener("focus", this.recordIfFocusedOnUppyRecently);
            document.removeEventListener("click", this.recordIfFocusedOnUppyRecently);
            if (this.opts.inline) this.el.removeEventListener("keydown", this.handleKeyDownInInline);
            if (this.opts.autoOpen) this.uppy.off("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded)[$b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded]);
        };
        this.superFocusOnEachUpdate = ()=>{
            const isFocusInUppy = this.el.contains(document.activeElement);
            // When focus is lost on the page (== focus is on body for most browsers, or focus is null for IE11)
            const isFocusNowhere = document.activeElement === document.body || document.activeElement === null;
            const isInformerHidden = this.uppy.getState().info.length === 0;
            const isModal = !this.opts.inline;
            if (// If update is connected to showing the Informer - let the screen reader calmly read it.
            isInformerHidden && // If we are in a modal - always superfocus without concern for other elements
            // on the page (user is unlikely to want to interact with the rest of the page)
            (isModal || // If we are already inside of Uppy, or
            isFocusInUppy || // If we are not focused on anything BUT we have already, at least once, focused on uppy
            //   1. We focus when isFocusNowhere, because when the element we were focused
            //      on disappears (e.g. an overlay), - focus gets lost. If user is typing
            //      something somewhere else on the page, - focus won't be 'nowhere'.
            //   2. We only focus when focus is nowhere AND this.ifFocusedOnUppyRecently,
            //      to avoid focus jumps if we do something else on the page.
            //   [Practical check] Without '&& this.ifFocusedOnUppyRecently', in Safari, in inline mode,
            //                     when file is uploading, - navigate via tab to the checkbox,
            //                     try to press space multiple times. Focus will jump to Uppy.
            isFocusNowhere && this.ifFocusedOnUppyRecently)) this.superFocus(this.el, this.getPluginState().activeOverlayType);
            else this.superFocus.cancel();
        };
        this.afterUpdate = ()=>{
            if (this.opts.disabled && !this.dashboardIsDisabled) {
                this.disableInteractiveElements(true);
                return;
            }
            if (!this.opts.disabled && this.dashboardIsDisabled) this.disableInteractiveElements(false);
            this.superFocusOnEachUpdate();
        };
        this.saveFileCard = (meta, fileID)=>{
            this.uppy.setFileMeta(fileID, meta);
            this.toggleFileCard(false, fileID);
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget, {
            writable: true,
            value: (target)=>{
                const plugin = this.uppy.getPlugin(target.id);
                return {
                    ...target,
                    icon: plugin.icon || this.opts.defaultPickerIcon,
                    render: plugin.render
                };
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_isTargetSupported, {
            writable: true,
            value: (target)=>{
                const plugin = this.uppy.getPlugin(target.id);
                // If the plugin does not provide a `supported` check, assume the plugin works everywhere.
                if (typeof plugin.isSupported !== "function") return true;
                return plugin.isSupported();
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getAcquirers, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "acquirer" && $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_isTargetSupported)[$b868dcf7a47332e3$var$_isTargetSupported](target)).map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getProgressIndicators, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "progressindicator").map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getEditors, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "editor").map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        this.render = (state)=>{
            const pluginState = this.getPluginState();
            const { files: files, capabilities: capabilities, allowNewUpload: allowNewUpload } = state;
            const { newFiles: newFiles, uploadStartedFiles: uploadStartedFiles, completeFiles: completeFiles, erroredFiles: erroredFiles, inProgressFiles: inProgressFiles, inProgressNotPausedFiles: inProgressNotPausedFiles, processingFiles: processingFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused } = this.uppy.getObjectOfFilesPerState();
            const acquirers = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getAcquirers)[$b868dcf7a47332e3$var$_getAcquirers](pluginState.targets);
            const progressindicators = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getProgressIndicators)[$b868dcf7a47332e3$var$_getProgressIndicators](pluginState.targets);
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](pluginState.targets);
            let theme;
            if (this.opts.theme === "auto") theme = capabilities.darkMode ? "dark" : "light";
            else theme = this.opts.theme;
            if ([
                "files",
                "folders",
                "both"
            ].indexOf(this.opts.fileManagerSelectionType) < 0) {
                this.opts.fileManagerSelectionType = "files";
                // eslint-disable-next-line no-console
                console.warn(`Unsupported option for "fileManagerSelectionType". Using default of "${this.opts.fileManagerSelectionType}".`);
            }
            return (0, $8dc96b7f61bbef1d$export$2e2bcd8739ae039)({
                state: state,
                isHidden: pluginState.isHidden,
                files: files,
                newFiles: newFiles,
                uploadStartedFiles: uploadStartedFiles,
                completeFiles: completeFiles,
                erroredFiles: erroredFiles,
                inProgressFiles: inProgressFiles,
                inProgressNotPausedFiles: inProgressNotPausedFiles,
                processingFiles: processingFiles,
                isUploadStarted: isUploadStarted,
                isAllComplete: isAllComplete,
                isAllErrored: isAllErrored,
                isAllPaused: isAllPaused,
                totalFileCount: Object.keys(files).length,
                totalProgress: state.totalProgress,
                allowNewUpload: allowNewUpload,
                acquirers: acquirers,
                theme: theme,
                disabled: this.opts.disabled,
                disableLocalFiles: this.opts.disableLocalFiles,
                direction: this.opts.direction,
                activePickerPanel: pluginState.activePickerPanel,
                showFileEditor: pluginState.showFileEditor,
                saveFileEditor: this.saveFileEditor,
                closeFileEditor: this.closeFileEditor,
                disableInteractiveElements: this.disableInteractiveElements,
                animateOpenClose: this.opts.animateOpenClose,
                isClosing: pluginState.isClosing,
                progressindicators: progressindicators,
                editors: editors,
                autoProceed: this.uppy.opts.autoProceed,
                id: this.id,
                closeModal: this.requestCloseModal,
                handleClickOutside: this.handleClickOutside,
                handleInputChange: this.handleInputChange,
                handlePaste: this.handlePaste,
                inline: this.opts.inline,
                showPanel: this.showPanel,
                hideAllPanels: this.hideAllPanels,
                i18n: this.i18n,
                i18nArray: this.i18nArray,
                uppy: this.uppy,
                note: this.opts.note,
                recoveredState: state.recoveredState,
                metaFields: pluginState.metaFields,
                resumableUploads: capabilities.resumableUploads || false,
                individualCancellation: capabilities.individualCancellation,
                isMobileDevice: capabilities.isMobileDevice,
                fileCardFor: pluginState.fileCardFor,
                toggleFileCard: this.toggleFileCard,
                toggleAddFilesPanel: this.toggleAddFilesPanel,
                showAddFilesPanel: pluginState.showAddFilesPanel,
                saveFileCard: this.saveFileCard,
                openFileEditor: this.openFileEditor,
                canEditFile: this.canEditFile,
                width: this.opts.width,
                height: this.opts.height,
                showLinkToFileUploadResult: this.opts.showLinkToFileUploadResult,
                fileManagerSelectionType: this.opts.fileManagerSelectionType,
                proudlyDisplayPoweredByUppy: this.opts.proudlyDisplayPoweredByUppy,
                hideCancelButton: this.opts.hideCancelButton,
                hideRetryButton: this.opts.hideRetryButton,
                hidePauseResumeButton: this.opts.hidePauseResumeButton,
                showRemoveButtonAfterComplete: this.opts.showRemoveButtonAfterComplete,
                containerWidth: pluginState.containerWidth,
                containerHeight: pluginState.containerHeight,
                areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
                isTargetDOMEl: this.isTargetDOMEl,
                parentElement: this.el,
                allowedFileTypes: this.uppy.opts.restrictions.allowedFileTypes,
                maxNumberOfFiles: this.uppy.opts.restrictions.maxNumberOfFiles,
                requiredMetaFields: this.uppy.opts.restrictions.requiredMetaFields,
                showSelectedFiles: this.opts.showSelectedFiles,
                showNativePhotoCameraButton: this.opts.showNativePhotoCameraButton,
                showNativeVideoCameraButton: this.opts.showNativeVideoCameraButton,
                nativeCameraFacingMode: this.opts.nativeCameraFacingMode,
                singleFileFullScreen: this.opts.singleFileFullScreen,
                handleCancelRestore: this.handleCancelRestore,
                handleRequestThumbnail: this.handleRequestThumbnail,
                handleCancelThumbnail: this.handleCancelThumbnail,
                // drag props
                isDraggingOver: pluginState.isDraggingOver,
                handleDragOver: this.handleDragOver,
                handleDragLeave: this.handleDragLeave,
                handleDrop: this.handleDrop
            });
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions, {
            writable: true,
            value: ()=>{
                const plugins = this.opts.plugins || [];
                plugins.forEach((pluginID)=>{
                    const plugin = this.uppy.getPlugin(pluginID);
                    if (plugin) plugin.mount(this, plugin);
                    else this.uppy.log(`[Uppy] Dashboard could not find plugin '${pluginID}', make sure to uppy.use() the plugins you are specifying`, "warning");
                });
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_autoDiscoverPlugins, {
            writable: true,
            value: ()=>{
                this.uppy.iteratePlugins($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget, {
            writable: true,
            value: (plugin)=>{
                var _plugin$opts;
                // Only these types belong on the Dashboard,
                // we wouldn’t want to try and mount Compressor or Tus, for example.
                const typesAllowed = [
                    "acquirer",
                    "editor"
                ];
                if (plugin && !((_plugin$opts = plugin.opts) != null && _plugin$opts.target) && typesAllowed.includes(plugin.type)) {
                    const pluginAlreadyAdded = this.getPluginState().targets.some((installedPlugin)=>plugin.id === installedPlugin.id);
                    if (!pluginAlreadyAdded) plugin.mount(this, plugin);
                }
            }
        });
        this.install = ()=>{
            // Set default state for Dashboard
            this.setPluginState({
                isHidden: true,
                fileCardFor: null,
                activeOverlayType: null,
                showAddFilesPanel: false,
                activePickerPanel: undefined,
                showFileEditor: false,
                metaFields: this.opts.metaFields,
                targets: [],
                // We'll make them visible once .containerWidth is determined
                areInsidesReadyToBeVisible: false,
                isDraggingOver: false
            });
            const { inline: inline, closeAfterFinish: closeAfterFinish } = this.opts;
            if (inline && closeAfterFinish) throw new Error("[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.");
            const { allowMultipleUploads: allowMultipleUploads, allowMultipleUploadBatches: allowMultipleUploadBatches } = this.uppy.opts;
            if ((allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish) this.uppy.log("[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true", "warning");
            const { target: target } = this.opts;
            if (target) this.mount(target, this);
            if (!this.opts.disableStatusBar) this.uppy.use((0, $f22a72e7b80fdb1a$export$2e2bcd8739ae039), {
                id: `${this.id}:StatusBar`,
                target: this,
                hideUploadButton: this.opts.hideUploadButton,
                hideRetryButton: this.opts.hideRetryButton,
                hidePauseResumeButton: this.opts.hidePauseResumeButton,
                hideCancelButton: this.opts.hideCancelButton,
                showProgressDetails: this.opts.showProgressDetails,
                hideAfterFinish: this.opts.hideProgressAfterFinish,
                locale: this.opts.locale,
                doneButtonHandler: this.opts.doneButtonHandler
            });
            if (!this.opts.disableInformer) this.uppy.use((0, $2d1e3e0d76faae78$export$2e2bcd8739ae039), {
                id: `${this.id}:Informer`,
                target: this
            });
            if (!this.opts.disableThumbnailGenerator) this.uppy.use((0, $f92c4ad36d89e394$export$2e2bcd8739ae039), {
                id: `${this.id}:ThumbnailGenerator`,
                thumbnailWidth: this.opts.thumbnailWidth,
                thumbnailHeight: this.opts.thumbnailHeight,
                thumbnailType: this.opts.thumbnailType,
                waitForThumbnailsBeforeUpload: this.opts.waitForThumbnailsBeforeUpload,
                // If we don't block on thumbnails, we can lazily generate them
                lazy: !this.opts.waitForThumbnailsBeforeUpload
            });
            // Dark Mode / theme
            this.darkModeMediaQuery = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
            const isDarkModeOnFromTheStart = this.darkModeMediaQuery ? this.darkModeMediaQuery.matches : false;
            this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnFromTheStart ? "on" : "off"}`);
            this.setDarkModeCapability(isDarkModeOnFromTheStart);
            if (this.opts.theme === "auto") {
                var _this$darkModeMediaQu;
                (_this$darkModeMediaQu = this.darkModeMediaQuery) == null || _this$darkModeMediaQu.addListener(this.handleSystemDarkModeChange);
            }
            $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions)[$b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions]();
            $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_autoDiscoverPlugins)[$b868dcf7a47332e3$var$_autoDiscoverPlugins]();
            this.initEvents();
        };
        this.uninstall = ()=>{
            if (!this.opts.disableInformer) {
                const informer = this.uppy.getPlugin(`${this.id}:Informer`);
                // Checking if this plugin exists, in case it was removed by uppy-core
                // before the Dashboard was.
                if (informer) this.uppy.removePlugin(informer);
            }
            if (!this.opts.disableStatusBar) {
                const statusBar = this.uppy.getPlugin(`${this.id}:StatusBar`);
                if (statusBar) this.uppy.removePlugin(statusBar);
            }
            if (!this.opts.disableThumbnailGenerator) {
                const thumbnail = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
                if (thumbnail) this.uppy.removePlugin(thumbnail);
            }
            const plugins = this.opts.plugins || [];
            plugins.forEach((pluginID)=>{
                const plugin = this.uppy.getPlugin(pluginID);
                if (plugin) plugin.unmount();
            });
            if (this.opts.theme === "auto") {
                var _this$darkModeMediaQu2;
                (_this$darkModeMediaQu2 = this.darkModeMediaQuery) == null || _this$darkModeMediaQu2.removeListener(this.handleSystemDarkModeChange);
            }
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.remove("uppy-Dashboard-isFixed");
            this.unmount();
            this.removeEvents();
        };
        this.id = this.opts.id || "Dashboard";
        this.title = "Dashboard";
        this.type = "orchestrator";
        this.defaultLocale = (0, $c4158ae05dd76b13$export$2e2bcd8739ae039);
        // Dynamic default options:
        (_this$opts4$doneButto = (_this$opts4 = this.opts).doneButtonHandler) != null ? _this$opts4$doneButto : _this$opts4.doneButtonHandler = ()=>{
            this.uppy.clearUploadedFiles();
            this.requestCloseModal();
        };
        (_this$opts5$onRequest = (_this$opts5 = this.opts).onRequestCloseModal) != null ? _this$opts5$onRequest : _this$opts5.onRequestCloseModal = ()=>this.closeModal();
        this.i18nInit();
    }
}
$b868dcf7a47332e3$export$2e2bcd8739ae039.VERSION = $b868dcf7a47332e3$var$packageJson.version;





let $44bd0219bfdf3171$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $44bd0219bfdf3171$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $44bd0219bfdf3171$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $44bd0219bfdf3171$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


function $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $c89f32c7d05a95a3$var$id = 0;
function $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $c89f32c7d05a95a3$var$id++ + "_" + name;
}
var $c89f32c7d05a95a3$var$_uppy = /*#__PURE__*/ $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey("uppy");
var $c89f32c7d05a95a3$var$_events = /*#__PURE__*/ $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey("events");
class $c89f32c7d05a95a3$export$2e2bcd8739ae039 {
    constructor(uppy){
        Object.defineProperty(this, $c89f32c7d05a95a3$var$_uppy, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c89f32c7d05a95a3$var$_events, {
            writable: true,
            value: []
        });
        $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy] = uppy;
    }
    /** @deprecated */ on(event, fn) {
        $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_events)[$c89f32c7d05a95a3$var$_events].push([
            event,
            fn
        ]);
        return $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].on(event, fn);
    }
    remove() {
        for (const [event, fn] of $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_events)[$c89f32c7d05a95a3$var$_events].splice(0))$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].off(event, fn);
    }
    onFilePause(fileID, cb) {
        this.on("upload-pause", (targetFileID, isPaused)=>{
            if (fileID === targetFileID) cb(isPaused);
        });
    }
    onFileRemove(fileID, cb) {
        this.on("file-removed", (file)=>{
            if (fileID === file.id) cb(file.id);
        });
    }
    onPause(fileID, cb) {
        this.on("upload-pause", (targetFileID, isPaused)=>{
            if (fileID === targetFileID) // const isPaused = this.#uppy.pauseResume(fileID)
            cb(isPaused);
        });
    }
    onRetry(fileID, cb) {
        this.on("upload-retry", (targetFileID)=>{
            if (fileID === targetFileID) cb();
        });
    }
    onRetryAll(fileID, cb) {
        this.on("retry-all", ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
    onPauseAll(fileID, cb) {
        this.on("pause-all", ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
    onCancelAll(fileID, eventHandler) {
        var _this = this;
        this.on("cancel-all", function() {
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(_this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            eventHandler(...arguments);
        });
    }
    onResumeAll(fileID, cb) {
        this.on("resume-all", ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
}


function $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $c8d4b79cf5a3269c$var$id = 0;
function $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $c8d4b79cf5a3269c$var$id++ + "_" + name;
}
var $c8d4b79cf5a3269c$var$_aliveTimer = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("aliveTimer");
var $c8d4b79cf5a3269c$var$_isDone = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("isDone");
var $c8d4b79cf5a3269c$var$_onTimedOut = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("onTimedOut");
var $c8d4b79cf5a3269c$var$_timeout = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("timeout");
/**
 * Helper to abort upload requests if there has not been any progress for `timeout` ms.
 * Create an instance using `timer = new ProgressTimeout(10000, onTimeout)`
 * Call `timer.progress()` to signal that there has been progress of any kind.
 * Call `timer.done()` when the upload has completed.
 */ class $c8d4b79cf5a3269c$var$ProgressTimeout {
    constructor(timeout, timeoutHandler){
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_aliveTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_isDone, {
            writable: true,
            value: false
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_onTimedOut, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_timeout, {
            writable: true,
            value: void 0
        });
        $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout] = timeout;
        $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_onTimedOut)[$c8d4b79cf5a3269c$var$_onTimedOut] = timeoutHandler;
    }
    progress() {
        // Some browsers fire another progress event when the upload is
        // cancelled, so we have to ignore progress after the timer was
        // told to stop.
        if ($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone]) return;
        if ($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout] > 0) {
            clearTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer]);
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer] = setTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_onTimedOut)[$c8d4b79cf5a3269c$var$_onTimedOut], $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout]);
        }
    }
    done() {
        if (!$c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone]) {
            clearTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer]);
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer] = undefined;
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone] = true;
        }
    }
}
var $c8d4b79cf5a3269c$export$2e2bcd8739ae039 = $c8d4b79cf5a3269c$var$ProgressTimeout;


function $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $6cb886e1a5aec334$var$id = 0;
function $6cb886e1a5aec334$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $6cb886e1a5aec334$var$id++ + "_" + name;
}
function $6cb886e1a5aec334$var$createCancelError(cause) {
    return new Error("Cancelled", {
        cause: cause
    });
}
function $6cb886e1a5aec334$var$abortOn(signal) {
    if (signal != null) {
        var _this$then;
        const abortPromise = ()=>this.abort(signal.reason);
        signal.addEventListener("abort", abortPromise, {
            once: true
        });
        const removeAbortListener = ()=>{
            signal.removeEventListener("abort", abortPromise);
        };
        (_this$then = this.then) == null || _this$then.call(this, removeAbortListener, removeAbortListener);
    }
    return this;
}
var $6cb886e1a5aec334$var$_activeRequests = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("activeRequests");
var $6cb886e1a5aec334$var$_queuedHandlers = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queuedHandlers");
var $6cb886e1a5aec334$var$_paused = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("paused");
var $6cb886e1a5aec334$var$_pauseTimer = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("pauseTimer");
var $6cb886e1a5aec334$var$_downLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("downLimit");
var $6cb886e1a5aec334$var$_upperLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("upperLimit");
var $6cb886e1a5aec334$var$_rateLimitingTimer = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("rateLimitingTimer");
var $6cb886e1a5aec334$var$_call = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("call");
var $6cb886e1a5aec334$var$_queueNext = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queueNext");
var $6cb886e1a5aec334$var$_next = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("next");
var $6cb886e1a5aec334$var$_queue = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queue");
var $6cb886e1a5aec334$var$_dequeue = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("dequeue");
var $6cb886e1a5aec334$var$_resume = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("resume");
var $6cb886e1a5aec334$var$_increaseLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("increaseLimit");
class $6cb886e1a5aec334$export$32306e81289653bc {
    constructor(limit){
        Object.defineProperty(this, $6cb886e1a5aec334$var$_dequeue, {
            value: $6cb886e1a5aec334$var$_dequeue2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queue, {
            value: $6cb886e1a5aec334$var$_queue2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_next, {
            value: $6cb886e1a5aec334$var$_next2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queueNext, {
            value: $6cb886e1a5aec334$var$_queueNext2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_call, {
            value: $6cb886e1a5aec334$var$_call2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_activeRequests, {
            writable: true,
            value: 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queuedHandlers, {
            writable: true,
            value: []
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_paused, {
            writable: true,
            value: false
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_pauseTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_downLimit, {
            writable: true,
            value: 1
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_upperLimit, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_rateLimitingTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_resume, {
            writable: true,
            value: ()=>this.resume()
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_increaseLimit, {
            writable: true,
            value: ()=>{
                if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused]) {
                    $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], 0);
                    return;
                }
                $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] = this.limit;
                this.limit = Math.ceil(($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] + $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit]) / 2);
                for(let i = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit]; i <= this.limit; i++)$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
                if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] - $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] > 3) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], 2000);
                else $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] = Math.floor($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] / 2);
            }
        });
        if (typeof limit !== "number" || limit === 0) this.limit = Infinity;
        else this.limit = limit;
    }
    run(fn, queueOptions) {
        if (!$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] && $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] < this.limit) return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_call)[$6cb886e1a5aec334$var$_call](fn);
        return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queue)[$6cb886e1a5aec334$var$_queue](fn, queueOptions);
    }
    wrapSyncFunction(fn, queueOptions) {
        var _this = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            const queuedRequest = _this.run(()=>{
                fn(...args);
                queueMicrotask(()=>queuedRequest.done());
                return ()=>{};
            }, queueOptions);
            return {
                abortOn: $6cb886e1a5aec334$var$abortOn,
                abort () {
                    queuedRequest.abort();
                }
            };
        };
    }
    wrapPromiseFunction(fn, queueOptions) {
        var _this2 = this;
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            let queuedRequest;
            const outerPromise = new Promise((resolve, reject)=>{
                queuedRequest = _this2.run(()=>{
                    let cancelError;
                    let innerPromise;
                    try {
                        innerPromise = Promise.resolve(fn(...args));
                    } catch (err) {
                        innerPromise = Promise.reject(err);
                    }
                    innerPromise.then((result)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            resolve(result);
                        }
                    }, (err)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            reject(err);
                        }
                    });
                    return (cause)=>{
                        cancelError = $6cb886e1a5aec334$var$createCancelError(cause);
                    };
                }, queueOptions);
            });
            outerPromise.abort = (cause)=>{
                queuedRequest.abort(cause);
            };
            outerPromise.abortOn = $6cb886e1a5aec334$var$abortOn;
            return outerPromise;
        };
    }
    resume() {
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] = false;
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer]);
        for(let i = 0; i < this.limit; i++)$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
    }
    /**
   * Freezes the queue for a while or indefinitely.
   *
   * @param {number | null } [duration] Duration for the pause to happen, in milliseconds.
   *                                    If omitted, the queue won't resume automatically.
   */ pause(duration) {
        if (duration === void 0) duration = null;
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] = true;
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer]);
        if (duration != null) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_resume)[$6cb886e1a5aec334$var$_resume], duration);
    }
    /**
   * Pauses the queue for a duration, and lower the limit of concurrent requests
   * when the queue resumes. When the queue resumes, it tries to progressively
   * increase the limit in `this.#increaseLimit` until another call is made to
   * `this.rateLimit`.
   * Call this function when using the RateLimitedQueue for network requests and
   * the remote server responds with 429 HTTP code.
   *
   * @param {number} duration in milliseconds.
   */ rateLimit(duration) {
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer]);
        this.pause(duration);
        if (this.limit > 1 && Number.isFinite(this.limit)) {
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] = this.limit - 1;
            this.limit = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit];
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], duration);
        }
    }
    get isPaused() {
        return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused];
    }
}
function $6cb886e1a5aec334$var$_call2(fn) {
    $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] += 1;
    let done = false;
    let cancelActive;
    try {
        cancelActive = fn();
    } catch (err) {
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
        throw err;
    }
    return {
        abort: (cause)=>{
            if (done) return;
            done = true;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
            cancelActive == null || cancelActive(cause);
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
        },
        done: ()=>{
            if (done) return;
            done = true;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
        }
    };
}
function $6cb886e1a5aec334$var$_queueNext2() {
    // Do it soon but not immediately, this allows clearing out the entire queue synchronously
    // one by one without continuously _advancing_ it (and starting new tasks before immediately
    // aborting them)
    queueMicrotask(()=>$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_next)[$6cb886e1a5aec334$var$_next]());
}
function $6cb886e1a5aec334$var$_next2() {
    if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] || $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] >= this.limit) return;
    if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].length === 0) return;
    // Dispatch the next request, and update the abort/done handlers
    // so that cancelling it does the Right Thing (and doesn't just try
    // to dequeue an already-running request).
    const next = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].shift();
    if (next == null) throw new Error("Invariant violation: next is null");
    const handler = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_call)[$6cb886e1a5aec334$var$_call](next.fn);
    next.abort = handler.abort;
    next.done = handler.done;
}
function $6cb886e1a5aec334$var$_queue2(fn, options) {
    const handler = {
        fn: fn,
        priority: (options == null ? void 0 : options.priority) || 0,
        abort: ()=>{
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_dequeue)[$6cb886e1a5aec334$var$_dequeue](handler);
        },
        done: ()=>{
            throw new Error("Cannot mark a queued request as done: this indicates a bug");
        }
    };
    const index = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].findIndex((other)=>{
        return handler.priority > other.priority;
    });
    if (index === -1) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].push(handler);
    else $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].splice(index, 0, handler);
    return handler;
}
function $6cb886e1a5aec334$var$_dequeue2(handler) {
    const index = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].indexOf(handler);
    if (index !== -1) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].splice(index, 1);
}
const $6cb886e1a5aec334$export$603eb9c93e04437 = Symbol("__queue");


class $0026c55df46f9934$var$NetworkError extends Error {
    constructor(error, xhr){
        if (xhr === void 0) xhr = null;
        super(`This looks like a network error, the endpoint might be blocked by an internet provider or a firewall.`);
        this.cause = error;
        this.isNetworkError = true;
        this.request = xhr;
    }
}
var $0026c55df46f9934$export$2e2bcd8739ae039 = $0026c55df46f9934$var$NetworkError;


function $404d4d8ff4ce3ae1$var$isNetworkError(xhr) {
    if (!xhr) return false;
    return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}
var $404d4d8ff4ce3ae1$export$2e2bcd8739ae039 = $404d4d8ff4ce3ae1$var$isNetworkError;


function $169d20dd56f976c7$export$3bd9b1601aad11ac(files) {
    const hasError = (file)=>"error" in file && !!file.error;
    return files.filter((file)=>!hasError(file));
}
function $169d20dd56f976c7$export$9e8ffa0bfbcfeed6(files) {
    return files.filter((file)=>{
        var _file$progress;
        return !((_file$progress = file.progress) != null && _file$progress.uploadStarted) || !file.isRestored;
    });
}


var $3b2facc875d4722d$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the Informer if an upload is being canceled because it stalled for too long.
        uploadStalled: "Upload has not made any progress for %{seconds} seconds. You may want to retry it."
    }
};


function $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $cf91058fd9d7f8ee$var$id = 0;
function $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $cf91058fd9d7f8ee$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $cf91058fd9d7f8ee$var$packageJson = {
    "version": "3.6.4"
};
function $cf91058fd9d7f8ee$var$buildResponseError(xhr, err) {
    let error = err;
    // No error message
    if (!error) error = new Error("Upload error");
    // Got an error message string
    if (typeof error === "string") error = new Error(error);
    // Got something else
    if (!(error instanceof Error)) error = Object.assign(new Error("Upload error"), {
        data: error
    });
    if ((0, $404d4d8ff4ce3ae1$export$2e2bcd8739ae039)(xhr)) {
        error = new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(error, xhr);
        return error;
    }
    // @ts-expect-error request can only be set on NetworkError
    // but we use NetworkError to distinguish between errors.
    error.request = xhr;
    return error;
}
/**
 * Set `data.type` in the blob to `file.meta.type`,
 * because we might have detected a more accurate file type in Uppy
 * https://stackoverflow.com/a/50875615
 */ function $cf91058fd9d7f8ee$var$setTypeInBlob(file) {
    const dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
    return dataWithUpdatedType;
}
const $cf91058fd9d7f8ee$var$defaultOptions = {
    formData: true,
    fieldName: "file",
    method: "post",
    allowedMetaFields: null,
    responseUrlFieldName: "url",
    bundle: false,
    headers: {},
    timeout: 30000,
    limit: 5,
    withCredentials: false,
    responseType: "",
    getResponseData (responseText) {
        let parsedResponse = {};
        try {
            parsedResponse = JSON.parse(responseText);
        } catch  {
        // ignore
        }
        // We don't have access to the B (Body) generic here
        // so we have to cast it to any. The user facing types
        // remain correct, this is only to please the merging of default options.
        return parsedResponse;
    },
    getResponseError (_, response) {
        let error = new Error("Upload error");
        if ((0, $404d4d8ff4ce3ae1$export$2e2bcd8739ae039)(response)) error = new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(error, response);
        return error;
    },
    validateStatus (status) {
        return status >= 200 && status < 300;
    }
};
var $cf91058fd9d7f8ee$var$_uploadLocalFile = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadLocalFile");
var $cf91058fd9d7f8ee$var$_uploadBundle = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadBundle");
var $cf91058fd9d7f8ee$var$_getCompanionClientArgs = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("getCompanionClientArgs");
var $cf91058fd9d7f8ee$var$_uploadFiles = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadFiles");
var $cf91058fd9d7f8ee$var$_handleUpload = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("handleUpload");
class $cf91058fd9d7f8ee$export$2e2bcd8739ae039 extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    constructor(uppy, _opts){
        super(uppy, {
            ...$cf91058fd9d7f8ee$var$defaultOptions,
            fieldName: _opts.bundle ? "files[]" : "file",
            ..._opts
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadFiles, {
            value: $cf91058fd9d7f8ee$var$_uploadFiles2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_getCompanionClientArgs, {
            value: $cf91058fd9d7f8ee$var$_getCompanionClientArgs2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadBundle, {
            value: $cf91058fd9d7f8ee$var$_uploadBundle2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadLocalFile, {
            value: $cf91058fd9d7f8ee$var$_uploadLocalFile2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_handleUpload, {
            writable: true,
            value: async (fileIDs)=>{
                if (fileIDs.length === 0) {
                    this.uppy.log("[XHRUpload] No files to upload!");
                    return;
                }
                // No limit configured by the user, and no RateLimitedQueue passed in by a "parent" plugin
                // (basically just AwsS3) using the internal symbol
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore untyped internal
                if (this.opts.limit === 0 && !this.opts[0, $6cb886e1a5aec334$export$603eb9c93e04437]) this.uppy.log("[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0", "warning");
                this.uppy.log("[XHRUpload] Uploading...");
                const files = this.uppy.getFilesByIds(fileIDs);
                const filesFiltered = (0, $169d20dd56f976c7$export$3bd9b1601aad11ac)(files);
                const filesToEmit = (0, $169d20dd56f976c7$export$9e8ffa0bfbcfeed6)(filesFiltered);
                this.uppy.emit("upload-start", filesToEmit);
                if (this.opts.bundle) {
                    // if bundle: true, we don’t support remote uploads
                    const isSomeFileRemote = filesFiltered.some((file)=>file.isRemote);
                    if (isSomeFileRemote) throw new Error("Can\u2019t upload remote files when the `bundle: true` option is set");
                    if (typeof this.opts.headers === "function") throw new TypeError("`headers` may not be a function when the `bundle: true` option is set");
                    await $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadBundle)[$cf91058fd9d7f8ee$var$_uploadBundle](filesFiltered);
                } else await $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadFiles)[$cf91058fd9d7f8ee$var$_uploadFiles](filesFiltered);
            }
        });
        this.type = "uploader";
        this.id = this.opts.id || "XHRUpload";
        this.defaultLocale = (0, $3b2facc875d4722d$export$2e2bcd8739ae039);
        this.i18nInit();
        // Simultaneous upload limiting is shared across all uploads with this plugin.
        if ((0, $6cb886e1a5aec334$export$603eb9c93e04437) in this.opts) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore untyped internal
        this.requests = this.opts[0, $6cb886e1a5aec334$export$603eb9c93e04437];
        else this.requests = new (0, $6cb886e1a5aec334$export$32306e81289653bc)(this.opts.limit);
        if (this.opts.bundle && !this.opts.formData) throw new Error("`opts.formData` must be true when `opts.bundle` is enabled.");
        if (this.opts.bundle && typeof this.opts.headers === "function") throw new Error("`opts.headers` can not be a function when the `bundle: true` option is set.");
        if ((_opts == null ? void 0 : _opts.allowedMetaFields) === undefined && "metaFields" in this.opts) throw new Error("The `metaFields` option has been renamed to `allowedMetaFields`.");
        this.uploaderEvents = Object.create(null);
    }
    getOptions(file) {
        const overrides = this.uppy.getState().xhrUpload;
        const { headers: headers } = this.opts;
        const opts = {
            ...this.opts,
            ...overrides || {},
            ...file.xhrUpload || {},
            headers: {}
        };
        // Support for `headers` as a function, only in the XHRUpload settings.
        // Options set by other plugins in Uppy state or on the files themselves are still merged in afterward.
        //
        // ```js
        // headers: (file) => ({ expires: file.meta.expires })
        // ```
        if (typeof headers === "function") opts.headers = headers(file);
        else Object.assign(opts.headers, this.opts.headers);
        if (overrides) Object.assign(opts.headers, overrides.headers);
        if (file.xhrUpload) Object.assign(opts.headers, file.xhrUpload.headers);
        return opts;
    }
    // eslint-disable-next-line class-methods-use-this
    addMetadata(formData, meta, opts) {
        const allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(meta); // Send along all fields by default.
        allowedMetaFields.forEach((item)=>{
            const value = meta[item];
            if (Array.isArray(value)) // In this case we don't transform `item` to add brackets, it's up to
            // the user to add the brackets so it won't be overridden.
            value.forEach((subItem)=>formData.append(item, subItem));
            else formData.append(item, value);
        });
    }
    createFormDataUpload(file, opts) {
        const formPost = new FormData();
        this.addMetadata(formPost, file.meta, opts);
        const dataWithUpdatedType = $cf91058fd9d7f8ee$var$setTypeInBlob(file);
        if (file.name) formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
        else formPost.append(opts.fieldName, dataWithUpdatedType);
        return formPost;
    }
    createBundledUpload(files, opts) {
        const formPost = new FormData();
        const { meta: meta } = this.uppy.getState();
        this.addMetadata(formPost, meta, opts);
        files.forEach((file)=>{
            const options = this.getOptions(file);
            const dataWithUpdatedType = $cf91058fd9d7f8ee$var$setTypeInBlob(file);
            if (file.name) formPost.append(options.fieldName, dataWithUpdatedType, file.name);
            else formPost.append(options.fieldName, dataWithUpdatedType);
        });
        return formPost;
    }
    install() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: false
                }
            });
        }
        this.uppy.addUploader($cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_handleUpload)[$cf91058fd9d7f8ee$var$_handleUpload]);
    }
    uninstall() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: true
                }
            });
        }
        this.uppy.removeUploader($cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_handleUpload)[$cf91058fd9d7f8ee$var$_handleUpload]);
    }
}
async function $cf91058fd9d7f8ee$var$_uploadLocalFile2(file, current, total) {
    const opts = this.getOptions(file);
    const uploadStarted = Date.now();
    this.uppy.log(`uploading ${current} of ${total}`);
    return new Promise((resolve, reject)=>{
        const data = opts.formData ? this.createFormDataUpload(file, opts) : file.data;
        const xhr = new XMLHttpRequest();
        const eventManager = new (0, $c89f32c7d05a95a3$export$2e2bcd8739ae039)(this.uppy);
        this.uploaderEvents[file.id] = eventManager;
        let queuedRequest;
        const timer = new (0, $c8d4b79cf5a3269c$export$2e2bcd8739ae039)(opts.timeout, ()=>{
            const error = new Error(this.i18n("uploadStalled", {
                seconds: Math.ceil(opts.timeout / 1000)
            }));
            this.uppy.emit("upload-stalled", error, [
                file
            ]);
        });
        const id = (0, $44bd0219bfdf3171$export$ac4959f4f1338dfc)();
        xhr.upload.addEventListener("loadstart", ()=>{
            this.uppy.log(`[XHRUpload] ${id} started`);
        });
        xhr.upload.addEventListener("progress", (ev)=>{
            this.uppy.log(`[XHRUpload] ${id} progress: ${ev.loaded} / ${ev.total}`);
            // Begin checking for timeouts when progress starts, instead of loading,
            // to avoid timing out requests on browser concurrency queue
            timer.progress();
            if (ev.lengthComputable) this.uppy.emit("upload-progress", this.uppy.getFile(file.id), {
                // TODO: do not send `uploader` in next major
                // @ts-expect-error we can't type this and we should remove it
                uploader: this,
                uploadStarted: uploadStarted,
                bytesUploaded: ev.loaded,
                bytesTotal: ev.total
            });
        });
        xhr.addEventListener("load", ()=>{
            this.uppy.log(`[XHRUpload] ${id} finished`);
            timer.done();
            queuedRequest.done();
            if (this.uploaderEvents[file.id]) {
                this.uploaderEvents[file.id].remove();
                this.uploaderEvents[file.id] = null;
            }
            if (opts.validateStatus(xhr.status, xhr.responseText, xhr)) {
                const body = opts.getResponseData(xhr.responseText, xhr);
                const uploadURL = body == null ? void 0 : body[opts.responseUrlFieldName];
                const uploadResp = {
                    status: xhr.status,
                    body: body,
                    uploadURL: uploadURL
                };
                this.uppy.emit("upload-success", this.uppy.getFile(file.id), uploadResp);
                if (uploadURL) this.uppy.log(`Download ${file.name} from ${uploadURL}`);
                return resolve(file);
            }
            const body = opts.getResponseData(xhr.responseText, xhr);
            const error = $cf91058fd9d7f8ee$var$buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
            const response = {
                status: xhr.status,
                body: body
            };
            this.uppy.emit("upload-error", file, error, response);
            return reject(error);
        });
        xhr.addEventListener("error", ()=>{
            this.uppy.log(`[XHRUpload] ${id} errored`);
            timer.done();
            queuedRequest.done();
            if (this.uploaderEvents[file.id]) {
                this.uploaderEvents[file.id].remove();
                this.uploaderEvents[file.id] = null;
            }
            const error = $cf91058fd9d7f8ee$var$buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
            this.uppy.emit("upload-error", file, error);
            return reject(error);
        });
        xhr.open(opts.method.toUpperCase(), opts.endpoint, true);
        // IE10 does not allow setting `withCredentials` and `responseType`
        // before `open()` is called.
        xhr.withCredentials = opts.withCredentials;
        if (opts.responseType !== "") xhr.responseType = opts.responseType;
        queuedRequest = this.requests.run(()=>{
            // When using an authentication system like JWT, the bearer token goes as a header. This
            // header needs to be fresh each time the token is refreshed so computing and setting the
            // headers just before the upload starts enables this kind of authentication to work properly.
            // Otherwise, half-way through the list of uploads the token could be stale and the upload would fail.
            const currentOpts = this.getOptions(file);
            Object.keys(currentOpts.headers).forEach((header)=>{
                xhr.setRequestHeader(header, currentOpts.headers[header]);
            });
            xhr.send(data);
            return ()=>{
                timer.done();
                xhr.abort();
            };
        });
        eventManager.onFileRemove(file.id, ()=>{
            queuedRequest.abort();
            reject(new Error("File removed"));
        });
        eventManager.onCancelAll(file.id, (_ref)=>{
            let { reason: reason } = _ref;
            if (reason === "user") queuedRequest.abort();
            reject(new Error("Upload cancelled"));
        });
    });
}
function $cf91058fd9d7f8ee$var$_uploadBundle2(files) {
    return new Promise((resolve, reject)=>{
        const { endpoint: endpoint } = this.opts;
        const { method: method } = this.opts;
        const uploadStarted = Date.now();
        const optsFromState = this.uppy.getState().xhrUpload;
        const formData = this.createBundledUpload(files, {
            ...this.opts,
            ...optsFromState || {}
        });
        const xhr = new XMLHttpRequest();
        const emitError = (error)=>{
            files.forEach((file)=>{
                this.uppy.emit("upload-error", file, error);
            });
        };
        const timer = new (0, $c8d4b79cf5a3269c$export$2e2bcd8739ae039)(this.opts.timeout, ()=>{
            const error = new Error(this.i18n("uploadStalled", {
                seconds: Math.ceil(this.opts.timeout / 1000)
            }));
            this.uppy.emit("upload-stalled", error, files);
        });
        xhr.upload.addEventListener("loadstart", ()=>{
            this.uppy.log("[XHRUpload] started uploading bundle");
            timer.progress();
        });
        xhr.upload.addEventListener("progress", (ev)=>{
            timer.progress();
            if (!ev.lengthComputable) return;
            files.forEach((file)=>{
                this.uppy.emit("upload-progress", this.uppy.getFile(file.id), {
                    // TODO: do not send `uploader` in next major
                    // @ts-expect-error we can't type this and we should remove it
                    uploader: this,
                    uploadStarted: uploadStarted,
                    bytesUploaded: ev.loaded / ev.total * file.size,
                    bytesTotal: file.size
                });
            });
        });
        xhr.addEventListener("load", ()=>{
            timer.done();
            if (this.opts.validateStatus(xhr.status, xhr.responseText, xhr)) {
                const body = this.opts.getResponseData(xhr.responseText, xhr);
                const uploadResp = {
                    status: xhr.status,
                    body: body
                };
                files.forEach((file)=>{
                    this.uppy.emit("upload-success", this.uppy.getFile(file.id), uploadResp);
                });
                return resolve();
            }
            const error = this.opts.getResponseError(xhr.responseText, xhr) || new (0, $0026c55df46f9934$export$2e2bcd8739ae039)("Upload error", xhr);
            emitError(error);
            return reject(error);
        });
        xhr.addEventListener("error", ()=>{
            timer.done();
            const error = this.opts.getResponseError(xhr.responseText, xhr) || new Error("Upload error");
            emitError(error);
            return reject(error);
        });
        this.uppy.on("cancel-all", function(_temp) {
            let { reason: reason } = _temp === void 0 ? {} : _temp;
            if (reason !== "user") return;
            timer.done();
            xhr.abort();
        });
        xhr.open(method.toUpperCase(), endpoint, true);
        // IE10 does not allow setting `withCredentials` and `responseType`
        // before `open()` is called.
        xhr.withCredentials = this.opts.withCredentials;
        if (this.opts.responseType !== "") xhr.responseType = this.opts.responseType;
        // In bundle mode headers can not be a function
        const headers = this.opts.headers;
        Object.keys(headers).forEach((header)=>{
            xhr.setRequestHeader(header, headers[header]);
        });
        xhr.send(formData);
    });
}
function $cf91058fd9d7f8ee$var$_getCompanionClientArgs2(file) {
    var _file$remote;
    const opts = this.getOptions(file);
    const allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(file.meta);
    return {
        ...(_file$remote = file.remote) == null ? void 0 : _file$remote.body,
        protocol: "multipart",
        endpoint: opts.endpoint,
        size: file.data.size,
        fieldname: opts.fieldName,
        metadata: Object.fromEntries(allowedMetaFields.map((name)=>[
                name,
                file.meta[name]
            ])),
        httpMethod: opts.method,
        useFormData: opts.formData,
        headers: opts.headers
    };
}
async function $cf91058fd9d7f8ee$var$_uploadFiles2(files) {
    await Promise.allSettled(files.map((file, i)=>{
        const current = i + 1;
        const total = files.length;
        if (file.isRemote) {
            const getQueue = ()=>this.requests;
            const controller = new AbortController();
            const removedHandler = (removedFile)=>{
                if (removedFile.id === file.id) controller.abort();
            };
            this.uppy.on("file-removed", removedHandler);
            const uploadPromise = this.uppy.getRequestClientForFile(file).uploadRemoteFile(file, $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getCompanionClientArgs)[$cf91058fd9d7f8ee$var$_getCompanionClientArgs](file), {
                signal: controller.signal,
                getQueue: getQueue
            });
            this.requests.wrapSyncFunction(()=>{
                this.uppy.off("file-removed", removedHandler);
            }, {
                priority: -1
            })();
            return uploadPromise;
        }
        return $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadLocalFile)[$cf91058fd9d7f8ee$var$_uploadLocalFile](file, current, total);
    }));
}
// eslint-disable-next-line global-require
$cf91058fd9d7f8ee$export$2e2bcd8739ae039.VERSION = $cf91058fd9d7f8ee$var$packageJson.version;






var $e04f4766b186d0a1$exports = {};
/*!
 * Compressor.js v1.2.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-02-28T14:09:41.732Z
 */ (function(global, factory) {
    $e04f4766b186d0a1$exports = factory();
})($e04f4766b186d0a1$exports, function() {
    "use strict";
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    var canvasToBlob = {
        exports: {}
    };
    /*
   * JavaScript Canvas to Blob
   * https://github.com/blueimp/JavaScript-Canvas-to-Blob
   *
   * Copyright 2012, Sebastian Tschan
   * https://blueimp.net
   *
   * Licensed under the MIT license:
   * https://opensource.org/licenses/MIT
   *
   * Based on stackoverflow user Stoive's code snippet:
   * http://stackoverflow.com/q/4998908
   */ (function(module1) {
        if (typeof window === "undefined") return;
        (function(window1) {
            var CanvasPrototype = window1.HTMLCanvasElement && window1.HTMLCanvasElement.prototype;
            var hasBlobConstructor = window1.Blob && function() {
                try {
                    return Boolean(new Blob());
                } catch (e) {
                    return false;
                }
            }();
            var hasArrayBufferViewSupport = hasBlobConstructor && window1.Uint8Array && function() {
                try {
                    return new Blob([
                        new Uint8Array(100)
                    ]).size === 100;
                } catch (e) {
                    return false;
                }
            }();
            var BlobBuilder = window1.BlobBuilder || window1.WebKitBlobBuilder || window1.MozBlobBuilder || window1.MSBlobBuilder;
            var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;
            var dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window1.atob && window1.ArrayBuffer && window1.Uint8Array && function(dataURI) {
                var matches, mediaType, isBase64, dataString, byteString, arrayBuffer, intArray, i, bb;
                // Parse the dataURI components as per RFC 2397
                matches = dataURI.match(dataURIPattern);
                if (!matches) throw new Error("invalid data URI");
                // Default to text/plain;charset=US-ASCII
                mediaType = matches[2] ? matches[1] : "text/plain" + (matches[3] || ";charset=US-ASCII");
                isBase64 = !!matches[4];
                dataString = dataURI.slice(matches[0].length);
                if (isBase64) // Convert base64 to raw binary data held in a string:
                byteString = atob(dataString);
                else // Convert base64/URLEncoded data component to raw binary:
                byteString = decodeURIComponent(dataString);
                // Write the bytes of the string to an ArrayBuffer:
                arrayBuffer = new ArrayBuffer(byteString.length);
                intArray = new Uint8Array(arrayBuffer);
                for(i = 0; i < byteString.length; i += 1)intArray[i] = byteString.charCodeAt(i);
                // Write the ArrayBuffer (or ArrayBufferView) to a blob:
                if (hasBlobConstructor) return new Blob([
                    hasArrayBufferViewSupport ? intArray : arrayBuffer
                ], {
                    type: mediaType
                });
                bb = new BlobBuilder();
                bb.append(arrayBuffer);
                return bb.getBlob(mediaType);
            };
            if (window1.HTMLCanvasElement && !CanvasPrototype.toBlob) {
                if (CanvasPrototype.mozGetAsFile) CanvasPrototype.toBlob = function(callback, type, quality) {
                    var self = this;
                    setTimeout(function() {
                        if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) callback(dataURLtoBlob(self.toDataURL(type, quality)));
                        else callback(self.mozGetAsFile("blob", type));
                    });
                };
                else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
                    if (CanvasPrototype.msToBlob) CanvasPrototype.toBlob = function(callback, type, quality) {
                        var self = this;
                        setTimeout(function() {
                            if ((type && type !== "image/png" || quality) && CanvasPrototype.toDataURL && dataURLtoBlob) callback(dataURLtoBlob(self.toDataURL(type, quality)));
                            else callback(self.msToBlob(type));
                        });
                    };
                    else CanvasPrototype.toBlob = function(callback, type, quality) {
                        var self = this;
                        setTimeout(function() {
                            callback(dataURLtoBlob(self.toDataURL(type, quality)));
                        });
                    };
                }
            }
            if (module1.exports) module1.exports = dataURLtoBlob;
            else window1.dataURLtoBlob = dataURLtoBlob;
        })(window);
    })(canvasToBlob);
    var toBlob = canvasToBlob.exports;
    var isBlob = function isBlob(value) {
        if (typeof Blob === "undefined") return false;
        return value instanceof Blob || Object.prototype.toString.call(value) === "[object Blob]";
    };
    var DEFAULTS = {
        /**
     * Indicates if output the original image instead of the compressed one
     * when the size of the compressed image is greater than the original one's
     * @type {boolean}
     */ strict: true,
        /**
     * Indicates if read the image's Exif Orientation information,
     * and then rotate or flip the image automatically.
     * @type {boolean}
     */ checkOrientation: true,
        /**
     * Indicates if retain the image's Exif information after compressed.
     * @type {boolean}
    */ retainExif: false,
        /**
     * The max width of the output image.
     * @type {number}
     */ maxWidth: Infinity,
        /**
     * The max height of the output image.
     * @type {number}
     */ maxHeight: Infinity,
        /**
     * The min width of the output image.
     * @type {number}
     */ minWidth: 0,
        /**
     * The min height of the output image.
     * @type {number}
     */ minHeight: 0,
        /**
     * The width of the output image.
     * If not specified, the natural width of the source image will be used.
     * @type {number}
     */ width: undefined,
        /**
     * The height of the output image.
     * If not specified, the natural height of the source image will be used.
     * @type {number}
     */ height: undefined,
        /**
     * Sets how the size of the image should be resized to the container
     * specified by the `width` and `height` options.
     * @type {string}
     */ resize: "none",
        /**
     * The quality of the output image.
     * It must be a number between `0` and `1`,
     * and only available for `image/jpeg` and `image/webp` images.
     * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
     * @type {number}
     */ quality: 0.8,
        /**
     * The mime type of the output image.
     * By default, the original mime type of the source image file will be used.
     * @type {string}
     */ mimeType: "auto",
        /**
     * Files whose file type is included in this list,
     * and whose file size exceeds the `convertSize` value will be converted to JPEGs.
     * @type {string｜Array}
     */ convertTypes: [
            "image/png"
        ],
        /**
     * PNG files over this size (5 MB by default) will be converted to JPEGs.
     * To disable this, just set the value to `Infinity`.
     * @type {number}
     */ convertSize: 5000000,
        /**
     * The hook function to execute before draw the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.fillStyle = '#fff';
     * }
     */ beforeDraw: null,
        /**
     * The hook function to execute after drew the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.filter = 'grayscale(100%)';
     * }
     */ drew: null,
        /**
     * The hook function to execute when success to compress the image.
     * @type {Function}
     * @param {File} file - The compressed image File object.
     * @example
     * function (file) {
     *   console.log(file);
     * }
     */ success: null,
        /**
     * The hook function to execute when fail to compress the image.
     * @type {Function}
     * @param {Error} err - An Error object.
     * @example
     * function (err) {
     *   console.log(err.message);
     * }
     */ error: null
    };
    var IS_BROWSER = typeof window !== "undefined" && typeof window.document !== "undefined";
    var WINDOW = IS_BROWSER ? window : {};
    /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */ var isPositiveNumber = function isPositiveNumber(value) {
        return value > 0 && value < Infinity;
    };
    var slice = Array.prototype.slice;
    /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */ function toArray(value) {
        return Array.from ? Array.from(value) : slice.call(value);
    }
    var REGEXP_IMAGE_TYPE = /^image\/.+$/;
    /**
   * Check if the given value is a mime type of image.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given is a mime type of image, else `false`.
   */ function isImageType(value) {
        return REGEXP_IMAGE_TYPE.test(value);
    }
    /**
   * Convert image type to extension.
   * @param {string} value - The image type to convert.
   * @returns {boolean} Returns the image extension.
   */ function imageTypeToExtension(value) {
        var extension = isImageType(value) ? value.substr(6) : "";
        if (extension === "jpeg") extension = "jpg";
        return ".".concat(extension);
    }
    var fromCharCode = String.fromCharCode;
    /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */ function getStringFromCharCode(dataView, start, length) {
        var str = "";
        var i;
        length += start;
        for(i = start; i < length; i += 1)str += fromCharCode(dataView.getUint8(i));
        return str;
    }
    var btoa = WINDOW.btoa;
    /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */ function arrayBufferToDataURL(arrayBuffer, mimeType) {
        var chunks = [];
        var chunkSize = 8192;
        var uint8 = new Uint8Array(arrayBuffer);
        while(uint8.length > 0){
            // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
            // eslint-disable-next-line prefer-spread
            chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
            uint8 = uint8.subarray(chunkSize);
        }
        return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join("")));
    }
    /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */ function resetAndGetOrientation(arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        var orientation;
        // Ignores range error when the image does not have correct Exif information
        try {
            var littleEndian;
            var app1Start;
            var ifdStart;
            // Only handle JPEG image (start by 0xFFD8)
            if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
                var length = dataView.byteLength;
                var offset = 2;
                while(offset + 1 < length){
                    if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
                        app1Start = offset;
                        break;
                    }
                    offset += 1;
                }
            }
            if (app1Start) {
                var exifIDCode = app1Start + 4;
                var tiffOffset = app1Start + 10;
                if (getStringFromCharCode(dataView, exifIDCode, 4) === "Exif") {
                    var endianness = dataView.getUint16(tiffOffset);
                    littleEndian = endianness === 0x4949;
                    if (littleEndian || endianness === 0x4D4D /* bigEndian */ ) {
                        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
                            if (firstIFDOffset >= 0x00000008) ifdStart = tiffOffset + firstIFDOffset;
                        }
                    }
                }
            }
            if (ifdStart) {
                var _length = dataView.getUint16(ifdStart, littleEndian);
                var _offset;
                var i;
                for(i = 0; i < _length; i += 1){
                    _offset = ifdStart + i * 12 + 2;
                    if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */ ) {
                        // 8 is the offset of the current tag's value
                        _offset += 8;
                        // Get the original orientation value
                        orientation = dataView.getUint16(_offset, littleEndian);
                        // Override the orientation with its default value
                        dataView.setUint16(_offset, 1, littleEndian);
                        break;
                    }
                }
            }
        } catch (e) {
            orientation = 1;
        }
        return orientation;
    }
    /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */ function parseOrientation(orientation) {
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;
        switch(orientation){
            // Flip horizontal
            case 2:
                scaleX = -1;
                break;
            // Rotate left 180°
            case 3:
                rotate = -180;
                break;
            // Flip vertical
            case 4:
                scaleY = -1;
                break;
            // Flip vertical and rotate right 90°
            case 5:
                rotate = 90;
                scaleY = -1;
                break;
            // Rotate right 90°
            case 6:
                rotate = 90;
                break;
            // Flip horizontal and rotate right 90°
            case 7:
                rotate = 90;
                scaleX = -1;
                break;
            // Rotate left 90°
            case 8:
                rotate = -90;
                break;
        }
        return {
            rotate: rotate,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
    /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */ function normalizeDecimalNumber(value) {
        var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
        return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
    }
    /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */ function getAdjustedSizes(_ref) {
        var aspectRatio = _ref.aspectRatio, height = _ref.height, width = _ref.width;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
        var isValidWidth = isPositiveNumber(width);
        var isValidHeight = isPositiveNumber(height);
        if (isValidWidth && isValidHeight) {
            var adjustedWidth = height * aspectRatio;
            if ((type === "contain" || type === "none") && adjustedWidth > width || type === "cover" && adjustedWidth < width) height = width / aspectRatio;
            else width = height * aspectRatio;
        } else if (isValidWidth) height = width / aspectRatio;
        else if (isValidHeight) width = height * aspectRatio;
        return {
            width: width,
            height: height
        };
    }
    /**
   * Get Exif information from the given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {Array} The read Exif information.
   */ function getExif(arrayBuffer) {
        var array = toArray(new Uint8Array(arrayBuffer));
        var length = array.length;
        var segments = [];
        var start = 0;
        while(start + 3 < length){
            var value = array[start];
            var next = array[start + 1];
            // SOS (Start of Scan)
            if (value === 0xFF && next === 0xDA) break;
            // SOI (Start of Image)
            if (value === 0xFF && next === 0xD8) start += 2;
            else {
                var offset = array[start + 2] * 256 + array[start + 3];
                var end = start + offset + 2;
                var segment = array.slice(start, end);
                segments.push(segment);
                start = end;
            }
        }
        return segments.reduce(function(exifArray, current) {
            if (current[0] === 0xFF && current[1] === 0xE1) return exifArray.concat(current);
            return exifArray;
        }, []);
    }
    /**
   * Insert Exif information into the given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {Array} exifArray - The Exif information to insert.
   * @returns {ArrayBuffer} The transformed array buffer.
   */ function insertExif(arrayBuffer, exifArray) {
        var array = toArray(new Uint8Array(arrayBuffer));
        if (array[2] !== 0xFF || array[3] !== 0xE0) return arrayBuffer;
        var app0Length = array[4] * 256 + array[5];
        var newArrayBuffer = [
            0xFF,
            0xD8
        ].concat(exifArray, array.slice(4 + app0Length));
        return new Uint8Array(newArrayBuffer);
    }
    var ArrayBuffer$1 = WINDOW.ArrayBuffer, FileReader = WINDOW.FileReader;
    var URL = WINDOW.URL || WINDOW.webkitURL;
    var REGEXP_EXTENSION = /\.\w+$/;
    var AnotherCompressor = WINDOW.Compressor;
    /**
   * Creates a new image compressor.
   * @class
   */ var Compressor = /*#__PURE__*/ function() {
        /**
     * The constructor of Compressor.
     * @param {File|Blob} file - The target image file for compressing.
     * @param {Object} [options] - The options for compressing.
     */ function Compressor(file, options) {
            _classCallCheck(this, Compressor);
            this.file = file;
            this.exif = [];
            this.image = new Image();
            this.options = _objectSpread2(_objectSpread2({}, DEFAULTS), options);
            this.aborted = false;
            this.result = null;
            this.init();
        }
        _createClass(Compressor, [
            {
                key: "init",
                value: function init() {
                    var _this = this;
                    var file = this.file, options = this.options;
                    if (!isBlob(file)) {
                        this.fail(new Error("The first argument must be a File or Blob object."));
                        return;
                    }
                    var mimeType = file.type;
                    if (!isImageType(mimeType)) {
                        this.fail(new Error("The first argument must be an image File or Blob object."));
                        return;
                    }
                    if (!URL || !FileReader) {
                        this.fail(new Error("The current browser does not support image compression."));
                        return;
                    }
                    if (!ArrayBuffer$1) {
                        options.checkOrientation = false;
                        options.retainExif = false;
                    }
                    var isJPEGImage = mimeType === "image/jpeg";
                    var checkOrientation = isJPEGImage && options.checkOrientation;
                    var retainExif = isJPEGImage && options.retainExif;
                    if (URL && !checkOrientation && !retainExif) this.load({
                        url: URL.createObjectURL(file)
                    });
                    else {
                        var reader = new FileReader();
                        this.reader = reader;
                        reader.onload = function(_ref) {
                            var target = _ref.target;
                            var result = target.result;
                            var data = {};
                            var orientation = 1;
                            if (checkOrientation) {
                                // Reset the orientation value to its default value 1
                                // as some iOS browsers will render image with its orientation
                                orientation = resetAndGetOrientation(result);
                                if (orientation > 1) _extends(data, parseOrientation(orientation));
                            }
                            if (retainExif) _this.exif = getExif(result);
                            if (checkOrientation || retainExif) {
                                if (!URL || orientation > 1) data.url = arrayBufferToDataURL(result, mimeType);
                                else data.url = URL.createObjectURL(file);
                            } else data.url = result;
                            _this.load(data);
                        };
                        reader.onabort = function() {
                            _this.fail(new Error("Aborted to read the image with FileReader."));
                        };
                        reader.onerror = function() {
                            _this.fail(new Error("Failed to read the image with FileReader."));
                        };
                        reader.onloadend = function() {
                            _this.reader = null;
                        };
                        if (checkOrientation || retainExif) reader.readAsArrayBuffer(file);
                        else reader.readAsDataURL(file);
                    }
                }
            },
            {
                key: "load",
                value: function load(data) {
                    var _this2 = this;
                    var file = this.file, image = this.image;
                    image.onload = function() {
                        _this2.draw(_objectSpread2(_objectSpread2({}, data), {}, {
                            naturalWidth: image.naturalWidth,
                            naturalHeight: image.naturalHeight
                        }));
                    };
                    image.onabort = function() {
                        _this2.fail(new Error("Aborted to load the image."));
                    };
                    image.onerror = function() {
                        _this2.fail(new Error("Failed to load the image."));
                    };
                    // Match all browsers that use WebKit as the layout engine in iOS devices,
                    // such as Safari for iOS, Chrome for iOS, and in-app browsers.
                    if (WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent)) // Fix the `The operation is insecure` error (#57)
                    image.crossOrigin = "anonymous";
                    image.alt = file.name;
                    image.src = data.url;
                }
            },
            {
                key: "draw",
                value: function draw(_ref2) {
                    var _this3 = this;
                    var naturalWidth = _ref2.naturalWidth, naturalHeight = _ref2.naturalHeight, _ref2$rotate = _ref2.rotate, rotate = _ref2$rotate === void 0 ? 0 : _ref2$rotate, _ref2$scaleX = _ref2.scaleX, scaleX = _ref2$scaleX === void 0 ? 1 : _ref2$scaleX, _ref2$scaleY = _ref2.scaleY, scaleY = _ref2$scaleY === void 0 ? 1 : _ref2$scaleY;
                    var file = this.file, image = this.image, options = this.options;
                    var canvas = document.createElement("canvas");
                    var context = canvas.getContext("2d");
                    var is90DegreesRotated = Math.abs(rotate) % 180 === 90;
                    var resizable = (options.resize === "contain" || options.resize === "cover") && isPositiveNumber(options.width) && isPositiveNumber(options.height);
                    var maxWidth = Math.max(options.maxWidth, 0) || Infinity;
                    var maxHeight = Math.max(options.maxHeight, 0) || Infinity;
                    var minWidth = Math.max(options.minWidth, 0) || 0;
                    var minHeight = Math.max(options.minHeight, 0) || 0;
                    var aspectRatio = naturalWidth / naturalHeight;
                    var width = options.width, height = options.height;
                    if (is90DegreesRotated) {
                        var _ref3 = [
                            maxHeight,
                            maxWidth
                        ];
                        maxWidth = _ref3[0];
                        maxHeight = _ref3[1];
                        var _ref4 = [
                            minHeight,
                            minWidth
                        ];
                        minWidth = _ref4[0];
                        minHeight = _ref4[1];
                        var _ref5 = [
                            height,
                            width
                        ];
                        width = _ref5[0];
                        height = _ref5[1];
                    }
                    if (resizable) aspectRatio = width / height;
                    var _getAdjustedSizes = getAdjustedSizes({
                        aspectRatio: aspectRatio,
                        width: maxWidth,
                        height: maxHeight
                    }, "contain");
                    maxWidth = _getAdjustedSizes.width;
                    maxHeight = _getAdjustedSizes.height;
                    var _getAdjustedSizes2 = getAdjustedSizes({
                        aspectRatio: aspectRatio,
                        width: minWidth,
                        height: minHeight
                    }, "cover");
                    minWidth = _getAdjustedSizes2.width;
                    minHeight = _getAdjustedSizes2.height;
                    if (resizable) {
                        var _getAdjustedSizes3 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: width,
                            height: height
                        }, options.resize);
                        width = _getAdjustedSizes3.width;
                        height = _getAdjustedSizes3.height;
                    } else {
                        var _getAdjustedSizes4 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: width,
                            height: height
                        });
                        var _getAdjustedSizes4$wi = _getAdjustedSizes4.width;
                        width = _getAdjustedSizes4$wi === void 0 ? naturalWidth : _getAdjustedSizes4$wi;
                        var _getAdjustedSizes4$he = _getAdjustedSizes4.height;
                        height = _getAdjustedSizes4$he === void 0 ? naturalHeight : _getAdjustedSizes4$he;
                    }
                    width = Math.floor(normalizeDecimalNumber(Math.min(Math.max(width, minWidth), maxWidth)));
                    height = Math.floor(normalizeDecimalNumber(Math.min(Math.max(height, minHeight), maxHeight)));
                    var destX = -width / 2;
                    var destY = -height / 2;
                    var destWidth = width;
                    var destHeight = height;
                    var params = [];
                    if (resizable) {
                        var srcX = 0;
                        var srcY = 0;
                        var srcWidth = naturalWidth;
                        var srcHeight = naturalHeight;
                        var _getAdjustedSizes5 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: naturalWidth,
                            height: naturalHeight
                        }, {
                            contain: "cover",
                            cover: "contain"
                        }[options.resize]);
                        srcWidth = _getAdjustedSizes5.width;
                        srcHeight = _getAdjustedSizes5.height;
                        srcX = (naturalWidth - srcWidth) / 2;
                        srcY = (naturalHeight - srcHeight) / 2;
                        params.push(srcX, srcY, srcWidth, srcHeight);
                    }
                    params.push(destX, destY, destWidth, destHeight);
                    if (is90DegreesRotated) {
                        var _ref6 = [
                            height,
                            width
                        ];
                        width = _ref6[0];
                        height = _ref6[1];
                    }
                    canvas.width = width;
                    canvas.height = height;
                    if (!isImageType(options.mimeType)) options.mimeType = file.type;
                    var fillStyle = "transparent";
                    // Converts PNG files over the `convertSize` to JPEGs.
                    if (file.size > options.convertSize && options.convertTypes.indexOf(options.mimeType) >= 0) options.mimeType = "image/jpeg";
                    var isJPEGImage = options.mimeType === "image/jpeg";
                    if (isJPEGImage) fillStyle = "#fff";
                    // Override the default fill color (#000, black)
                    context.fillStyle = fillStyle;
                    context.fillRect(0, 0, width, height);
                    if (options.beforeDraw) options.beforeDraw.call(this, context, canvas);
                    if (this.aborted) return;
                    context.save();
                    context.translate(width / 2, height / 2);
                    context.rotate(rotate * Math.PI / 180);
                    context.scale(scaleX, scaleY);
                    context.drawImage.apply(context, [
                        image
                    ].concat(params));
                    context.restore();
                    if (options.drew) options.drew.call(this, context, canvas);
                    if (this.aborted) return;
                    var callback = function callback(blob) {
                        if (!_this3.aborted) {
                            var done = function done(result) {
                                return _this3.done({
                                    naturalWidth: naturalWidth,
                                    naturalHeight: naturalHeight,
                                    result: result
                                });
                            };
                            if (blob && isJPEGImage && options.retainExif && _this3.exif && _this3.exif.length > 0) {
                                var next = function next(arrayBuffer) {
                                    return done(toBlob(arrayBufferToDataURL(insertExif(arrayBuffer, _this3.exif), options.mimeType)));
                                };
                                if (blob.arrayBuffer) blob.arrayBuffer().then(next).catch(function() {
                                    _this3.fail(new Error("Failed to read the compressed image with Blob.arrayBuffer()."));
                                });
                                else {
                                    var reader = new FileReader();
                                    _this3.reader = reader;
                                    reader.onload = function(_ref7) {
                                        var target = _ref7.target;
                                        next(target.result);
                                    };
                                    reader.onabort = function() {
                                        _this3.fail(new Error("Aborted to read the compressed image with FileReader."));
                                    };
                                    reader.onerror = function() {
                                        _this3.fail(new Error("Failed to read the compressed image with FileReader."));
                                    };
                                    reader.onloadend = function() {
                                        _this3.reader = null;
                                    };
                                    reader.readAsArrayBuffer(blob);
                                }
                            } else done(blob);
                        }
                    };
                    if (canvas.toBlob) canvas.toBlob(callback, options.mimeType, options.quality);
                    else callback(toBlob(canvas.toDataURL(options.mimeType, options.quality)));
                }
            },
            {
                key: "done",
                value: function done(_ref8) {
                    var naturalWidth = _ref8.naturalWidth, naturalHeight = _ref8.naturalHeight, result = _ref8.result;
                    var file = this.file, image = this.image, options = this.options;
                    if (URL && image.src.indexOf("blob:") === 0) URL.revokeObjectURL(image.src);
                    if (result) {
                        // Returns original file if the result is greater than it and without size related options
                        if (options.strict && !options.retainExif && result.size > file.size && options.mimeType === file.type && !(options.width > naturalWidth || options.height > naturalHeight || options.minWidth > naturalWidth || options.minHeight > naturalHeight || options.maxWidth < naturalWidth || options.maxHeight < naturalHeight)) result = file;
                        else {
                            var date = new Date();
                            result.lastModified = date.getTime();
                            result.lastModifiedDate = date;
                            result.name = file.name;
                            // Convert the extension to match its type
                            if (result.name && result.type !== file.type) result.name = result.name.replace(REGEXP_EXTENSION, imageTypeToExtension(result.type));
                        }
                    } else // Returns original file if the result is null in some cases.
                    result = file;
                    this.result = result;
                    if (options.success) options.success.call(this, result);
                }
            },
            {
                key: "fail",
                value: function fail(err) {
                    var options = this.options;
                    if (options.error) options.error.call(this, err);
                    else throw err;
                }
            },
            {
                key: "abort",
                value: function abort() {
                    if (!this.aborted) {
                        this.aborted = true;
                        if (this.reader) this.reader.abort();
                        else if (!this.image.complete) {
                            this.image.onload = null;
                            this.image.onabort();
                        } else this.fail(new Error("The compression process has been aborted."));
                    }
                }
            }
        ], [
            {
                key: "noConflict",
                value: function noConflict() {
                    window.Compressor = AnotherCompressor;
                    return Compressor;
                }
            },
            {
                key: "setDefaults",
                value: function setDefaults(options) {
                    _extends(DEFAULTS, options);
                }
            }
        ]);
        return Compressor;
    }();
    return Compressor;
});


var $de0418694bba9f03$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the Status Bar
        compressingImages: "Compressing images...",
        compressedX: "Saved %{size} by compressing images"
    }
};


function $d847a4c5a8f23ad9$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $d847a4c5a8f23ad9$var$id = 0;
function $d847a4c5a8f23ad9$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $d847a4c5a8f23ad9$var$id++ + "_" + name;
}
var $d847a4c5a8f23ad9$var$_RateLimitedQueue = /*#__PURE__*/ $d847a4c5a8f23ad9$var$_classPrivateFieldLooseKey("RateLimitedQueue");
class $d847a4c5a8f23ad9$export$2e2bcd8739ae039 extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, opts);
        Object.defineProperty(this, $d847a4c5a8f23ad9$var$_RateLimitedQueue, {
            writable: true,
            value: void 0
        });
        this.id = this.opts.id || "Compressor";
        this.type = "modifier";
        this.defaultLocale = (0, $de0418694bba9f03$export$2e2bcd8739ae039);
        const defaultOptions = {
            quality: 0.6,
            limit: 10
        };
        this.opts = {
            ...defaultOptions,
            ...opts
        };
        $d847a4c5a8f23ad9$var$_classPrivateFieldLooseBase(this, $d847a4c5a8f23ad9$var$_RateLimitedQueue)[$d847a4c5a8f23ad9$var$_RateLimitedQueue] = new (0, $6cb886e1a5aec334$export$32306e81289653bc)(this.opts.limit);
        this.i18nInit();
        this.prepareUpload = this.prepareUpload.bind(this);
        this.compress = this.compress.bind(this);
    }
    compress(blob) {
        return new Promise((resolve, reject)=>{
            /* eslint-disable no-new */ new (0, (/*@__PURE__*/$parcel$interopDefault($e04f4766b186d0a1$exports)))(blob, {
                ...this.opts,
                success: resolve,
                error: reject
            });
        });
    }
    async prepareUpload(fileIDs) {
        let totalCompressedSize = 0;
        const compressedFiles = [];
        const compressAndApplyResult = $d847a4c5a8f23ad9$var$_classPrivateFieldLooseBase(this, $d847a4c5a8f23ad9$var$_RateLimitedQueue)[$d847a4c5a8f23ad9$var$_RateLimitedQueue].wrapPromiseFunction(async (file)=>{
            try {
                const compressedBlob = await this.compress(file.data);
                const compressedSavingsSize = file.data.size - compressedBlob.size;
                this.uppy.log(`[Image Compressor] Image ${file.id} compressed by ${(0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(compressedSavingsSize)}`);
                totalCompressedSize += compressedSavingsSize;
                const { name: name, type: type, size: size } = compressedBlob;
                const compressedFileName = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(name);
                const metaFileName = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.meta.name);
                // Name (file.meta.name) might have been changed by user, so we update only the extension
                const newMetaName = `${metaFileName.name}.${compressedFileName.extension}`;
                this.uppy.setFileState(file.id, {
                    ...name && {
                        name: name
                    },
                    ...compressedFileName.extension && {
                        extension: compressedFileName.extension
                    },
                    ...type && {
                        type: type
                    },
                    ...size && {
                        size: size
                    },
                    data: compressedBlob,
                    meta: {
                        ...file.meta,
                        type: type,
                        name: newMetaName
                    }
                });
                compressedFiles.push(file);
            } catch (err) {
                this.uppy.log(`[Image Compressor] Failed to compress ${file.id}:`, "warning");
                this.uppy.log(err, "warning");
            }
        });
        const promises = fileIDs.map((fileID)=>{
            var _file$type;
            const file = this.uppy.getFile(fileID);
            this.uppy.emit("preprocess-progress", file, {
                mode: "indeterminate",
                message: this.i18n("compressingImages")
            });
            if (file.isRemote) return Promise.resolve();
            // Some browsers (Firefox) add blobs with empty file type, when files are
            // added from a folder. Uppy auto-detects type from extension, but leaves the original blob intact.
            // However, Compressor.js failes when file has no type, so we set it here
            if (!file.data.type) file.data = file.data.slice(0, file.data.size, file.type);
            if (!((_file$type = file.type) != null && _file$type.startsWith("image/"))) return Promise.resolve();
            return compressAndApplyResult(file);
        });
        // Why emit `preprocess-complete` for all files at once, instead of
        // above when each is processed?
        // Because it leads to StatusBar showing a weird “upload 6 files” button,
        // while waiting for all the files to complete pre-processing.
        await Promise.all(promises);
        this.uppy.emit("compressor:complete", compressedFiles);
        // Only show informer if Compressor mananged to save at least a kilobyte
        if (totalCompressedSize > 1024) this.uppy.info(this.i18n("compressedX", {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalCompressedSize)
        }), "info");
        for (const fileID of fileIDs){
            const file = this.uppy.getFile(fileID);
            this.uppy.emit("preprocess-complete", file);
        }
    }
    install() {
        this.uppy.addPreProcessor(this.prepareUpload);
    }
    uninstall() {
        this.uppy.removePreProcessor(this.prepareUpload);
    }
}



const $cb482a25fa64fd81$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $cb482a25fa64fd81$export$2e2bcd8739ae039 = {
    randomUUID: $cb482a25fa64fd81$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $a4faffbfed8ce8b6$var$getRandomValues;
const $a4faffbfed8ce8b6$var$rnds8 = new Uint8Array(16);
function $a4faffbfed8ce8b6$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$a4faffbfed8ce8b6$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $a4faffbfed8ce8b6$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$a4faffbfed8ce8b6$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $a4faffbfed8ce8b6$var$getRandomValues($a4faffbfed8ce8b6$var$rnds8);
}


var $f53d8abb4c91ec67$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $8e32bacb71dd477f$var$validate(uuid) {
    return typeof uuid === "string" && (0, $f53d8abb4c91ec67$export$2e2bcd8739ae039).test(uuid);
}
var $8e32bacb71dd477f$export$2e2bcd8739ae039 = $8e32bacb71dd477f$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $489cbfc69d38cb8e$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$489cbfc69d38cb8e$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $489cbfc69d38cb8e$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $489cbfc69d38cb8e$var$byteToHex[arr[offset + 0]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 1]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 2]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 3]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 4]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 5]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 6]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 7]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 8]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 9]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 10]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 11]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 12]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 13]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 14]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 15]];
}
function $489cbfc69d38cb8e$var$stringify(arr, offset = 0) {
    const uuid = $489cbfc69d38cb8e$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $8e32bacb71dd477f$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $489cbfc69d38cb8e$export$2e2bcd8739ae039 = $489cbfc69d38cb8e$var$stringify;


function $d0666643e2ee88b4$var$v4(options, buf, offset) {
    if ((0, $cb482a25fa64fd81$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $cb482a25fa64fd81$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $a4faffbfed8ce8b6$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $489cbfc69d38cb8e$export$8fb373d660548968)(rnds);
}
var $d0666643e2ee88b4$export$2e2bcd8739ae039 = $d0666643e2ee88b4$var$v4;


const $4dcbb1f6ebd585d1$var$de_DE = {
    strings: {},
    pluralize (count) {
        if (count === 1) return 0;
        return 1;
    }
};
$4dcbb1f6ebd585d1$var$de_DE.strings = {
    addBulkFilesFailed: {
        "0": "Das Hinzuf\xfcgen einer Datei ist aufgrund eines internen Fehlers fehlgeschlagen",
        "1": "Das Hinzuf\xfcgen von %{smart_count} Dateien ist aufgrund eines internen Fehlers fehlgeschlagen"
    },
    addingMoreFiles: "Dateien hinzuf\xfcgen",
    addMore: "Mehr hinzuf\xfcgen",
    addMoreFiles: "Dateien hinzuf\xfcgen",
    allFilesFromFolderNamed: "Alle Dateien vom Ordner %{name}",
    allowAccessDescription: "Um Bilder oder Videos mit Ihrer Kamera aufzunehmen, erlauben Sie dieser Website bitte den Zugriff auf Ihre Kamera.",
    allowAccessTitle: "Bitte erlauben Sie Zugriff auf Ihre Kamera",
    aspectRatioLandscape: "Zuschneiden auf Querformat (16:9)",
    aspectRatioPortrait: "Zuschneiden auf Hochformat (9:16)",
    aspectRatioSquare: "Zuschneiden auf Quadrat",
    authenticateWith: "Mit %{pluginName} verbinden",
    authenticateWithTitle: "Bitte authentifizieren Sie sich mit %{pluginName}, um Dateien auszuw\xe4hlen",
    back: "Zur\xfcck",
    backToSearch: "Zur\xfcck zur Suche",
    browse: "durchsuchen",
    browseFiles: "Dateien durchsuchen",
    browseFolders: "Ordner durchsuchen",
    cancel: "Abbrechen",
    cancelUpload: "Hochladen abbrechen",
    chooseFiles: "Dateien ausw\xe4hlen",
    closeModal: "Fenster schlie\xdfen",
    companionError: "Verbindung zu Companion fehlgeschlagen",
    companionUnauthorizeHint: "Um die Autorisierung f\xfcr Ihr %{provider} Konto aufzuheben, gehen Sie bitte zu %{url}",
    complete: "Fertig",
    connectedToInternet: "Mit dem Internet verbunden",
    copyLink: "Link kopieren",
    copyLinkToClipboardFallback: "Untenstehende URL kopieren",
    copyLinkToClipboardSuccess: "Link in die Zwischenablage kopiert",
    creatingAssembly: "Das Hochladen wird vorbereiten...",
    creatingAssemblyFailed: "Transloadit: Assembly konnte nicht erstellt werden",
    dashboardTitle: "Hochladen von Dateien",
    dashboardWindowTitle: "Hochladen von Dateien (ESC dr\xfccken zum Schlie\xdfen)",
    dataUploadedOfTotal: "%{complete} von %{total}",
    discardRecordedFile: "Aufgenommene Datei verwerfen",
    done: "Abgeschlossen",
    dropHereOr: "Dateien hier ablegen oder %{browse}",
    dropHint: "Dateien hier ablegen",
    dropPasteBoth: "Dateien hier ablegen/einf\xfcgen, %{browseFiles} oder %{browseFolders}",
    dropPasteFiles: "Dateien hier ablegen/einf\xfcgen oder %{browseFiles}",
    dropPasteFolders: "Dateien hier ablegen/einf\xfcgen oder %{browseFolders}",
    dropPasteImportBoth: "Dateien hier ablegen/einf\xfcgen, %{browse} oder von folgenden Quellen importieren:",
    dropPasteImportFiles: "Dateien hier ablegen/einf\xfcgen, %{browseFiles} oder von folgenden Quellen importieren:",
    dropPasteImportFolders: "Dateien hier ablegen/einf\xfcgen, %{browseFolders} oder von folgenden Quellen importieren:",
    editFile: "Datei bearbeiten",
    editImage: "Bild bearbeiten",
    editFileWithFilename: "Datei %{file} bearbeiten",
    editing: "%{file} bearbeiten",
    emptyFolderAdded: "Keine Dateien hinzugef\xfcgt, da der Ordner leer war",
    encoding: "Kodieren...",
    enterCorrectUrl: "Falsche URL: Bitte stellen Sie sicher, dass Sie einen direkten Link zu einer Datei eingeben",
    enterTextToSearch: "Text zum Suchen von Bildern eingeben",
    enterUrlToImport: "URL zum Importieren einer Datei eingeben",
    exceedsSize: "Datei %{file} ist gr\xf6\xdfer als die maximal erlaubte Dateigr\xf6\xdfe von %{size}",
    failedToFetch: "Companion konnte diese URL nicht verarbeiten - stellen Sie bitte sicher, dass sie korrekt ist",
    failedToUpload: "Fehler beim Hochladen der Datei %{file}",
    filesUploadedOfTotal: {
        "0": "%{complete} von %{smart_count} Datei hochgeladen",
        "1": "%{complete} von %{smart_count} Dateien hochgeladen"
    },
    filter: "Filter",
    finishEditingFile: "Bearbeitung beenden",
    flipHorizontal: "Horizontal spiegeln",
    folderAdded: {
        "0": "Eine Datei von %{folder} hinzugef\xfcgt",
        "1": "%{smart_count} Dateien von %{folder} hinzugef\xfcgt"
    },
    folderAlreadyAdded: 'Der Ordner "%{folder}" wurde bereits hinzugef\xfcgt',
    generatingThumbnails: "Erstellen von Miniaturansichten...",
    import: "Importieren",
    importFiles: "Importiere Dateien von:",
    importFrom: "Importieren von %{name}",
    inferiorSize: "Diese Datei ist kleiner als die minimal erlaubte Dateigr\xf6\xdfe von %{size}",
    loading: "Laden...",
    logOut: "Abmelden",
    micDisabled: "Zugriff auf Mikrofon von Benutzer abgelehnt",
    missingRequiredMetaField: "Fehlende erforderliche Meta-Felder",
    missingRequiredMetaFieldOnFile: "Fehlende erforderliche Meta-Felder in %{fileName}",
    missingRequiredMetaFields: {
        "0": "Fehlendes erforderliches Meta-Feld: %{fields}.",
        "1": "Fehlende erforderliche Meta-Felder: %{fields}."
    },
    myDevice: "Mein Ger\xe4t",
    noCameraDescription: "Bitte Kamera anschlie\xdfen, um Bilder oder Videos aufzunehmen",
    noCameraTitle: "Kamera nicht verf\xfcgbar",
    noDuplicates: "Datei '%{fileName}' existiert bereits und kann nicht erneut hinzugef\xfcgt werden",
    noFilesFound: "Sie haben hier keine Dateien oder Ordner",
    noInternetConnection: "Keine Internetverbindung",
    noMoreFilesAllowed: "W\xe4hrend der Upload l\xe4uft, k\xf6nnen keine weiteren Dateien hinzugef\xfcgt werden",
    openFolderNamed: "Ordner %{name} \xf6ffnen",
    pause: "Pausieren",
    paused: "Pausiert",
    pauseUpload: "Hochladen pausieren",
    pluginNameBox: "Box",
    pluginNameCamera: "Kamera",
    pluginNameDropbox: "Dropbox",
    pluginNameFacebook: "Facebook",
    pluginNameGoogleDrive: "Google Drive",
    pluginNameInstagram: "Instagram",
    pluginNameOneDrive: "OneDrive",
    pluginNameZoom: "Zoom",
    poweredBy: "Powered by %{uppy}",
    processingXFiles: {
        "0": "Eine Datei verarbeiten",
        "1": "%{smart_count} Dateien verarbeiten"
    },
    recording: "Aufnahme",
    recordingLength: "Aufnahmedauer %{recording_length}",
    recordingStoppedMaxSize: "Die Aufnahme wurde gestoppt, weil die Dateigr\xf6\xdfe das Limit \xfcberschritten hat",
    recordVideoBtn: "Video aufnehmen",
    recoveredAllFiles: "Wir haben alle Dateien wiederhergestellt. Sie k\xf6nnen mit dem Hochladen fortfahren.",
    recoveredXFiles: {
        "0": "Wir konnten eine Datei nicht vollst\xe4ndig wiederherstellen. Bitte w\xe4hlen Sie sie erneut aus und fahren Sie dann mit dem Hochladen fort.",
        "1": "Wir konnten %{smart_count} Dateien nicht vollst\xe4ndig wiederherstellen. Bitte w\xe4hlen Sie sie erneut aus und fahren Sie dann mit dem Hochladen fort."
    },
    removeFile: "Datei entfernen",
    reSelect: "Erneut ausw\xe4hlen",
    resetFilter: "Filter zur\xfccksetzen",
    resume: "Fortsetzen",
    resumeUpload: "Hochladen fortsetzen",
    retry: "Erneut versuchen",
    retryUpload: "Hochladen erneut versuchen",
    revert: "R\xfcckg\xe4ngig machen",
    rotate: "Drehen",
    save: "Speichern",
    saveChanges: "\xc4nderungen speichern",
    searchImages: "Suche nach Bildern",
    selectX: {
        "0": "W\xe4hlen Sie %{smart_count}",
        "1": "W\xe4hlen Sie %{smart_count}"
    },
    sessionRestored: "",
    smile: "Bitte l\xe4cheln!",
    startCapturing: "Bildschirmaufnahme starten",
    startRecording: "Videoaufnahme starten",
    stopCapturing: "Bildschirmaufnahme stoppen",
    stopRecording: "Videoaufnahme stoppen",
    streamActive: "Stream aktiv",
    streamPassive: "Stream passiv",
    submitRecordedFile: "Aufgezeichnete Datei verwenden",
    takePicture: "Ein Foto aufnehmen",
    takePictureBtn: "Foto aufnehmen",
    timedOut: "Upload f\xfcr %{seconds} Sekunden stehen geblieben, breche ab.",
    upload: "Hochladen",
    uploadComplete: "Hochladen abgeschlossen",
    uploadFailed: "Hochladen fehlgeschlagen",
    uploading: "Wird hochgeladen",
    uploadingXFiles: {
        "0": "Eine Datei wird hochgeladen",
        "1": "%{smart_count} Dateien werden hochgeladen"
    },
    uploadPaused: "Hochladen pausiert",
    uploadXFiles: {
        "0": "Eine Datei hochladen",
        "1": "%{smart_count} Dateien hochladen"
    },
    uploadXNewFiles: {
        "0": "+%{smart_count} Datei hochladen",
        "1": "+%{smart_count} Dateien hochladen"
    },
    xFilesSelected: {
        "0": "Eine Datei ausgew\xe4hlt",
        "1": "%{smart_count} Dateien ausgew\xe4hlt"
    },
    xMoreFilesAdded: {
        "0": "Eine weitere Datei hinzugef\xfcgt",
        "1": "%{smart_count} weitere Dateien hinzugef\xfcgt"
    },
    xTimeLeft: "%{time} verbleibend",
    youCanOnlyUploadFileTypes: "Sie k\xf6nnen nur folgende Dateitypen hochladen: %{types}",
    youCanOnlyUploadX: {
        "0": "Sie k\xf6nnen nur eine Datei hochladen",
        "1": "Sie k\xf6nnen nur %{smart_count} Dateien hochladen"
    },
    youHaveToAtLeastSelectX: {
        "0": "Sie m\xfcssen mindestens eine Datei ausw\xe4hlen",
        "1": "Sie m\xfcssen mindestens %{smart_count} Dateien ausw\xe4hlen"
    },
    zoomIn: "Vergr\xf6\xdfern",
    zoomOut: "Verkleinern"
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== "undefined") // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.de_DE = $4dcbb1f6ebd585d1$var$de_DE;
var $4dcbb1f6ebd585d1$export$2e2bcd8739ae039 = $4dcbb1f6ebd585d1$var$de_DE;


const $eb5fbf45bcb54698$var$fr_FR = {
    strings: {},
    pluralize (n) {
        if (n <= 1) return 0;
        return 1;
    }
};
$eb5fbf45bcb54698$var$fr_FR.strings = {
    addBulkFilesFailed: {
        "0": "L\u2019ajout de %{smart_count} fichier a \xe9chou\xe9",
        "1": "L\u2019ajout de %{smart_count} fichiers a \xe9chou\xe9"
    },
    addedNumFiles: "%{numFiles} fichier(s) ajout\xe9(s)",
    addingMoreFiles: "Ajout de fichiers",
    addMore: "Ajouter d\u2019autres",
    addMoreFiles: "Ajouter d\u2019autres fichiers",
    allFilesFromFolderNamed: "Tous les fichiers du dossier %{name}",
    allowAccessDescription: "Pour prendre des photos ou enregistrer une vid\xe9o, veuillez autoriser l\u2019acc\xe8s \xe0 votre cam\xe9ra pour ce site.",
    allowAccessTitle: "Veuillez autoriser l\u2019acc\xe8s \xe0 votre cam\xe9ra",
    authAborted: "Authentification interrompue",
    authenticateWith: "Se connecter \xe0 %{pluginName}",
    authenticateWithTitle: "Veuillez vous authentifier avec %{pluginName} pour s\xe9lectionner les fichiers",
    back: "Retour",
    browse: "naviguer",
    browseFiles: "naviguer",
    cancel: "Annuler",
    cancelUpload: "Annuler le t\xe9l\xe9versement",
    chooseFiles: "Choisir des fichiers",
    closeModal: "Fermer la fen\xeatre",
    companionError: "Connexion \xe0 Companion a \xe9chou\xe9",
    companionUnauthorizeHint: "Pour vous d\xe9connecter de votre compte %{provider}, veuillez aller \xe0 %{url}",
    complete: "Termin\xe9",
    compressedX: "%{size} \xe9conomis\xe9(s) par la compression",
    compressingImages: "Compression des images\u2026",
    connectedToInternet: "Connect\xe9 \xe0 Internet",
    copyLink: "Copier le lien",
    copyLinkToClipboardFallback: "Copier le lien ci-dessous",
    copyLinkToClipboardSuccess: "Lien copi\xe9",
    creatingAssembly: "Pr\xe9paration du t\xe9l\xe9versement\u2026",
    creatingAssemblyFailed: "Transloadit: Impossible de cr\xe9er Assembly",
    dashboardTitle: "T\xe9l\xe9verseur de fichiers",
    dashboardWindowTitle: "Fen\xeatre de t\xe9l\xe9versement de fichiers (Appuyez sur \xc9chap pour fermer)",
    dataUploadedOfTotal: "%{complete} sur %{total}",
    done: "Termin\xe9",
    dropHereOr: "D\xe9poser les fichiers ici ou %{browse}",
    dropHint: "D\xe9posez vos fichiers ici",
    dropPasteBoth: "D\xe9poser les fichiers ici, coller ou %{browse}",
    dropPasteFiles: "D\xe9poser les fichiers ici, coller ou %{browse}",
    dropPasteFolders: "D\xe9poser les fichiers ici, coller ou %{browse}",
    dropPasteImportBoth: "D\xe9poser les fichiers ici, coller, %{browse} ou importer de",
    dropPasteImportFiles: "D\xe9poser les fichiers ici, coller, %{browse} ou importer de",
    dropPasteImportFolders: "D\xe9poser les fichiers ici, coller, %{browse} ou importer de",
    editFile: "Modifier le fichier",
    editImage: "Modifier l\u2019image",
    editFileWithFilename: "Modifier le fichier %{file}",
    editing: "Modification en cours de %{file}",
    emptyFolderAdded: "Aucun fichier n\u2019a \xe9t\xe9 ajout\xe9 depuis un dossier vide",
    encoding: "Traitement\u2026",
    enterCorrectUrl: "Lien incorrect: Assurez-vous que vous entrez un lien direct vers le fichier",
    enterUrlToImport: "Entrez le lien pour importer un fichier",
    exceedsSize: "Ce fichier d\xe9passe la taille maximale autoris\xe9e de %{size}",
    failedToFetch: "Companion a \xe9chou\xe9 \xe0 r\xe9cup\xe9rer ce lien, assurez-vous qu\u2019il est correct",
    failedToUpload: "Le t\xe9l\xe9versement de %{file} a \xe9chou\xe9",
    fileSource: "Fichier source: %{name}",
    filesUploadedOfTotal: {
        "0": "%{complete} sur %{smart_count} fichier t\xe9l\xe9vers\xe9",
        "1": "%{complete} sur %{smart_count} fichiers t\xe9l\xe9vers\xe9s"
    },
    filter: "Filtrer",
    finishEditingFile: "Terminer l\u2019\xe9dition du fichier",
    folderAdded: {
        "0": "%{smart_count} fichier ajout\xe9 de %{folder}",
        "1": "%{smart_count} fichiers ajout\xe9s de %{folder}"
    },
    generatingThumbnails: "G\xe9n\xe9ration des vignettes\u2026",
    import: "Importer",
    importFrom: "Importer de %{name}",
    loading: "Chargement\u2026",
    logOut: "D\xe9connexion",
    micDisabled: "Acc\xe8s au micro refus\xe9 par l\u2019utilisateur",
    myDevice: "Mon Appareil",
    noDuplicates: 'Impossible d\u2019ajouter le fichier "%{fileName}", il existe d\xe9j\xe0',
    noFilesFound: "Vous n\u2019avez aucun fichier ou dossier ici",
    noInternetConnection: "Pas de connexion \xe0 Internet",
    noMoreFilesAllowed: "Impossible d\u2019ajouter de nouveaux fichiers: en cours de chargement ",
    openFolderNamed: "Ouvrir %{name}",
    pause: "Pause",
    pauseUpload: "Mettre en pause le t\xe9l\xe9versement",
    paused: "En pause",
    poweredBy: "Propuls\xe9 par %{uppy}",
    processingXFiles: {
        "0": "Traitement de %{smart_count} fichier",
        "1": "Traitement de %{smart_count} fichiers"
    },
    recording: "Enregistrement",
    recordingLength: "Dur\xe9e d\u2019enregistrement %{recording_length}",
    recordingStoppedMaxSize: "L\u2019enregistrement s\u2019est arr\xe9t\xe9 car la taille du fichier d\xe9passe la limite",
    removeFile: "Effacer le fichier %{file}",
    resetFilter: "R\xe9initialiser filtre",
    resume: "Reprendre",
    resumeUpload: "Reprendre le t\xe9l\xe9versement",
    retry: "R\xe9essayer",
    retryUpload: "R\xe9essayer le t\xe9l\xe9versement",
    save: "Sauvegarder",
    saveChanges: "Sauvegarder les modifications",
    selectFileNamed: "S\xe9lectionner le fichier %{name}",
    selectX: {
        "0": "S\xe9lectionner %{smart_count}",
        "1": "S\xe9lectionner %{smart_count}"
    },
    smile: "Souriez !",
    startRecording: "Commencer l\u2019enregistrement vid\xe9o",
    stopRecording: "Arr\xeater l\u2019enregistrement vid\xe9o",
    streamActive: "Stream actif",
    streamPassive: "Stream passif",
    submitRecordedFile: "Envoyer la vid\xe9o enregistr\xe9e",
    takePicture: "Prendre une photo",
    timedOut: "T\xe9l\xe9versement bloqu\xe9 durant %{seconds} secondes, annulation.",
    unselectFileNamed: "D\xe9s\xe9lectionner le fichier %{name}",
    upload: "T\xe9l\xe9verser",
    uploadComplete: "T\xe9l\xe9versement termin\xe9",
    uploadFailed: "Le t\xe9l\xe9versement a \xe9chou\xe9",
    uploadPaused: "T\xe9l\xe9versement mis en pause",
    uploadStalled: "T\xe9l\xe9versement bloqu\xe9 depuis %{seconds} secondes. Il est peut-\xeatre n\xe9cessaire de recommencer l\u2019op\xe9ration.",
    uploadXFiles: {
        "0": "T\xe9l\xe9verser %{smart_count} fichier",
        "1": "T\xe9l\xe9verser %{smart_count} fichiers"
    },
    uploadXNewFiles: {
        "0": "T\xe9l\xe9verser +%{smart_count} fichier",
        "1": "T\xe9l\xe9verser +%{smart_count} fichiers"
    },
    uploading: "T\xe9l\xe9versement en cours",
    uploadingXFiles: {
        "0": "T\xe9l\xe9versement de %{smart_count} fichier",
        "1": "T\xe9l\xe9versement de %{smart_count} fichiers"
    },
    xFilesSelected: {
        "0": "%{smart_count} fichier s\xe9lectionn\xe9",
        "1": "%{smart_count} fichiers s\xe9lectionn\xe9s"
    },
    xMoreFilesAdded: {
        "0": "%{smart_count} autre fichier ajout\xe9",
        "1": "%{smart_count} autres fichiers ajout\xe9s"
    },
    xTimeLeft: "%{time} restantes",
    youCanOnlyUploadFileTypes: "Vous pouvez seulement t\xe9l\xe9verser: %{types}",
    youCanOnlyUploadX: {
        "0": "Vous pouvez seulement t\xe9l\xe9verser %{smart_count} fichier",
        "1": "Vous pouvez seulement t\xe9l\xe9verser %{smart_count} fichiers"
    },
    youHaveToAtLeastSelectX: {
        "0": "Vous devez s\xe9lectionner au moins %{smart_count} fichier",
        "1": "Vous devez s\xe9lectionner au moins %{smart_count} fichiers"
    }
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== "undefined") // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.fr_FR = $eb5fbf45bcb54698$var$fr_FR;
var $eb5fbf45bcb54698$export$2e2bcd8739ae039 = $eb5fbf45bcb54698$var$fr_FR;


const $17e4618551887cdb$var$it_IT = {
    strings: {},
    pluralize (n) {
        if (n === 1) return 0;
        return 1;
    }
};
$17e4618551887cdb$var$it_IT.strings = {
    addMoreFiles: "Aggiungi pi\xf9 file",
    addingMoreFiles: "Sto aggiungendo altri file",
    allowAccessDescription: "Per acquisire foto o video con la tua fotocamera, abilitane l'accesso da questo sito.",
    allowAccessTitle: "Abilita l'accesso alla fotocamera",
    authenticateWith: "Connetti a %{pluginName}",
    authenticateWithTitle: "Autenticati con %{pluginName} per selezionare i file",
    back: "Indietro",
    addMore: "Aggiungi pi\xf9",
    browse: "sfoglia",
    browseFiles: "sfoglia",
    cancel: "Annulla",
    cancelUpload: "Annulla upload",
    chooseFiles: "Scegli i file",
    closeModal: "Chiudi modale",
    companionError: "Connessione con Companion fallita",
    complete: "Completato",
    connectedToInternet: "Connesso a internet",
    copyLink: "Copia link",
    copyLinkToClipboardFallback: "Copia l'URL sottostante",
    copyLinkToClipboardSuccess: "Link copiato",
    creatingAssembly: "Upload in preparazione...",
    creatingAssemblyFailed: "Transloadit: Non ho potuto creare l'Assembly",
    dashboardTitle: "File Uploader",
    dashboardWindowTitle: "File Uploader (Premi Esc per chiudere)",
    dataUploadedOfTotal: "%{complete} di %{total}",
    done: "Fatto",
    dropHereOr: "Trascina i file qui o %{browse}",
    dropHint: "Trascina i file qui",
    dropPasteBoth: "Trascina i file qui, incolla o %{browse}",
    dropPasteFiles: "Trascina i file qui, incolla o %{browse}",
    dropPasteFolders: "Trascina i file qui, incolla o %{browse}",
    dropPasteImportBoth: "Trascina i file qui, incolla, %{browse} o importa da",
    dropPasteImportFiles: "Trascina i file qui, incolla, %{browse} o importa da",
    dropPasteImportFolders: "Trascina i file qui, incolla, %{browse} o importa da",
    editFile: "Modifica file",
    editImage: "Modifica immagine",
    editing: "Modifica %{file}",
    emptyFolderAdded: "Nessun file aggiunto dalla cartella vuota",
    encoding: "Encoding...",
    enterCorrectUrl: "URL non corretta: assicurati che sia un link diretto ad un file",
    enterUrlToImport: "Immetti l'URL per importare un file",
    exceedsSize: "Questo file supera la dimensione massima di %{size}",
    failedToFetch: "Impossibile verificare questa URL, assicurati che sia corretta",
    failedToUpload: "Upload del file %{file} non riuscito",
    fileSource: "Sorgente file: %{name}",
    filesUploadedOfTotal: {
        "0": "%{complete} di %{smart_count} file caricato",
        "1": "%{complete} di %{smart_count} file caricati"
    },
    filter: "Filter",
    finishEditingFile: "Finish editing file",
    folderAdded: {
        "0": "Aggiunto %{smart_count} file da %{folder}",
        "1": "Aggiunti %{smart_count} file da %{folder}"
    },
    import: "Importa",
    importFrom: "Importa da %{name}",
    loading: "Caricamento...",
    logOut: "Logout",
    myDevice: "Il mio computer",
    noFilesFound: "Non hai file o cartelle qui",
    noInternetConnection: "Nessuna connessione a internet",
    pause: "Pausa",
    pauseUpload: "Pausa upload",
    paused: "In pausa",
    poweredBy: "Powered by %{uppy}",
    processingXFiles: {
        "0": "Sto processando %{smart_count} file",
        "1": "Sto processando %{smart_count} file"
    },
    removeFile: "Rimuovi il file",
    resetFilter: "Ripristina filtro",
    resume: "Riprendi",
    resumeUpload: "Riprendi l'upload",
    retry: "Riprova",
    retryUpload: "Riprova l'upload",
    saveChanges: "Salva le modifiche",
    selectX: {
        "0": "Seleziona %{smart_count}",
        "1": "Seleziona %{smart_count}"
    },
    smile: "Sorridi!",
    startRecording: "Inizia la registrazione del video",
    stopRecording: "Interrompi la registrazione del video",
    takePicture: "Scatta una foto",
    timedOut: "Upload fermo da %{seconds} secondi, sto annullando.",
    upload: "Upload",
    uploadComplete: "Upload completato",
    uploadFailed: "Upload non riuscito",
    uploadPaused: "Upload in pausa",
    uploadXFiles: {
        "0": "Upload di %{smart_count} file",
        "1": "Upload di %{smart_count} file"
    },
    uploadXNewFiles: {
        "0": "Upload +%{smart_count} file",
        "1": "Upload +%{smart_count} file"
    },
    uploading: "In caricamento",
    uploadingXFiles: {
        "0": "Caricando %{smart_count} file",
        "1": "Caricando %{smart_count} file"
    },
    xFilesSelected: {
        "0": "%{smart_count} file selezionato",
        "1": "%{smart_count} file selezionati"
    },
    xMoreFilesAdded: {
        "0": "%{smart_count} alto file aggiunto",
        "1": "%{smart_count} altri file aggiunti"
    },
    xTimeLeft: "%{time} rimasto",
    youCanOnlyUploadFileTypes: "Puoi caricare solamente: %{types}",
    youCanOnlyUploadX: {
        "0": "Puoi caricare %{smart_count} solo file",
        "1": "Puoi caricare solo %{smart_count} file"
    },
    youHaveToAtLeastSelectX: {
        "0": "Devi selezionare almeno %{smart_count} file",
        "1": "Devi selezionare almeno %{smart_count} file"
    },
    selectFileNamed: "Seleziona il file %{name}",
    unselectFileNamed: "Deseleziona il file %{name}",
    openFolderNamed: "Cartella aperta %{name}"
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== "undefined") // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.it_IT = $17e4618551887cdb$var$it_IT;
var $17e4618551887cdb$export$2e2bcd8739ae039 = $17e4618551887cdb$var$it_IT;


const $e8c2aad43689e7e3$var$en_US = {
    strings: {},
    pluralize (count) {
        if (count === 1) return 0;
        return 1;
    }
};
$e8c2aad43689e7e3$var$en_US.strings = {
    addBulkFilesFailed: {
        "0": "Failed to add %{smart_count} file due to an internal error",
        "1": "Failed to add %{smart_count} files due to internal errors"
    },
    addedNumFiles: "Added %{numFiles} file(s)",
    addingMoreFiles: "Adding more files",
    additionalRestrictionsFailed: "%{count} additional restrictions were not fulfilled",
    addMore: "Add more",
    addMoreFiles: "Add more files",
    allFilesFromFolderNamed: "All files from folder %{name}",
    allowAccessDescription: "In order to take pictures or record video with your camera, please allow camera access for this site.",
    allowAccessTitle: "Please allow access to your camera",
    allowAudioAccessDescription: "In order to record audio, please allow microphone access for this site.",
    allowAudioAccessTitle: "Please allow access to your microphone",
    aspectRatioLandscape: "Crop landscape (16:9)",
    aspectRatioPortrait: "Crop portrait (9:16)",
    aspectRatioSquare: "Crop square",
    authAborted: "Authentication aborted",
    authenticateWith: "Connect to %{pluginName}",
    authenticateWithTitle: "Please authenticate with %{pluginName} to select files",
    back: "Back",
    browse: "browse",
    browseFiles: "browse files",
    browseFolders: "browse folders",
    cancel: "Cancel",
    cancelUpload: "Cancel upload",
    chooseFiles: "Choose files",
    closeModal: "Close Modal",
    companionError: "Connection with Companion failed",
    companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}",
    complete: "Complete",
    compressedX: "Saved %{size} by compressing images",
    compressingImages: "Compressing images...",
    connectedToInternet: "Connected to the Internet",
    copyLink: "Copy link",
    copyLinkToClipboardFallback: "Copy the URL below",
    copyLinkToClipboardSuccess: "Link copied to clipboard.",
    creatingAssembly: "Preparing upload...",
    creatingAssemblyFailed: "Transloadit: Could not create Assembly",
    dashboardTitle: "Uppy Dashboard",
    dashboardWindowTitle: "Uppy Dashboard Window (Press escape to close)",
    dataUploadedOfTotal: "%{complete} of %{total}",
    discardRecordedFile: "Discard recorded file",
    done: "Done",
    dropHereOr: "Drop here or %{browse}",
    dropHint: "Drop your files here",
    dropPasteBoth: "Drop files here, %{browseFiles} or %{browseFolders}",
    dropPasteFiles: "Drop files here or %{browseFiles}",
    dropPasteFolders: "Drop files here or %{browseFolders}",
    dropPasteImportBoth: "Drop files here, %{browseFiles}, %{browseFolders} or import from:",
    dropPasteImportFiles: "Drop files here, %{browseFiles} or import from:",
    dropPasteImportFolders: "Drop files here, %{browseFolders} or import from:",
    editFile: "Edit file",
    editImage: "Edit image",
    editFileWithFilename: "Edit file %{file}",
    editing: "Editing %{file}",
    emptyFolderAdded: "No files were added from empty folder",
    encoding: "Encoding...",
    enterCorrectUrl: "Incorrect URL: Please make sure you are entering a direct link to a file",
    enterTextToSearch: "Enter text to search for images",
    enterUrlToImport: "Enter URL to import a file",
    error: "Error",
    exceedsSize: "%{file} exceeds maximum allowed size of %{size}",
    failedToFetch: "Companion failed to fetch this URL, please make sure it\u2019s correct",
    failedToUpload: "Failed to upload %{file}",
    filesUploadedOfTotal: {
        "0": "%{complete} of %{smart_count} file uploaded",
        "1": "%{complete} of %{smart_count} files uploaded"
    },
    filter: "Filter",
    finishEditingFile: "Finish editing file",
    flipHorizontal: "Flip horizontal",
    folderAdded: {
        "0": "Added %{smart_count} file from %{folder}",
        "1": "Added %{smart_count} files from %{folder}"
    },
    folderAlreadyAdded: 'The folder "%{folder}" was already added',
    generatingThumbnails: "Generating thumbnails...",
    import: "Import",
    importFiles: "Import files from:",
    importFrom: "Import from %{name}",
    inferiorSize: "This file is smaller than the allowed size of %{size}",
    loadedXFiles: "Loaded %{numFiles} files",
    loading: "Loading...",
    logOut: "Log out",
    micDisabled: "Microphone access denied by user",
    missingRequiredMetaField: "Missing required meta fields",
    missingRequiredMetaFieldOnFile: "Missing required meta fields in %{fileName}",
    missingRequiredMetaFields: {
        "0": "Missing required meta field: %{fields}.",
        "1": "Missing required meta fields: %{fields}."
    },
    myDevice: "My Device",
    noAudioDescription: "In order to record audio, please connect a microphone or another audio input device",
    noAudioTitle: "Microphone Not Available",
    noCameraDescription: "In order to take pictures or record video, please connect a camera device",
    noCameraTitle: "Camera Not Available",
    noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
    noFilesFound: "You have no files or folders here",
    noInternetConnection: "No Internet connection",
    noMoreFilesAllowed: "Cannot add more files",
    noSearchResults: "Unfortunately, there are no results for this search",
    openFolderNamed: "Open folder %{name}",
    pause: "Pause",
    paused: "Paused",
    pauseUpload: "Pause upload",
    pluginNameAudio: "Audio",
    pluginNameBox: "Box",
    pluginNameCamera: "Camera",
    pluginNameDropbox: "Dropbox",
    pluginNameFacebook: "Facebook",
    pluginNameGoogleDrive: "Google Drive",
    pluginNameInstagram: "Instagram",
    pluginNameOneDrive: "OneDrive",
    pluginNameZoom: "Zoom",
    poweredBy: "Powered by %{uppy}",
    processingXFiles: {
        "0": "Processing %{smart_count} file",
        "1": "Processing %{smart_count} files"
    },
    recording: "Recording",
    recordingLength: "Recording length %{recording_length}",
    recordingStoppedMaxSize: "Recording stopped because the file size is about to exceed the limit",
    recordVideoBtn: "Record Video",
    recoveredAllFiles: "We restored all files. You can now resume the upload.",
    recoveredXFiles: {
        "0": "We could not fully recover 1 file. Please re-select it and resume the upload.",
        "1": "We could not fully recover %{smart_count} files. Please re-select them and resume the upload."
    },
    removeFile: "Remove file",
    reSelect: "Re-select",
    resetFilter: "Reset filter",
    resetSearch: "Reset search",
    resume: "Resume",
    resumeUpload: "Resume upload",
    retry: "Retry",
    retryUpload: "Retry upload",
    revert: "Revert",
    rotate: "Rotate",
    save: "Save",
    saveChanges: "Save changes",
    search: "Search",
    searchImages: "Search for images",
    selectX: {
        "0": "Select %{smart_count}",
        "1": "Select %{smart_count}"
    },
    sessionRestored: "Session restored",
    showErrorDetails: "Show error details",
    signInWithGoogle: "Sign in with Google",
    smile: "Smile!",
    startAudioRecording: "Begin audio recording",
    startCapturing: "Begin screen capturing",
    startRecording: "Begin video recording",
    stopAudioRecording: "Stop audio recording",
    stopCapturing: "Stop screen capturing",
    stopRecording: "Stop video recording",
    streamActive: "Stream active",
    streamPassive: "Stream passive",
    submitRecordedFile: "Submit recorded file",
    takePicture: "Take a picture",
    takePictureBtn: "Take Picture",
    timedOut: "Upload stalled for %{seconds} seconds, aborting.",
    upload: "Upload",
    uploadComplete: "Upload complete",
    uploadFailed: "Upload failed",
    uploading: "Uploading",
    uploadingXFiles: {
        "0": "Uploading %{smart_count} file",
        "1": "Uploading %{smart_count} files"
    },
    uploadPaused: "Upload paused",
    uploadStalled: "Upload has not made any progress for %{seconds} seconds. You may want to retry it.",
    uploadXFiles: {
        "0": "Upload %{smart_count} file",
        "1": "Upload %{smart_count} files"
    },
    uploadXNewFiles: {
        "0": "Upload +%{smart_count} file",
        "1": "Upload +%{smart_count} files"
    },
    xFilesSelected: {
        "0": "%{smart_count} file selected",
        "1": "%{smart_count} files selected"
    },
    xMoreFilesAdded: {
        "0": "%{smart_count} more file added",
        "1": "%{smart_count} more files added"
    },
    xTimeLeft: "%{time} left",
    youCanOnlyUploadFileTypes: "You can only upload: %{types}",
    youCanOnlyUploadX: {
        "0": "You can only upload %{smart_count} file",
        "1": "You can only upload %{smart_count} files"
    },
    youHaveToAtLeastSelectX: {
        "0": "You have to select at least %{smart_count} file",
        "1": "You have to select at least %{smart_count} files"
    },
    zoomIn: "Zoom in",
    zoomOut: "Zoom out"
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== "undefined") // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.en_US = $e8c2aad43689e7e3$var$en_US;
var $e8c2aad43689e7e3$export$2e2bcd8739ae039 = $e8c2aad43689e7e3$var$en_US;


class $2b8eccc7b4db22b8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.isWithinIFrame = false;
        this.api = this.getAttribute("data-tk-api") || undefined;
        this.moveAPI = this.getAttribute("data-tk-move-api") || undefined;
        this.usage = this.getAttribute("data-tk-usage") || undefined;
        this.filePath = this.getAttribute("data-tk-file-path") || undefined;
        this.disableCompressor = this.hasAttribute("data-tk-disable-compressor");
        this.outputMimeType = this.getAttribute("data-tk-output-mime-type") || "image/webp";
        this.maxNumberOfFiles = Number(this.getAttribute("data-tk-max-number-of-files")) || null;
        this.maxFileSize = Number(this.getAttribute("data-tk-max-file-size")) || null;
        this.allowedFileTypes = (this.getAttribute("data-tk-allowed-file-types") || "image/*").split(",");
        this.locale = Number(this.getAttribute("data-tk-locale")) || 1;
        this.disableUniqueFileNames = this.hasAttribute("data-tk-disable-unique-file-names");
        const getLanguage = {
            1: (0, $4dcbb1f6ebd585d1$export$2e2bcd8739ae039),
            2: (0, $eb5fbf45bcb54698$export$2e2bcd8739ae039),
            3: (0, $e8c2aad43689e7e3$export$2e2bcd8739ae039),
            4: (0, $17e4618551887cdb$export$2e2bcd8739ae039)
        };
        this.language = getLanguage[this.locale];
        this.filePrefix = this.getAttribute("data-tk-file-prefix") || undefined;
        this.isWithinIFrame = this.hasAttribute("data-tk-is-within-iframe");
    }
    connectedCallback() {
        if (!this.api || !this.moveAPI || !this.usage || !this.filePath) throw new Error("FileUploadArea: Attributes are missing!");
        this.init();
    }
    init() {
        const endpoint = `${this.api}${this.usage}`;
        this.uppy = new (0, $b16b91c7840d3bff$export$2e2bcd8739ae039)();
        this.uppy.setOptions({
            restrictions: {
                maxFileSize: this.maxFileSize,
                maxNumberOfFiles: this.maxNumberOfFiles,
                allowedFileTypes: this.allowedFileTypes
            },
            locale: this.language
        });
        this.uppy.use((0, $b868dcf7a47332e3$export$2e2bcd8739ae039), {
            target: this,
            inline: true,
            width: "100%"
        });
        this.uppy.use((0, $cf91058fd9d7f8ee$export$2e2bcd8739ae039), {
            endpoint: endpoint,
            allowedMetaFields: [],
            getResponseData: (responseText, response)=>this.getResponseData(responseText, response)
        });
        !this.disableCompressor && this.uppy.use((0, $d847a4c5a8f23ad9$export$2e2bcd8739ae039), {
            mimeType: this.outputMimeType
        });
        this.uppy.on("file-added", (file)=>{
            const modifiedFileName = this.getFileName(file);
            this.uppy?.setFileMeta(file.id, {
                name: modifiedFileName
            });
            this.uppy?.setFileState(file.id, {
                name: modifiedFileName
            });
        });
    }
    async getResponseData(responseText, response) {
        if (response instanceof XMLHttpRequest && response.status === 200) {
            const response = await this.moveFile();
            const { path: path, success: success } = response.dataAsJson;
            if (!success) {
                const error = {
                    message: "FAILED!"
                };
                this.uppy?.emit("error", error);
                this.uppy?.emit("upload-cancel", error);
            } else {
                if (this.isWithinIFrame) window.parent.postMessage({
                    mceAction: "close",
                    content: path,
                    size: {
                        width: 0,
                        height: 0
                    }
                }, "*");
                return {
                    url: path
                };
            }
        }
    }
    async moveFile() {
        const data = {
            usage: this.usage,
            path: this.filePath
        };
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: this.moveAPI,
                resolveHandler: (success)=>resolve(success),
                payload: data
            });
        });
    }
    getFileName(file) {
        if (this.disableUniqueFileNames && this.filePrefix) return `${this.filePrefix}-${file.name}`;
        if (!this.disableUniqueFileNames && this.filePrefix) return `${this.filePrefix}-${(0, $d0666643e2ee88b4$export$2e2bcd8739ae039)()}.${file.extension}`;
        if (!this.disableUniqueFileNames && !this.filePrefix) return `${(0, $d0666643e2ee88b4$export$2e2bcd8739ae039)()}.${file.extension}`;
        return file.name;
    }
}


class $a2e6d2278a4d4be5$export$2e2bcd8739ae039 extends (0, $2b8eccc7b4db22b8$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    async getResponseData(responseText, response) {
        if (response instanceof XMLHttpRequest && response.status === 200) {
            const response = await this.moveFile();
            const { path: path, success: success, type: type, mode: mode } = response.dataAsJson;
            if (!success) {
                const error = {
                    message: "FAILED!"
                };
                this.uppy?.emit("error", error);
                this.uppy?.emit("upload-cancel", error);
            } else {
                if (this.isWithinIFrame) window.parent.postMessage({
                    mceAction: "close",
                    content: path,
                    size: {
                        width: 0,
                        height: 0
                    }
                }, "*");
                if (type === "dialog") {
                    const dialog = this.closest("dialog");
                    if (dialog) {
                        const button = dialog.querySelector(`[data-tk-dialog-${mode}]`);
                        if (button) {
                            button.disabled = false;
                            button.click();
                        }
                    }
                }
                return {
                    url: path,
                    type: type,
                    mode: mode
                };
            }
        }
    }
}



class $93780757a145052d$export$2e2bcd8739ae039 extends (0, $9a3403e3213d867d$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.isBoolean = this.hasAttribute("data-tk-boolean");
        this.checkboxElement = this.querySelector('input[type="checkbox"]') || undefined;
        this.hiddenElement = this.querySelector('input[type="hidden"]') || undefined;
        this.defaultValue = this.hiddenElement?.value || "0";
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.isBoolean) return;
        this.registerBooleanListener();
        this.checkboxElement && this.toggleBoolean(this.checkboxElement);
    }
    registerBooleanListener() {
        if (!this.checkboxElement || !this.hiddenElement) return;
        const onInput = this.handleInput.bind(this);
        this.pushListener({
            event: "input",
            element: this.checkboxElement,
            action: onInput
        });
    }
    handleInput(event) {
        const target = event.target;
        this.toggleBoolean(target);
    }
    toggleBoolean(element) {
        if (element.checked) this.hiddenElement.value = element.value;
        else this.hiddenElement.value = this.defaultValue;
    }
}





class $b89635042a3c885d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.form = document.querySelector("[data-tk-tour-form]") || undefined;
        const closestValidator = this.form?.closest("tk-form-validator");
        if (this.form && closestValidator) this.formValidator = closestValidator;
        this.url = this.getAttribute("data-tk-url") || undefined;
    }
    connectedCallback() {
        if (!this.form || !this.url) return;
        this.pushListener({
            event: "submit",
            element: this.form,
            action: this.getTourDetails.bind(this)
        });
    }
    getTourDetails(e) {
        e.preventDefault();
        if (this.formValidator) this.formValidator.isFormValid().then((isValid)=>{
            if (!isValid) return; // Proceed only if the form is valid
            this.fetchContent();
        });
        else this.fetchContent();
    }
    fetchContent() {
        const formData = new FormData(this.form);
        const data = {
            zip: formData.get("tour-zip"),
            city: formData.get("tour-city")
        };
        // fetch content
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            resolveHandler: this.showTourDetails.bind(this),
            payload: data
        });
    }
    showTourDetails(response) {
        // show content
        this.replaceChildren((0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml, true));
        this.form.reset();
    }
}





var $ffa8deea28bceade$var$DialogActions;
(function(DialogActions) {
    DialogActions["JUMP_FORWARD"] = "jump_forward";
    DialogActions["JUMP_BACKWARD"] = "jump_backward";
    DialogActions["JUMP_TO"] = "jump_to";
    DialogActions["RESET_FORM"] = "reset_form";
    DialogActions["REFRESH"] = "refresh";
})($ffa8deea28bceade$var$DialogActions || ($ffa8deea28bceade$var$DialogActions = {}));
class $ffa8deea28bceade$export$2e2bcd8739ae039 extends (0, $2215c02a950e9fbf$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.tag = this.getAttribute("data-tk-tag") || "dialog";
    }
    connectedCallback() {
        super.connectedCallback();
    }
    createDialog(url) {
        const dialog = $ffa8deea28bceade$export$2e2bcd8739ae039.renderDialog({
            className: `${this.dialogClassName} ${this.shouldMaxWidth ? this.maxWidthClassName : ""}`,
            closeClassName: this.dialogCloseClassName,
            innerClassName: this.dialogInnerClassName,
            tag: this.tag,
            isConfirm: this.isConfirm,
            confirmURL: url,
            confirmTitle: this.confirmTitle,
            confirmDescription: this.confirmDescription,
            confirmCancelIcon: this.confirmCancelIcon,
            confirmCancelLabel: this.confirmCancelLabel,
            confirmSubmitIcon: this.confirmSubmitIcon,
            confirmSubmitLabel: this.confirmSubmitLabel
        });
        const onClosed = this.closedDialog.bind(this);
        this.pushListener({
            event: "close",
            element: dialog,
            action: onClosed
        });
        this.currentDialog = this.dialogs.push({
            url: url,
            dialog: dialog
        }) - 1;
        return dialog;
    }
    static renderDialog(options) {
        const { tag: tag, className: className = "tk-dialog", closeClassName: closeClassName = "tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close", innerClassName: innerClassName = "tk-dialog__inner", content: content, isConfirm: isConfirm = false, confirmURL: confirmURL, confirmTitle: confirmTitle, confirmDescription: confirmDescription, confirmCancelIcon: confirmCancelIcon, confirmCancelLabel: confirmCancelLabel, confirmSubmitIcon: confirmSubmitIcon, confirmSubmitLabel: confirmSubmitLabel } = options;
        const dialog = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            ${isConfirm ? `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            <form action="${confirmURL}" method="post">
                                <div class="tk-dialog__header">
                                    <h3>${confirmTitle}</h3>
                                </div>
                                <div class="tk-dialog__body">
                                    <p>${confirmDescription}</p>
                                </div>
                                <div class="flex flex--gap-x-2 flex--justify-end tk-dialog__footer">
                                    <button type="button" class="tk-button tk-button--secondary" data-tk-dialog-close>
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmCancelIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmCancelLabel}</span>
                                    </button>
                                    <button type="submit" class="tk-button tk-button--primary">
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmSubmitIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmSubmitLabel}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </${tag}>
                ` : `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            ${content}
                        </div>
                    </${tag}>
                `}
        `);
        document.body.insertAdjacentElement("beforeend", dialog);
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, "[data-tk-dialog-close]", ()=>(0, $2215c02a950e9fbf$export$2e2bcd8739ae039).close(dialog));
        return dialog;
    }
    getContent(url) {
        if (this.isConfirm) {
            this.closeCurrentDialog();
            const dialog = this.createDialog(url);
            $ffa8deea28bceade$export$2e2bcd8739ae039.open(dialog, this.isPopup);
        } else (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url)
        });
    }
    handleResponseSuccess(url, response) {
        if (!response || !response.success) return;
        this.closeCurrentDialog();
        const dialog = this.createDialog(url);
        const content = dialog.querySelector("[data-tk-dialog-content]");
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
        $ffa8deea28bceade$export$2e2bcd8739ae039.open(dialog, this.isPopup);
        this.hookAfterShowModal(dialog);
        const form = content.querySelector("form");
        form && this.registerFormListener(form);
    }
    handleUrlAndDialogs(url) {
        const existsURL = this.dialogs.some((dialogItem)=>dialogItem.url === url);
        if (existsURL) {
            const nextDialog = this.getDialogByURL(url);
            if (!nextDialog) return;
            const waitForContent = this.forceReloadContent;
            if (this.forceReloadContent) this.renewDialogContent(nextDialog, url);
            if (waitForContent) return;
            $ffa8deea28bceade$export$2e2bcd8739ae039.open(nextDialog);
        } else try {
            const payload = JSON.parse(this.formDataString || "{}");
            Object.keys(payload).length > 0 ? this.getContentWithData(url, payload) : this.getContent(url);
        } catch (error) {
            throw new Error(`Dialog: ${error}`);
        }
    }
    static closeDialogIfOutside(element, event) {
        /**
         * Checking the coordinates of the client for the value 0 and the
         * HTMLSelectElement or HTMLOptionElement element ensures that the
         * dialogue does not close in Mozilla. This is a bug in Firefox
         * that has not yet been fixed.
         */ if (event.clientX === 0 && event.clientY === 0 && (event.target instanceof HTMLSelectElement || event.target instanceof HTMLOptionElement)) return;
        const dialogDimensions = element.getBoundingClientRect();
        if (event.clientX < dialogDimensions.left || event.clientX > dialogDimensions.right || event.clientY < dialogDimensions.top || event.clientY > dialogDimensions.bottom) $ffa8deea28bceade$export$2e2bcd8739ae039.close(element);
    }
    hookAfterShowModal(dialog) {
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, "[data-tk-dialog-close]", ()=>$ffa8deea28bceade$export$2e2bcd8739ae039.close(dialog));
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, "[data-tk-dialog-close-and-reset]", (button)=>this.handleActions("reset_form", button));
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, "[data-tk-dialog-jump-forward]", (button)=>this.handleActions("jump_forward", button));
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, "[data-tk-dialog-jump-backward]", (button)=>this.handleActions("jump_backward", button));
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, "[data-tk-dialog-jump-to]", (button)=>this.handleActions("jump_to", button));
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, "[data-tk-dialog-refresh]", (button)=>this.handleActions("refresh", button));
    }
    handleActions(action, button) {
        const handler = {
            jump_forward: ()=>this.forward(button),
            jump_backward: ()=>this.backward(),
            jump_to: ()=>this.jumpTo(button),
            reset_form: ()=>this.resetForm(button),
            refresh: ()=>this.refresh(button)
        };
        handler[action]();
    }
    closeCurrentDialog() {
        const dialogItem = this.dialogs.at(this.currentDialog);
        if (!dialogItem) return;
        $ffa8deea28bceade$export$2e2bcd8739ae039.close(dialogItem.dialog);
    }
    closeDialog(event) {
        const dialogItem = this.dialogs.at(this.currentDialog);
        // Used to check if the event isn't triggered by the enter key
        const isRealClickEvent = event.pointerId !== -1;
        if (!dialogItem || !isRealClickEvent) return;
        const { dialog: dialog } = dialogItem;
        if (this.closeOnBackdropClick) $ffa8deea28bceade$export$2e2bcd8739ae039.closeDialogIfOutside(dialog, event);
    }
    // eslint-disable-next-line class-methods-use-this
    refresh(button) {
        // Check if already exists
        const url = button.getAttribute("data-tk-url");
        if (!url) throw new Error("Dialog: URL is missing!");
        window.open(url, "_self");
    }
}


/* eslint-disable no-underscore-dangle */ 
const $a06c39645f985d69$var$isValidJSON = (value)=>{
    try {
        const json = JSON.parse(value);
        return {
            isValid: true,
            json: json
        };
    } catch (error) {
        return {
            isValid: false
        };
    }
};
var $a06c39645f985d69$export$2e2bcd8739ae039 = $a06c39645f985d69$var$isValidJSON;


const $0e551bcb8ad3f0f3$var$parseBooleanOrString = (value)=>{
    if (value === "true") return true;
    if (value === "false") return false;
    return value;
};
var $0e551bcb8ad3f0f3$export$2e2bcd8739ae039 = $0e551bcb8ad3f0f3$var$parseBooleanOrString;


const $f911f521be33fa22$var$toSnakeCase = (input)=>input.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
var $f911f521be33fa22$export$2e2bcd8739ae039 = $f911f521be33fa22$var$toSnakeCase;


const $7fb9ed192a85071f$var$FORM_TRACKER_ATTR = "data-form-tracker";
class $7fb9ed192a85071f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.attributeList = [];
        this.tracker = window._mtm || [];
        this.trackerElement = this.closest("kw-tracker") || undefined;
        this.event = this.getAttribute("data-tk-event") || undefined;
        this.location = window.location.href;
        this.form = this.querySelector("form") || undefined;
    }
    async connectedCallback() {
        if (!this.trackerElement) {
            const trackerElement = document.body.querySelector("kw-tracker");
            if (trackerElement) this.trackerElement = trackerElement;
            else throw new Error("Tracker Element is missing!");
        }
        if (!this.event) throw new Error("Event is not defined");
        this.registerSubmitListener();
    }
    registerSubmitListener() {
        if (!this.form) throw new Error("Form Element is missing!");
        const onSubmit = this.handleSubmit.bind(this);
        this.pushListener({
            event: "submit",
            element: this.form,
            action: onSubmit
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        this.getAllAttributes();
        this.getFormFields();
        this.pushTracker();
    }
    getAllAttributes() {
        Object.keys(this.dataset).filter((item)=>!item.startsWith("tk")).forEach((key)=>{
            const value = this.dataset[key];
            if (!value) return;
            const result = (0, $a06c39645f985d69$export$2e2bcd8739ae039)(value);
            const attribute = {
                key: key,
                value: result.isValid ? result.json : (0, $0e551bcb8ad3f0f3$export$2e2bcd8739ae039)(value)
            };
            this.attributeList.push(attribute);
        });
    }
    getFormFields() {
        const formFields = this.querySelectorAll(`[${$7fb9ed192a85071f$var$FORM_TRACKER_ATTR}]`);
        formFields.forEach((formField)=>{
            const attribute = {
                key: formField.getAttribute($7fb9ed192a85071f$var$FORM_TRACKER_ATTR) || "",
                value: formField.value
            };
            this.attributeList.push(attribute);
        });
    }
    pushTracker() {
        const item = {
            event: this.event,
            location: this.location,
            ...this.attributeList.reduce((acc, attr)=>{
                const key = (0, $f911f521be33fa22$export$2e2bcd8739ae039)(attr.key);
                acc[key] = attr.value;
                return acc;
            }, {})
        };
        this.tracker.push(item);
    }
}


var $4fd6157d2364abb3$export$407448d2b89b1813 = class r extends Error {
    constructor(e){
        super(e.message);
        Object.setPrototypeOf(this, r.prototype), typeof e.name == "string" && (this.name = e.name), typeof e.message == "string" && (this.message = e.message);
    }
};


var $7061b11aca9abb6f$export$407448d2b89b1813 = class extends (0, $4fd6157d2364abb3$export$407448d2b89b1813) {
    constructor(r){
        super({
            name: "UnsupportedBrowserError",
            message: `This OS / browser has one or more missing features preventing it from working correctly (${r.missingFeatures.join(", ")})`
        });
        this.data = r;
    }
};


var $9fbbcde428fa7e14$export$407448d2b89b1813;
((u)=>{
    ((e)=>(e.Debug = "debug", e.Info = "info", e.Warn = "warn", e.Error = "error", e.Quiet = "quiet"))(u.Level || (u.Level = {}));
    let n = new Map([
        [
            "debug",
            1
        ],
        [
            "info",
            2
        ],
        [
            "warn",
            3
        ],
        [
            "error",
            4
        ],
        [
            "quiet",
            5
        ]
    ]), l = "debug";
    function a(r) {
        l = r;
    }
    u.setLevel = a;
    function v(r, ...o) {
        if (!(n.get(l) > n.get(r))) switch(r){
            case "debug":
                console.debug(...o);
                break;
            case "info":
                console.log(...o);
                break;
            case "warn":
                console.warn(...o);
                break;
            case "error":
                console.error(...o);
                break;
        }
    }
    u.log = v;
})($9fbbcde428fa7e14$export$407448d2b89b1813 || ($9fbbcde428fa7e14$export$407448d2b89b1813 = {}));



var $73362e49aa734db9$var$r = async ()=>WebAssembly.validate(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        5,
        1,
        96,
        0,
        1,
        123,
        3,
        2,
        1,
        0,
        10,
        10,
        1,
        8,
        0,
        65,
        0,
        253,
        15,
        253,
        98,
        11
    ]));
var $73362e49aa734db9$var$t = ()=>(async (a)=>{
        try {
            return typeof MessageChannel < "u" && new MessageChannel().port1.postMessage(new SharedArrayBuffer(1)), WebAssembly.validate(a);
        } catch (e) {
            return !1;
        }
    })(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        2,
        1,
        0,
        5,
        4,
        1,
        3,
        1,
        1,
        10,
        11,
        1,
        9,
        0,
        65,
        0,
        254,
        16,
        2,
        0,
        26,
        11
    ]));
function $73362e49aa734db9$export$407448d2b89b1813() {
    return typeof crossOriginIsolated > "u" ? !1 : crossOriginIsolated;
}
function $73362e49aa734db9$export$8b22cf2602fb60ce() {
    try {
        return new WebAssembly.Memory({
            initial: 1,
            maximum: 1,
            shared: !0
        }).buffer.constructor.name === "SharedArrayBuffer";
    } catch (a) {
        return !1;
    }
}
async function $73362e49aa734db9$export$db3b6bfb95261072() {
    return $73362e49aa734db9$var$r();
}
async function $73362e49aa734db9$export$4368d992c4eafac0() {
    if (!await $73362e49aa734db9$var$t()) return !1;
    let e = null;
    try {
        e = new Worker(URL.createObjectURL(new Blob([
            'postMessage("Worker" in self);'
        ], {
            type: "text/javascript"
        })), {
            name: "nestedWorkerTest"
        });
    } catch (n) {
        return !1;
    }
    return new Promise((n)=>{
        if (e == null) {
            n(!1);
            return;
        }
        e.onmessage = (s)=>{
            e == null || e.terminate(), n(s.data);
        };
    });
}
async function $73362e49aa734db9$export$f1e1789686576879() {
    let a = await $73362e49aa734db9$export$4368d992c4eafac0();
    return $73362e49aa734db9$export$407448d2b89b1813() && $73362e49aa734db9$export$8b22cf2602fb60ce() && a;
}


var $9aa2b00a42a878e2$var$q = Object.create;
var $9aa2b00a42a878e2$var$o = Object.defineProperty;
var $9aa2b00a42a878e2$var$r = Object.getOwnPropertyDescriptor;
var $9aa2b00a42a878e2$var$s = Object.getOwnPropertyNames;
var $9aa2b00a42a878e2$var$t = Object.getPrototypeOf, $9aa2b00a42a878e2$var$u = Object.prototype.hasOwnProperty;
var $9aa2b00a42a878e2$var$n = (a, b)=>{
    if (b = Symbol[a]) return b;
    throw Error("Symbol." + a + " is not defined");
};
var $9aa2b00a42a878e2$export$407448d2b89b1813 = (a, b)=>()=>(b || a((b = {
            exports: {}
        }).exports, b), b.exports);
var $9aa2b00a42a878e2$var$v = (a, b, c, e)=>{
    if (b && typeof b == "object" || typeof b == "function") for (let d of $9aa2b00a42a878e2$var$s(b))!$9aa2b00a42a878e2$var$u.call(a, d) && d !== c && $9aa2b00a42a878e2$var$o(a, d, {
        get: ()=>b[d],
        enumerable: !(e = $9aa2b00a42a878e2$var$r(b, d)) || e.enumerable
    });
    return a;
};
var $9aa2b00a42a878e2$export$8b22cf2602fb60ce = (a, b, c)=>(c = a != null ? $9aa2b00a42a878e2$var$q($9aa2b00a42a878e2$var$t(a)) : {}, $9aa2b00a42a878e2$var$v(b || !a || !a.__esModule ? $9aa2b00a42a878e2$var$o(c, "default", {
        value: a,
        enumerable: !0
    }) : c, a));
var $9aa2b00a42a878e2$export$db3b6bfb95261072 = function(a, b) {
    this[0] = a, this[1] = b;
}, $9aa2b00a42a878e2$export$4368d992c4eafac0 = (a, b, c)=>{
    var e = (h, g, i, k)=>{
        try {
            var l = c[h](g), m = (g = l.value) instanceof $9aa2b00a42a878e2$export$db3b6bfb95261072, p = l.done;
            Promise.resolve(m ? g[0] : g).then((j)=>m ? e(h === "return" ? h : "next", g[1] ? {
                    done: j.done,
                    value: j.value
                } : j, i, k) : i({
                    value: j,
                    done: p
                })).catch((j)=>e("throw", j, i, k));
        } catch (j) {
            k(j);
        }
    }, d = (h)=>f[h] = (g)=>new Promise((i, k)=>e(h, g, i, k)), f = {};
    return c = c.apply(a, b), f[Symbol.asyncIterator] = ()=>f, d("next"), d("throw"), d("return"), f;
};
var $9aa2b00a42a878e2$export$f1e1789686576879 = (a, b, c)=>(b = a[$9aa2b00a42a878e2$var$n("asyncIterator")]) ? b.call(a) : (a = a[$9aa2b00a42a878e2$var$n("iterator")](), b = {}, c = (e, d)=>(d = a[e]) && (b[e] = (f)=>new Promise((h, g, i)=>(f = d.call(a, f), i = f.done, Promise.resolve(f.value).then((k)=>h({
                        value: k,
                        done: i
                    }), g)))), c("next"), c("return"), b);


var $08663c8936fe6aaa$var$Oe = (0, $9aa2b00a42a878e2$export$407448d2b89b1813)((ke, ye)=>{
    (function(h) {
        var c;
        if (typeof define == "function" && define.amd && (define(h), c = !0), typeof ke == "object" && (ye.exports = h(), c = !0), !c) {
            var I = window.Cookies, v = window.Cookies = h();
            v.noConflict = function() {
                return window.Cookies = I, v;
            };
        }
    })(function() {
        function h() {
            for(var v = 0, y = {}; v < arguments.length; v++){
                var T = arguments[v];
                for(var O in T)y[O] = T[O];
            }
            return y;
        }
        function c(v) {
            return v.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
        }
        function I(v) {
            function y() {}
            function T(x, S, f) {
                if (!(typeof document > "u")) {
                    f = h({
                        path: "/"
                    }, y.defaults, f), typeof f.expires == "number" && (f.expires = new Date(new Date * 1 + f.expires * 864e5)), f.expires = f.expires ? f.expires.toUTCString() : "";
                    try {
                        var o = JSON.stringify(S);
                        /^[\{\[]/.test(o) && (S = o);
                    } catch (i) {}
                    S = v.write ? v.write(S, x) : encodeURIComponent(String(S)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), x = encodeURIComponent(String(x)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                    var n = "";
                    for(var e in f)f[e] && (n += "; " + e, f[e] !== !0 && (n += "=" + f[e].split(";")[0]));
                    return document.cookie = x + "=" + S + n;
                }
            }
            function O(x, S) {
                if (!(typeof document > "u")) {
                    for(var f = {}, o = document.cookie ? document.cookie.split("; ") : [], n = 0; n < o.length; n++){
                        var e = o[n].split("="), i = e.slice(1).join("=");
                        !S && i.charAt(0) === '"' && (i = i.slice(1, -1));
                        try {
                            var t = c(e[0]);
                            if (i = (v.read || v)(i, t) || c(i), S) try {
                                i = JSON.parse(i);
                            } catch (A) {}
                            if (f[t] = i, x === t) break;
                        } catch (A) {}
                    }
                    return x ? f[x] : f;
                }
            }
            return y.set = T, y.get = function(x) {
                return O(x, !1);
            }, y.getJSON = function(x) {
                return O(x, !0);
            }, y.remove = function(x, S) {
                T(x, "", h(S, {
                    expires: -1
                }));
            }, y.defaults = {}, y.withConverter = I, y;
        }
        return I(function() {});
    });
});
var $08663c8936fe6aaa$var$Ce = (0, $9aa2b00a42a878e2$export$407448d2b89b1813)((V, X)=>{
    (function(h, c) {
        var I = "1.0.34", v = "", y = "?", T = "function", O = "undefined", x = "object", S = "string", f = "major", o = "model", n = "name", e = "type", i = "vendor", t = "version", A = "architecture", P = "console", d = "mobile", b = "tablet", C = "smarttv", B = "wearable", $ = "embedded", j = 350, D = "Amazon", a = "Apple", u = "ASUS", s = "BlackBerry", m = "Browser", k = "Chrome", _ = "Edge", M = "Firefox", F = "Google", re = "Huawei", J = "LG", K = "Microsoft", ae = "Motorola", H = "Opera", Q = "Samsung", se = "Sharp", G = "Sony", ee = "Xiaomi", ie = "Zebra", le = "Facebook", ce = "Chromium OS", ue = "Mac OS", _e = function(w, p) {
            var l = {};
            for(var g in w)p[g] && p[g].length % 2 === 0 ? l[g] = p[g].concat(w[g]) : l[g] = w[g];
            return l;
        }, Y = function(w) {
            for(var p = {}, l = 0; l < w.length; l++)p[w[l].toUpperCase()] = w[l];
            return p;
        }, be = function(w, p) {
            return typeof w === S ? W(p).indexOf(W(w)) !== -1 : !1;
        }, W = function(w) {
            return w.toLowerCase();
        }, Me = function(w) {
            return typeof w === S ? w.replace(/[^\d\.]/g, v).split(".")[0] : c;
        }, oe = function(w, p) {
            if (typeof w === S) return w = w.replace(/^\s\s*/, v), typeof p === O ? w : w.substring(0, j);
        }, q = function(w, p) {
            for(var l = 0, g, N, R, r, z, U; l < p.length && !z;){
                var te = p[l], fe = p[l + 1];
                for(g = N = 0; g < te.length && !z && te[g];)if (z = te[g++].exec(w), z) for(R = 0; R < fe.length; R++)U = z[++N], r = fe[R], typeof r === x && r.length > 0 ? r.length === 2 ? typeof r[1] == T ? this[r[0]] = r[1].call(this, U) : this[r[0]] = r[1] : r.length === 3 ? typeof r[1] === T && !(r[1].exec && r[1].test) ? this[r[0]] = U ? r[1].call(this, U, r[2]) : c : this[r[0]] = U ? U.replace(r[1], r[2]) : c : r.length === 4 && (this[r[0]] = U ? r[3].call(this, U.replace(r[1], r[2])) : c) : this[r] = U || c;
                l += 2;
            }
        }, ne = function(w, p) {
            for(var l in p)if (typeof p[l] === x && p[l].length > 0) {
                for(var g = 0; g < p[l].length; g++)if (be(p[l][g], w)) return l === y ? c : l;
            } else if (be(p[l], w)) return l === y ? c : l;
            return w;
        }, Re = {
            "1.0": "/8",
            "1.2": "/1",
            "1.3": "/3",
            "2.0": "/412",
            "2.0.2": "/416",
            "2.0.3": "/417",
            "2.0.4": "/419",
            "?": "/"
        }, de = {
            ME: "4.90",
            "NT 3.11": "NT3.51",
            "NT 4.0": "NT4.0",
            2e3: "NT 5.0",
            XP: [
                "NT 5.1",
                "NT 5.2"
            ],
            Vista: "NT 6.0",
            7: "NT 6.1",
            8: "NT 6.2",
            "8.1": "NT 6.3",
            10: [
                "NT 6.4",
                "NT 10.0"
            ],
            RT: "ARM"
        }, we = {
            browser: [
                [
                    /\b(?:crmo|crios)\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "Chrome"
                    ]
                ],
                [
                    /edg(?:e|ios|a)?\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "Edge"
                    ]
                ],
                [
                    /(opera mini)\/([-\w\.]+)/i,
                    /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                    /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                ],
                [
                    n,
                    t
                ],
                [
                    /opios[\/ ]+([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        H + " Mini"
                    ]
                ],
                [
                    /\bopr\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        H
                    ]
                ],
                [
                    /(kindle)\/([\w\.]+)/i,
                    /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                    /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                    /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                    /(?:ms|\()(ie) ([\w\.]+)/i,
                    /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                    /(weibo)__([\d\.]+)/i
                ],
                [
                    n,
                    t
                ],
                [
                    /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "UC" + m
                    ]
                ],
                [
                    /microm.+\bqbcore\/([\w\.]+)/i,
                    /\bqbcore\/([\w\.]+).+microm/i
                ],
                [
                    t,
                    [
                        n,
                        "WeChat(Win) Desktop"
                    ]
                ],
                [
                    /micromessenger\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "WeChat"
                    ]
                ],
                [
                    /konqueror\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "Konqueror"
                    ]
                ],
                [
                    /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                ],
                [
                    t,
                    [
                        n,
                        "IE"
                    ]
                ],
                [
                    /yabrowser\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "Yandex"
                    ]
                ],
                [
                    /(avast|avg)\/([\w\.]+)/i
                ],
                [
                    [
                        n,
                        /(.+)/,
                        "$1 Secure " + m
                    ],
                    t
                ],
                [
                    /\bfocus\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        M + " Focus"
                    ]
                ],
                [
                    /\bopt\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        H + " Touch"
                    ]
                ],
                [
                    /coc_coc\w+\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "Coc Coc"
                    ]
                ],
                [
                    /dolfin\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "Dolphin"
                    ]
                ],
                [
                    /coast\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        H + " Coast"
                    ]
                ],
                [
                    /miuibrowser\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "MIUI " + m
                    ]
                ],
                [
                    /fxios\/([-\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        M
                    ]
                ],
                [
                    /\bqihu|(qi?ho?o?|360)browser/i
                ],
                [
                    [
                        n,
                        "360 " + m
                    ]
                ],
                [
                    /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
                ],
                [
                    [
                        n,
                        /(.+)/,
                        "$1 " + m
                    ],
                    t
                ],
                [
                    /(comodo_dragon)\/([\w\.]+)/i
                ],
                [
                    [
                        n,
                        /_/g,
                        " "
                    ],
                    t
                ],
                [
                    /(electron)\/([\w\.]+) safari/i,
                    /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                    /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
                ],
                [
                    n,
                    t
                ],
                [
                    /(metasr)[\/ ]?([\w\.]+)/i,
                    /(lbbrowser)/i,
                    /\[(linkedin)app\]/i
                ],
                [
                    n
                ],
                [
                    /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                ],
                [
                    [
                        n,
                        le
                    ],
                    t
                ],
                [
                    /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                    /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                    /safari (line)\/([\w\.]+)/i,
                    /\b(line)\/([\w\.]+)\/iab/i,
                    /(chromium|instagram)[\/ ]([-\w\.]+)/i
                ],
                [
                    n,
                    t
                ],
                [
                    /\bgsa\/([\w\.]+) .*safari\//i
                ],
                [
                    t,
                    [
                        n,
                        "GSA"
                    ]
                ],
                [
                    /headlesschrome(?:\/([\w\.]+)| )/i
                ],
                [
                    t,
                    [
                        n,
                        k + " Headless"
                    ]
                ],
                [
                    / wv\).+(chrome)\/([\w\.]+)/i
                ],
                [
                    [
                        n,
                        k + " WebView"
                    ],
                    t
                ],
                [
                    /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                ],
                [
                    t,
                    [
                        n,
                        "Android " + m
                    ]
                ],
                [
                    /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                ],
                [
                    n,
                    t
                ],
                [
                    /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
                ],
                [
                    t,
                    [
                        n,
                        "Mobile Safari"
                    ]
                ],
                [
                    /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
                ],
                [
                    t,
                    n
                ],
                [
                    /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                ],
                [
                    n,
                    [
                        t,
                        ne,
                        Re
                    ]
                ],
                [
                    /(webkit|khtml)\/([\w\.]+)/i
                ],
                [
                    n,
                    t
                ],
                [
                    /(navigator|netscape\d?)\/([-\w\.]+)/i
                ],
                [
                    [
                        n,
                        "Netscape"
                    ],
                    t
                ],
                [
                    /mobile vr; rv:([\w\.]+)\).+firefox/i
                ],
                [
                    t,
                    [
                        n,
                        M + " Reality"
                    ]
                ],
                [
                    /ekiohf.+(flow)\/([\w\.]+)/i,
                    /(swiftfox)/i,
                    /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                    /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                    /(firefox)\/([\w\.]+)/i,
                    /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                    /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                    /(links) \(([\w\.]+)/i,
                    /panasonic;(viera)/i
                ],
                [
                    n,
                    t
                ],
                [
                    /(cobalt)\/([\w\.]+)/i
                ],
                [
                    n,
                    [
                        t,
                        /master.|lts./,
                        ""
                    ]
                ]
            ],
            cpu: [
                [
                    /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                ],
                [
                    [
                        A,
                        "amd64"
                    ]
                ],
                [
                    /(ia32(?=;))/i
                ],
                [
                    [
                        A,
                        W
                    ]
                ],
                [
                    /((?:i[346]|x)86)[;\)]/i
                ],
                [
                    [
                        A,
                        "ia32"
                    ]
                ],
                [
                    /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                ],
                [
                    [
                        A,
                        "arm64"
                    ]
                ],
                [
                    /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                ],
                [
                    [
                        A,
                        "armhf"
                    ]
                ],
                [
                    /windows (ce|mobile); ppc;/i
                ],
                [
                    [
                        A,
                        "arm"
                    ]
                ],
                [
                    /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                ],
                [
                    [
                        A,
                        /ower/,
                        v,
                        W
                    ]
                ],
                [
                    /(sun4\w)[;\)]/i
                ],
                [
                    [
                        A,
                        "sparc"
                    ]
                ],
                [
                    /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                ],
                [
                    [
                        A,
                        W
                    ]
                ]
            ],
            device: [
                [
                    /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                ],
                [
                    o,
                    [
                        i,
                        Q
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                    /samsung[- ]([-\w]+)/i,
                    /sec-(sgh\w+)/i
                ],
                [
                    o,
                    [
                        i,
                        Q
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\((ip(?:hone|od)[\w ]*);/i
                ],
                [
                    o,
                    [
                        i,
                        a
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\((ipad);[-\w\),; ]+apple/i,
                    /applecoremedia\/[\w\.]+ \((ipad)/i,
                    /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                ],
                [
                    o,
                    [
                        i,
                        a
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /(macintosh);/i
                ],
                [
                    o,
                    [
                        i,
                        a
                    ]
                ],
                [
                    /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                ],
                [
                    o,
                    [
                        i,
                        se
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                ],
                [
                    o,
                    [
                        i,
                        re
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /(?:huawei|honor)([-\w ]+)[;\)]/i,
                    /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
                ],
                [
                    o,
                    [
                        i,
                        re
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b(poco[\w ]+)(?: bui|\))/i,
                    /\b; (\w+) build\/hm\1/i,
                    /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                    /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                    /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                ],
                [
                    [
                        o,
                        /_/g,
                        " "
                    ],
                    [
                        i,
                        ee
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                ],
                [
                    [
                        o,
                        /_/g,
                        " "
                    ],
                    [
                        i,
                        ee
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /; (\w+) bui.+ oppo/i,
                    /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                ],
                [
                    o,
                    [
                        i,
                        "OPPO"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /vivo (\w+)(?: bui|\))/i,
                    /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                ],
                [
                    o,
                    [
                        i,
                        "Vivo"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b(rmx[12]\d{3})(?: bui|;|\))/i
                ],
                [
                    o,
                    [
                        i,
                        "Realme"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                    /\bmot(?:orola)?[- ](\w*)/i,
                    /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                ],
                [
                    o,
                    [
                        i,
                        ae
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                ],
                [
                    o,
                    [
                        i,
                        ae
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                ],
                [
                    o,
                    [
                        i,
                        J
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                    /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                    /\blg-?([\d\w]+) bui/i
                ],
                [
                    o,
                    [
                        i,
                        J
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /(ideatab[-\w ]+)/i,
                    /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                ],
                [
                    o,
                    [
                        i,
                        "Lenovo"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /(?:maemo|nokia).*(n900|lumia \d+)/i,
                    /nokia[-_ ]?([-\w\.]*)/i
                ],
                [
                    [
                        o,
                        /_/g,
                        " "
                    ],
                    [
                        i,
                        "Nokia"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /(pixel c)\b/i
                ],
                [
                    o,
                    [
                        i,
                        F
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                ],
                [
                    o,
                    [
                        i,
                        F
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                ],
                [
                    o,
                    [
                        i,
                        G
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /sony tablet [ps]/i,
                    /\b(?:sony)?sgp\w+(?: bui|\))/i
                ],
                [
                    [
                        o,
                        "Xperia Tablet"
                    ],
                    [
                        i,
                        G
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    / (kb2005|in20[12]5|be20[12][59])\b/i,
                    /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                ],
                [
                    o,
                    [
                        i,
                        "OnePlus"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /(alexa)webm/i,
                    /(kf[a-z]{2}wi)( bui|\))/i,
                    /(kf[a-z]+)( bui|\)).+silk\//i
                ],
                [
                    o,
                    [
                        i,
                        D
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                ],
                [
                    [
                        o,
                        /(.+)/g,
                        "Fire Phone $1"
                    ],
                    [
                        i,
                        D
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /(playbook);[-\w\),; ]+(rim)/i
                ],
                [
                    o,
                    i,
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b((?:bb[a-f]|st[hv])100-\d)/i,
                    /\(bb10; (\w+)/i
                ],
                [
                    o,
                    [
                        i,
                        s
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                ],
                [
                    o,
                    [
                        i,
                        u
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                ],
                [
                    o,
                    [
                        i,
                        u
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /(nexus 9)/i
                ],
                [
                    o,
                    [
                        i,
                        "HTC"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                    /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                    /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
                ],
                [
                    i,
                    [
                        o,
                        /_/g,
                        " "
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                ],
                [
                    o,
                    [
                        i,
                        "Acer"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /droid.+; (m[1-5] note) bui/i,
                    /\bmz-([-\w]{2,})/i
                ],
                [
                    o,
                    [
                        i,
                        "Meizu"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                    /(hp) ([\w ]+\w)/i,
                    /(asus)-?(\w+)/i,
                    /(microsoft); (lumia[\w ]+)/i,
                    /(lenovo)[-_ ]?([-\w]+)/i,
                    /(jolla)/i,
                    /(oppo) ?([\w ]+) bui/i
                ],
                [
                    i,
                    o,
                    [
                        e,
                        d
                    ]
                ],
                [
                    /(kobo)\s(ereader|touch)/i,
                    /(archos) (gamepad2?)/i,
                    /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                    /(kindle)\/([\w\.]+)/i,
                    /(nook)[\w ]+build\/(\w+)/i,
                    /(dell) (strea[kpr\d ]*[\dko])/i,
                    /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                    /(trinity)[- ]*(t\d{3}) bui/i,
                    /(gigaset)[- ]+(q\w{1,9}) bui/i,
                    /(vodafone) ([\w ]+)(?:\)| bui)/i
                ],
                [
                    i,
                    o,
                    [
                        e,
                        b
                    ]
                ],
                [
                    /(surface duo)/i
                ],
                [
                    o,
                    [
                        i,
                        K
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /droid [\d\.]+; (fp\du?)(?: b|\))/i
                ],
                [
                    o,
                    [
                        i,
                        "Fairphone"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /(u304aa)/i
                ],
                [
                    o,
                    [
                        i,
                        "AT&T"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\bsie-(\w*)/i
                ],
                [
                    o,
                    [
                        i,
                        "Siemens"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b(rct\w+) b/i
                ],
                [
                    o,
                    [
                        i,
                        "RCA"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b(venue[\d ]{2,7}) b/i
                ],
                [
                    o,
                    [
                        i,
                        "Dell"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b(q(?:mv|ta)\w+) b/i
                ],
                [
                    o,
                    [
                        i,
                        "Verizon"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                ],
                [
                    o,
                    [
                        i,
                        "Barnes & Noble"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b(tm\d{3}\w+) b/i
                ],
                [
                    o,
                    [
                        i,
                        "NuVision"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b(k88) b/i
                ],
                [
                    o,
                    [
                        i,
                        "ZTE"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b(nx\d{3}j) b/i
                ],
                [
                    o,
                    [
                        i,
                        "ZTE"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b(gen\d{3}) b.+49h/i
                ],
                [
                    o,
                    [
                        i,
                        "Swiss"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b(zur\d{3}) b/i
                ],
                [
                    o,
                    [
                        i,
                        "Swiss"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b((zeki)?tb.*\b) b/i
                ],
                [
                    o,
                    [
                        i,
                        "Zeki"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b([yr]\d{2}) b/i,
                    /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                ],
                [
                    [
                        i,
                        "Dragon Touch"
                    ],
                    o,
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b(ns-?\w{0,9}) b/i
                ],
                [
                    o,
                    [
                        i,
                        "Insignia"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b((nxa|next)-?\w{0,9}) b/i
                ],
                [
                    o,
                    [
                        i,
                        "NextBook"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                ],
                [
                    [
                        i,
                        "Voice"
                    ],
                    o,
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b(lvtel\-)?(v1[12]) b/i
                ],
                [
                    [
                        i,
                        "LvTel"
                    ],
                    o,
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b(ph-1) /i
                ],
                [
                    o,
                    [
                        i,
                        "Essential"
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /\b(v(100md|700na|7011|917g).*\b) b/i
                ],
                [
                    o,
                    [
                        i,
                        "Envizen"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b(trio[-\w\. ]+) b/i
                ],
                [
                    o,
                    [
                        i,
                        "MachSpeed"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\btu_(1491) b/i
                ],
                [
                    o,
                    [
                        i,
                        "Rotor"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /(shield[\w ]+) b/i
                ],
                [
                    o,
                    [
                        i,
                        "Nvidia"
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /(sprint) (\w+)/i
                ],
                [
                    i,
                    o,
                    [
                        e,
                        d
                    ]
                ],
                [
                    /(kin\.[onetw]{3})/i
                ],
                [
                    [
                        o,
                        /\./g,
                        " "
                    ],
                    [
                        i,
                        K
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                ],
                [
                    o,
                    [
                        i,
                        ie
                    ],
                    [
                        e,
                        b
                    ]
                ],
                [
                    /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                ],
                [
                    o,
                    [
                        i,
                        ie
                    ],
                    [
                        e,
                        d
                    ]
                ],
                [
                    /smart-tv.+(samsung)/i
                ],
                [
                    i,
                    [
                        e,
                        C
                    ]
                ],
                [
                    /hbbtv.+maple;(\d+)/i
                ],
                [
                    [
                        o,
                        /^/,
                        "SmartTV"
                    ],
                    [
                        i,
                        Q
                    ],
                    [
                        e,
                        C
                    ]
                ],
                [
                    /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                ],
                [
                    [
                        i,
                        J
                    ],
                    [
                        e,
                        C
                    ]
                ],
                [
                    /(apple) ?tv/i
                ],
                [
                    i,
                    [
                        o,
                        a + " TV"
                    ],
                    [
                        e,
                        C
                    ]
                ],
                [
                    /crkey/i
                ],
                [
                    [
                        o,
                        k + "cast"
                    ],
                    [
                        i,
                        F
                    ],
                    [
                        e,
                        C
                    ]
                ],
                [
                    /droid.+aft(\w)( bui|\))/i
                ],
                [
                    o,
                    [
                        i,
                        D
                    ],
                    [
                        e,
                        C
                    ]
                ],
                [
                    /\(dtv[\);].+(aquos)/i,
                    /(aquos-tv[\w ]+)\)/i
                ],
                [
                    o,
                    [
                        i,
                        se
                    ],
                    [
                        e,
                        C
                    ]
                ],
                [
                    /(bravia[\w ]+)( bui|\))/i
                ],
                [
                    o,
                    [
                        i,
                        G
                    ],
                    [
                        e,
                        C
                    ]
                ],
                [
                    /(mitv-\w{5}) bui/i
                ],
                [
                    o,
                    [
                        i,
                        ee
                    ],
                    [
                        e,
                        C
                    ]
                ],
                [
                    /Hbbtv.*(technisat) (.*);/i
                ],
                [
                    i,
                    o,
                    [
                        e,
                        C
                    ]
                ],
                [
                    /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                    /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
                ],
                [
                    [
                        i,
                        oe
                    ],
                    [
                        o,
                        oe
                    ],
                    [
                        e,
                        C
                    ]
                ],
                [
                    /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                ],
                [
                    [
                        e,
                        C
                    ]
                ],
                [
                    /(ouya)/i,
                    /(nintendo) ([wids3utch]+)/i
                ],
                [
                    i,
                    o,
                    [
                        e,
                        P
                    ]
                ],
                [
                    /droid.+; (shield) bui/i
                ],
                [
                    o,
                    [
                        i,
                        "Nvidia"
                    ],
                    [
                        e,
                        P
                    ]
                ],
                [
                    /(playstation [345portablevi]+)/i
                ],
                [
                    o,
                    [
                        i,
                        G
                    ],
                    [
                        e,
                        P
                    ]
                ],
                [
                    /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                ],
                [
                    o,
                    [
                        i,
                        K
                    ],
                    [
                        e,
                        P
                    ]
                ],
                [
                    /((pebble))app/i
                ],
                [
                    i,
                    o,
                    [
                        e,
                        B
                    ]
                ],
                [
                    /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
                ],
                [
                    o,
                    [
                        i,
                        a
                    ],
                    [
                        e,
                        B
                    ]
                ],
                [
                    /droid.+; (glass) \d/i
                ],
                [
                    o,
                    [
                        i,
                        F
                    ],
                    [
                        e,
                        B
                    ]
                ],
                [
                    /droid.+; (wt63?0{2,3})\)/i
                ],
                [
                    o,
                    [
                        i,
                        ie
                    ],
                    [
                        e,
                        B
                    ]
                ],
                [
                    /(quest( 2| pro)?)/i
                ],
                [
                    o,
                    [
                        i,
                        le
                    ],
                    [
                        e,
                        B
                    ]
                ],
                [
                    /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                ],
                [
                    i,
                    [
                        e,
                        $
                    ]
                ],
                [
                    /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
                ],
                [
                    o,
                    [
                        e,
                        d
                    ]
                ],
                [
                    /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                ],
                [
                    o,
                    [
                        e,
                        b
                    ]
                ],
                [
                    /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                ],
                [
                    [
                        e,
                        b
                    ]
                ],
                [
                    /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
                ],
                [
                    [
                        e,
                        d
                    ]
                ],
                [
                    /(android[-\w\. ]{0,9});.+buil/i
                ],
                [
                    o,
                    [
                        i,
                        "Generic"
                    ]
                ]
            ],
            engine: [
                [
                    /windows.+ edge\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        _ + "HTML"
                    ]
                ],
                [
                    /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "Blink"
                    ]
                ],
                [
                    /(presto)\/([\w\.]+)/i,
                    /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                    /ekioh(flow)\/([\w\.]+)/i,
                    /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                    /(icab)[\/ ]([23]\.[\d\.]+)/i
                ],
                [
                    n,
                    t
                ],
                [
                    /rv\:([\w\.]{1,9})\b.+(gecko)/i
                ],
                [
                    t,
                    n
                ]
            ],
            os: [
                [
                    /microsoft (windows) (vista|xp)/i
                ],
                [
                    n,
                    t
                ],
                [
                    /(windows) nt 6\.2; (arm)/i,
                    /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                    /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
                ],
                [
                    n,
                    [
                        t,
                        ne,
                        de
                    ]
                ],
                [
                    /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                ],
                [
                    [
                        n,
                        "Windows"
                    ],
                    [
                        t,
                        ne,
                        de
                    ]
                ],
                [
                    /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                    /cfnetwork\/.+darwin/i
                ],
                [
                    [
                        t,
                        /_/g,
                        "."
                    ],
                    [
                        n,
                        "iOS"
                    ]
                ],
                [
                    /(mac os x) ?([\w\. ]*)/i,
                    /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                ],
                [
                    [
                        n,
                        ue
                    ],
                    [
                        t,
                        /_/g,
                        "."
                    ]
                ],
                [
                    /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
                ],
                [
                    t,
                    n
                ],
                [
                    /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                    /(blackberry)\w*\/([\w\.]*)/i,
                    /(tizen|kaios)[\/ ]([\w\.]+)/i,
                    /\((series40);/i
                ],
                [
                    n,
                    t
                ],
                [
                    /\(bb(10);/i
                ],
                [
                    t,
                    [
                        n,
                        s
                    ]
                ],
                [
                    /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                ],
                [
                    t,
                    [
                        n,
                        "Symbian"
                    ]
                ],
                [
                    /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        M + " OS"
                    ]
                ],
                [
                    /web0s;.+rt(tv)/i,
                    /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "webOS"
                    ]
                ],
                [
                    /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        "watchOS"
                    ]
                ],
                [
                    /crkey\/([\d\.]+)/i
                ],
                [
                    t,
                    [
                        n,
                        k + "cast"
                    ]
                ],
                [
                    /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
                ],
                [
                    [
                        n,
                        ce
                    ],
                    t
                ],
                [
                    /panasonic;(viera)/i,
                    /(netrange)mmh/i,
                    /(nettv)\/(\d+\.[\w\.]+)/i,
                    /(nintendo|playstation) ([wids345portablevuch]+)/i,
                    /(xbox); +xbox ([^\);]+)/i,
                    /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                    /(mint)[\/\(\) ]?(\w*)/i,
                    /(mageia|vectorlinux)[; ]/i,
                    /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                    /(hurd|linux) ?([\w\.]*)/i,
                    /(gnu) ?([\w\.]*)/i,
                    /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                    /(haiku) (\w+)/i
                ],
                [
                    n,
                    t
                ],
                [
                    /(sunos) ?([\w\.\d]*)/i
                ],
                [
                    [
                        n,
                        "Solaris"
                    ],
                    t
                ],
                [
                    /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                    /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                    /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
                    /(unix) ?([\w\.]*)/i
                ],
                [
                    n,
                    t
                ]
            ]
        }, E = function(w, p) {
            if (typeof w === x && (p = w, w = c), !(this instanceof E)) return new E(w, p).getResult();
            var l = typeof h !== O && h.navigator ? h.navigator : c, g = w || (l && l.userAgent ? l.userAgent : v), N = l && l.userAgentData ? l.userAgentData : c, R = p ? _e(we, p) : we;
            return this.getBrowser = function() {
                var r = {};
                return r[n] = c, r[t] = c, q.call(r, g, R.browser), r[f] = Me(r[t]), l && l.brave && typeof l.brave.isBrave == T && (r[n] = "Brave"), r;
            }, this.getCPU = function() {
                var r = {};
                return r[A] = c, q.call(r, g, R.cpu), r;
            }, this.getDevice = function() {
                var r = {};
                return r[i] = c, r[o] = c, r[e] = c, q.call(r, g, R.device), !r[e] && N && N.mobile && (r[e] = d), r[o] == "Macintosh" && l && typeof l.standalone !== O && l.maxTouchPoints && l.maxTouchPoints > 2 && (r[o] = "iPad", r[e] = b), r;
            }, this.getEngine = function() {
                var r = {};
                return r[n] = c, r[t] = c, q.call(r, g, R.engine), r;
            }, this.getOS = function() {
                var r = {};
                return r[n] = c, r[t] = c, q.call(r, g, R.os), !r[n] && N && N.platform != "Unknown" && (r[n] = N.platform.replace(/chrome os/i, ce).replace(/macos/i, ue)), r;
            }, this.getResult = function() {
                return {
                    ua: this.getUA(),
                    browser: this.getBrowser(),
                    engine: this.getEngine(),
                    os: this.getOS(),
                    device: this.getDevice(),
                    cpu: this.getCPU()
                };
            }, this.getUA = function() {
                return g;
            }, this.setUA = function(r) {
                return g = typeof r === S && r.length > j ? oe(r, j) : r, this;
            }, this.setUA(g), this;
        };
        E.VERSION = I, E.BROWSER = Y([
            n,
            t,
            f
        ]), E.CPU = Y([
            A
        ]), E.DEVICE = Y([
            o,
            i,
            e,
            P,
            d,
            C,
            b,
            B,
            $
        ]), E.ENGINE = E.OS = Y([
            n,
            t
        ]), typeof V !== O ? (typeof X !== O && X.exports && (V = X.exports = E), V.UAParser = E) : typeof define === T && define.amd ? define(function() {
            return E;
        }) : typeof h !== O && (h.UAParser = E);
        var L = typeof h !== O && (h.jQuery || h.Zepto);
        if (L && !L.ua) {
            var Z = new E;
            L.ua = Z.getResult(), L.ua.get = function() {
                return Z.getUA();
            }, L.ua.set = function(w) {
                Z.setUA(w);
                var p = Z.getResult();
                for(var l in p)L.ua[l] = p[l];
            };
        }
    })(typeof window == "object" ? window : V);
});
var $08663c8936fe6aaa$var$Ee = (0, $9aa2b00a42a878e2$export$8b22cf2602fb60ce)($08663c8936fe6aaa$var$Oe(), 1), $08663c8936fe6aaa$var$Te = (0, $9aa2b00a42a878e2$export$8b22cf2602fb60ce)($08663c8936fe6aaa$var$Ce(), 1);
var $08663c8936fe6aaa$export$407448d2b89b1813;
((D)=>{
    let h;
    function c$1() {
        return h == null && (h = new $08663c8936fe6aaa$var$Te.default(navigator.userAgent)), h;
    }
    D.getUserAgentInfo = c$1;
    function I() {
        var s;
        if ("orientation" in window) return !1;
        let a = "(any-pointer: coarse)", u = (s = window.matchMedia) == null ? void 0 : s.call(window, a);
        return navigator.maxTouchPoints === 0 || (u == null ? void 0 : u.media) === a && !(u != null && u.matches);
    }
    D.isDesktopDevice = I;
    function v() {
        return c$1().getDevice().model === "iPhone";
    }
    D.isIPhone = v;
    function y() {
        let a = c$1().getOS();
        return a.name === "iOS" && a.version != null && a.version.localeCompare("16.3", void 0, {
            numeric: !0
        }) >= 0;
    }
    D.isIOSDeviceWithExtendedCameraAccess = y;
    function T() {
        return "document" in window ? window.document.createElement("canvas") : null;
    }
    D.getCanvas = T;
    function O(a) {
        return a.name === "iOS" && a.version != null && [
            "11.2.2",
            "11.2.5",
            "11.2.6"
        ].includes(a.version);
    }
    async function x() {
        return (0, $73362e49aa734db9$export$db3b6bfb95261072)();
    }
    D.hasSIMDSupport = x;
    async function S() {
        return (0, $73362e49aa734db9$export$4368d992c4eafac0)();
    }
    D.hasThreadsSupport = S;
    function f(a, u, s) {
        let m = a[u[0]];
        return m == null ? !1 : u.length === 1 ? typeof m === s : (typeof m == "function" || typeof m == "object") && f(m, u.slice(1), s);
    }
    function o() {
        var _;
        let a = !0, u = null, s = null, m = null, k = null;
        try {
            if (u = D.getCanvas(), s = D.getCanvas(), m = u == null ? void 0 : u.getContext("webgl"), k = s == null ? void 0 : s.getContext("experimental-webgl"), !f(window, [
                "WebGLRenderingContext"
            ], "function") || m == null && k == null) throw new Error("WebGLRenderingContext is not supported");
        } catch (M) {
            a = !1;
        } finally{
            for (let M of [
                m,
                k
            ])typeof (M == null ? void 0 : M.getExtension) == "function" && ((_ = M.getExtension("WEBGL_lose_context")) == null || _.loseContext());
            m = null, k = null, u = null, s = null;
        }
        return a;
    }
    function n() {
        let a = !0, u = !0, s = new Set;
        location.protocol.startsWith("http") || s.add("httpProtocol"), f(window, [
            "isSecureContext"
        ], "boolean") && !window.isSecureContext && s.add("secureContext"), !f(navigator, [
            "mediaDevices",
            "getUserMedia"
        ], "function") && !f(navigator, [
            "enumerateDevices"
        ], "function") && !f(window, [
            "MediaStreamTrack",
            "getSources"
        ], "function") && (s.add("mediaDevices"), a = !1), f(window, [
            "Worker"
        ], "function") || (s.add("webWorkers"), a = !1, u = !1), f(window, [
            "WebAssembly"
        ], "object") || (s.add("webAssembly"), a = !1, u = !1), f(window, [
            "Blob"
        ], "function") || (s.add("blob"), a = !1, u = !1), f(window, [
            "URL",
            "createObjectURL"
        ], "function") || (s.add("urlObject"), a = !1, u = !1), f(window, [
            "OffscreenCanvas"
        ], "function") || s.add("offscreenCanvas"), o() || s.add("webGL");
        let m = c$1().getOS();
        return O(m) && (s.add("webAssemblyErrorFree"), a = !1, u = !1), (0, $73362e49aa734db9$export$8b22cf2602fb60ce)() || s.add("sharedArrayBuffer"), (0, $73362e49aa734db9$export$407448d2b89b1813)() || s.add("crossOriginIsolated"), {
            fullSupport: a,
            scannerSupport: u,
            missingFeatures: [
                ...s
            ]
        };
    }
    D.checkBrowserCompatibility = n;
    async function e$1() {
        return (0, $73362e49aa734db9$export$f1e1789686576879)();
    }
    D.checkMultithreadingSupport = e$1;
    function i() {
        let a = "scandit-device-id", u = "localStorage" in globalThis ? globalThis.localStorage : void 0;
        if (!u) return "";
        let s = u.getItem(a);
        if (s != null && s !== "") return s;
        if (s = (0, $08663c8936fe6aaa$var$Ee.get)(a), s != null && s !== "") return u.setItem(a, s), s;
        let m = new Uint8Array(20);
        return crypto.getRandomValues(m), s = [
            ...m
        ].map((k)=>{
            let _ = k.toString(16);
            return _.length === 1 ? `0${_}` : _;
        }).join(""), u.setItem(a, s), s;
    }
    D.getDeviceId = i;
    function t(a) {
        return a instanceof HTMLElement || a != null && typeof a == "object" && typeof a.tagName == "string";
    }
    D.isValidHTMLElement = t;
    function A() {
        var m, k;
        let a = c$1().getOS();
        if (a.name !== "iOS") return !0;
        let [u, s] = (k = (m = a.version) == null ? void 0 : m.split(".").map(Number)) != null ? k : [];
        return u > 14 || u === 14 && s >= 6;
    }
    D.isSupportedIOSVersion = A;
    function P() {
        var s, m, k, _;
        let a = /iphone|ipod|ipad/.test((m = (s = c$1().getDevice().model) == null ? void 0 : s.toLowerCase()) != null ? m : ""), u = (_ = (k = c$1().getBrowser().name) == null ? void 0 : k.toLowerCase().includes("safari")) != null ? _ : !1;
        return a && !u;
    }
    D.isIosWebView = P;
    async function d$1() {
        var u;
        return ((u = c$1().getOS().name) == null ? void 0 : u.toLowerCase()) !== "android" ? !1 : c$1().getUA().includes("wv") ? !0 : [
            ...(await fetch(document.location.toString(), {
                method: "HEAD"
            })).headers
        ].some(([s])=>s.toLowerCase() === "x-requested-with");
    }
    D.isAndroidWebView = d$1;
    function b() {
        return c$1().getOS().name === "Windows";
    }
    D.isWindows = b;
    function C() {
        return c$1().getBrowser().name === "Firefox";
    }
    D.isFirefox = C;
    function B() {
        for (let a of [
            "vibrate",
            "webkitVibrate",
            "msVibrate",
            "mozVibrate"
        ])if (typeof navigator[a] == "function") return navigator[a];
    }
    D.getSupportedVibrationMethod = B;
    function $() {
        return B() != null && !I() && !b() && !C();
    }
    D.isVibrationAvailable = $;
    function j() {
        return c$1().getOS().name === "iOS";
    }
    D.isIOS = j;
})($08663c8936fe6aaa$export$407448d2b89b1813 || ($08663c8936fe6aaa$export$407448d2b89b1813 = {}));


var $fa51dabf90952f18$export$407448d2b89b1813 = ((C)=>(C.WorldFacing = "worldFacing", C.UserFacing = "userFacing", C))($fa51dabf90952f18$export$407448d2b89b1813 || {}), $fa51dabf90952f18$export$8b22cf2602fb60ce = ((c)=>(c[c.ULTRA_HD = 0] = "ULTRA_HD", c[c.FULL_HD = 1] = "FULL_HD", c[c.HD = 2] = "HD", c[c.SD = 3] = "SD", c[c.NONE = 4] = "NONE", c))($fa51dabf90952f18$export$8b22cf2602fb60ce || {}), $fa51dabf90952f18$export$db3b6bfb95261072 = ((v)=>(v.AUTO = "auto", v.FOUR_TO_THREE = "fourToThree", v.SIXTEEN_TO_NINE = "sixteenToNine", v))($fa51dabf90952f18$export$db3b6bfb95261072 || {}), $fa51dabf90952f18$export$4368d992c4eafac0;
((l)=>{
    let U = new Map([
        [
            "DeviceCaptureError",
            "AbortError"
        ],
        [
            "NotSupportedError",
            "AbortError"
        ],
        [
            "ScreenCaptureError",
            "AbortError"
        ],
        [
            "TabCaptureError",
            "AbortError"
        ],
        [
            "TypeError",
            "AbortError"
        ],
        [
            "InvalidStateError",
            "NotAllowedError"
        ],
        [
            "MediaDeviceFailedDueToShutdown",
            "NotAllowedError"
        ],
        [
            "MediaDeviceKillSwitchOn",
            "NotAllowedError"
        ],
        [
            "PermissionDeniedError",
            "NotAllowedError"
        ],
        [
            "PermissionDismissedError",
            "NotAllowedError"
        ],
        [
            "DevicesNotFoundError",
            "NotFoundError"
        ],
        [
            "SourceUnavailableError",
            "NotReadableError"
        ],
        [
            "TrackStartError",
            "NotReadableError"
        ],
        [
            "ConstraintNotSatisfiedError",
            "OverconstrainedError"
        ]
    ]), P = [
        "rear",
        "back",
        "r\xfcck",
        "arri\xe8re",
        "trasera",
        "tr\xe1s",
        "traseira",
        "posteriore",
        "\u540E\u9762",
        "\u5F8C\u9762",
        "\u80CC\u9762",
        "\u540E\u7F6E",
        "\u5F8C\u7F6E",
        "\u80CC\u7F6E",
        "\u0437\u0430\u0434\u043D\u0435\u0439",
        "\u0627\u0644\u062E\u0644\u0641\u064A\u0629",
        "\uD6C4",
        "arka",
        "achterzijde",
        "\u0E2B\u0E25\u0E31\u0E07",
        "baksidan",
        "bagside",
        "sau",
        "bak",
        "tylny",
        "takakamera",
        "belakang",
        "\u05D0\u05D7\u05D5\u05E8\u05D9\u05EA",
        "\u03C0\u03AF\u03C3\u03C9",
        "spate",
        "h\xe1ts\xf3",
        "zadn\xed",
        "darrere",
        "posterior",
        "zadn\xe1",
        "\u0437\u0430\u0434\u043D\u044F",
        "stra\u017Enja",
        "belakang",
        "\u092C\u0948\u0915"
    ], C = new Set([
        "Desk View Camera",
        "Schreibtischansicht-Kamera",
        "Cam\xe9ra Desk\xa0View",
        "C\xe1mara de Vista Cenital",
        "C\xe2mara da Vista de Secret\xe1ria",
        "Fotocamera di Panoramica Scrivania",
        "\u684C\u4E0A\u89C6\u89D2\u76F8\u673A",
        "\u30C7\u30B9\u30AF\u30D3\u30E5\u30FC\u30AB\u30E1\u30E9",
        "\u041A\u0430\u043C\u0435\u0440\u0430 \u041E\u0431\u0437\u043E\u0440\u0430 \u0441\u0442\u043E\u043B\u0430",
        "Masa G\xf6r\xfcnt\xfcs\xfc Kameras\u0131",
        "Bureauweergave-camera",
        "\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0631\u0623\u0633\u064A",
        "\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E14\u0E39\u0E14\u0E49\u0E32\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E15\u0E4A\u0E30",
        "Bordsvisningskamera",
        "Kamera til Visning af skrivebord",
        "Camera Desk View",
        "Bordvisning-kamera",
        "Kamera w\xa0aplikacji Widok blatu",
        "Ty\xf6p\xf6yt\xe4n\xe4kym\xe4n kamera",
        "Kamera Tampilan Meja",
        "\u05DE\u05E6\u05DC\u05DE\u05EA \u05F4\u05EA\u05E6\u05D5\u05D2\u05EA \u05E9\u05D5\u05DC\u05D7\u05DF\u05F4",
        "\u039A\u03AC\u03BC\u03B5\u03C1\u03B1 \u03C4\u03B7\u03C2 \u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE\u03C2 \u03B3\u03C1\u03B1\u03C6\u03B5\u03AF\u03BF\u03C5",
        "Camer\u0103 Vizualizare birou",
        "\xcdr\xf3asztal n\xe9zet kamer\xe1ja",
        "Stoln\xed kamera",
        "C\xe0mera de l\u2019app Vista de l\u2019Escriptori"
    ]), v = new Set([
        "Front Camera",
        "Frontkamera",
        "Appareil photo avant",
        "C\xe1mara frontal",
        "C\xe2mera Frontal",
        "C\xe2mara frontal",
        "Fotocamera (anteriore)",
        "\u524D\u7F6E\u76F8\u673A",
        "\u524D\u7F6E\u76F8\u6A5F",
        "\u524D\u9762\u30AB\u30E1\u30E9",
        "\u041A\u0430\u043C\u0435\u0440\u0430 \u043D\u0430 \u043F\u0435\u0440\u0435\u0434\u043D\u0435\u0439 \u043F\u0430\u043D\u0435\u043B\u0438",
        "\xd6n Kamera",
        "Camera aan voorzijde",
        "\u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0623\u0645\u0627\u0645\u064A\u0629",
        "\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E14\u0E49\u0E32\u0E19\u0E2B\u0E19\u0E49\u0E32",
        "Kamera p\xe5 framsidan",
        "Forsidekamera",
        "Camera m\u1EB7t tr\u01B0\u1EDBc",
        "Kamera foran",
        "Przedni aparat",
        "Etukamera",
        "Kamera Depan",
        "\u05DE\u05E6\u05DC\u05DE\u05D4 \u05E7\u05D3\u05DE\u05D9\u05EA",
        "\u039C\u03C0\u03C1\u03BF\u03C3\u03C4\u03B9\u03BD\u03AE \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1",
        "Camer\u0103 fa\u021B\u0103",
        "El\xfcls\u0151 kamera",
        "P\u0159edn\xed fotoapar\xe1t",
        "C\xe0mera frontal",
        "Predn\xe1 kamera",
        "\u041F\u0435\u0440\u0435\u0434\u043D\u044F \u043A\u0430\u043C\u0435\u0440\u0430",
        "Prednja kamera",
        "Kamera Depan",
        "\u092B\u093C\u094D\u0930\u0902\u091F \u0915\u0948\u092E\u0930\u093E"
    ]), x = new Set([
        "Back Camera",
        "R\xfcckkamera",
        "Cam\xe9ra arri\xe8re",
        "C\xe1mara trasera",
        "C\xe2mera Traseira",
        "C\xe2mara traseira",
        "Fotocamera (posteriore)",
        "\u540E\u7F6E\u76F8\u673A",
        "\u5F8C\u7F6E\u76F8\u6A5F",
        "\u80CC\u9762\u30AB\u30E1\u30E9",
        "\u041A\u0430\u043C\u0435\u0440\u0430 \u043D\u0430 \u0437\u0430\u0434\u043D\u0435\u0439 \u043F\u0430\u043D\u0435\u043B\u0438",
        "Arka Kamera",
        "Camera aan achterzijde",
        "\u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u062E\u0644\u0641\u064A\u0629",
        "\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E14\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "Kamera p\xe5 baksidan",
        "Bagsidekamera",
        "Camera m\u1EB7t sau",
        "Kamera bak",
        "Tylny aparat",
        "Takakamera",
        "Kamera Belakang",
        "\u05DE\u05E6\u05DC\u05DE\u05D4 \u05D0\u05D7\u05D5\u05E8\u05D9\u05EA",
        "\u03A0\u03AF\u03C3\u03C9 \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1",
        "Camer\u0103 spate",
        "H\xe1ts\xf3 kamera",
        "Zadn\xed fotoapar\xe1t",
        "C\xe0mera posterior",
        "Zadn\xe1 kamera",
        "\u0417\u0430\u0434\u043D\u044F \u043A\u0430\u043C\u0435\u0440\u0430",
        "Stra\u017Enja kamera",
        "Kamera Belakang",
        "\u092C\u0948\u0915 \u0915\u0948\u092E\u0930\u093E"
    ]), c = new Set([
        "Back Dual Wide Camera",
        "R\xfcckseitige Dual-Weitwinkelkamera",
        "Double appareil photo grand angle arri\xe8re",
        "C\xe1mara trasera dual con gran angular",
        "C\xe2mera Dupla Grande-Angular Traseira",
        "C\xe2mara grande angular dupla traseira",
        "Fotocamera doppia con grandangolo (posteriore)",
        "\u540E\u7F6E\u53CC\u5E7F\u89D2\u955C\u5934",
        "\u5F8C\u7F6E\u96D9\u5EE3\u89D2\u76F8\u6A5F",
        "\u80CC\u9762\u30C7\u30E5\u30A2\u30EB\u5E83\u89D2\u30AB\u30E1\u30E9",
        "\u0417\u0430\u0434\u043D\u044F\u044F \u0434\u0432\u043E\u0439\u043D\u0430\u044F \u0448\u0438\u0440\u043E\u043A\u043E\u0443\u0433\u043E\u043B\u044C\u043D\u0430\u044F \u043A\u0430\u043C\u0435\u0440\u0430",
        "\xc7ift Geni\u015F Kamera Arka Y\xfcz\xfc",
        "\u0643\u0627\u0645\u064A\u0631\u0627 \u062E\u0644\u0641\u064A\u0629 \u0645\u0632\u062F\u0648\u062C\u0629 \u0639\u0631\u064A\u0636\u0629",
        "\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E04\u0E39\u0E48\u0E14\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E21\u0E38\u0E21\u0E01\u0E27\u0E49\u0E32\u0E07",
        "Dubbel vidvinkelkamera p\xe5 baksidan",
        "Camera k\xe9p r\u1ED9ng m\u1EB7t sau",
        "Dobbelt vidvinkelkamera bak",
        "Tylny dwuobiektywowy aparat szerokok\u0105tny",
        "Laajakulmainen kaksoistakakamera",
        "Kamera Lebar Belakang Ganda",
        "\u05DE\u05E6\u05DC\u05DE\u05D4 \u05DB\u05E4\u05D5\u05DC\u05D4 \u05E8\u05D7\u05D1\u05D4 \u05D0\u05D7\u05D5\u05E8\u05D9\u05EA",
        "\u03A0\u03AF\u03C3\u03C9 \u03B4\u03B9\u03C0\u03BB\u03AE \u03B5\u03C5\u03C1\u03B5\u03AF\u03B1 \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1",
        "Camer\u0103 dubl\u0103 cu obiectiv superangular spate",
        "H\xe1ts\xf3, kett\u0151s, sz\xe9les l\xe1t\xf3sz\xf6g\u0171 kamera",
        "Zadn\xed du\xe1ln\xed \u0161iroko\xfahl\xfd fotoapar\xe1t",
        "C\xe0mera dual posterior amb gran angular",
        "Zadn\xe1 du\xe1lna \u0161irokouhl\xe1 kamera",
        "\u0417\u0430\u0434\u043D\u044F \u0437\u0434\u0432\u043E\u0454\u043D\u0430 \u0448\u0438\u0440\u043E\u043A\u043E\u043A\u0443\u0442\u043D\u0430 \u043A\u0430\u043C\u0435\u0440\u0430",
        "Stra\u017Enja dvostruka \u0161iroka kamera",
        "Dwikamera Lebar Belakang",
        "\u092C\u0948\u0915 \u0921\u094D\u092F\u0941\u0905\u0932 \u0935\u093E\u0907\u0921 \u0915\u0948\u092E\u0930\u093E"
    ]), O = new Set([
        "Back Ultra Wide Camera",
        "R\xfcckseitige Ultra-Weitwinkelkamera",
        "Appareil photo ultra grand angle arri\xe8re",
        "C\xe1mara trasera con ultra gran angular",
        "C\xe2mera Ultra-Angular Traseira",
        "C\xe2mara ultra grande angular traseira",
        "Fotocamera con ultra-grandangolo (posteriore)",
        "\u540E\u7F6E\u8D85\u5E7F\u89D2\u76F8\u673A",
        "\u5F8C\u7F6E\u8D85\u5EE3\u89D2\u76F8\u6A5F",
        "\u80CC\u9762\u8D85\u5E83\u89D2\u30AB\u30E1\u30E9",
        "\u0417\u0430\u0434\u043D\u044F\u044F \u0441\u0432\u0435\u0440\u0445\u0448\u0438\u0440\u043E\u043A\u043E\u0443\u0433\u043E\u043B\u044C\u043D\u0430\u044F \u043A\u0430\u043C\u0435\u0440\u0430",
        "Ultra Geni\u015F Kamera Arka Y\xfcz\xfc",
        "Ultrabrede camera aan achterzijde",
        "\u0643\u0627\u0645\u064A\u0631\u0627 \u062E\u0644\u0641\u064A\u0629 \u0639\u0631\u064A\u0636\u0629 \u062C\u062F\u064B\u0627",
        "\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E14\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E21\u0E38\u0E21\u0E01\u0E27\u0E49\u0E32\u0E07\u0E2D\u0E31\u0E25\u0E15\u0E23\u0E49\u0E32",
        "Ultravidvinkelkamera p\xe5 baksidan",
        "Ultravidvinkelkameraet p\xe5 bagsiden",
        "Camera c\u1EF1c r\u1ED9ng m\u1EB7t sau",
        "Ultravidvinkelkamera bak",
        "Tylny aparat ultraszerokok\u0105tny",
        "Ultralaajakulmainen takakamera",
        "Kamera Ultra Lebar Belakang",
        "\u05DE\u05E6\u05DC\u05DE\u05D4 \u05D0\u05D5\u05DC\u05D8\u05E8\u05D4 \u05E8\u05D7\u05D1\u05D4 \u05D0\u05D7\u05D5\u05E8\u05D9\u05EA",
        "\u03A0\u03AF\u03C3\u03C9 \u03C5\u03C0\u03B5\u03C1\u03B5\u03C5\u03C1\u03B5\u03AF\u03B1 \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1",
        "Camer\u0103 cu obiectiv ultra\u2011superangular spate",
        "H\xe1ts\xf3, ultrasz\xe9les l\xe1t\xf3sz\xf6g\u0171 kamera",
        "Zadn\xed ultra \u0161iroko\xfahl\xfd fotoapar\xe1t",
        "C\xe0mera posterior amb ultra gran angular",
        "Zadn\xe1 ultra\u0161irokouhl\xe1 kamera",
        "\u0417\u0430\u0434\u043D\u044F \u043D\u0430\u0434\u0448\u0438\u0440\u043E\u043A\u043E\u043A\u0443\u0442\u043D\u0430 \u043A\u0430\u043C\u0435\u0440\u0430",
        "Stra\u017Enja ultra \u0161iroka kamera",
        "Kamera Ultralebar Belakang",
        "\u092C\u0948\u0915 \u0905\u0932\u094D\u091F\u094D\u0930\u093E \u0935\u093E\u0907\u0921 \u0915\u0948\u092E\u0930\u093E"
    ]), d, D = !1;
    l.mainCameraForPositionOverridesOnDesktop = new Map, l.deviceIdToCameraObjects = new Map, l.inaccessibleDeviceIds = new Set;
    function ee(e, i) {
        l.mainCameraForPositionOverridesOnDesktop.set(e, i);
    }
    l.setMainCameraForPositionOverridesOnDesktop = ee;
    function ae() {
        l.mainCameraForPositionOverridesOnDesktop.clear();
    }
    l.clearMainCameraForPositionOverridesOnDesktop = ae;
    function F() {
        return navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
    }
    function N() {
        if (typeof navigator.enumerateDevices == "function") return navigator.enumerateDevices.bind(navigator);
        if (typeof navigator.mediaDevices == "object" && typeof navigator.mediaDevices.enumerateDevices == "function") return navigator.mediaDevices.enumerateDevices.bind(navigator.mediaDevices);
    }
    function S() {
        D = !0;
    }
    function B(e) {
        let i = e.toLowerCase();
        return P.some((a)=>i.includes(a));
    }
    function E(e) {
        return v.has(e);
    }
    l.isIOSFrontCameraLabel = E;
    function w(e) {
        return x.has(e);
    }
    l.isIOSBackCameraLabel = w;
    function M(e) {
        return c.has(e);
    }
    l.isIOSBackDualWideCameraLabel = M;
    function K(e) {
        return O.has(e);
    }
    l.isIOSUltraWideBackCameraLabel = K;
    function I(e) {
        var a;
        let i = e.message === "Invalid constraint" ? "OverconstrainedError" : (a = U.get(e.name)) != null ? a : e.name;
        Object.defineProperty(e, "name", {
            value: i
        });
    }
    function W(e) {
        if (e.length === 0) return {
            areSomeCameraLabelsFilled: !1,
            areAllCameraLabelsFilled: !1,
            areAllCameraLabelsUnfilled: !1
        };
        let i = e.every((r)=>r.label !== ""), a = e.every((r)=>r.label === "");
        return {
            areSomeCameraLabelsFilled: !a && !i,
            areAllCameraLabelsFilled: i,
            areAllCameraLabelsUnfilled: a
        };
    }
    function R(e, i) {
        var a;
        return (a = l.mainCameraForPositionOverridesOnDesktop.get(i)) != null ? a : e.find((n)=>n.position === i);
    }
    function j(e, i) {
        if (i === "worldFacing") {
            let a = e.find((r)=>M(r.label));
            if (a != null) return a;
            let n = e.find((r)=>w(r.label));
            if (n != null) return n;
        } else {
            let a = e.find((n)=>E(n.label));
            if (a != null) return a;
        }
    }
    function z(e, i) {
        let { areSomeCameraLabelsFilled: a$1, areAllCameraLabelsUnfilled: n } = W(e);
        if (n) return e[i === "userFacing" ? 0 : e.length - 1];
        if (a$1) {
            let r = e.filter((t)=>t.position === i);
            return r.length === 1 ? r[0] : r[i === "userFacing" ? 0 : r.length - 1];
        }
        if ((0, $08663c8936fe6aaa$export$407448d2b89b1813).getUserAgentInfo().getOS().name === "iOS") {
            let r = j(e, i);
            if (r) return r;
        }
        return e.filter((r)=>r.position === i).sort((r, t)=>r.label.localeCompare(t.label))[0];
    }
    function re(e, i) {
        return (0, $08663c8936fe6aaa$export$407448d2b89b1813).isDesktopDevice() ? R(e, i) : z(e, i);
    }
    l.getMainCameraForPosition = re;
    function b(e, i) {
        return e.unshift(e.splice(i, 1)[0]);
    }
    function ie(e, i) {
        function a$1(t, o) {
            let s = l.mainCameraForPositionOverridesOnDesktop.get(o);
            return s != null && t.includes(s) && (t = t.filter((f)=>f !== s), t.unshift(s)), t;
        }
        let n = e.filter((t)=>t.position === "userFacing"), r = e.filter((t)=>t.position === "worldFacing");
        return (0, $08663c8936fe6aaa$export$407448d2b89b1813).isDesktopDevice() ? (n = a$1(n, "userFacing"), r = a$1(r, "worldFacing")) : e.every((t)=>t.label === "") ? r.reverse() : (n.sort((t, o)=>t.label.localeCompare(o.label)), r.sort((t, o)=>t.label.localeCompare(o.label)), (0, $08663c8936fe6aaa$export$407448d2b89b1813).getUserAgentInfo().getOS().name === "iOS" && (n.some((t, o)=>E(t.label) && b(n, o) >= 0), r.some((t, o)=>K(t.label) && b(r, o) >= 0), r.some((t, o)=>M(t.label) && b(r, o) >= 0) || r.some((t, o)=>w(t.label) && b(r, o) >= 0))), i === "userFacing" ? [
            ...n,
            ...r
        ] : [
            ...r,
            ...n
        ];
    }
    l.sortCamerasForCameraPosition = ie;
    function _(e, i) {
        let a = e.getVideoTracks();
        if (a.length > 0) {
            let n = a[0], r;
            typeof n.getSettings == "function" && (r = n.getSettings(), r.facingMode != null && r.facingMode.length > 0 && (i.position = r.facingMode === "environment" ? "worldFacing" : "userFacing"));
            let { label: t = "" } = n;
            t.length > 0 && (i.label = t);
        }
    }
    l.adjustCameraFromMediaStream = _;
    function H(e, i, a$1) {
        if (l.deviceIdToCameraObjects.has(e.deviceId)) return l.deviceIdToCameraObjects.get(e.deviceId);
        let { label: n = "", deviceId: r } = e, t;
        return !(0, $08663c8936fe6aaa$export$407448d2b89b1813).isDesktopDevice() && a$1.every((o)=>o.label === "" && !l.deviceIdToCameraObjects.has(o.deviceId)) ? t = a$1.length === 1 || i + 1 <= Math.floor(a$1.length / 2) ? "userFacing" : "worldFacing" : t = B(n) ? "worldFacing" : "userFacing", {
            position: t,
            label: n,
            deviceId: r
        };
    }
    function A(e) {
        let i = e.map((a, n, r)=>H(a, n, r)).map((a)=>(a.deviceId !== "" && l.deviceIdToCameraObjects.set(a.deviceId, a), a)).filter((a)=>!/\b(?:ir|infrared)\b/i.test(a.label)).filter((a)=>!C.has(a.label)).filter((a)=>!l.inaccessibleDeviceIds.has(a.deviceId));
        if (!(0, $08663c8936fe6aaa$export$407448d2b89b1813).isDesktopDevice() && i.length > 1 && !i.some((a)=>a.position === "worldFacing")) {
            let a = i.length - 1, n = i.map((r)=>{
                let t = /\b(\d+)mp?\b/i.exec(r.label);
                return t != null ? Number.parseInt(t[1], 10) : Number.NaN;
            });
            n.some((r)=>Number.isNaN(r)) || (a = n.lastIndexOf(Math.max(...n))), i[a].position = "worldFacing";
        }
        return i;
    }
    async function V() {
        if (d != null && d.length > 0 && d.every((e)=>e.label === "" && !l.deviceIdToCameraObjects.has(e.deviceId))) try {
            return await F()({
                video: !0,
                audio: !1
            });
        } catch (e) {}
    }
    function G(e, i) {
        var a, n;
        if (i.length > 0 && e.length === i.length && !i.every((r, t)=>e[t].deviceId === r.deviceId)) {
            let r = {};
            for (let [t, o] of e.entries()){
                let s = l.deviceIdToCameraObjects.get(o.deviceId);
                if (s == null || s.label !== ((n = (a = i[t]) == null ? void 0 : a.label) != null ? n : "")) continue;
                let f = i[t].deviceId;
                r[s.deviceId] = f, l.inaccessibleDeviceIds.has(s.deviceId) && l.inaccessibleDeviceIds.add(f), s.deviceId = f, l.deviceIdToCameraObjects.set(f, s);
            }
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Detected updated camera deviceId information and updated it accordingly", r);
        }
    }
    function Z() {
        typeof navigator.mediaDevices.addEventListener == "function" ? navigator.mediaDevices.addEventListener("devicechange", S) : navigator.mediaDevices.ondevicechange = S;
    }
    async function y() {
        let e, i = N();
        if (i) e = await i();
        else throw new (0, $7061b11aca9abb6f$export$407448d2b89b1813)({
            fullSupport: !1,
            scannerSupport: !0,
            missingFeatures: [
                "mediaDevices"
            ]
        });
        return e.filter((a)=>a.kind === "videoinput");
    }
    async function te(e = !1, i = !1) {
        var r;
        let a$3 = (0, $08663c8936fe6aaa$export$407448d2b89b1813).checkBrowserCompatibility();
        if (!a$3.fullSupport) throw new (0, $7061b11aca9abb6f$export$407448d2b89b1813)(a$3);
        if (Z(), d == null || e || D) {
            D = !1;
            let t, o = d != null ? d : [];
            d = [];
            try {
                d = await y(), i || (t = await V(), t != null && (d = await y())), (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Camera list (devices):", ...d), G(o, d);
            } catch (s) {
                throw I(s), s;
            } finally{
                for (let s of (r = t == null ? void 0 : t.getVideoTracks()) != null ? r : [])s.stop();
            }
        }
        let n = A(d);
        return (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Camera list (cameras): ", ...n), [
            ...n
        ];
    }
    l.getCameras = te;
    async function Y(e) {
        return (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Attempt to access camera (parameters):", e.video), new Promise((i, a)=>{
            window.setTimeout(()=>{
                let n = F()(e);
                if (n == null) {
                    a(new (0, $4fd6157d2364abb3$export$407448d2b89b1813)({
                        name: "AbortError"
                    }));
                    return;
                }
                i(n);
            }, 0);
        });
    }
    function X(e, i) {
        let a = {
            resizeMode: "none"
        };
        switch(e){
            case 0:
                return {
                    ...a,
                    width: {
                        min: 2880,
                        ideal: i === "fourToThree" ? 2880 : 3840,
                        max: 4096
                    },
                    height: {
                        min: 1800,
                        ideal: 2160,
                        max: 2400
                    }
                };
            case 1:
                return {
                    ...a,
                    width: {
                        min: 1440,
                        ideal: i === "fourToThree" ? 1440 : 1920,
                        max: 2160
                    },
                    height: {
                        min: 900,
                        ideal: 1080,
                        max: 1440
                    }
                };
            case 2:
                return {
                    ...a,
                    width: {
                        min: 960,
                        ideal: i === "fourToThree" ? 960 : 1280,
                        max: 1440
                    },
                    height: {
                        min: 480,
                        ideal: 720,
                        max: 960
                    }
                };
            case 3:
                return {
                    ...a,
                    width: {
                        min: 640,
                        ideal: 640,
                        max: 800
                    },
                    height: {
                        min: 360,
                        ideal: i === "fourToThree" ? 480 : 360,
                        max: 640
                    }
                };
            case 4:
            default:
                return {};
        }
    }
    l.getUserMediaVideoParameters = X;
    function q(e) {
        e.deviceId !== "" && ((0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Camera marked to be inaccessible:", e), l.inaccessibleDeviceIds.add(e.deviceId));
    }
    l.markCameraAsInaccessible = q;
    async function ne(e, i, a) {
        (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Attempt to access camera (camera):", e);
        let n = {
            audio: !1,
            video: X(i, a)
        };
        e.deviceId === "" ? n.video.facingMode = {
            ideal: e.position === "worldFacing" ? "environment" : "user"
        } : n.video.deviceId = {
            exact: e.deviceId
        };
        try {
            let r = await Y(n);
            return _(r, e), r;
        } catch (r) {
            throw I(r), [
                "OverconstrainedError",
                "NotReadableError",
                "NotAllowedError"
            ].includes(r.name) || q(e), r;
        }
    }
    l.accessCameraStream = ne;
})($fa51dabf90952f18$export$4368d992c4eafac0 || ($fa51dabf90952f18$export$4368d992c4eafac0 = {}));


var $fd2706c93ce4bdd2$export$407448d2b89b1813;
((m)=>{
    async function n(o, t) {
        return (0, $fa51dabf90952f18$export$4368d992c4eafac0).getCameras(o != null ? o : !1, t != null ? t : !1);
    }
    m.getCameras = n;
})($fd2706c93ce4bdd2$export$407448d2b89b1813 || ($fd2706c93ce4bdd2$export$407448d2b89b1813 = {}));



function $2df61634b2608b63$export$407448d2b89b1813(r, o, t) {
    let e = r.createProgram();
    if (!e) throw new Error("Cannot create webgl program");
    return r.attachShader(e, o), r.attachShader(e, t), r.linkProgram(e), r.getProgramParameter(e, r.LINK_STATUS) ? e : ((0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Error, "Program linking error:", r.getProgramInfoLog(e)), r.deleteProgram(e), null);
}
function $2df61634b2608b63$export$8b22cf2602fb60ce(r, o, t) {
    let e = r.createShader(o);
    if (!e) throw new Error("Cannot create a shader");
    return r.shaderSource(e, t), r.compileShader(e), r.getShaderParameter(e, r.COMPILE_STATUS) ? e : ((0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Error, "Shader compilation error:", r.getShaderInfoLog(e)), r.deleteShader(e), null);
}


var $44c3a75d903dcc03$var$p = `
attribute vec2 a_position;
varying vec2 v_texcoord;

void main() {
  gl_Position = vec4(a_position, 0, 1);
  v_texcoord = a_position * 0.5 + 0.5;
}
`, $44c3a75d903dcc03$var$b = `
precision mediump float;
varying vec2 v_texcoord;
uniform sampler2D u_texture;
uniform float x_spacing; // Uniform for x-spacing between pixels

// Function to calculate grayscale
float toGray(vec4 color) {
  return dot(color.rgb, vec3(0.299, 0.587, 0.114));
}

void main() {
  // Sample adjacent pixels with spacing of 1/width
  vec4 a = texture2D(u_texture, v_texcoord + vec2(0.0 * x_spacing, 0.0));
  vec4 b = texture2D(u_texture, v_texcoord + vec2(1.0 * x_spacing, 0.0));
  vec4 c = texture2D(u_texture, v_texcoord + vec2(2.0 * x_spacing, 0.0));
  vec4 d = texture2D(u_texture, v_texcoord + vec2(3.0 * x_spacing, 0.0));

  // Calculate grayscale values
  float grayscaleA = toGray(a);
  float grayscaleB = toGray(b);
  float grayscaleC = toGray(c);
  float grayscaleD = toGray(d);

  // Set the final color with grayscale values
  gl_FragColor = vec4(grayscaleA, grayscaleB, grayscaleC, grayscaleD);
}`, $44c3a75d903dcc03$export$407448d2b89b1813 = class {
    constructor(t){
        this.colorType = "GRAYSCALE";
        this._originalGLContext = t, this._canvas = document.createElement("canvas");
    }
    get _webglContext() {
        if (!this._ctx) {
            if (this._ctx = this._canvas.getContext("webgl"), !this._ctx) throw new Error("Cannot get webgl context");
            this.setup();
        }
        return this._ctx;
    }
    readFromSource(t) {
        var _;
        this.updateCanvasSizeIfNeeded();
        let e = (_ = t == null ? void 0 : t.videoWidth) != null ? _ : this._originalGLContext.drawingBufferWidth, { drawingBufferWidth: r, drawingBufferHeight: i, TEXTURE_2D: h, RGBA: a, UNSIGNED_BYTE: n, TRIANGLES: x } = this._webglContext, s = r * i * 4;
        (!this.pixelsData || this.pixelsData.length !== s) && (this.pixelsData = new Uint8ClampedArray(s)), this._webglContext.viewport(0, 0, r, i);
        let c = this._webglContext.getUniformLocation(this._shaderProgram, "x_spacing"), C = 1 / e;
        this._webglContext.uniform1f(c, C), this._webglContext.texImage2D(h, 0, a, a, n, t), this._webglContext.drawArrays(x, 0, 6), this._webglContext.readPixels(0, 0, r, i, a, n, this.pixelsData);
        let d = new Uint8ClampedArray(this.pixelsData.buffer, 0, e * i);
        return {
            width: e,
            height: i,
            data: d,
            colorType: "GRAYSCALE"
        };
    }
    updateCanvasSizeIfNeeded() {
        (this._canvas.width !== this._originalGLContext.drawingBufferWidth / 4 || this._canvas.height !== this._originalGLContext.drawingBufferHeight) && (this._canvas.width = this._originalGLContext.drawingBufferWidth / 4, this._canvas.height = this._originalGLContext.drawingBufferHeight);
    }
    setup() {
        this.initShaderProgram(), this.initBuffers(), this.initTexture();
    }
    initShaderProgram() {
        let t = (0, $2df61634b2608b63$export$8b22cf2602fb60ce)(this._webglContext, this._webglContext.VERTEX_SHADER, $44c3a75d903dcc03$var$p), e = (0, $2df61634b2608b63$export$8b22cf2602fb60ce)(this._webglContext, this._webglContext.FRAGMENT_SHADER, $44c3a75d903dcc03$var$b);
        if (!t || !e) throw new Error("Shaders cannot be created");
        this._shaderProgram = (0, $2df61634b2608b63$export$407448d2b89b1813)(this._webglContext, t, e), this._webglContext.useProgram(this._shaderProgram);
    }
    initBuffers() {
        this._positionBuffer = this._webglContext.createBuffer(), this._webglContext.bindBuffer(this._webglContext.ARRAY_BUFFER, this._positionBuffer);
        let t = [
            -1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1
        ];
        this._webglContext.bufferData(this._webglContext.ARRAY_BUFFER, new Float32Array(t), this._webglContext.STATIC_DRAW);
        let e = this._webglContext.getAttribLocation(this._shaderProgram, "a_position");
        this._webglContext.enableVertexAttribArray(e), this._webglContext.bindBuffer(this._webglContext.ARRAY_BUFFER, this._positionBuffer), this._webglContext.vertexAttribPointer(e, 2, this._webglContext.FLOAT, !1, 0, 0);
    }
    initTexture() {
        this._texture = this._webglContext.createTexture(), this._webglContext.bindTexture(this._webglContext.TEXTURE_2D, this._texture), this._webglContext.texParameteri(this._webglContext.TEXTURE_2D, this._webglContext.TEXTURE_WRAP_S, this._webglContext.CLAMP_TO_EDGE), this._webglContext.texParameteri(this._webglContext.TEXTURE_2D, this._webglContext.TEXTURE_WRAP_T, this._webglContext.CLAMP_TO_EDGE), this._webglContext.texParameteri(this._webglContext.TEXTURE_2D, this._webglContext.TEXTURE_MIN_FILTER, this._webglContext.LINEAR), this._webglContext.texParameteri(this._webglContext.TEXTURE_2D, this._webglContext.TEXTURE_MAG_FILTER, this._webglContext.LINEAR);
        let t = this._webglContext.getUniformLocation(this._shaderProgram, "u_texture");
        this._webglContext.uniform1i(t, 0);
    }
};



var $8064bc49b8144d77$export$407448d2b89b1813 = ((i)=>(i.RGBA = "RGBA", i.GRAYSCALE = "GRAYSCALE", i))($8064bc49b8144d77$export$407448d2b89b1813 || {}), $8064bc49b8144d77$export$8b22cf2602fb60ce = class {
    constructor(t){
        this.colorType = "RGBA";
        this._contextWebGL = t;
    }
    get _initialized() {
        return this._texture != null && this._framebuffer != null;
    }
    readFromSource(t) {
        return this._initialized || this.setup(), this._pixelsDataLength = this._contextWebGL.drawingBufferWidth * this._contextWebGL.drawingBufferHeight * 4, (this.pixelsData == null || this.pixelsData.byteLength !== this._pixelsDataLength) && (this.pixelsData = void 0, this.pixelsData = new Uint8ClampedArray(this._pixelsDataLength)), this._contextWebGL.texImage2D(this._contextWebGL.TEXTURE_2D, 0, this._contextWebGL.RGBA, this._contextWebGL.RGBA, this._contextWebGL.UNSIGNED_BYTE, t), this._contextWebGL.readPixels(0, 0, this._contextWebGL.drawingBufferWidth, this._contextWebGL.drawingBufferHeight, this._contextWebGL.RGBA, this._contextWebGL.UNSIGNED_BYTE, this.pixelsData), {
            width: this._contextWebGL.drawingBufferWidth,
            height: this._contextWebGL.drawingBufferHeight,
            data: this.pixelsData,
            colorType: this.colorType
        };
    }
    setup() {
        this._texture = this._contextWebGL.createTexture(), this._texture == null && (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Could not create texture from WebGLRenderingContext"), this._contextWebGL.bindTexture(this._contextWebGL.TEXTURE_2D, this._texture), this._framebuffer = this._contextWebGL.createFramebuffer(), this._framebuffer == null && (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Could not create frameBuffer from WebGLRenderingContext"), this._contextWebGL.bindFramebuffer(this._contextWebGL.FRAMEBUFFER, this._framebuffer), this._contextWebGL.framebufferTexture2D(this._contextWebGL.FRAMEBUFFER, this._contextWebGL.COLOR_ATTACHMENT0, this._contextWebGL.TEXTURE_2D, this._texture, 0), this._contextWebGL.texParameteri(this._contextWebGL.TEXTURE_2D, this._contextWebGL.TEXTURE_WRAP_S, this._contextWebGL.CLAMP_TO_EDGE), this._contextWebGL.texParameteri(this._contextWebGL.TEXTURE_2D, this._contextWebGL.TEXTURE_WRAP_T, this._contextWebGL.CLAMP_TO_EDGE), this._contextWebGL.texParameteri(this._contextWebGL.TEXTURE_2D, this._contextWebGL.TEXTURE_MIN_FILTER, this._contextWebGL.NEAREST), this._contextWebGL.texParameteri(this._contextWebGL.TEXTURE_2D, this._contextWebGL.TEXTURE_MAG_FILTER, this._contextWebGL.NEAREST);
    }
};


var $80d48380ab62f10e$export$407448d2b89b1813 = {
    CONTAINER_CLASS_NAME: "scandit-container",
    PAINTBOARDS_CONTAINER_CLASS_NAME: "scandit-paintboards",
    PAINTBOARD_CLASS_NAME: "scandit-paintboard",
    PAINTBOARD_CLASS_NAME_STATE_ON: "scandit-paintboard--camera-on",
    CONTROLS_CLASS_NAME: "scandit-controls",
    CONTROL_WIDGET_CLASS_NAME: "scandit-control-widget",
    MIRRORED_CLASS_NAME: "scandit-mirrored",
    CAMERA_RECOVERY_CLASS_NAME: "scandit-camera-recovery",
    ERROR_CLASS_NAME: "scandit-error",
    HINT_CONTAINER_CLASS_NAME: "scandit-hint-container",
    HINT_CLASS_NAME: "scandit-hint",
    SINGLE_IMAGE_UPLOADER_CONTAINER_CLASS_NAME: "scandit-single-image-uploader-container",
    CANVAS_VIDEO_PREVIEW_CLASS_NAME: "scandit-canvas-video-preview",
    TORCH_SWITCH_CONTROL_CLASS_NAME: "torch",
    CAMERA_SWITCH_CONTROL_CLASS_NAME: "camera",
    CAMERA_FOV_SWITCH_CONTROL_CLASS_NAME: "camera-fov",
    FROZEN_FRAME: "frozen-frame"
};






var $593c5318613e8031$export$407448d2b89b1813 = ((r)=>(r.CONTINUOUS = "continuous", r.MANUAL = "manual", r.NONE = "none", r.SINGLE_SHOT = "single-shot", r))($593c5318613e8031$export$407448d2b89b1813 || {}), $593c5318613e8031$export$8b22cf2602fb60ce = ((s)=>(s[s.ULTRA_HD = 0] = "ULTRA_HD", s[s.FULL_HD = 1] = "FULL_HD", s[s.HD = 2] = "HD", s[s.SD = 3] = "SD", s[s.NONE = 4] = "NONE", s))($593c5318613e8031$export$8b22cf2602fb60ce || {}), $593c5318613e8031$export$db3b6bfb95261072 = ((t)=>(t.CAMERA_PROPERTIES = "cameraProperties", t.CAMERA_ACCESS_ERROR = "cameraAccessError", t))($593c5318613e8031$export$db3b6bfb95261072 || {}), $593c5318613e8031$var$n = class n {
    constructor(){
        this.checkCameraVideoStreamAccessIfVisibleListener = this.checkCameraVideoStreamAccessIfVisible.bind(this);
        this.handleWebGLContextLostListener = this.handleWebGLContextLost.bind(this);
        this.listeners = new Map;
        this.mirrorImageOverrides = new Map;
        this.postStreamInitializationListener = this.postStreamInitialization.bind(this);
        this.triggerManualFocusListener = this.triggerManualFocus.bind(this);
        this.triggerZoomMoveListener = this.triggerZoomMove.bind(this);
        this.triggerZoomStartListener = this.triggerZoomStart.bind(this);
        this.videoResizeListener = this.handleVideoResize.bind(this);
        this.videoTrackEndedListener = this.videoTrackEndedRecovery.bind(this);
        this.videoTrackMuteListener = this.videoTrackMuteRecovery.bind(this);
        this._glFrameReaders = {
            GRAYSCALE: null,
            RGBA: null,
            current: null
        };
        this._frameReaderType = "RGBA";
        this.cameraPosition = "worldFacing", this.gui = {
            isCameraRecoveryVisible: ()=>!1,
            setCameraRecoveryVisible: ()=>{}
        }, this.isWebGLSupported = !(0, $08663c8936fe6aaa$export$407448d2b89b1813).checkBrowserCompatibility().missingFeatures.includes("webGL"), this.videoElement = document.createElement("video"), this.canvas = document.createElement("canvas"), this.canvas.addEventListener("webglcontextlost", this.handleWebGLContextLostListener);
    }
    set imageData(e) {
        this._glFrameReaders.current != null && (this._glFrameReaders.current.pixelsData = e);
    }
    get mediaStream() {
        return this._mediaStream;
    }
    set mediaStream(e) {
        this._mediaStream = e, e && (this.mediaTrackCapabilitiesPromise = new Promise((t)=>{
            this.mediaTrackCapabilitiesPromiseResolver = t;
        }));
    }
    get canvas2dContext() {
        return this._canvas2dContext || (this._canvas2dContext = this.canvas.getContext("2d", {
            willReadFrequently: !0
        }), this._canvas2dContext == null && (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Unable to get 2d canvas context"), this.handleVideoResize()), this._canvas2dContext;
    }
    get canvasWebGLContext() {
        var e;
        if (!this._canvas2dContext && !this._canvasWebGLContext) {
            if (!this.isWebGLSupported) {
                (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "WebGL context not supported, falling back to 2d canvas context. This may impact the scanning performance.");
                return;
            }
            let t = (e = this.canvas.getContext("webgl", {
                alpha: !1,
                antialias: !1
            })) != null ? e : this.canvas.getContext("experimental-webgl", {
                alpha: !1,
                antialias: !1
            });
            t != null && (this._canvasWebGLContext = t, this._glFrameReaders.GRAYSCALE = new (0, $44c3a75d903dcc03$export$407448d2b89b1813)(t), this._glFrameReaders.RGBA = new (0, $8064bc49b8144d77$export$8b22cf2602fb60ce)(t), this._glFrameReaders.current = this._glFrameReaders[this._frameReaderType], (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, `Frame will be sent in ${this._frameReaderType} mode`), this.handleVideoResize());
        }
        return this._canvasWebGLContext;
    }
    static instance() {
        return n._instance == null && (n._instance = new n), n._instance;
    }
    requestVideoFrame(e) {
        return "requestVideoFrameCallback" in HTMLVideoElement.prototype ? this.videoElement.requestVideoFrameCallback(e) : requestAnimationFrame(e);
    }
    cancelVideoFrame(e) {
        if ("cancelVideoFrameCallback" in HTMLVideoElement.prototype) {
            this.videoElement.cancelVideoFrameCallback(e);
            return;
        }
        cancelAnimationFrame(e);
    }
    addListener(e, t) {
        var r;
        let i = (r = this.listeners.get(e)) != null ? r : [];
        i.includes(t) || this.listeners.set(e, [
            ...i,
            t
        ]);
    }
    async applyCameraSettings(e) {
        if (this.selectedCameraSettings = e, this.activeCamera == null) throw new (0, $4fd6157d2364abb3$export$407448d2b89b1813)(n.noCameraErrorParameters);
        return this.initializeCameraWithSettings(this.activeCamera, e);
    }
    captureImage() {
        var e;
        if (((e = this.mediaStream) == null ? void 0 : e.active) != null) {
            if (this.canvasWebGLContext != null) return this.captureImageForWebGLContext();
            if (this.canvas2dContext != null) return this.captureImageFor2dContext();
        }
        return null;
    }
    async initializeCameraWithSettings(e, t) {
        if (this.cameraInitializationPromise && await this.cameraInitializationPromise, e == null) throw new (0, $4fd6157d2364abb3$export$407448d2b89b1813)(n.noCameraErrorParameters);
        return this.setSelectedCamera(e), this.selectedCameraSettings = t, this.activeCameraSettings = t, this.cameraInitializationPromise = this.initializeCameraAndCheckUpdatedSettings(e), this.cameraInitializationPromise;
    }
    isMirrorImageEnabled() {
        if (this.selectedCamera && this.activeCamera) {
            let e = this.mirrorImageOverrides.get(this.activeCamera);
            return e != null ? e : this.activeCamera.position === "userFacing";
        }
        return !1;
    }
    isPinchToZoomEnabled() {
        return this.pinchToZoomEnabled;
    }
    isTapToFocusEnabled() {
        return this.tapToFocusEnabled;
    }
    async isTorchAvailable() {
        var e;
        return this.mediaStream ? (await this.waitForCapabilities(), ((e = this.mediaTrackCapabilities) == null ? void 0 : e.torch) === !0) : !1;
    }
    async playVideo() {
        return new Promise((e)=>{
            this._canvas2dContext && this._canvas2dContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
            let t = this.videoElement.play();
            t == null ? e() : t.then(e).catch(()=>{
                e();
            });
        });
    }
    async reinitializeCamera() {
        if (this.activeCamera == null) (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Camera reinitialization delayed");
        else {
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Reinitialize camera:", this.activeCamera);
            try {
                let e = this.activeCamera;
                await this.stopStream(), await this.initializeCameraWithSettings(e, this.activeCameraSettings);
            } catch (e) {
                throw (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Couldn't access camera:", this.activeCamera, e), this.emit("cameraAccessError", e), e;
            }
        }
    }
    removeListener(e, t) {
        var s;
        let r = ((s = this.listeners.get(e)) != null ? s : []).filter((o)=>o !== t);
        this.listeners.set(e, r);
    }
    async setCameraPosition(e) {
        var i;
        this.setInitialCameraPosition(e);
        let t = (0, $fa51dabf90952f18$export$4368d992c4eafac0).getMainCameraForPosition(await (0, $fa51dabf90952f18$export$4368d992c4eafac0).getCameras(), e);
        if (t && t.deviceId !== ((i = this.selectedCamera) == null ? void 0 : i.deviceId)) return this.initializeCameraWithSettings(t, this.selectedCameraSettings);
    }
    async setExposure(e) {
        var r, s, o, m, d, l, v, p;
        let t = (s = (r = this.mediaStream) == null ? void 0 : r.getVideoTracks()) != null ? s : [];
        if (t.length === 0 || typeof t[0].applyConstraints != "function") return;
        await this.waitForCapabilities();
        let i = e.time != null && e.time > 0 ? "manual" : "continuous";
        if (((m = (o = this.mediaTrackCapabilities) == null ? void 0 : o.exposureMode) == null ? void 0 : m.includes(i)) === !0) {
            if (await t[0].applyConstraints({
                advanced: [
                    {
                        exposureMode: i
                    }
                ]
            }), e.time != null && e.time > 0 && this.mediaTrackCapabilities.exposureTime) {
                let h = Math.max((d = this.mediaTrackCapabilities.exposureTime.min) != null ? d : .01, Math.min(e.time, (l = this.mediaTrackCapabilities.exposureTime.max) != null ? l : 1e5));
                await t[0].applyConstraints({
                    advanced: [
                        {
                            exposureTime: h
                        }
                    ]
                });
            } else if (e.compensation != null && i === "continuous" && this.mediaTrackCapabilities.exposureCompensation) {
                let h = Math.max((v = this.mediaTrackCapabilities.exposureCompensation.min) != null ? v : -10, Math.min(e.compensation, (p = this.mediaTrackCapabilities.exposureCompensation.max) != null ? p : 10));
                await t[0].applyConstraints({
                    advanced: [
                        {
                            exposureCompensation: h
                        }
                    ]
                });
            }
        }
    }
    async setFocus(e) {
        var i, r, s, o, m;
        if (!this.mediaStream) return;
        let t = this.mediaStream.getVideoTracks();
        if (t.length > 0 && typeof t[0].applyConstraints == "function") {
            await this.waitForCapabilities();
            let d = e >= 0 ? "manual" : "continuous";
            if (((r = (i = this.mediaTrackCapabilities) == null ? void 0 : i.focusMode) == null ? void 0 : r.includes(d)) === !0 && (await t[0].applyConstraints({
                advanced: [
                    {
                        focusMode: d
                    }
                ]
            }), d === "manual" && this.mediaTrackCapabilities.focusDistance)) {
                let l = Math.max(0, Math.min(e, 1)) * (((s = this.mediaTrackCapabilities.focusDistance.max) != null ? s : 1e3) - ((o = this.mediaTrackCapabilities.focusDistance.min) != null ? o : .01)) + ((m = this.mediaTrackCapabilities.focusDistance.min) != null ? m : .01);
                await t[0].applyConstraints({
                    advanced: [
                        {
                            focusDistance: l
                        }
                    ]
                });
            }
        }
    }
    async setFrameRate(e) {
        var t, i, r;
        if (this.mediaStream && (await this.waitForCapabilities(), (t = this.mediaTrackCapabilities) != null && t.frameRate)) {
            let s = this.mediaStream.getVideoTracks();
            if (s.length > 0 && typeof s[0].applyConstraints == "function") {
                let o = Math.min((i = this.mediaTrackCapabilities.frameRate.max) != null ? i : 240, (r = e.max) != null ? r : 240);
                await s[0].applyConstraints({
                    advanced: [
                        {
                            frameRate: o
                        }
                    ]
                });
            }
        }
    }
    setInitialCameraPosition(e) {
        this.cameraPosition = e;
    }
    setInteractionOptions(e, t, i) {
        this.torchToggleEnabled = e, this.tapToFocusEnabled = t, this.pinchToZoomEnabled = i;
    }
    setMirrorImageEnabled(e, t) {
        this.selectedCamera && (e ? (this.videoElement.classList.add(n.MIRRORED_CLASS_NAME), this.canvas.classList.add(n.MIRRORED_CLASS_NAME)) : (this.videoElement.classList.remove(n.MIRRORED_CLASS_NAME), this.canvas.classList.remove(n.MIRRORED_CLASS_NAME)), t && this.mirrorImageOverrides.set(this.selectedCamera, e));
    }
    setPinchToZoomEnabled(e) {
        this.pinchToZoomEnabled = e, this.mediaStream && (this.pinchToZoomEnabled ? this.enablePinchToZoomListeners() : this.disablePinchToZoomListeners());
    }
    setSelectedCamera(e) {
        this.selectedCamera = e;
    }
    setSelectedCameraSettings(e) {
        this.selectedCameraSettings = e;
    }
    setTapToFocusEnabled(e) {
        this.tapToFocusEnabled = e, this.mediaStream && (this.tapToFocusEnabled ? this.enableTapToFocusListeners() : this.disableTapToFocusListeners());
    }
    async setTorchEnabled(e) {
        var t;
        if (this.mediaStream && ((t = this.mediaTrackCapabilities) == null ? void 0 : t.torch) === !0) {
            this.torchEnabled = e;
            let i = this.mediaStream.getVideoTracks();
            i.length > 0 && typeof i[0].applyConstraints == "function" && await i[0].applyConstraints({
                advanced: [
                    {
                        torch: e
                    }
                ]
            });
        }
    }
    async setZoom(e) {
        var t, i, r;
        if (this.mediaStream && (await this.waitForCapabilities(), (t = this.mediaTrackCapabilities) != null && t.zoom)) {
            let s = this.mediaStream.getVideoTracks();
            if (s.length > 0 && typeof s[0].applyConstraints == "function") {
                let o = Math.max((i = this.mediaTrackCapabilities.zoom.min) != null ? i : 1, Math.min(e, (r = this.mediaTrackCapabilities.zoom.max) != null ? r : 16));
                await s[0].applyConstraints({
                    advanced: [
                        {
                            zoom: o
                        }
                    ]
                });
            }
        }
    }
    async setupCameras() {
        return this.cameraSetupPromise ? this.cameraSetupPromise : (this.cameraSetupPromise = this.setupCamerasAndStream(), this.cameraSetupPromise);
    }
    pauseStream() {
        if (!this.mediaStream) return;
        let e = this.mediaStream.getVideoTracks()[0];
        e.enabled = !1, (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Pause camera video stream", this.mediaStream);
    }
    resumeStream() {
        if (!this.mediaStream) return;
        let e = this.mediaStream.getVideoTracks()[0];
        e.enabled = !0, (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Resume camera video stream", this.mediaStream);
    }
    async stopStream(e = !1) {
        this.activeCamera && (this.activeCamera.currentResolution = void 0), this.activeCamera = void 0, this.torchEnabled = !1, this.mediaStream && ((0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, `Stop camera video stream access${e ? " (abort access detection)" : ""}:`, this.mediaStream), document.removeEventListener("visibilitychange", this.checkCameraVideoStreamAccessIfVisibleListener), window.clearTimeout(this.cameraAccessTimeout), window.clearInterval(this.videoMetadataCheckInterval), window.clearTimeout(this.getCapabilitiesTimeout), window.clearTimeout(this.manualFocusWaitTimeout), window.clearTimeout(this.manualToAutofocusResumeTimeout), window.clearInterval(this.autofocusInterval), this.videoElement.pause(), await new Promise((t)=>{
            setTimeout(()=>{
                var i, r, s;
                for (let o of (r = (i = this.mediaStream) == null ? void 0 : i.getVideoTracks()) != null ? r : [])o.removeEventListener("ended", this.videoTrackEndedListener), o.stop();
                this.videoElement.srcObject = null, this._canvas2dContext && this._canvas2dContext.clearRect(0, 0, this.canvas.width, this.canvas.height), this.mediaStream = void 0, this.mediaTrackCapabilities = void 0, this.mediaTrackCapabilitiesPromise = void 0, this.mediaTrackCapabilitiesPromiseResolver = void 0, e || (s = this.abortedCameraInitializationResolveCallback) == null || s.call(this), t();
            }, 0);
        }));
    }
    stopVideoTracks() {
        if (this.mediaStream != null) for (let e of this.mediaStream.getVideoTracks())e.stop();
    }
    async toggleTorch() {
        this.torchEnabled = !this.torchEnabled, await this.setTorchEnabled(this.torchEnabled);
    }
    updateCanvasVideoImage() {
        this.canvas2dContext.drawImage(this.videoElement, 0, 0);
    }
    async waitForCapabilities() {
        var e;
        return (e = this.mediaTrackCapabilitiesPromise) != null ? e : Promise.resolve();
    }
    setFrameReaderType(e) {
        this._frameReaderType = e, this._glFrameReaders.current = this._glFrameReaders[e], (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, `Change frame reader type. Frames will be sent in ${this._frameReaderType} mode`);
    }
    async allowPictureInPicture(e) {
        e ? (this.videoElement.disablePictureInPicture = !1, this.videoElement.removeAttribute("controlslist"), this.videoElement.removeAttribute("disablepictureinpicture")) : (this.videoElement.disablePictureInPicture = !0, this.videoElement.setAttribute("controlslist", "nodownload"), this.videoElement.setAttribute("disablepictureinpicture", "true")), await this.reinitializeCamera();
    }
    async accessAutoselectedCamera(e) {
        let t = (0, $fa51dabf90952f18$export$4368d992c4eafac0).sortCamerasForCameraPosition(e, this.cameraPosition), i = t.shift();
        for(; i;)try {
            await this.initializeCameraWithSettings(i, this.selectedCameraSettings);
            return;
        } catch (r) {
            if (this.setSelectedCamera(), t.length > 0) {
                (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Couldn't access camera:", i, r), i = t.shift();
                continue;
            }
            throw r;
        }
        throw new (0, $4fd6157d2364abb3$export$407448d2b89b1813)(n.noCameraErrorParameters);
    }
    async accessInitialCamera() {
        let e = {
            position: this.cameraPosition,
            deviceId: "",
            label: ""
        };
        try {
            await this.initializeCameraWithSettings(e, this.selectedCameraSettings);
        } catch (t) {} finally{
            this.setSelectedCamera();
        }
        return e;
    }
    recreateCanvas() {
        this.canvas.removeEventListener("webglcontextlost", this.handleWebGLContextLostListener), this._canvasWebGLContext = void 0, this._canvas2dContext = void 0;
        let e = document.createElement("canvas");
        e.addEventListener("webglcontextlost", this.handleWebGLContextLostListener), e.width = this.canvas.width, e.height = this.canvas.height, e.className = this.canvas.className, this.canvas = e;
    }
    captureImageFor2dContext() {
        if (!this.isVideoAndContextStateValid()) return null;
        let { width: e, height: t } = this.canvas;
        return {
            colorType: "RGBA",
            data: this.canvas2dContext.getImageData(0, 0, e, t).data,
            width: e,
            height: t
        };
    }
    captureImageForWebGLContext() {
        if (!this.isVideoAndContextStateValid() || !this.canvasWebGLContext || this.canvasWebGLContext.drawingBufferWidth <= 2 || this.canvasWebGLContext.drawingBufferHeight <= 2 || this._glFrameReaders.current == null) return null;
        let e = this._glFrameReaders.current.readFromSource(this.videoElement);
        if (e.data[3] !== 255 && e.colorType === "RGBA") {
            if ((0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Detected incorrect GPU accelerated WebGL image processing, switching to canvas mode"), this.recreateCanvas(), this.canvas2dContext == null) throw new Error("Unable to get 2d canvas context");
            return this.captureImage();
        }
        return e;
    }
    async checkCameraAccess(e) {
        return new Promise((t, i)=>{
            this.cameraAccessRejectCallback = (r)=>{
                (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Camera video stream access failure (video data load timeout):", e), this.gui.setCameraRecoveryVisible(!0), i(r);
            }, this.setCameraAccessTimeout();
        });
    }
    checkCameraVideoStreamAccessIfVisible() {
        document.visibilityState === "visible" && ((0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Page is visible again, waiting for camera video stream start..."), document.removeEventListener("visibilitychange", this.checkCameraVideoStreamAccessIfVisibleListener), this.setCameraAccessTimeout());
    }
    async checkVideoMetadata(e) {
        return new Promise((t, i)=>{
            this.videoElement.onloadeddata = ()=>{
                if (this.videoElement.onloadeddata = null, window.clearTimeout(this.cameraAccessTimeout), this.videoElement.videoWidth > 2 && this.videoElement.videoHeight > 2 && this.videoElement.currentTime > 0) {
                    this.updateActiveCameraCurrentResolution(e), (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Camera video stream access success:", e), t();
                    return;
                }
                let r = performance.now();
                window.clearInterval(this.videoMetadataCheckInterval), this.videoMetadataCheckInterval = window.setInterval(async ()=>{
                    if (this.videoElement.videoWidth <= 2 || this.videoElement.videoHeight <= 2 || this.videoElement.currentTime === 0) {
                        if (performance.now() - r > n.videoMetadataCheckTimeoutMs) {
                            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Camera video stream access failure (valid video metadata timeout):", e), window.clearInterval(this.videoMetadataCheckInterval), await this.stopStream(!0), i(new (0, $4fd6157d2364abb3$export$407448d2b89b1813)(n.notReadableErrorParameters));
                            return;
                        }
                        return;
                    }
                    window.clearInterval(this.videoMetadataCheckInterval), this.updateActiveCameraCurrentResolution(e), (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Camera video stream access success:", e), t();
                }, n.videoMetadataCheckIntervalMs);
            };
        });
    }
    disablePinchToZoomListeners() {
        this.videoElement.removeEventListener("touchstart", this.triggerZoomStartListener), this.videoElement.removeEventListener("touchmove", this.triggerZoomMoveListener);
    }
    disableTapToFocusListeners() {
        for (let e of [
            "touchend",
            "mousedown"
        ])this.videoElement.removeEventListener(e, this.triggerManualFocusListener);
    }
    emit(e, t) {
        var r;
        let i = (r = this.listeners.get(e)) != null ? r : [];
        for (let s of i)s(t);
    }
    enablePinchToZoomListeners() {
        this.videoElement.addEventListener("touchstart", this.triggerZoomStartListener), this.videoElement.addEventListener("touchmove", this.triggerZoomMoveListener);
    }
    enableTapToFocusListeners() {
        for (let e of [
            "touchend",
            "mousedown"
        ])this.videoElement.addEventListener(e, this.triggerManualFocusListener);
    }
    getActiveCamera(e, t, i) {
        return e.length === 1 ? e[0] : e.find((r)=>r.deviceId === i || r.label !== "" && r.label === t);
    }
    getInitialCameraResolutionConstraint(e) {
        var i;
        let t;
        switch((i = this.activeCameraSettings) == null ? void 0 : i.preferredResolution){
            case "uhd4k":
                t = 0;
                break;
            case "fullHd":
                t = 1;
                break;
            case "hd":
            default:
                t = 2;
                break;
        }
        return t;
    }
    async handleCameraInitializationError(e, t, i) {
        if (![
            "OverconstrainedError",
            "NotReadableError"
        ].includes(i.name) || i.name === "NotReadableError" && t === 4) throw (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Camera video stream access failure (unrecoverable error)", e, i), i.name !== "NotAllowedError" && (0, $fa51dabf90952f18$export$4368d992c4eafac0).markCameraAsInaccessible(e), i;
        if (i.name === "OverconstrainedError" && t === 4) {
            if (e.deviceId === "") throw (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Camera video stream access failure (no camera with such type error)", e, i), i;
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Detected non-existent deviceId error, attempt to find and reaccess updated camera", e, i);
            let r = e.deviceId;
            if (await (0, $fa51dabf90952f18$export$4368d992c4eafac0).getCameras(!0), r === e.deviceId) throw (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Camera video stream access failure (updated camera not found after non-existent deviceId error)", e, i), (0, $fa51dabf90952f18$export$4368d992c4eafac0).markCameraAsInaccessible(e), i;
            return (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Updated camera found (recovered from non-existent deviceId error), attempt to access it", e), this.initializeCameraForResolution(e);
        }
        return this.initializeCameraForResolution(e, t + 1);
    }
    handleVideoResize() {
        if (!(this.videoElement.videoWidth <= 2 || this.videoElement.videoHeight <= 2)) {
            if (this.activeCamera && this.updateActiveCameraCurrentResolution(this.activeCamera), this.canvasWebGLContext != null) {
                if (this.canvas.width === this.videoElement.videoWidth && this.canvas.height === this.videoElement.videoHeight) return;
                this.canvas.width = this.videoElement.videoWidth, this.canvas.height = this.videoElement.videoHeight, this.canvasWebGLContext.viewport(0, 0, this.canvasWebGLContext.drawingBufferWidth, this.canvasWebGLContext.drawingBufferHeight);
            } else if (this.canvas2dContext != null) {
                if (this.canvas.width === this.videoElement.videoWidth && this.canvas.height === this.videoElement.videoHeight) return;
                this.canvas.width = this.videoElement.videoWidth, this.canvas.height = this.videoElement.videoHeight;
            }
        }
    }
    handleWebGLContextLost() {
        (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "WebGL context has been lost, restoring..."), this._canvasWebGLContext = void 0, this.canvasWebGLContext ? (this.handleVideoResize(), (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "WebGL context restored")) : (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Error, "WebGL context restore failed");
    }
    async initializeCameraAndCheckUpdatedSettings(e) {
        var t, i, r, s, o;
        try {
            if (await this.initializeCameraForResolution(e), this.selectedCameraSettings !== this.activeCameraSettings && (this.selectedCameraSettings == null || this.activeCameraSettings == null || Object.keys(this.selectedCameraSettings).some((h)=>{
                var g, b;
                return ((g = this.selectedCameraSettings) == null ? void 0 : g[h]) !== ((b = this.activeCameraSettings) == null ? void 0 : b[h]);
            }))) {
                this.activeCameraSettings = this.selectedCameraSettings, await this.initializeCameraAndCheckUpdatedSettings(e);
                return;
            }
            this.activeCameraSettings && this.activeCameraSettings.zoomFactor > 1 && await this.setZoom(this.activeCameraSettings.zoomFactor);
            let m = (t = this.activeCameraSettings) == null ? void 0 : t.getProperty("minFrameRate"), d = (i = this.activeCameraSettings) == null ? void 0 : i.getProperty("maxFrameRate");
            (m != null || d != null) && await this.setFrameRate({
                min: m,
                max: d
            });
            let l = (r = this.activeCameraSettings) == null ? void 0 : r.getProperty("manualLensPosition");
            l != null && await this.setFocus(l);
            let v = (s = this.activeCameraSettings) == null ? void 0 : s.getProperty("exposureTargetBias"), p = (o = this.activeCameraSettings) == null ? void 0 : o.getProperty("exposureDuration");
            (v != null || p != null) && await this.setExposure({
                compensation: v,
                time: p
            });
        } finally{
            this.cameraInitializationPromise = void 0;
        }
    }
    async initializeCameraForResolution(e, t) {
        var r;
        this.gui.setCameraRecoveryVisible(!1);
        let i = t != null ? t : this.getInitialCameraResolutionConstraint(e);
        this.mediaStream != null && e.deviceId !== "" && ((r = this.activeCamera) == null ? void 0 : r.deviceId) === e.deviceId ? await ((0, $08663c8936fe6aaa$export$407448d2b89b1813).isIPhone() ? this.initializeStreamForResolution(e, i) : this.updateStreamForResolution(e, i)) : await this.initializeStreamForResolution(e, i);
    }
    async initializeStreamForResolution(e, t) {
        var i;
        await this.stopStream();
        try {
            let r = (i = this.activeCameraSettings) == null ? void 0 : i.getProperty("preferredAspectRatio"), s = await (0, $fa51dabf90952f18$export$4368d992c4eafac0).accessCameraStream(e, t, r);
            if ((0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Camera accessed, waiting for camera video stream start..."), typeof s.getVideoTracks()[0].getSettings == "function") {
                let o = s.getVideoTracks()[0].getSettings();
                if (o.width != null && o.height != null && (o.width === 2 || o.height === 2)) {
                    if ((0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Camera video stream access failure (invalid video metadata):", e), t === 4) throw new (0, $4fd6157d2364abb3$export$407448d2b89b1813)(n.notReadableErrorParameters);
                    return await this.stopStream(), this.initializeStreamForResolution(e, t + 1);
                }
            }
            this.mediaStream = s;
            for (let o of this.mediaStream.getVideoTracks())o.addEventListener("ended", this.videoTrackEndedListener), o.addEventListener("mute", this.videoTrackMuteListener), o.addEventListener("unmute", this.videoTrackMuteListener);
            try {
                await this.setupCameraStreamVideo(e, s);
            } catch (o) {
                if (t === 4) throw o;
                return this.initializeStreamForResolution(e, t + 1);
            }
        } catch (r) {
            return this.handleCameraInitializationError(e, t, r);
        }
    }
    isVideoAndContextStateValid() {
        return this.videoElement.readyState === 4 && this.videoElement.videoWidth > 2 && this.videoElement.videoHeight > 2 && this.canvas.width > 2 && this.canvas.height > 2;
    }
    postStreamInitialization() {
        window.clearTimeout(this.getCapabilitiesTimeout), this.getCapabilitiesTimeout = window.setTimeout(()=>{
            this.storeStreamCapabilities(), this.setupAutofocus();
        }, n.getCapabilitiesTimeoutMs);
    }
    async recoverStreamIfNeeded() {
        var t, i;
        let e = (t = this.mediaStream) == null ? void 0 : t.getVideoTracks();
        ((i = e == null ? void 0 : e[0]) == null ? void 0 : i.readyState) === "ended" && await this.reinitializeCamera();
    }
    reportCameraProperties(e, t, i = !0) {
        this.emit("cameraProperties", {
            deviceId: e,
            isFrontFacing: t === "userFacing",
            hasAutofocus: i
        });
    }
    setCameraAccessTimeout() {
        window.clearTimeout(this.cameraAccessTimeout), this.cameraAccessTimeout = window.setTimeout(async ()=>{
            var e;
            document.visibilityState === "visible" ? (await this.stopStream(!0), (e = this.cameraAccessRejectCallback) == null || e.call(this, new (0, $4fd6157d2364abb3$export$407448d2b89b1813)(n.notReadableErrorParameters))) : ((0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Page is currently not visible, delay camera video stream access detection"), document.addEventListener("visibilitychange", this.checkCameraVideoStreamAccessIfVisibleListener));
        }, n.cameraAccessTimeoutMs);
    }
    setupAutofocus() {
        if (window.clearTimeout(this.manualFocusWaitTimeout), window.clearTimeout(this.manualToAutofocusResumeTimeout), this.mediaStream && this.mediaTrackCapabilities) {
            let e = this.mediaTrackCapabilities.focusMode;
            Array.isArray(e) && !e.includes("continuous") && e.includes("single-shot") && (window.clearInterval(this.autofocusInterval), this.autofocusInterval = window.setInterval(this.triggerAutoFocus.bind(this), n.autofocusIntervalMs));
        }
    }
    async setupCameraStreamVideo(e, t) {
        this.videoElement.addEventListener("loadedmetadata", this.postStreamInitializationListener), this.videoElement.addEventListener("resize", this.videoResizeListener), this.tapToFocusEnabled && this.enableTapToFocusListeners(), this.pinchToZoomEnabled && this.enablePinchToZoomListeners();
        let i = Promise.race([
            this.checkCameraAccess(e),
            this.checkVideoMetadata(e),
            new Promise((r)=>{
                this.abortedCameraInitializationResolveCallback = r;
            })
        ]);
        return this.videoElement.srcObject = t, this.videoElement.load(), await this.playVideo(), this.handleVideoResize(), this.reportCameraProperties(e.deviceId, e.position), i;
    }
    async setupCamerasAndStream() {
        var e, t;
        try {
            let i;
            this.selectedCamera == null && (i = await this.accessInitialCamera());
            let r = await (0, $fa51dabf90952f18$export$4368d992c4eafac0).getCameras(!1, !0), s = (t = (e = this.mediaStream) == null ? void 0 : e.getVideoTracks()[0]) == null ? void 0 : t.getSettings().deviceId;
            if (this.mediaStream && i) {
                let o = this.getActiveCamera(r, i.label, s);
                if (o) {
                    if ((0, $fa51dabf90952f18$export$4368d992c4eafac0).adjustCameraFromMediaStream(this.mediaStream, o), (0, $08663c8936fe6aaa$export$407448d2b89b1813).isDesktopDevice() && ((0, $fa51dabf90952f18$export$4368d992c4eafac0).setMainCameraForPositionOverridesOnDesktop(this.cameraPosition, o), (0, $fa51dabf90952f18$export$4368d992c4eafac0).setMainCameraForPositionOverridesOnDesktop(o.position, o)), r.length === 1 || (0, $fa51dabf90952f18$export$4368d992c4eafac0).getMainCameraForPosition(r, this.cameraPosition) === o) {
                        (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Initial camera access was correct (main camera), keep camera:", o), this.setSelectedCamera(o), this.updateActiveCameraCurrentResolution(o), await this.recoverStreamIfNeeded();
                        return;
                    }
                    (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Initial camera access was incorrect (not main camera), change camera", {
                        ...i,
                        deviceId: s
                    });
                } else (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Initial camera access was incorrect (unknown camera), change camera", {
                    ...i,
                    deviceId: s
                });
            }
            if (this.selectedCamera == null) {
                await this.accessAutoselectedCamera(r);
                return;
            }
            await this.initializeCameraWithSettings(this.selectedCamera, this.selectedCameraSettings);
        } finally{
            this.cameraSetupPromise = void 0;
        }
    }
    storeStreamCapabilities() {
        var e;
        if (this.mediaStream) {
            let t = this.mediaStream.getVideoTracks();
            t.length > 0 && typeof t[0].getCapabilities == "function" && (this.mediaTrackCapabilities = t[0].getCapabilities()), this.mediaTrackCapabilitiesPromiseResolver && this.mediaTrackCapabilitiesPromiseResolver();
        }
        this.activeCamera && this.reportCameraProperties(this.activeCamera.deviceId, this.activeCamera.position, ((e = this.mediaTrackCapabilities) == null ? void 0 : e.focusMode) == null || this.mediaTrackCapabilities.focusMode.includes("continuous"));
    }
    async triggerAutoFocus() {
        await this.triggerFocusMode("single-shot");
    }
    async triggerFocusMode(e) {
        if (this.mediaStream) {
            let t = this.mediaStream.getVideoTracks();
            if (t.length > 0 && typeof t[0].applyConstraints == "function") try {
                await t[0].applyConstraints({
                    advanced: [
                        {
                            focusMode: e
                        }
                    ]
                });
            } catch (i) {}
        }
    }
    async triggerManualFocus(e) {
        if (e) {
            if (e.preventDefault(), e.type === "touchend" && e.touches.length > 0) return;
            if (this.pinchToZoomDistance != null) {
                this.pinchToZoomDistance = void 0;
                return;
            }
        }
        if (window.clearTimeout(this.manualFocusWaitTimeout), window.clearTimeout(this.manualToAutofocusResumeTimeout), !this.mediaStream || !this.mediaTrackCapabilities) return;
        let t = this.mediaTrackCapabilities.focusMode;
        Array.isArray(t) && t.includes("single-shot") && (t.includes("continuous") && t.includes("manual") ? await this.triggerManualFocusForContinuous() : t.includes("continuous") || await this.triggerManualFocusForSingleShot());
    }
    async triggerManualFocusForContinuous() {
        var i;
        if (!this.mediaStream) return;
        this.manualToAutofocusResumeTimeout = window.setTimeout(async ()=>{
            await this.triggerFocusMode("continuous");
        }, n.manualToAutofocusResumeTimeoutMs);
        let e = !0, t = this.mediaStream.getVideoTracks();
        t.length > 0 && typeof t[0].getConstraints == "function" && (e = ((i = t[0].getConstraints().advanced) == null ? void 0 : i.some((r)=>r.focusMode === "manual")) === !0), e ? (await this.triggerFocusMode("continuous"), this.manualFocusWaitTimeout = window.setTimeout(async ()=>{
            await this.triggerFocusMode("manual");
        }, n.manualFocusWaitTimeoutMs)) : await this.triggerFocusMode("manual");
    }
    async triggerManualFocusForSingleShot() {
        window.clearInterval(this.autofocusInterval), this.manualToAutofocusResumeTimeout = window.setTimeout(()=>{
            this.autofocusInterval = window.setInterval(this.triggerAutoFocus.bind(this), n.autofocusIntervalMs);
        }, n.manualToAutofocusResumeTimeoutMs);
        try {
            await this.triggerFocusMode("single-shot");
        } catch (e) {}
    }
    async triggerZoomMove(e) {
        this.pinchToZoomDistance == null || (e == null ? void 0 : e.touches.length) !== 2 || e.preventDefault();
    }
    triggerZoomStart(e) {
        var r, s, o, m;
        if ((e == null ? void 0 : e.touches.length) !== 2 || (e.preventDefault(), this.pinchToZoomDistance = Math.hypot((e.touches[1].screenX - e.touches[0].screenX) / screen.width, (e.touches[1].screenY - e.touches[0].screenY) / screen.height), !this.mediaStream || !((r = this.mediaTrackCapabilities) != null && r.zoom))) return;
        let t = this.mediaStream.getVideoTracks();
        if (t.length === 0 || typeof t[0].getConstraints != "function") return;
        this.pinchToZoomInitialZoom = (s = this.mediaTrackCapabilities.zoom.min) != null ? s : 1;
        let i = t[0].getConstraints();
        if (i.advanced) {
            let d = (o = i.advanced.find((l)=>"zoom" in l)) == null ? void 0 : o.zoom;
            d != null && (this.pinchToZoomInitialZoom = typeof d == "number" ? d : (m = d.ideal) != null ? m : 1);
        }
    }
    updateActiveCameraCurrentResolution(e) {
        this.videoElement.videoWidth > 2 && this.videoElement.videoHeight > 2 && (e.currentResolution = {
            width: this.videoElement.videoWidth,
            height: this.videoElement.videoHeight
        }), e.deviceId !== "" && (this.activeCamera = e, this.setMirrorImageEnabled(this.isMirrorImageEnabled(), !1));
    }
    async updateStreamForResolution(e, t) {
        var i;
        if (this.mediaStream == null) await this.initializeCameraForResolution(e, t);
        else try {
            let r = (i = this.activeCameraSettings) == null ? void 0 : i.getProperty("preferredAspectRatio");
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Setting new resolution for active camera video stream..."), await this.mediaStream.getVideoTracks()[0].applyConstraints((0, $fa51dabf90952f18$export$4368d992c4eafac0).getUserMediaVideoParameters(t, r)), await new Promise((o)=>{
                this.videoElement.addEventListener("timeupdate", ()=>{
                    o();
                }, {
                    once: !0
                });
            });
            let s = this.mediaStream.getVideoTracks()[0].getSettings();
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "New active camera video stream resolution set", {
                width: s.width,
                height: s.height
            });
        } catch (r) {
            if (t === 4) throw r;
            await this.updateStreamForResolution(e, t + 1);
        }
    }
    async videoTrackEndedRecovery() {
        if (document.visibilityState === "visible") try {
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, 'Detected video track "ended" event, try to reinitialize camera'), await this.reinitializeCamera();
        } catch (e) {}
        else (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Page is currently not visible, delay camera reinitialization until visible"), document.addEventListener("visibilitychange", this.checkCameraVideoStreamAccessIfVisibleListener);
    }
    videoTrackMuteRecovery(e) {
        if (this.videoElement.onloadeddata != null) {
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, `Detected video track "${e.type}" event, delay camera video stream access detection`), this.setCameraAccessTimeout();
            return;
        }
        let t = e.type === "mute";
        t !== this.gui.isCameraRecoveryVisible() && ((0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, `Detected video track "${e.type}" event, ${t ? "enable" : "disable"} camera recovery`), this.gui.setCameraRecoveryVisible(t));
    }
};
$593c5318613e8031$var$n.autofocusIntervalMs = 1500, $593c5318613e8031$var$n.cameraAccessTimeoutMs = 4e3, $593c5318613e8031$var$n.getCapabilitiesTimeoutMs = 500, $593c5318613e8031$var$n.manualFocusWaitTimeoutMs = 400, $593c5318613e8031$var$n.manualToAutofocusResumeTimeoutMs = 5e3, $593c5318613e8031$var$n.noCameraErrorParameters = {
    name: "NoCameraAvailableError",
    message: "No camera available"
}, $593c5318613e8031$var$n.notReadableErrorParameters = {
    name: "NotReadableError",
    message: "Could not initialize camera correctly"
}, $593c5318613e8031$var$n.videoMetadataCheckIntervalMs = 50, $593c5318613e8031$var$n.videoMetadataCheckTimeoutMs = 4e3, $593c5318613e8031$var$n.MIRRORED_CLASS_NAME = (0, $80d48380ab62f10e$export$407448d2b89b1813).MIRRORED_CLASS_NAME, $593c5318613e8031$var$n._instance = null;
var $593c5318613e8031$export$4368d992c4eafac0 = $593c5318613e8031$var$n;




var $ec0c8796762efcd7$export$407448d2b89b1813 = "data:audio/mp3;base64,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", $ec0c8796762efcd7$export$8b22cf2602fb60ce = "PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTU4IDEwSDI4LjZMMjIuOS41QTEgMSAwIDAgMCAyMiAwSDJhMiAyIDAgMCAwLTIgMnY0NmE2IDYgMCAwIDAgNiA2aDQ4YTYgNiAwIDAgMCA2LTZWMTJhMiAyIDAgMCAwLTItMlptLTM3LjUgOGE0LjUgNC41IDAgMSAxIDAgOSA0LjUgNC41IDAgMCAxIDAtOVptMjcuNCAyNy41YTEgMSAwIDAgMS0uOS41SDEzYTEgMSAwIDAgMS0uOC0xLjVsNy0xMWExIDEgMCAwIDEgMS42LS4xbDUgNiA5LjQtMTVhMSAxIDAgMCAxIDEuMy0uM2wuNC40IDExIDIwYTEgMSAwIDAgMSAwIDFaIi8+PC9zdmc+", $ec0c8796762efcd7$export$db3b6bfb95261072 = "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", $ec0c8796762efcd7$export$4368d992c4eafac0 = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";


var $0ff37fbb7e4f9b60$export$407448d2b89b1813 = ((i)=>(i.Rounded = "rounded", i.Square = "square", i))($0ff37fbb7e4f9b60$export$407448d2b89b1813 || {}), $0ff37fbb7e4f9b60$export$8b22cf2602fb60ce = ((i)=>(i.Light = "light", i.Bold = "bold", i))($0ff37fbb7e4f9b60$export$8b22cf2602fb60ce || {}), $0ff37fbb7e4f9b60$export$db3b6bfb95261072 = ((e)=>(e.Animated = "animated", e))($0ff37fbb7e4f9b60$export$db3b6bfb95261072 || {}), $0ff37fbb7e4f9b60$export$4368d992c4eafac0 = class r {
    constructor(e){
        this._isLooping = !1;
        this._isLooping = e;
    }
    get isLooping() {
        return this._isLooping;
    }
    static fromJSON(e) {
        return e === null ? null : new r(e.looping);
    }
    toJSONObject() {
        return {
            looping: this.isLooping
        };
    }
};


var $3c3c81672794fa7f$export$407448d2b89b1813 = ((e)=>(e.Minimal = "minimal", e.Extended = "extended", e))($3c3c81672794fa7f$export$407448d2b89b1813 || {}), $3c3c81672794fa7f$export$8b22cf2602fb60ce = class {
    constructor(){
        this.type = "tapToFocus";
    }
    toJSONObject() {
        return {
            type: this.type
        };
    }
}, $3c3c81672794fa7f$export$db3b6bfb95261072 = class {
    constructor(){
        this.type = "swipeToZoom";
    }
    toJSONObject() {
        return {
            type: this.type
        };
    }
};


var $72be97bdfeffe3ee$export$407448d2b89b1813 = class e {
    constructor(t, i){
        this._x = t, this._y = i;
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
    static fromJSON(t) {
        return new e(t.x, t.y);
    }
    toJSONObject() {
        return {
            x: this.x,
            y: this.y
        };
    }
}, $72be97bdfeffe3ee$export$8b22cf2602fb60ce = class e {
    constructor(t, i, r, o){
        this._topLeft = t, this._topRight = i, this._bottomRight = r, this._bottomLeft = o;
    }
    get topLeft() {
        return this._topLeft;
    }
    get topRight() {
        return this._topRight;
    }
    get bottomRight() {
        return this._bottomRight;
    }
    get bottomLeft() {
        return this._bottomLeft;
    }
    static fromJSON(t) {
        return new e($72be97bdfeffe3ee$export$407448d2b89b1813.fromJSON(t.topLeft), $72be97bdfeffe3ee$export$407448d2b89b1813.fromJSON(t.topRight), $72be97bdfeffe3ee$export$407448d2b89b1813.fromJSON(t.bottomRight), $72be97bdfeffe3ee$export$407448d2b89b1813.fromJSON(t.bottomLeft));
    }
    toJSONObject() {
        return {
            topLeft: this.topLeft.toJSONObject(),
            topRight: this.topRight.toJSONObject(),
            bottomLeft: this.bottomLeft.toJSONObject(),
            bottomRight: this.bottomRight.toJSONObject()
        };
    }
}, $72be97bdfeffe3ee$export$db3b6bfb95261072 = ((i)=>(i.Pixel = "pixel", i.Fraction = "fraction", i))($72be97bdfeffe3ee$export$db3b6bfb95261072 || {}), $72be97bdfeffe3ee$export$4368d992c4eafac0 = class e {
    constructor(t, i){
        this._value = t, this._unit = i;
    }
    get value() {
        return this._value;
    }
    get unit() {
        return this._unit;
    }
    static fromJSON(t) {
        return new e(t.value, t.unit);
    }
    toJSONObject() {
        return {
            unit: this.unit,
            value: this.value
        };
    }
}, $72be97bdfeffe3ee$export$f1e1789686576879 = class e {
    constructor(t, i){
        this._x = t, this._y = i;
    }
    static get zero() {
        return new e(new $72be97bdfeffe3ee$export$4368d992c4eafac0(0, "pixel"), new $72be97bdfeffe3ee$export$4368d992c4eafac0(0, "pixel"));
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
    static fromJSON(t) {
        return new e($72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.x), $72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.y));
    }
    toJSONObject() {
        return {
            x: this.x.toJSONObject(),
            y: this.y.toJSONObject()
        };
    }
}, $72be97bdfeffe3ee$export$2d1720544b23b823 = class {
    constructor(t, i){
        this._origin = t, this._size = i;
    }
    get origin() {
        return this._origin;
    }
    get size() {
        return this._size;
    }
    toJSONObject() {
        return {
            origin: this.origin.toJSONObject(),
            size: this.size.toJSONObject()
        };
    }
}, $72be97bdfeffe3ee$export$39b482c5e57630a8 = class {
    constructor(t, i){
        this._origin = t, this._size = i;
    }
    get origin() {
        return this._origin;
    }
    get size() {
        return this._size;
    }
    toJSONObject() {
        return {
            origin: this._origin.toJSONObject(),
            size: this._size.toJSONObject()
        };
    }
}, $72be97bdfeffe3ee$export$dda1d9f60106f0e9 = class e {
    constructor(t, i){
        this._width = t, this._height = i;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    static fromJSON(t) {
        return new e($72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.width), $72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.height));
    }
    isSameAs(t) {
        return JSON.stringify(this.toJSONObject()) === JSON.stringify(t.toJSONObject());
    }
    toJSONObject() {
        return {
            width: this.width.toJSONObject(),
            height: this.height.toJSONObject()
        };
    }
}, $72be97bdfeffe3ee$export$23f2a1d2818174ef = class e {
    constructor(t, i){
        this._width = t, this._height = i;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    static fromJSON(t) {
        return new e(t.width, t.height);
    }
    toJSONObject() {
        return {
            height: this.height,
            width: this.width
        };
    }
}, $72be97bdfeffe3ee$export$35e795649ee09318 = class {
    constructor(t, i){
        this._size = t, this._aspect = i;
    }
    get size() {
        return this._size;
    }
    get aspect() {
        return this._aspect;
    }
}, $72be97bdfeffe3ee$export$342063e11d6c3cad = ((o)=>(o.WidthAndHeight = "widthAndHeight", o.WidthAndAspectRatio = "widthAndAspectRatio", o.HeightAndAspectRatio = "heightAndAspectRatio", o.ShorterDimensionAndAspectRatio = "shorterDimensionAndAspectRatio", o))($72be97bdfeffe3ee$export$342063e11d6c3cad || {}), $72be97bdfeffe3ee$export$882b5998b3b9117c = class e {
    constructor(){
        this._shorterDimensionAndAspectRatio = null;
    }
    get widthAndHeight() {
        return this._widthAndHeight;
    }
    get widthAndAspectRatio() {
        return this._widthAndAspectRatio;
    }
    get heightAndAspectRatio() {
        return this._heightAndAspectRatio;
    }
    get shorterDimensionAndAspectRatio() {
        return this._shorterDimensionAndAspectRatio;
    }
    get sizingMode() {
        return this.widthAndAspectRatio ? "widthAndAspectRatio" : this.heightAndAspectRatio ? "heightAndAspectRatio" : this.shorterDimensionAndAspectRatio ? "shorterDimensionAndAspectRatio" : "widthAndHeight";
    }
    static sizeWithWidthAndHeight(t) {
        let i = new e;
        return i._widthAndHeight = t, i;
    }
    static sizeWithWidthAndAspectRatio(t, i) {
        let r = new e;
        return r._widthAndAspectRatio = new $72be97bdfeffe3ee$export$35e795649ee09318(t, i), r;
    }
    static sizeWithHeightAndAspectRatio(t, i) {
        let r = new e;
        return r._heightAndAspectRatio = new $72be97bdfeffe3ee$export$35e795649ee09318(t, i), r;
    }
    static sizeWithShorterDimensionAndAspectRatio(t, i) {
        let r = new e;
        return r._shorterDimensionAndAspectRatio = new $72be97bdfeffe3ee$export$35e795649ee09318(t, i), r;
    }
    static fromJSON(t) {
        if (t.width && t.height) return this.sizeWithWidthAndHeight(new $72be97bdfeffe3ee$export$dda1d9f60106f0e9($72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.width), $72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.height)));
        if (t.width && typeof t.aspect == "number") return this.sizeWithWidthAndAspectRatio($72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.width), t.aspect);
        if (t.height && typeof t.aspect == "number") return this.sizeWithHeightAndAspectRatio($72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.height), t.aspect);
        if (t.shorterDimension && typeof t.aspect == "number") return this.sizeWithShorterDimensionAndAspectRatio($72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.shorterDimension), t.aspect);
        throw new Error(`SizeWithUnitAndAspectJSON is malformed: ${JSON.stringify(t)}`);
    }
    toJSONObject() {
        var t, i, r, o, s, c, h, b;
        switch(this.sizingMode){
            case "widthAndAspectRatio":
                return {
                    width: (t = this.widthAndAspectRatio) == null ? void 0 : t.size.toJSONObject(),
                    aspect: (i = this.widthAndAspectRatio) == null ? void 0 : i.aspect
                };
            case "heightAndAspectRatio":
                return {
                    height: (r = this.heightAndAspectRatio) == null ? void 0 : r.size.toJSONObject(),
                    aspect: (o = this.heightAndAspectRatio) == null ? void 0 : o.aspect
                };
            case "shorterDimensionAndAspectRatio":
                return {
                    shorterDimension: (s = this.shorterDimensionAndAspectRatio) == null ? void 0 : s.size.toJSONObject(),
                    aspect: (c = this.shorterDimensionAndAspectRatio) == null ? void 0 : c.aspect
                };
            default:
                return {
                    width: (h = this.widthAndHeight) == null ? void 0 : h.width.toJSONObject(),
                    height: (b = this.widthAndHeight) == null ? void 0 : b.height.toJSONObject()
                };
        }
    }
}, $72be97bdfeffe3ee$export$953cecd6e717a553 = class e {
    constructor(t, i, r, o){
        this._left = t, this._top = i, this._right = r, this._bottom = o;
    }
    static get zero() {
        return new e(new $72be97bdfeffe3ee$export$4368d992c4eafac0(0, "pixel"), new $72be97bdfeffe3ee$export$4368d992c4eafac0(0, "pixel"), new $72be97bdfeffe3ee$export$4368d992c4eafac0(0, "pixel"), new $72be97bdfeffe3ee$export$4368d992c4eafac0(0, "pixel"));
    }
    get left() {
        return this._left;
    }
    get right() {
        return this._right;
    }
    get top() {
        return this._top;
    }
    get bottom() {
        return this._bottom;
    }
    static fromJSON(t) {
        return new e($72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.left), $72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.top), $72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.right), $72be97bdfeffe3ee$export$4368d992c4eafac0.fromJSON(t.bottom));
    }
    toJSONObject() {
        return {
            left: this.left.toJSONObject(),
            right: this.right.toJSONObject(),
            top: this.top.toJSONObject(),
            bottom: this.bottom.toJSONObject()
        };
    }
}, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5 = class e {
    constructor(t){
        this.hexadecimalString = t;
    }
    get redComponent() {
        return this.hexadecimalString.slice(0, 2);
    }
    get greenComponent() {
        return this.hexadecimalString.slice(2, 4);
    }
    get blueComponent() {
        return this.hexadecimalString.slice(4, 6);
    }
    get alphaComponent() {
        return this.hexadecimalString.slice(6, 8);
    }
    get red() {
        return e.hexToNumber(this.redComponent);
    }
    get green() {
        return e.hexToNumber(this.greenComponent);
    }
    get blue() {
        return e.hexToNumber(this.blueComponent);
    }
    get alpha() {
        return e.hexToNumber(this.alphaComponent);
    }
    static fromHex(t) {
        return new e(e.normalizeHex(t));
    }
    static fromRGBA(t, i, r, o = 1) {
        let s = [
            t,
            i,
            r,
            this.normalizeAlpha(o)
        ].reduce((c, h)=>c + this.numberToHex(h), "");
        return new e(s);
    }
    static areEquals(t, i) {
        return t == null || i == null ? !1 : t.hexadecimalString === i.hexadecimalString;
    }
    static hexToNumber(t) {
        return Number.parseInt(t, 16);
    }
    static fromJSON(t) {
        return e.fromHex(t);
    }
    static numberToHex(t) {
        let r = Math.round(t).toString(16);
        return r.length === 1 && (r = `0${r}`), r.toUpperCase();
    }
    static normalizeHex(t) {
        let i = t;
        return i.startsWith("#") && (i = i.slice(1)), i.length < 6 && (i = [
            ...i
        ].map((r)=>r + r).join("")), i.length === 6 && (i += "FF"), i.toUpperCase();
    }
    static normalizeAlpha(t) {
        return t > 0 && t <= 1 ? 255 * t : t;
    }
    withAlpha(t) {
        let i = this.hexadecimalString.slice(0, 6) + e.numberToHex(e.normalizeAlpha(t));
        return e.fromHex(i);
    }
    toJSON() {
        return this.hexadecimalString;
    }
}, $72be97bdfeffe3ee$export$ae1af26003f05816 = ((s)=>(s.Unknown = "unknown", s.Portrait = "portrait", s.PortraitUpsideDown = "portraitUpsideDown", s.LandscapeRight = "landscapeRight", s.LandscapeLeft = "landscapeLeft", s))($72be97bdfeffe3ee$export$ae1af26003f05816 || {}), $72be97bdfeffe3ee$export$ffb5f4729a158638 = ((h)=>(h.None = "none", h.Horizontal = "horizontal", h.LeftToRight = "leftToRight", h.RightToLeft = "rightToLeft", h.Vertical = "vertical", h.TopToBottom = "topToBottom", h.BottomToTop = "bottomToTop", h))($72be97bdfeffe3ee$export$ffb5f4729a158638 || {}), $72be97bdfeffe3ee$export$9e5f44173e64f162 = ((u)=>(u.TopLeft = "topLeft", u.TopCenter = "topCenter", u.TopRight = "topRight", u.CenterLeft = "centerLeft", u.Center = "center", u.CenterRight = "centerRight", u.BottomLeft = "bottomLeft", u.BottomCenter = "bottomCenter", u.BottomRight = "bottomRight", u))($72be97bdfeffe3ee$export$9e5f44173e64f162 || {});


var $520f4e9f5a30204d$export$407448d2b89b1813 = class {
    static fromJSON(t) {
        return (t == null ? void 0 : t.type) === "tapToFocus" ? new (0, $3c3c81672794fa7f$export$8b22cf2602fb60ce) : null;
    }
}, $520f4e9f5a30204d$export$8b22cf2602fb60ce = class {
    static fromJSON(t) {
        return (t == null ? void 0 : t.type) === "swipeToZoom" ? new (0, $3c3c81672794fa7f$export$db3b6bfb95261072) : null;
    }
};
function $520f4e9f5a30204d$var$l(e) {
    let t = "document" in globalThis ? globalThis.document : void 0, i = t == null ? void 0 : t.createRange().createContextualFragment(e);
    if (i) return i.firstElementChild;
}
function $520f4e9f5a30204d$export$db3b6bfb95261072(e$1) {
    var t;
    return {
        Camera: {
            Settings: {
                preferredResolution: e$1.Camera.Settings.preferredResolution,
                zoomFactor: e$1.Camera.Settings.zoomFactor,
                zoomGestureZoomFactor: e$1.Camera.Settings.zoomGestureZoomFactor,
                focusGestureStrategy: e$1.Camera.Settings.focusGestureStrategy
            },
            defaultPosition: (t = e$1.Camera.defaultPosition) != null ? t : null,
            availablePositions: e$1.Camera.availablePositions
        },
        SingleImageUploader: {
            Settings: {
                iconElement: $520f4e9f5a30204d$var$l(e$1.SingleImageUploader.Settings.iconElement),
                informationElement: $520f4e9f5a30204d$var$l(e$1.SingleImageUploader.Settings.informationElement),
                buttonElement: $520f4e9f5a30204d$var$l(e$1.SingleImageUploader.Settings.buttonElement),
                containerStyle: e$1.SingleImageUploader.Settings.containerStyle,
                iconStyle: e$1.SingleImageUploader.Settings.iconStyle,
                informationStyle: e$1.SingleImageUploader.Settings.informationStyle,
                buttonStyle: e$1.SingleImageUploader.Settings.buttonStyle,
                onlyCameraCapture: e$1.SingleImageUploader.Settings.onlyCameraCapture
            }
        },
        DataCaptureView: {
            scanAreaMargins: (0, $72be97bdfeffe3ee$export$953cecd6e717a553).fromJSON(JSON.parse(e$1.DataCaptureView.scanAreaMargins)),
            pointOfInterest: (0, $72be97bdfeffe3ee$export$f1e1789686576879).fromJSON(JSON.parse(e$1.DataCaptureView.pointOfInterest)),
            logoStyle: e$1.DataCaptureView.logoStyle,
            logoAnchor: e$1.DataCaptureView.logoAnchor,
            logoOffset: (0, $72be97bdfeffe3ee$export$f1e1789686576879).fromJSON(JSON.parse(e$1.DataCaptureView.logoOffset)),
            focusGesture: $520f4e9f5a30204d$export$407448d2b89b1813.fromJSON(JSON.parse(e$1.DataCaptureView.focusGesture)),
            zoomGesture: $520f4e9f5a30204d$export$8b22cf2602fb60ce.fromJSON(JSON.parse(e$1.DataCaptureView.zoomGesture)),
            cameraRecoveryText: e$1.DataCaptureView.cameraRecoveryText
        },
        LaserlineViewfinder: Object.keys(e$1.LaserlineViewfinder.styles).reduce((i, o)=>{
            let r = e$1.LaserlineViewfinder.styles[o];
            return i.styles[o] = {
                width: (0, $72be97bdfeffe3ee$export$4368d992c4eafac0).fromJSON(JSON.parse(r.width)),
                enabledColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(r.enabledColor),
                disabledColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(r.disabledColor),
                style: r.style
            }, i;
        }, {
            defaultStyle: e$1.LaserlineViewfinder.defaultStyle,
            styles: {}
        }),
        RectangularViewfinder: Object.keys(e$1.RectangularViewfinder.styles).reduce((i, o)=>{
            let r = e$1.RectangularViewfinder.styles[o];
            return i.styles[o] = {
                size: (0, $72be97bdfeffe3ee$export$882b5998b3b9117c).fromJSON(JSON.parse(r.size)),
                color: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(r.color),
                style: r.style,
                lineStyle: r.lineStyle,
                dimming: Number.parseFloat(r.dimming.toString()),
                animation: (0, $0ff37fbb7e4f9b60$export$4368d992c4eafac0).fromJSON(JSON.parse(r.animation))
            }, i;
        }, {
            defaultStyle: e$1.RectangularViewfinder.defaultStyle,
            styles: {}
        }),
        AimerViewfinder: {
            frameColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e$1.AimerViewfinder.frameColor),
            dotColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e$1.AimerViewfinder.dotColor)
        },
        Brush: {
            fillColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e$1.Brush.fillColor),
            strokeColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e$1.Brush.strokeColor),
            strokeWidth: e$1.Brush.strokeWidth
        },
        Feedback: {
            defaultVibrationPattern: e$1.Feedback.defaultVibrationPattern
        }
    };
}
var $520f4e9f5a30204d$export$4368d992c4eafac0 = $520f4e9f5a30204d$export$db3b6bfb95261072({
    DataCaptureView: {
        focusGesture: "null",
        zoomGesture: "null",
        logoAnchor: "bottomRight",
        logoStyle: "extended",
        logoOffset: JSON.stringify({
            x: {
                value: 0,
                unit: "fraction"
            },
            y: {
                value: 0,
                unit: "fraction"
            }
        }),
        pointOfInterest: JSON.stringify({
            x: {
                value: .5,
                unit: "fraction"
            },
            y: {
                value: .5,
                unit: "fraction"
            }
        }),
        scanAreaMargins: JSON.stringify({
            left: {
                value: 0,
                unit: "fraction"
            },
            right: {
                value: 0,
                unit: "fraction"
            },
            top: {
                value: 0,
                unit: "fraction"
            },
            bottom: {
                value: 0,
                unit: "fraction"
            }
        }),
        cameraRecoveryText: "(This text is updated from translations)"
    },
    Camera: {
        Settings: {
            preferredResolution: "auto",
            zoomFactor: 1,
            focusGestureStrategy: "manualUntilCapture",
            zoomGestureZoomFactor: 2
        },
        defaultPosition: "worldFacing",
        availablePositions: [
            "worldFacing",
            "userFacing"
        ]
    },
    SingleImageUploader: {
        Settings: {
            iconElement: atob((0, $ec0c8796762efcd7$export$8b22cf2602fb60ce)),
            informationElement: "<p data-scandit-default>(This text is updated from translations)</p>",
            buttonElement: "<div data-scandit-default>(This text is updated from translations)</div>",
            containerStyle: {
                backgroundColor: "#FFFFFF"
            },
            iconStyle: {
                fill: "#121619"
            },
            informationStyle: {
                color: "#121619",
                marginBottom: "2em"
            },
            buttonStyle: {
                color: "#FFFFFF",
                backgroundColor: "#121619",
                fontWeight: "bold",
                padding: "1.25em",
                width: "12em",
                textAlign: "center",
                textTransform: "uppercase"
            },
            onlyCameraCapture: !1
        }
    },
    LaserlineViewfinder: {
        defaultStyle: "animated",
        styles: {
            animated: {
                width: JSON.stringify({
                    unit: "fraction",
                    value: .8
                }),
                enabledColor: "#FFFFFFFF",
                disabledColor: "#00000000",
                style: "animated"
            }
        }
    },
    AimerViewfinder: {
        frameColor: "#FFFFFFFF",
        dotColor: "#FFFFFFCC"
    },
    RectangularViewfinder: {
        defaultStyle: "rounded",
        styles: {
            rounded: {
                size: JSON.stringify({
                    aspect: 1,
                    shorterDimension: {
                        unit: "fraction",
                        value: .75
                    }
                }),
                color: "#FFFFFFFF",
                style: "rounded",
                lineStyle: "light",
                dimming: 0,
                animation: JSON.stringify({
                    looping: !0
                })
            },
            square: {
                size: JSON.stringify({
                    aspect: 1,
                    shorterDimension: {
                        unit: "fraction",
                        value: .75
                    }
                }),
                color: "#FFFFFFFF",
                style: "square",
                lineStyle: "light",
                dimming: 0,
                animation: JSON.stringify({
                    looping: !0
                })
            }
        }
    },
    Brush: {
        fillColor: "#00000000",
        strokeColor: "#00000000",
        strokeWidth: 0
    },
    Feedback: {
        defaultVibrationPattern: [
            300
        ]
    }
});
function $520f4e9f5a30204d$export$f1e1789686576879(e) {
    $520f4e9f5a30204d$export$4368d992c4eafac0 = e;
}


var $26b53f2fcaea5d86$export$407448d2b89b1813 = ((o)=>(o.On = "on", o.Off = "off", o.Standby = "standby", o.Starting = "starting", o.Stopping = "stopping", o.BootingUp = "bootingUp", o.WakingUp = "wakingUp", o.GoingToSleep = "goingToSleep", o.ShuttingDown = "shuttingDown", o))($26b53f2fcaea5d86$export$407448d2b89b1813 || {}), $26b53f2fcaea5d86$export$8b22cf2602fb60ce = ((t)=>(t.On = "on", t.Off = "off", t))($26b53f2fcaea5d86$export$8b22cf2602fb60ce || {}), $26b53f2fcaea5d86$export$db3b6bfb95261072 = ((t)=>(t.WorldFacing = "worldFacing", t.UserFacing = "userFacing", t))($26b53f2fcaea5d86$export$db3b6bfb95261072 || {}), $26b53f2fcaea5d86$export$4368d992c4eafac0 = ((r)=>(r.Auto = "auto", r.HD = "hd", r.FullHD = "fullHd", r.UHD4K = "uhd4k", r))($26b53f2fcaea5d86$export$4368d992c4eafac0 || {}), $26b53f2fcaea5d86$export$f1e1789686576879 = ((r)=>(r.None = "none", r.Manual = "manual", r.ManualUntilCapture = "manualUntilCapture", r.AutoOnLocation = "autoOnLocation", r))($26b53f2fcaea5d86$export$f1e1789686576879 || {});
function $26b53f2fcaea5d86$export$2d1720544b23b823(a) {
    var e;
    return ((e = a == null ? void 0 : a.toJSONObject()) == null ? void 0 : e.type) === "camera";
}
var $26b53f2fcaea5d86$export$39b482c5e57630a8 = class a {
    constructor(e){
        this.preferredResolution = (0, $520f4e9f5a30204d$export$4368d992c4eafac0).Camera.Settings.preferredResolution;
        this.zoomFactor = (0, $520f4e9f5a30204d$export$4368d992c4eafac0).Camera.Settings.zoomFactor;
        this.zoomGestureZoomFactor = (0, $520f4e9f5a30204d$export$4368d992c4eafac0).Camera.Settings.zoomGestureZoomFactor;
        this.focus = {
            focusGestureStrategy: (0, $520f4e9f5a30204d$export$4368d992c4eafac0).Camera.Settings.focusGestureStrategy
        };
        if (e != null) for (let t of Object.getOwnPropertyNames(e))this[t] = e[t];
    }
    get focusGestureStrategy() {
        return this.focus.focusGestureStrategy;
    }
    set focusGestureStrategy(e) {
        this.focus.focusGestureStrategy = e;
    }
    static fromJSON(e) {
        let t = new a;
        return t.preferredResolution = e.preferredResolution, t.zoomFactor = e.zoomFactor, t.zoomGestureZoomFactor = e.zoomGestureZoomFactor, t.focusGestureStrategy = e.focusGestureStrategy, t;
    }
    setProperty(e, t) {
        this[e] = t;
    }
    getProperty(e) {
        return this[e];
    }
    toJSONObject() {
        let e = {
            preferredResolution: this.preferredResolution,
            zoomFactor: this.zoomFactor,
            zoomGestureZoomFactor: this.zoomGestureZoomFactor,
            focus: {
                focusGestureStrategy: this.focus.focusGestureStrategy
            }
        }, t = {};
        for (let n of Object.keys(this))[
            ...Object.keys(e),
            "focusGestureStrategy"
        ].includes(n) || (t[n] = this[n]);
        return {
            ...e,
            ...t
        };
    }
};



var $01f73a9bc5262471$export$407448d2b89b1813 = class n {
    constructor(t){
        this.deviceId = "";
        this.type = "camera";
        this._currentState = "off";
        this._settings = new (0, $26b53f2fcaea5d86$export$39b482c5e57630a8);
        this._desiredTorchState = "off";
        this._desiredState = "off";
        this.listeners = [];
        this._context = null;
        this.stateTransitionStrategyMap = {
            off: {
                on: this.transitionFromStateOffToOn.bind(this),
                standby: this.transitionFromStateOffToStandby.bind(this)
            },
            on: {
                off: this.transitionFromStateOnToOff.bind(this),
                standby: this.transitionFromStateOnToStandby.bind(this)
            },
            standby: {
                off: this.transitionFromStateStandbyToOff.bind(this),
                on: this.transitionFromStateStandbyToOn.bind(this)
            }
        };
        this.cameraManager = t != null ? t : (0, $593c5318613e8031$export$4368d992c4eafac0).instance(), this.updateCanvasVideoImage = this.updateCanvasVideoImage.bind(this), this.captureAndSend = this.captureAndSend.bind(this);
    }
    static get default() {
        let t = new n;
        return t.position = "worldFacing", t;
    }
    get desiredState() {
        return this._desiredState;
    }
    get settings() {
        return this._settings;
    }
    get currentResolution() {
        var t;
        return (t = this._currentResolution) != null ? t : null;
    }
    get context() {
        return this._context;
    }
    set context(t) {
        this._context = t, this._context && this.currentState === "on" && this.startSendingCapturesToWorker();
    }
    get currentState() {
        return this._currentState;
    }
    static atPosition(t) {
        if ((0, $520f4e9f5a30204d$export$4368d992c4eafac0).Camera.availablePositions.includes(t)) {
            let e = new n;
            return e.position = t, e;
        }
        return (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, `invalid CameraPosition: "${t}"`), null;
    }
    static fromDeviceCamera(t) {
        let e = n.atPosition(t.position);
        return e.deviceId = t.deviceId, e.label = t.label, e;
    }
    async switchToDesiredState(t) {
        var e, i;
        return this.currentTransitionStrategyPromise && await this.currentTransitionStrategyPromise, this.currentTransitionStrategyPromise = (i = (e = this.stateTransitionStrategyMap[this.currentState]) == null ? void 0 : e[t]) == null ? void 0 : i.call(e).catch((r)=>{
            if (r instanceof DOMException && r.message === "The associated Track is in an invalid state") {
                (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, r);
                return;
            }
            throw r;
        }), this.currentTransitionStrategyPromise;
    }
    getDesiredTorchState() {
        return this._desiredTorchState;
    }
    async setDesiredTorchState(t) {
        this._desiredTorchState = t, await this.cameraManager.setTorchEnabled(this._desiredTorchState === "on"), await this.notifyContext({
            type: "torchState",
            newValue: this._desiredTorchState
        });
    }
    async isTorchAvailable() {
        return this.cameraManager.isTorchAvailable();
    }
    addListener(t) {
        t != null && (this.listeners.includes(t) || this.listeners.push(t));
    }
    removeListener(t) {
        t != null && this.listeners.includes(t) && this.listeners.splice(this.listeners.indexOf(t), 1);
    }
    async applySettings(t) {
        var i;
        this._settings = new (0, $26b53f2fcaea5d86$export$39b482c5e57630a8)(t);
        let e = this.settings.getProperty("grayScaleFrameReader");
        if (this.cameraManager.setFrameReaderType(e ? "GRAYSCALE" : "RGBA"), this.currentState === "on") {
            let r = this.cameraManager.activeCameraSettings;
            (r == null ? void 0 : r.preferredResolution) !== this.settings.preferredResolution && (await this.cameraManager.applyCameraSettings(this.settings), (i = this.cameraManager.activeCamera) != null && i.currentResolution && (this._currentResolution = {
                width: this.cameraManager.activeCamera.currentResolution.width,
                height: this.cameraManager.activeCamera.currentResolution.height
            })), await this.cameraManager.setZoom(this.settings.zoomFactor);
            let o = this.settings.getProperty("minFrameRate"), c = this.settings.getProperty("maxFrameRate");
            (o != null || c != null) && await this.cameraManager.setFrameRate({
                min: o,
                max: c
            });
            let m = this.settings.getProperty("manualLensPosition");
            m != null && await this.cameraManager.setFocus(m);
            let u = this.settings.getProperty("exposureTargetBias"), d = this.settings.getProperty("exposureDuration");
            (u != null || d != null) && await this.cameraManager.setExposure({
                compensation: u,
                time: d
            });
        }
        return this.notifyContext({
            type: "cameraSettings",
            newValue: this.settings
        });
    }
    toJSONObject() {
        return {
            type: this.type,
            position: this.position,
            settings: this.settings.toJSONObject(),
            desiredState: this.desiredState,
            desiredTorchState: this._desiredTorchState
        };
    }
    getMirrorImageEnabled() {
        var t;
        return (t = this._desiredMirrorImageEnabled) != null ? t : this.cameraManager.isMirrorImageEnabled();
    }
    async setMirrorImageEnabled(t) {
        this._desiredMirrorImageEnabled = t, this.cameraManager.setMirrorImageEnabled(t, !0), this.context && await this.context.setFrameSource(this);
    }
    getCurrentState() {
        return this._currentState;
    }
    async setCurrentState(t) {
        if (t !== this._currentState) {
            this._currentState = t, this.notifyListeners();
            try {
                if (await this.notifyContext({
                    type: "frameSourceState",
                    newValue: t
                }), t === "on") {
                    this.startSendingCapturesToWorker();
                    return;
                }
            } catch (e) {
                (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Error while notifying context about new state of Camera");
            }
        }
    }
    async setupCamera() {
        if (this.cameraManager.setSelectedCameraSettings(this.settings), this.deviceId !== "") {
            let e = (await (0, $fd2706c93ce4bdd2$export$407448d2b89b1813).getCameras()).find((i)=>i.deviceId === this.deviceId);
            e && (this.cameraManager.setInitialCameraPosition(e.position), this.cameraManager.setSelectedCamera(e));
        } else this.cameraManager.setSelectedCamera(), this.cameraManager.setInitialCameraPosition(this.position);
        await this.cameraManager.setupCameras(), typeof this._desiredMirrorImageEnabled == "boolean" ? this.cameraManager.setMirrorImageEnabled(this._desiredMirrorImageEnabled, !0) : this.cameraManager.setMirrorImageEnabled(this.cameraManager.isMirrorImageEnabled(), !1), this.context && await this.context.setFrameSource(this), this.cameraManager.activeCamera && (this.label = this.cameraManager.activeCamera.label, this.position = this.cameraManager.activeCamera.position, this.deviceId = this.cameraManager.activeCamera.deviceId, this._currentResolution = this.cameraManager.activeCamera.currentResolution);
    }
    async notifyContext(t) {
        if (this.context) return this.context.update([
            t
        ]);
    }
    notifyListeners() {
        for (let t of this.listeners)t.didChangeState && t.didChangeState(this, this.currentState);
    }
    updateCanvasVideoImage() {
        this.currentState === "on" && this.context && (this.cameraManager.updateCanvasVideoImage(), this._lastCanvasVideoPreviewAnimationFrame = this.cameraManager.requestVideoFrame(this.updateCanvasVideoImage));
    }
    async captureAndSend() {
        if (this.currentState !== "on" || !this.context) return;
        if (!this.context.hasEnabledMode()) {
            this._lastCaptureRequestAnimationFrame = this.cameraManager.requestVideoFrame(this.captureAndSend);
            return;
        }
        let t = null;
        try {
            t = this.cameraManager.captureImage();
        } catch (e) {
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, e.message);
        } finally{
            if (t != null) try {
                this.cameraManager.imageData = (await this.context.sendFrameToProcessor(t)).data;
            } catch (e) {}
            this._lastCaptureRequestAnimationFrame = this.cameraManager.requestVideoFrame(this.captureAndSend);
        }
    }
    startSendingCapturesToWorker() {
        this._lastCanvasVideoPreviewAnimationFrame != null && this.cameraManager.cancelVideoFrame(this._lastCanvasVideoPreviewAnimationFrame), this._lastCaptureRequestAnimationFrame != null && this.cameraManager.cancelVideoFrame(this._lastCaptureRequestAnimationFrame), this.captureAndSend();
    }
    async transitionFromStateOffToOn() {
        if (!(this.currentState === "on" || this.currentState === "starting" || this.currentState === "wakingUp")) {
            this._desiredState = "on", await this.setCurrentState("starting");
            try {
                await this.setupCamera(), await this.setCurrentState("on");
            } catch (t) {
                throw (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Error, t), await this.setCurrentState("off"), t;
            }
        }
    }
    async transitionFromStateOffToStandby() {
        if (!(this.currentState === "standby" || this.currentState === "bootingUp" || this.currentState === "goingToSleep")) {
            if (await this.isAndroidWebView()) {
                (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, 'Warning: "Standby" state does not work inside web views. Falling back to state "On".'), await this.transitionFromStateOffToOn();
                return;
            }
            this._desiredState = "standby", await this.setCurrentState("bootingUp");
            try {
                await this.setupCamera(), this.cameraManager.pauseStream(), await this.setCurrentState("standby");
            } catch (t) {
                throw (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Error, t), await this.setCurrentState("off"), t;
            }
            await this.setCurrentState("standby"), await this.setDesiredTorchState("off");
        }
    }
    async transitionFromStateOnToOff() {
        this.currentState === "off" || this.currentState === "stopping" || (this._desiredState = "off", await this.setCurrentState("stopping"), await this.cameraManager.stopStream(), await this.setCurrentState("off"), await this.setDesiredTorchState("off"));
    }
    async transitionFromStateOnToStandby() {
        if (!(this.currentState === "standby" || this.currentState === "bootingUp" || this.currentState === "goingToSleep")) {
            if (await this.isAndroidWebView()) {
                (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, 'Warning: "Standby" state does not work inside web views. Falling back to state "Off".'), await this.transitionFromStateOnToOff();
                return;
            }
            this._desiredState = "standby", await this.setCurrentState("goingToSleep"), this.cameraManager.pauseStream(), await this.setCurrentState("standby"), await this.setDesiredTorchState("off");
        }
    }
    async transitionFromStateStandbyToOff() {
        this.currentState === "off" || this.currentState === "stopping" || (this._desiredState = "off", await this.setCurrentState("shuttingDown"), await this.cameraManager.stopStream(), await this.setCurrentState("off"), await this.setDesiredTorchState("off"));
    }
    async transitionFromStateStandbyToOn() {
        this.currentState === "on" || this.currentState === "starting" || this.currentState === "wakingUp" || (this._desiredState = "on", await this.setCurrentState("wakingUp"), this.cameraManager.resumeStream(), await this.setCurrentState("on"));
    }
    async isAndroidWebView() {
        return this._isAndroidWebView == null && (this._isAndroidWebView = await (0, $08663c8936fe6aaa$export$407448d2b89b1813).isAndroidWebView()), this._isAndroidWebView;
    }
};

var $206a320454b17b13$export$407448d2b89b1813 = 'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none"%0A    xmlns="http://www.w3.org/2000/svg">%0A    <rect opacity="0.35" width="32" height="32" rx="16" fill="%23DAE1E7" />%0A<path d="M7.98828 21.082C8.59668 21.082 9.08887 20.5898 9.08887 19.9814C9.08887 19.3662 8.59668 18.8809 7.98828 18.8809C7.37305 18.8809 6.8877 19.3662 6.8877 19.9814C6.8877 20.5898 7.37305 21.082 7.98828 21.082Z" fill="%23F1F5F8" />%0A<path d="M14.3662 21.2188C16.6152 21.2188 18.1807 19.7969 18.1807 17.6914C18.1807 15.8115 16.8408 14.4854 14.9541 14.4854C13.9492 14.4854 13.1426 14.8818 12.7393 15.5176H12.6982L12.9307 12.7764H16.8271C17.3467 12.7764 17.6748 12.4551 17.6748 11.9561C17.6748 11.457 17.3398 11.1357 16.8271 11.1357H12.5C11.7002 11.1357 11.2695 11.4707 11.2012 12.3047L10.9141 15.9209C10.9072 15.9551 10.9072 15.9756 10.9072 16.0029C10.8799 16.5566 11.2012 17.0283 11.8779 17.0283C12.3359 17.0283 12.541 16.9258 12.9443 16.5498C13.293 16.2148 13.7852 15.9619 14.373 15.9619C15.4463 15.9619 16.2119 16.7002 16.2119 17.7393C16.2119 18.8057 15.4395 19.5781 14.3662 19.5781C13.4775 19.5781 12.8965 19.1475 12.541 18.4365C12.3086 18.0674 12.0488 17.9238 11.6387 17.9238C11.1055 17.9238 10.7773 18.2383 10.7773 18.7646C10.7773 19.0107 10.8389 19.2227 10.9414 19.4414C11.4336 20.4873 12.8008 21.2188 14.3662 21.2188Z" fill="%23F1F5F8" />%0A<path d="M19.9307 21.1436C20.2861 21.1436 20.4844 21.0273 20.7578 20.6035L22.1865 18.457H22.2275L23.6836 20.6377C23.9092 20.9795 24.1006 21.1436 24.4902 21.1436C25.0303 21.1436 25.4404 20.8018 25.4404 20.2617C25.4404 20.043 25.3721 19.8516 25.2217 19.6465L23.5195 17.2949L25.1943 15.0596C25.3857 14.8135 25.4609 14.6152 25.4609 14.3691C25.4609 13.8633 25.085 13.5215 24.5244 13.5215C24.1553 13.5215 23.9434 13.6855 23.6768 14.1025L22.3369 16.1465H22.2959L20.9287 14.0889C20.6621 13.665 20.4502 13.5215 20.0469 13.5215C19.5 13.5215 19.0898 13.8975 19.0898 14.3965C19.0898 14.6289 19.1582 14.8271 19.3018 15.0186L21.0107 17.3496L19.2949 19.6465C19.1035 19.8994 19.0283 20.0908 19.0283 20.3301C19.0283 20.8086 19.4043 21.1436 19.9307 21.1436Z" fill="%23F1F5F8" />%0A%0A</svg>%0A';
var $206a320454b17b13$export$8b22cf2602fb60ce = 'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none"%0A    xmlns="http://www.w3.org/2000/svg">%0A    <rect opacity="0.35" width="32" height="32" rx="16" fill="%23DAE1E7" />%0A<path d="M12.2881 21.1436C12.8965 21.1436 13.3066 20.7334 13.3066 20.1113V12.1406C13.3066 11.4297 12.8691 10.9854 12.1377 10.9854C11.7139 10.9854 11.3857 11.0469 10.9072 11.375L8.95215 12.7285C8.63086 12.9541 8.50781 13.1865 8.50781 13.501C8.50781 13.9385 8.81543 14.2393 9.23242 14.2393C9.44434 14.2393 9.58789 14.1914 9.7793 14.0547L11.2217 13.0498H11.2627V20.1113C11.2627 20.7334 11.6797 21.1436 12.2881 21.1436ZM16.9023 20.3164C17.2441 20.3164 17.4014 20.1865 17.6816 19.9131L19.3633 18.2451L21.0381 19.9062C21.3184 20.1865 21.4824 20.3164 21.8174 20.3164C22.2617 20.3164 22.6377 19.9746 22.6377 19.5234C22.6377 19.2158 22.4873 19.0176 22.2549 18.7852L20.5254 17.0488L22.2549 15.3057C22.4873 15.0732 22.6377 14.875 22.6377 14.5674C22.6377 14.1162 22.2617 13.7744 21.8174 13.7744C21.4824 13.7744 21.3184 13.9043 21.0381 14.1846L19.3633 15.8457L17.6885 14.1846C17.4082 13.9043 17.251 13.7744 16.9092 13.7744C16.4648 13.7744 16.0889 14.1162 16.0889 14.5674C16.0889 14.8818 16.2393 15.0732 16.4717 15.3057L18.1943 17.0488L16.4717 18.7852C16.2324 19.0244 16.0889 19.2158 16.0889 19.5234C16.0889 19.9814 16.458 20.3164 16.9023 20.3164Z" fill="%23F1F5F8" />%0A%0A</svg>%0A';
var $206a320454b17b13$export$db3b6bfb95261072 = 'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none"%0A    xmlns="http://www.w3.org/2000/svg">%0A    <rect opacity="0.5" width="32" height="32" rx="16" fill="white" />%0A<path d="M7.98828 21.082C8.59668 21.082 9.08887 20.5898 9.08887 19.9814C9.08887 19.3662 8.59668 18.8809 7.98828 18.8809C7.37305 18.8809 6.8877 19.3662 6.8877 19.9814C6.8877 20.5898 7.37305 21.082 7.98828 21.082Z" fill="white" />%0A<path d="M14.3662 21.2188C16.6152 21.2188 18.1807 19.7969 18.1807 17.6914C18.1807 15.8115 16.8408 14.4854 14.9541 14.4854C13.9492 14.4854 13.1426 14.8818 12.7393 15.5176H12.6982L12.9307 12.7764H16.8271C17.3467 12.7764 17.6748 12.4551 17.6748 11.9561C17.6748 11.457 17.3398 11.1357 16.8271 11.1357H12.5C11.7002 11.1357 11.2695 11.4707 11.2012 12.3047L10.9141 15.9209C10.9072 15.9551 10.9072 15.9756 10.9072 16.0029C10.8799 16.5566 11.2012 17.0283 11.8779 17.0283C12.3359 17.0283 12.541 16.9258 12.9443 16.5498C13.293 16.2148 13.7852 15.9619 14.373 15.9619C15.4463 15.9619 16.2119 16.7002 16.2119 17.7393C16.2119 18.8057 15.4395 19.5781 14.3662 19.5781C13.4775 19.5781 12.8965 19.1475 12.541 18.4365C12.3086 18.0674 12.0488 17.9238 11.6387 17.9238C11.1055 17.9238 10.7773 18.2383 10.7773 18.7646C10.7773 19.0107 10.8389 19.2227 10.9414 19.4414C11.4336 20.4873 12.8008 21.2188 14.3662 21.2188Z" fill="white" />%0A<path d="M19.9307 21.1436C20.2861 21.1436 20.4844 21.0273 20.7578 20.6035L22.1865 18.457H22.2275L23.6836 20.6377C23.9092 20.9795 24.1006 21.1436 24.4902 21.1436C25.0303 21.1436 25.4404 20.8018 25.4404 20.2617C25.4404 20.043 25.3721 19.8516 25.2217 19.6465L23.5195 17.2949L25.1943 15.0596C25.3857 14.8135 25.4609 14.6152 25.4609 14.3691C25.4609 13.8633 25.085 13.5215 24.5244 13.5215C24.1553 13.5215 23.9434 13.6855 23.6768 14.1025L22.3369 16.1465H22.2959L20.9287 14.0889C20.6621 13.665 20.4502 13.5215 20.0469 13.5215C19.5 13.5215 19.0898 13.8975 19.0898 14.3965C19.0898 14.6289 19.1582 14.8271 19.3018 15.0186L21.0107 17.3496L19.2949 19.6465C19.1035 19.8994 19.0283 20.0908 19.0283 20.3301C19.0283 20.8086 19.4043 21.1436 19.9307 21.1436Z" fill="white" />%0A%0A</svg>%0A';
var $206a320454b17b13$export$4368d992c4eafac0 = 'data:image/svg+xml,<?xml version="1.0" encoding="UTF-8"?>%0A<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1"%0A    xmlns="http://www.w3.org/2000/svg"%0A    xmlns:xlink="http://www.w3.org/1999/xlink">%0A    <title>Icons / With Shadow / Clicked / Camera Rotate Back</title>%0A    <defs>%0A        <filter x="-106.3%" y="-106.2%" width="312.5%" height="312.5%" filterUnits="objectBoundingBox" id="filter-1">%0A            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>%0A            <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>%0A            <feColorMatrix values="0 0 0 0 0.105882353   0 0 0 0 0.125490196   0 0 0 0 0.149019608  0 0 0 0.32 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>%0A            <feMerge>%0A                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>%0A                <feMergeNode in="SourceGraphic"></feMergeNode>%0A            </feMerge>%0A        </filter>%0A    </defs>%0A    <g id="Icons-/-With-Shadow-/-Clicked-/-Camera-Rotate-Back" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">%0A        <rect id="Bg" fill="%23FFFFFF" opacity="0" x="0" y="0" width="24" height="24"></rect>%0A        <g id="camera-rotate" filter="url(%23filter-1)" opacity="0.639999986" transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" stroke="%23FFFFFF" stroke-linejoin="round" stroke-width="2">%0A            <polyline id="Path" stroke-linecap="round" transform="translate(4.000000, 14.000000) scale(1, -1) rotate(-360.000000) translate(-4.000000, -14.000000) " points="3 12 5 14 3 16"></polyline>%0A            <circle id="Oval" cx="8" cy="8" r="2"></circle>%0A            <path d="M8,3 L14,3 C15.1045695,3 16,3.8954305 16,5 L16,12 C16,13.1045695 15.1045695,14 14,14 L12,14 L12,14" id="Path-2" stroke-linecap="round" transform="translate(12.000000, 8.500000) scale(1, -1) translate(-12.000000, -8.500000) "></path>%0A            <polyline id="Path" stroke-linecap="round" transform="translate(12.000000, 3.000000) rotate(-180.000000) translate(-12.000000, -3.000000) " points="11 1 13 3 11 5"></polyline>%0A            <path d="M4,14 L2,14 C0.8954305,14 1.3527075e-16,13.1045695 0,12 L0,5 C-1.3527075e-16,3.8954305 0.8954305,3 2,3 L2.5,3 C3.32842712,3 4,2.32842712 4,1.5 C4,0.671572875 4.67157288,1.52179594e-16 5.5,0 L10,0 L10,0" id="Path-2" stroke-linecap="round"></path>%0A        </g>%0A    </g>%0A</svg>%0A';
var $206a320454b17b13$export$f1e1789686576879 = 'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none"%0A    xmlns="http://www.w3.org/2000/svg">%0A    <rect opacity="0.5" width="32" height="32" rx="16" fill="white" />%0A<path d="M12.2881 21.1436C12.8965 21.1436 13.3066 20.7334 13.3066 20.1113V12.1406C13.3066 11.4297 12.8691 10.9854 12.1377 10.9854C11.7139 10.9854 11.3857 11.0469 10.9072 11.375L8.95215 12.7285C8.63086 12.9541 8.50781 13.1865 8.50781 13.501C8.50781 13.9385 8.81543 14.2393 9.23242 14.2393C9.44434 14.2393 9.58789 14.1914 9.7793 14.0547L11.2217 13.0498H11.2627V20.1113C11.2627 20.7334 11.6797 21.1436 12.2881 21.1436ZM16.9023 20.3164C17.2441 20.3164 17.4014 20.1865 17.6816 19.9131L19.3633 18.2451L21.0381 19.9062C21.3184 20.1865 21.4824 20.3164 21.8174 20.3164C22.2617 20.3164 22.6377 19.9746 22.6377 19.5234C22.6377 19.2158 22.4873 19.0176 22.2549 18.7852L20.5254 17.0488L22.2549 15.3057C22.4873 15.0732 22.6377 14.875 22.6377 14.5674C22.6377 14.1162 22.2617 13.7744 21.8174 13.7744C21.4824 13.7744 21.3184 13.9043 21.0381 14.1846L19.3633 15.8457L17.6885 14.1846C17.4082 13.9043 17.251 13.7744 16.9092 13.7744C16.4648 13.7744 16.0889 14.1162 16.0889 14.5674C16.0889 14.8818 16.2393 15.0732 16.4717 15.3057L18.1943 17.0488L16.4717 18.7852C16.2324 19.0244 16.0889 19.2158 16.0889 19.5234C16.0889 19.9814 16.458 20.3164 16.9023 20.3164Z" fill="white" />%0A%0A</svg>%0A';
var $206a320454b17b13$export$2d1720544b23b823 = 'data:image/svg+xml,<svg viewBox="0 0 24 24"%0A    xmlns="http://www.w3.org/2000/svg">%0A    <defs>%0A        <filter x="-121.5%" y="-88.9%" width="343%" height="277.8%" filterUnits="objectBoundingBox" id="prefix__a">%0A            <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>%0A            <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>%0A            <feColorMatrix values="0 0 0 0 0.105882353 0 0 0 0 0.125490196 0 0 0 0 0.149019608 0 0 0 0.32 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/>%0A            <feMerge>%0A                <feMergeNode in="shadowMatrixOuter1"/>%0A                <feMergeNode in="SourceGraphic"/>%0A            </feMerge>%0A        </filter>%0A    </defs>%0A    <g filter="url(%23prefix__a)" opacity=".64" transform="translate(3.742 3)" fill="%23FFF" fill-rule="nonzero">%0A        <path d="M4.223 17.946a.75.75 0 01-.456-.83L5.105 9.75h-3.6a.75.75 0 01-.727-.946l1.183-4.335L.22 2.728a.75.75 0 111.06-1.062l11.668 11.668a.75.75 0 01-1.06 1.06L9.14 11.646l-4.013 6.02a.75.75 0 01-.904.28zM10.838 9.1L2.872 1.135l.159-.58A.75.75 0 013.755 0h5.25a.75.75 0 01.722.959L8.499 5.25h3.505a.75.75 0 01.626 1.167l-1.79 2.684h-.002z"/>%0A    </g>%0A</svg>%0A';
var $206a320454b17b13$export$39b482c5e57630a8 = 'data:image/svg+xml,<?xml version="1.0" encoding="UTF-8"?>%0A<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1"%0A    xmlns="http://www.w3.org/2000/svg"%0A    xmlns:xlink="http://www.w3.org/1999/xlink">%0A    <title>Icons / With Shadow / Normal / Camera Rotate Back</title>%0A    <defs>%0A        <filter x="-106.3%" y="-106.2%" width="312.5%" height="312.5%" filterUnits="objectBoundingBox" id="filter-1">%0A            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>%0A            <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>%0A            <feColorMatrix values="0 0 0 0 0.105882353   0 0 0 0 0.125490196   0 0 0 0 0.149019608  0 0 0 0.32 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>%0A            <feMerge>%0A                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>%0A                <feMergeNode in="SourceGraphic"></feMergeNode>%0A            </feMerge>%0A        </filter>%0A    </defs>%0A    <g id="Icons-/-With-Shadow-/-Normal-/-Camera-Rotate-Back" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">%0A        <rect id="Bg" fill="%23FFFFFF" opacity="0" x="0" y="0" width="24" height="24"></rect>%0A        <g id="camera-rotate" filter="url(%23filter-1)" transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" stroke="%23FFFFFF" stroke-linejoin="round" stroke-width="2">%0A            <polyline id="Path" stroke-linecap="round" transform="translate(4.000000, 14.000000) scale(1, -1) rotate(-360.000000) translate(-4.000000, -14.000000) " points="3 12 5 14 3 16"></polyline>%0A            <circle id="Oval" cx="8" cy="8" r="2"></circle>%0A            <path d="M8,3 L14,3 C15.1045695,3 16,3.8954305 16,5 L16,12 C16,13.1045695 15.1045695,14 14,14 L12,14 L12,14" id="Path-2" stroke-linecap="round" transform="translate(12.000000, 8.500000) scale(1, -1) translate(-12.000000, -8.500000) "></path>%0A            <polyline id="Path" stroke-linecap="round" transform="translate(12.000000, 3.000000) rotate(-180.000000) translate(-12.000000, -3.000000) " points="11 1 13 3 11 5"></polyline>%0A            <path d="M4,14 L2,14 C0.8954305,14 1.3527075e-16,13.1045695 0,12 L0,5 C-1.3527075e-16,3.8954305 0.8954305,3 2,3 L2.5,3 C3.32842712,3 4,2.32842712 4,1.5 C4,0.671572875 4.67157288,1.52179594e-16 5.5,0 L10,0 L10,0" id="Path-2" stroke-linecap="round"></path>%0A        </g>%0A    </g>%0A</svg>%0A';
var $206a320454b17b13$export$dda1d9f60106f0e9 = 'data:image/svg+xml,<svg viewBox="0 0 24 24"%0A    xmlns="http://www.w3.org/2000/svg">%0A    <defs>%0A        <filter x="-133.3%" y="-88.9%" width="366.6%" height="277.8%" filterUnits="objectBoundingBox" id="prefix__a">%0A            <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>%0A            <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>%0A            <feColorMatrix values="0 0 0 0 0.105882353 0 0 0 0 0.125490196 0 0 0 0 0.149019608 0 0 0 0.32 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/>%0A            <feMerge>%0A                <feMergeNode in="shadowMatrixOuter1"/>%0A                <feMergeNode in="SourceGraphic"/>%0A            </feMerge>%0A        </filter>%0A    </defs>%0A    <g filter="url(%23prefix__a)" opacity=".64" transform="translate(4.5 3)" fill="%23FFF" fill-rule="nonzero">%0A        <path d="M11.25 5.25H7.745L8.972.956A.75.75 0 008.25 0H3a.75.75 0 00-.724.553l-2.25 8.25a.75.75 0 00.724.947h3.6l-1.338 7.366a.75.75 0 001.363.55l7.5-11.25a.75.75 0 00-.625-1.166z"/>%0A    </g>%0A</svg>%0A';
var $206a320454b17b13$export$23f2a1d2818174ef = 'data:image/svg+xml,<svg viewBox="0 0 24 24"%0A    xmlns="http://www.w3.org/2000/svg">%0A    <defs>%0A        <filter x="-114.3%" y="-88.9%" width="328.6%" height="277.8%" filterUnits="objectBoundingBox" id="prefix__a">%0A            <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>%0A            <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>%0A            <feColorMatrix values="0 0 0 0 0.105882353 0 0 0 0 0.125490196 0 0 0 0 0.149019608 0 0 0 0.32 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/>%0A            <feMerge>%0A                <feMergeNode in="shadowMatrixOuter1"/>%0A                <feMergeNode in="SourceGraphic"/>%0A            </feMerge>%0A        </filter>%0A    </defs>%0A    <g filter="url(%23prefix__a)" transform="translate(3 3)" fill="%23FFF" fill-rule="nonzero">%0A        <path d="M4.966 17.946a.75.75 0 01-.457-.83L5.848 9.75h-3.6a.75.75 0 01-.727-.946l1.182-4.335-1.74-1.74a.75.75 0 111.06-1.062L13.69 13.334a.75.75 0 01-1.061 1.06l-2.748-2.748-4.012 6.02a.75.75 0 01-.904.28zM11.58 9.1L3.614 1.135l.16-.58A.75.75 0 014.496 0h5.25a.75.75 0 01.722.959L9.242 5.25h3.504a.75.75 0 01.627 1.167l-1.79 2.684h-.002z"/>%0A    </g>%0A</svg>%0A';
var $206a320454b17b13$export$35e795649ee09318 = 'data:image/svg+xml,<svg viewBox="0 0 24 24"%0A    xmlns="http://www.w3.org/2000/svg">%0A    <defs>%0A        <filter x="-133.3%" y="-88.9%" width="366.6%" height="277.8%" filterUnits="objectBoundingBox" id="prefix__a">%0A            <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>%0A            <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>%0A            <feColorMatrix values="0 0 0 0 0.105882353 0 0 0 0 0.125490196 0 0 0 0 0.149019608 0 0 0 0.32 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/>%0A            <feMerge>%0A                <feMergeNode in="shadowMatrixOuter1"/>%0A                <feMergeNode in="SourceGraphic"/>%0A            </feMerge>%0A        </filter>%0A    </defs>%0A    <g filter="url(%23prefix__a)" transform="translate(4.5 3)" fill="%23FFF" fill-rule="nonzero">%0A        <path d="M11.25 5.25H7.745L8.972.956A.75.75 0 008.25 0H3a.75.75 0 00-.724.553l-2.25 8.25a.75.75 0 00.724.947h3.6l-1.338 7.366a.75.75 0 001.363.55l7.5-11.25a.75.75 0 00-.625-1.166z"/>%0A    </g>%0A</svg>%0A';



var $e59ab12df8b69a4c$export$407448d2b89b1813 = {
    CONTAINER_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).CONTAINER_CLASS_NAME,
    PAINTBOARD_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME,
    PAINTBOARD_CLASS_NAME_STATE_ON: (0, $80d48380ab62f10e$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME_STATE_ON,
    CONTROLS_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).CONTROLS_CLASS_NAME,
    CONTROL_WIDGET_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).CONTROL_WIDGET_CLASS_NAME,
    MIRRORED_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).MIRRORED_CLASS_NAME,
    CAMERA_RECOVERY_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).CAMERA_RECOVERY_CLASS_NAME,
    ERROR_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).ERROR_CLASS_NAME,
    HINT_CONTAINER_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).HINT_CONTAINER_CLASS_NAME,
    HINT_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).HINT_CLASS_NAME,
    PAINTBOARDS_CONTAINER_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).PAINTBOARDS_CONTAINER_CLASS_NAME,
    SINGLE_IMAGE_UPLOADER_CONTAINER_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).SINGLE_IMAGE_UPLOADER_CONTAINER_CLASS_NAME,
    CANVAS_VIDEO_PREVIEW_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).CANVAS_VIDEO_PREVIEW_CLASS_NAME,
    TORCH_SWITCH_CONTROL_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).TORCH_SWITCH_CONTROL_CLASS_NAME,
    CAMERA_SWITCH_CONTROL_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).CAMERA_SWITCH_CONTROL_CLASS_NAME,
    CAMERA_FOV_SWITCH_CONTROL_CLASS_NAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).CAMERA_FOV_SWITCH_CONTROL_CLASS_NAME,
    FROZEN_FRAME: (0, $80d48380ab62f10e$export$407448d2b89b1813).FROZEN_FRAME
};


var $ac769ba1832773dd$var$i = class {
    toJSONObject() {
        return {
            type: this.type
        };
    }
}, $ac769ba1832773dd$export$407448d2b89b1813 = class extends $ac769ba1832773dd$var$i {
    constructor(){
        super(...arguments);
        this.type = "torch";
        this.view = null;
        this.icon = {
            on: {
                idle: (0, $206a320454b17b13$export$35e795649ee09318),
                pressed: (0, $206a320454b17b13$export$dda1d9f60106f0e9)
            },
            off: {
                idle: (0, $206a320454b17b13$export$23f2a1d2818174ef),
                pressed: (0, $206a320454b17b13$export$2d1720544b23b823)
            }
        };
    }
    get torchOffImage() {
        return this.icon.off.idle;
    }
    set torchOffImage(t) {
        var e;
        this.icon.off.idle = t, (e = this.view) == null || e.controlsUpdated();
    }
    get torchOffPressedImage() {
        return this.icon.off.pressed;
    }
    set torchOffPressedImage(t) {
        var e;
        this.icon.off.pressed = t, (e = this.view) == null || e.controlsUpdated();
    }
    get torchOnImage() {
        return this.icon.on.idle;
    }
    set torchOnImage(t) {
        var e;
        this.icon.on.idle = t, (e = this.view) == null || e.controlsUpdated();
    }
    get torchOnPressedImage() {
        return this.icon.on.pressed;
    }
    set torchOnPressedImage(t) {
        var e;
        this.icon.on.pressed = t, (e = this.view) == null || e.controlsUpdated();
    }
};
$ac769ba1832773dd$export$407448d2b89b1813.CLASS_NAME = (0, $e59ab12df8b69a4c$export$407448d2b89b1813).TORCH_SWITCH_CONTROL_CLASS_NAME;
var $ac769ba1832773dd$export$8b22cf2602fb60ce = class extends $ac769ba1832773dd$var$i {
    constructor(){
        super(...arguments);
        this.type = "camera";
        this.view = null;
        this.icon = {
            idle: (0, $206a320454b17b13$export$39b482c5e57630a8),
            pressed: (0, $206a320454b17b13$export$4368d992c4eafac0)
        };
    }
    get idleImage() {
        return this.icon.idle;
    }
    set idleImage(t) {
        var e;
        this.icon.idle = t, (e = this.view) == null || e.controlsUpdated();
    }
    get pressedImage() {
        return this.icon.pressed;
    }
    set pressedImage(t) {
        var e;
        this.icon.pressed = t, (e = this.view) == null || e.controlsUpdated();
    }
};
$ac769ba1832773dd$export$8b22cf2602fb60ce.CLASS_NAME = (0, $e59ab12df8b69a4c$export$407448d2b89b1813).CAMERA_SWITCH_CONTROL_CLASS_NAME;
var $ac769ba1832773dd$export$db3b6bfb95261072 = class extends $ac769ba1832773dd$var$i {
    constructor(){
        super(...arguments);
        this.type = "camera-fov";
        this.view = null;
        this.icon = {
            wide: {
                idle: (0, $206a320454b17b13$export$f1e1789686576879),
                pressed: (0, $206a320454b17b13$export$8b22cf2602fb60ce)
            },
            ultraWide: {
                idle: (0, $206a320454b17b13$export$db3b6bfb95261072),
                pressed: (0, $206a320454b17b13$export$407448d2b89b1813)
            }
        };
    }
    get cameraFOVUltraWideImage() {
        return this.icon.ultraWide.idle;
    }
    set cameraFOVUltraWideImage(t) {
        var e;
        this.icon.ultraWide.idle = t, (e = this.view) == null || e.controlsUpdated();
    }
    get cameraFOVUltraWidePressedImage() {
        return this.icon.ultraWide.pressed;
    }
    set cameraFOVUltraWidePressedImage(t) {
        var e;
        this.icon.ultraWide.pressed = t, (e = this.view) == null || e.controlsUpdated();
    }
    get cameraFOVWideImage() {
        return this.icon.wide.idle;
    }
    set cameraFOVWideImage(t) {
        var e;
        this.icon.wide.idle = t, (e = this.view) == null || e.controlsUpdated();
    }
    get cameraFOVWidePressedImage() {
        return this.icon.wide.pressed;
    }
    set cameraFOVWidePressedImage(t) {
        var e;
        this.icon.wide.pressed = t, (e = this.view) == null || e.controlsUpdated();
    }
};
$ac769ba1832773dd$export$db3b6bfb95261072.CLASS_NAME = (0, $e59ab12df8b69a4c$export$407448d2b89b1813).CAMERA_FOV_SWITCH_CONTROL_CLASS_NAME;


var $2d78a6453b76bc96$export$407448d2b89b1813 = ((a)=>(a.Auto = "auto", a.Off = "off", a.On = "on", a))($2d78a6453b76bc96$export$407448d2b89b1813 || {}), $2d78a6453b76bc96$export$8b22cf2602fb60ce = class {
    constructor(e){
        this.overrideThreadsSupport = "auto";
        this.overrideSimdSupport = "auto";
        this.workerCommandId = 1;
        this.workerTasks = new Map;
        this.workerListeners = [];
        var r, a;
        this.libraryLocation = e.libraryLocation, this.isPreloadEngine = (r = e.preloadEngine) != null ? r : !1, this.workerMessageListener = this.onWorkerMessage.bind(this), this.dataCaptureWorker.addEventListener("message", this.workerMessageListener), this.overrideThreadsSupport = e.overrideThreadsSupport, this.overrideSimdSupport = e.overrideSimdSupport, this.verifyResponseHash = e.verifyResponseHash, this.highEndBlurryRecognition = (a = e.highEndBlurryRecognition) != null ? a : !1, typeof e.loadProgressNotifier == "function" && this.addWorkerListener((o)=>{
            var s;
            o.type === "loadLibraryProgress" && ((s = e.loadProgressNotifier) == null || s.call(e, o.payload));
        });
    }
    get dataCaptureWorker() {
        return this._dataCaptureWorker != null || (this._dataCaptureWorker = void 0), this._dataCaptureWorker;
    }
    get name() {
        return "CoreLoader";
    }
    static async create(e) {
        var a$1;
        let r = new this(e);
        return await r.workerCommand("setLogLevel", {
            level: (a$1 = e.logLevel) != null ? a$1 : (0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug
        }), await r.load(), r;
    }
    async load() {
        var e;
        try {
            await this.workerCommand("loadLibrary", {
                libraryLocation: this.libraryLocation,
                locationPath: window.location.pathname,
                referredOrigin: window.location.origin,
                preloadEngine: this.isPreloadEngine,
                writableDataPathOverride: (e = localStorage.getItem("scanditWritableDataPathOverride")) != null ? e : void 0,
                overrideThreadsSupport: this.overrideThreadsSupport,
                overrideSimdSupport: this.overrideSimdSupport,
                verifyResponseHash: this.verifyResponseHash
            });
        } catch (r) {
            if (r != null && typeof r == "object" && typeof r.error == "string" && r.error.includes("BlockedIndexedDB")) return await this.terminateDataCaptureWorker(!1), this.dataCaptureWorker.addEventListener("message", this.workerMessageListener), localStorage.setItem("scanditWritableDataPathOverride", `/scandit_sync_folder_${[
                ...crypto.getRandomValues(new Uint32Array(2))
            ].map((a)=>a.toString(32)).join("")}`), this.load();
            throw r;
        }
    }
    async workerCommand(e, r, a) {
        return new Promise((o, s)=>{
            let t = this.workerCommandId++;
            this.workerTasks.set(t, {
                resolve: o,
                reject: s,
                command: e
            });
            let d = {
                ...r,
                command: e,
                id: t
            };
            this.dataCaptureWorker.postMessage(d, a);
        });
    }
    async terminateDataCaptureWorker(e = !0) {
        var r, a;
        e && await this.workerCommand("dispose", {}), (r = this._dataCaptureWorker) == null || r.removeEventListener("message", this.workerMessageListener), (a = this._dataCaptureWorker) == null || a.terminate(), this._dataCaptureWorker = void 0;
    }
    addWorkerListener(e) {
        this.workerListeners.push(e);
    }
    removeWorkerListener(e) {
        this.workerListeners.includes(e) && this.workerListeners.splice(this.workerListeners.indexOf(e), 1);
    }
    onWorkerMessage(e) {
        let r = e.data;
        if (r.type === "workerTaskId" && typeof r.id == "number") {
            let { id: a, error: o, payload: s } = r, t = this.workerTasks.get(a);
            o == null ? t == null || t.resolve(s) : t == null || t.reject(r), this.workerTasks.delete(a);
        } else for (let a of this.workerListeners)a(r);
    }
};



function $277b7d9e6d31883a$export$407448d2b89b1813(t, e = location) {
    return t += t.endsWith("/") ? "" : "/", /^https?:\/\//.test(t) ? t : (t = t.split("/").filter((n)=>n.length > 0).join("/"), t = t === "" ? "/" : `/${t}/`, e.protocol === "file:" || e.origin === "null" ? `${e.href.split("/").slice(0, -1).join("/")}${t}` : `${e.origin}${t}`);
}
function $277b7d9e6d31883a$export$8b22cf2602fb60ce(t) {
    return /^https?:\/\/(?:[^./]*\.)*cdn.jsdelivr.net\//.test(t) ? {
        result: !0,
        cdnBaseURL: "https://cdn.jsdelivr.net/npm/"
    } : /^https?:\/\/(?:[^./]*\.)*unpkg.com\//.test(t) ? {
        result: !0,
        cdnBaseURL: "https://unpkg.com/"
    } : {
        result: !1,
        cdnBaseURL: ""
    };
}
function $277b7d9e6d31883a$export$db3b6bfb95261072(t) {
    let n = /scandit-web-datacapture-[a-z]+/i.exec(t);
    return n ? n[0] : null;
}
function $277b7d9e6d31883a$export$4368d992c4eafac0(t, e, n) {
    let s = e, i = $277b7d9e6d31883a$export$8b22cf2602fb60ce(s);
    if (i.result) {
        let u = $277b7d9e6d31883a$export$db3b6bfb95261072(s);
        u != null && (s = `${i.cdnBaseURL}${u}@${t}/build/engine/`);
    }
    let r = n.replace(".wasm", "");
    return i.result ? {
        jsURI: `${s}${r}.js`,
        wasmURI: `${s}${r}.wasm`
    } : {
        jsURI: `${s}${r}.js?v=${t}`,
        wasmURI: `${s}${r}.wasm?v=${t}`
    };
}


var $043376cb7dc40b01$export$407448d2b89b1813 = {
    "core.view.loading": "Loading the Scandit SDK...",
    "core.singleImageUploader.title": "Analyze an image from your device.",
    "core.singleImageUploader.button": "Choose an Image",
    "core.camera.recovery": "Tap/click to resume scanning"
};





async function $44cca9bce8501bbc$var$s(e, a) {
    let t = document.createElement("canvas");
    t.width = this.width, t.height = this.height;
    let r = t.getContext("2d");
    if (!r) throw new Error("Could not get 2d context from an HTMLCanvasElement");
    let o = await this.getData();
    return o == null ? null : (r.putImageData(new ImageData(o, this.width, this.height), 0, 0), new Promise((i, m)=>{
        t.toBlob((n)=>{
            if (n === null) {
                m(new Error("Could not create Blob object from canvas"));
                return;
            }
            i(n);
        }, e, a);
    }));
}
function $44cca9bce8501bbc$export$407448d2b89b1813(e, a) {
    let t = {
        width: e.width,
        height: e.height,
        isFrameSourceMirrored: e.isFrameSourceMirrored,
        getData: async ()=>(await a.requestFrameData(e.frameId)).data
    };
    return t.toBlob = $44cca9bce8501bbc$var$s.bind(t), t;
}





var $9c00ec23a1023c4e$export$407448d2b89b1813 = {
    type: "none"
}, $9c00ec23a1023c4e$export$8b22cf2602fb60ce = class {
    constructor(t){
        this.type = "radius";
        this._radius = t;
    }
    get radius() {
        return this._radius;
    }
    toJSONObject() {
        return {
            type: this.type,
            radius: this.radius.toJSONObject()
        };
    }
}, $9c00ec23a1023c4e$export$db3b6bfb95261072 = class n {
    constructor(){
        this.type = "rectangular";
    }
    get sizeWithUnitAndAspect() {
        return this._sizeWithUnitAndAspect;
    }
    static withSize(t) {
        let i = new n;
        return i._sizeWithUnitAndAspect = (0, $72be97bdfeffe3ee$export$882b5998b3b9117c).sizeWithWidthAndHeight(t), i;
    }
    static withWidthAndAspectRatio(t, i) {
        let e = new n;
        return e._sizeWithUnitAndAspect = (0, $72be97bdfeffe3ee$export$882b5998b3b9117c).sizeWithWidthAndAspectRatio(t, i), e;
    }
    static withHeightAndAspectRatio(t, i) {
        let e = new n;
        return e._sizeWithUnitAndAspect = (0, $72be97bdfeffe3ee$export$882b5998b3b9117c).sizeWithHeightAndAspectRatio(t, i), e;
    }
    toJSONObject() {
        return {
            type: this.type,
            size: this.sizeWithUnitAndAspect.toJSONObject()
        };
    }
};






var $40135a80c33a0e18$var$t = class t {
    constructor(){
        this.hasApi = !1;
        this.hasTouch = !1;
        this.requiresPrefix = !1;
    }
    detect() {
        var e;
        try {
            "PointerEvent" in window ? this.hasApi = !0 : "msPointerEnabled" in navigator && (this.hasApi = !0, this.requiresPrefix = !0);
            let o = (e = navigator.msMaxTouchPoints) != null ? e : navigator.maxTouchPoints;
            this.hasTouch = o > 0;
        } catch (o) {}
    }
    prefixIfNeeded(e) {
        return this.requiresPrefix ? t.prefixEventMap[e] : e;
    }
};
$40135a80c33a0e18$var$t.prefixEventMap = {
    pointerdown: "MSPointerDown",
    pointerup: "MSPointerUp",
    pointercancel: "MSPointerCancel",
    pointermove: "MSPointerMove",
    pointerover: "MSPointerOver",
    pointerout: "MSPointerOut",
    pointerenter: "MSPointerEnter",
    pointerleave: "MSPointerLeave",
    gotpointercapture: "MSGotPointerCapture",
    lostpointercapture: "MSLostPointerCapture"
};
var $40135a80c33a0e18$var$n = $40135a80c33a0e18$var$t, $40135a80c33a0e18$export$407448d2b89b1813 = new $40135a80c33a0e18$var$n;


var $4ad9120b36f687df$export$407448d2b89b1813 = class {
    constructor(){
        this._listeners = new Set;
    }
    get listeners() {
        return [
            ...this._listeners
        ];
    }
    addListener(e) {
        this._listeners.add(e);
    }
    removeListener(e) {
        this._listeners.delete(e);
    }
};



var $8965d7ce2acc0c07$export$407448d2b89b1813 = class extends (0, $4ad9120b36f687df$export$407448d2b89b1813) {
    constructor(t){
        super();
        this._onTouchStart = this.onTouchStart.bind(this);
        this._onPointerDown = this.onPointerDown.bind(this);
        (0, $40135a80c33a0e18$export$407448d2b89b1813).detect(), this.element = t, this.addPointerDownListener();
    }
    removeAllListeners() {
        this.element.removeEventListener("touchend", this._onTouchStart), this.element.removeEventListener("mousedown", this._onPointerDown), this.element.removeEventListener("pointerdown", this._onPointerDown);
    }
    addPointerDownListener() {
        (0, $40135a80c33a0e18$export$407448d2b89b1813).hasApi ? this.element.addEventListener((0, $40135a80c33a0e18$export$407448d2b89b1813).prefixIfNeeded("pointerdown"), this._onPointerDown) : (0, $40135a80c33a0e18$export$407448d2b89b1813).hasTouch ? this.element.addEventListener("touchstart", this._onTouchStart) : this.element.addEventListener("mousedown", this._onPointerDown);
    }
    onPointerDown(t) {
        let { clientX: n, clientY: e, button: i, currentTarget: a = this.element } = t;
        i === 0 && this.onTap(this.pointRelativeToElement({
            clientX: n,
            clientY: e,
            rect: a.getBoundingClientRect()
        }));
    }
    onTouchStart(t) {
        let [n] = t.touches, { clientX: e, clientY: i } = n;
        this.onTap(this.pointRelativeToElement({
            clientX: e,
            clientY: i,
            rect: this.element.getBoundingClientRect()
        }));
    }
    pointRelativeToElement({ clientX: t, clientY: n, rect: e }) {
        return new (0, $72be97bdfeffe3ee$export$407448d2b89b1813)(t - e.left, n - e.top);
    }
    onTap(t) {
        var n;
        for (let e of this.listeners)(n = e.onTap) == null || n.call(e, t);
    }
};







var $902e77576353d3be$export$407448d2b89b1813 = ((e)=>(e.Idle = "idle", e.Pressed = "pressed", e))($902e77576353d3be$export$407448d2b89b1813 || {}), $902e77576353d3be$var$l = class {
    constructor(t, e){
        this.state = "idle";
        this.isHover = !1;
        this.control = t, this.domHost = e, this.onTouchStartListener = this.onTouchStart.bind(this), this.onMouseEnterListener = this.onMouseEnter.bind(this), this.onMouseLeaveListener = this.onMouseLeave.bind(this), this.onClickListener = this.onClick.bind(this), this.setup();
    }
    get frameSource() {
        var t, e;
        return (e = (t = this.control.view) == null ? void 0 : t.getContext()) == null ? void 0 : e.frameSource;
    }
    get context() {
        var t;
        return (t = this.control.view) == null ? void 0 : t.getContext();
    }
    async install() {
        this.button || this.setup();
        let t = await this.canShow();
        return t ? (this.updateButtonBackground(this.button, this.getImageFromState()), this.show()) : this.hide(), t;
    }
    remove(t = !1) {
        t && this.button ? (this.button.removeEventListener("mouseenter", this.onMouseEnterListener), this.button.removeEventListener("mouseleave", this.onMouseLeaveListener), this.button.removeEventListener("touchstart", this.onTouchStartListener), this.button.removeEventListener("click", this.onClickListener), this.button.remove(), this.isHover = !1, this.button = void 0) : this.hide();
    }
    hide() {
        this.button && (this.button.style.display = "none");
    }
    show() {
        this.button && (this.button.style.display = "block");
    }
    setupButton() {
        let t = document.createElement("button");
        return t.type = "button", t.style.display = "none", t.className = `scandit-control-widget scandit-control-widget-${this.control.type}`, this.updateButtonBackground(t, this.getImageFromState()), this.domHost.append(t), t.addEventListener("mouseenter", this.onMouseEnterListener), t.addEventListener("mouseleave", this.onMouseLeaveListener), (0, $08663c8936fe6aaa$export$407448d2b89b1813).isDesktopDevice() || t.addEventListener("touchstart", this.onTouchStartListener), t.addEventListener("click", this.onClickListener), t.setAttribute("aria-pressed", String(this.state === "pressed")), this.button = t, this.button;
    }
    setup() {
        this.setupButton();
    }
    onTouchStart() {
        var t, e;
        (t = this.button) == null || t.removeEventListener("mouseenter", this.onMouseEnterListener), (e = this.button) == null || e.removeEventListener("mouseleave", this.onMouseLeaveListener);
    }
    onMouseEnter() {
        this.isHover = !0, this.updateButtonBackground(this.button, this.getImageFromState());
    }
    onMouseLeave() {
        this.isHover = !1, this.updateButtonBackground(this.button, this.getImageFromState());
    }
    onClick() {
        var t;
        this.state = this.state === "pressed" ? "idle" : "pressed", this.buttonClicked(), this.updateButtonBackground(this.button, this.getImageFromState()), (t = this.button) == null || t.setAttribute("aria-pressed", String(this.state === "pressed"));
    }
    updateButtonBackground(t, e) {
        e != null && t != null && (t.style.backgroundImage = `url(${JSON.stringify(e)})`);
    }
}, $902e77576353d3be$export$8b22cf2602fb60ce = class extends $902e77576353d3be$var$l {
    constructor(t, e){
        super(t, e);
    }
    async buttonClicked() {
        await this.frameSource.setDesiredTorchState(this.retrieveTorchState() === "on" ? "off" : "on");
    }
    async canShow() {
        return this.isTorchAvailable();
    }
    getImageFromState() {
        return this.retrieveTorchState() === "on" ? this.isHover ? this.control.torchOnPressedImage : this.control.torchOnImage : this.isHover ? this.control.torchOffPressedImage : this.control.torchOffImage;
    }
    setup() {
        if (this.control.torchOffImage == null || this.control.torchOnImage == null) {
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "TorchSwitchControl icon is not set or is empty, the control will not be rendered.");
            return;
        }
        super.setup();
    }
    async isTorchAvailable() {
        return (0, $26b53f2fcaea5d86$export$2d1720544b23b823)(this.frameSource) ? this.frameSource.isTorchAvailable() : !1;
    }
    retrieveTorchState() {
        return (0, $26b53f2fcaea5d86$export$2d1720544b23b823)(this.frameSource) ? this.frameSource.getDesiredTorchState() : "off";
    }
}, $902e77576353d3be$export$db3b6bfb95261072 = class o extends $902e77576353d3be$var$l {
    constructor(e, r){
        super(e, r);
    }
    static get Camera() {
        return 0, $01f73a9bc5262471$export$407448d2b89b1813;
    }
    static get CameraAccess() {
        return 0, $fa51dabf90952f18$export$4368d992c4eafac0;
    }
    async canShow() {
        return (await o.CameraAccess.getCameras()).length > 1;
    }
    getImageFromState() {
        return this.isHover ? this.control.pressedImage : this.control.idleImage;
    }
    async buttonClicked() {
        if (this.isTransitioning) return;
        let e = await this.getNextDeviceCamera();
        e && await this.switchCameras(e);
    }
    setup() {
        if (this.control.idleImage == null) {
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "CameraSwitchControl idle icon is not set or is empty, the control will not be rendered.");
            return;
        }
        super.setup();
    }
    async getNextDeviceCamera() {
        var u, p;
        let e = await o.CameraAccess.getCameras(), r = this.frameSource ? this.frameSource : null, a = (u = r == null ? void 0 : r.cameraManager.activeCamera) == null ? void 0 : u.deviceId, i = e.findIndex((g)=>g.deviceId === a);
        return i > -1 ? (p = e[i + 1]) != null ? p : e[0] : e.length > 0 ? e[0] : null;
    }
    async switchCameras(e) {
        var i;
        this.isTransitioning = !0;
        let r = this.frameSource;
        r != null && await r.switchToDesiredState("off");
        let a = new o.Camera;
        a.deviceId = e.deviceId, r != null && await a.applySettings(new (0, $26b53f2fcaea5d86$export$39b482c5e57630a8)(r.settings)), await a.switchToDesiredState("on"), await ((i = this.context) == null ? void 0 : i.setFrameSource(a)), this.isTransitioning = !1;
    }
}, $902e77576353d3be$export$4368d992c4eafac0 = class o extends $902e77576353d3be$var$l {
    constructor(e, r){
        super(e, r);
    }
    static get Camera() {
        return 0, $01f73a9bc5262471$export$407448d2b89b1813;
    }
    static get CameraAccess() {
        return 0, $fa51dabf90952f18$export$4368d992c4eafac0;
    }
    async install() {
        let e = await super.install();
        return e && await this.setInitialCamera(), e;
    }
    async canShow() {
        return !(0, $08663c8936fe6aaa$export$407448d2b89b1813).isIOSDeviceWithExtendedCameraAccess() || !(0, $26b53f2fcaea5d86$export$2d1720544b23b823)(this.frameSource) ? !1 : (0, $fa51dabf90952f18$export$4368d992c4eafac0).isIOSBackDualWideCameraLabel(this.frameSource.label) || (0, $fa51dabf90952f18$export$4368d992c4eafac0).isIOSBackCameraLabel(this.frameSource.label) || (0, $fa51dabf90952f18$export$4368d992c4eafac0).isIOSUltraWideBackCameraLabel(this.frameSource.label);
    }
    getImageFromState() {
        return this.isUltraWideBackCamera() ? this.isHover ? this.control.cameraFOVUltraWidePressedImage : this.control.cameraFOVUltraWideImage : this.isHover ? this.control.cameraFOVWidePressedImage : this.control.cameraFOVWideImage;
    }
    async buttonClicked() {
        if (this.isTransitioning) return;
        let e = await this.getAlternativeDeviceCamera();
        e && await this.switchCameras(e);
    }
    async setInitialCamera() {
        var e, r;
        if (!this.isTransitioning && !(0, $fa51dabf90952f18$export$4368d992c4eafac0).isIOSBackCameraLabel((r = (e = this.frameSource) == null ? void 0 : e.label) != null ? r : "")) {
            let i = (await o.CameraAccess.getCameras()).find((u)=>(0, $fa51dabf90952f18$export$4368d992c4eafac0).isIOSBackCameraLabel(u.label));
            i && await this.switchCameras(i);
        }
    }
    setup() {
        if (this.control.cameraFOVUltraWideImage == null || this.control.cameraFOVWideImage == null) {
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "CameraFOVSwitchControl icon is not set or is empty, the control will not be rendered.");
            return;
        }
        super.setup();
    }
    isUltraWideBackCamera() {
        return (0, $26b53f2fcaea5d86$export$2d1720544b23b823)(this.frameSource) ? (0, $fa51dabf90952f18$export$4368d992c4eafac0).isIOSUltraWideBackCameraLabel(this.frameSource.label) : !1;
    }
    async getAlternativeDeviceCamera() {
        return (await o.CameraAccess.getCameras()).find((r)=>this.isUltraWideBackCamera() ? (0, $fa51dabf90952f18$export$4368d992c4eafac0).isIOSBackCameraLabel(r.label) : (0, $fa51dabf90952f18$export$4368d992c4eafac0).isIOSUltraWideBackCameraLabel(r.label));
    }
    async switchCameras(e) {
        var i;
        this.isTransitioning = !0;
        let r = this.frameSource;
        r != null && await r.switchToDesiredState("off");
        let a = new o.Camera;
        a.deviceId = e.deviceId, r != null && await a.applySettings(new (0, $26b53f2fcaea5d86$export$39b482c5e57630a8)(r.settings)), await a.switchToDesiredState("on"), await ((i = this.context) == null ? void 0 : i.setFrameSource(a)), this.isTransitioning = !1;
    }
};



function $5572345873cef079$export$407448d2b89b1813() {
    return `
    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTAINER_CLASS_NAME}::before {
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      width: 1px;
      height: 1px;
      background-color: white;
      pointer-events: none;
      opacity: 0;
      animation: scandit-rotation 1s linear infinite;
    }

    @keyframes scandit-rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTAINER_CLASS_NAME} {
      display: flex;
      /* Without this the flex child overflows its parent on Chrome mobile: */
      flex-direction: column;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARDS_CONTAINER_CLASS_NAME} {
      position: relative;
      width: 100%;
      height: inherit;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} {
      position: relative;
      width: 100%;
      height: 100%;
      min-width: 1px;
      min-height: 1px;
      background-color: black;
      aspect-ratio: 16 / 9;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME}.${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME_STATE_ON} {
      aspect-ratio: auto
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} video {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: opacity 300ms;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).MIRRORED_CLASS_NAME} {
      transform: scale(-1, 1);
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CAMERA_RECOVERY_CLASS_NAME} {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 5;
      cursor: pointer;
      background-color: #000;
      color: #fff;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).ERROR_CLASS_NAME} {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      z-index: 6;
      color: white;
      background-color: rgba(0,0,0,0.5);
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).HINT_CONTAINER_CLASS_NAME} {
      position: absolute;
      width: 100%;
      top: 5vh;
      bottom: 5vh;
      display: grid;
      pointer-events: none;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).HINT_CLASS_NAME} {
      width: fit-content;
      color: black;
      background-color: white;
      padding: 10px;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CAMERA_RECOVERY_CLASS_NAME}[hidden],
    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).ERROR_CLASS_NAME}[hidden] {
      display: none;
    }
    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).HINT_CLASS_NAME}[hidden] {
      display: none;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} canvas {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      object-fit: cover;
      transition: opacity 300ms;
      pointer-events: none;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTROLS_CLASS_NAME} {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTROL_WIDGET_CLASS_NAME}-${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).TORCH_SWITCH_CONTROL_CLASS_NAME} {
      position: absolute;
      top: 24px;
      left: 16px;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTROL_WIDGET_CLASS_NAME}-${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CAMERA_SWITCH_CONTROL_CLASS_NAME} {
      position: absolute;
      top: 24px;
      right: 16px;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTROL_WIDGET_CLASS_NAME}-${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CAMERA_FOV_SWITCH_CONTROL_CLASS_NAME} {
      position: absolute;
      bottom: 24px;
      right: 24px;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).SINGLE_IMAGE_UPLOADER_CONTAINER_CLASS_NAME} {
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).SINGLE_IMAGE_UPLOADER_CONTAINER_CLASS_NAME} label {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).SINGLE_IMAGE_UPLOADER_CONTAINER_CLASS_NAME} label input[type="file"] {
      position: absolute;
      top: -9999px;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME} .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).SINGLE_IMAGE_UPLOADER_CONTAINER_CLASS_NAME} label button {
      pointer-events: none;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTROL_WIDGET_CLASS_NAME} {
      width: 32px;
      height: 32px;
      background-color: transparent;
      background-repeat: no-repeat;
      border: none;
      cursor: pointer;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTROL_WIDGET_CLASS_NAME} + .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTROL_WIDGET_CLASS_NAME} {
      margin-left: 16px;
    }

    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).FROZEN_FRAME} {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 1;
    }
    
    .${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).FROZEN_FRAME}[hidden] {
      opacity: 0;
      pointer-events: none;
      visibility: hidden;
    }
  `;
}


var $d9543ee5e02d547f$var$e = new Set, $d9543ee5e02d547f$export$407448d2b89b1813 = $d9543ee5e02d547f$var$e;



var $8423b731039ba20b$export$407448d2b89b1813 = class c {
    constructor(e){
        this.element = e, this.setupListeners(), this.cacheDOMRect();
    }
    get width() {
        return this.cachedDOMRect.width;
    }
    get height() {
        return this.cachedDOMRect.height;
    }
    static areEquivalentJSONStates(e, t) {
        return !e || !t ? !1 : e.size.isSameAs(t.size) && e.visible === t.visible;
    }
    onStateChanged(e) {
        this.onStateChangedListener = e;
    }
    onDisconnected(e) {
        this.onDisconnectedListener = e;
    }
    toJSONObject() {
        return {
            size: new (0, $72be97bdfeffe3ee$export$dda1d9f60106f0e9)(new (0, $72be97bdfeffe3ee$export$4368d992c4eafac0)(this.width, "pixel"), new (0, $72be97bdfeffe3ee$export$4368d992c4eafac0)(this.height, "pixel")),
            visible: this.isVisible()
        };
    }
    isSameAs(e) {
        return c.areEquivalentJSONStates(this.toJSONObject(), e.toJSONObject());
    }
    removeListeners() {
        this.resizeObserver.disconnect(), this.mutationObserver.disconnect();
    }
    isVisible() {
        return this.width > 0 && this.height > 0 || this.element.getClientRects().length > 0;
    }
    setupListeners() {
        this.resizeObserver = new ResizeObserver(this.onSizeChange.bind(this)), this.resizeObserver.observe(this.element), this.mutationObserver = new MutationObserver(this.onMutation.bind(this)), this.element.parentElement && this.mutationObserver.observe(this.element.parentElement, {
            childList: !0
        });
    }
    onSizeChange(e) {
        var t;
        this.cacheDOMRect(e), document.contains(this.element) && ((t = this.onStateChangedListener) == null || t.call(this));
    }
    onMutation(e) {
        var s;
        let t = e.find(({ type: i })=>i === "childList");
        if (t) {
            for (let i of t.removedNodes)if (i === this.element && !document.contains(this.element)) {
                (s = this.onDisconnectedListener) == null || s.call(this);
                return;
            }
        }
    }
    cacheDOMRect(e) {
        let t;
        Array.isArray(e) && e.length > 0 && (t = e[0].contentRect), t == null && (t = this.element.getBoundingClientRect()), this.cachedDOMRect = t;
    }
};


var $5ca95f0db55618fd$export$407448d2b89b1813 = {
    PROGRESSBAR_CONTAINER: "scandit-progressbar-container",
    MESSAGE: "scandit-progressbar-message",
    HIDE: "scandit-progressbar-hide"
}, $5ca95f0db55618fd$var$e = `
    @media (prefers-color-scheme: dark) {
      .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER} {
        --foreground-color: white;
        --background-color: black;
      }
    }

    @media (prefers-color-scheme: light) {
      .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER} {
        --foreground-color: black;
        --background-color: white;
      }
    }
    
    .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER} {
      --accent-color: #62d1da;
      --secondary-color: #dae1e7;
      --100-w: 15rem;
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 1;
      background-color: var(--background-color);
    }
    
    .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER}.${$5ca95f0db55618fd$export$407448d2b89b1813.HIDE} {
       display: none;
    }
    
    .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER} .${$5ca95f0db55618fd$export$407448d2b89b1813.MESSAGE} {
      text-align: center;
      font-family: "Open Sans", sans-serif;
      margin-bottom: 1rem;
      color: var(--foreground-color);
    }
    
    .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER} [role="progressbar"] {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      position: relative;
      overflow: hidden;
      border: none;
      width: var(--100-w);
      height: 0.5rem;
    }
    
    .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER} [role="progressbar"]::before,
    .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER} [role="progressbar"]::after {
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      background: var(--accent-color);
      height: 0.5rem;
      border-radius: 0.5rem;
    }
    
    .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER} [role="progressbar"]:not([aria-valuenow])::after {
      width: calc(var(--100-w) / 3.5);
      animation: indeterminate-progress-bar 2.5s ease infinite;
      z-index: 1;
    }

    .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER} [role="progressbar"][aria-valuenow]::after {
      width: 0;
      animation: none;
    }
    
    .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER} [role="progressbar"][aria-valuenow]::before {
      width: calc(var(--aria-valuenow) * 1%);
      background-color: var(--accent-color);
      border-radius: 0.5rem;
      transition: width 0.3s linear;
    }
    
    .${$5ca95f0db55618fd$export$407448d2b89b1813.PROGRESSBAR_CONTAINER} [role="progressbar"] {
      background-color: var(--secondary-color);
      border-radius: 0.5rem;
    }
    
    @-webkit-keyframes indeterminate-progress-bar {
      0% {
        left: 0%;
      }
      50% {
        left: calc(var(--100-w) - var(--100-w) / 3.5);
      }
    }
    
    @keyframes indeterminate-progress-bar {
      0% {
        left: 0%;
      }
      50% {
        left: calc(var(--100-w) - var(--100-w) / 3.5);
      }
    }
`, $5ca95f0db55618fd$export$8b22cf2602fb60ce = $5ca95f0db55618fd$var$e;


var $5b3d0f158899517d$export$407448d2b89b1813 = class i {
    constructor(){
        this.translations = new Map;
    }
    static getInstance() {
        return i.instance == null && (i.instance = new i), i.instance;
    }
    get(t) {
        var s;
        return (s = this.translations.get(t)) != null ? s : "";
    }
    getAll() {
        return {
            ...this.translations
        };
    }
    update(t) {
        this.translations = new Map(Object.entries({
            ...Object.fromEntries(this.translations),
            ...t
        }));
    }
    updateIfMissing(t) {
        for (let [s, e] of Object.entries(t))this.translations.has(s) || this.translations.set(s, e);
    }
};


var $151d6ec27bf4afa2$var$b = `
    <div>
      <div class="${(0, $5ca95f0db55618fd$export$407448d2b89b1813).MESSAGE}" id="scandit-loadinglabel"></div>
      <div id="scandit-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-labelledby="scandit-loadinglabel" />
    </div>
`, $151d6ec27bf4afa2$var$a = "aria-valuenow", $151d6ec27bf4afa2$var$v = "aria-valuemin", $151d6ec27bf4afa2$var$_ = "aria-valuemax", $151d6ec27bf4afa2$var$o = class o {
    constructor(){
        this._mounted = !1;
        this._htmlRoot = null;
        this._progress = null;
        this._message = null;
    }
    set value(e) {
        var r, l, m, u, d, c;
        if (!this._mounted) return;
        if (e == null) {
            (r = this._progress) == null || r.removeAttribute($151d6ec27bf4afa2$var$a), (l = this._progress) == null || l.removeAttribute("style");
            return;
        }
        let t = Number((m = this._progress) == null ? void 0 : m.getAttribute($151d6ec27bf4afa2$var$v)), s = Number((u = this._progress) == null ? void 0 : u.getAttribute($151d6ec27bf4afa2$var$_));
        if (e >= t && e <= s) {
            let p = String(e);
            (d = this._progress) == null || d.setAttribute($151d6ec27bf4afa2$var$a, p), (c = this._progress) == null || c.setAttribute("style", `--aria-valuenow: ${p}`);
        }
    }
    get value() {
        var s;
        let e = (s = this._progress) == null ? void 0 : s.getAttribute($151d6ec27bf4afa2$var$a);
        if (e === null) return null;
        let t = Number(e);
        return Number.isNaN(t) ? null : t;
    }
    set message(e) {
        this._message && (this._message.textContent = e);
    }
    get message() {
        var e, t;
        return (t = (e = this._message) == null ? void 0 : e.textContent) != null ? t : "";
    }
    mount(e) {
        var s;
        if (this._mounted) return;
        if (!document.head.querySelector(`[data-component=${o.componentName}]`)) {
            let r = document.createElement("style");
            r.dataset.component = o.componentName, r.append(document.createTextNode((0, $5ca95f0db55618fd$export$8b22cf2602fb60ce))), document.head.append(r);
        }
        let t = document.createElement("div");
        t.classList.add((0, $5ca95f0db55618fd$export$407448d2b89b1813).PROGRESSBAR_CONTAINER), t.classList.add((0, $5ca95f0db55618fd$export$407448d2b89b1813).HIDE), t.innerHTML = $151d6ec27bf4afa2$var$b, (s = e.parentNode) == null || s.replaceChild(t, e), this._htmlRoot = t, this._progress = this._htmlRoot.querySelector("[role=progressbar]"), this._message = this._htmlRoot.querySelector(`.${(0, $5ca95f0db55618fd$export$407448d2b89b1813).MESSAGE}`), this.message = (0, $5b3d0f158899517d$export$407448d2b89b1813).getInstance().get("core.view.loading"), this._mounted = !0;
    }
    unmount() {
        var e, t;
        this._mounted && ((e = this._htmlRoot) == null || e.remove(), (t = document.head.querySelector(`[data-component=${o.componentName}]`)) == null || t.remove(), this._mounted = !1);
    }
    show() {
        this._mounted && this._htmlRoot && this._htmlRoot.classList.remove((0, $5ca95f0db55618fd$export$407448d2b89b1813).HIDE);
    }
    hide() {
        this._mounted && this._htmlRoot && this._htmlRoot.classList.add((0, $5ca95f0db55618fd$export$407448d2b89b1813).HIDE);
    }
};
$151d6ec27bf4afa2$var$o.componentName = "ProgressBarView";
var $151d6ec27bf4afa2$var$n = $151d6ec27bf4afa2$var$o, $151d6ec27bf4afa2$export$407448d2b89b1813 = $151d6ec27bf4afa2$var$n;


var $728acd77ffb729b8$export$407448d2b89b1813 = {
    SINGLE_IMAGE_UPLOADER_CONTAINER: "scandit-single-image-uploader-container"
}, $728acd77ffb729b8$export$8b22cf2602fb60ce = {
    SINGLE_IMAGE_UPLOADER_CONTAINER_STYLE: {
        backgroundColor: "#FFFFFF"
    },
    SINGLE_IMAGE_UPLOADER_ICON_STYLE: {
        fill: "#121619"
    },
    SINGLE_IMAGE_UPLOADER_INFORMATION_STYLE: {
        color: "#121619",
        marginBottom: "2em"
    },
    SINGLE_IMAGE_UPLOADER_BUTTON_STYLE: {
        color: "#FFFFFF",
        backgroundColor: "#121619",
        fontWeight: "bold",
        padding: "1.25em",
        width: "12em",
        textAlign: "center",
        textTransform: "uppercase"
    }
}, $728acd77ffb729b8$export$db3b6bfb95261072 = `
  .${$728acd77ffb729b8$export$407448d2b89b1813.SINGLE_IMAGE_UPLOADER_CONTAINER} {
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .${$728acd77ffb729b8$export$407448d2b89b1813.SINGLE_IMAGE_UPLOADER_CONTAINER} label {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .${$728acd77ffb729b8$export$407448d2b89b1813.SINGLE_IMAGE_UPLOADER_CONTAINER} label input[type="file"] {
    position: absolute;
    top: -9999px;
  }

  .${$728acd77ffb729b8$export$407448d2b89b1813.SINGLE_IMAGE_UPLOADER_CONTAINER} label div {
    user-select: none;
  }

  .${$728acd77ffb729b8$export$407448d2b89b1813.SINGLE_IMAGE_UPLOADER_CONTAINER} label input[type="file"]:disabled + div {
    opacity: 0.5;
  }
`;





var $7119f91274c59aa3$var$o = class o {
    constructor(e){
        this.canUploadFile = !1;
        this._mounted = !1;
        this._loading = !1;
        this._htmlRoot = void 0;
        this._canvas = void 0;
        this._onInputCheck = void 0;
        this._onBeforeFileRead = void 0;
        this._onImageLoadError = void 0;
        this._onFileReaderError = void 0;
        this._onCaptureReady = void 0;
        this._resizedImageSizeLimit = 1440;
        this._inputElement = void 0;
        this._buttonElement = void 0;
        this._chooseImageText = "";
        this._settings = e;
    }
    get canvas() {
        return this._canvas || (this._canvas = document.createElement("canvas")), this._canvas;
    }
    get canvasContext() {
        return this._canvasContext || (this._canvasContext = this.canvas.getContext("2d", {
            willReadFrequently: !0
        })), this._canvasContext;
    }
    mount(e) {
        var E;
        if (this._mounted) return;
        if (!document.head.querySelector(`[data-component=${o.componentName}]`)) {
            let s = document.createElement("style");
            s.dataset.component = o.componentName, s.textContent = (0, $728acd77ffb729b8$export$db3b6bfb95261072), document.head.append(s);
        }
        let t = document.createElement("div");
        t.className = (0, $728acd77ffb729b8$export$407448d2b89b1813).SINGLE_IMAGE_UPLOADER_CONTAINER, Object.assign(t.style, (0, $728acd77ffb729b8$export$8b22cf2602fb60ce).SINGLE_IMAGE_UPLOADER_CONTAINER_STYLE, this._settings.containerStyle), e.append(t);
        let { iconElement: n, iconStyle: d, informationElement: i, informationStyle: u, buttonElement: r, buttonStyle: c$2, onlyCameraCapture: b$1 } = this._settings;
        Object.assign(n.style, (0, $728acd77ffb729b8$export$8b22cf2602fb60ce).SINGLE_IMAGE_UPLOADER_ICON_STYLE, d, {
            maxWidth: "100px",
            maxHeight: "100px"
        }), t.append(n), i.hasAttribute(o.DEFAULT_DOM_ATTRIBUTE) && (Object.assign(i.style, (0, $728acd77ffb729b8$export$8b22cf2602fb60ce).SINGLE_IMAGE_UPLOADER_INFORMATION_STYLE, u), i.textContent = (0, $5b3d0f158899517d$export$407448d2b89b1813).getInstance().get("core.singleImageUploader.title")), t.append(i);
        let a$2 = document.createElement("input");
        a$2.type = "file", a$2.accept = "image/*", b$1 && (a$2.capture = "environment", a$2.dataset.onlyCaptureOnMobile = "environment"), a$2.addEventListener("change", (s)=>{
            this.onFileUpload(s);
        }), a$2.addEventListener("click", (s)=>{
            var l;
            (l = this._onInputCheck) == null || l.call(this, s);
        }), a$2.addEventListener("keydown", (s)=>{
            var l;
            (l = this._onInputCheck) == null || l.call(this, s);
        });
        let p = document.createElement("label");
        p.append(a$2), r.hasAttribute(o.DEFAULT_DOM_ATTRIBUTE) && (Object.assign(r.style, (0, $728acd77ffb729b8$export$8b22cf2602fb60ce).SINGLE_IMAGE_UPLOADER_BUTTON_STYLE, c$2), r.textContent = (0, $5b3d0f158899517d$export$407448d2b89b1813).getInstance().get("core.singleImageUploader.button")), p.append(r), t.append(p);
        let v = document.createRange().createContextualFragment(atob((0, $ec0c8796762efcd7$export$db3b6bfb95261072))).firstElementChild;
        Object.assign(v.style, {
            position: "absolute",
            bottom: "1em",
            right: "1em",
            width: "10em"
        }), t.append(v), this._htmlRoot = t, this._mounted = !0, this._inputElement = a$2, this._buttonElement = r, this._chooseImageText = (E = r.textContent) != null ? E : "";
    }
    unmount() {
        var e, t;
        this._mounted && ((e = this._htmlRoot) == null || e.remove(), (t = document.head.querySelector(`[data-component=${o.componentName}]`)) == null || t.remove(), this._mounted = !1);
    }
    setButtonState(e) {
        this._inputElement && (this._inputElement.disabled = e === "disabled");
    }
    getButtonState() {
        return this._inputElement ? this._inputElement.disabled ? "disabled" : "enabled" : "disabled";
    }
    getLastUploadedImage() {
        return this.canvasContext.getImageData(0, 0, this.canvasContext.canvas.width, this.canvasContext.canvas.height);
    }
    onInputCheck(e) {
        this._onInputCheck = e;
    }
    onBeforeFileRead(e) {
        this._onBeforeFileRead = e;
    }
    onImageLoadError(e) {
        this._onImageLoadError = e;
    }
    onFileReaderError(e) {
        this._onFileReaderError = e;
    }
    onCaptureReady(e) {
        this._onCaptureReady = e;
    }
    setLoading(e) {
        this._buttonElement && (this.setButtonState(e ? "disabled" : "enabled"), this._buttonElement.textContent = e ? "..." : this._chooseImageText, this._loading = e);
    }
    getResizedImageDimensions(e, t) {
        return e <= this._resizedImageSizeLimit && t <= this._resizedImageSizeLimit ? {
            width: e,
            height: t
        } : e > t ? {
            width: this._resizedImageSizeLimit,
            height: Math.round(t / e * this._resizedImageSizeLimit)
        } : {
            width: Math.round(e / t * this._resizedImageSizeLimit),
            height: this._resizedImageSizeLimit
        };
    }
    onImageLoad(e) {
        var i;
        let { height: t, width: n } = this.getResizedImageDimensions(e.naturalWidth, e.naturalHeight);
        this.canvasContext.canvas.width = n, this.canvasContext.canvas.height = t, this.canvasContext.drawImage(e, 0, 0, n, t);
        let d = {
            data: this.canvasContext.getImageData(0, 0, n, t).data,
            width: n,
            height: t
        };
        (i = this._onCaptureReady) == null || i.call(this, d);
    }
    onFileReaderLoad(e, t, n) {
        e.value = "", t.result != null && (n.addEventListener("load", ()=>{
            this.onImageLoad(n), this.setLoading(!1);
        }, {
            once: !0
        }), n.addEventListener("error", (d)=>{
            var i;
            (i = this._onImageLoadError) == null || i.call(this, d), this.setLoading(!1);
        }, {
            once: !0
        }), n.src = t.result);
    }
    onFileUpload(e) {
        var u;
        this.setLoading(!0);
        let t = e.currentTarget, { files: n } = t;
        if (n == null || n.length === 0) {
            this.setLoading(!1);
            return;
        }
        if ((u = this._onBeforeFileRead) == null || u.call(this, e), !this.canUploadFile) {
            t.value = "", (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Can't upload file"), this.setLoading(!1);
            return;
        }
        let d = new Image, i = new FileReader;
        i.addEventListener("load", ()=>{
            this.onFileReaderLoad(t, i, d);
        }), i.addEventListener("error", (r)=>{
            var c;
            (c = this._onFileReaderError) == null || c.call(this, r), this.setLoading(!1);
        }), i.readAsDataURL(n[0]);
    }
};
$7119f91274c59aa3$var$o.componentName = "SingleImageUploaderView", $7119f91274c59aa3$var$o.DEFAULT_DOM_ATTRIBUTE = "data-scandit-default";
var $7119f91274c59aa3$export$407448d2b89b1813 = $7119f91274c59aa3$var$o;


function $bd33549b1d5635fe$export$407448d2b89b1813(e, n) {
    if (e === !1) throw new Error(n);
}
function $bd33549b1d5635fe$export$8b22cf2602fb60ce(e) {
    console.warn("Reached unexpected case", e);
}
function $bd33549b1d5635fe$export$db3b6bfb95261072(e) {
    throw new Error("Reached unexpected case");
}


var $0fb8d1264f279d3d$export$407448d2b89b1813 = ((e)=>(e.Nonzero = "nonzero", e.Evenodd = "evenodd", e))($0fb8d1264f279d3d$export$407448d2b89b1813 || {}), $0fb8d1264f279d3d$export$8b22cf2602fb60ce = class {
    constructor(){
        this.pathWinding = "nonzero";
    }
    drawSingleCommand(t, e) {
        switch(t){
            case 0:
                this.addLine(e);
                break;
            case 1:
                this.addArc(e);
                break;
            case 2:
                this.addCircle(e);
                break;
            case 3:
                this.addRectangle(e);
                break;
            case 4:
                this.addRoundedRectangle(e);
                break;
            case 5:
                this.beginPath(e);
                break;
            case 6:
                this.closePath(e);
                break;
            case 7:
                this.fill(e);
                break;
            case 8:
                this.stroke(e);
                break;
            case 10:
                this.setStrokeWidth(e);
                break;
            case 11:
                this.setFillColor(e);
                break;
            case 12:
                this.setStrokeColor(e);
                break;
            case 13:
                this.moveTo(e);
                break;
            case 14:
                this.lineTo(e);
                break;
            case 15:
                this.saveState(e);
                break;
            case 16:
                this.restoreState(e);
                break;
            case 17:
                this.translate(e);
                break;
            case 19:
                this.bezierTo(e);
                break;
            case 20:
                this.transform(e);
                break;
            case 21:
                this.scale(e);
                break;
            case 22:
                this.addPathWinding(e);
                break;
            case 9:
            case 18:
            default:
                (0, $bd33549b1d5635fe$export$8b22cf2602fb60ce)(t);
                break;
        }
    }
    beginPath(t) {
        this.context.beginPath();
    }
    closePath(t) {
        this.context.closePath();
    }
    setStrokeColor(t) {
        let e = t.extractColor();
        this.context.strokeStyle = this.colorToRgbaString(e);
    }
    setFillColor(t) {
        let e = t.extractColor();
        this.context.fillStyle = this.colorToRgbaString(e);
    }
    fill(t) {
        this.context.fill(this.pathWinding);
    }
    stroke(t) {
        this.context.stroke();
    }
    addLine(t) {
        let e = t.extractFloat(), a = t.extractFloat();
        this.context.moveTo(e, a);
        let o = t.extractFloat(), r = t.extractFloat();
        this.context.lineTo(o, r);
    }
    lineTo(t) {
        let e = t.extractFloat(), a = t.extractFloat();
        this.context.lineTo(e, a);
    }
    moveTo(t) {
        let e = t.extractFloat(), a = t.extractFloat();
        this.context.moveTo(e, a);
    }
    addRectangle(t) {
        let e = t.extractFloat(), a = t.extractFloat(), o = t.extractFloat(), r = t.extractFloat();
        this.context.rect(e, a, o, r);
    }
    addRoundedRectangle(t) {
        let e = t.extractFloat(), a = t.extractFloat(), o = t.extractFloat(), r = t.extractFloat(), i = t.extractFloat();
        this.context.moveTo(e + i, a), this.context.lineTo(e + o - i, a), this.context.quadraticCurveTo(e + o, a, e + o, a + i), this.context.lineTo(e + o, a + r - i), this.context.quadraticCurveTo(e + o, a + r, e + o - i, a + r), this.context.lineTo(e + i, a + r), this.context.quadraticCurveTo(e, a + r, e, a + r - i), this.context.lineTo(e, a + i), this.context.quadraticCurveTo(e, a, e + i, a), this.context.closePath();
    }
    setStrokeWidth(t) {
        this.context.lineWidth = t.extractFloat();
    }
    addArc(t) {
        let e = t.extractFloat(), a = t.extractFloat(), o = t.extractFloat(), r = t.extractFloat(), i = t.extractFloat(), s = t.extractBoolean();
        this.context.arc(e, a, o, r, i, s);
    }
    addCircle(t) {
        let e = t.extractFloat(), a = t.extractFloat(), o = t.extractFloat();
        this.context.arc(e, a, o, 0, Math.PI * 2);
    }
    bezierTo(t) {
        let e = t.extractFloat(), a = t.extractFloat(), o = t.extractFloat(), r = t.extractFloat(), i = t.extractFloat(), s = t.extractFloat();
        this.context.bezierCurveTo(e, a, o, r, i, s);
    }
    saveState(t) {
        this.context.save();
    }
    restoreState(t) {
        this.context.restore();
    }
    translate(t) {
        let e = t.extractFloat(), a = t.extractFloat();
        this.context.translate(e, a);
    }
    transform(t) {
        let e = t.extractFloat(), a = t.extractFloat(), o = t.extractFloat(), r = t.extractFloat(), i = t.extractFloat(), s = t.extractFloat();
        this.context.transform(e, a, o, r, i, s);
    }
    scale(t) {
        let e = t.extractFloat();
        this.context.scale(e, e);
    }
    addPathWinding(t) {
        let e = t.extractBoolean();
        this.pathWinding = e ? "nonzero" : "evenodd";
    }
    colorToRgbaString(t) {
        return `rgba(${t.r},${t.g},${t.b},${t.a})`;
    }
};


var $47f30af04591f276$export$407448d2b89b1813 = ((e)=>(e[e.AddLine = 0] = "AddLine", e[e.AddArc = 1] = "AddArc", e[e.AddCircle = 2] = "AddCircle", e[e.AddRect = 3] = "AddRect", e[e.AddRoundedRect = 4] = "AddRoundedRect", e[e.BeginPath = 5] = "BeginPath", e[e.ClosePath = 6] = "ClosePath", e[e.Fill = 7] = "Fill", e[e.Stroke = 8] = "Stroke", e[e.Clear = 9] = "Clear", e[e.SetStrokeWidth = 10] = "SetStrokeWidth", e[e.SetFillColor = 11] = "SetFillColor", e[e.SetStrokeColor = 12] = "SetStrokeColor", e[e.MoveTo = 13] = "MoveTo", e[e.LineTo = 14] = "LineTo", e[e.SaveState = 15] = "SaveState", e[e.RestoreState = 16] = "RestoreState", e[e.Translate = 17] = "Translate", e[e.ScaleAroundPoint = 18] = "ScaleAroundPoint", e[e.BezierTo = 19] = "BezierTo", e[e.Transform = 20] = "Transform", e[e.Scale = 21] = "Scale", e[e.AddPathWinding = 22] = "AddPathWinding", e))($47f30af04591f276$export$407448d2b89b1813 || {}), $47f30af04591f276$export$8b22cf2602fb60ce = class {
    constructor(t){
        this._index = 0;
        this._view = new DataView(t.buffer), this._index = 0;
    }
    extractCommandType() {
        let t = this._view.getUint8(this._index);
        return this._index += 1, t;
    }
    extractFloat() {
        let t = this._view.getFloat32(this._index, !0);
        return this._index += 4, t;
    }
    extractBoolean() {
        let t = this._view.getUint8(this._index);
        return this._index += 1, t !== 0;
    }
    extractColor() {
        let t = this._view.getUint8(this._index), s = this._view.getUint8(this._index + 1), l = this._view.getUint8(this._index + 2), c = this._view.getUint8(this._index + 3) / 256;
        return this._index += 4, {
            r: t,
            g: s,
            b: l,
            a: c
        };
    }
    isConsumed() {
        return this._index >= this._view.byteLength;
    }
};


var $d09252450bfd6e84$export$407448d2b89b1813 = ((e)=>(e.Nonzero = "nonzero", e.Evenodd = "evenodd", e))($d09252450bfd6e84$export$407448d2b89b1813 || {}), $d09252450bfd6e84$var$n = class n extends (0, $0fb8d1264f279d3d$export$8b22cf2602fb60ce) {
    constructor(e){
        super();
        this._context = null;
        this.isNextDrawPending = !1;
        this.latestCommands = new Uint8Array([]);
        this.canvas = e, this.doDrawLoop = this.doDraw.bind(this);
    }
    get context() {
        if (!this._context && (this._context = this.canvas.getContext("2d"), !this._context)) throw new TypeError("CanvasRenderingContext cannot be retrieved.");
        return this._context;
    }
    draw(e) {
        if (this.latestCommands = e, !this.isCanvasReady()) {
            this.postponeDraw();
            return;
        }
        this.isNextDrawPending || (this.isNextDrawPending = !0, requestAnimationFrame(this.doDrawLoop));
    }
    updateCanvasSizeAttributes(e, s, t = window.devicePixelRatio) {
        let i = Math.round(e * t), r = Math.round(s * t);
        (i !== this.canvas.width || r !== this.canvas.height) && (this.canvas.width = i, this.canvas.height = r, this.context.scale(t, t));
    }
    startObservingCanvasResize() {
        if (!this.resizeObserver) {
            if (!n.ResizeObserver) throw new Error("PrivateCanvasDrawer.ResizeObserver is not set");
            this.resizeObserver = new n.ResizeObserver((e)=>{
                var r;
                let [s] = e, { width: t, height: i } = (r = s.contentRect) != null ? r : this.canvas;
                t === 0 || i === 0 || (this.updateCanvasSizeAttributes(t, i), this.latestCommands.length !== 0 && (this.draw(this.latestCommands), this.latestCommands = new Uint8Array([])));
            }), this.resizeObserver.observe(this.canvas);
        }
    }
    endObservingCanvasResize() {
        this.resizeObserver && this.resizeObserver.unobserve(this.canvas);
    }
    doDraw() {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        let e = new (0, $47f30af04591f276$export$8b22cf2602fb60ce)(this.latestCommands);
        for(; !e.isConsumed();){
            let s = e.extractCommandType();
            this.drawSingleCommand(s, e);
        }
        this.isNextDrawPending = !1;
    }
    postponeDraw() {
        this.startObservingCanvasResize();
    }
    isCanvasReady() {
        return this.canvas.width > 0 && this.canvas.height > 0;
    }
};
$d09252450bfd6e84$var$n.ResizeObserver = "ResizeObserver" in globalThis ? globalThis.ResizeObserver : void 0;
var $d09252450bfd6e84$export$8b22cf2602fb60ce = $d09252450bfd6e84$var$n;



var $05ef5a7b63bfed46$var$x = {
    processedFramesCount: {
        text: "Frames processed by engine",
        valueSuffix: "/sec"
    },
    frameDataPoolSize: {
        text: "Frame data pool size",
        valueSuffix: ""
    },
    redrawRequestsCount: {
        text: "Engine redraw requests",
        valueSuffix: "/sec"
    },
    actualRedrawsCount: {
        text: "Actual redraws",
        valueSuffix: "/sec"
    },
    FPS: {
        text: "Overlay FPS ",
        valueSuffix: "/sec"
    }
}, $05ef5a7b63bfed46$export$407448d2b89b1813 = class extends (0, $d09252450bfd6e84$export$8b22cf2602fb60ce) {
    constructor(){
        super(...arguments);
        this.drawPerformanceTimer = null;
        this.drawPerformanceFPSCounter = 0;
        this.lastDrawPerformanceFPSCounter = 0;
    }
    setPerformanceMetrics(r) {
        this.performanceMetrics = r, this.drawPerformanceMetrics();
    }
    doDraw() {
        super.doDraw();
    }
    drawPerformanceMetrics() {
        this.drawPerformanceTimer == null && ((0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "Drawing performance monitoring enabled, FPS will be drawn into canvas"), this.drawPerformanceTimer = setInterval(()=>{
            this.lastDrawPerformanceFPSCounter = this.drawPerformanceFPSCounter, this.drawPerformanceFPSCounter = 0;
        }, 1e3)), this.drawPerformanceFPSCounter++, this.drawFullPerformanceMetrics();
    }
    drawFullPerformanceMetrics() {
        let r = {
            ...this.performanceMetrics,
            FPS: this.lastDrawPerformanceFPSCounter
        };
        this.context.lineWidth = 1, this.context.fillStyle = "white", this.context.strokeStyle = "black";
        let e = Math.min(Math.max(window.innerWidth / 35, 13), 20), t = 3 * e, s = 1.5;
        this.context.font = `bold ${e}px sans-serif`;
        let u = 0, a = 0, i = [];
        for (let [o, d] of Object.entries(r)){
            let c = $05ef5a7b63bfed46$var$x[o], f = `${c.text}: ${d}${c.valueSuffix}`;
            a = Math.max(this.context.measureText(f).width, a), i.push([
                f,
                t,
                t + e * s * u++
            ]);
        }
        this.context.clearRect(t, t - e, a, Object.values(r).length * e * s);
        for (let o of i)this.context.fillText(...o), this.context.strokeText(...o);
    }
};










var $dbe5fa81d62f48f7$export$407448d2b89b1813 = class n {
    static fromJSON(e) {
        let t = new n;
        return t._code = e.code, t._message = e.message, t._isValid = e.isValid, t;
    }
    get message() {
        return this._message;
    }
    get code() {
        return this._code;
    }
    get isValid() {
        return this._isValid;
    }
}, $dbe5fa81d62f48f7$export$8b22cf2602fb60ce = ((a)=>(a.None = "None", a.X = "X", a.Y = "Y", a))($dbe5fa81d62f48f7$export$8b22cf2602fb60ce || {});


var $8408943213286160$export$407448d2b89b1813 = class z {
    constructor(){
        this.focusGesture = (0, $520f4e9f5a30204d$export$4368d992c4eafac0).DataCaptureView.focusGesture;
        this.zoomGesture = (0, $520f4e9f5a30204d$export$4368d992c4eafac0).DataCaptureView.zoomGesture;
        this._scanAreaMargins = (0, $520f4e9f5a30204d$export$4368d992c4eafac0).DataCaptureView.scanAreaMargins;
        this._pointOfInterest = (0, $520f4e9f5a30204d$export$4368d992c4eafac0).DataCaptureView.pointOfInterest;
        this._logoStyle = (0, $520f4e9f5a30204d$export$4368d992c4eafac0).DataCaptureView.logoStyle;
        this._logoAnchor = (0, $520f4e9f5a30204d$export$4368d992c4eafac0).DataCaptureView.logoAnchor;
        this._logoOffset = (0, $520f4e9f5a30204d$export$4368d992c4eafac0).DataCaptureView.logoOffset;
        this._cameraRecoveryText = (0, $5b3d0f158899517d$export$407448d2b89b1813).getInstance().get("core.camera.recovery");
        this._context = null;
        this.overlays = [];
        this.controls = [];
        this.controlWidgets = new WeakMap;
        this.frozenFrameCanvas = document.createElement("canvas");
        this.listeners = [];
        this.isVideoElementDetached = !1;
        this.visibilityListener = this.onVisibilityChange.bind(this), this.cameraRecoveryListener = this.cameraRecovery.bind(this);
    }
    get scanAreaMargins() {
        return this._scanAreaMargins;
    }
    set scanAreaMargins(e) {
        var t;
        this._scanAreaMargins = e, (t = this.privateContext) == null || t.update();
    }
    get pointOfInterest() {
        return this._pointOfInterest;
    }
    set pointOfInterest(e) {
        var t;
        this._pointOfInterest = e, (t = this.privateContext) == null || t.update();
    }
    get logoStyle() {
        return this._logoStyle;
    }
    set logoStyle(e) {
        var t;
        this._logoStyle = e, (t = this.privateContext) == null || t.update();
    }
    get logoAnchor() {
        return this._logoAnchor;
    }
    set logoAnchor(e) {
        var t;
        this._logoAnchor = e, (t = this.privateContext) == null || t.update();
    }
    get logoOffset() {
        return this._logoOffset;
    }
    set logoOffset(e) {
        var t;
        this._logoOffset = e, (t = this.privateContext) == null || t.update();
    }
    get cameraRecoveryText() {
        return this._cameraRecoveryText;
    }
    set cameraRecoveryText(e) {
        (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, "DEPRECATED: DataCaptureView.cameraRecoveryText is deprecated, use the Localization API instead."), this._cameraRecoveryText = e, this.cameraRecoveryElement.textContent = e;
    }
    get width() {
        var e, t;
        return Math.round((t = (e = this.htmlElementState) == null ? void 0 : e.width) != null ? t : 0);
    }
    get height() {
        var e, t;
        return Math.round((t = (e = this.htmlElementState) == null ? void 0 : e.height) != null ? t : 0);
    }
    get canvasDrawer() {
        return !this._canvasDrawer && this.canvasElement != null && (this._canvasDrawer = new (0, $d09252450bfd6e84$export$8b22cf2602fb60ce)(this.canvasElement), this._canvasDrawer.startObservingCanvasResize()), this._canvasDrawer;
    }
    get privateContext() {
        return this._context;
    }
    static async forContext(e) {
        let t = new z;
        return await t.setContext(e), t;
    }
    showProgressBar() {
        var e;
        (e = this.progressBarView) == null || e.show();
    }
    hideProgressBar() {
        var e;
        (e = this.progressBarView) == null || e.hide();
    }
    setProgressBarPercentage(e) {
        this.progressBarView && (this.progressBarView.value = e);
    }
    setProgressBarMessage(e) {
        this.progressBarView && (this.progressBarView.message = e);
    }
    getContext() {
        return this._context;
    }
    async setContext(e) {
        var t, i, a;
        if (this._context = e, e) {
            if (this.overlays.length > 0 && ((t = this.privateContext) == null ? void 0 : t.modes.length) === 0) throw new Error([
                "Cannot assign this view to this context. This view has overlays but the context does not have any mode attached matching these overlays.",
                "Remove the overlays first before attaching the view to the context, or add the corresponding mode to the context before attaching this view."
            ].join(" "));
            await e.setView(this), (i = this.privateContext) == null || i.subscribeToWorkerMessages(this.onWorkerMessage.bind(this)), (a = this._context) != null && a.frameSource && await this.onFrameSourceChange(this._context.frameSource);
        }
    }
    connectToElement(e) {
        var t;
        this.setupHtmlElement(e), (t = this.canvasDrawer) == null || t.startObservingCanvasResize(), this.htmlElementDidChange(), (0, $d9543ee5e02d547f$export$407448d2b89b1813).add(this);
    }
    detachFromElement() {
        var e, t, i, a;
        (e = this.htmlElementState) == null || e.removeListeners(), this.removeStyles(), (t = this.canvasDrawer) == null || t.endObservingCanvasResize(), document.removeEventListener("visibilitychange", this.visibilityListener);
        for (let n of [
            "touchend",
            "mousedown"
        ])this.cameraRecoveryElement.removeEventListener(n, this.cameraRecoveryListener);
        (i = this.progressBarView) == null || i.unmount(), this.htmlElementDidChange(), (a = this.gestureRecognizer) == null || a.removeAllListeners(), this.clearHtmlElementContent(), (0, $d9543ee5e02d547f$export$407448d2b89b1813).delete(this);
    }
    async addOverlay(e) {
        var t;
        this.overlays.includes(e) || (this.overlays.push(e), await ((t = this.privateContext) == null ? void 0 : t.update([
            {
                type: "addOverlay",
                newValue: e
            }
        ])));
    }
    async removeOverlay(e) {
        var t;
        this.overlays.includes(e) && (this.overlays.splice(this.overlays.indexOf(e), 1), await ((t = this.privateContext) == null ? void 0 : t.update([
            {
                type: "removeOverlay",
                newValue: e
            }
        ])));
    }
    addListener(e) {
        this.listeners.includes(e) || this.listeners.push(e);
    }
    removeListener(e) {
        this.listeners.includes(e) && this.listeners.splice(this.listeners.indexOf(e), 1);
    }
    viewPointForFramePoint(e) {
        var u, g, E, C, f, S, y, w;
        let t = {
            width: (g = (u = this.htmlElementState) == null ? void 0 : u.width) != null ? g : 0,
            height: (C = (E = this.htmlElementState) == null ? void 0 : E.height) != null ? C : 0
        }, i = {
            width: (S = (f = this.videoElement) == null ? void 0 : f.videoWidth) != null ? S : 0,
            height: (w = (y = this.videoElement) == null ? void 0 : y.videoHeight) != null ? w : 0
        }, a = t.width / t.height, n = i.width / i.height, o = a > n ? t.width / i.width : t.height / i.height, h = {
            x: e.x * o,
            y: e.y * o
        }, d = (i.width * o - t.width) / 2, c = (i.height * o - t.height) / 2;
        return new (0, $72be97bdfeffe3ee$export$407448d2b89b1813)(h.x - d, h.y - c);
    }
    viewQuadrilateralForFrameQuadrilateral(e) {
        let t = this.viewPointForFramePoint(e.topLeft), i = this.viewPointForFramePoint(e.topRight), a = this.viewPointForFramePoint(e.bottomLeft), n = this.viewPointForFramePoint(e.bottomRight);
        return new (0, $72be97bdfeffe3ee$export$8b22cf2602fb60ce)(t, i, n, a);
    }
    addControl(e) {
        var t;
        this.controls.includes(e) || (e.view = this, this.controls.push(e), this.controlsUpdated(), (t = this.privateContext) == null || t.update([
            {
                type: "addControl",
                newValue: e
            }
        ]));
    }
    removeControl(e) {
        var t;
        if (this.controls.includes(e)) {
            e.view = null;
            let i = this.controls.splice(this.controls.indexOf(e), 1);
            this.getControlWidget(i[0]).remove(!0), this.controlsUpdated(), (t = this.privateContext) == null || t.update([
                {
                    type: "removeControl",
                    newValue: e
                }
            ]);
        }
    }
    toJSONObject() {
        var e;
        return {
            scanAreaMargins: this.scanAreaMargins.toJSONObject(),
            pointOfInterest: this.pointOfInterest.toJSONObject(),
            logoAnchor: this.logoAnchor,
            logoOffset: this.logoOffset.toJSONObject(),
            logoHidden: (e = this.logoHidden) != null ? e : !1,
            logoStyle: this.logoStyle,
            overlays: this.overlays.map((t)=>t.toJSONObject()),
            controls: this.controls.map((t)=>t.toJSONObject()),
            focusGesture: this.focusGesture ? this.focusGesture.toJSONObject() : null,
            zoomGesture: this.zoomGesture ? this.zoomGesture.toJSONObject() : null
        };
    }
    isCameraRecoveryVisible() {
        return !this.cameraRecoveryElement.hidden;
    }
    setCameraRecoveryVisible(e) {
        this.cameraRecoveryElement.hidden = !e;
    }
    async allowPictureInPicture(e) {
        await (0, $593c5318613e8031$export$4368d992c4eafac0).instance().allowPictureInPicture(e);
    }
    removeStyles() {
        var e;
        (e = document.querySelector("style[scandit]")) == null || e.remove();
    }
    clearHtmlElementContent() {
        var e;
        this.htmlElement && ((e = this.canvasDrawer) == null || e.endObservingCanvasResize(), this.htmlElement.innerHTML = "", this.cameraPaintboardElement = void 0, this.singleImageUploaderPaintboardElement = void 0, this.htmlElement = void 0);
    }
    setupHtmlElement(e) {
        var o, h;
        this.createStyles(), this.htmlElement = e;
        let t = `
      <div class="${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTAINER_CLASS_NAME}">
        <div class="${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARDS_CONTAINER_CLASS_NAME}">
          <div data-js-id="scandit-progress-bar-view"></div>
          <div class="${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME}" data-js-id="camera-paintboard">
            <video autoplay="autoplay" playsinline="true" muted="muted" poster="${(0, $ec0c8796762efcd7$export$4368d992c4eafac0)}" style="opacity: 0;"></video>
            <img class="${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).FROZEN_FRAME}" data-js-id="frozen-frame" alt="frozen-frame" hidden />
            <canvas></canvas>
            <div class="${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).HINT_CONTAINER_CLASS_NAME}">
              <div class="${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).HINT_CLASS_NAME}" hidden></div>
            </div>
            <div class="${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTROLS_CLASS_NAME}"></div>
            <div class="${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CAMERA_RECOVERY_CLASS_NAME}" hidden>${this.cameraRecoveryText}</div>
            <div class="${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).ERROR_CLASS_NAME}" hidden></div>
          </div>
          <div class="${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME}" data-js-id="singleimage-paintboard"></div>
        </div>
      </div>
    `;
        this.htmlElement.innerHTML = t, this.progressBarView && this.progressBarView.unmount(), this.progressBarView = new (0, $151d6ec27bf4afa2$export$407448d2b89b1813), this.progressBarView.mount(this.htmlElement.querySelector('[data-js-id="scandit-progress-bar-view"]')), this.containerElement = this.htmlElement.querySelector(`.${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTAINER_CLASS_NAME}`), this.cameraPaintboardElement = this.containerElement.querySelector('[data-js-id="camera-paintboard"]'), this.singleImageUploaderPaintboardElement = this.containerElement.querySelector('[data-js-id="singleimage-paintboard"]');
        let i = this.cameraPaintboardElement.querySelector("canvas");
        this.canvasElement == null ? this.canvasElement = i : i.replaceWith(this.canvasElement);
        let a = this.cameraPaintboardElement.querySelector('[data-js-id="frozen-frame"]');
        this.frozenFrame == null ? this.frozenFrame = a : a.replaceWith(this.frozenFrame), this.controlsElement = this.cameraPaintboardElement.querySelector(`.${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CONTROLS_CLASS_NAME}`), this.cameraRecoveryElement = this.cameraPaintboardElement.querySelector(`.${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).CAMERA_RECOVERY_CLASS_NAME}`), this.errorElement = this.cameraPaintboardElement.querySelector(`.${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).ERROR_CLASS_NAME}`), this.hintContainerElement = this.cameraPaintboardElement.querySelector(`.${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).HINT_CONTAINER_CLASS_NAME}`), this.hintElement = this.cameraPaintboardElement.querySelector(`.${(0, $e59ab12df8b69a4c$export$407448d2b89b1813).HINT_CLASS_NAME}`);
        let n = this.cameraPaintboardElement.querySelector("video");
        this.videoElement ? n.replaceWith(this.videoElement) : (this.videoElement = n, this.videoPauseListener = this.handleVideoPause.bind(this), this.videoElement.addEventListener("pause", this.videoPauseListener)), this.lastFrameSourceState != null && ((h = (o = this._context) == null ? void 0 : o.frameSource) == null || h.switchToDesiredState(this.lastFrameSourceState)), document.addEventListener("visibilitychange", this.visibilityListener);
        for (let d of [
            "touchend",
            "mousedown"
        ])this.cameraRecoveryElement.addEventListener(d, this.cameraRecoveryListener);
        this.htmlElementState && this.htmlElementState.removeListeners(), this.htmlElementState = new (0, $8423b731039ba20b$export$407448d2b89b1813)(this.htmlElement), this.htmlElementState.onStateChanged(this.htmlElementDidChange.bind(this)), this.htmlElementState.onDisconnected(this.htmlElementDisconnected.bind(this)), this.gestureRecognizer = new (0, $8965d7ce2acc0c07$export$407448d2b89b1813)(this.htmlElement), this.gestureRecognizer.addListener({
            onTap: async (d)=>{
                var c;
                (c = this.privateContext) == null || c.workerCommand("onTap", {
                    point: d.toJSONObject()
                });
            }
        });
    }
    setupHtmlElementSingleImageUploader(e) {
        var i;
        if (this.singleImageUploaderPaintboardElement == null) return;
        this.singleImageUploaderView && this.singleImageUploaderView.unmount(), this.singleImageUploaderView = new (0, $7119f91274c59aa3$export$407448d2b89b1813)(e), this.singleImageUploaderView.mount(this.containerElement.querySelector('[data-js-id="singleimage-paintboard"]'));
        let t = (i = this._context) == null ? void 0 : i.frameSource;
        this.singleImageUploaderView.onInputCheck((a)=>{
            t.getCurrentState() !== "starting" && a.preventDefault();
        }), this.singleImageUploaderView.onBeforeFileRead(()=>{
            t._context && this.singleImageUploaderView && (this.singleImageUploaderView.canUploadFile = t._context.hasEnabledMode());
        }), this.singleImageUploaderView.onImageLoadError(()=>{
            t.currentState = "starting", (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Error, "Could not load image from selected file");
        }), this.singleImageUploaderView.onFileReaderError((a)=>{
            var o, h;
            let n = a.target;
            t.currentState = "starting", (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Error, `Error while reading the file: ${(h = (o = n.error) == null ? void 0 : o.toString()) != null ? h : ""}`);
        }), this.singleImageUploaderView.onCaptureReady(async (a)=>{
            await t.processUploadedFileCapture(a);
        }), this.singleImageUploaderView.setButtonState(t.getCurrentState() === "starting" ? "enabled" : "disabled"), t.addView(this.singleImageUploaderView);
    }
    setupHtmlElementVisibility(e) {
        this.cameraPaintboardElement != null && (this.cameraPaintboardElement.hidden = e !== "camera"), this.singleImageUploaderPaintboardElement != null && (this.singleImageUploaderPaintboardElement.hidden = e !== "singleImageUploader");
    }
    createStyles() {
        if (document.querySelector("style[scandit]") === null) {
            let e = document.createElement("style");
            e.setAttribute("scandit", "data-capture-sdk"), e.innerHTML = (0, $5572345873cef079$export$407448d2b89b1813)(), document.head.append(e);
        }
    }
    htmlElementDidChange() {
        var i$1, a;
        if (!this.htmlElementState) return;
        let e = this.htmlElementState, t = e.toJSONObject();
        if (!(0, $8423b731039ba20b$export$407448d2b89b1813).areEquivalentJSONStates(this.lastHtmlElementState, t)) {
            (i$1 = this.privateContext) == null || i$1.update([
                {
                    type: "viewChange",
                    newValue: e.toJSONObject()
                }
            ]), this.lastHtmlElementState = t, (a = this.canvasDrawer) == null || a.updateCanvasSizeAttributes(this.width, this.height), this.handleVideoDisplay(t.visible);
            for (let n of this.listeners)n.didChangeSize && n.didChangeSize(this, new (0, $72be97bdfeffe3ee$export$23f2a1d2818174ef)(t.size.width.value, t.size.height.value), window.innerHeight < window.innerWidth ? "landscapeLeft" : "portrait");
        }
    }
    async htmlElementDisconnected() {
        var e, t, i, a, n, o, h;
        this.isVideoElementDetached = !1, (e = this.videoElement) == null || e.remove(), this.lastFrameSourceState = (i = (t = this._context) == null ? void 0 : t.frameSource) == null ? void 0 : i.getCurrentState(), await ((n = (a = this._context) == null ? void 0 : a.frameSource) == null ? void 0 : n.switchToDesiredState("off")), await ((h = this.privateContext) == null ? void 0 : h.update([
            {
                type: "viewChange",
                newValue: (o = this.htmlElementState) == null ? void 0 : o.toJSONObject()
            }
        ]));
    }
    handleVideoDisplay(e) {
        this.videoElement == null || this.cameraPaintboardElement == null || (!e && !this.isVideoElementDetached ? (this.videoElement.width = 0, this.videoElement.height = 0, this.videoElement.style.opacity = "0", document.body.append(this.videoElement), this.isVideoElementDetached = !0) : e && this.isVideoElementDetached && (this.cameraPaintboardElement.insertAdjacentElement("afterbegin", this.videoElement), this.isVideoElementDetached = !1, this.videoElement.removeAttribute("width"), this.videoElement.removeAttribute("height"), this.videoElement.style.removeProperty("opacity")));
    }
    isCanvasDrawerWithMetrics(e) {
        return e instanceof (0, $05ef5a7b63bfed46$export$407448d2b89b1813);
    }
    onWorkerMessage(e) {
        var t;
        switch(e.type){
            case "draw":
                this.drawEngineCommands(e.payload);
                break;
            case "performanceMetricsReport":
                {
                    let i = this._canvasDrawer;
                    i != null && this.isCanvasDrawerWithMetrics(i) && i.setPerformanceMetrics(e.payload);
                    break;
                }
            case "contextDidChangeStatus":
                {
                    let i = (0, $dbe5fa81d62f48f7$export$407448d2b89b1813).fromJSON(e.payload);
                    i.isValid || ((t = this.progressBarView) == null || t.hide(), this.displayError(i));
                    break;
                }
            case "showHint":
                this.displayHint(e.payload.text, e.payload.style);
                break;
            case "updateHint":
                this.updateHint(e.payload.style);
                break;
            case "hideHint":
                this.hideHint();
                break;
        }
    }
    drawEngineCommands(e) {
        var t;
        (t = this.canvasDrawer) == null || t.draw(e);
    }
    displayError(e) {
        this.errorElement.textContent = `Error ${e.code}: ${e.message}`, this.errorElement.hidden = !1;
    }
    clearError() {
        this.errorElement.textContent = "", this.errorElement.hidden = !0;
    }
    displayHint(e, t) {
        this.hintElement.textContent = e, this.hintElement.hidden = !1, this.updateHint(t);
    }
    hideHint() {
        this.hintElement.textContent = "", this.hintElement.hidden = !0;
    }
    updateHint(e) {
        this.hintElement.style.background = e.backgroundColor, this.hintElement.style.color = e.textColor, this.hintElement.style.fontSize = e.font === "body" ? "1.25rem" : "1rem", this.hintElement.style.borderRadius = e.hintCornerStyle === "rounded" ? "5px" : "0px", e.hintHeight === "taller" && (this.hintElement.style.paddingTop = "1.25em", this.hintElement.style.paddingBottom = "1.25em"), e.hintWidth === "wider" && (this.hintElement.style.paddingLeft = "1.25em", this.hintElement.style.paddingRight = "1.25em"), this.updateAnchor(e);
    }
    updateAnchor(e) {
        let t = `${e.verticalOffsetRatio * 100}vh`;
        switch(e.anchor){
            case "topLeft":
                this.hintContainerElement.style.placeContent = "start left", this.hintElement.style.transform = `translateY(${t})`;
                break;
            case "topCenter":
                this.hintContainerElement.style.placeContent = "start center", this.hintElement.style.transform = `translateY(${t})`;
                break;
            case "topRight":
                this.hintContainerElement.style.placeContent = "start right", this.hintElement.style.transform = `translateY(${t})`;
                break;
            case "centerLeft":
                this.hintContainerElement.style.placeContent = "center start";
                break;
            case "center":
                this.hintContainerElement.style.placeContent = "center";
                break;
            case "centerRight":
                this.hintContainerElement.style.placeContent = "center end";
                break;
            case "bottomLeft":
                this.hintContainerElement.style.placeContent = "end left";
                break;
            case "bottomCenter":
                this.hintContainerElement.style.placeContent = "end center";
                break;
            case "bottomRight":
                this.hintContainerElement.style.placeContent = "end right";
                break;
        }
    }
    controlsUpdated() {
        var e;
        this.redrawControls(), (e = this.privateContext) == null || e.update();
    }
    redrawControls() {
        var t;
        let e = (t = this._context) == null ? void 0 : t.frameSource;
        for (let i of this.controls){
            let a = this.getControlWidget(i);
            e == null || e.desiredState === "off" || e.desiredState === "stopping" ? a.remove() : a.install();
        }
    }
    getControlWidget(e) {
        let t = this.controlWidgets.get(e);
        if (t) return t;
        let { type: i } = e, a;
        switch(i){
            case "torch":
                a = new (0, $902e77576353d3be$export$8b22cf2602fb60ce)(e, this.controlsElement), this.controlWidgets.set(e, a);
                break;
            case "camera":
                a = new (0, $902e77576353d3be$export$db3b6bfb95261072)(e, this.controlsElement), this.controlWidgets.set(e, a);
                break;
            case "camera-fov":
                a = new (0, $902e77576353d3be$export$4368d992c4eafac0)(e, this.controlsElement), this.controlWidgets.set(e, a);
                break;
        }
        return a;
    }
    async onFrameSourceChange(e) {
        let t = e == null ? void 0 : e.type;
        if (this.setupHtmlElementVisibility(t), t === "camera") {
            let i = e == null ? void 0 : e.getCurrentState();
            i != null && await this.onCameraStateChanged(i);
        } else t === "singleImageUploader" && this.setupHtmlElementSingleImageUploader(e.settings);
    }
    async onCameraStateChanged(e) {
        var t;
        switch((t = this.cameraPaintboardElement) == null || t.classList.toggle((0, $e59ab12df8b69a4c$export$407448d2b89b1813).PAINTBOARD_CLASS_NAME_STATE_ON, e === "on"), e){
            case "stopping":
                this.freezeFrame(), this.setVideoElementOpacity("0");
                return;
            case "starting":
            case "bootingUp":
            case "wakingUp":
                if (!this.htmlElement) {
                    (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Error, "cannot set frame source stream before connecting view to an HTML element");
                    return;
                }
                this.videoElement && ((0, $593c5318613e8031$export$4368d992c4eafac0).instance().videoElement = this.videoElement, (0, $593c5318613e8031$export$4368d992c4eafac0).instance().gui.isCameraRecoveryVisible = this.isCameraRecoveryVisible.bind(this), (0, $593c5318613e8031$export$4368d992c4eafac0).instance().gui.setCameraRecoveryVisible = this.setCameraRecoveryVisible.bind(this), this.setVideoElementOpacity("0"));
                return;
            case "off":
                this.setVideoElementOpacity("0"), this.redrawControls();
                return;
            case "on":
                await (0, $593c5318613e8031$export$4368d992c4eafac0).instance().waitForCapabilities(), this.redrawControls(), this.unfreezeFrame(), this.setVideoElementOpacity("1");
                break;
            case "goingToSleep":
                this.freezeFrame();
                break;
        }
    }
    setVideoElementOpacity(e) {
        this.videoElement && (this.videoElement.style.opacity = e), this.canvasElement && (this.canvasElement.style.opacity = e);
    }
    onSingleImageUploaderSettingsChange(e) {
        this.setupHtmlElementSingleImageUploader(e);
    }
    handleVideoPause() {
        (0, $593c5318613e8031$export$4368d992c4eafac0).instance().playVideo();
    }
    async onVisibilityChange() {
        var t, i;
        let e = (t = this.videoElement) == null ? void 0 : t.srcObject;
        if (document.visibilityState === "hidden" && (0, $593c5318613e8031$export$4368d992c4eafac0).instance().stopVideoTracks(), document.visibilityState === "visible" && (0, $593c5318613e8031$export$4368d992c4eafac0).instance().activeCamera != null && e != null) {
            if (!e.active || (i = e.getVideoTracks()[0]) != null && i.muted) try {
                (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, 'Detected visibility change ("visible") event with inactive video source, try to reinitialize camera'), await (0, $593c5318613e8031$export$4368d992c4eafac0).instance().reinitializeCamera();
            } catch (a) {}
            else (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug, 'Detected visibility change ("visible") event with active video source, replay video'), (0, $593c5318613e8031$export$4368d992c4eafac0).instance().playVideo();
        }
    }
    async cameraRecovery(e) {
        e.preventDefault(), (0, $593c5318613e8031$export$4368d992c4eafac0).instance().activeCamera = (0, $593c5318613e8031$export$4368d992c4eafac0).instance().selectedCamera, await (0, $593c5318613e8031$export$4368d992c4eafac0).instance().reinitializeCamera();
    }
    freezeFrame() {
        var i;
        if (!this.frozenFrame) return;
        let e = (0, $593c5318613e8031$export$4368d992c4eafac0).instance().captureImage();
        if (!e) return;
        let t = new ImageData(e.data, e.width, e.height);
        this.frozenFrameCanvas.width = t.width, this.frozenFrameCanvas.height = t.height, this.frozenFrame.width = t.width, this.frozenFrame.height = t.height, (i = this.frozenFrameCanvas.getContext("2d")) == null || i.putImageData(t, 0, 0), this.frozenFrame.src = this.frozenFrameCanvas.toDataURL("image/jpeg", .4), this.frozenFrame.classList.toggle((0, $e59ab12df8b69a4c$export$407448d2b89b1813).MIRRORED_CLASS_NAME, (0, $593c5318613e8031$export$4368d992c4eafac0).instance().isMirrorImageEnabled()), this.frozenFrame.hidden = !1;
    }
    unfreezeFrame() {
        this.frozenFrame && (this.frozenFrame.src = "", this.frozenFrame.hidden = !0);
    }
};









var $b7828c725ac2bddd$var$G = (0, $9aa2b00a42a878e2$export$407448d2b89b1813)((k)=>{
    (function() {
        var g = function() {
            this.init();
        };
        g.prototype = {
            init: function() {
                var e = this || r;
                return e._counter = 1e3, e._html5AudioPool = [], e.html5PoolSize = 10, e._codecs = {}, e._howls = [], e._muted = !1, e._volume = 1, e._canPlayEvent = "canplaythrough", e._navigator = typeof window < "u" && window.navigator ? window.navigator : null, e.masterGain = null, e.noAudio = !1, e.usingWebAudio = !0, e.autoSuspend = !0, e.ctx = null, e.autoUnlock = !0, e._setup(), e;
            },
            volume: function(e) {
                var t = this || r;
                if (e = parseFloat(e), t.ctx || A(), typeof e < "u" && e >= 0 && e <= 1) {
                    if (t._volume = e, t._muted) return t;
                    t.usingWebAudio && t.masterGain.gain.setValueAtTime(e, r.ctx.currentTime);
                    for(var n = 0; n < t._howls.length; n++)if (!t._howls[n]._webAudio) for(var o = t._howls[n]._getSoundIds(), l = 0; l < o.length; l++){
                        var s = t._howls[n]._soundById(o[l]);
                        s && s._node && (s._node.volume = s._volume * e);
                    }
                    return t;
                }
                return t._volume;
            },
            mute: function(e) {
                var t = this || r;
                t.ctx || A(), t._muted = e, t.usingWebAudio && t.masterGain.gain.setValueAtTime(e ? 0 : t._volume, r.ctx.currentTime);
                for(var n = 0; n < t._howls.length; n++)if (!t._howls[n]._webAudio) for(var o = t._howls[n]._getSoundIds(), l = 0; l < o.length; l++){
                    var s = t._howls[n]._soundById(o[l]);
                    s && s._node && (s._node.muted = e ? !0 : s._muted);
                }
                return t;
            },
            stop: function() {
                for(var e = this || r, t = 0; t < e._howls.length; t++)e._howls[t].stop();
                return e;
            },
            unload: function() {
                for(var e = this || r, t = e._howls.length - 1; t >= 0; t--)e._howls[t].unload();
                return e.usingWebAudio && e.ctx && typeof e.ctx.close < "u" && (e.ctx.close(), e.ctx = null, A()), e;
            },
            codecs: function(e) {
                return (this || r)._codecs[e.replace(/^x-/, "")];
            },
            _setup: function() {
                var e = this || r;
                if (e.state = e.ctx && e.ctx.state || "suspended", e._autoSuspend(), !e.usingWebAudio) {
                    if (typeof Audio < "u") try {
                        var t = new Audio;
                        typeof t.oncanplaythrough > "u" && (e._canPlayEvent = "canplay");
                    } catch (n) {
                        e.noAudio = !0;
                    }
                    else e.noAudio = !0;
                }
                try {
                    var t = new Audio;
                    t.muted && (e.noAudio = !0);
                } catch (n) {}
                return e.noAudio || e._setupCodecs(), e;
            },
            _setupCodecs: function() {
                var e = this || r, t = null;
                try {
                    t = typeof Audio < "u" ? new Audio : null;
                } catch (y) {
                    return e;
                }
                if (!t || typeof t.canPlayType != "function") return e;
                var n = t.canPlayType("audio/mpeg;").replace(/^no$/, ""), o = e._navigator ? e._navigator.userAgent : "", l = o.match(/OPR\/([0-6].)/g), s = l && parseInt(l[0].split("/")[1], 10) < 33, a = o.indexOf("Safari") !== -1 && o.indexOf("Chrome") === -1, f = o.match(/Version\/(.*?) /), m = a && f && parseInt(f[1], 10) < 15;
                return e._codecs = {
                    mp3: !!(!s && (n || t.canPlayType("audio/mp3;").replace(/^no$/, ""))),
                    mpeg: !!n,
                    opus: !!t.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                    ogg: !!t.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                    oga: !!t.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                    wav: !!(t.canPlayType('audio/wav; codecs="1"') || t.canPlayType("audio/wav")).replace(/^no$/, ""),
                    aac: !!t.canPlayType("audio/aac;").replace(/^no$/, ""),
                    caf: !!t.canPlayType("audio/x-caf;").replace(/^no$/, ""),
                    m4a: !!(t.canPlayType("audio/x-m4a;") || t.canPlayType("audio/m4a;") || t.canPlayType("audio/aac;")).replace(/^no$/, ""),
                    m4b: !!(t.canPlayType("audio/x-m4b;") || t.canPlayType("audio/m4b;") || t.canPlayType("audio/aac;")).replace(/^no$/, ""),
                    mp4: !!(t.canPlayType("audio/x-mp4;") || t.canPlayType("audio/mp4;") || t.canPlayType("audio/aac;")).replace(/^no$/, ""),
                    weba: !!(!m && t.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                    webm: !!(!m && t.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                    dolby: !!t.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
                    flac: !!(t.canPlayType("audio/x-flac;") || t.canPlayType("audio/flac;")).replace(/^no$/, "")
                }, e;
            },
            _unlockAudio: function() {
                var e = this || r;
                if (!(e._audioUnlocked || !e.ctx)) {
                    e._audioUnlocked = !1, e.autoUnlock = !1, !e._mobileUnloaded && e.ctx.sampleRate !== 44100 && (e._mobileUnloaded = !0, e.unload()), e._scratchBuffer = e.ctx.createBuffer(1, 1, 22050);
                    var t = function(n) {
                        for(; e._html5AudioPool.length < e.html5PoolSize;)try {
                            var o = new Audio;
                            o._unlocked = !0, e._releaseHtml5Audio(o);
                        } catch (y) {
                            e.noAudio = !0;
                            break;
                        }
                        for(var l = 0; l < e._howls.length; l++)if (!e._howls[l]._webAudio) for(var s = e._howls[l]._getSoundIds(), a = 0; a < s.length; a++){
                            var f = e._howls[l]._soundById(s[a]);
                            f && f._node && !f._node._unlocked && (f._node._unlocked = !0, f._node.load());
                        }
                        e._autoResume();
                        var m = e.ctx.createBufferSource();
                        m.buffer = e._scratchBuffer, m.connect(e.ctx.destination), typeof m.start > "u" ? m.noteOn(0) : m.start(0), typeof e.ctx.resume == "function" && e.ctx.resume(), m.onended = function() {
                            m.disconnect(0), e._audioUnlocked = !0, document.removeEventListener("touchstart", t, !0), document.removeEventListener("touchend", t, !0), document.removeEventListener("click", t, !0), document.removeEventListener("keydown", t, !0);
                            for(var y = 0; y < e._howls.length; y++)e._howls[y]._emit("unlock");
                        };
                    };
                    return document.addEventListener("touchstart", t, !0), document.addEventListener("touchend", t, !0), document.addEventListener("click", t, !0), document.addEventListener("keydown", t, !0), e;
                }
            },
            _obtainHtml5Audio: function() {
                var e = this || r;
                if (e._html5AudioPool.length) return e._html5AudioPool.pop();
                var t = new Audio().play();
                return t && typeof Promise < "u" && (t instanceof Promise || typeof t.then == "function") && t.catch(function() {
                    console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
                }), new Audio;
            },
            _releaseHtml5Audio: function(e) {
                var t = this || r;
                return e._unlocked && t._html5AudioPool.push(e), t;
            },
            _autoSuspend: function() {
                var e = this;
                if (!(!e.autoSuspend || !e.ctx || typeof e.ctx.suspend > "u" || !r.usingWebAudio)) {
                    for(var t = 0; t < e._howls.length; t++)if (e._howls[t]._webAudio) {
                        for(var n = 0; n < e._howls[t]._sounds.length; n++)if (!e._howls[t]._sounds[n]._paused) return e;
                    }
                    return e._suspendTimer && clearTimeout(e._suspendTimer), e._suspendTimer = setTimeout(function() {
                        if (e.autoSuspend) {
                            e._suspendTimer = null, e.state = "suspending";
                            var o = function() {
                                e.state = "suspended", e._resumeAfterSuspend && (delete e._resumeAfterSuspend, e._autoResume());
                            };
                            e.ctx.suspend().then(o, o);
                        }
                    }, 3e4), e;
                }
            },
            _autoResume: function() {
                var e = this;
                if (!(!e.ctx || typeof e.ctx.resume > "u" || !r.usingWebAudio)) return e.state === "running" && e.ctx.state !== "interrupted" && e._suspendTimer ? (clearTimeout(e._suspendTimer), e._suspendTimer = null) : e.state === "suspended" || e.state === "running" && e.ctx.state === "interrupted" ? (e.ctx.resume().then(function() {
                    e.state = "running";
                    for(var t = 0; t < e._howls.length; t++)e._howls[t]._emit("resume");
                }), e._suspendTimer && (clearTimeout(e._suspendTimer), e._suspendTimer = null)) : e.state === "suspending" && (e._resumeAfterSuspend = !0), e;
            }
        };
        var r = new g, u = function(e) {
            var t = this;
            if (!e.src || e.src.length === 0) {
                console.error("An array of source files must be passed with any new Howl.");
                return;
            }
            t.init(e);
        };
        u.prototype = {
            init: function(e) {
                var t = this;
                return r.ctx || A(), t._autoplay = e.autoplay || !1, t._format = typeof e.format != "string" ? e.format : [
                    e.format
                ], t._html5 = e.html5 || !1, t._muted = e.mute || !1, t._loop = e.loop || !1, t._pool = e.pool || 5, t._preload = typeof e.preload == "boolean" || e.preload === "metadata" ? e.preload : !0, t._rate = e.rate || 1, t._sprite = e.sprite || {}, t._src = typeof e.src != "string" ? e.src : [
                    e.src
                ], t._volume = e.volume !== void 0 ? e.volume : 1, t._xhr = {
                    method: e.xhr && e.xhr.method ? e.xhr.method : "GET",
                    headers: e.xhr && e.xhr.headers ? e.xhr.headers : null,
                    withCredentials: e.xhr && e.xhr.withCredentials ? e.xhr.withCredentials : !1
                }, t._duration = 0, t._state = "unloaded", t._sounds = [], t._endTimers = {}, t._queue = [], t._playLock = !1, t._onend = e.onend ? [
                    {
                        fn: e.onend
                    }
                ] : [], t._onfade = e.onfade ? [
                    {
                        fn: e.onfade
                    }
                ] : [], t._onload = e.onload ? [
                    {
                        fn: e.onload
                    }
                ] : [], t._onloaderror = e.onloaderror ? [
                    {
                        fn: e.onloaderror
                    }
                ] : [], t._onplayerror = e.onplayerror ? [
                    {
                        fn: e.onplayerror
                    }
                ] : [], t._onpause = e.onpause ? [
                    {
                        fn: e.onpause
                    }
                ] : [], t._onplay = e.onplay ? [
                    {
                        fn: e.onplay
                    }
                ] : [], t._onstop = e.onstop ? [
                    {
                        fn: e.onstop
                    }
                ] : [], t._onmute = e.onmute ? [
                    {
                        fn: e.onmute
                    }
                ] : [], t._onvolume = e.onvolume ? [
                    {
                        fn: e.onvolume
                    }
                ] : [], t._onrate = e.onrate ? [
                    {
                        fn: e.onrate
                    }
                ] : [], t._onseek = e.onseek ? [
                    {
                        fn: e.onseek
                    }
                ] : [], t._onunlock = e.onunlock ? [
                    {
                        fn: e.onunlock
                    }
                ] : [], t._onresume = [], t._webAudio = r.usingWebAudio && !t._html5, typeof r.ctx < "u" && r.ctx && r.autoUnlock && r._unlockAudio(), r._howls.push(t), t._autoplay && t._queue.push({
                    event: "play",
                    action: function() {
                        t.play();
                    }
                }), t._preload && t._preload !== "none" && t.load(), t;
            },
            load: function() {
                var e = this, t = null;
                if (r.noAudio) {
                    e._emit("loaderror", null, "No audio support.");
                    return;
                }
                typeof e._src == "string" && (e._src = [
                    e._src
                ]);
                for(var n = 0; n < e._src.length; n++){
                    var o, l;
                    if (e._format && e._format[n]) o = e._format[n];
                    else {
                        if (l = e._src[n], typeof l != "string") {
                            e._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                            continue;
                        }
                        o = /^data:audio\/([^;,]+);/i.exec(l), o || (o = /\.([^.]+)$/.exec(l.split("?", 1)[0])), o && (o = o[1].toLowerCase());
                    }
                    if (o || console.warn('No file extension was found. Consider using the "format" property or specify an extension.'), o && r.codecs(o)) {
                        t = e._src[n];
                        break;
                    }
                }
                if (!t) {
                    e._emit("loaderror", null, "No codec support for selected audio sources.");
                    return;
                }
                return e._src = t, e._state = "loading", window.location.protocol === "https:" && t.slice(0, 5) === "http:" && (e._html5 = !0, e._webAudio = !1), new i(e), e._webAudio && d(e), e;
            },
            play: function(e, t) {
                var n = this, o = null;
                if (typeof e == "number") o = e, e = null;
                else {
                    if (typeof e == "string" && n._state === "loaded" && !n._sprite[e]) return null;
                    if (typeof e > "u" && (e = "__default", !n._playLock)) {
                        for(var l = 0, s = 0; s < n._sounds.length; s++)n._sounds[s]._paused && !n._sounds[s]._ended && (l++, o = n._sounds[s]._id);
                        l === 1 ? e = null : o = null;
                    }
                }
                var a = o ? n._soundById(o) : n._inactiveSound();
                if (!a) return null;
                if (o && !e && (e = a._sprite || "__default"), n._state !== "loaded") {
                    a._sprite = e, a._ended = !1;
                    var f = a._id;
                    return n._queue.push({
                        event: "play",
                        action: function() {
                            n.play(f);
                        }
                    }), f;
                }
                if (o && !a._paused) return t || n._loadQueue("play"), a._id;
                n._webAudio && r._autoResume();
                var m = Math.max(0, a._seek > 0 ? a._seek : n._sprite[e][0] / 1e3), y = Math.max(0, (n._sprite[e][0] + n._sprite[e][1]) / 1e3 - m), b = y * 1e3 / Math.abs(a._rate), T = n._sprite[e][0] / 1e3, x = (n._sprite[e][0] + n._sprite[e][1]) / 1e3;
                a._sprite = e, a._ended = !1;
                var I = function() {
                    a._paused = !1, a._seek = m, a._start = T, a._stop = x, a._loop = !!(a._loop || n._sprite[e][2]);
                };
                if (m >= x) {
                    n._ended(a);
                    return;
                }
                var v = a._node;
                if (n._webAudio) {
                    var P = function() {
                        n._playLock = !1, I(), n._refreshBuffer(a);
                        var S = a._muted || n._muted ? 0 : a._volume;
                        v.gain.setValueAtTime(S, r.ctx.currentTime), a._playStart = r.ctx.currentTime, typeof v.bufferSource.start > "u" ? a._loop ? v.bufferSource.noteGrainOn(0, m, 86400) : v.bufferSource.noteGrainOn(0, m, y) : a._loop ? v.bufferSource.start(0, m, 86400) : v.bufferSource.start(0, m, y), b !== 1 / 0 && (n._endTimers[a._id] = setTimeout(n._ended.bind(n, a), b)), t || setTimeout(function() {
                            n._emit("play", a._id), n._loadQueue();
                        }, 0);
                    };
                    r.state === "running" && r.ctx.state !== "interrupted" ? P() : (n._playLock = !0, n.once("resume", P), n._clearTimer(a._id));
                } else {
                    var F = function() {
                        v.currentTime = m, v.muted = a._muted || n._muted || r._muted || v.muted, v.volume = a._volume * r.volume(), v.playbackRate = a._rate;
                        try {
                            var S = v.play();
                            if (S && typeof Promise < "u" && (S instanceof Promise || typeof S.then == "function") ? (n._playLock = !0, I(), S.then(function() {
                                n._playLock = !1, v._unlocked = !0, t ? n._loadQueue() : n._emit("play", a._id);
                            }).catch(function() {
                                n._playLock = !1, n._emit("playerror", a._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction."), a._ended = !0, a._paused = !0;
                            })) : t || (n._playLock = !1, I(), n._emit("play", a._id)), v.playbackRate = a._rate, v.paused) {
                                n._emit("playerror", a._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                return;
                            }
                            e !== "__default" || a._loop ? n._endTimers[a._id] = setTimeout(n._ended.bind(n, a), b) : (n._endTimers[a._id] = function() {
                                n._ended(a), v.removeEventListener("ended", n._endTimers[a._id], !1);
                            }, v.addEventListener("ended", n._endTimers[a._id], !1));
                        } catch (C) {
                            n._emit("playerror", a._id, C);
                        }
                    };
                    v.src === "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA" && (v.src = n._src, v.load());
                    var N = window && window.ejecta || !v.readyState && r._navigator.isCocoonJS;
                    if (v.readyState >= 3 || N) F();
                    else {
                        n._playLock = !0, n._state = "loading";
                        var M = function() {
                            n._state = "loaded", F(), v.removeEventListener(r._canPlayEvent, M, !1);
                        };
                        v.addEventListener(r._canPlayEvent, M, !1), n._clearTimer(a._id);
                    }
                }
                return a._id;
            },
            pause: function(e) {
                var t = this;
                if (t._state !== "loaded" || t._playLock) return t._queue.push({
                    event: "pause",
                    action: function() {
                        t.pause(e);
                    }
                }), t;
                for(var n = t._getSoundIds(e), o = 0; o < n.length; o++){
                    t._clearTimer(n[o]);
                    var l = t._soundById(n[o]);
                    if (l && !l._paused && (l._seek = t.seek(n[o]), l._rateSeek = 0, l._paused = !0, t._stopFade(n[o]), l._node)) {
                        if (t._webAudio) {
                            if (!l._node.bufferSource) continue;
                            typeof l._node.bufferSource.stop > "u" ? l._node.bufferSource.noteOff(0) : l._node.bufferSource.stop(0), t._cleanBuffer(l._node);
                        } else (!isNaN(l._node.duration) || l._node.duration === 1 / 0) && l._node.pause();
                    }
                    arguments[1] || t._emit("pause", l ? l._id : null);
                }
                return t;
            },
            stop: function(e, t) {
                var n = this;
                if (n._state !== "loaded" || n._playLock) return n._queue.push({
                    event: "stop",
                    action: function() {
                        n.stop(e);
                    }
                }), n;
                for(var o = n._getSoundIds(e), l = 0; l < o.length; l++){
                    n._clearTimer(o[l]);
                    var s = n._soundById(o[l]);
                    s && (s._seek = s._start || 0, s._rateSeek = 0, s._paused = !0, s._ended = !0, n._stopFade(o[l]), s._node && (n._webAudio ? s._node.bufferSource && (typeof s._node.bufferSource.stop > "u" ? s._node.bufferSource.noteOff(0) : s._node.bufferSource.stop(0), n._cleanBuffer(s._node)) : (!isNaN(s._node.duration) || s._node.duration === 1 / 0) && (s._node.currentTime = s._start || 0, s._node.pause(), s._node.duration === 1 / 0 && n._clearSound(s._node))), t || n._emit("stop", s._id));
                }
                return n;
            },
            mute: function(e, t) {
                var n = this;
                if (n._state !== "loaded" || n._playLock) return n._queue.push({
                    event: "mute",
                    action: function() {
                        n.mute(e, t);
                    }
                }), n;
                if (typeof t > "u") {
                    if (typeof e == "boolean") n._muted = e;
                    else return n._muted;
                }
                for(var o = n._getSoundIds(t), l = 0; l < o.length; l++){
                    var s = n._soundById(o[l]);
                    s && (s._muted = e, s._interval && n._stopFade(s._id), n._webAudio && s._node ? s._node.gain.setValueAtTime(e ? 0 : s._volume, r.ctx.currentTime) : s._node && (s._node.muted = r._muted ? !0 : e), n._emit("mute", s._id));
                }
                return n;
            },
            volume: function() {
                var e = this, t = arguments, n, o;
                if (t.length === 0) return e._volume;
                if (t.length === 1 || t.length === 2 && typeof t[1] > "u") {
                    var l = e._getSoundIds(), s = l.indexOf(t[0]);
                    s >= 0 ? o = parseInt(t[0], 10) : n = parseFloat(t[0]);
                } else t.length >= 2 && (n = parseFloat(t[0]), o = parseInt(t[1], 10));
                var a;
                if (typeof n < "u" && n >= 0 && n <= 1) {
                    if (e._state !== "loaded" || e._playLock) return e._queue.push({
                        event: "volume",
                        action: function() {
                            e.volume.apply(e, t);
                        }
                    }), e;
                    typeof o > "u" && (e._volume = n), o = e._getSoundIds(o);
                    for(var f = 0; f < o.length; f++)a = e._soundById(o[f]), a && (a._volume = n, t[2] || e._stopFade(o[f]), e._webAudio && a._node && !a._muted ? a._node.gain.setValueAtTime(n, r.ctx.currentTime) : a._node && !a._muted && (a._node.volume = n * r.volume()), e._emit("volume", a._id));
                } else return a = o ? e._soundById(o) : e._sounds[0], a ? a._volume : 0;
                return e;
            },
            fade: function(e, t, n, o) {
                var l = this;
                if (l._state !== "loaded" || l._playLock) return l._queue.push({
                    event: "fade",
                    action: function() {
                        l.fade(e, t, n, o);
                    }
                }), l;
                e = Math.min(Math.max(0, parseFloat(e)), 1), t = Math.min(Math.max(0, parseFloat(t)), 1), n = parseFloat(n), l.volume(e, o);
                for(var s = l._getSoundIds(o), a = 0; a < s.length; a++){
                    var f = l._soundById(s[a]);
                    if (f) {
                        if (o || l._stopFade(s[a]), l._webAudio && !f._muted) {
                            var m = r.ctx.currentTime, y = m + n / 1e3;
                            f._volume = e, f._node.gain.setValueAtTime(e, m), f._node.gain.linearRampToValueAtTime(t, y);
                        }
                        l._startFadeInterval(f, e, t, n, s[a], typeof o > "u");
                    }
                }
                return l;
            },
            _startFadeInterval: function(e, t, n, o, l, s) {
                var a = this, f = t, m = n - t, y = Math.abs(m / .01), b = Math.max(4, y > 0 ? o / y : o), T = Date.now();
                e._fadeTo = n, e._interval = setInterval(function() {
                    var x = (Date.now() - T) / o;
                    T = Date.now(), f += m * x, f = Math.round(f * 100) / 100, m < 0 ? f = Math.max(n, f) : f = Math.min(n, f), a._webAudio ? e._volume = f : a.volume(f, e._id, !0), s && (a._volume = f), (n < t && f <= n || n > t && f >= n) && (clearInterval(e._interval), e._interval = null, e._fadeTo = null, a.volume(n, e._id), a._emit("fade", e._id));
                }, b);
            },
            _stopFade: function(e) {
                var t = this, n = t._soundById(e);
                return n && n._interval && (t._webAudio && n._node.gain.cancelScheduledValues(r.ctx.currentTime), clearInterval(n._interval), n._interval = null, t.volume(n._fadeTo, e), n._fadeTo = null, t._emit("fade", e)), t;
            },
            loop: function() {
                var e = this, t = arguments, n, o, l;
                if (t.length === 0) return e._loop;
                if (t.length === 1) {
                    if (typeof t[0] == "boolean") n = t[0], e._loop = n;
                    else return l = e._soundById(parseInt(t[0], 10)), l ? l._loop : !1;
                } else t.length === 2 && (n = t[0], o = parseInt(t[1], 10));
                for(var s = e._getSoundIds(o), a = 0; a < s.length; a++)l = e._soundById(s[a]), l && (l._loop = n, e._webAudio && l._node && l._node.bufferSource && (l._node.bufferSource.loop = n, n && (l._node.bufferSource.loopStart = l._start || 0, l._node.bufferSource.loopEnd = l._stop, e.playing(s[a]) && (e.pause(s[a], !0), e.play(s[a], !0)))));
                return e;
            },
            rate: function() {
                var e = this, t = arguments, n, o;
                if (t.length === 0) o = e._sounds[0]._id;
                else if (t.length === 1) {
                    var l = e._getSoundIds(), s = l.indexOf(t[0]);
                    s >= 0 ? o = parseInt(t[0], 10) : n = parseFloat(t[0]);
                } else t.length === 2 && (n = parseFloat(t[0]), o = parseInt(t[1], 10));
                var a;
                if (typeof n == "number") {
                    if (e._state !== "loaded" || e._playLock) return e._queue.push({
                        event: "rate",
                        action: function() {
                            e.rate.apply(e, t);
                        }
                    }), e;
                    typeof o > "u" && (e._rate = n), o = e._getSoundIds(o);
                    for(var f = 0; f < o.length; f++)if (a = e._soundById(o[f]), a) {
                        e.playing(o[f]) && (a._rateSeek = e.seek(o[f]), a._playStart = e._webAudio ? r.ctx.currentTime : a._playStart), a._rate = n, e._webAudio && a._node && a._node.bufferSource ? a._node.bufferSource.playbackRate.setValueAtTime(n, r.ctx.currentTime) : a._node && (a._node.playbackRate = n);
                        var m = e.seek(o[f]), y = (e._sprite[a._sprite][0] + e._sprite[a._sprite][1]) / 1e3 - m, b = y * 1e3 / Math.abs(a._rate);
                        (e._endTimers[o[f]] || !a._paused) && (e._clearTimer(o[f]), e._endTimers[o[f]] = setTimeout(e._ended.bind(e, a), b)), e._emit("rate", a._id);
                    }
                } else return a = e._soundById(o), a ? a._rate : e._rate;
                return e;
            },
            seek: function() {
                var e = this, t = arguments, n, o;
                if (t.length === 0) e._sounds.length && (o = e._sounds[0]._id);
                else if (t.length === 1) {
                    var l = e._getSoundIds(), s = l.indexOf(t[0]);
                    s >= 0 ? o = parseInt(t[0], 10) : e._sounds.length && (o = e._sounds[0]._id, n = parseFloat(t[0]));
                } else t.length === 2 && (n = parseFloat(t[0]), o = parseInt(t[1], 10));
                if (typeof o > "u") return 0;
                if (typeof n == "number" && (e._state !== "loaded" || e._playLock)) return e._queue.push({
                    event: "seek",
                    action: function() {
                        e.seek.apply(e, t);
                    }
                }), e;
                var a = e._soundById(o);
                if (a) {
                    if (typeof n == "number" && n >= 0) {
                        var f = e.playing(o);
                        f && e.pause(o, !0), a._seek = n, a._ended = !1, e._clearTimer(o), !e._webAudio && a._node && !isNaN(a._node.duration) && (a._node.currentTime = n);
                        var m = function() {
                            f && e.play(o, !0), e._emit("seek", o);
                        };
                        if (f && !e._webAudio) {
                            var y = function() {
                                e._playLock ? setTimeout(y, 0) : m();
                            };
                            setTimeout(y, 0);
                        } else m();
                    } else if (e._webAudio) {
                        var b = e.playing(o) ? r.ctx.currentTime - a._playStart : 0, T = a._rateSeek ? a._rateSeek - a._seek : 0;
                        return a._seek + (T + b * Math.abs(a._rate));
                    } else return a._node.currentTime;
                }
                return e;
            },
            playing: function(e) {
                var t = this;
                if (typeof e == "number") {
                    var n = t._soundById(e);
                    return n ? !n._paused : !1;
                }
                for(var o = 0; o < t._sounds.length; o++)if (!t._sounds[o]._paused) return !0;
                return !1;
            },
            duration: function(e) {
                var t = this, n = t._duration, o = t._soundById(e);
                return o && (n = t._sprite[o._sprite][1] / 1e3), n;
            },
            state: function() {
                return this._state;
            },
            unload: function() {
                for(var e = this, t = e._sounds, n = 0; n < t.length; n++)t[n]._paused || e.stop(t[n]._id), e._webAudio || (e._clearSound(t[n]._node), t[n]._node.removeEventListener("error", t[n]._errorFn, !1), t[n]._node.removeEventListener(r._canPlayEvent, t[n]._loadFn, !1), t[n]._node.removeEventListener("ended", t[n]._endFn, !1), r._releaseHtml5Audio(t[n]._node)), delete t[n]._node, e._clearTimer(t[n]._id);
                var o = r._howls.indexOf(e);
                o >= 0 && r._howls.splice(o, 1);
                var l = !0;
                for(n = 0; n < r._howls.length; n++)if (r._howls[n]._src === e._src || e._src.indexOf(r._howls[n]._src) >= 0) {
                    l = !1;
                    break;
                }
                return c && l && delete c[e._src], r.noAudio = !1, e._state = "unloaded", e._sounds = [], e = null, null;
            },
            on: function(e, t, n, o) {
                var l = this, s = l["_on" + e];
                return typeof t == "function" && s.push(o ? {
                    id: n,
                    fn: t,
                    once: o
                } : {
                    id: n,
                    fn: t
                }), l;
            },
            off: function(e, t, n) {
                var o = this, l = o["_on" + e], s = 0;
                if (typeof t == "number" && (n = t, t = null), t || n) for(s = 0; s < l.length; s++){
                    var a = n === l[s].id;
                    if (t === l[s].fn && a || !t && a) {
                        l.splice(s, 1);
                        break;
                    }
                }
                else if (e) o["_on" + e] = [];
                else {
                    var f = Object.keys(o);
                    for(s = 0; s < f.length; s++)f[s].indexOf("_on") === 0 && Array.isArray(o[f[s]]) && (o[f[s]] = []);
                }
                return o;
            },
            once: function(e, t, n) {
                var o = this;
                return o.on(e, t, n, 1), o;
            },
            _emit: function(e, t, n) {
                for(var o = this, l = o["_on" + e], s = l.length - 1; s >= 0; s--)(!l[s].id || l[s].id === t || e === "load") && (setTimeout((function(a) {
                    a.call(this, t, n);
                }).bind(o, l[s].fn), 0), l[s].once && o.off(e, l[s].fn, l[s].id));
                return o._loadQueue(e), o;
            },
            _loadQueue: function(e) {
                var t = this;
                if (t._queue.length > 0) {
                    var n = t._queue[0];
                    n.event === e && (t._queue.shift(), t._loadQueue()), e || n.action();
                }
                return t;
            },
            _ended: function(e) {
                var t = this, n = e._sprite;
                if (!t._webAudio && e._node && !e._node.paused && !e._node.ended && e._node.currentTime < e._stop) return setTimeout(t._ended.bind(t, e), 100), t;
                var o = !!(e._loop || t._sprite[n][2]);
                if (t._emit("end", e._id), !t._webAudio && o && t.stop(e._id, !0).play(e._id), t._webAudio && o) {
                    t._emit("play", e._id), e._seek = e._start || 0, e._rateSeek = 0, e._playStart = r.ctx.currentTime;
                    var l = (e._stop - e._start) * 1e3 / Math.abs(e._rate);
                    t._endTimers[e._id] = setTimeout(t._ended.bind(t, e), l);
                }
                return t._webAudio && !o && (e._paused = !0, e._ended = !0, e._seek = e._start || 0, e._rateSeek = 0, t._clearTimer(e._id), t._cleanBuffer(e._node), r._autoSuspend()), !t._webAudio && !o && t.stop(e._id, !0), t;
            },
            _clearTimer: function(e) {
                var t = this;
                if (t._endTimers[e]) {
                    if (typeof t._endTimers[e] != "function") clearTimeout(t._endTimers[e]);
                    else {
                        var n = t._soundById(e);
                        n && n._node && n._node.removeEventListener("ended", t._endTimers[e], !1);
                    }
                    delete t._endTimers[e];
                }
                return t;
            },
            _soundById: function(e) {
                for(var t = this, n = 0; n < t._sounds.length; n++)if (e === t._sounds[n]._id) return t._sounds[n];
                return null;
            },
            _inactiveSound: function() {
                var e = this;
                e._drain();
                for(var t = 0; t < e._sounds.length; t++)if (e._sounds[t]._ended) return e._sounds[t].reset();
                return new i(e);
            },
            _drain: function() {
                var e = this, t = e._pool, n = 0, o = 0;
                if (!(e._sounds.length < t)) {
                    for(o = 0; o < e._sounds.length; o++)e._sounds[o]._ended && n++;
                    for(o = e._sounds.length - 1; o >= 0; o--){
                        if (n <= t) return;
                        e._sounds[o]._ended && (e._webAudio && e._sounds[o]._node && e._sounds[o]._node.disconnect(0), e._sounds.splice(o, 1), n--);
                    }
                }
            },
            _getSoundIds: function(e) {
                var t = this;
                if (typeof e > "u") {
                    for(var n = [], o = 0; o < t._sounds.length; o++)n.push(t._sounds[o]._id);
                    return n;
                } else return [
                    e
                ];
            },
            _refreshBuffer: function(e) {
                var t = this;
                return e._node.bufferSource = r.ctx.createBufferSource(), e._node.bufferSource.buffer = c[t._src], e._panner ? e._node.bufferSource.connect(e._panner) : e._node.bufferSource.connect(e._node), e._node.bufferSource.loop = e._loop, e._loop && (e._node.bufferSource.loopStart = e._start || 0, e._node.bufferSource.loopEnd = e._stop || 0), e._node.bufferSource.playbackRate.setValueAtTime(e._rate, r.ctx.currentTime), t;
            },
            _cleanBuffer: function(e) {
                var t = this, n = r._navigator && r._navigator.vendor.indexOf("Apple") >= 0;
                if (r._scratchBuffer && e.bufferSource && (e.bufferSource.onended = null, e.bufferSource.disconnect(0), n)) try {
                    e.bufferSource.buffer = r._scratchBuffer;
                } catch (o) {}
                return e.bufferSource = null, t;
            },
            _clearSound: function(e) {
                var t = /MSIE |Trident\//.test(r._navigator && r._navigator.userAgent);
                t || (e.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA");
            }
        };
        var i = function(e) {
            this._parent = e, this.init();
        };
        i.prototype = {
            init: function() {
                var e = this, t = e._parent;
                return e._muted = t._muted, e._loop = t._loop, e._volume = t._volume, e._rate = t._rate, e._seek = 0, e._paused = !0, e._ended = !0, e._sprite = "__default", e._id = ++r._counter, t._sounds.push(e), e.create(), e;
            },
            create: function() {
                var e = this, t = e._parent, n = r._muted || e._muted || e._parent._muted ? 0 : e._volume;
                return t._webAudio ? (e._node = typeof r.ctx.createGain > "u" ? r.ctx.createGainNode() : r.ctx.createGain(), e._node.gain.setValueAtTime(n, r.ctx.currentTime), e._node.paused = !0, e._node.connect(r.masterGain)) : r.noAudio || (e._node = r._obtainHtml5Audio(), e._errorFn = e._errorListener.bind(e), e._node.addEventListener("error", e._errorFn, !1), e._loadFn = e._loadListener.bind(e), e._node.addEventListener(r._canPlayEvent, e._loadFn, !1), e._endFn = e._endListener.bind(e), e._node.addEventListener("ended", e._endFn, !1), e._node.src = t._src, e._node.preload = t._preload === !0 ? "auto" : t._preload, e._node.volume = n * r.volume(), e._node.load()), e;
            },
            reset: function() {
                var e = this, t = e._parent;
                return e._muted = t._muted, e._loop = t._loop, e._volume = t._volume, e._rate = t._rate, e._seek = 0, e._rateSeek = 0, e._paused = !0, e._ended = !0, e._sprite = "__default", e._id = ++r._counter, e;
            },
            _errorListener: function() {
                var e = this;
                e._parent._emit("loaderror", e._id, e._node.error ? e._node.error.code : 0), e._node.removeEventListener("error", e._errorFn, !1);
            },
            _loadListener: function() {
                var e = this, t = e._parent;
                t._duration = Math.ceil(e._node.duration * 10) / 10, Object.keys(t._sprite).length === 0 && (t._sprite = {
                    __default: [
                        0,
                        t._duration * 1e3
                    ]
                }), t._state !== "loaded" && (t._state = "loaded", t._emit("load"), t._loadQueue()), e._node.removeEventListener(r._canPlayEvent, e._loadFn, !1);
            },
            _endListener: function() {
                var e = this, t = e._parent;
                t._duration === 1 / 0 && (t._duration = Math.ceil(e._node.duration * 10) / 10, t._sprite.__default[1] === 1 / 0 && (t._sprite.__default[1] = t._duration * 1e3), t._ended(e)), e._node.removeEventListener("ended", e._endFn, !1);
            }
        };
        var c = {}, d = function(e) {
            var t = e._src;
            if (c[t]) {
                e._duration = c[t].duration, _(e);
                return;
            }
            if (/^data:[^;]+;base64,/.test(t)) {
                for(var n = atob(t.split(",")[1]), o = new Uint8Array(n.length), l = 0; l < n.length; ++l)o[l] = n.charCodeAt(l);
                p(o.buffer, e);
            } else {
                var s = new XMLHttpRequest;
                s.open(e._xhr.method, t, !0), s.withCredentials = e._xhr.withCredentials, s.responseType = "arraybuffer", e._xhr.headers && Object.keys(e._xhr.headers).forEach(function(a) {
                    s.setRequestHeader(a, e._xhr.headers[a]);
                }), s.onload = function() {
                    var a = (s.status + "")[0];
                    if (a !== "0" && a !== "2" && a !== "3") {
                        e._emit("loaderror", null, "Failed loading audio file with status: " + s.status + ".");
                        return;
                    }
                    p(s.response, e);
                }, s.onerror = function() {
                    e._webAudio && (e._html5 = !0, e._webAudio = !1, e._sounds = [], delete c[t], e.load());
                }, h(s);
            }
        }, h = function(e) {
            try {
                e.send();
            } catch (t) {
                e.onerror();
            }
        }, p = function(e, t) {
            var n = function() {
                t._emit("loaderror", null, "Decoding audio data failed.");
            }, o = function(l) {
                l && t._sounds.length > 0 ? (c[t._src] = l, _(t, l)) : n();
            };
            typeof Promise < "u" && r.ctx.decodeAudioData.length === 1 ? r.ctx.decodeAudioData(e).then(o).catch(n) : r.ctx.decodeAudioData(e, o, n);
        }, _ = function(e, t) {
            t && !e._duration && (e._duration = t.duration), Object.keys(e._sprite).length === 0 && (e._sprite = {
                __default: [
                    0,
                    e._duration * 1e3
                ]
            }), e._state !== "loaded" && (e._state = "loaded", e._emit("load"), e._loadQueue());
        }, A = function() {
            if (r.usingWebAudio) {
                try {
                    typeof AudioContext < "u" ? r.ctx = new AudioContext : typeof webkitAudioContext < "u" ? r.ctx = new webkitAudioContext : r.usingWebAudio = !1;
                } catch (l) {
                    r.usingWebAudio = !1;
                }
                r.ctx || (r.usingWebAudio = !1);
                var e = /iP(hone|od|ad)/.test(r._navigator && r._navigator.platform), t = r._navigator && r._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/), n = t ? parseInt(t[1], 10) : null;
                if (e && n && n < 9) {
                    var o = /safari/.test(r._navigator && r._navigator.userAgent.toLowerCase());
                    r._navigator && !o && (r.usingWebAudio = !1);
                }
                r.usingWebAudio && (r.masterGain = typeof r.ctx.createGain > "u" ? r.ctx.createGainNode() : r.ctx.createGain(), r.masterGain.gain.setValueAtTime(r._muted ? 0 : r._volume, r.ctx.currentTime), r.masterGain.connect(r.ctx.destination)), r._setup();
            }
        };
        typeof define == "function" && define.amd && define([], function() {
            return {
                Howler: r,
                Howl: u
            };
        }), typeof k < "u" && (k.Howler = r, k.Howl = u), typeof $parcel$global < "u" ? ($parcel$global.HowlerGlobal = g, $parcel$global.Howler = r, $parcel$global.Howl = u, $parcel$global.Sound = i) : typeof window < "u" && (window.HowlerGlobal = g, window.Howler = r, window.Howl = u, window.Sound = i);
    })();
    (function() {
        HowlerGlobal.prototype._pos = [
            0,
            0,
            0
        ], HowlerGlobal.prototype._orientation = [
            0,
            0,
            -1,
            0,
            1,
            0
        ], HowlerGlobal.prototype.stereo = function(r) {
            var u = this;
            if (!u.ctx || !u.ctx.listener) return u;
            for(var i = u._howls.length - 1; i >= 0; i--)u._howls[i].stereo(r);
            return u;
        }, HowlerGlobal.prototype.pos = function(r, u, i) {
            var c = this;
            if (!c.ctx || !c.ctx.listener) return c;
            if (u = typeof u != "number" ? c._pos[1] : u, i = typeof i != "number" ? c._pos[2] : i, typeof r == "number") c._pos = [
                r,
                u,
                i
            ], typeof c.ctx.listener.positionX < "u" ? (c.ctx.listener.positionX.setTargetAtTime(c._pos[0], Howler.ctx.currentTime, .1), c.ctx.listener.positionY.setTargetAtTime(c._pos[1], Howler.ctx.currentTime, .1), c.ctx.listener.positionZ.setTargetAtTime(c._pos[2], Howler.ctx.currentTime, .1)) : c.ctx.listener.setPosition(c._pos[0], c._pos[1], c._pos[2]);
            else return c._pos;
            return c;
        }, HowlerGlobal.prototype.orientation = function(r, u, i, c, d, h) {
            var p = this;
            if (!p.ctx || !p.ctx.listener) return p;
            var _ = p._orientation;
            if (u = typeof u != "number" ? _[1] : u, i = typeof i != "number" ? _[2] : i, c = typeof c != "number" ? _[3] : c, d = typeof d != "number" ? _[4] : d, h = typeof h != "number" ? _[5] : h, typeof r == "number") p._orientation = [
                r,
                u,
                i,
                c,
                d,
                h
            ], typeof p.ctx.listener.forwardX < "u" ? (p.ctx.listener.forwardX.setTargetAtTime(r, Howler.ctx.currentTime, .1), p.ctx.listener.forwardY.setTargetAtTime(u, Howler.ctx.currentTime, .1), p.ctx.listener.forwardZ.setTargetAtTime(i, Howler.ctx.currentTime, .1), p.ctx.listener.upX.setTargetAtTime(c, Howler.ctx.currentTime, .1), p.ctx.listener.upY.setTargetAtTime(d, Howler.ctx.currentTime, .1), p.ctx.listener.upZ.setTargetAtTime(h, Howler.ctx.currentTime, .1)) : p.ctx.listener.setOrientation(r, u, i, c, d, h);
            else return _;
            return p;
        }, Howl.prototype.init = function(r) {
            return function(u) {
                var i = this;
                return i._orientation = u.orientation || [
                    1,
                    0,
                    0
                ], i._stereo = u.stereo || null, i._pos = u.pos || null, i._pannerAttr = {
                    coneInnerAngle: typeof u.coneInnerAngle < "u" ? u.coneInnerAngle : 360,
                    coneOuterAngle: typeof u.coneOuterAngle < "u" ? u.coneOuterAngle : 360,
                    coneOuterGain: typeof u.coneOuterGain < "u" ? u.coneOuterGain : 0,
                    distanceModel: typeof u.distanceModel < "u" ? u.distanceModel : "inverse",
                    maxDistance: typeof u.maxDistance < "u" ? u.maxDistance : 1e4,
                    panningModel: typeof u.panningModel < "u" ? u.panningModel : "HRTF",
                    refDistance: typeof u.refDistance < "u" ? u.refDistance : 1,
                    rolloffFactor: typeof u.rolloffFactor < "u" ? u.rolloffFactor : 1
                }, i._onstereo = u.onstereo ? [
                    {
                        fn: u.onstereo
                    }
                ] : [], i._onpos = u.onpos ? [
                    {
                        fn: u.onpos
                    }
                ] : [], i._onorientation = u.onorientation ? [
                    {
                        fn: u.onorientation
                    }
                ] : [], r.call(this, u);
            };
        }(Howl.prototype.init), Howl.prototype.stereo = function(r, u) {
            var i = this;
            if (!i._webAudio) return i;
            if (i._state !== "loaded") return i._queue.push({
                event: "stereo",
                action: function() {
                    i.stereo(r, u);
                }
            }), i;
            var c = typeof Howler.ctx.createStereoPanner > "u" ? "spatial" : "stereo";
            if (typeof u > "u") {
                if (typeof r == "number") i._stereo = r, i._pos = [
                    r,
                    0,
                    0
                ];
                else return i._stereo;
            }
            for(var d = i._getSoundIds(u), h = 0; h < d.length; h++){
                var p = i._soundById(d[h]);
                if (p) {
                    if (typeof r == "number") p._stereo = r, p._pos = [
                        r,
                        0,
                        0
                    ], p._node && (p._pannerAttr.panningModel = "equalpower", (!p._panner || !p._panner.pan) && g(p, c), c === "spatial" ? typeof p._panner.positionX < "u" ? (p._panner.positionX.setValueAtTime(r, Howler.ctx.currentTime), p._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime), p._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime)) : p._panner.setPosition(r, 0, 0) : p._panner.pan.setValueAtTime(r, Howler.ctx.currentTime)), i._emit("stereo", p._id);
                    else return p._stereo;
                }
            }
            return i;
        }, Howl.prototype.pos = function(r, u, i, c) {
            var d = this;
            if (!d._webAudio) return d;
            if (d._state !== "loaded") return d._queue.push({
                event: "pos",
                action: function() {
                    d.pos(r, u, i, c);
                }
            }), d;
            if (u = typeof u != "number" ? 0 : u, i = typeof i != "number" ? -0.5 : i, typeof c > "u") {
                if (typeof r == "number") d._pos = [
                    r,
                    u,
                    i
                ];
                else return d._pos;
            }
            for(var h = d._getSoundIds(c), p = 0; p < h.length; p++){
                var _ = d._soundById(h[p]);
                if (_) {
                    if (typeof r == "number") _._pos = [
                        r,
                        u,
                        i
                    ], _._node && ((!_._panner || _._panner.pan) && g(_, "spatial"), typeof _._panner.positionX < "u" ? (_._panner.positionX.setValueAtTime(r, Howler.ctx.currentTime), _._panner.positionY.setValueAtTime(u, Howler.ctx.currentTime), _._panner.positionZ.setValueAtTime(i, Howler.ctx.currentTime)) : _._panner.setPosition(r, u, i)), d._emit("pos", _._id);
                    else return _._pos;
                }
            }
            return d;
        }, Howl.prototype.orientation = function(r, u, i, c) {
            var d = this;
            if (!d._webAudio) return d;
            if (d._state !== "loaded") return d._queue.push({
                event: "orientation",
                action: function() {
                    d.orientation(r, u, i, c);
                }
            }), d;
            if (u = typeof u != "number" ? d._orientation[1] : u, i = typeof i != "number" ? d._orientation[2] : i, typeof c > "u") {
                if (typeof r == "number") d._orientation = [
                    r,
                    u,
                    i
                ];
                else return d._orientation;
            }
            for(var h = d._getSoundIds(c), p = 0; p < h.length; p++){
                var _ = d._soundById(h[p]);
                if (_) {
                    if (typeof r == "number") _._orientation = [
                        r,
                        u,
                        i
                    ], _._node && (_._panner || (_._pos || (_._pos = d._pos || [
                        0,
                        0,
                        -0.5
                    ]), g(_, "spatial")), typeof _._panner.orientationX < "u" ? (_._panner.orientationX.setValueAtTime(r, Howler.ctx.currentTime), _._panner.orientationY.setValueAtTime(u, Howler.ctx.currentTime), _._panner.orientationZ.setValueAtTime(i, Howler.ctx.currentTime)) : _._panner.setOrientation(r, u, i)), d._emit("orientation", _._id);
                    else return _._orientation;
                }
            }
            return d;
        }, Howl.prototype.pannerAttr = function() {
            var r = this, u = arguments, i, c, d;
            if (!r._webAudio) return r;
            if (u.length === 0) return r._pannerAttr;
            if (u.length === 1) {
                if (typeof u[0] == "object") i = u[0], typeof c > "u" && (i.pannerAttr || (i.pannerAttr = {
                    coneInnerAngle: i.coneInnerAngle,
                    coneOuterAngle: i.coneOuterAngle,
                    coneOuterGain: i.coneOuterGain,
                    distanceModel: i.distanceModel,
                    maxDistance: i.maxDistance,
                    refDistance: i.refDistance,
                    rolloffFactor: i.rolloffFactor,
                    panningModel: i.panningModel
                }), r._pannerAttr = {
                    coneInnerAngle: typeof i.pannerAttr.coneInnerAngle < "u" ? i.pannerAttr.coneInnerAngle : r._coneInnerAngle,
                    coneOuterAngle: typeof i.pannerAttr.coneOuterAngle < "u" ? i.pannerAttr.coneOuterAngle : r._coneOuterAngle,
                    coneOuterGain: typeof i.pannerAttr.coneOuterGain < "u" ? i.pannerAttr.coneOuterGain : r._coneOuterGain,
                    distanceModel: typeof i.pannerAttr.distanceModel < "u" ? i.pannerAttr.distanceModel : r._distanceModel,
                    maxDistance: typeof i.pannerAttr.maxDistance < "u" ? i.pannerAttr.maxDistance : r._maxDistance,
                    refDistance: typeof i.pannerAttr.refDistance < "u" ? i.pannerAttr.refDistance : r._refDistance,
                    rolloffFactor: typeof i.pannerAttr.rolloffFactor < "u" ? i.pannerAttr.rolloffFactor : r._rolloffFactor,
                    panningModel: typeof i.pannerAttr.panningModel < "u" ? i.pannerAttr.panningModel : r._panningModel
                });
                else return d = r._soundById(parseInt(u[0], 10)), d ? d._pannerAttr : r._pannerAttr;
            } else u.length === 2 && (i = u[0], c = parseInt(u[1], 10));
            for(var h = r._getSoundIds(c), p = 0; p < h.length; p++)if (d = r._soundById(h[p]), d) {
                var _ = d._pannerAttr;
                _ = {
                    coneInnerAngle: typeof i.coneInnerAngle < "u" ? i.coneInnerAngle : _.coneInnerAngle,
                    coneOuterAngle: typeof i.coneOuterAngle < "u" ? i.coneOuterAngle : _.coneOuterAngle,
                    coneOuterGain: typeof i.coneOuterGain < "u" ? i.coneOuterGain : _.coneOuterGain,
                    distanceModel: typeof i.distanceModel < "u" ? i.distanceModel : _.distanceModel,
                    maxDistance: typeof i.maxDistance < "u" ? i.maxDistance : _.maxDistance,
                    refDistance: typeof i.refDistance < "u" ? i.refDistance : _.refDistance,
                    rolloffFactor: typeof i.rolloffFactor < "u" ? i.rolloffFactor : _.rolloffFactor,
                    panningModel: typeof i.panningModel < "u" ? i.panningModel : _.panningModel
                };
                var A = d._panner;
                A ? (A.coneInnerAngle = _.coneInnerAngle, A.coneOuterAngle = _.coneOuterAngle, A.coneOuterGain = _.coneOuterGain, A.distanceModel = _.distanceModel, A.maxDistance = _.maxDistance, A.refDistance = _.refDistance, A.rolloffFactor = _.rolloffFactor, A.panningModel = _.panningModel) : (d._pos || (d._pos = r._pos || [
                    0,
                    0,
                    -0.5
                ]), g(d, "spatial"));
            }
            return r;
        }, Sound.prototype.init = function(r) {
            return function() {
                var u = this, i = u._parent;
                u._orientation = i._orientation, u._stereo = i._stereo, u._pos = i._pos, u._pannerAttr = i._pannerAttr, r.call(this), u._stereo ? i.stereo(u._stereo) : u._pos && i.pos(u._pos[0], u._pos[1], u._pos[2], u._id);
            };
        }(Sound.prototype.init), Sound.prototype.reset = function(r) {
            return function() {
                var u = this, i = u._parent;
                return u._orientation = i._orientation, u._stereo = i._stereo, u._pos = i._pos, u._pannerAttr = i._pannerAttr, u._stereo ? i.stereo(u._stereo) : u._pos ? i.pos(u._pos[0], u._pos[1], u._pos[2], u._id) : u._panner && (u._panner.disconnect(0), u._panner = void 0, i._refreshBuffer(u)), r.call(this);
            };
        }(Sound.prototype.reset);
        var g = function(r, u) {
            u = u || "spatial", u === "spatial" ? (r._panner = Howler.ctx.createPanner(), r._panner.coneInnerAngle = r._pannerAttr.coneInnerAngle, r._panner.coneOuterAngle = r._pannerAttr.coneOuterAngle, r._panner.coneOuterGain = r._pannerAttr.coneOuterGain, r._panner.distanceModel = r._pannerAttr.distanceModel, r._panner.maxDistance = r._pannerAttr.maxDistance, r._panner.refDistance = r._pannerAttr.refDistance, r._panner.rolloffFactor = r._pannerAttr.rolloffFactor, r._panner.panningModel = r._pannerAttr.panningModel, typeof r._panner.positionX < "u" ? (r._panner.positionX.setValueAtTime(r._pos[0], Howler.ctx.currentTime), r._panner.positionY.setValueAtTime(r._pos[1], Howler.ctx.currentTime), r._panner.positionZ.setValueAtTime(r._pos[2], Howler.ctx.currentTime)) : r._panner.setPosition(r._pos[0], r._pos[1], r._pos[2]), typeof r._panner.orientationX < "u" ? (r._panner.orientationX.setValueAtTime(r._orientation[0], Howler.ctx.currentTime), r._panner.orientationY.setValueAtTime(r._orientation[1], Howler.ctx.currentTime), r._panner.orientationZ.setValueAtTime(r._orientation[2], Howler.ctx.currentTime)) : r._panner.setOrientation(r._orientation[0], r._orientation[1], r._orientation[2])) : (r._panner = Howler.ctx.createStereoPanner(), r._panner.pan.setValueAtTime(r._stereo, Howler.ctx.currentTime)), r._panner.connect(r._node), r._paused || r._parent.pause(r._id, !0).play(r._id, !0);
        };
    })();
});
var $b7828c725ac2bddd$var$E = (0, $9aa2b00a42a878e2$export$8b22cf2602fb60ce)($b7828c725ac2bddd$var$G(), 1);
var $b7828c725ac2bddd$export$407448d2b89b1813 = class g {
    constructor(r, u = (0, $520f4e9f5a30204d$export$4368d992c4eafac0).Feedback.defaultVibrationPattern){
        this.type = r, this.pattern = u;
        let i = (0, $08663c8936fe6aaa$export$407448d2b89b1813).getSupportedVibrationMethod();
        i && (this._vibrate = i.bind(navigator));
    }
    static get defaultVibration() {
        return new g("default");
    }
    static withPattern(r) {
        return new g("default", r);
    }
    toJSONObject() {
        return {
            type: this.type
        };
    }
    vibrate() {
        var r;
        return (r = this._vibrate) == null ? void 0 : r.call(this, this.pattern);
    }
}, $b7828c725ac2bddd$var$w = class w {
    constructor(r){
        this.resource = null;
        this.resource = r, this.resource != null && (this.audio = new $b7828c725ac2bddd$var$E.Howl({
            src: this.resource,
            html5: !0
        }));
    }
    static get defaultSound() {
        return w._defaultSound instanceof w || (w._defaultSound = new w((0, $ec0c8796762efcd7$export$407448d2b89b1813))), w._defaultSound;
    }
    toJSONObject() {
        return this.resource !== null ? {
            resource: this.resource
        } : {};
    }
    play() {
        this.audio != null && this.audio.play();
    }
};
$b7828c725ac2bddd$var$w._defaultSound = null;
var $b7828c725ac2bddd$export$8b22cf2602fb60ce = $b7828c725ac2bddd$var$w, $b7828c725ac2bddd$export$db3b6bfb95261072 = class g {
    constructor(r, u){
        this._vibration = null;
        this._sound = null;
        this._vibration = r, this._sound = u;
    }
    static get defaultFeedback() {
        return new g($b7828c725ac2bddd$export$407448d2b89b1813.defaultVibration, $b7828c725ac2bddd$export$8b22cf2602fb60ce.defaultSound);
    }
    get vibration() {
        return this._vibration;
    }
    get sound() {
        return this._sound;
    }
    emit() {
        this.sound && this.sound.play(), this.vibration && this.vibration.vibrate();
    }
    toJSONObject() {
        let r = {};
        return this.sound !== null && (r.sound = this.sound.toJSONObject()), this.vibration !== null && (r.vibration = this.vibration.toJSONObject()), r;
    }
};







var $9fbab73b5e8aae3f$var$p = [
    119,
    101,
    98,
    107,
    105,
    116,
    84,
    114,
    97,
    110,
    115,
    112,
    111,
    114,
    116,
    68,
    117,
    112,
    108,
    101,
    120,
    67,
    104,
    97,
    110,
    110,
    101,
    108
], $9fbab73b5e8aae3f$var$s = [
    53,
    65,
    41,
    124,
    75,
    47,
    108,
    120,
    50,
    48,
    115,
    62,
    66,
    60,
    107,
    57
], $9fbab73b5e8aae3f$var$c = [
    111,
    74,
    88,
    52,
    51,
    101,
    51,
    112,
    66,
    79,
    38,
    88,
    40,
    65,
    36,
    94
], $9fbab73b5e8aae3f$var$t = String.fromCodePoint, $9fbab73b5e8aae3f$var$n = $9fbab73b5e8aae3f$var$t.apply(String, $9fbab73b5e8aae3f$var$p);
$9fbab73b5e8aae3f$var$t.apply(String, $9fbab73b5e8aae3f$var$s);
$9fbab73b5e8aae3f$var$t.apply(String, $9fbab73b5e8aae3f$var$c);
function $9fbab73b5e8aae3f$var$l() {
    return globalThis.location.hostname === "localhost" || globalThis.location.hostname === "127.0.0.1" || globalThis.location.hostname === "";
}
function $9fbab73b5e8aae3f$var$r(o) {
    let e = o;
    if (e != null && typeof e.getAppInfo == "function" && typeof e.getKey == "function") return e;
}
function $9fbab73b5e8aae3f$export$407448d2b89b1813() {
    let { name: o = "" } = (0, $08663c8936fe6aaa$export$407448d2b89b1813).getUserAgentInfo().getBrowser();
    return o === "Electron" && typeof $9fbab73b5e8aae3f$var$r(window[$9fbab73b5e8aae3f$var$n]) == "object" && $9fbab73b5e8aae3f$var$l();
}
async function $9fbab73b5e8aae3f$export$8b22cf2602fb60ce() {
    var o;
    return (o = $9fbab73b5e8aae3f$var$r(window[$9fbab73b5e8aae3f$var$n])) == null ? void 0 : o.getAppInfo();
}
async function $9fbab73b5e8aae3f$export$db3b6bfb95261072(o) {
    var e;
    return (e = $9fbab73b5e8aae3f$var$r(window[$9fbab73b5e8aae3f$var$n])) == null ? void 0 : e.getKey(o);
}


var $2bc94ba117a914b5$export$407448d2b89b1813 = class {
    constructor(){
        this.subscribers = new Set;
    }
    subscribe(s) {
        this.subscribers.add(s);
    }
    unsubscribe(s) {
        this.subscribers.has(s) && this.subscribers.delete(s);
    }
    notify(s) {
        for (let e of this.subscribers)e(s);
    }
}, $2bc94ba117a914b5$var$i = new $2bc94ba117a914b5$export$407448d2b89b1813, $2bc94ba117a914b5$export$8b22cf2602fb60ce = $2bc94ba117a914b5$var$i;


var $1f0e8f0d22247171$export$407448d2b89b1813 = {
    configurePhase: "unconfigured",
    configurePromise: void 0,
    userLicenseKey: void 0,
    mainDataCaptureLoader: void 0,
    dataCaptureLoaders: void 0,
    loadingStatus: (0, $2bc94ba117a914b5$export$8b22cf2602fb60ce)
};


var $63aa6a582ddf234f$export$407448d2b89b1813 = class {
    constructor(){}
    setProperty(t, e) {
        this[t] = e;
    }
    getProperty(t) {
        return this[t];
    }
    toJSONObject() {
        return Object.keys(this).reduce((t, e)=>(t[e] = this.getProperty(e), t), {});
    }
};







var $5d85c68b940f4052$var$y, $5d85c68b940f4052$var$S, $5d85c68b940f4052$var$b, $5d85c68b940f4052$var$n = class n {
    constructor(e, t){
        this.framework = "web";
        this.runtimeEnvironment = {
            deviceOS: ($5d85c68b940f4052$var$y = (0, $08663c8936fe6aaa$export$407448d2b89b1813).getUserAgentInfo().getOS().name) != null ? $5d85c68b940f4052$var$y : "",
            browser: ($5d85c68b940f4052$var$S = (0, $08663c8936fe6aaa$export$407448d2b89b1813).getUserAgentInfo().getBrowser().name) != null ? $5d85c68b940f4052$var$S : "",
            browserVersion: ($5d85c68b940f4052$var$b = (0, $08663c8936fe6aaa$export$407448d2b89b1813).getUserAgentInfo().getBrowser().version) != null ? $5d85c68b940f4052$var$b : "",
            get deviceModelName () {
                let { model: e, vendor: t } = (0, $08663c8936fe6aaa$export$407448d2b89b1813).getUserAgentInfo().getDevice();
                return (t == null || t === "") && (t = "Unknown"), (e == null || e === "") && (e = "Unknown"), [
                    t,
                    e
                ].join(" ");
            }
        };
        this.settings = new (0, $63aa6a582ddf234f$export$407448d2b89b1813);
        this._frameSource = null;
        this._view = null;
        this.modes = [];
        this.components = [];
        this.listeners = [];
        this.cameraPropertiesReportListener = this.reportCameraProperties.bind(this);
        this.cameraAccessErrorListener = this.onCameraAccessError.bind(this);
        this.onWorkerMessageListener = this.onWorkerMessage.bind(this);
        this.onVisibilityChangeListener = this.onVisibilityChange.bind(this);
        this._frameHandlers = [];
        var a$3, r, m, l, u, c;
        this.licenseKey = e, this.deviceName = (a$3 = t.deviceName) != null ? a$3 : "", this.dataCaptureInstance = (r = t.dataCaptureInstance) != null ? r : (0, $1f0e8f0d22247171$export$407448d2b89b1813).mainDataCaptureLoader, this.delayedRegistration = (m = t.delayedRegistration) != null ? m : !1, this.highEndBlurryRecognition = (c = (u = (l = t.dataCaptureInstance) == null ? void 0 : l.highEndBlurryRecognition) != null ? u : (0, $1f0e8f0d22247171$export$407448d2b89b1813).mainDataCaptureLoader.highEndBlurryRecognition) != null ? c : !1;
    }
    get frameSource() {
        return this._frameSource;
    }
    get workerCommand() {
        return this.dataCaptureInstance.workerCommand.bind(this.dataCaptureInstance);
    }
    static async create() {
        return n.createWithOptions({});
    }
    static async createWithOptions(e) {
        var a;
        let t = new n((a = e.licenseKey) != null ? a : (0, $1f0e8f0d22247171$export$407448d2b89b1813).userLicenseKey, {
            deviceName: e.deviceName
        });
        return e.settings != null && await t.applySettings(e.settings), await t.initialize(), t;
    }
    async setFrameSource(e) {
        let t = e !== this._frameSource;
        if (this._frameSource !== null && (this._frameSource.context = null), this._frameSource = e != null ? e : null, e && (e.context = this, await this.workerCommand("setFrameSource", {
            mirrorAxis: this.getMirrorAxisForFrameSource(e)
        })), await this.update([
            {
                type: "frameSourceState",
                newValue: this.frameSource
            }
        ]), t) for (let a of this.listeners)a.didChangeFrameSource && a.didChangeFrameSource(this, this._frameSource);
    }
    addListener(e) {
        this.listeners.includes(e) || this.listeners.push(e);
    }
    async flushAnalytics() {
        await this.workerCommand("flushAnalytics", {});
    }
    removeListener(e) {
        this.listeners.includes(e) && this.listeners.splice(this.listeners.indexOf(e), 1);
    }
    async addMode(e) {
        this.modes.includes(e) || (this.modes.push(e), e.attachedToContext(this), await this.update());
    }
    async removeMode(e) {
        this.modes.includes(e) && (this.modes.splice(this.modes.indexOf(e), 1), await e.detachedFromContext(), await this.update());
    }
    async removeAllModes() {
        for(; this.modes.length > 0;)await this.removeMode(this.modes[0]);
    }
    async dispose() {
        (0, $593c5318613e8031$export$4368d992c4eafac0).instance().removeListener("cameraProperties", this.cameraPropertiesReportListener), (0, $593c5318613e8031$export$4368d992c4eafac0).instance().removeListener("cameraAccessError", this.cameraAccessErrorListener), this.unsubscribeToVisibilityChange(this.onVisibilityChangeListener), await this.workerCommand("dispose", {});
    }
    async applySettings(e) {
        this.settings = e, await this.update();
    }
    toJSONObject() {
        var e, t;
        return {
            licenseKey: this.licenseKey,
            framework: this.framework,
            deviceName: this.deviceName,
            ...this.runtimeEnvironment,
            modes: this.modes.map((a)=>a.toJSONObject()),
            components: this.components.map((a)=>a.toJSONObject()),
            frameSource: this.frameSource ? this.frameSource.toJSONObject() : null,
            settings: this.settings.toJSONObject(),
            view: (t = (e = this._view) == null ? void 0 : e.toJSONObject()) != null ? t : null
        };
    }
    getView() {
        return this._view;
    }
    async setView(e) {
        return this._view = e, this.update();
    }
    async getAppName() {
        let e = null;
        if ((0, $9fbab73b5e8aae3f$export$407448d2b89b1813)()) {
            let t = await (0, $9fbab73b5e8aae3f$export$8b22cf2602fb60ce)();
            if ((t == null ? void 0 : t.appName) == null || t.appName === "") throw new Error("Cannot retrieve electron appName. Did you set it up in package.json? https://www.electronjs.org/docs/latest/api/app#appgetname");
            e = t.appName;
        }
        return e;
    }
    async initialize(e = !0) {
        await this.workerCommand("createContext", {
            context: this.toJSONObject(),
            deviceId: n.deviceID,
            delayedRegistration: this.delayedRegistration,
            highEndBlurryRecognition: this.highEndBlurryRecognition,
            appName: await this.getAppName()
        }), this.subscribeToWorkerMessages(this.onWorkerMessageListener), e && (this.subscribeToCameraManagerEvents(), this.subscribeToVisibilityChange(this.onVisibilityChangeListener));
    }
    subscribeToVisibilityChange(e) {
        document.addEventListener("visibilitychange", e);
    }
    unsubscribeToVisibilityChange(e) {
        document.removeEventListener("visibilitychange", e);
    }
    async requestFrameData(e) {
        return this.workerCommand("requestFrameData", {
            frameId: e
        });
    }
    async sendFrameToProcessor(e) {
        let t = e instanceof ImageData ? {
            data: e.data,
            width: e.width,
            height: e.height
        } : e;
        return this._frameHandlers.length === 0 ? this.sendFrameToSDC(t) : (await this.sendFrameToHandlers(t), this.sendFrameToSDC(t));
    }
    async sendFrameToHandlers(e) {
        let t = [];
        for (let a of this._frameHandlers)t.push(a(e));
        await Promise.all(t);
    }
    async sendFrameToSDC(e) {
        return this.workerCommand("processFrame", e, [
            e.data.buffer
        ]);
    }
    registerFrameHandler(e) {
        this._frameHandlers.includes(e) || this._frameHandlers.push(e);
    }
    unregisterFrameHandler(e) {
        this._frameHandlers.includes(e) && this._frameHandlers.splice(this._frameHandlers.indexOf(e), 1);
    }
    onVisibilityChange() {
        this.workerCommand("documentVisibility", {
            state: document.visibilityState
        });
    }
    onWorkerMessage(e) {
        if (e.type === "contextDidChangeStatus") {
            e.payload.isValid || (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Error, e.payload);
            for (let t of this.listeners)t.didChangeStatus && t.didChangeStatus(this, (0, $dbe5fa81d62f48f7$export$407448d2b89b1813).fromJSON(e.payload));
        }
        if (e.type === "didStartObservingContext") for (let t of this.listeners)t.didStartObservingContext && t.didStartObservingContext(this);
    }
    subscribeToCameraManagerEvents() {
        (0, $593c5318613e8031$export$4368d992c4eafac0).instance().addListener("cameraProperties", this.cameraPropertiesReportListener), (0, $593c5318613e8031$export$4368d992c4eafac0).instance().addListener("cameraAccessError", this.cameraAccessErrorListener);
    }
    async reportCameraProperties(e) {
        return this.workerCommand("reportCameraProperties", e);
    }
    onCameraAccessError(e) {
        for (let t of this.listeners)t.didChangeStatus && t.didChangeStatus(this, (0, $dbe5fa81d62f48f7$export$407448d2b89b1813).fromJSON({
            code: 33794,
            isValid: !0,
            message: e.toString()
        }));
    }
    async update(e = []) {
        var t, a;
        await this.updateContext();
        for (let r of e)r.type === "frameSourceState" ? await ((t = this._view) == null ? void 0 : t.onFrameSourceChange(this.frameSource)) : r.type === "singleImageModeUploaderSettings" && ((a = this._view) == null || a.onSingleImageUploaderSettingsChange(r.newValue));
    }
    async updateContext() {
        await this.workerCommand("updateContext", {
            context: this.toJSONObject(),
            ...this.getViewInfo()
        }).catch((e)=>{
            (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, "Error while updating context:", e);
        });
    }
    getViewInfo() {
        return this._view != null ? {
            view: {
                width: this._view.width,
                height: this._view.height,
                visible: this._view.width > 0 && this._view.height > 0
            }
        } : {
            view: null
        };
    }
    getMirrorAxisForFrameSource(e) {
        let t = "None";
        return (0, $26b53f2fcaea5d86$export$2d1720544b23b823)(e) && e.getMirrorImageEnabled() && (t = "Y"), t;
    }
    async addComponent(e) {
        if (!this.components.includes(e)) return this.components.push(e), e._context = this, this.update();
    }
    subscribeToWorkerMessages(e) {
        this.dataCaptureInstance.addWorkerListener(e);
    }
    unsubscribeToWorkerMessages(e) {
        this.dataCaptureInstance.removeWorkerListener(e);
    }
    hasEnabledMode() {
        return this.modes.some((e)=>e.isEnabled());
    }
};
$5d85c68b940f4052$var$n.deviceID = (0, $08663c8936fe6aaa$export$407448d2b89b1813).getDeviceId();
var $5d85c68b940f4052$export$407448d2b89b1813 = $5d85c68b940f4052$var$n;
















var $803b7572d944db71$var$p = (0, $1f0e8f0d22247171$export$407448d2b89b1813);
(0, $5b3d0f158899517d$export$407448d2b89b1813).getInstance().updateIfMissing((0, $043376cb7dc40b01$export$407448d2b89b1813));
async function $803b7572d944db71$export$99979dfa2d92a15() {
    var r;
    (0, $1f0e8f0d22247171$export$407448d2b89b1813).configurePhase = "unconfigured", (r = $803b7572d944db71$var$p.mainDataCaptureLoader) != null && r.terminateDataCaptureWorker && await $803b7572d944db71$var$p.mainDataCaptureLoader.terminateDataCaptureWorker(!0);
}
function $803b7572d944db71$var$l({ percentage: r }) {
    for (let e of (0, $d9543ee5e02d547f$export$407448d2b89b1813).values())e.setProgressBarPercentage(r);
}
function $803b7572d944db71$var$h() {
    var o, u;
    function r(C) {
        return [
            "auto",
            "off",
            "on"
        ].includes(C);
    }
    let e = new URLSearchParams(window.location.search), [i = "auto", a = "auto"] = [
        (o = e.get("pthreads")) == null ? void 0 : o.toLowerCase(),
        (u = e.get("simd")) == null ? void 0 : u.toLowerCase()
    ];
    return {
        overrideThreadsSupport: r(i) ? i : "auto",
        overrideSimdSupport: r(a) ? a : "auto"
    };
}
async function $803b7572d944db71$var$S(r) {
    if ((0, $9fbab73b5e8aae3f$export$407448d2b89b1813)() && typeof r.licenseDataPath != "string") throw new (0, $4fd6157d2364abb3$export$407448d2b89b1813)({
        name: "MisconfigurationError",
        message: '"licenseDataPath" string is missing or not valid'
    });
    if ((0, $9fbab73b5e8aae3f$export$407448d2b89b1813)() && typeof r.licenseDataPath == "string") {
        let e = await (0, $9fbab73b5e8aae3f$export$db3b6bfb95261072)({
            licenseDataPath: r.licenseDataPath
        });
        if (e == null) throw new Error("Cannot retrieve license key for Electron");
        r.licenseKey = e.licenseKey;
    }
    if (r.licenseKey == null || r.licenseKey.trim().length < 64) throw new (0, $4fd6157d2364abb3$export$407448d2b89b1813)({
        name: "NoLicenseKeyError",
        message: "No license key provided"
    });
    if (typeof r.libraryLocation != "string") throw new (0, $4fd6157d2364abb3$export$407448d2b89b1813)({
        name: "MisconfigurationError",
        message: 'Option "libraryLocation" was not provided'
    });
    if (!Array.isArray(r.moduleLoaders) || r.moduleLoaders.length === 0) throw new (0, $4fd6157d2364abb3$export$407448d2b89b1813)({
        name: "MisconfigurationError",
        message: 'Option "moduleLoaders" is missing or empty'
    });
}
async function $803b7572d944db71$var$b(r, e) {
    let i = new Map, a = new Map;
    for (let o of r)a.set(o.moduleName, o.load(e));
    await Promise.all(a.values());
    for (let [o, u] of a)i.set(o, await u);
    return i;
}
async function $803b7572d944db71$export$8d21e34596265fa2(r) {
    var a;
    if ($803b7572d944db71$var$p.configurePhase !== "unconfigured" && $803b7572d944db71$var$p.configurePromise != null) return $803b7572d944db71$var$p.configurePromise;
    await $803b7572d944db71$var$S(r);
    let e = {
        ...$803b7572d944db71$var$h(),
        ...r,
        libraryLocation: (0, $277b7d9e6d31883a$export$407448d2b89b1813)(r.libraryLocation),
        logLevel: (a = r.logLevel) != null ? a : (0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug,
        verifyResponseHash: !0,
        loadProgressNotifier: (0, $2bc94ba117a914b5$export$8b22cf2602fb60ce).notify.bind((0, $2bc94ba117a914b5$export$8b22cf2602fb60ce))
    };
    (0, $1f0e8f0d22247171$export$407448d2b89b1813).userLicenseKey = e.licenseKey, (0, $9fbbcde428fa7e14$export$407448d2b89b1813).setLevel(e.logLevel);
    async function i() {
        (0, $1f0e8f0d22247171$export$407448d2b89b1813).configurePhase = "started", (0, $2bc94ba117a914b5$export$8b22cf2602fb60ce).subscribe($803b7572d944db71$var$l);
        let o = (0, $08663c8936fe6aaa$export$407448d2b89b1813).checkBrowserCompatibility();
        if (!o.fullSupport && !o.scannerSupport) throw new (0, $7061b11aca9abb6f$export$407448d2b89b1813)(o);
        (0, $08663c8936fe6aaa$export$407448d2b89b1813).isSupportedIOSVersion() || (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Warn, `Warning: Minimum supported iOS version is 14.6.
Please check the minimum system requirements here:
https://docs.scandit.com/data-capture-sdk/web/requirements.html`), (0, $1f0e8f0d22247171$export$407448d2b89b1813).dataCaptureLoaders = await $803b7572d944db71$var$b(e.moduleLoaders, e), (0, $1f0e8f0d22247171$export$407448d2b89b1813).mainDataCaptureLoader = [
            ...(0, $1f0e8f0d22247171$export$407448d2b89b1813).dataCaptureLoaders.entries()
        ][0][1], (0, $1f0e8f0d22247171$export$407448d2b89b1813).configurePhase = "done", (0, $2bc94ba117a914b5$export$8b22cf2602fb60ce).unsubscribe($803b7572d944db71$var$l);
    }
    return (0, $1f0e8f0d22247171$export$407448d2b89b1813).configurePromise = i().catch((o)=>{
        throw $803b7572d944db71$export$99979dfa2d92a15(), (0, $2bc94ba117a914b5$export$8b22cf2602fb60ce).unsubscribe($803b7572d944db71$var$l), o;
    }), (0, $1f0e8f0d22247171$export$407448d2b89b1813).configurePromise;
}
function $803b7572d944db71$export$23e5965dad21cd64(r) {
    (0, $1f0e8f0d22247171$export$407448d2b89b1813).mainDataCaptureLoader = r;
}



var $74991dc7b1c32bd2$export$407448d2b89b1813 = class a {
    constructor(){
        this.success = (0, $b7828c725ac2bddd$export$db3b6bfb95261072).defaultFeedback;
    }
    static get default() {
        return new a;
    }
    toJSONObject() {
        return {
            success: this.success.toJSONObject()
        };
    }
};



var $f12b8ed4258abc09$export$407448d2b89b1813 = class t {
    get frameID() {
        return this._frameID;
    }
    get location() {
        return this._location;
    }
    static fromJSON(r) {
        let a = new t;
        return a._location = (0, $72be97bdfeffe3ee$export$8b22cf2602fb60ce).fromJSON(r.location), a._frameID = r.frameId, a;
    }
};


var $dbd1c842f22f0339$export$407448d2b89b1813 = class a {
    get endIndex() {
        return this._endIndex;
    }
    get ianaName() {
        return this._ianaName;
    }
    get startIndex() {
        return this._startIndex;
    }
    static fromJSON(n) {
        let e = new a;
        return e._ianaName = n.ianaName, e._startIndex = n.startIndex, e._endIndex = n.endIndex, e;
    }
};


var $5f5ebc5c4f48ef8d$export$407448d2b89b1813 = class r {
    get barcodeSetId() {
        return this._barcodeSetId;
    }
    get completeData() {
        return this._completeData;
    }
    get encodingRanges() {
        return this._encodingRanges;
    }
    get isComplete() {
        return this._complete;
    }
    get rawCompleteData() {
        return this._rawCompleteData;
    }
    get scannedSegmentCount() {
        return this._scannedSegmentCount;
    }
    get totalSegmentCount() {
        return this._totalSegmentCount;
    }
    static fromJSON(e) {
        if (e == null) return null;
        let t = new r;
        return t._complete = e.complete, t._barcodeSetId = e.barcodeSetId, t._scannedSegmentCount = e.scannedSegmentCount, t._totalSegmentCount = e.totalSegmentCount, t._encodingRanges = e.completeDataEncodings.map((o)=>(0, $dbd1c842f22f0339$export$407448d2b89b1813).fromJSON(o)), t._completeData = e.completeDataUtf8String, t._rawCompleteData = e.completeDataRaw, t;
    }
};




var $1877baa693087f92$export$407448d2b89b1813 = ((a)=>(a.EAN13UPCA = "ean13Upca", a.UPCE = "upce", a.EAN8 = "ean8", a.Code39 = "code39", a.Code93 = "code93", a.Code128 = "code128", a.Code11 = "code11", a.Code25 = "code25", a.Codabar = "codabar", a.InterleavedTwoOfFive = "interleavedTwoOfFive", a.MSIPlessey = "msiPlessey", a.QR = "qr", a.DataMatrix = "dataMatrix", a.Aztec = "aztec", a.MaxiCode = "maxicode", a.DotCode = "dotcode", a.KIX = "kix", a.RM4SCC = "rm4scc", a.GS1Databar = "databar", a.GS1DatabarExpanded = "databarExpanded", a.GS1DatabarLimited = "databarLimited", a.PDF417 = "pdf417", a.MicroPDF417 = "microPdf417", a.MicroQR = "microQr", a.Code32 = "code32", a.Lapa4SC = "lapa4sc", a.IATATwoOfFive = "iata2of5", a.MatrixTwoOfFive = "matrix2of5", a.USPSIntelligentMail = "uspsIntelligentMail", a))($1877baa693087f92$export$407448d2b89b1813 || {}), $1877baa693087f92$export$8b22cf2602fb60ce = ((i)=>(i.A = "A", i.B = "B", i.C = "C", i))($1877baa693087f92$export$8b22cf2602fb60ce || {}), $1877baa693087f92$export$db3b6bfb95261072 = ((r)=>(r.Mod10 = "mod10", r.Mod11 = "mod11", r.Mod16 = "mod16", r.Mod43 = "mod43", r.Mod47 = "mod47", r.Mod103 = "mod103", r.Mod10AndMod11 = "mod1110", r.Mod10AndMod10 = "mod1010", r))($1877baa693087f92$export$db3b6bfb95261072 || {}), $1877baa693087f92$export$4368d992c4eafac0 = ((n)=>(n.None = "none", n.Unknown = "unknown", n.Linked = "linked", n.GS1TypeA = "gs1TypeA", n.GS1TypeB = "gs1TypeB", n.GS1TypeC = "gs1TypeC", n))($1877baa693087f92$export$4368d992c4eafac0 || {}), $1877baa693087f92$export$f1e1789686576879 = class u {
    get isStructuredAppend() {
        return this._structuredAppendData != null;
    }
    get structuredAppendData() {
        return this._structuredAppendData;
    }
    get addOnData() {
        return this._addOnData;
    }
    get compositeData() {
        return this._compositeData;
    }
    get compositeFlag() {
        return this._compositeFlag;
    }
    get compositeRawData() {
        return this._compositeRawData;
    }
    get data() {
        return this._data;
    }
    get encodingRanges() {
        return this._encodingRanges;
    }
    get frameID() {
        return this._frameID;
    }
    get isColorInverted() {
        return this._isColorInverted;
    }
    get isGS1DataCarrier() {
        return this._isGS1DataCarrier;
    }
    get location() {
        return this._location;
    }
    get rawData() {
        return this._rawData;
    }
    get symbolCount() {
        return this._symbolCount;
    }
    get symbology() {
        return this._symbology;
    }
    static fromJSON(e) {
        var i;
        let t = new u;
        return t._symbology = e.symbology, t._data = e.data, t._rawData = e.rawData, t._compositeData = e.compositeData, t._compositeRawData = e.compositeRawData, t._addOnData = (i = e.addOnData) != null ? i : null, t._isGS1DataCarrier = e.isGS1DataCarrier, t._compositeFlag = e.compositeFlag, t._isColorInverted = e.isColorInverted, t._symbolCount = e.symbolCount, t._frameID = e.frameId, t._encodingRanges = e.encodingRanges.map((c)=>(0, $dbd1c842f22f0339$export$407448d2b89b1813).fromJSON(c)), t._location = (0, $72be97bdfeffe3ee$export$8b22cf2602fb60ce).fromJSON(e.location), t._structuredAppendData = (0, $5f5ebc5c4f48ef8d$export$407448d2b89b1813).fromJSON(e.structuredAppendData), t;
    }
};


var $618b50c72dbb0026$export$407448d2b89b1813 = class n {
    get newlyRecognizedBarcodes() {
        return this._newlyRecognizedBarcodes;
    }
    get newlyLocalizedBarcodes() {
        return this._newlyLocalizedBarcodes;
    }
    get frameSequenceID() {
        return this._frameSequenceID;
    }
    static fromJSON(r) {
        let e$1 = new n;
        return e$1._newlyRecognizedBarcodes = r.newlyRecognizedBarcodes.map((o)=>(0, $1877baa693087f92$export$f1e1789686576879).fromJSON(o)), e$1._newlyLocalizedBarcodes = r.newlyLocalizedBarcodes.map((o)=>(0, $f12b8ed4258abc09$export$407448d2b89b1813).fromJSON(o)), e$1._frameSequenceID = r.frameSequenceId, e$1;
    }
};


var $db5182b789c922c9$export$407448d2b89b1813 = class t {
    get isFixed() {
        return this.minimum === this.maximum || this.step <= 0;
    }
    get maximum() {
        return this._maximum;
    }
    get minimum() {
        return this._minimum;
    }
    get step() {
        return this._step;
    }
    static fromJSON(i) {
        let m = new t;
        return m._minimum = i.minimum, m._maximum = i.maximum, m._step = i.step, m;
    }
    toJSONObject() {
        return {
            maximum: this.maximum,
            minimum: this.minimum,
            step: this.step
        };
    }
};


var $aa05797868cb9a30$export$407448d2b89b1813 = class t {
    constructor(e){
        if (e != null) return t.all[t.all.findIndex((i)=>i.identifier === e)];
    }
    static get all() {
        return this.defaults().SymbologyDescriptions;
    }
    get activeSymbolCountRange() {
        return this._activeSymbolCountRange;
    }
    get defaultSymbolCountRange() {
        return this._defaultSymbolCountRange;
    }
    get identifier() {
        return this._identifier;
    }
    get isAvailable() {
        return this._isAvailable;
    }
    get isColorInvertible() {
        return this._isColorInvertible;
    }
    get readableName() {
        return this._readableName;
    }
    get supportedExtensions() {
        return [
            ...this._supportedExtensions
        ];
    }
    get symbology() {
        return this.identifier;
    }
    static forIdentifier(e) {
        return t.all.findIndex((r)=>r.identifier === e) === -1 ? null : new t(e);
    }
    static fromJSON(e) {
        let i = new t;
        return i._identifier = e.identifier, i._readableName = e.readableName, i._isAvailable = e.isAvailable, i._isColorInvertible = e.isColorInvertible, i._activeSymbolCountRange = (0, $db5182b789c922c9$export$407448d2b89b1813).fromJSON(e.activeSymbolCountRange), i._defaultSymbolCountRange = (0, $db5182b789c922c9$export$407448d2b89b1813).fromJSON(e.defaultSymbolCountRange), i._supportedExtensions = new Set(e.supportedExtensions), i;
    }
};


var $a42468f675ba5ac8$export$407448d2b89b1813 = class o {
    get enabledExtensions() {
        return [
            ...this.extensions
        ];
    }
    get symbology() {
        return this._symbology;
    }
    static fromJSON(e) {
        let t = new o;
        return t.extensions = new Set(e.extensions), t.isEnabled = e.enabled, t.isColorInvertedEnabled = e.colorInvertedEnabled, t.checksums = new Set(e.checksums), t.activeSymbolCounts = e.activeSymbolCounts, t;
    }
    setExtensionEnabled(e, t) {
        t ? this.extensions.add(e) : this.extensions.delete(e);
    }
    toJSONObject() {
        return {
            activeSymbolCounts: [
                ...this.activeSymbolCounts
            ],
            checksums: [
                ...this.checksums
            ],
            colorInvertedEnabled: this.isColorInvertedEnabled,
            enabled: this.isEnabled,
            extensions: [
                ...this.extensions
            ]
        };
    }
};



var $4e01d9cab6eba960$export$407448d2b89b1813 = (e)=>({
        SymbologySettings: Object.keys(e.SymbologySettings).reduce((a, o)=>(a[o] = (0, $a42468f675ba5ac8$export$407448d2b89b1813).fromJSON(JSON.parse(e.SymbologySettings[o])), a), {}),
        SymbologyDescriptions: e.SymbologyDescriptions.map((a$1)=>(0, $aa05797868cb9a30$export$407448d2b89b1813).fromJSON(JSON.parse(a$1))),
        CompositeTypeDescriptions: e.CompositeTypeDescriptions.map((a)=>JSON.parse(a)),
        BarcodeCapture: {
            BarcodeCaptureOverlay: {
                defaultStyle: e.BarcodeCapture.BarcodeCaptureOverlay.defaultStyle,
                DefaultBrush: {
                    fillColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e.BarcodeCapture.BarcodeCaptureOverlay.DefaultBrush.fillColor),
                    strokeColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e.BarcodeCapture.BarcodeCaptureOverlay.DefaultBrush.strokeColor),
                    strokeWidth: e.BarcodeCapture.BarcodeCaptureOverlay.DefaultBrush.strokeWidth
                },
                styles: Object.fromEntries(Object.keys(e.BarcodeCapture.BarcodeCaptureOverlay.styles).map((a)=>[
                        a,
                        {
                            DefaultBrush: {
                                fillColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e.BarcodeCapture.BarcodeCaptureOverlay.styles[a].DefaultBrush.fillColor),
                                strokeColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e.BarcodeCapture.BarcodeCaptureOverlay.styles[a].DefaultBrush.strokeColor),
                                strokeWidth: e.BarcodeCapture.BarcodeCaptureOverlay.styles[a].DefaultBrush.strokeWidth
                            }
                        }
                    ]))
            },
            BarcodeCaptureSettings: {
                codeDuplicateFilter: e.BarcodeCapture.BarcodeCaptureSettings.codeDuplicateFilter
            },
            RecommendedCameraSettings: (0, $26b53f2fcaea5d86$export$39b482c5e57630a8).fromJSON(e.BarcodeCapture.RecommendedCameraSettings)
        },
        BarcodeTracking: {
            BarcodeTrackingBasicOverlay: {
                defaultStyle: e.BarcodeTracking.BarcodeTrackingBasicOverlay.defaultStyle,
                DefaultBrush: {
                    fillColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e.BarcodeTracking.BarcodeTrackingBasicOverlay.DefaultBrush.fillColor),
                    strokeColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e.BarcodeTracking.BarcodeTrackingBasicOverlay.DefaultBrush.strokeColor),
                    strokeWidth: e.BarcodeTracking.BarcodeTrackingBasicOverlay.DefaultBrush.strokeWidth
                },
                styles: Object.fromEntries(Object.keys(e.BarcodeTracking.BarcodeTrackingBasicOverlay.styles).map((a)=>[
                        a,
                        {
                            DefaultBrush: {
                                fillColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e.BarcodeTracking.BarcodeTrackingBasicOverlay.styles[a].DefaultBrush.fillColor),
                                strokeColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e.BarcodeTracking.BarcodeTrackingBasicOverlay.styles[a].DefaultBrush.strokeColor),
                                strokeWidth: e.BarcodeTracking.BarcodeTrackingBasicOverlay.styles[a].DefaultBrush.strokeWidth
                            }
                        }
                    ]))
            },
            RecommendedCameraSettings: (0, $26b53f2fcaea5d86$export$39b482c5e57630a8).fromJSON(e.BarcodeTracking.RecommendedCameraSettings)
        },
        SparkScan: {
            SparkScanFeedback: {
                errorVibrationPattern: e.SparkScan.SparkScanFeedback.errorVibrationPattern
            },
            SparkScanSettings: {
                codeDuplicateFilter: e.SparkScan.SparkScanSettings.codeDuplicateFilter,
                locationSelection: {
                    radius: e.SparkScan.SparkScanSettings.locationSelection.radius,
                    unit: e.SparkScan.SparkScanSettings.locationSelection.unit
                },
                hiddenProperties: {
                    other: {
                        advanced_localization: e.SparkScan.SparkScanSettings.hiddenProperties.other.advanced_localization,
                        blurryAnglesScanningEnabled: e.SparkScan.SparkScanSettings.hiddenProperties.other.blurryAnglesScanningEnabled
                    },
                    ios: {
                        advanced_localization: e.SparkScan.SparkScanSettings.hiddenProperties.ios.advanced_localization,
                        blurryAnglesScanningEnabled: e.SparkScan.SparkScanSettings.hiddenProperties.ios.blurryAnglesScanningEnabled,
                        preprocess_image_downsample_factor: e.SparkScan.SparkScanSettings.hiddenProperties.ios.preprocess_image_downsample_factor,
                        preprocess_image_options: e.SparkScan.SparkScanSettings.hiddenProperties.ios.preprocess_image_options
                    }
                }
            },
            SparkScanOverlay: {
                DefaultBrush: {
                    fillColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e.SparkScan.SparkScanOverlay.DefaultBrush.fillColor),
                    strokeColor: (0, $72be97bdfeffe3ee$export$7ccc53e8f1e7dfc5).fromJSON(e.SparkScan.SparkScanOverlay.DefaultBrush.strokeColor),
                    strokeWidth: e.SparkScan.SparkScanOverlay.DefaultBrush.strokeWidth
                },
                defaultStyle: "frame"
            },
            CameraSettings: {
                other: {
                    hiddenProperties: {
                        exposureTargetBias: e.SparkScan.CameraSettings.other.hiddenProperties.exposureTargetBias,
                        grayScaleFrameReader: e.SparkScan.CameraSettings.other.hiddenProperties.grayScaleFrameReader,
                        repeatedTriggerInterval: e.SparkScan.CameraSettings.other.hiddenProperties.repeatedTriggerInterval
                    },
                    settings: (0, $26b53f2fcaea5d86$export$39b482c5e57630a8).fromJSON(e.SparkScan.CameraSettings.other.settings)
                },
                ios: {
                    hiddenProperties: {
                        activeMaxExposureDuration: e.SparkScan.CameraSettings.ios.hiddenProperties.activeMaxExposureDuration,
                        exposureTargetBias: e.SparkScan.CameraSettings.ios.hiddenProperties.exposureTargetBias,
                        forceAggressiveAutofocus: e.SparkScan.CameraSettings.ios.hiddenProperties.forceAggressiveAutofocus,
                        grayScaleFrameReader: e.SparkScan.CameraSettings.ios.hiddenProperties.grayScaleFrameReader,
                        preferredAspectRatio: e.SparkScan.CameraSettings.ios.hiddenProperties.preferredAspectRatio
                    },
                    settings: (0, $26b53f2fcaea5d86$export$39b482c5e57630a8).fromJSON(e.SparkScan.CameraSettings.ios.settings)
                }
            },
            SparkScanViewSettings: {
                triggerButtonCollapseTimeout: e.SparkScan.SparkScanViewSettings.triggerButtonCollapseTimeout,
                continuousCaptureTimeout: e.SparkScan.SparkScanViewSettings.continuousCaptureTimeout,
                defaultTorchState: e.SparkScan.SparkScanViewSettings.defaultTorchState,
                soundEnabled: e.SparkScan.SparkScanViewSettings.soundEnabled,
                hapticEnabled: e.SparkScan.SparkScanViewSettings.hapticEnabled,
                defaultHandMode: e.SparkScan.SparkScanViewSettings.defaultHandMode,
                holdToScanEnabled: e.SparkScan.SparkScanViewSettings.holdToScanEnabled,
                visualFeedbackEnabled: e.SparkScan.SparkScanViewSettings.visualFeedbackEnabled
            }
        },
        SparkCapture: {
            SparkCaptureSettings: {
                codeDuplicateFilter: e.SparkCapture.SparkCaptureSettings.codeDuplicateFilter
            }
        }
    }), $4e01d9cab6eba960$export$8b22cf2602fb60ce = $4e01d9cab6eba960$export$407448d2b89b1813({
    BarcodeCapture: {
        BarcodeCaptureSettings: {
            codeDuplicateFilter: 0
        },
        BarcodeCaptureOverlay: {
            defaultStyle: "frame",
            DefaultBrush: {
                fillColor: "#00000000",
                strokeColor: "#FFFFFFFF",
                strokeWidth: 3
            },
            styles: {
                frame: {
                    DefaultBrush: {
                        fillColor: "#00000000",
                        strokeColor: "#FFFFFFFF",
                        strokeWidth: 3
                    }
                }
            }
        },
        RecommendedCameraSettings: {
            zoomFactor: 1,
            zoomGestureZoomFactor: 2,
            focusGestureStrategy: "manualUntilCapture",
            preferredResolution: "auto"
        }
    },
    SymbologySettings: {
        ean13Upca: JSON.stringify({
            activeSymbolCounts: [
                12
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        ean8: JSON.stringify({
            activeSymbolCounts: [
                8
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        upce: JSON.stringify({
            activeSymbolCounts: [
                6
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        code128: JSON.stringify({
            activeSymbolCounts: [
                40,
                39,
                38,
                37,
                36,
                35,
                34,
                33,
                32,
                31,
                30,
                29,
                28,
                27,
                26,
                25,
                24,
                23,
                22,
                21,
                20,
                19,
                18,
                17,
                16,
                15,
                14,
                13,
                12,
                11,
                10,
                9,
                8,
                7,
                6
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: [
                "strip_leading_fnc1"
            ]
        }),
        code39: JSON.stringify({
            activeSymbolCounts: [
                40,
                39,
                38,
                37,
                36,
                35,
                34,
                33,
                32,
                31,
                30,
                29,
                28,
                27,
                26,
                25,
                24,
                23,
                22,
                21,
                20,
                19,
                18,
                17,
                16,
                15,
                14,
                13,
                12,
                11,
                10,
                9,
                8,
                7,
                6
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        code93: JSON.stringify({
            activeSymbolCounts: [
                40,
                39,
                38,
                37,
                36,
                35,
                34,
                33,
                32,
                31,
                30,
                29,
                28,
                27,
                26,
                25,
                24,
                23,
                22,
                21,
                20,
                19,
                18,
                17,
                16,
                15,
                14,
                13,
                12,
                11,
                10,
                9,
                8,
                7,
                6
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        interleavedTwoOfFive: JSON.stringify({
            activeSymbolCounts: [
                40,
                38,
                36,
                34,
                32,
                30,
                28,
                26,
                24,
                22,
                20,
                18,
                16,
                14,
                12,
                10,
                8,
                6
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        qr: JSON.stringify({
            activeSymbolCounts: [],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        dataMatrix: JSON.stringify({
            activeSymbolCounts: [],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: [
                "strip_leading_fnc1"
            ]
        }),
        pdf417: JSON.stringify({
            activeSymbolCounts: [],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        msiPlessey: JSON.stringify({
            activeSymbolCounts: [
                32,
                31,
                30,
                29,
                28,
                27,
                26,
                25,
                24,
                23,
                22,
                21,
                20,
                19,
                18,
                17,
                16,
                15,
                14,
                13,
                12,
                11,
                10,
                9,
                8,
                7,
                6
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        databar: JSON.stringify({
            activeSymbolCounts: [
                2
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        databarExpanded: JSON.stringify({
            activeSymbolCounts: [],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        codabar: JSON.stringify({
            activeSymbolCounts: [
                20,
                19,
                18,
                17,
                16,
                15,
                14,
                13,
                12,
                11,
                10,
                9,
                8,
                7
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        aztec: JSON.stringify({
            activeSymbolCounts: [],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        maxicode: JSON.stringify({
            activeSymbolCounts: [],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        code11: JSON.stringify({
            activeSymbolCounts: [
                20,
                19,
                18,
                17,
                16,
                15,
                14,
                13,
                12,
                11,
                10,
                9,
                8,
                7
            ],
            checksums: [
                "mod11"
            ],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        databarLimited: JSON.stringify({
            activeSymbolCounts: [
                1
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        code25: JSON.stringify({
            activeSymbolCounts: [
                20,
                19,
                18,
                17,
                16,
                15,
                14,
                13,
                12,
                11,
                10,
                9,
                8,
                7
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        microPdf417: JSON.stringify({
            activeSymbolCounts: [],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        rm4scc: JSON.stringify({
            activeSymbolCounts: [
                24,
                23,
                22,
                21,
                20,
                19,
                18,
                17,
                16,
                15,
                14,
                13,
                12,
                11,
                10,
                9,
                8,
                7
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        kix: JSON.stringify({
            activeSymbolCounts: [
                24,
                23,
                22,
                21,
                20,
                19,
                18,
                17,
                16,
                15,
                14,
                13,
                12,
                11,
                10,
                9,
                8,
                7
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        dotcode: JSON.stringify({
            activeSymbolCounts: [],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        microQr: JSON.stringify({
            activeSymbolCounts: [],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        code32: JSON.stringify({
            activeSymbolCounts: [
                8
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        lapa4sc: JSON.stringify({
            activeSymbolCounts: [
                16
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        iata2of5: JSON.stringify({
            activeSymbolCounts: [
                20,
                19,
                18,
                17,
                16,
                15,
                14,
                13,
                12,
                11,
                10,
                9,
                8,
                7
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        matrix2of5: JSON.stringify({
            activeSymbolCounts: [
                20,
                19,
                18,
                17,
                16,
                15,
                14,
                13,
                12,
                11,
                10,
                9,
                8,
                7
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        }),
        uspsIntelligentMail: JSON.stringify({
            activeSymbolCounts: [
                65
            ],
            checksums: [],
            colorInvertedEnabled: !1,
            enabled: !1,
            extensions: []
        })
    },
    BarcodeTracking: {
        BarcodeTrackingBasicOverlay: {
            defaultStyle: "frame",
            DefaultBrush: {
                fillColor: "#00000000",
                strokeColor: "#FFFFFFFF",
                strokeWidth: 3
            },
            styles: {
                frame: {
                    DefaultBrush: {
                        fillColor: "#00000000",
                        strokeColor: "#FFFFFFFF",
                        strokeWidth: 3
                    }
                },
                dot: {
                    DefaultBrush: {
                        fillColor: "#FFFFFFFF",
                        strokeColor: "#FFFFFFFF",
                        strokeWidth: 1
                    }
                },
                legacy: {
                    DefaultBrush: {
                        fillColor: "#00000000",
                        strokeColor: "#FFFFFFFF",
                        strokeWidth: 1
                    }
                }
            }
        },
        RecommendedCameraSettings: {
            zoomFactor: 1,
            zoomGestureZoomFactor: 2,
            focusGestureStrategy: "manualUntilCapture",
            preferredResolution: "fullHd"
        }
    },
    SparkScan: {
        SparkScanFeedback: {
            errorVibrationPattern: [
                600
            ]
        },
        SparkScanSettings: {
            codeDuplicateFilter: 700,
            locationSelection: {
                radius: .2,
                unit: (0, $72be97bdfeffe3ee$export$db3b6bfb95261072).Fraction
            },
            hiddenProperties: {
                other: {
                    advanced_localization: 1,
                    blurryAnglesScanningEnabled: !0
                },
                ios: {
                    advanced_localization: 1,
                    blurryAnglesScanningEnabled: !0,
                    preprocess_image_downsample_factor: 2,
                    preprocess_image_options: 1
                }
            }
        },
        SparkScanOverlay: {
            DefaultBrush: {
                fillColor: "#00000000",
                strokeColor: "#FFFFFFFF",
                strokeWidth: 3
            },
            defaultStyle: "frame"
        },
        CameraSettings: {
            other: {
                hiddenProperties: {
                    exposureTargetBias: -1,
                    grayScaleFrameReader: !0,
                    repeatedTriggerInterval: 1
                },
                settings: {
                    focusGestureStrategy: (0, $26b53f2fcaea5d86$export$f1e1789686576879).AutoOnLocation,
                    preferredResolution: (0, $26b53f2fcaea5d86$export$4368d992c4eafac0).FullHD,
                    zoomFactor: 1,
                    zoomGestureZoomFactor: 1
                }
            },
            ios: {
                hiddenProperties: {
                    activeMaxExposureDuration: "1/200",
                    exposureTargetBias: -1,
                    forceAggressiveAutofocus: 1,
                    grayScaleFrameReader: !0,
                    preferredAspectRatio: "fourToThree"
                },
                settings: {
                    focusGestureStrategy: (0, $26b53f2fcaea5d86$export$f1e1789686576879).AutoOnLocation,
                    preferredResolution: (0, $26b53f2fcaea5d86$export$4368d992c4eafac0).UHD4K,
                    zoomFactor: 1,
                    zoomGestureZoomFactor: 1
                }
            }
        },
        SparkScanViewSettings: {
            continuousCaptureTimeout: 6e4,
            defaultHandMode: "right",
            defaultTorchState: (0, $26b53f2fcaea5d86$export$8b22cf2602fb60ce).Off,
            hapticEnabled: !0,
            holdToScanEnabled: !0,
            soundEnabled: !0,
            triggerButtonCollapseTimeout: Number.NEGATIVE_INFINITY,
            visualFeedbackEnabled: !0
        }
    },
    CompositeTypeDescriptions: [
        JSON.stringify({
            symbologies: [
                "ean8",
                "ean13Upca",
                "microPdf417",
                "databarLimited",
                "upce",
                "databar",
                "databarExpanded"
            ],
            types: [
                "A"
            ]
        }),
        JSON.stringify({
            symbologies: [
                "ean8",
                "ean13Upca",
                "microPdf417",
                "databarLimited",
                "upce",
                "databar",
                "databarExpanded"
            ],
            types: [
                "B"
            ]
        }),
        JSON.stringify({
            symbologies: [
                "code128",
                "pdf417"
            ],
            types: [
                "C"
            ]
        })
    ],
    SparkCapture: {
        SparkCaptureSettings: {
            codeDuplicateFilter: 1e3
        }
    },
    SymbologyDescriptions: [
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 12,
                minimum: 12,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 12,
                minimum: 12,
                step: 1
            },
            identifier: "ean13Upca",
            isAvailable: !0,
            isColorInvertible: !0,
            readableName: "EAN-13/UPC-A",
            supportedChecksums: [],
            supportedExtensions: [
                "two_digit_add_on",
                "strict",
                "remove_leading_upca_zero",
                "relaxed_sharp_quiet_zone_check",
                "five_digit_add_on"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 8,
                minimum: 8,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 8,
                minimum: 8,
                step: 1
            },
            identifier: "ean8",
            isAvailable: !0,
            isColorInvertible: !0,
            readableName: "EAN-8",
            supportedChecksums: [],
            supportedExtensions: [
                "two_digit_add_on",
                "strict",
                "relaxed_sharp_quiet_zone_check",
                "five_digit_add_on"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 6,
                minimum: 6,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 6,
                minimum: 6,
                step: 1
            },
            identifier: "upce",
            isAvailable: !0,
            isColorInvertible: !0,
            readableName: "UPC-E",
            supportedChecksums: [],
            supportedExtensions: [
                "two_digit_add_on",
                "strict",
                "return_as_upca",
                "remove_leading_upca_zero",
                "five_digit_add_on"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 50,
                minimum: 4,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 40,
                minimum: 6,
                step: 1
            },
            identifier: "code128",
            isAvailable: !0,
            isColorInvertible: !0,
            readableName: "Code 128",
            supportedChecksums: [],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 50,
                minimum: 3,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 40,
                minimum: 6,
                step: 1
            },
            identifier: "code39",
            isAvailable: !0,
            isColorInvertible: !0,
            readableName: "Code 39",
            supportedChecksums: [
                "mod43"
            ],
            supportedExtensions: [
                "strict",
                "relaxed_sharp_quiet_zone_check",
                "full_ascii"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 60,
                minimum: 5,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 40,
                minimum: 6,
                step: 1
            },
            identifier: "code93",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "Code 93",
            supportedChecksums: [],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 50,
                minimum: 4,
                step: 2
            },
            defaultSymbolCountRange: {
                maximum: 40,
                minimum: 6,
                step: 2
            },
            identifier: "interleavedTwoOfFive",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "Interleaved Two of Five",
            supportedChecksums: [],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            defaultSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            identifier: "qr",
            isAvailable: !0,
            isColorInvertible: !0,
            readableName: "QR Code",
            supportedChecksums: [],
            supportedExtensions: [
                "guess_encoding"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            defaultSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            identifier: "dataMatrix",
            isAvailable: !0,
            isColorInvertible: !0,
            readableName: "Data Matrix",
            supportedChecksums: [],
            supportedExtensions: [
                "direct_part_marking_mode"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            defaultSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            identifier: "pdf417",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "PDF417",
            supportedChecksums: [],
            supportedExtensions: []
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 32,
                minimum: 3,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 32,
                minimum: 6,
                step: 1
            },
            identifier: "msiPlessey",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "MSI Plessey",
            supportedChecksums: [
                "mod11",
                "mod1010",
                "mod1110"
            ],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 2,
                minimum: 2,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 2,
                minimum: 2,
                step: 1
            },
            identifier: "databar",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "GS1 DataBar 14",
            supportedChecksums: [],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            defaultSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            identifier: "databarExpanded",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "GS1 DataBar Expanded",
            supportedChecksums: [],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 34,
                minimum: 3,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 20,
                minimum: 7,
                step: 1
            },
            identifier: "codabar",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "Codabar",
            supportedChecksums: [
                "mod11",
                "mod16"
            ],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            defaultSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            identifier: "aztec",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "Aztec",
            supportedChecksums: [],
            supportedExtensions: []
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            defaultSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            identifier: "maxicode",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "MaxiCode",
            supportedChecksums: [],
            supportedExtensions: []
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 34,
                minimum: 5,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 20,
                minimum: 7,
                step: 1
            },
            identifier: "code11",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "Code 11",
            supportedChecksums: [
                "mod11"
            ],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 1,
                minimum: 1,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 1,
                minimum: 1,
                step: 1
            },
            identifier: "databarLimited",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "GS1 DataBar Limited",
            supportedChecksums: [],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 32,
                minimum: 3,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 20,
                minimum: 7,
                step: 1
            },
            identifier: "code25",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "Code 25",
            supportedChecksums: [],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            defaultSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            identifier: "microPdf417",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "MicroPDF417",
            supportedChecksums: [],
            supportedExtensions: []
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 50,
                minimum: 4,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 24,
                minimum: 7,
                step: 1
            },
            identifier: "rm4scc",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "RM4SCC",
            supportedChecksums: [],
            supportedExtensions: []
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 50,
                minimum: 4,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 24,
                minimum: 7,
                step: 1
            },
            identifier: "kix",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "KIX",
            supportedChecksums: [],
            supportedExtensions: []
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            defaultSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            identifier: "dotcode",
            isAvailable: !0,
            isColorInvertible: !0,
            readableName: "DotCode",
            supportedChecksums: [],
            supportedExtensions: []
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            defaultSymbolCountRange: {
                maximum: 0,
                minimum: 0,
                step: 0
            },
            identifier: "microQr",
            isAvailable: !0,
            isColorInvertible: !0,
            readableName: "Micro QR",
            supportedChecksums: [],
            supportedExtensions: []
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 8,
                minimum: 8,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 8,
                minimum: 8,
                step: 1
            },
            identifier: "code32",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "Code 32",
            supportedChecksums: [],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 16,
                minimum: 16,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 16,
                minimum: 16,
                step: 1
            },
            identifier: "lapa4sc",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "LAPA4SC",
            supportedChecksums: [],
            supportedExtensions: []
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 32,
                minimum: 3,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 20,
                minimum: 7,
                step: 1
            },
            identifier: "iata2of5",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "IATA 2 of 5",
            supportedChecksums: [
                "mod1010"
            ],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 32,
                minimum: 3,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 20,
                minimum: 7,
                step: 1
            },
            identifier: "matrix2of5",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "Matrix 2 of 5",
            supportedChecksums: [],
            supportedExtensions: [
                "strict"
            ]
        }),
        JSON.stringify({
            activeSymbolCountRange: {
                maximum: 65,
                minimum: 65,
                step: 1
            },
            defaultSymbolCountRange: {
                maximum: 65,
                minimum: 65,
                step: 1
            },
            identifier: "uspsIntelligentMail",
            isAvailable: !0,
            isColorInvertible: !1,
            readableName: "USPS Intelligent Mail",
            supportedChecksums: [],
            supportedExtensions: []
        })
    ]
});
function $4e01d9cab6eba960$export$db3b6bfb95261072(e) {
    $4e01d9cab6eba960$export$8b22cf2602fb60ce = e;
}
(0, $aa05797868cb9a30$export$407448d2b89b1813).defaults = ()=>({
        SymbologyDescriptions: $4e01d9cab6eba960$export$8b22cf2602fb60ce.SymbologyDescriptions
    });



var $d951bfb2ebebf89a$export$407448d2b89b1813 = class u {
    constructor(){
        this.type = "barcodeCapture";
        this._isEnabled = !0;
        this._feedback = (0, $74991dc7b1c32bd2$export$407448d2b89b1813).default;
        this._context = null;
        this.listeners = new Set;
        this.allowedRemainingWorkerMessages = new Set;
        this.workerMessageListener = this.onWorkerMessage.bind(this);
    }
    static get recommendedCameraSettings() {
        return new (0, $26b53f2fcaea5d86$export$39b482c5e57630a8)((0, $4e01d9cab6eba960$export$8b22cf2602fb60ce).BarcodeCapture.RecommendedCameraSettings);
    }
    get context() {
        return this._context;
    }
    get feedback() {
        return this._feedback;
    }
    set feedback(e) {
        this._feedback = e, (0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Info, "Please use BarcodeCapture.setFeedback instead of BarcodeCapture.feedback setter"), this.notifyContext();
    }
    static async forContext(e, a) {
        let t = new u;
        return t.settings = a, e && await e.addMode(t), t;
    }
    async setFeedback(e) {
        return this._feedback = e, this.notifyContext();
    }
    isEnabled() {
        return this._isEnabled;
    }
    async setEnabled(e) {
        this._isEnabled = e, await this.notifyContext();
    }
    async applySettings(e) {
        return this.settings = e, this.notifyContext();
    }
    addListener(e) {
        this.listeners.has(e) || this.listeners.add(e);
    }
    removeListener(e) {
        this.listeners.delete(e);
    }
    toJSONObject() {
        return {
            type: this.type,
            enabled: this._isEnabled,
            feedback: this.feedback.toJSONObject(),
            settings: this.settings.toJSONObject()
        };
    }
    attachedToContext(e) {
        this._context = e, this._context.subscribeToWorkerMessages(this.workerMessageListener);
    }
    async detachedFromContext() {
        var e;
        (e = this._context) == null || e.unsubscribeToWorkerMessages(this.workerMessageListener), this._context = null;
    }
    sendClearFrameDataRequest(e) {
        setTimeout(()=>{
            var a;
            (a = this.context) == null || a.workerCommand("deleteFrameData", {
                frameId: e
            });
        }, 0);
    }
    async onDidScan(e) {
        if (this.context == null) return;
        let a = (0, $618b50c72dbb0026$export$407448d2b89b1813).fromJSON(e.payload.session), { frameData: t } = e.payload;
        if (!this._isEnabled) {
            this.sendClearFrameDataRequest(t.frameId), this.allowedRemainingWorkerMessages.clear();
            return;
        }
        this.allowedRemainingWorkerMessages.add("successFeedback");
        let n = [];
        for (let r of this.listeners)if (r.didScan) try {
            let s = r.didScan(this, a, (0, $44cca9bce8501bbc$export$407448d2b89b1813)(t, this.context));
            s instanceof Promise && await s;
        } catch (s) {
            n.push(s);
        }
        this.sendClearFrameDataRequest(t.frameId), this.allowedRemainingWorkerMessages.add("barcodeCaptureDidUpdateSession");
        for (let r of n)(0, $9fbbcde428fa7e14$export$407448d2b89b1813).log((0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Error, r);
    }
    onDidUpdateSession(e) {
        let a = (0, $618b50c72dbb0026$export$407448d2b89b1813).fromJSON(e.payload);
        if (!(!this._isEnabled && !this.allowedRemainingWorkerMessages.has(e.type))) {
            this.allowedRemainingWorkerMessages.delete(e.type);
            for (let t of this.listeners)t.didUpdateSession && t.didUpdateSession(this, a);
        }
    }
    onSuccessFeedback(e) {
        !this._isEnabled && !this.allowedRemainingWorkerMessages.has(e.type) || (this.allowedRemainingWorkerMessages.delete(e.type), this.feedback.success.emit());
    }
    async onWorkerMessage(e) {
        switch(e.type){
            case "barcodeCaptureDidScan":
                this.onDidScan(e);
                break;
            case "barcodeCaptureDidUpdateSession":
                this.onDidUpdateSession(e);
                break;
            case "successFeedback":
                this.onSuccessFeedback(e);
                break;
        }
    }
    async notifyContext() {
        this.context != null && await this.context.update();
    }
};


var $9ada12739a6a95f5$var$u = URL.createObjectURL(new Blob([
    '"use strict";(()=>{var g={"scandit-datacapture-sdk-barcode-pthreads.wasm":{bytes:6409216},"scandit-datacapture-sdk-barcode-simd.wasm":{bytes:6569952},"scandit-datacapture-sdk-barcode-simd-pthreads.wasm":{bytes:6674112},"scandit-datacapture-sdk-barcode.wasm":{bytes:6305202}};var o;(r=>{(s=>(s.Debug="debug",s.Info="info",s.Warn="warn",s.Error="error",s.Quiet="quiet"))(r.Level||(r.Level={}));let e=new Map([["debug",1],["info",2],["warn",3],["error",4],["quiet",5]]),t="debug";function a(s){t=s}r.setLevel=a;function i(s,...n){if(!(e.get(t)>e.get(s)))switch(s){case"debug":console.debug(...n);break;case"info":console.log(...n);break;case"warn":console.warn(...n);break;case"error":console.error(...n);break}}r.log=i})(o||(o={}));function ce(r){return/^https?:\\/\\/(?:[^./]*\\.)*cdn.jsdelivr.net\\//.test(r)?{result:!0,cdnBaseURL:"https://cdn.jsdelivr.net/npm/"}:/^https?:\\/\\/(?:[^./]*\\.)*unpkg.com\\//.test(r)?{result:!0,cdnBaseURL:"https://unpkg.com/"}:{result:!1,cdnBaseURL:""}}function ue(r){let e=/scandit-web-datacapture-[a-z]+/i.exec(r);return e?e[0]:null}function U(r,e,t){let a=e,i=ce(a);if(i.result){let n=ue(a);n!=null&&(a=`${i.cdnBaseURL}${n}@${r}/build/engine/`)}let s=t.replace(".wasm","");return i.result?{jsURI:`${a}${s}.js`,wasmURI:`${a}${s}.wasm`}:{jsURI:`${a}${s}.js?v=${r}`,wasmURI:`${a}${s}.wasm?v=${r}`}}var $=(r,e)=>{if(e=Symbol[r])return e;throw Error("Symbol."+r+" is not defined")};var E=function(r,e){this[0]=r,this[1]=e},j=(r,e,t)=>{var a=(n,l,c,d)=>{try{var u=t[n](l),m=(l=u.value)instanceof E,p=u.done;Promise.resolve(m?l[0]:l).then(h=>m?a(n==="return"?n:"next",l[1]?{done:h.done,value:h.value}:h,c,d):c({value:h,done:p})).catch(h=>a("throw",h,c,d))}catch(h){d(h)}},i=n=>s[n]=l=>new Promise((c,d)=>a(n,l,c,d)),s={};return t=t.apply(r,e),s[Symbol.asyncIterator]=()=>s,i("next"),i("throw"),i("return"),s},J=(r,e,t)=>(e=r[$("asyncIterator")])?e.call(r):(r=r[$("iterator")](),e={},t=(a,i)=>(i=r[a])&&(e[a]=s=>new Promise((n,l,c)=>(s=i.call(r,s),c=s.done,Promise.resolve(s.value).then(d=>n({value:d,done:c}),l)))),t("next"),t("return"),e);var V={};function pe(r){return[...new Uint8Array(r)].map(e=>{let t=e.toString(16);return t.length===1?`0${t}`:t}).join("")}function he(r){return j(this,null,function*(){let e=r.getReader();try{for(;;){let{done:t,value:a}=yield new E(e.read());if(t)return;yield a}}finally{e.releaseLock()}})}async function me(r){let e=[],t=0,a=0;try{for(var i=J(he(r)),s,n,l;s=!(n=await i.next()).done;s=!1){let d=n.value;e.push(d),t+=d.length}}catch(d){l=[d]}finally{try{s&&(n=i.return)&&await n.call(i)}finally{if(l)throw l[0]}}let c=new Uint8Array(t);for(let d of e)c.set(d,a),a+=d.length;return c.buffer}var ge=(r=>(r.VALID="VALID",r.INVALID="INVALID",r.NOT_VERIFIABLE="NOT_VERIFIABLE",r))(ge||{});async function fe(r,e,t){if(typeof crypto.subtle.digest!="function")return o.log(o.Level.Warn,`Insecure context (see https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts): The hash of the Scandit Data Capture library WASM file found at ${t} could not be verified`),"NOT_VERIFIABLE";try{let a=r instanceof Promise?await r:r,i=await crypto.subtle.digest("SHA-256",a),s=pe(i);return e==null?(o.log(o.Level.Warn,"The library hash is not defined or empty, cannot correctly verify integrity."),"NOT_VERIFIABLE"):s===e?(o.log(o.Level.Debug,"Data Capture library WASM integrity has been verified correctly."),"VALID"):(o.log(o.Level.Warn,`The Scandit Data Capture library WASM file found at ${t} seems invalid: expected file hash doesn\'t match (received: ${s}, expected: ${e}). Please ensure the correct Scandit Data Capture file (with correct version) is retrieved.`),"INVALID")}catch(a){return o.log(o.Level.Warn,"Wasm response could not be verified",a),"NOT_VERIFIABLE"}}var _=new Map([["br",4.4],["gzip",2.9],["none",1]]);function be(r){var e;let t="content-encoding";if(r==null||r.get(t)==null)return _.get("none");let a=new Set(((e=r.get(t))!=null?e:"").split(",").map(i=>i.trim()));for(let[i,s]of _)if(a.has(i))return s;return _.get("none")}function ye(r){var e,t;if(r==null)return 0;let a=(e=be(r))!=null?e:1,i=Number.parseInt((t=r.get("content-length"))!=null?t:"0",10);return Number.isNaN(i)?0:Math.floor(i*a*100)/100}function we(r){let{pathname:e}=new URL(r);for(let[t,a]of Object.entries(V))if(e.endsWith(t))return a.bytes;return 0}function q(r){V=r}var Me=(r,e)=>{let t=ye(e);return t===0?we(r):t};function Se(r,e,t,{onProgress:a,onError:i,onComplete:s}){if(!e.body)return[e];let n=Me(r,e.headers),l=0,c=0,[d,u]=t?e.body.tee():[e.body],m=d.pipeThrough(new TransformStream({async transform(p,h){try{l+=p.length,c=Number((l/n*100).toFixed(2)),n>0&&p.length>0&&c<100?a?.({percentage:c,loadedBytes:l,privateUri:r}):n===0&&p.length>0&&a?.({percentage:null,loadedBytes:l,privateUri:r}),h.enqueue(p)}catch(b){h.error(b),i?.({error:b})}},flush(p){a?.({percentage:100,loadedBytes:l,privateUri:r}),s?.({percentage:100,loadedBytes:l,privateUri:r}),p.terminate()}}));return[new Response(m,{headers:new Headers(e.headers),status:e.status,statusText:e.statusText}),u]}async function O({wasmURI:r,expectedHash:e,verifyResponseHash:t,onProgress:a,onComplete:i,onError:s,referredOrigin:n}){let l=await fetch(r,{referrerPolicy:"origin",referrer:n??""});if(!l.ok)throw new Error(`HTTP status code is not ok: ${l.status}, ${l.statusText}`);let[c,d]=Se(r,l,t,{onProgress:a,onError:s,onComplete:i});return d!=null&&fe(me(d),e,r),c}function G({wasmURI:r,expectedHash:e,verifyResponseHash:t,progressCallback:a,successCallback:i,importObject:s,referredOrigin:n}){async function l(d){try{let u=await O({wasmURI:r,expectedHash:e,verifyResponseHash:t,onProgress:a,referredOrigin:n}),m=await(d??u).arrayBuffer(),p=await globalThis.WebAssembly.instantiate(m,s);i(p.instance,p.module)}catch(u){o.log(o.Level.Error,u),o.log(o.Level.Error,`Couldn\'t instantiate Scandit SDK DataCapture library at ${r}, did you configure the path for it correctly?`)}}async function c(){let d;try{d=await O({wasmURI:r,expectedHash:e,verifyResponseHash:t,onProgress:a,referredOrigin:n});let u=await globalThis.WebAssembly.instantiateStreaming(d,s);i(u.instance,u.module)}catch(u){o.log(o.Level.Warn,u),o.log(o.Level.Warn,"WebAssembly streaming compile failed. Falling back to ArrayBuffer instantiation (this will make things slower)"),l(d?.bodyUsed===!0?void 0:d)}}typeof globalThis.WebAssembly.instantiateStreaming=="function"?c():l()}async function P(r,e,t,a){return new Promise((i,s)=>{r().then(i).catch(n=>{let l=e*2;if(l>t){s(n);return}a(n),globalThis.setTimeout(()=>{P(r,l,t,a).then(i).catch(s)},e)})})}function B(r){var e,t;let a="";if((e=r.href)!=null&&e.startsWith("blob:null/"))a="localhost";else{let i=((t=r.pathname)==null?void 0:t.length)>1&&!r.pathname.startsWith("/");a=new URL(i?r.pathname:r.origin).hostname}return a.startsWith("[")&&a.endsWith("]")&&(a=a.slice(1,-1)),a}var C=class K extends Error{constructor(e){super(e.message),Object.setPrototypeOf(this,K.prototype),typeof e.name=="string"&&(this.name=e.name),typeof e.message=="string"&&(this.message=e.message)}};var v=Promise.resolve(),k=!1,N=!1,S,M={writableDataPathPreload:"",writableDataPath:"",preloading:!1};async function De(){let r="FILE_DATA",e,t,a,i,s;function n(){clearTimeout(s),a.result.close(),i.result.close(),e(0)}function l(){try{let c=[],d=a.result.transaction(r,"readonly");d.addEventListener("error",n),d.addEventListener("abort",n);let u=d.objectStore(r).openCursor();u.onsuccess=()=>{let m=u.result;if(m==null)try{let p=0,h=i.result.transaction(r,"readwrite"),b=h.objectStore(r);h.addEventListener("error",n),h.addEventListener("abort",n),h.oncomplete=()=>{clearTimeout(s),a.result.close(),i.result.close(),e(p)};for(let y of c){let w=b.count(y.primaryKey);w.onsuccess=()=>{w.result===0&&(++p,b.add(y.value,y.primaryKey))},clearTimeout(s),s=globalThis.setTimeout(()=>{o.log(o.Level.Warn,"IndexedDB database is blocked! Resetting Scandit Data Capture library..."),t(new C({name:"BlockedIndexedDB",message:"IndexedDB database is blocked"}))},500)}}catch(p){n.call({error:p})}else{let{writableDataPathPreload:p,writableDataPath:h}=M;c.push({value:m.value,primaryKey:m.primaryKey.toString().replace(`${p}/`,`${h}/`)}),m.continue()}},u.onerror=n}catch(c){n.call({error:c})}}return new Promise((c,d)=>{let{writableDataPathPreload:u,writableDataPath:m}=M;e=c,t=d,a=indexedDB.open(u),a.onupgradeneeded=()=>{try{a.result.createObjectStore(r)}catch{}},a.onsuccess=()=>{if(!Array.from(a.result.objectStoreNames).includes(r)){c(0);return}i=indexedDB.open(m),i.onupgradeneeded=()=>{try{i.result.createObjectStore(r)}catch{}},i.onsuccess=()=>{l()},i.onblocked=i.onerror=n},a.onblocked=a.onerror=n})}async function X(r,e){let{preloading:t}=M;if(S!=null){if(k=!0,!t&&r){let a=await De();if(!e&&a===0){k=!1;return}}await new Promise((a,i)=>{S?.(r,s=>{if(k=!1,s!=null){i(s);return}a()})})}}async function Y(r,e=!1,t=!1){return(!N||t)&&(k?(N=!0,v=v.then(async()=>(N=!1,X(r,e)))):v=X(r,e)),v}async function Z(r){M=r,S=FS.syncfs,FS.syncfs=(e,t)=>{let a=t,i=s=>{a(s)};Y(e).then(i).catch(i)};try{FS.mkdir(M.writableDataPath)}catch(e){if(e.code!=="EEXIST")throw S=void 0,e}return FS.mount(IDBFS,{},M.writableDataPath),Y(!0,!0)}function L(r){return typeof r=="object"&&r!=null}function Q(r){if(typeof r=="string")return r;if(L(r)){if(typeof r.message=="string")return r.message}else if(typeof r?.toString=="function")return r.toString();return"unknow error"}var ee=class{constructor(){this.promise=new Promise((r,e)=>{this.reject=e,this.resolve=r})}};var x;(r=>{function e(){return"6.23.4"}r.sdkVersion=e})(x||(x={}));var Ce=async()=>WebAssembly.validate(new Uint8Array([0,97,115,109,1,0,0,0,1,5,1,96,0,1,123,3,2,1,0,10,10,1,8,0,65,0,253,15,253,98,11])),ve=()=>(async r=>{try{return typeof MessageChannel<"u"&&new MessageChannel().port1.postMessage(new SharedArrayBuffer(1)),WebAssembly.validate(r)}catch{return!1}})(new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,2,1,0,5,4,1,3,1,1,10,11,1,9,0,65,0,254,16,2,0,26,11]));function ke(){return typeof crossOriginIsolated>"u"?!1:crossOriginIsolated}function Le(){try{return new WebAssembly.Memory({initial:1,maximum:1,shared:!0}).buffer.constructor.name==="SharedArrayBuffer"}catch{return!1}}async function te(){return Ce()}async function xe(){if(!await ve())return!1;let r=null;try{r=new Worker(URL.createObjectURL(new Blob([\'postMessage("Worker" in self);\'],{type:"text/javascript"})),{name:"nestedWorkerTest"})}catch{return!1}return new Promise(e=>{if(r==null){e(!1);return}r.onmessage=t=>{r?.terminate(),e(t.data)}})}async function re(){let r=await xe();return ke()&&Le()&&r}async function Te(r,e){async function t(){return importScripts(r)}try{await P(t,250,4e3,i=>{o.log(o.Level.Warn,i),o.log(o.Level.Warn,`Couldn\'t retrieve Scandit Data Capture library at ${r}, retrying...`)}),self.Module.mainScriptUrlOrBlob=r;let a=globalThis.SDC_WASM_JS_VERSION;return a!==e&&o.log(o.Level.Warn,`The Scandit Data Capture library JS file found at ${r} seems invalid: expected version doesn\'t match (received: ${a}, expected: ${e}). Please ensure the correct Scandit Data Capture file (with correct version) is retrieved.`),!0}catch(a){return o.log(o.Level.Error,a),!1}}var ae=class se{constructor(e,t){this.MAX_NUMBER_OF_IMAGES_IN_FRAME_DATA_POOL=10,this.redrawInterval=1e3/30,this.redrawRequests=[],this._isDrawLoopRunning=!1,this.frameDataPool=new Map,this.lastFrameCounter=-1,this.poorMansBenchmarkLogs=!1,this.writableDataPathPreload="/scandit_sync_folder_preload",this.writableDataPathStandard="/scandit_sync_folder",this.resourceFilesSubfolder="resources",this.performanceMetricsReporterTimer=void 0,this.performanceMetrics={frameDataPoolSize:0,processedFramesCount:0,redrawRequestsCount:0,actualRedrawsCount:0},this.gestureListener=null,this.moduleHandler=e,this.workerFunctions=t,this._loadProgressCallback=this._loadProgressCallback.bind(this),q(this.getWasmMetadata())}get Module(){return this.moduleHandler.get()}set isDrawLoopRunning(e){this._isDrawLoopRunning=e,!e&&typeof this.loopTimeoutId=="number"&&(clearTimeout(this.loopTimeoutId),this.loopTimeoutId=void 0)}get isDrawLoopRunning(){return this._isDrawLoopRunning}setPoorMansBenchmarkLogs(e){this.poorMansBenchmarkLogs=e}convertToLoadableFrameData(e){let t=this.getNextFrameId();this.frameDataPool.set(t,new Uint8ClampedArray(e.getFrameData()));let a=this.lastUsedModuleMirrorAxis!=null?this.lastUsedModuleMirrorAxis!==this.Module.Axis.None:!1;return{frameId:t,width:e.getWidth(),height:e.getHeight(),isFrameSourceMirrored:a}}createContext(e){var t,a;let i=this.getModeDeserializers(),s=B(location);(s==="localhost"||s==="127.0.0.1")&&navigator.userAgent.includes("Electron")&&e.appName!=null&&(s+=`-${e.appName}`),this.contextDeserializer=new this.Module.DataCaptureContextDeserializer(this.writableDataPath,e.deviceId,e.context.deviceModelName,s,i,e.delayedRegistration,e.highEndBlurryRecognition,this.resourcePath);let n=this.contextDeserializer.contextFromJson(JSON.stringify(e.context));if(n==null)throw new Error("Could not create the context");let l=n.getView();this.context=n.getContext(),n.delete();let c=this.Module.DataCaptureContextListener.extend("DataCaptureContextListener",{didChangeStatus:(m,p)=>{this.contextDidChangeStatus(JSON.parse(p.toJson()))},didStartObservingContext:()=>{this.didStartObservingContext()}}),d=this.Module.GestureRecognizer.extend("GestureRecognizer",{setGestureListener:(m,p)=>{var h;(h=this.gestureListener)==null||h.delete(),this.gestureListener=m.clone()}});(t=this.gestureRecognizer)==null||t.delete(),this.gestureRecognizer=new d;let u=new c;this.context.addListener(u),u.delete(),this.setView(l),(a=this.view)==null||a.setGestureRecognizer(this.gestureRecognizer)}onTap(e){var t;(t=this.gestureListener)==null||t.onTap(JSON.stringify(e))}startReportingPerformanceMetrics(){this.performanceMetricsReporterTimer==null&&(this.performanceMetricsReporterTimer=setInterval(()=>{this.reportPerformanceMetrics();for(let e of Object.keys(this.performanceMetrics))this.performanceMetrics[e]=0},1e3))}async reportPerformanceMetrics(){this.workerFunctions.postMessage({type:"performanceMetricsReport",payload:{...this.performanceMetrics}})}deleteFrameData(e){this.frameDataPool.delete(e)}dispose(){var e,t;this.context.dispose(),this.frameDataPool.clear(),this.isDrawLoopRunning=!1,this.lastFrameCounter=-1,(e=this.gestureRecognizer)==null||e.delete(),this.gestureRecognizer=null,(t=this.gestureListener)==null||t.delete(),this.gestureListener=null}flushAnalytics(){this.context.flushAnalytics()}extractCentaurusLicense(e){return{payload:{centaurus:{licenseKey:this.Module.LicenseUtils[se.get3dPartyLicenseKeyMethodName](e)}}}}getModeDeserializers(){return new this.Module.VectorDataCaptureModeDeserializer}loadLibrary(e){return this.libraryLoadingPromise!=null?this.libraryLoadingPromise:(this.libraryLoadingPromise=this.setup(e),this.libraryLoadingPromise)}processFrame(e){var t;if(this.context==null)return{payload:e,transferables:[e.data.buffer]};let a=e.data,i=e.colorType==="GRAYSCALE"?this.Module.ImageBufferFormat.Grayscale8:this.Module.ImageBufferFormat.Rgba8888,s=this.Module.allocateUint8Array(a.byteLength);return this.Module.HEAPU8.set(a,s),(t=this.imageFrameSource)==null||t.outputFrame(s,e.width,e.height,i),{payload:e,transferables:[e.data.buffer]}}reportCameraProperties(e){this.context.setCameraProperties(e.deviceId,e.isFrontFacing,e.hasAutofocus)}requestFrameData(e){let t=this.frameDataPool.get(e);return t==null?{payload:{data:null}}:{payload:{data:t},transferables:[t.buffer]}}scheduleRedraw(e,t){this.addRedrawRequest(t),this.isDrawLoopRunning||this.startDrawLoop(e)}sendViewRefreshCommands(e){this.workerFunctions.postMessage({type:"draw",payload:e},[e.buffer])}setFrameSource(e){var t;this.lastUsedModuleMirrorAxis=this.mapMirrorAxisOnModule(e),(t=this.imageFrameSource)==null||t.delete(),this.imageFrameSource=new this.Module.ImageBufferFrameSource(this.lastUsedModuleMirrorAxis),this.context.setFrameSource(this.imageFrameSource)}startDrawLoop(e){this.isDrawLoopRunning=!0;let t=s=>this.redrawRequests.length>0&&this.redrawRequests[0]<=s,a=s=>{for(;this.redrawRequests.length>0&&this.redrawRequests[0]<=s;)this.redrawRequests.shift()},i=()=>{this.loopTimeoutId=setTimeout(()=>{if(!this.isDrawLoopRunning)return;let s=performance.now();if(t(s)){a(s),e.draw();let n=e.getDrawCommands();this.sendViewRefreshCommands(new Uint8Array(n))}i()},this.redrawInterval)};i()}updateContext(e){if(this.context!=null&&this.contextDeserializer!=null){e.view!=null&&!e.view.visible&&this.context.flushAnalytics();let t=this.contextDeserializer.updateContextFromJson(this.context,this.view,JSON.stringify(e.context));if(t==null)throw new Error("Could not update the context");this.context.delete(),this.context=t.getContext();let a=t.getView();t.delete(),a!=null&&e.view!=null&&a.setViewSize(e.view.width,e.view.height),this.gestureRecognizer!=null&&a?.setGestureRecognizer(this.gestureRecognizer),this.setView(a),o.log(o.Level.Debug,"context updated",e)}}onDocumentVisibilityChange(e){e==="hidden"&&this.context.flushAnalytics()}getNextFrameId(){return this.lastFrameCounter++,this.lastFrameCounter>=this.MAX_NUMBER_OF_IMAGES_IN_FRAME_DATA_POOL&&(this.lastFrameCounter=0),this.lastFrameCounter}getWasmDynamicLibraries(e){return this.getWasmSideModuleFileName()==null?[]:[`${e.replace(/\\/[^/]*$/,"/")}${this.getWasmSideModuleFileName()}`]}getWasmCoreExpectedHash(e,t){return t?e?"1fdc7ac93502d92c5e34889b68e60941a06dcb387d5d297ce34ecbfba9c3a46c":"92818d024670e2504af608669e691f2d4404be1a23eede254d3bf34904ab7b70":e?"eb0dbe0a399ec54bcca2fecca81404e454f63c33e1fa52fdaad474777f6b1a51":""}getWasmCoreFileName(e,t){return t?e?"scandit-datacapture-sdk-barcode-simd-pthreads.wasm":"scandit-datacapture-sdk-barcode-pthreads.wasm":e?"scandit-datacapture-sdk-barcode-simd.wasm":""}getWasmMetadata(){return g}getWasmSideModuleFileName(){return""}_loadProgressCallback(e){this.workerFunctions.postMessage({type:"loadLibraryProgress",payload:e})}addRedrawRequest(e){this.redrawRequests.push(Math.round(performance.now())+e),this.redrawRequests.sort((t,a)=>t-a)}contextDidChangeStatus(e){e.code===260&&(e.message=e.message.replace("domain name",`domain name (${B(location)})`)),this.workerFunctions.postMessage({type:"contextDidChangeStatus",payload:e})}didStartObservingContext(){this.workerFunctions.postMessage({type:"didStartObservingContext"})}mapMirrorAxisOnModule(e){switch(e){case"None":return this.Module.Axis.None;case"X":return this.Module.Axis.X;case"Y":return this.Module.Axis.Y;default:return this.Module.Axis.None}}setView(e){this.view=e,this.setViewRefreshHandler(e),e==null&&(this.isDrawLoopRunning=!1,this.sendViewRefreshCommands(new Uint8Array([])))}setViewRefreshHandler(e){if(e==null||e.isViewRefreshHandlerSet)return;let t=this.Module.NeedsRedrawDelegate.extend("NeedsRedrawDelegate",{setNeedsRedrawIn:this.scheduleRedraw.bind(this,e)}),a=new t;e.setNeedsRedrawDelegate(a),e.isViewRefreshHandlerSet=!0}setupDataDecoding(){let e=this.moduleHandler.get(),t=e.DataDecoding.extend("DataDecoding",{decode(a,i){try{let s=JSON.parse(i),n=[];for(let l of s){let c=new TextDecoder(l.ianaName,{fatal:!0});n.push(c.decode(a.slice(l.startIndex,l.endIndex)))}return n.join("")}catch{return""}}});e.setDataDecoding(new t)}start(e,t,a){e&&t&&(this.setupDataDecoding(),this.moduleHandler.get().callMain(),typeof this.moduleHandler.get().PThread=="object"||a())}getWritableDataPath(e,t){return e?this.writableDataPathPreload:t!=null?(o.log(o.Level.Debug,`IndexedDB database name override in use to recover from blocked standard database: ${t}`),t):this.writableDataPathStandard}async setup({libraryLocation:e,locationPath:t,preloadEngine:a,writableDataPathOverride:i,overrideThreadsSupport:s,overrideSimdSupport:n,verifyResponseHash:l,referredOrigin:c}){var d;let u=!1,m=!1;this.writableDataPath=this.getWritableDataPath(a,i),this.resourcePath=`${e}${this.resourceFilesSubfolder}/`,globalThis.path=t;let{resolve:p,reject:h,promise:b}=new ee,y=x.sdkVersion();if(y==="")throw new C({name:"Invalid library version",message:"Library version is not defined or empty, cannot generate proper path to library files."});let[w,F]=await Promise.all([te(),re()]);s!=="auto"&&(F=s==="on"),n!=="auto"&&(w=n==="on");let oe=U(y,e,this.getWasmCoreFileName(w,F)),{jsURI:A,wasmURI:H}=oe;return this.moduleHandler.set({mainScriptUrlOrBlob:A,canvas:(d=this.workerFunctions.getOffscreenCanvas())!=null?d:{getContext:()=>null},instantiateWasm:(f,le)=>(G({importObject:f,wasmURI:H,expectedHash:this.getWasmCoreExpectedHash(w,F),verifyResponseHash:l,successCallback:le,progressCallback:this._loadProgressCallback,referredOrigin:c}),{}),dynamicLibraries:this.getWasmDynamicLibraries(H),locateFile:f=>e+f,noInitialRun:!0,preRun:[async()=>{try{await Z({writableDataPathPreload:this.writableDataPathPreload,writableDataPath:this.writableDataPath,preloading:a})}catch(f){if(f.name==="BlockedIndexedDB"){h(f.toString());return}o.log(o.Level.Debug,"No IndexedDB support, some data will not be persisted:",f)}m=!0,this.start(m,u,p)}],onMainComplete:()=>{if([u,m].includes(!1)){o.log(o.Level.Warn,{runtimeLoaded:u,fileSystemSynced:m},"Both runtimeLoaded and fileSystemSynced should be true when calling onMainComplete"),h("onMainComplete has been called but runtime or file system was not ready.");return}p()},onRuntimeInitialized:()=>{u=!0,this.start(m,u,p)},print:f=>{o.log(o.Level.Info,f),this.poorMansBenchmarkLogs&&this.workerFunctions.postMessage({type:"console",payload:f})}}),await Te(A,y)||h(`Couldn\'t retrieve Scandit Data Capture library at ${A}, did you configure the path for it correctly?`),b}};ae.get3dPartyLicenseKeyMethodName=atob("Z2V0QmxpbmtJZExpY2Vuc2VLZXk=");var D=ae;function ie(r){console.warn("Reached unexpected case",r)}var z=class ne{constructor(e,t){this.onMessageListener=this.onMessage.bind(this),this.workerSelf=e,this.dataCaptureInstance=new D(t,{postMessage:this.postMessage.bind(this),getOffscreenCanvas:this.getOffscreenCanvas.bind(this)}),ne.isWorkerScope(e)&&this.listenToMessages()}static isWorkerScope(e){return typeof e=="object"&&e!=null&&e.document==null&&"addEventListener"in e&&typeof e.importScripts=="function"}listenToMessages(){this.workerSelf.addEventListener("message",this.onMessageListener),this.workerSelf.addEventListener("error",e=>{o.log(o.Level.Error,e)}),this.workerSelf.addEventListener("messageerror",e=>{o.log(o.Level.Error,e)})}postMessage(e,t){this.workerSelf.postMessage(e,t??[])}getOffscreenCanvas(){if(typeof this.workerSelf.OffscreenCanvas=="function")return new this.workerSelf.OffscreenCanvas(32,32)}hasPayload(e){return L(e)&&"payload"in e}hasTransferables(e){return L(e)&&Array.isArray(e.transferables)}async respondWith(e,t,a){let i=null,s;try{s=a(),s instanceof Promise&&(s=await s)}catch(l){s=void 0,i=Q(l)}let n={type:"workerTaskId",command:e,id:t,payload:this.hasPayload(s)?s.payload:void 0};i!=null&&(n.error=i),this.postMessage(n,this.hasTransferables(s)?s.transferables:[])}onMessage(e){switch(e.data.command){case"loadLibrary":{{let{data:t}=e;this.respondWith(t.command,t.id,async()=>this.dataCaptureInstance.loadLibrary({libraryLocation:t.libraryLocation,locationPath:t.locationPath,referredOrigin:t.referredOrigin,preloadEngine:t.preloadEngine,writableDataPathOverride:t.writableDataPathOverride,overrideThreadsSupport:t.overrideThreadsSupport,overrideSimdSupport:t.overrideSimdSupport,verifyResponseHash:t.verifyResponseHash}))}break}case"onTap":{{let{data:t}=e;this.respondWith(t.command,t.id,async()=>{this.dataCaptureInstance.onTap(t.point)})}break}case"createContext":{{let{data:t}=e;this.respondWith(t.command,t.id,()=>this.dataCaptureInstance.createContext({context:t.context,deviceId:t.deviceId,delayedRegistration:t.delayedRegistration,highEndBlurryRecognition:t.highEndBlurryRecognition,appName:t.appName}))}break}case"setFrameSource":{{let{data:t}=e;this.respondWith(t.command,t.id,()=>this.dataCaptureInstance.setFrameSource(t.mirrorAxis))}break}case"processFrame":{{let{data:t}=e;this.respondWith(t.command,t.id,()=>this.dataCaptureInstance.processFrame({data:t.data,width:t.width,height:t.height,colorType:t.colorType}))}break}case"requestFrameData":{{let{data:t}=e;this.respondWith(t.command,t.id,()=>this.dataCaptureInstance.requestFrameData(t.frameId))}break}case"deleteFrameData":{{let{data:t}=e;this.respondWith(t.command,t.id,()=>{this.dataCaptureInstance.deleteFrameData(t.frameId)})}break}case"updateContext":{{let{data:t}=e;this.respondWith(t.command,t.id,async()=>this.dataCaptureInstance.updateContext(t))}break}case"dispose":{this.respondWith(e.data.command,e.data.id,()=>this.dataCaptureInstance.dispose());break}case"flushAnalytics":{this.respondWith(e.data.command,e.data.id,()=>{this.dataCaptureInstance.flushAnalytics()});break}case"reportCameraProperties":{{let{data:t}=e;this.respondWith(t.command,t.id,async()=>this.dataCaptureInstance.reportCameraProperties(t))}break}case"setLogLevel":{{let{data:t}=e;this.respondWith(t.command,t.id,()=>{o.setLevel(t.level)})}break}case"setPoorMansBenchmarkLogs":{{let{data:t}=e;this.respondWith(t.command,t.id,()=>{this.dataCaptureInstance.setPoorMansBenchmarkLogs(t.enable)})}break}case"extractCentaurusLicense":{{let{data:t}=e;this.respondWith(t.command,t.id,()=>this.dataCaptureInstance.extractCentaurusLicense(t.licenseKey))}break}case"documentVisibility":{{let{data:t}=e;this.respondWith(t.command,t.id,()=>{this.dataCaptureInstance.onDocumentVisibilityChange(t.state)})}break}default:return ie(e.data),!1}return!0}};var T=class{constructor(e,t,a){this.captureListenerSet=!1;this.coreEngine=e,this.Module=t,this.workerFunctions=a,this.setup()}barcodeCaptureDidUpdateSession(e){this.workerFunctions.postMessage({type:"barcodeCaptureDidUpdateSession",payload:JSON.parse(e.toJson())})}barcodeTrackingDidUpdateSession(e){this.workerFunctions.postMessage({type:"barcodeTrackingDidUpdateSession",payload:JSON.parse(e.toJson())})}getCaptureDeserializer(){return this.barcodeCaptureDeserializer}getTrackingDeserializer(){return this.barcodeTrackingDeserializer}setup(){let e=this.Module.BarcodeCaptureListener.extend("BarcodeCaptureListener",{didScan:(i,s,n)=>{this.barcodeCaptureDidScan(s,n)},didUpdateSession:(i,s)=>{this.barcodeCaptureDidUpdateSession(s)}}),t=this.Module.Feedback.extend("Feedback",{emit:()=>{this.successFeedback()}}),a=this.Module.BarcodeCaptureDeserializerListener.extend("BarcodeCaptureDeserializerListener",{onModeDeserializationFinished:(i,s)=>{this.captureListenerSet||(s.addListener(new e,1),s.setSuccessFeedback(new t),this.captureListenerSet=!0)},onModeDeserializationStarted(){},onSettingsDeserializationStarted(){},onSettingsDeserializationFinished(){}});this.barcodeCaptureDeserializer=new this.Module.BarcodeCaptureDeserializer,this.barcodeCaptureDeserializer.setListener(new a)}successFeedback(){this.workerFunctions.postMessage({type:"successFeedback"})}barcodeCaptureDidScan(e,t){let a=this.coreEngine.convertToLoadableFrameData(t);this.workerFunctions.postMessage({type:"barcodeCaptureDidScan",payload:{session:JSON.parse(e.toJson()),frameData:a}})}};var R=class{constructor(e,t,a){this.trackingListenerSet=!1;this.coreEngine=e,this.Module=t,this.workerFunctions=a,this.setup()}barcodeTrackingDidUpdateSession(e){this.workerFunctions.postMessage({type:"barcodeTrackingDidUpdateSession",payload:JSON.parse(e.toJson())})}getTrackingDeserializer(){return this.barcodeTrackingDeserializer}setup(){let e=this.Module.BarcodeTrackingListener.extend("BarcodeTrackingListener",{didUpdateSession:(a,i)=>{this.barcodeTrackingDidUpdateSession(i)},onTrackedBarcodeTapped:(a,i)=>{this.onTrackedBarcodeTapped(i)}}),t=this.Module.BarcodeTrackingDeserializerListener.extend("BarcodeTrackingDeserializerListener",{onModeDeserializationFinished:(a,i)=>{this.trackingListenerSet||(i.addListener(new e,1),this.trackingListenerSet=!0)},onModeDeserializationStarted(){},onSettingsDeserializationStarted(){},onSettingsDeserializationFinished(){}});this.barcodeTrackingDeserializer=new this.Module.BarcodeTrackingDeserializer,this.barcodeTrackingDeserializer.setListener(new t)}onTrackedBarcodeTapped(e){this.workerFunctions.postMessage({type:"didTapTrackedBarcode",payload:JSON.parse(e.toJson())})}};var I=class extends D{constructor(e,t){super(e,t)}createBlurryTable(e){this.Module.BlurryTableCreator.createTables(this.context,e),this.workerFunctions.postMessage({type:"createBlurryTableResult",payload:{symbology:e}})}getModeDeserializers(){this.barcodeCaptureMode=new T(this,this.Module,this.workerFunctions),this.barcodeTrackingMode=new R(this,this.Module,this.workerFunctions);let e=super.getModeDeserializers();return e.push_back(this.barcodeCaptureMode.getCaptureDeserializer()),e.push_back(this.barcodeTrackingMode.getTrackingDeserializer()),e}getWasmSideModuleFileName(){return""}getWasmCoreFileName(e,t){return t?e?"scandit-datacapture-sdk-barcode-simd-pthreads.wasm":"scandit-datacapture-sdk-barcode-pthreads.wasm":e?"scandit-datacapture-sdk-barcode-simd.wasm":"scandit-datacapture-sdk-barcode.wasm"}getWasmCoreExpectedHash(e,t){return t?e?"1fdc7ac93502d92c5e34889b68e60941a06dcb387d5d297ce34ecbfba9c3a46c":"92818d024670e2504af608669e691f2d4404be1a23eede254d3bf34904ab7b70":e?"eb0dbe0a399ec54bcca2fecca81404e454f63c33e1fa52fdaad474777f6b1a51":"1e2f7743852ca9774488753f681869e23c222b2f6a216b868494266b2403ee3b"}getWasmMetadata(){return g}};var W=class extends z{constructor(e,t){super(e,t),this.dataCaptureInstance=new I(t,{postMessage:this.postMessage.bind(this),getOffscreenCanvas:this.getOffscreenCanvas.bind(this)})}onMessage(e){return e.data.command==="createBlurryTable"?(this.dataCaptureInstance.createBlurryTable(e.data.symbology),!0):super.onMessage(e)}};var zt=new W(globalThis,{get:()=>globalThis.Module,set:r=>{globalThis.Module=r}});function Ht(r){}})();\n'
], {
    type: "application/javascript"
}));
function $9ada12739a6a95f5$var$o(i) {
    return new Worker($9ada12739a6a95f5$var$u, i);
}
var $9ada12739a6a95f5$export$407448d2b89b1813 = class i extends (0, $2d78a6453b76bc96$export$8b22cf2602fb60ce) {
    get dataCaptureWorker() {
        return this._dataCaptureWorker != null || (this._dataCaptureWorker = $9ada12739a6a95f5$var$o({
            name: this.name
        })), this._dataCaptureWorker;
    }
    get name() {
        return `BarcodeCapture${this.isPreloadEngine ? " (preload)" : ""}`;
    }
    static async create(e) {
        var a, s;
        let t = new i(e), r = (a = e.poorMansBenchmarkLogs) != null ? a : !1;
        return r && await t.workerCommand("setPoorMansBenchmarkLogs", {
            enable: r
        }), await t.workerCommand("setLogLevel", {
            level: (s = e.logLevel) != null ? s : (0, $9fbbcde428fa7e14$export$407448d2b89b1813).Level.Debug
        }), await t.load(), t;
    }
    async workerCommand(e, t, r) {
        return new Promise((a, s)=>{
            let n = this.workerCommandId++;
            this.workerTasks.set(n, {
                resolve: a,
                reject: s,
                command: e
            });
            let l = {
                ...t,
                command: e,
                id: n
            };
            this.dataCaptureWorker.postMessage(l, r);
        });
    }
};


var $d59606414692476f$export$407448d2b89b1813 = {};



function $383c38e6fcd275e1$export$407448d2b89b1813(r) {
    return (0, $5b3d0f158899517d$export$407448d2b89b1813).getInstance().updateIfMissing({
        ...(0, $d59606414692476f$export$407448d2b89b1813)
    }), {
        moduleName: "BarcodeCapture",
        load: async (t)=>{
            var e;
            let n = t;
            return await (0, $9ada12739a6a95f5$export$407448d2b89b1813).create({
                ...n,
                highEndBlurryRecognition: (e = r == null ? void 0 : r.highEndBlurryRecognition) != null ? e : !1
            });
        }
    };
}



var $a07d6d60c5399ba7$export$407448d2b89b1813 = class {
    constructor(){
        this.codeDuplicateFilter = (0, $4e01d9cab6eba960$export$8b22cf2602fb60ce).BarcodeCapture.BarcodeCaptureSettings.codeDuplicateFilter;
        this.locationSelection = null;
        this.enabledCompositeTypes = [];
        this.properties = {};
        this.symbologies = {};
    }
    get enabledSymbologies() {
        return Object.keys(this.symbologies).filter((e)=>{
            var o;
            return (o = this.symbologies[e]) == null ? void 0 : o.isEnabled;
        });
    }
    get compositeTypeDescriptions() {
        return (0, $4e01d9cab6eba960$export$8b22cf2602fb60ce).CompositeTypeDescriptions.reduce((e, o)=>(e[o.types[0]] = o, e), {});
    }
    settingsForSymbology(e) {
        if (!this.symbologies[e]) {
            let o = (0, $4e01d9cab6eba960$export$8b22cf2602fb60ce).SymbologySettings[e];
            o._symbology = e, this.symbologies[e] = o;
        }
        return this.symbologies[e];
    }
    setProperty(e, o) {
        this.properties[e] = o;
    }
    getProperty(e) {
        return this.properties[e];
    }
    enableSymbologies(e) {
        for (let o of e)this.enableSymbology(o, !0);
    }
    enableSymbology(e, o) {
        this.settingsForSymbology(e).isEnabled = o;
    }
    enableSymbologiesForCompositeTypes(e) {
        for (let o of e)this.enableSymbologies(this.compositeTypeDescriptions[o].symbologies);
    }
    toJSONObject() {
        var o, i;
        let e = {};
        return {
            codeDuplicateFilter: this.codeDuplicateFilter,
            enabledCompositeTypes: [
                ...this.enabledCompositeTypes
            ],
            locationSelection: (i = (o = this.locationSelection) == null ? void 0 : o.toJSONObject()) != null ? i : (0, $9c00ec23a1023c4e$export$407448d2b89b1813),
            properties: {
                ...this.properties
            },
            symbologies: Object.keys(this.symbologies).reduce((s, r)=>{
                var n;
                let l = (n = this.symbologies[r]) == null ? void 0 : n.toJSONObject();
                return l && (s[r] = l), s;
            }, e)
        };
    }
};



class $865cf4c4bc7ec6fb$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.view = new (0, $8408943213286160$export$407448d2b89b1813)();
        this.searchForm = document.querySelector("[data-tk-search]") || undefined;
    }
    connectedCallback() {
        this.loader();
        this.initScan();
    }
    loader() {
        this.view.connectToElement(this);
        this.view.showProgressBar();
        this.view.setProgressBarMessage("Loading ...");
    }
    hideLoader() {
        this.view.hideProgressBar();
    }
    setScanningBehaviour() {
        this.settings = new (0, $a07d6d60c5399ba7$export$407448d2b89b1813)();
        this.settings.enableSymbologies([
            (0, $1877baa693087f92$export$407448d2b89b1813).Code128,
            (0, $1877baa693087f92$export$407448d2b89b1813).Code39,
            (0, $1877baa693087f92$export$407448d2b89b1813).QR,
            (0, $1877baa693087f92$export$407448d2b89b1813).EAN8,
            (0, $1877baa693087f92$export$407448d2b89b1813).UPCE,
            (0, $1877baa693087f92$export$407448d2b89b1813).EAN13UPCA
        ]);
    }
    async initScan() {
        // Set the progress bar to be in an indeterminate state
        this.view.setProgressBarPercentage(null);
        this.view.setProgressBarMessage("Accessing Camera...");
        await (0, $803b7572d944db71$export$8d21e34596265fa2)({
            licenseKey: "",
            libraryLocation: new URL("webportal/config/layout/themes/tk/vendor/scandit/library/engine", document.baseURI.split("/").slice(0, 4).join("/")).toString(),
            moduleLoaders: [
                (0, $383c38e6fcd275e1$export$407448d2b89b1813)()
            ]
        });
        this.context = await (0, $5d85c68b940f4052$export$407448d2b89b1813).create();
        await this.view.setContext(this.context);
        // set scanning behaviour
        this.setScanningBehaviour();
        if (!this.context && !this.settings) return;
        const barcodeCapture = await (0, $d951bfb2ebebf89a$export$407448d2b89b1813).forContext(this.context, this.settings);
        this.listener(barcodeCapture);
        const camera = (0, $01f73a9bc5262471$export$407448d2b89b1813).default;
        const cameraSettings = (0, $d951bfb2ebebf89a$export$407448d2b89b1813).recommendedCameraSettings;
        if (camera) {
            await camera.applySettings(cameraSettings);
            await this.context.setFrameSource(camera);
            await camera.switchToDesiredState((0, $26b53f2fcaea5d86$export$407448d2b89b1813).On);
        }
        this.view.addControl(new (0, $ac769ba1832773dd$export$8b22cf2602fb60ce)());
        this.hideLoader();
    }
    listener(barcodeCapture) {
        const listener = {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            didScan: async (barcodeCapture, session)=>{
                const barcode = session.newlyRecognizedBarcodes[0];
                await barcodeCapture.setEnabled(false);
                this.searchArticle(barcode.data);
            }
        };
        barcodeCapture.addListener(listener);
    }
    searchArticle(barCode) {
        if (!this.searchForm) return;
        const input = this.searchForm.querySelector("input");
        if (!input) return;
        input.value = barCode;
        this.searchForm.submit();
    }
}





class $0c064ead9dd24e2e$export$2e2bcd8739ae039 extends (0, $e31d2de11bbf216d$export$2e2bcd8739ae039) {
    constructor(){
        super([
            {
                name: "tk-manager",
                constructor: (0, $4576c900b5c49dcd$export$2e2bcd8739ae039)
            },
            {
                name: "tk-viewport",
                constructor: (0, $2e3d1137f4724c0f$export$2e2bcd8739ae039)
            },
            {
                name: "kw-form-tracker",
                constructor: (0, $7fb9ed192a85071f$export$2e2bcd8739ae039)
            },
            {
                name: "tk-dialog",
                constructor: (0, $2215c02a950e9fbf$export$2e2bcd8739ae039)
            },
            {
                name: "tk-static-content",
                constructor: (0, $edcef81612fbf4b7$export$2e2bcd8739ae039)
            },
            {
                name: "tk-form-element",
                constructor: (0, $9a3403e3213d867d$export$2e2bcd8739ae039)
            },
            {
                name: "tk-form-validator",
                constructor: (0, $21a7ddce6a8de4e2$export$2e2bcd8739ae039)
            },
            {
                name: "tk-compare-list-link",
                constructor: (0, $5163560edb86f711$export$2e2bcd8739ae039)
            },
            {
                name: "tk-button-dropdown",
                constructor: (0, $9d20cb2aef3a6ec2$export$2e2bcd8739ae039)
            },
            {
                name: "tk-minibasket",
                constructor: (0, $8b05e2474621c644$export$2e2bcd8739ae039)
            },
            {
                name: "tk-search",
                constructor: (0, $66984fa0a405fb2a$export$2e2bcd8739ae039)
            },
            {
                name: "tk-file-upload-area",
                constructor: (0, $a2e6d2278a4d4be5$export$2e2bcd8739ae039)
            },
            {
                name: "tk-form-zip-city",
                constructor: (0, $cb17fd7e698c018c$export$2e2bcd8739ae039)
            },
            {
                name: "kw-form-element",
                constructor: (0, $93780757a145052d$export$2e2bcd8739ae039)
            },
            {
                name: "kw-tour-schedule",
                constructor: (0, $b89635042a3c885d$export$2e2bcd8739ae039)
            },
            {
                name: "tk-table",
                constructor: (0, $2595e2ca594d6789$export$2e2bcd8739ae039)
            },
            {
                name: "kw-dialog",
                constructor: (0, $ffa8deea28bceade$export$2e2bcd8739ae039)
            },
            {
                name: "kw-scan",
                constructor: (0, $865cf4c4bc7ec6fb$export$2e2bcd8739ae039)
            },
            {
                name: "tk-nav-sidebar",
                constructor: (0, $40898dd22403025f$export$2e2bcd8739ae039)
            }
        ]);
    }
}
// eslint-disable-next-line no-new
new $0c064ead9dd24e2e$export$2e2bcd8739ae039();

})();
//# sourceMappingURL=contact.js.map
